import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomFieldScalar: any;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  TranslationKeysScalar: any;
  Upload: any;
};

export type AchDetails = {
  __typename?: 'ACHDetails';
  account_holder_type?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  networks?: Maybe<AchNetworks>;
  routing_number?: Maybe<Scalars['String']>;
};

export type AchNetworks = {
  __typename?: 'ACHNetworks';
  preferred?: Maybe<Scalars['String']>;
  supported?: Maybe<Array<Scalars['String']>>;
};

export type ArCodeObject = {
  __typename?: 'ARCodeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ActivityChangeLogModel = {
  __typename?: 'ActivityChangeLogModel';
  action: ActivityLogActions;
  text: Scalars['String'];
};

export enum ActivityLogActions {
  Add = 'add',
  Archive = 'archive',
  CheckIn = 'check_in',
  Company = 'company',
  Create = 'create',
  Date = 'date',
  Delete = 'delete',
  EmailSend = 'email_send',
  Generate = 'generate',
  Payment = 'payment',
  Print = 'print',
  Priority = 'priority',
  Rating = 'rating',
  Refund = 'refund',
  Remove = 'remove',
  SmsSend = 'sms_send',
  Status = 'status',
  Update = 'update',
  User = 'user'
}

export type ActivityLogModel = {
  __typename?: 'ActivityLogModel';
  activityType: ActivityTypeEnum;
  author?: Maybe<AuthorObject>;
  changeLog: Array<ActivityChangeLogModel>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  referToRecord: ReferToObject;
};

export enum ActivityTypeEnum {
  Changelog = 'CHANGELOG',
  Comment = 'COMMENT'
}

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AmanoAccessGroupObject = {
  __typename?: 'AmanoAccessGroupObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AmanoFacilityObject = {
  __typename?: 'AmanoFacilityObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AmanoOccupancyGroupObject = {
  __typename?: 'AmanoOccupancyGroupObject';
  available: Scalars['Int'];
  occupied: Scalars['Int'];
};

export type AmanoOccupancyWidget = {
  __typename?: 'AmanoOccupancyWidget';
  contract?: Maybe<AmanoOccupancyGroupObject>;
  name: Scalars['String'];
  overall?: Maybe<AmanoOccupancyGroupObject>;
  transient?: Maybe<AmanoOccupancyGroupObject>;
};

export type AmanoSettingInput = {
  accessGroups: Array<BasicInputInput>;
  facility: BasicInputInput;
  productId: Scalars['String'];
};

export type AmanoSettingsObject = {
  __typename?: 'AmanoSettingsObject';
  accessGroups: Array<AmanoAccessGroupObject>;
  facility: AmanoFacilityObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  product?: Maybe<ProductItemObject>;
};

export type AmenityInput = {
  icon: Scalars['String'];
  name: Scalars['String'];
};

export type AmenityModel = {
  __typename?: 'AmenityModel';
  icon: Scalars['String'];
  name: Scalars['String'];
};

/** The supported values for get users request. */
export enum ArchiveStatusEnum {
  /** All records */
  All = 'ALL',
  /** Archived record list */
  Archived = 'ARCHIVED',
  /** Non archived record list */
  NotArchived = 'NOT_ARCHIVED'
}

export type AuthorObject = {
  __typename?: 'AuthorObject';
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  photo?: Maybe<FileObject>;
  status: UserStatuses;
};

export type BasicInputInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** List of delivery status for broadcast msg. */
export enum BroadcastDeliveryStatus {
  /** Error delivery */
  Error = 'error',
  /** Scheduled delivery */
  Pending = 'pending',
  /** Delivery not possible */
  Skip = 'skip',
  /** All good */
  Success = 'success'
}

export type BroadcastObject = {
  __typename?: 'BroadcastObject';
  app: Scalars['Boolean'];
  attachments: Array<FileObject>;
  body?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<CompanyObject>>;
  companyTypes?: Maybe<Array<CompanyTypeEnum>>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  email: Scalars['Boolean'];
  emailBody?: Maybe<Scalars['String']>;
  event?: Maybe<EventObject>;
  id: Scalars['String'];
  roles?: Maybe<Array<RoleObject>>;
  sms: Scalars['Boolean'];
  subject: Scalars['String'];
  users?: Maybe<Array<UserObject>>;
};

export type BroadcastRecipientEmailObject = {
  __typename?: 'BroadcastRecipientEmailObject';
  message?: Maybe<Scalars['String']>;
  status: BroadcastDeliveryStatus;
};

export type BroadcastRecipientNotificationObject = {
  __typename?: 'BroadcastRecipientNotificationObject';
  message?: Maybe<Scalars['String']>;
  status: BroadcastDeliveryStatus;
};

export type BroadcastRecipientObject = {
  __typename?: 'BroadcastRecipientObject';
  app?: Maybe<BroadcastRecipientNotificationObject>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<BroadcastRecipientEmailObject>;
  id: Scalars['String'];
  sms?: Maybe<BroadcastRecipientSmsObject>;
  user: UserObject;
};

export type BroadcastRecipientSmsObject = {
  __typename?: 'BroadcastRecipientSMSObject';
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  status: BroadcastDeliveryStatus;
};

export enum BroadcastTypeEnum {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type BuildingObject = {
  __typename?: 'BuildingObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  title: Scalars['String'];
};

export type BuildingPopulatedObject = {
  __typename?: 'BuildingPopulatedObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type CoiInput = {
  attachment: FileObjectInput;
  companyId: Scalars['String'];
  contactEmails?: InputMaybe<Array<Scalars['String']>>;
  customFields?: Array<RecordCustomFieldInput>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CoiStatusEnum>;
  title: Scalars['String'];
  validFrom: Scalars['String'];
  validTo: Scalars['String'];
};

export type CoiUpdateInput = {
  attachment: FileObjectInput;
  companyId: Scalars['String'];
  contactEmails?: InputMaybe<Array<Scalars['String']>>;
  customFields?: Array<RecordCustomFieldInput>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CoiStatusEnum>;
  title: Scalars['String'];
  validFrom: Scalars['String'];
  validTo: Scalars['String'];
};

export type CoiWidget = {
  __typename?: 'COIWidget';
  count: Scalars['Int'];
  name: CoiWidgetStatusEnum;
  percentage: Scalars['Float'];
};

export enum CameraType {
  Back = 'back',
  Front = 'front'
}

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']>;
  checks?: Maybe<Checks>;
  country?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  generated_from?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  networks?: Maybe<Networks>;
  three_d_secure_usage?: Maybe<ThreeSecure>;
};

export type CategoryGroupInput = {
  icon?: InputMaybe<Scalars['String']>;
  recordType: CategoryRecordType;
  title: Scalars['String'];
};

export type CategoryGroupObject = {
  __typename?: 'CategoryGroupObject';
  active: Scalars['Boolean'];
  categories?: Maybe<Array<CategoryObject>>;
  categoryCount: Scalars['Int'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryInput = {
  defaultPriorityId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  notifyList?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CategoryObject = {
  __typename?: 'CategoryObject';
  active: Scalars['Boolean'];
  defaultPriority?: Maybe<PriorityObject>;
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeeObject>;
  group?: Maybe<CategoryGroupObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  usersNotify?: Maybe<Array<UserObject>>;
};

/** The supported records type. */
export enum CategoryRecordType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type ChargeCodeObject = {
  __typename?: 'ChargeCodeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum ChargeEnum {
  Labor = 'labor',
  Material = 'material'
}

export type ChargeInput = {
  data: ChargeInputData;
  recordId: Scalars['String'];
  recordType: ChargeTypeRecord;
};

export type ChargeInputData = {
  baseTaxable?: Scalars['Boolean'];
  billable: Scalars['Boolean'];
  date?: InputMaybe<Scalars['String']>;
  employeeUserId?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Float']>;
  laborRateId?: InputMaybe<Scalars['String']>;
  markupAmount?: InputMaybe<Scalars['Float']>;
  markupId?: InputMaybe<Scalars['String']>;
  markupTaxable?: Scalars['Boolean'];
  markupType?: InputMaybe<ValueUnit>;
  materialId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Float']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['String']>;
  total: Scalars['Float'];
  type: ChargeEnum;
};

export type ChargeItemObject = {
  __typename?: 'ChargeItemObject';
  amount: Scalars['Float'];
  amountRefunded: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  refunded: Scalars['Boolean'];
};

export type ChargeObject = {
  __typename?: 'ChargeObject';
  baseTaxable: Scalars['Boolean'];
  billable: Scalars['Boolean'];
  date?: Maybe<Scalars['String']>;
  employeeUser?: Maybe<UserObject>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  laborRate?: Maybe<LaborRateObject>;
  markup?: Maybe<MarkupObject>;
  markupAmount?: Maybe<Scalars['Float']>;
  markupTaxable: Scalars['Boolean'];
  markupType?: Maybe<ValueUnit>;
  material?: Maybe<MaterialObject>;
  notes?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  tax?: Maybe<TaxObject>;
  taxAmount?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  type: ChargeEnum;
};

/** The supported types for charge item. */
export enum ChargeTypeRecord {
  RecurringInvoice = 'recurringInvoice',
  RoomReservation = 'roomReservation',
  Task = 'task',
  WorkOrder = 'workOrder',
  WorkOrderTemplate = 'workOrderTemplate'
}

export type Checks = {
  __typename?: 'Checks';
  address_line1_check?: Maybe<Scalars['String']>;
  address_postal_code_check?: Maybe<Scalars['String']>;
  cvc_check?: Maybe<Scalars['String']>;
};

export type CoiBulkObject = {
  __typename?: 'CoiBulkObject';
  data?: Maybe<Array<CoiObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type CoiEmailInput = {
  allowUnknownSender?: Scalars['Boolean'];
  companyId?: InputMaybe<Scalars['String']>;
  contactEmails?: InputMaybe<Array<Scalars['String']>>;
  emailSlug?: InputMaybe<Scalars['String']>;
  status: CoiStatusEnum;
  title: Scalars['String'];
};

export type CoiEmailObject = {
  __typename?: 'CoiEmailObject';
  active: Scalars['Boolean'];
  allowUnknownSender: Scalars['Boolean'];
  company?: Maybe<CompanyObject>;
  contactEmails: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  email: Scalars['String'];
  emailSlug: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  status: CoiStatusEnum;
  title: Scalars['String'];
};

export enum CoiExpirationEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiresSoon = 'EXPIRES_SOON',
  Today = 'TODAY'
}

export type CoiObject = {
  __typename?: 'CoiObject';
  attachment: FileObject;
  company: CompanyObject;
  contactEmails: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  customFields: Array<RecordCustomFieldObject>;
  expiration: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  status: CoiStatusEnum;
  title: Scalars['String'];
  validFrom: Scalars['String'];
  validTo: Scalars['String'];
};

export enum CoiStatusEnum {
  Compliant = 'COMPLIANT',
  NotCompliant = 'NOT_COMPLIANT',
  Pending = 'PENDING'
}

export enum CoiWidgetStatusEnum {
  Compliant = 'COMPLIANT',
  Expired = 'EXPIRED',
  NotCompliant = 'NOT_COMPLIANT',
  Pending = 'PENDING'
}

export type CommentInput = {
  internal?: Scalars['Boolean'];
  parentId?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  type: ReferToType;
};

export type CommentModel = {
  __typename?: 'CommentModel';
  author: AuthorObject;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  parent?: Maybe<CommentModel>;
  text: Scalars['String'];
};

export type CompanyBillObject = {
  __typename?: 'CompanyBillObject';
  billTo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CompanyBillingInput = {
  billTo?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export type CompanyObject = {
  __typename?: 'CompanyObject';
  active: Scalars['Boolean'];
  address?: Maybe<Address>;
  billing?: Maybe<CompanyBillObject>;
  building?: Maybe<BuildingObject>;
  complianceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  floor?: Maybe<FloorObject>;
  geneaTenant?: Maybe<GeneaTenantObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  suite?: Maybe<SuiteObject>;
  taxCode?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userCount: Scalars['Int'];
  vendorId?: Maybe<Scalars['String']>;
};

export type CompanyPropertyAddInput = {
  addUserToCompany?: Scalars['Boolean'];
  companyId: Scalars['String'];
};

export type CompanyPropertyCreateInput = {
  addUserToCompany?: Scalars['Boolean'];
  address?: InputMaybe<AddressInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<FileObjectInput>;
  suiteId?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CompanyPropertyUpdateInput = {
  buildingId?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CompanySearchObject = {
  __typename?: 'CompanySearchObject';
  existInProperty: Scalars['Boolean'];
  id: Scalars['String'];
  photo?: Maybe<FileObject>;
  taxCode?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
};

export enum CompanyTypeEnum {
  Management = 'MANAGEMENT',
  Other = 'OTHER',
  Tenant = 'TENANT',
  Vendor = 'VENDOR'
}

export type CouponInput = {
  discountAmount: Scalars['Float'];
  discountType: DiscountTypeEnum;
  duration: DurationEnum;
  /** Required if duration == repeating */
  durationInMonths?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  products?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CouponListObject = {
  __typename?: 'CouponListObject';
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  discountType: DiscountTypeEnum;
  duration: DurationEnum;
  durationInMonths?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  redemptions: Scalars['Int'];
  title: Scalars['String'];
};

export type CouponObject = {
  __typename?: 'CouponObject';
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  discountType: DiscountTypeEnum;
  duration: DurationEnum;
  durationInMonths?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  products?: Maybe<Array<CouponProductsListObject>>;
  redemptions: Scalars['Int'];
  stripeAccount?: Maybe<StripeAccountObject>;
  title: Scalars['String'];
};

export type CouponProductsListObject = {
  __typename?: 'CouponProductsListObject';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type CouponStripeObject = {
  __typename?: 'CouponStripeObject';
  discountAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type CouponUpdateInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
  title: Scalars['String'];
};

export type CouponValidateInput = {
  coupon: Scalars['String'];
  priceId: Scalars['String'];
  productId: Scalars['String'];
};

export type CouponValidationObject = {
  __typename?: 'CouponValidationObject';
  discount: Scalars['Float'];
  price: Scalars['Float'];
  total: Scalars['Float'];
};

export type CreateEquipmentInput = {
  assetTag?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<FileObjectInput>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  specificLocation?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateGeneaUserCardInput = {
  activationTime: Scalars['DateTime'];
  badgeTypeId: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['Float']>;
  deactivationTime?: InputMaybe<Scalars['DateTime']>;
  type: GeneaUserCardTypeEnum;
  userId: Scalars['String'];
};

export type CronJobObject = {
  __typename?: 'CronJobObject';
  isActive: Scalars['Boolean'];
  lastDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nextDate?: Maybe<Scalars['String']>;
};

export type CursorPagination = {
  __typename?: 'CursorPagination';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type CustomFieldCreateInput = {
  addToExistingRecords: Scalars['Boolean'];
  dropdownOptions?: InputMaybe<CustomFieldOptionDropdownInput>;
  inputOptions?: InputMaybe<CustomFieldOptionInput>;
  label: Scalars['String'];
  rangeDatepickerOptions?: InputMaybe<CustomFieldOptionRangeDatePickerInput>;
  recordType: CustomFieldRecordType;
  required?: Scalars['Boolean'];
  type: CustomFieldType;
};

export enum CustomFieldDropdownType {
  Color = 'COLOR',
  Text = 'TEXT'
}

export enum CustomFieldInputType {
  Email = 'EMAIL',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CustomFieldObject = {
  __typename?: 'CustomFieldObject';
  active: Scalars['Boolean'];
  dropdownOptions?: Maybe<CustomFieldOptionDropdownObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  inputOptions?: Maybe<CustomFieldOptionInputObject>;
  key: Scalars['String'];
  label: Scalars['String'];
  rangeDatepickerOptions?: Maybe<CustomFieldOptionRangeDatePickerObject>;
  required: Scalars['Boolean'];
  type: CustomFieldType;
};

export type CustomFieldOptionDropdownInput = {
  items?: InputMaybe<Array<Scalars['String']>>;
  multi?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<CustomFieldDropdownType>;
};

export type CustomFieldOptionDropdownObject = {
  __typename?: 'CustomFieldOptionDropdownObject';
  items?: Maybe<Array<Scalars['String']>>;
  multi?: Maybe<Scalars['Boolean']>;
  type?: Maybe<CustomFieldDropdownType>;
};

export type CustomFieldOptionInput = {
  type?: InputMaybe<CustomFieldInputType>;
};

export type CustomFieldOptionInputObject = {
  __typename?: 'CustomFieldOptionInputObject';
  type?: Maybe<CustomFieldInputType>;
};

export type CustomFieldOptionRangeDatePickerInput = {
  separate?: InputMaybe<Scalars['Boolean']>;
};

export type CustomFieldOptionRangeDatePickerObject = {
  __typename?: 'CustomFieldOptionRangeDatePickerObject';
  separate?: Maybe<Scalars['Boolean']>;
};

export enum CustomFieldRecordType {
  Coi = 'COI',
  Incident = 'INCIDENT',
  MeetingHub = 'MEETING_HUB',
  WorkOrder = 'WORK_ORDER'
}

export type CustomFieldToggleInput = {
  id: Scalars['String'];
  /** If true, system also set active: true/false for all records which use this custom field */
  withData: Scalars['Boolean'];
};

export enum CustomFieldType {
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Input = 'INPUT',
  RangeDatepicker = 'RANGE_DATEPICKER',
  SingleDatepicker = 'SINGLE_DATEPICKER'
}

export type CustomFieldUpdateInput = {
  dropdownOptions?: InputMaybe<CustomFieldOptionDropdownInput>;
  inputOptions?: InputMaybe<CustomFieldOptionInput>;
  key: Scalars['String'];
  label: Scalars['String'];
  rangeDatepickerOptions?: InputMaybe<CustomFieldOptionRangeDatePickerInput>;
  required?: Scalars['Boolean'];
};

export enum DashboardWidgetEnum {
  Guests = 'GUESTS',
  Incidents = 'INCIDENTS',
  MyWorkOrder = 'MY_WORK_ORDER',
  Tasks = 'TASKS',
  TasksCounter = 'TASKS_COUNTER',
  UpcomingReservations = 'UPCOMING_RESERVATIONS',
  Watchlist = 'WATCHLIST',
  WorkOrder = 'WORK_ORDER'
}

export type DealCategoryObject = {
  __typename?: 'DealCategoryObject';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  order?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type DealInput = {
  categoryId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<FileObjectInput>;
  link?: InputMaybe<Scalars['String']>;
  pdf?: InputMaybe<FileObjectInput>;
  popupDescription?: InputMaybe<Scalars['String']>;
  redemptions?: InputMaybe<Array<RedemptionObjectInput>>;
  title: Scalars['String'];
  validUntil?: InputMaybe<Scalars['DateTime']>;
  website?: InputMaybe<Scalars['String']>;
};

export type DealObject = {
  __typename?: 'DealObject';
  active: Scalars['Boolean'];
  category: DealCategoryObject;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  discount: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<FileObject>;
  index: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
  pdf?: Maybe<FileObject>;
  popupDescription?: Maybe<Scalars['String']>;
  redemptionCount: Scalars['Int'];
  redemptionUniqCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  website: Scalars['String'];
};

export type DealUpdateInput = {
  categoryId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<FileObjectInput>;
  link?: InputMaybe<Scalars['String']>;
  pdf?: InputMaybe<FileObjectInput>;
  popupDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  validUntil?: InputMaybe<Scalars['DateTime']>;
  website?: InputMaybe<Scalars['String']>;
};

export type DeleteRecordsInput = {
  ids: Array<Scalars['String']>;
};

export type DeviceInput = {
  printerId: Scalars['String'];
  title: Scalars['String'];
};

export type DeviceLogCreateInput = {
  location?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  type: DeviceLogType;
};

export type DeviceLogModel = {
  __typename?: 'DeviceLogModel';
  device: DeviceModel;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  type: DeviceLogType;
};

export enum DeviceLogType {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type DeviceModel = {
  __typename?: 'DeviceModel';
  appVersion?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isPaired: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  osVersion?: Maybe<Scalars['String']>;
  printer: PrinterModel;
  title: Scalars['String'];
};

export type DevicePairInput = {
  appVersion: Scalars['String'];
  deviceId: Scalars['String'];
  osVersion: Scalars['String'];
};

export type DeviceSettingModel = {
  __typename?: 'DeviceSettingModel';
  device: DeviceModel;
  property: PropertyObject;
};

export type DeviceTokenModel = {
  __typename?: 'DeviceTokenModel';
  token: Scalars['String'];
};

export type DeviceUpdateInput = {
  printerId: Scalars['String'];
  title: Scalars['String'];
};

export enum DiscountTypeEnum {
  Amount = 'Amount',
  Percent = 'Percent'
}

export type DocCategoryInput = {
  icon: Scalars['String'];
  title: Scalars['String'];
};

export type DocCategoryObject = {
  __typename?: 'DocCategoryObject';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  order: Scalars['Float'];
  title: Scalars['String'];
};

export enum DurationEnum {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

export type EmailTemplateObject = {
  __typename?: 'EmailTemplateObject';
  appActive?: Maybe<Scalars['Boolean']>;
  appBody?: Maybe<Scalars['String']>;
  bcc?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  cc?: Maybe<Array<Scalars['String']>>;
  custom: Scalars['Boolean'];
  emailActive?: Maybe<Scalars['Boolean']>;
  emailBody?: Maybe<Scalars['String']>;
  globalParams: Array<Scalars['String']>;
  id: Scalars['String'];
  localParams?: Maybe<Array<Scalars['String']>>;
  portfolioId?: Maybe<Scalars['String']>;
  smsActive?: Maybe<Scalars['Boolean']>;
  smsBody?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  trigger: Scalars['String'];
  type: EmailTemplateType;
};

export enum EmailTemplateType {
  CoiApproved = 'COI_APPROVED',
  CoiExpired = 'COI_EXPIRED',
  CoiExpire_7Days = 'COI_EXPIRE_7_DAYS',
  CoiExpire_15Days = 'COI_EXPIRE_15_DAYS',
  CoiExpire_30Days = 'COI_EXPIRE_30_DAYS',
  CoiReceived = 'COI_RECEIVED',
  CoiRejected = 'COI_REJECTED',
  CoiRequestDocument = 'COI_REQUEST_DOCUMENT',
  CommentAdded = 'COMMENT_ADDED',
  CustomMessage = 'CUSTOM_MESSAGE',
  Email_2Fa = 'EMAIL_2FA',
  ForgotPassword = 'FORGOT_PASSWORD',
  GuestAddWatcher = 'GUEST_ADD_WATCHER',
  GuestApproved = 'GUEST_APPROVED',
  GuestCanceled = 'GUEST_CANCELED',
  GuestCheckIn = 'GUEST_CHECK_IN',
  GuestCreatedHost = 'GUEST_CREATED_HOST',
  GuestCreatedVisitor = 'GUEST_CREATED_VISITOR',
  GuestCsvUpload = 'GUEST_CSV_UPLOAD',
  GuestPending = 'GUEST_PENDING',
  GuestUpdated = 'GUEST_UPDATED',
  GuestVisitReminder = 'GUEST_VISIT_REMINDER',
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentShare = 'INCIDENT_SHARE',
  InvocieCreate = 'INVOCIE_CREATE',
  InvoiceSend = 'INVOICE_SEND',
  InvoiceShare = 'INVOICE_SHARE',
  MagicLogin = 'MAGIC_LOGIN',
  NotificationMail = 'NOTIFICATION_MAIL',
  ParkingBarcode = 'PARKING_BARCODE',
  PmTaskCreated = 'PM_TASK_CREATED',
  RecurringInvocieCreate = 'RECURRING_INVOCIE_CREATE',
  ReportDelivery = 'REPORT_DELIVERY',
  ResetPassword = 'RESET_PASSWORD',
  RoomReservationApprove = 'ROOM_RESERVATION_APPROVE',
  RoomReservationCancel = 'ROOM_RESERVATION_CANCEL',
  RoomReservationConfirm = 'ROOM_RESERVATION_CONFIRM',
  RoomReservationNotApproved = 'ROOM_RESERVATION_NOT_APPROVED',
  RoomReservationPending = 'ROOM_RESERVATION_PENDING',
  SubscriptionActivated = 'SUBSCRIPTION_ACTIVATED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionDeactivated = 'SUBSCRIPTION_DEACTIVATED',
  SubscriptionPaymentFailed = 'SUBSCRIPTION_PAYMENT_FAILED',
  SubscriptionPaymentFailedAdmin = 'SUBSCRIPTION_PAYMENT_FAILED_ADMIN',
  SubscriptionPaymentFinalFailed = 'SUBSCRIPTION_PAYMENT_FINAL_FAILED',
  SubscriptionPaymentProcessed = 'SUBSCRIPTION_PAYMENT_PROCESSED',
  SubscriptionPaymentProcessedAdmin = 'SUBSCRIPTION_PAYMENT_PROCESSED_ADMIN',
  SubscriptionRenew = 'SUBSCRIPTION_RENEW',
  SubscriptionUpdated = 'SUBSCRIPTION_UPDATED',
  UserActivated = 'USER_ACTIVATED',
  UserDeactivated = 'USER_DEACTIVATED',
  UserPasswordChanged = 'USER_PASSWORD_CHANGED',
  UserRegistered = 'USER_REGISTERED',
  UserResetPassword = 'USER_RESET_PASSWORD',
  VendorAccessApproved = 'VENDOR_ACCESS_APPROVED',
  VendorAccessCanceled = 'VENDOR_ACCESS_CANCELED',
  VendorAccessCheckIn = 'VENDOR_ACCESS_CHECK_IN',
  VendorAccessCreatedHost = 'VENDOR_ACCESS_CREATED_HOST',
  VendorAccessCreatedVisitor = 'VENDOR_ACCESS_CREATED_VISITOR',
  VendorAccessCsvUpload = 'VENDOR_ACCESS_CSV_UPLOAD',
  VendorAccessPending = 'VENDOR_ACCESS_PENDING',
  VendorAccessUpdated = 'VENDOR_ACCESS_UPDATED',
  VendorAccessVisitReminder = 'VENDOR_ACCESS_VISIT_REMINDER',
  WatcherAdd = 'WATCHER_ADD',
  WorkOrderAcknowledgeReminder = 'WORK_ORDER_ACKNOWLEDGE_REMINDER',
  WorkOrderAcknowledgeReminderPriority = 'WORK_ORDER_ACKNOWLEDGE_REMINDER_PRIORITY',
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
  WorkOrderCreated = 'WORK_ORDER_CREATED',
  WorkOrderDetails = 'WORK_ORDER_DETAILS',
  WorkOrderEmailError = 'WORK_ORDER_EMAIL_ERROR',
  WorkOrderReassigned = 'WORK_ORDER_REASSIGNED',
  WorkOrderScheduled = 'WORK_ORDER_SCHEDULED',
  WorkOrderShare = 'WORK_ORDER_SHARE',
  WorkOrderUpdates = 'WORK_ORDER_UPDATES',
  WoTemplateCancel = 'WO_TEMPLATE_CANCEL',
  WoTemplateCreate = 'WO_TEMPLATE_CREATE',
  WoTemplatePause = 'WO_TEMPLATE_PAUSE',
  WoTemplateSkip = 'WO_TEMPLATE_SKIP',
  WoTemplateUpdate = 'WO_TEMPLATE_UPDATE'
}

export enum EmailToggleEnum {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type EmployeeInput = {
  laborRateId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type EmployeeObject = {
  __typename?: 'EmployeeObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  laborRate?: Maybe<LaborRateObject>;
  tax?: Maybe<TaxObject>;
  updatedAt: Scalars['DateTime'];
  user: UserObject;
};

export type EquipmentCategoryInput = {
  title: Scalars['String'];
};

export type EquipmentCategoryModel = {
  __typename?: 'EquipmentCategoryModel';
  createdAt: Scalars['DateTime'];
  equipmentCount?: Maybe<Scalars['Float']>;
  equipmentList?: Maybe<Array<EquipmentModel>>;
  id: Scalars['String'];
  index: Scalars['Float'];
  title: Scalars['String'];
};

export type EquipmentModel = {
  __typename?: 'EquipmentModel';
  active: Scalars['Boolean'];
  assetTag?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<FileObject>>;
  building?: Maybe<BuildingObject>;
  category: EquipmentCategoryModel;
  createdBy: UserObject;
  details?: Maybe<Scalars['String']>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Float'];
  manufacturer?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  specificLocation?: Maybe<Scalars['String']>;
  suite?: Maybe<SuiteObject>;
  title: Scalars['String'];
};

/** The supported values for get equipment request. */
export enum EquipmentNonBuildingEnum {
  /** List of all equipment with building */
  Exclude = 'EXCLUDE',
  /** List of all equipment with building + without building */
  Include = 'INCLUDE',
  /** List of equipment only without building */
  Only = 'ONLY'
}

export type EventAttendanceObject = {
  __typename?: 'EventAttendanceObject';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  user: UserObject;
};

export type EventInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  capacity?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  eventDate: Scalars['String'];
  eventLength?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  registration?: Scalars['Boolean'];
  rruleObject?: InputMaybe<RRuleObjectInput>;
  showCapacity?: Scalars['Boolean'];
  startTime: Scalars['String'];
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type EventMessageInput = {
  app?: Scalars['Boolean'];
  body?: InputMaybe<Scalars['String']>;
  email?: Scalars['Boolean'];
  eventId: Scalars['String'];
  sms?: Scalars['Boolean'];
  subject?: InputMaybe<Scalars['String']>;
};

export enum EventNewsEnum {
  Event = 'EVENT',
  News = 'NEWS'
}

export type EventNewsObject = {
  __typename?: 'EventNewsObject';
  event?: Maybe<EventObject>;
  news?: Maybe<NewsfeedObject>;
  type: EventNewsEnum;
};

export type EventObject = {
  __typename?: 'EventObject';
  attachments?: Maybe<Array<FileObject>>;
  averageRating?: Maybe<Scalars['Int']>;
  capacity?: Maybe<Scalars['Int']>;
  capacityAvailable?: Maybe<Scalars['Int']>;
  capacityUsed?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  description: Scalars['String'];
  eventDate: Scalars['String'];
  eventLength?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  isRegistered: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  registration: Scalars['Boolean'];
  repeatId?: Maybe<Scalars['String']>;
  rruleObject?: Maybe<RRuleObject>;
  showCapacity: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  userRating?: Maybe<EventAttendanceObject>;
};

export type EventReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  score: Scalars['Int'];
};

export type EventUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  capacity?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  eventDate: Scalars['String'];
  eventLength?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  registration?: Scalars['Boolean'];
  showCapacity?: Scalars['Boolean'];
  startTime: Scalars['String'];
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export enum EventUpdateType {
  All = 'ALL',
  Future = 'FUTURE',
  Single = 'SINGLE'
}

export type FeatureItemObject = {
  __typename?: 'FeatureItemObject';
  anyPermissions?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  minPermissions?: Maybe<Array<MinPermissionObject>>;
  mobile: Scalars['Boolean'];
  title: Scalars['String'];
  web: Scalars['Boolean'];
  webUrl: Scalars['String'];
};

export type FeatureObject = {
  __typename?: 'FeatureObject';
  id: SearchFeatureEnum;
  title: Scalars['String'];
};

export enum FieldKeyEnum {
  Building = 'BUILDING',
  Category = 'CATEGORY',
  Company = 'COMPANY',
  Date = 'DATE',
  Description = 'DESCRIPTION',
  EstimatedLabor = 'ESTIMATED_LABOR',
  Expired = 'EXPIRED',
  Floor = 'FLOOR',
  Interval = 'INTERVAL',
  Location = 'LOCATION',
  Money = 'MONEY',
  ScheduleCount = 'SCHEDULE_COUNT',
  Suite = 'SUITE',
  TaxCode = 'TAX_CODE',
  Time = 'TIME',
  Title = 'TITLE',
  Type = 'TYPE',
  User = 'USER'
}

export type FileObject = {
  __typename?: 'FileObject';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

export type FileObjectInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

/** The supported records type. */
export enum FilterableCategoryLocationType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder',
  /** For Work Order Template components */
  WorkOrderTemplate = 'workOrderTemplate'
}

export type FilterableCategoryObject = {
  __typename?: 'FilterableCategoryObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The supported records type. */
export enum FilterableCompanyLocationType {
  Guest = 'GUEST',
  /** For Incident component */
  Incident = 'INCIDENT',
  Subscription = 'SUBSCRIPTION',
  VendorAccess = 'VENDOR_ACCESS',
  Watchlist = 'WATCHLIST',
  /** For Work Order component */
  WorkOrder = 'WORK_ORDER',
  /** For Work Order Template components */
  WorkOrderTemplate = 'WORK_ORDER_TEMPLATE'
}

export type FilterableCompanyObject = {
  __typename?: 'FilterableCompanyObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  photo?: Maybe<FileObject>;
  title: Scalars['String'];
};

export type FilterableGroupedCategoryObject = {
  __typename?: 'FilterableGroupedCategoryObject';
  active: Scalars['Boolean'];
  categories: Array<FilterableCategoryObject>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The supported records type. */
export enum FilterablePriorityLocationType {
  /** For Work Order component */
  WorkOrder = 'workOrder',
  /** For Work Order Template components */
  WorkOrderTemplate = 'workOrderTemplate'
}

export type FilterablePriorityObject = {
  __typename?: 'FilterablePriorityObject';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The supported records type. */
export enum FilterableStatusLocationType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type FilterableStatusObject = {
  __typename?: 'FilterableStatusObject';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

export type FloorCreateInput = {
  attachment?: InputMaybe<FileObjectInput>;
  buildingId: Scalars['String'];
  size: Scalars['Float'];
  title: Scalars['String'];
};

export type FloorObject = {
  __typename?: 'FloorObject';
  attachment?: Maybe<FileObject>;
  building: BuildingObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  order: Scalars['Int'];
  size: Scalars['Float'];
  suites?: Maybe<Array<SuiteObject>>;
  title: Scalars['String'];
};

export type FloorUpdateInput = {
  attachment?: InputMaybe<FileObjectInput>;
  size: Scalars['Float'];
  title: Scalars['String'];
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
  portfolioId: Scalars['String'];
};

export type GlAccountObject = {
  __typename?: 'GLAccountObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GeneaAccessGroupObject = {
  __typename?: 'GeneaAccessGroupObject';
  accgrp?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId: Scalars['String'];
  sets?: Maybe<Array<SetsObject>>;
  title: Scalars['String'];
};

export type GeneaAccessGroupProductLinkInput = {
  accessGroupId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type GeneaBadgeTypesObject = {
  __typename?: 'GeneaBadgeTypesObject';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefaultBadgeType: Scalars['Boolean'];
  name: Scalars['String'];
};

export type GeneaDoorObject = {
  __typename?: 'GeneaDoorObject';
  controllerId?: Maybe<Scalars['String']>;
  controllerIsOnline?: Maybe<Scalars['String']>;
  controllerName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  doorAccessMode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isLocked?: Maybe<Scalars['Boolean']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  schedule?: Maybe<Scalars['String']>;
};

export type GeneaInvitationObject = {
  __typename?: 'GeneaInvitationObject';
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invitationCode: Scalars['String'];
  status: Scalars['String'];
};

export type GeneaLocationObject = {
  __typename?: 'GeneaLocationObject';
  address_line1?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
  uuid: Scalars['String'];
};

export type GeneaSettingInput = {
  badgeTypeId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export type GeneaSettingObject = {
  __typename?: 'GeneaSettingObject';
  badgeType?: Maybe<GeneaBadgeTypesObject>;
  email?: Maybe<Scalars['String']>;
};

export type GeneaTenantObject = {
  __typename?: 'GeneaTenantObject';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type GeneaUserCardObject = {
  __typename?: 'GeneaUserCardObject';
  activationTime: Scalars['DateTime'];
  badgeTypeId: Scalars['String'];
  deactivationTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invitation?: Maybe<GeneaInvitationObject>;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  number: Scalars['Float'];
  status: GeneaUserCardStatusEnum;
  type: GeneaUserCardTypeEnum;
};

export enum GeneaUserCardStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  PendingActivation = 'PENDING_ACTIVATION',
  PendingDownload = 'PENDING_DOWNLOAD'
}

export enum GeneaUserCardTypeEnum {
  Keycard = 'KEYCARD',
  Mobile = 'MOBILE'
}

export type GetActivityLogsObject = {
  __typename?: 'GetActivityLogsObject';
  data: Array<ActivityLogModel>;
  pagination: CursorPagination;
};

export type GetAmanoSettingsObject = {
  __typename?: 'GetAmanoSettingsObject';
  data: Array<AmanoSettingsObject>;
  pagination: CursorPagination;
};

export type GetBroadcastRecipientsObject = {
  __typename?: 'GetBroadcastRecipientsObject';
  data: Array<BroadcastRecipientObject>;
  pagination: CursorPagination;
};

export type GetBroadcastsObject = {
  __typename?: 'GetBroadcastsObject';
  data: Array<BroadcastObject>;
  pagination: CursorPagination;
};

export type GetBuildings = {
  __typename?: 'GetBuildings';
  data: Array<BuildingObject>;
  pagination: CursorPagination;
};

export type GetCategories = {
  __typename?: 'GetCategories';
  data: Array<CategoryObject>;
  pagination: CursorPagination;
};

export type GetCategoriesGrouped = {
  __typename?: 'GetCategoriesGrouped';
  data: Array<CategoryGroupObject>;
  pagination: CursorPagination;
};

export type GetCategoryGroups = {
  __typename?: 'GetCategoryGroups';
  data: Array<CategoryGroupObject>;
  pagination: CursorPagination;
};

export type GetCoiEmailsObject = {
  __typename?: 'GetCoiEmailsObject';
  data: Array<CoiEmailObject>;
  pagination: CursorPagination;
};

export type GetCoiObject = {
  __typename?: 'GetCoiObject';
  data: Array<CoiObject>;
  pagination: CursorPagination;
};

export type GetCompanyObject = {
  __typename?: 'GetCompanyObject';
  data: Array<CompanyObject>;
  pagination: CursorPagination;
};

export type GetDealsObject = {
  __typename?: 'GetDealsObject';
  data: Array<DealObject>;
  pagination: CursorPagination;
};

export type GetDeviceLogs = {
  __typename?: 'GetDeviceLogs';
  data: Array<DeviceLogModel>;
  pagination: CursorPagination;
};

export type GetEmployees = {
  __typename?: 'GetEmployees';
  data: Array<EmployeeObject>;
  pagination: CursorPagination;
};

export type GetEquipmentCategoriesObject = {
  __typename?: 'GetEquipmentCategoriesObject';
  data: Array<EquipmentCategoryModel>;
  pagination: CursorPagination;
};

export type GetEquipmentGroupedObject = {
  __typename?: 'GetEquipmentGroupedObject';
  data: Array<EquipmentCategoryModel>;
  pagination: CursorPagination;
};

export type GetEquipmentTaskObject = {
  __typename?: 'GetEquipmentTaskObject';
  data: Array<TaskObject>;
  pagination: CursorPagination;
};

export type GetEquipmentWorkOrderObject = {
  __typename?: 'GetEquipmentWorkOrderObject';
  data: Array<WorkOrderObject>;
  pagination: CursorPagination;
};

export type GetEquipmentsObject = {
  __typename?: 'GetEquipmentsObject';
  data: Array<EquipmentModel>;
  pagination: CursorPagination;
};

export type GetEventAttendancesObject = {
  __typename?: 'GetEventAttendancesObject';
  data: Array<EventAttendanceObject>;
  pagination: CursorPagination;
};

export type GetFilterableCompanies = {
  __typename?: 'GetFilterableCompanies';
  data: Array<FilterableCompanyObject>;
  pagination: CursorPagination;
};

export type GetFilterableGroupedCategories = {
  __typename?: 'GetFilterableGroupedCategories';
  data: Array<FilterableGroupedCategoryObject>;
  pagination: CursorPagination;
};

export type GetForms = {
  __typename?: 'GetForms';
  data: Array<GuestWoFormObject>;
  pagination: CursorPagination;
};

export type GetGeneaAccessGroups = {
  __typename?: 'GetGeneaAccessGroups';
  data: Array<GeneaAccessGroupObject>;
  pagination: CursorPagination;
};

export type GetGeneaTenants = {
  __typename?: 'GetGeneaTenants';
  data: Array<GeneaTenantObject>;
  pagination: CursorPagination;
};

export type GetGuestsObject = {
  __typename?: 'GetGuestsObject';
  data: Array<GuestModel>;
  pagination: CursorPagination;
};

export type GetIncidentsObject = {
  __typename?: 'GetIncidentsObject';
  data: Array<IncidentModel>;
  pagination: CursorPagination;
};

export type GetInvoiceChargesObject = {
  __typename?: 'GetInvoiceChargesObject';
  data: Array<InvoiceChargeObject>;
  pagination: CursorPagination;
};

export type GetInvoicesObject = {
  __typename?: 'GetInvoicesObject';
  data: Array<InvoiceObject>;
  pagination: CursorPagination;
};

export type GetLeases = {
  __typename?: 'GetLeases';
  data: Array<LeaseObject>;
  pagination: CursorPagination;
};

export type GetMaterialGroups = {
  __typename?: 'GetMaterialGroups';
  data: Array<MaterialGroupObject>;
  pagination: CursorPagination;
};

export type GetMaterials = {
  __typename?: 'GetMaterials';
  data: Array<MaterialObject>;
  pagination: CursorPagination;
};

export type GetMaterialsGrouped = {
  __typename?: 'GetMaterialsGrouped';
  data: Array<MaterialGroupObject>;
  pagination: CursorPagination;
};

export type GetNotifications = {
  __typename?: 'GetNotifications';
  data: Array<NotificationObject>;
  pagination: CursorPagination;
};

export type GetPackagesObject = {
  __typename?: 'GetPackagesObject';
  data: Array<PackageObject>;
  pagination: CursorPagination;
};

export type GetPaymentsObject = {
  __typename?: 'GetPaymentsObject';
  data: Array<PaymentObject>;
  pagination: CursorPagination;
};

export type GetPopulateCompanyObject = {
  __typename?: 'GetPopulateCompanyObject';
  data: Array<PopulatedCompanyObject>;
  pagination: CursorPagination;
};

export type GetPopulatedBuildings = {
  __typename?: 'GetPopulatedBuildings';
  data: Array<BuildingPopulatedObject>;
  pagination: CursorPagination;
};

export type GetPredefinedBroadcastsObject = {
  __typename?: 'GetPredefinedBroadcastsObject';
  data: Array<PredefinedBroadcastObject>;
  pagination: CursorPagination;
};

export type GetProceduresObject = {
  __typename?: 'GetProceduresObject';
  data: Array<ProcedureObject>;
  pagination: CursorPagination;
};

export type GetRecurringInvoicesObject = {
  __typename?: 'GetRecurringInvoicesObject';
  data: Array<RecurringInvoiceObject>;
  pagination: CursorPagination;
};

export type GetReportsObject = {
  __typename?: 'GetReportsObject';
  data: Array<ReportModel>;
  pagination: CursorPagination;
};

export type GetRepositoryFiles = {
  __typename?: 'GetRepositoryFiles';
  breadcrumbs: Array<RepositoryBreadcrumbObject>;
  files: Array<RepositoryFileObject>;
};

export type GetRolesObject = {
  __typename?: 'GetRolesObject';
  data: Array<RoleObject>;
  pagination: CursorPagination;
};

export type GetRoomReservationsObject = {
  __typename?: 'GetRoomReservationsObject';
  data: Array<RoomReservationObject>;
  pagination: CursorPagination;
};

export type GetSchedulesObject = {
  __typename?: 'GetSchedulesObject';
  data: Array<SchedulesObject>;
  pagination: CursorPagination;
};

export type GetStakingPlan = {
  __typename?: 'GetStakingPlan';
  floors: Array<StakingPlanFloor>;
  years: Array<Scalars['String']>;
};

export type GetStepValuesObject = {
  __typename?: 'GetStepValuesObject';
  data: Array<StepValuesObject>;
  pagination: CursorPagination;
};

export type GetStripeInvoicesObject = {
  __typename?: 'GetStripeInvoicesObject';
  data: Array<StripeInvoiceObject>;
  pagination: CursorPagination;
};

export type GetSubscriptionsObject = {
  __typename?: 'GetSubscriptionsObject';
  data: Array<SubscriptionObject>;
  pagination: CursorPagination;
};

export type GetSuiteObject = {
  __typename?: 'GetSuiteObject';
  data: Array<SuiteObject>;
  pagination: CursorPagination;
};

export type GetTasksObject = {
  __typename?: 'GetTasksObject';
  data: Array<TaskObject>;
  pagination: CursorPagination;
};

export type GetUsersObject = {
  __typename?: 'GetUsersObject';
  data: Array<UserObject>;
  pagination: CursorPagination;
};

export type GetVendorAccessListObject = {
  __typename?: 'GetVendorAccessListObject';
  data: Array<VendorAccessModel>;
  pagination: CursorPagination;
};

export type GetWatchlistObject = {
  __typename?: 'GetWatchlistObject';
  data: Array<WatchlistObject>;
  pagination: CursorPagination;
};

export type GetWorkOrderEmailsObject = {
  __typename?: 'GetWorkOrderEmailsObject';
  data: Array<WorkOrderEmailObject>;
  pagination: CursorPagination;
};

export type GetWorkOrderTemplatesObject = {
  __typename?: 'GetWorkOrderTemplatesObject';
  data: Array<WorkOrderTemplateObject>;
  pagination: CursorPagination;
};

export type GetWorkOrdersObject = {
  __typename?: 'GetWorkOrdersObject';
  data: Array<WorkOrderObject>;
  pagination: CursorPagination;
};

export type GlobalTranslationObject = {
  __typename?: 'GlobalTranslationObject';
  active: Scalars['Boolean'];
  countryCode: Scalars['String'];
  descriptions?: Maybe<Scalars['TranslationKeysScalar']>;
  id: Scalars['String'];
  sources?: Maybe<Scalars['TranslationKeysScalar']>;
  title: Scalars['String'];
};

export type GuestActionObject = {
  __typename?: 'GuestActionObject';
  data?: Maybe<Array<GuestModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type GuestBulkObject = {
  __typename?: 'GuestBulkObject';
  data?: Maybe<Array<GuestModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type GuestCsvErrorsObject = {
  __typename?: 'GuestCsvErrorsObject';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type GuestCsvObject = {
  __typename?: 'GuestCsvObject';
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<GuestCsvErrorsObject>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type GuestModel = {
  __typename?: 'GuestModel';
  attachments?: Maybe<Array<FileObject>>;
  avatar?: Maybe<FileObject>;
  building: BuildingObject;
  code: Scalars['Int'];
  company: CompanyObject;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  lastName: Scalars['String'];
  property: PropertyObject;
  requestedFor: UserObject;
  status: GuestStatusEnum;
  visit: GuestVisitModel;
};

export type GuestPrintActionObject = {
  __typename?: 'GuestPrintActionObject';
  data?: Maybe<Array<GuestModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  notification: Scalars['Boolean'];
  successCount: Scalars['Int'];
};

export type GuestSettingsInput = {
  badgeLogo?: InputMaybe<FileObjectInput>;
  julianDate?: InputMaybe<Scalars['Boolean']>;
  printQRCode?: InputMaybe<Scalars['Boolean']>;
};

export type GuestSettingsObject = {
  __typename?: 'GuestSettingsObject';
  badgeLogo?: Maybe<FileObject>;
  julianDate?: Maybe<Scalars['Boolean']>;
  printQRCode?: Maybe<Scalars['Boolean']>;
};

export enum GuestStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  WaitingForApproval = 'WaitingForApproval'
}

export type GuestVisitDateObject = {
  __typename?: 'GuestVisitDateObject';
  date: Scalars['String'];
};

export type GuestVisitModel = {
  __typename?: 'GuestVisitModel';
  allDayAccess?: Maybe<Scalars['Boolean']>;
  checkInDates?: Maybe<Array<Scalars['String']>>;
  dates: Array<GuestVisitDateObject>;
  endTime?: Maybe<Scalars['String']>;
  guestId: Scalars['String'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  notifyUsers?: Maybe<Array<UserObject>>;
  startTime?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  type: GuestVisitTypeEnum;
};

export enum GuestVisitTypeEnum {
  MultipleDays = 'MultipleDays',
  PeriodRange = 'PeriodRange',
  SingleDay = 'SingleDay'
}

export type GuestWoFormInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  assigneeRequired?: Scalars['Boolean'];
  attachmentTypes: Array<Scalars['String']>;
  attachmentsRequired?: Scalars['Boolean'];
  buildingId: Scalars['String'];
  categoryId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  floorId?: InputMaybe<Scalars['String']>;
  floorRequired?: Scalars['Boolean'];
  hasAssignee?: Scalars['Boolean'];
  hasAttachments?: Scalars['Boolean'];
  hasFloor?: Scalars['Boolean'];
  hasPriority?: Scalars['Boolean'];
  hasStatus?: Scalars['Boolean'];
  hasSuite?: Scalars['Boolean'];
  priorityId?: InputMaybe<Scalars['String']>;
  priorityRequired?: Scalars['Boolean'];
  requestedForId: Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
  statusRequired?: Scalars['Boolean'];
  subTitle?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  suiteRequired?: Scalars['Boolean'];
  title: Scalars['String'];
};

export type GuestWoFormObject = {
  __typename?: 'GuestWOFormObject';
  active: Scalars['Boolean'];
  assignee?: Maybe<UserObject>;
  assigneeRequired: Scalars['Boolean'];
  attachmentTypes: Array<Scalars['String']>;
  attachmentsRequired: Scalars['Boolean'];
  building: BuildingObject;
  category?: Maybe<CategoryObject>;
  company?: Maybe<CompanyObject>;
  createdBy: UserObject;
  floor?: Maybe<FloorObject>;
  floorRequired: Scalars['Boolean'];
  hasAssignee: Scalars['Boolean'];
  hasAttachments: Scalars['Boolean'];
  hasFloor: Scalars['Boolean'];
  hasPriority: Scalars['Boolean'];
  hasStatus: Scalars['Boolean'];
  hasSuite: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  priority?: Maybe<PriorityObject>;
  priorityRequired: Scalars['Boolean'];
  propertyId: Scalars['String'];
  requestedFor: UserObject;
  status?: Maybe<StatusObject>;
  statusRequired: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['String']>;
  suite?: Maybe<SuiteObject>;
  suiteRequired: Scalars['Boolean'];
  title: Scalars['String'];
};

export type GuestWoFormUpdateInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  assigneeRequired?: Scalars['Boolean'];
  attachmentTypes: Array<Scalars['String']>;
  attachmentsRequired?: Scalars['Boolean'];
  categoryId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  floorId?: InputMaybe<Scalars['String']>;
  floorRequired?: Scalars['Boolean'];
  hasAssignee?: Scalars['Boolean'];
  hasAttachments?: Scalars['Boolean'];
  hasFloor?: Scalars['Boolean'];
  hasPriority?: Scalars['Boolean'];
  hasStatus?: Scalars['Boolean'];
  hasSuite?: Scalars['Boolean'];
  priorityId?: InputMaybe<Scalars['String']>;
  priorityRequired?: Scalars['Boolean'];
  requestedForId: Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
  statusRequired?: Scalars['Boolean'];
  subTitle?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  suiteRequired?: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ImportCoiInput = {
  companyId?: InputMaybe<Scalars['String']>;
  contactEmails?: InputMaybe<Array<Scalars['String']>>;
  insideAttachment?: InputMaybe<FileObjectInput>;
  note?: InputMaybe<Scalars['String']>;
  outsideAttachment?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CoiStatusEnum>;
  title?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['String']>;
  validTo?: InputMaybe<Scalars['String']>;
};

export type ImportCoiObject = {
  __typename?: 'ImportCOIObject';
  attachment?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyObject>;
  contactEmails?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<ImportErrorObject>>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<CoiStatusEnum>;
  title?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['String']>;
  validTo?: Maybe<Scalars['String']>;
};

export type ImportCompaniesInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  geneaId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CompanyTypeEnum>;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ImportCompanyObject = {
  __typename?: 'ImportCompanyObject';
  active?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  geneaId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CompanyTypeEnum>;
  vendorId?: Maybe<Scalars['String']>;
};

export type ImportDealCategoryInput = {
  icon?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportDealCategoryObject = {
  __typename?: 'ImportDealCategoryObject';
  errors?: Maybe<Array<ImportErrorObject>>;
  icon?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type ImportDealInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  pdf?: InputMaybe<Scalars['String']>;
  popupDescription?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  validUntil?: InputMaybe<Scalars['DateTime']>;
  website?: InputMaybe<Scalars['String']>;
};

export type ImportDealObject = {
  __typename?: 'ImportDealObject';
  category?: Maybe<DealCategoryObject>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  popupDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ImportEquipmentCategoryInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type ImportEquipmentCategoryObject = {
  __typename?: 'ImportEquipmentCategoryObject';
  errors?: Maybe<Array<ImportErrorObject>>;
  title?: Maybe<Scalars['String']>;
};

export type ImportEquipmentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assetTag?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['String']>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  specificLocation?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportEquipmentObject = {
  __typename?: 'ImportEquipmentObject';
  active?: Maybe<Scalars['Boolean']>;
  assetTag?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Scalars['String']>>;
  building?: Maybe<BuildingObject>;
  category?: Maybe<EquipmentCategoryModel>;
  details?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  floor?: Maybe<FloorObject>;
  manufacturer?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  specificLocation?: Maybe<Scalars['String']>;
  suite?: Maybe<SuiteObject>;
  title?: Maybe<Scalars['String']>;
};

export type ImportErrorObject = {
  __typename?: 'ImportErrorObject';
  error: Scalars['String'];
  key: Scalars['String'];
};

export type ImportFloorInput = {
  buildingId?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportFloorObject = {
  __typename?: 'ImportFloorObject';
  building?: Maybe<BuildingObject>;
  errors?: Maybe<Array<ImportErrorObject>>;
  size?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type ImportIncidentInput = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ImportIncidentObject = {
  __typename?: 'ImportIncidentObject';
  attachments?: Maybe<Array<Scalars['String']>>;
  building?: Maybe<BuildingObject>;
  category?: Maybe<CategoryObject>;
  company?: Maybe<CompanyObject>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  floor?: Maybe<FloorObject>;
  requestedFor?: Maybe<UserObject>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<StatusObject>;
  suite?: Maybe<SuiteObject>;
  timezone?: Maybe<Scalars['String']>;
};

export type ImportMaterialGroupInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type ImportMaterialGroupObject = {
  __typename?: 'ImportMaterialGroupObject';
  errors?: Maybe<Array<ImportErrorObject>>;
  title?: Maybe<Scalars['String']>;
};

export type ImportMaterialInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  markupId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportMaterialObject = {
  __typename?: 'ImportMaterialObject';
  active?: Maybe<Scalars['Boolean']>;
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  glAccount?: Maybe<GlAccountObject>;
  group?: Maybe<MaterialGroupObject>;
  markup?: Maybe<MarkupObject>;
  price?: Maybe<Scalars['Float']>;
  tax?: Maybe<TaxObject>;
  title?: Maybe<Scalars['String']>;
};

export type ImportProcedureInput = {
  estimatedLabor?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<ImportProceduresSectionInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportProcedureObject = {
  __typename?: 'ImportProcedureObject';
  errors?: Maybe<Array<ImportErrorObject>>;
  estimatedLabor?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<ImportProcedureSectionObject>>;
  title?: Maybe<Scalars['String']>;
};

export type ImportProcedureSectionObject = {
  __typename?: 'ImportProcedureSectionObject';
  steps: Array<ImportProcedureSectionStepObject>;
  title: Scalars['String'];
};

export type ImportProcedureSectionStepObject = {
  __typename?: 'ImportProcedureSectionStepObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  inputOptions?: Maybe<ProcedureSectionStepInputOptionObject>;
  predefinedCustomField?: Maybe<PmCustomIdObject>;
  title: Scalars['String'];
  type: PmStepType;
};

export type ImportProceduresSectionInput = {
  steps?: InputMaybe<Array<ImportProceduresStepsInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportProceduresStepsInput = {
  customId?: InputMaybe<Scalars['String']>;
  dropdownOptions?: InputMaybe<PmOptionDropdownInput>;
  inputOptions?: InputMaybe<PmOptionInputInput>;
  predefinedCustomFieldId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PmStepType>;
};

export type ImportRoomInput = {
  addons?: InputMaybe<Array<Scalars['String']>>;
  amenities?: InputMaybe<Array<AmenityInput>>;
  arCodeId?: InputMaybe<Scalars['String']>;
  bufferTime?: InputMaybe<Scalars['Float']>;
  cancellationPeriod?: InputMaybe<Scalars['Float']>;
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  fullDayRate?: InputMaybe<Scalars['Float']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  halfDayMinutes?: InputMaybe<Scalars['Float']>;
  halfDayRate?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<RateIntervalEnum>;
  liabilityPolicy?: InputMaybe<Scalars['String']>;
  maxBookingTime?: InputMaybe<Scalars['Float']>;
  maxRate?: InputMaybe<Scalars['Float']>;
  minBookingTime?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  rateModel?: InputMaybe<RateModelEnum>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<RoomSizeEnum>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type ImportRoomObject = {
  __typename?: 'ImportRoomObject';
  addons?: Maybe<Array<MaterialObject>>;
  amenities?: Maybe<Array<AmenityModel>>;
  arCode?: Maybe<ArCodeObject>;
  bufferTime?: Maybe<Scalars['Float']>;
  cancellationPeriod?: Maybe<Scalars['Float']>;
  cancellationPolicy?: Maybe<Scalars['String']>;
  chargeCode?: Maybe<ChargeCodeObject>;
  color?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  from?: Maybe<Scalars['String']>;
  fullDayRate?: Maybe<Scalars['Float']>;
  glAccount?: Maybe<GlAccountObject>;
  halfDayMinutes?: Maybe<Scalars['Float']>;
  halfDayRate?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['String']>;
  interval?: Maybe<RateIntervalEnum>;
  liabilityPolicy?: Maybe<Scalars['String']>;
  maxBookingTime?: Maybe<Scalars['Float']>;
  maxRate?: Maybe<Scalars['Float']>;
  minBookingTime?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  rateModel?: Maybe<RateModelEnum>;
  requiresApproval?: Maybe<Scalars['Boolean']>;
  size?: Maybe<RoomSizeEnum>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ImportScheduleInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  buildingId?: InputMaybe<Scalars['String']>;
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  equipmentIds?: InputMaybe<Array<Scalars['String']>>;
  excludeDates?: InputMaybe<Array<Scalars['String']>>;
  notes?: InputMaybe<Scalars['String']>;
  procedureIds?: InputMaybe<Array<Scalars['String']>>;
  rruleObject?: InputMaybe<RRuleObjectInput>;
  splitEquipmentOnTask?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  taskTypeId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportScheduleObject = {
  __typename?: 'ImportScheduleObject';
  assignedTo?: Maybe<UserObject>;
  building?: Maybe<BuildingObject>;
  dueAfterDays?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Array<EquipmentModel>>;
  errors?: Maybe<Array<ImportErrorObject>>;
  excludeDates?: Maybe<Array<Scalars['String']>>;
  notes?: Maybe<Scalars['String']>;
  procedures?: Maybe<Array<ProcedureObject>>;
  rruleObject?: Maybe<RRuleObject>;
  splitEquipmentOnTask?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['String']>;
  taskType?: Maybe<TaskTypeModel>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ImportSuiteInput = {
  bomaSize?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SuiteType>;
};

export type ImportSuiteObject = {
  __typename?: 'ImportSuiteObject';
  bomaSize?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  floor?: Maybe<FloorObject>;
  isPublic?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SuiteType>;
};

export type ImportUserObject = {
  __typename?: 'ImportUserObject';
  buildings?: Maybe<Array<BuildingObject>>;
  companies?: Maybe<Array<CompanyObject>>;
  email?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  firstName?: Maybe<Scalars['String']>;
  fullAccessBuildings: Scalars['Boolean'];
  fullAccessCompanies: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<RoleObject>;
  title?: Maybe<Scalars['String']>;
};

export type ImportUsersInput = {
  buildings?: InputMaybe<Array<Scalars['String']>>;
  companies?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullAccessBuildings?: Scalars['Boolean'];
  fullAccessCompanies?: Scalars['Boolean'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ImportWotInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['String']>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  excludeDates?: InputMaybe<Array<Scalars['String']>>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  recordStatus?: InputMaybe<RRuleStatuses>;
  requestedForId?: InputMaybe<Scalars['String']>;
  rruleObject?: InputMaybe<RRuleObjectInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ImportWotObject = {
  __typename?: 'ImportWOTObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<Scalars['String']>>;
  building?: Maybe<BuildingObject>;
  category?: Maybe<CategoryObject>;
  company?: Maybe<CompanyObject>;
  description?: Maybe<Scalars['String']>;
  dueAfterDays?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  excludeDates?: Maybe<Array<Scalars['String']>>;
  floor?: Maybe<FloorObject>;
  priority?: Maybe<PriorityObject>;
  recordStatus?: Maybe<RRuleStatuses>;
  requestedFor?: Maybe<UserObject>;
  rruleObject?: Maybe<RRuleObject>;
  startDate?: Maybe<Scalars['String']>;
  suite?: Maybe<SuiteObject>;
  timezone?: Maybe<Scalars['String']>;
};

export type ImportWatchlistInput = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  userPhoto?: InputMaybe<Scalars['String']>;
};

export type ImportWatchlistObject = {
  __typename?: 'ImportWatchlistObject';
  attachments?: Maybe<Array<Scalars['String']>>;
  company?: Maybe<CompanyObject>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  requestedFor?: Maybe<UserObject>;
  userPhoto?: Maybe<Scalars['String']>;
};

export type ImportWorkOrderInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['String']>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  closedAt?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ImportWorkOrderObject = {
  __typename?: 'ImportWorkOrderObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<Scalars['String']>>;
  building?: Maybe<BuildingObject>;
  category?: Maybe<CategoryObject>;
  closedAt?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyObject>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ImportErrorObject>>;
  floor?: Maybe<FloorObject>;
  priority?: Maybe<PriorityObject>;
  requestedFor?: Maybe<UserObject>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<StatusObject>;
  suite?: Maybe<SuiteObject>;
  timezone?: Maybe<Scalars['String']>;
};

export type IncidentBulkObject = {
  __typename?: 'IncidentBulkObject';
  data?: Maybe<Array<IncidentModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type IncidentInput = {
  attachments?: Array<FileObjectInput>;
  buildingId: Scalars['String'];
  categoryId: Scalars['String'];
  companyId: Scalars['String'];
  customFields?: Array<RecordCustomFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  requestedForId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type IncidentModel = {
  __typename?: 'IncidentModel';
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  category: CategoryObject;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  customFields: Array<RecordCustomFieldObject>;
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  incidentWatchers?: Maybe<Array<UserObject>>;
  index: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  requestedFor?: Maybe<UserObject>;
  startDate: Scalars['DateTime'];
  status: StatusObject;
  suite?: Maybe<SuiteObject>;
  timezone: Scalars['String'];
};

export type IncidentShareInput = {
  emails: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type IncidentUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  categoryId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type IntegrationAuthCheckDto = {
  __typename?: 'IntegrationAuthCheckDTO';
  successful: Scalars['Boolean'];
};

export type IntegrationBlocksDto = {
  __typename?: 'IntegrationBlocksDTO';
  isPublic: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type IntegrationListModel = {
  __typename?: 'IntegrationListModel';
  hasIntegration: Scalars['Boolean'];
  status: Scalars['Int'];
  type: IntegrationTypeEnum;
};

export type IntegrationSettingsInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type IntegrationSetupModel = {
  __typename?: 'IntegrationSetupModel';
  hasIntegration: Scalars['Boolean'];
  keys: Array<IntegrationBlocksDto>;
  status: Scalars['Boolean'];
  type: IntegrationTypeEnum;
};

export enum IntegrationTypeEnum {
  Amano = 'Amano',
  Genea = 'Genea',
  Intercom = 'Intercom',
  Mailgun = 'Mailgun',
  PrintNode = 'PrintNode',
  Stripe = 'Stripe',
  Twilio = 'Twilio'
}

export type InvoiceChargeInputData = {
  baseTaxable?: Scalars['Boolean'];
  date?: InputMaybe<Scalars['String']>;
  employeeUserId?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Float']>;
  laborRateId?: InputMaybe<Scalars['String']>;
  markupAmount?: InputMaybe<Scalars['Float']>;
  markupId?: InputMaybe<Scalars['String']>;
  markupTaxable?: Scalars['Boolean'];
  markupType?: InputMaybe<ValueUnit>;
  materialId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Float']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['String']>;
  total: Scalars['Float'];
  type: ChargeEnum;
};

export type InvoiceChargeObject = {
  __typename?: 'InvoiceChargeObject';
  baseTaxable: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['String']>;
  employeeUser?: Maybe<UserObject>;
  feature?: Maybe<InvoiceFeatureObject>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  laborRate?: Maybe<LaborRateObject>;
  markup?: Maybe<MarkupObject>;
  markupAmount?: Maybe<Scalars['Float']>;
  markupTaxable: Scalars['Boolean'];
  markupType?: Maybe<ValueUnit>;
  material?: Maybe<MaterialObject>;
  notes?: Maybe<Scalars['String']>;
  originalChargeId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  tax?: Maybe<TaxObject>;
  taxAmount?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  type: ChargeEnum;
};

export enum InvoiceFeatureEnum {
  Reservation = 'RESERVATION',
  Task = 'TASK',
  WorkOrder = 'WORK_ORDER'
}

export type InvoiceFeatureObject = {
  __typename?: 'InvoiceFeatureObject';
  id: Scalars['String'];
  index: Scalars['Int'];
  status: ObjectStatus;
  title?: Maybe<Scalars['String']>;
  type: InvoiceFeatureEnum;
};

export type InvoiceInput = {
  companyId: Scalars['String'];
  dueDate: Scalars['DateTime'];
  invoiceDate: Scalars['DateTime'];
  notes?: InputMaybe<Scalars['String']>;
};

export type InvoiceItemObject = {
  __typename?: 'InvoiceItemObject';
  charges: Array<ChargeItemObject>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoiceLink?: Maybe<Scalars['String']>;
};

export type InvoiceObject = {
  __typename?: 'InvoiceObject';
  attachments?: Maybe<Array<FileObject>>;
  bcc?: Maybe<Array<Scalars['String']>>;
  billTo?: Maybe<Scalars['String']>;
  cc?: Maybe<Array<Scalars['String']>>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueDate: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  file?: Maybe<FileObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  invoiceDate: Scalars['DateTime'];
  invoiceTemplateId?: Maybe<Scalars['String']>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  paidAmount: Scalars['Float'];
  status: InvoiceStatus;
  stripeAccount?: Maybe<StripeAccountObject>;
  totalAmount: Scalars['Float'];
};

export type InvoicePaymentInput = {
  amount: Scalars['Float'];
  invoiceId: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  tax: Scalars['Float'];
};

export enum InvoicePaymentStatusEnum {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartialRefunded = 'PARTIAL_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Success = 'SUCCESS'
}

/** The supported statuses for invoice item. */
export enum InvoiceStatus {
  Due = 'DUE',
  Open = 'OPEN',
  Overdue = 'OVERDUE',
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  Voided = 'VOIDED'
}

export type InvoiceUpdateInput = {
  bcc?: InputMaybe<Array<Scalars['String']>>;
  billTo?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type KioskSettingsInput = {
  kioskBgColor?: InputMaybe<Scalars['String']>;
  kioskBgImg?: InputMaybe<FileObjectInput>;
  locatorCheckIn?: InputMaybe<Scalars['Boolean']>;
  qrCodeCheckIn?: InputMaybe<Scalars['Boolean']>;
  qrScanCamera?: InputMaybe<CameraType>;
  qrScanCameraFlip?: InputMaybe<Scalars['Boolean']>;
  selfieCamera?: InputMaybe<CameraType>;
  selfieCameraFlip?: InputMaybe<Scalars['Boolean']>;
  welcomeGuestSubtitle?: InputMaybe<Scalars['String']>;
  welcomeText?: InputMaybe<Scalars['String']>;
};

export type KioskSettingsObject = {
  __typename?: 'KioskSettingsObject';
  kioskBgColor?: Maybe<Scalars['String']>;
  kioskBgImg?: Maybe<FileObject>;
  locatorCheckIn?: Maybe<Scalars['Boolean']>;
  qrCodeCheckIn?: Maybe<Scalars['Boolean']>;
  qrScanCamera?: Maybe<CameraType>;
  qrScanCameraFlip?: Maybe<Scalars['Boolean']>;
  selfieCamera?: Maybe<CameraType>;
  selfieCameraFlip?: Maybe<Scalars['Boolean']>;
  welcomeGuestSubtitle?: Maybe<Scalars['String']>;
  welcomeText?: Maybe<Scalars['String']>;
};

export type LaborRateInput = {
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  markupId?: InputMaybe<Scalars['String']>;
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type LaborRateObject = {
  __typename?: 'LaborRateObject';
  active: Scalars['Boolean'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  markup?: Maybe<MarkupObject>;
  propertyId?: Maybe<Scalars['String']>;
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type LeaseChargeTypeObject = {
  __typename?: 'LeaseChargeTypeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum LeaseFeeUnitEnum {
  Percent = 'PERCENT',
  Value = 'VALUE'
}

export type LeaseInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  companyId: Scalars['String'];
  gracePeriod?: InputMaybe<Scalars['Int']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']>;
  lateFeeUnit?: InputMaybe<LeaseFeeUnitEnum>;
  rentFootage?: InputMaybe<Scalars['Float']>;
  rents: Array<LeaseRentInput>;
};

export type LeaseObject = {
  __typename?: 'LeaseObject';
  attachments?: Maybe<Array<FileObject>>;
  company: CompanyObject;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserObject;
  gracePeriod?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  lateFeeAmount?: Maybe<Scalars['Float']>;
  lateFeeUnit?: Maybe<LeaseFeeUnitEnum>;
  leaseEnd: Scalars['String'];
  leaseStart: Scalars['String'];
  rentFootage?: Maybe<Scalars['Float']>;
  rents: Array<LeaseRentObject>;
  status: LeaseStatusEnum;
  suites: Array<SuiteObject>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LeaseRentInput = {
  amount: Scalars['Float'];
  chargeTypeId: Scalars['String'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  suiteIds: Array<Scalars['String']>;
};

export type LeaseRentObject = {
  __typename?: 'LeaseRentObject';
  amount: Scalars['Float'];
  chargeType: LeaseChargeTypeObject;
  endDate: Scalars['String'];
  id: Scalars['String'];
  startDate: Scalars['String'];
  suites: Array<SuiteObject>;
};

export enum LeaseStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type LeaseUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']>;
  lateFeeUnit?: InputMaybe<LeaseFeeUnitEnum>;
  rentFootage?: InputMaybe<Scalars['Float']>;
};

export type LoginCodeInput = {
  code: Scalars['String'];
  type: TwoFaTypeEnum;
  userId: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  portfolioId: Scalars['String'];
  rememberMe?: Scalars['Boolean'];
};

export type LoginObject = {
  __typename?: 'LoginObject';
  token?: Maybe<Scalars['String']>;
  twoFA?: Maybe<TwoFaObject>;
};

export type MagicLoginAuthInput = {
  portfolioId: Scalars['String'];
  token: Scalars['String'];
};

export type MagicLoginInput = {
  email: Scalars['String'];
  portfolioId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};

export type MagicLoginObject = {
  __typename?: 'MagicLoginObject';
  email: Scalars['String'];
  portfolios: Array<PortfolioModel>;
};

export type ManualGuestInputDto = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  companyId: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  requestedForId: Scalars['String'];
};

export type MarkUpInput = {
  amount: Scalars['Float'];
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ValueUnit;
};

export type MarkupObject = {
  __typename?: 'MarkupObject';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: ValueUnit;
};

export type MaterialGroupObject = {
  __typename?: 'MaterialGroupObject';
  categoryCount: Scalars['Int'];
  id: Scalars['String'];
  index: Scalars['Int'];
  materials?: Maybe<Array<MaterialObject>>;
  title: Scalars['String'];
};

export type MaterialInput = {
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  markupId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MaterialObject = {
  __typename?: 'MaterialObject';
  active: Scalars['Boolean'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  group: MaterialGroupObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  markup?: Maybe<MarkupObject>;
  price?: Maybe<Scalars['Float']>;
  tax?: Maybe<TaxObject>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MenuItemInput = {
  children?: InputMaybe<Array<MenuItemInput>>;
  currentId: Scalars['String'];
  embedBody?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: MenuTypes;
  url?: InputMaybe<Scalars['String']>;
};

export type MenuItemObject = {
  __typename?: 'MenuItemObject';
  children?: Maybe<Array<MenuItemObject>>;
  currentId: Scalars['String'];
  embedBody?: Maybe<Scalars['String']>;
  featureId?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  product?: Maybe<ProductItemObject>;
  propertyId: Scalars['String'];
  title: Scalars['String'];
  type: MenuTypes;
  url?: Maybe<Scalars['String']>;
};

/** The supported types for menu items. */
export enum MenuLocation {
  /** Menu for mobile app */
  Mobile = 'mobile',
  /** Menu for web app */
  Web = 'web'
}

/** The supported types for menu items. */
export enum MenuTypes {
  /** Some embed code */
  Embed = 'embed',
  /** Any link outside app */
  ExternalLink = 'externalLink',
  /** In the app feature */
  Feature = 'feature',
  /** Any link inside app */
  Link = 'link',
  /** Any product item in the system */
  Product = 'product',
  /** No link just title for some group of links */
  SectionTitle = 'sectionTitle'
}

export type MinPermissionObject = {
  __typename?: 'MinPermissionObject';
  key: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeWorkOrder: WorkOrderObject;
  activateInvoices: Scalars['Boolean'];
  addComment: ActivityLogModel;
  addCompanyToProperty: CompanyObject;
  addInvoiceAttachments: InvoiceObject;
  addInvoiceCharges: Scalars['Boolean'];
  addLeaseRent: LeaseObject;
  addPackageAttachments: PackageObject;
  addRecurringInvoiceAttachments: RecurringInvoiceObject;
  addRecurringInvoicePayment: RecurringInvoicePaymentObject;
  addRepositoryFiles: Scalars['Boolean'];
  addRepositoryFolder: Scalars['Boolean'];
  addScheduleAttachments: SchedulesObject;
  addScheduleEquipment: SchedulesObject;
  addScheduleProcedure: SchedulesObject;
  addSubscriptionAttachments: SubscriptionObject;
  addTaskAttachments: TaskObject;
  addTaskEquipment: TaskObject;
  addTaskProcedure: TaskObject;
  addUserToProperty: UserObject;
  addWorkOrderEquipment: Scalars['Boolean'];
  approveRoomReservation: Scalars['Boolean'];
  archiveCois: Scalars['Boolean'];
  archiveIncidents: Scalars['Boolean'];
  archiveWorkOrders: Scalars['Boolean'];
  bulkAssigneeWO: WorkOrderBulkObject;
  bulkAssigneeWOTemplate: WorkOrderTemplateBulkObject;
  bulkPauseRecurringInvoice: RecurringInvoiceBulkObject;
  bulkPauseSchedules: SchedulesBulkObject;
  bulkPauseWOTemplate: WorkOrderTemplateBulkObject;
  bulkSkipNextRecurringInvoice: RecurringInvoiceBulkObject;
  bulkSkipNextSchedules: SchedulesBulkObject;
  bulkSkipNextWOTemplate: WorkOrderTemplateBulkObject;
  bulkStatusCois: CoiBulkObject;
  bulkStatusGuests: GuestBulkObject;
  bulkStatusIncidents: IncidentBulkObject;
  bulkStatusPackages: PackageBulkObject;
  bulkStatusUser: UserBulkObject;
  bulkStatusVendorAccess: VendorAccessBulkObject;
  bulkStatusWO: WorkOrderBulkObject;
  cancelRoomReservation: Scalars['Boolean'];
  cancelSubscription: SubscriptionObject;
  checkSubscriptionTrial: Scalars['Boolean'];
  completeTask: TaskObject;
  createARCode: ArCodeObject;
  createBuilding: BuildingObject;
  createCategory: CategoryObject;
  createCategoryGroup: CategoryGroupObject;
  createCharge: ChargeObject;
  createChargeCode: ChargeCodeObject;
  createCoi: CoiObject;
  createCoiEmail: CoiEmailObject;
  createCompany: CompanyObject;
  createCoupon: CouponObject;
  createCustomField: CustomFieldObject;
  createDeal: DealObject;
  createDealCategory: DealCategoryObject;
  createDevice: DeviceModel;
  createDocCategory: DocCategoryObject;
  createEmployee: EmployeeObject;
  createEquipment: EquipmentModel;
  createEquipmentCategory: EquipmentCategoryModel;
  createEvent: EventObject;
  createFloor: FloorObject;
  createGLAccount: GlAccountObject;
  createGeneaUserCard: GeneaUserCardObject;
  createGuestWorkOrderForm: GuestWoFormObject;
  createIncident: IncidentModel;
  createInvoice: InvoiceObject;
  createInvoiceCharge: InvoiceChargeObject;
  createLaborRate: LaborRateObject;
  createLease: LeaseObject;
  createLeaseChargeType: LeaseChargeTypeObject;
  createMarkup: MarkupObject;
  createMaterial: MaterialObject;
  createMaterialGroup: MaterialGroupObject;
  createNewsFeed: NewsfeedObject;
  createPMCustomId: PmCustomIdObject;
  createPMReport: ReportModel;
  createPackages: Array<PackageObject>;
  createPredefinedBroadcast: PredefinedBroadcastObject;
  createPrinter: PrinterModel;
  createPriority: PriorityObject;
  createProcedure: ProcedureObject;
  createProduct: ProductItemObject;
  createPropertyAddon: PropertyAddonObject;
  createPublicWorkOrder: Scalars['Boolean'];
  createRecurringInvoice: RecurringInvoiceObject;
  createReport: ReportModel;
  createRoom: RoomObject;
  createRoomReservation: RoomReservationObject;
  createSchedule: SchedulesObject;
  createShippingProvider: ShippingProviderObject;
  createStatus: StatusObject;
  createSubscription?: Maybe<SubscriptionObject>;
  createSuite: SuiteObject;
  createTaskType: TaskTypeModel;
  createTax: TaxObject;
  createUser: UserObject;
  createUserPaymentMethod: StripeSetupIntent;
  createWOReview: Scalars['Boolean'];
  createWaiverTemplate: WaiverTemplateModel;
  createWatchlist: WatchlistObject;
  createWorkOrder: WorkOrderObject;
  createWorkOrderEmail: WorkOrderEmailObject;
  createWorkOrderTemplate: WorkOrderTemplateObject;
  deactivateInvoices: Scalars['Boolean'];
  deleteAmanoSettings: Scalars['Boolean'];
  deleteDevices: Scalars['Boolean'];
  deleteEquipmentAttachment: Scalars['Boolean'];
  deleteGeneaUserCard: Scalars['Boolean'];
  deleteGuestAttachment: Scalars['Boolean'];
  deleteIncidentAttachment: Scalars['Boolean'];
  deletePackageAttachment: PackageObject;
  deletePackages: Scalars['Boolean'];
  deletePrinters: Scalars['Boolean'];
  deleteRecurringInvoiceAttachment: RecurringInvoiceObject;
  deleteRepositoryFiles: Scalars['Boolean'];
  deleteRoomReservationAttachment: Scalars['Boolean'];
  deleteVendorAccessAttachment: Scalars['Boolean'];
  deleteWOAttachment: Scalars['Boolean'];
  deleteWOTemplateAttachment: Scalars['Boolean'];
  deleteWatchlistAttachment: Scalars['Boolean'];
  denyRoomReservation: Scalars['Boolean'];
  downloadRepositoryFiles: Scalars['String'];
  forgotPassword: Scalars['Boolean'];
  generateInvoicePDF: InvoiceObject;
  generateRecurringInvoice: Scalars['Boolean'];
  generateRoomReservationWO: RoomReservationObject;
  generateSubscriptionWaiverText: SubscriptionWaiverTextModel;
  generateTask: Scalars['Boolean'];
  generateWorkOrder: Scalars['Boolean'];
  guestCheckIn: Scalars['Boolean'];
  guestWebCheckIn: GuestActionObject;
  handleStripeOauth: Scalars['Boolean'];
  importParseCOIs: Array<ImportCoiObject>;
  importParseCompanies: Array<ImportCompanyObject>;
  importParseDealCategories: Array<ImportDealCategoryObject>;
  importParseDeals: Array<ImportDealObject>;
  importParseEquipment: Array<ImportEquipmentObject>;
  importParseEquipmentCategories: Array<ImportEquipmentCategoryObject>;
  importParseFloors: Array<ImportFloorObject>;
  importParseIncidents: Array<ImportIncidentObject>;
  importParseMaterialGroups: Array<ImportMaterialGroupObject>;
  importParseMaterials: Array<ImportMaterialObject>;
  importParseProcedures: Array<ImportProcedureObject>;
  importParseRooms: Array<ImportRoomObject>;
  importParseSchedules: Array<ImportScheduleObject>;
  importParseSuites: Array<ImportSuiteObject>;
  importParseUsers: Array<ImportUserObject>;
  importParseWatchlist: Array<ImportWatchlistObject>;
  importParseWorkOrderTemplates: Array<ImportWotObject>;
  importParseWorkOrders: Array<ImportWorkOrderObject>;
  importStoreCOIs?: Maybe<Array<ImportCoiObject>>;
  importStoreCompanies?: Maybe<Array<ImportCompanyObject>>;
  importStoreDealCategories?: Maybe<Array<ImportDealCategoryObject>>;
  importStoreDeals?: Maybe<Array<ImportDealObject>>;
  importStoreEquipment?: Maybe<Array<ImportEquipmentObject>>;
  importStoreEquipmentCategories?: Maybe<Array<ImportEquipmentCategoryObject>>;
  importStoreFloors?: Maybe<Array<ImportFloorObject>>;
  importStoreIncidents?: Maybe<Array<ImportIncidentObject>>;
  importStoreMaterialGroups?: Maybe<Array<ImportMaterialGroupObject>>;
  importStoreMaterials?: Maybe<Array<ImportMaterialObject>>;
  importStoreProcedures?: Maybe<Array<ImportProcedureObject>>;
  importStoreRooms?: Maybe<Array<ImportRoomObject>>;
  importStoreSchedules?: Maybe<Array<ImportScheduleObject>>;
  importStoreSuites?: Maybe<Array<ImportSuiteObject>>;
  importStoreUsers?: Maybe<Array<ImportUserObject>>;
  importStoreWatchlist?: Maybe<Array<ImportWatchlistObject>>;
  importStoreWorkOrderTemplates?: Maybe<Array<ImportWotObject>>;
  importStoreWorkOrders?: Maybe<Array<ImportWorkOrderObject>>;
  incidentSubscribe: Array<UserObject>;
  invoicePay: Scalars['Boolean'];
  invoicePaymentRefund: PaymentsObject;
  markAllNotificationsAsRead: Scalars['Boolean'];
  markNotificationAsRead: Scalars['Boolean'];
  moveRepositoryFiles: Scalars['Boolean'];
  newsFeedToggleLike: NewsfeedObject;
  notifyGuest: Array<UserObject>;
  notifyVendorAccess: Array<UserObject>;
  pairDevice: DeviceTokenModel;
  printGuestBadge: GuestPrintActionObject;
  printVendorAccessBadge: VendorAccessPrintActionObject;
  redeemDeal: Scalars['Boolean'];
  refundCharge: Scalars['Boolean'];
  registerEvent: EventObject;
  removeARCodes: Scalars['Boolean'];
  removeBuildings: Scalars['Boolean'];
  removeCategories: Scalars['Boolean'];
  removeCategoryGroups: Scalars['Boolean'];
  removeCharge: Scalars['Boolean'];
  removeChargeCodes: Scalars['Boolean'];
  removeCharges: Scalars['Boolean'];
  removeCoi: Scalars['Boolean'];
  removeCoiEmails: Scalars['Boolean'];
  removeComment: Scalars['Boolean'];
  removeCompanies: Scalars['Boolean'];
  removeCoupons: Scalars['Boolean'];
  removeCustomFields: Scalars['Boolean'];
  removeDealCategories: Scalars['Boolean'];
  removeDeals: Scalars['Boolean'];
  removeDocCategories: Scalars['Boolean'];
  removeEmployees: Scalars['Boolean'];
  removeEquipmentCategories: Scalars['Boolean'];
  removeEquipments: Scalars['Boolean'];
  removeEvent: Scalars['Boolean'];
  removeEvents: Scalars['Boolean'];
  removeFloors: Scalars['Boolean'];
  removeGLAccounts: Scalars['Boolean'];
  removeGuestWorkOrderForm: Scalars['Boolean'];
  removeIncidents: Scalars['Boolean'];
  removeIntegration: Scalars['Boolean'];
  removeInvoiceAttachment: InvoiceObject;
  removeInvoiceCharges: Scalars['Boolean'];
  removeLaborRates: Scalars['Boolean'];
  removeLeaseAttachment: Scalars['Boolean'];
  removeLeaseChargeTypes: Scalars['Boolean'];
  removeLeaseRent: LeaseObject;
  removeLeases: Scalars['Boolean'];
  removeMarkups: Scalars['Boolean'];
  removeMaterialGroups: Scalars['Boolean'];
  removeMaterials: Scalars['Boolean'];
  removeNewsFeeds: Scalars['Boolean'];
  removePMCustomIds: Scalars['Boolean'];
  removePredefinedBroadcasts: Scalars['Boolean'];
  removePriorities: Scalars['Boolean'];
  removeProcedures: Scalars['Boolean'];
  removeProducts: Scalars['Boolean'];
  removePropertyAddons: Scalars['Boolean'];
  removeRecurringInvoicePayment: Scalars['Boolean'];
  removeRecurringInvoices: Scalars['Boolean'];
  removeReports: Scalars['Boolean'];
  removeRooms: Scalars['Boolean'];
  removeScheduleAttachment: SchedulesObject;
  removeScheduleEquipment: SchedulesObject;
  removeScheduleProcedure: SchedulesObject;
  removeSchedules: Scalars['Boolean'];
  removeShippingProviders: Scalars['Boolean'];
  removeStatuses: Scalars['Boolean'];
  removeSubscriptionAttachment: SubscriptionObject;
  removeSuites: Scalars['Boolean'];
  removeTaskAttachment: TaskObject;
  removeTaskEquipment: TaskObject;
  removeTaskProcedure: TaskObject;
  removeTaskStepAttachment: TaskObject;
  removeTaskTypes: Scalars['Boolean'];
  removeTasks: Scalars['Boolean'];
  removeTaxes: Scalars['Boolean'];
  removeUserPaymentMethod: Scalars['Boolean'];
  removeUserPhone: Scalars['Boolean'];
  removeUserWidget: Scalars['Boolean'];
  removeWaiverTemplates: Scalars['Boolean'];
  removeWatchlist: Scalars['Boolean'];
  removeWorkOrderEmails: Scalars['Boolean'];
  removeWorkOrderEquipment: Scalars['Boolean'];
  removeWorkOrderTemplates: Scalars['Boolean'];
  removeWorkOrders: Scalars['Boolean'];
  reorderCategories: Scalars['Boolean'];
  reorderCustomFields: Scalars['Boolean'];
  reorderDealCategories: Scalars['Boolean'];
  reorderDocCategories: Scalars['Boolean'];
  reorderEmployees: Scalars['Boolean'];
  reorderFloors: Scalars['Boolean'];
  reorderLaborRates: Scalars['Boolean'];
  reorderLeaseChargeTypes: Scalars['Boolean'];
  reorderMarkups: Scalars['Boolean'];
  reorderMaterials: Scalars['Boolean'];
  reorderPriorities: Scalars['Boolean'];
  reorderRooms: Scalars['Boolean'];
  reorderStatuses: Scalars['Boolean'];
  reorderSuites: Scalars['Boolean'];
  reorderTableFloors: Scalars['Boolean'];
  reorderTaxes: Scalars['Boolean'];
  requestLoginCode: Scalars['Boolean'];
  resendGuestEmail: Scalars['Boolean'];
  resendVendorAccessEmail: Scalars['Boolean'];
  resendWelcomeEmail: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resumeSubscription: SubscriptionObject;
  saveAmanoSettings: AmanoSettingsObject;
  saveEventRating: EventObject;
  saveMenu: Scalars['Boolean'];
  saveUserVerificationPaymentMethod: Scalars['Boolean'];
  saveUserWidget: UserWidgetObject;
  sendBroadcast: BroadcastObject;
  sendEventMessage: Scalars['Boolean'];
  sendInvoice: Scalars['Boolean'];
  sendTestMail: Scalars['Boolean'];
  setPrimaryDevice: DeviceModel;
  setTaskStepCustomId: TaskObject;
  setTaskStepValue: TaskObject;
  setUserDefaultPaymentMethod: Scalars['Boolean'];
  shareIncident: Scalars['Boolean'];
  shareInvoice: Scalars['Boolean'];
  shareWorkOrder: Scalars['Boolean'];
  skipRecurringInvoiceDate: RecurringInvoiceObject;
  skipScheduleDate: SchedulesObject;
  skipWOTemplateDate: WorkOrderTemplateObject;
  storeDeviceLog: DeviceLogModel;
  storeGuests: Scalars['Boolean'];
  storeIntegration: Scalars['String'];
  storeRecentSearch: Scalars['Boolean'];
  storeVendorAccess: Scalars['Boolean'];
  syncPrinters: Scalars['Boolean'];
  syncRoomReservationWO: RoomReservationObject;
  testIntegration: IntegrationAuthCheckDto;
  toggleARCode: Scalars['Boolean'];
  toggleBuilding: Scalars['Boolean'];
  toggleCategory: Scalars['Boolean'];
  toggleCategoryGroup: Scalars['Boolean'];
  toggleChargeCode: Scalars['Boolean'];
  toggleCoiEmail: Scalars['Boolean'];
  toggleCompany: Scalars['Boolean'];
  toggleCustomField: Scalars['Boolean'];
  toggleCustomTemplate: EmailTemplateObject;
  toggleDeal: Scalars['Boolean'];
  toggleDevice: Scalars['Boolean'];
  toggleEmailTemplate: Scalars['Boolean'];
  toggleEmployee: Scalars['Boolean'];
  toggleEquipment: Scalars['Boolean'];
  toggleGLAccount: Scalars['Boolean'];
  toggleGeneaDoors: Scalars['Boolean'];
  toggleGuestWorkOrderForm: Scalars['Boolean'];
  toggleIntegration: Scalars['Boolean'];
  toggleLaborRate: Scalars['Boolean'];
  toggleLeaseChargeType: Scalars['Boolean'];
  toggleLoginAuth: Scalars['Boolean'];
  toggleMarkup: Scalars['Boolean'];
  toggleMaterial: Scalars['Boolean'];
  toggleMyNotification: Scalars['Boolean'];
  togglePMCustomId: Scalars['Boolean'];
  togglePredefinedBroadcast: Scalars['Boolean'];
  togglePriority: Scalars['Boolean'];
  toggleProcedure: Scalars['Boolean'];
  toggleProduct: Scalars['Boolean'];
  toggleRoom: Scalars['Boolean'];
  toggleScheduleSplitEquipmentOnTask: SchedulesObject;
  toggleStatus: Scalars['Boolean'];
  toggleTask: TaskObject;
  toggleTaskType: Scalars['Boolean'];
  toggleTaskWatcher: Array<UserObject>;
  toggleTax: Scalars['Boolean'];
  toggleWatchlist: Scalars['Boolean'];
  toggleWorkOrderEmail: Scalars['Boolean'];
  unArchiveCois: Scalars['Boolean'];
  unArchiveIncidents: Scalars['Boolean'];
  unArchiveWorkOrders: Scalars['Boolean'];
  unPairDevice: Scalars['Boolean'];
  unRegisterEvent: EventObject;
  unSyncRoomReservationWO: RoomReservationObject;
  updateARCode: ArCodeObject;
  updateAmanoSettings: AmanoSettingsObject;
  updateBuilding: BuildingObject;
  updateCategory: CategoryObject;
  updateCategoryGroup: CategoryGroupObject;
  updateCharge: ChargeObject;
  updateChargeCode: ChargeCodeObject;
  updateCoi: CoiObject;
  updateCoiEmail: CoiEmailObject;
  updateCompany: CompanyObject;
  updateCompanyAddress: CompanyObject;
  updateCompanyBilling: CompanyObject;
  updateCompanyPhoto: CompanyObject;
  updateCoupon: CouponObject;
  updateCustomField: CustomFieldObject;
  updateDeal: DealObject;
  updateDealCategory: DealCategoryObject;
  updateDevice: DeviceModel;
  updateDocCategory: DocCategoryObject;
  updateEmailTemplate: Scalars['Boolean'];
  updateEmployee: EmployeeObject;
  updateEquipment: EquipmentModel;
  updateEquipmentCategory: EquipmentCategoryModel;
  updateEvent: EventObject;
  updateFloor: FloorObject;
  updateGLAccount: GlAccountObject;
  updateGeneaProductAccessLink: ProductItemObject;
  updateGeneaSettings: GeneaSettingObject;
  updateGeneaTenantLink: CompanyObject;
  updateGeneaUserAvatar: Scalars['Boolean'];
  updateGuestSettings: GuestSettingsObject;
  updateGuestVisit: GuestModel;
  updateGuestWorkOrderForm: GuestWoFormObject;
  updateIncident: IncidentModel;
  updateIncidentCustomField: RecordCustomFieldObject;
  updateInvoice: InvoiceObject;
  updateInvoiceCharge: InvoiceChargeObject;
  updateKioskSettings: KioskSettingsObject;
  updateLaborRate: LaborRateObject;
  updateLease: LeaseObject;
  updateLeaseChargeType: LeaseChargeTypeObject;
  updateLeaseRent: LeaseObject;
  updateMarkup: MarkupObject;
  updateMaterial: MaterialObject;
  updateMaterialGroup: MaterialGroupObject;
  updateNewsFeed: NewsfeedObject;
  updatePMCustomId: PmCustomIdObject;
  updatePackages: PackageObject;
  updatePortfolioCategory: CategoryObject;
  updatePredefinedBroadcast: PredefinedBroadcastObject;
  updatePrinter: PrinterModel;
  updatePriority: PriorityObject;
  updateProcedure: ProcedureObject;
  updateProduct: ProductItemObject;
  updateProperty: PropertyObject;
  updatePropertyAddon: PropertyAddonObject;
  updateRecurringInvoice: RecurringInvoiceObject;
  updateRecurringInvoiceNextGenerationDate: RecurringInvoiceObject;
  updateReportSettings: ReportSettingsObject;
  updateRepositoryFolder: Scalars['Boolean'];
  updateRoom: RoomObject;
  updateRoomReservation: RoomReservationObject;
  updateRoomReservationCustomField: RecordCustomFieldObject;
  updateRoomSettings: RoomSettingObject;
  updateScheduleAssignedToId: SchedulesObject;
  updateScheduleDueAfterDays: SchedulesObject;
  updateScheduleNextGenerationDate: SchedulesObject;
  updateScheduleNotes: SchedulesObject;
  updateScheduleRRule: SchedulesObject;
  updateScheduleTaskType: SchedulesObject;
  updateScheduleTitle: SchedulesObject;
  updateShippingProvider: ShippingProviderObject;
  updateStatus: StatusObject;
  updateStripeSettings: StripeSettingsObject;
  updateSubscription: SubscriptionObject;
  updateSubscriptionCoupon: SubscriptionObject;
  updateSuite: SuiteObject;
  updateTaskAssignedTo: TaskObject;
  updateTaskDueDate: TaskObject;
  updateTaskNotes: TaskObject;
  updateTaskProcedureNotes: TaskObject;
  updateTaskTaskType: TaskObject;
  updateTaskType: TaskTypeModel;
  updateTax: TaxObject;
  updateUser: UserObject;
  updateUserPhone: Scalars['Boolean'];
  updateUserPhoto: UserObject;
  updateUserPreference: UserObject;
  updateUserPrinter: UserObject;
  updateUserWidgetsLayout: Scalars['Boolean'];
  updateVendorAccessVisit: VendorAccessModel;
  updateWOTemplateNextGenerationDate: WorkOrderTemplateObject;
  updateWaiverTemplate: WaiverTemplateModel;
  updateWatchlist: WatchlistObject;
  updateWorkOrder: WorkOrderObject;
  updateWorkOrderCustomField: RecordCustomFieldObject;
  updateWorkOrderEmail: WorkOrderEmailObject;
  updateWorkOrderTemplate: WorkOrderTemplateObject;
  uploadFiles: Array<UploadFileDto>;
  uploadGuestCsv: Array<GuestCsvObject>;
  validateCoupon: CouponValidationObject;
  validateSubscriptionCoupon: CouponValidationObject;
  vendorAccessCheckIn: Scalars['Boolean'];
  vendorAccessWebCheckIn: VendorAccessActionObject;
  verifyPhone: Scalars['Boolean'];
  workOrderSubscribe: Array<UserObject>;
};


export type MutationAcknowledgeWorkOrderArgs = {
  workOrderId: Scalars['String'];
};


export type MutationActivateInvoicesArgs = {
  input: DeleteRecordsInput;
};


export type MutationAddCommentArgs = {
  input: CommentInput;
};


export type MutationAddCompanyToPropertyArgs = {
  input: CompanyPropertyAddInput;
};


export type MutationAddInvoiceAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  id: Scalars['String'];
};


export type MutationAddInvoiceChargesArgs = {
  chargeIds: Array<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationAddLeaseRentArgs = {
  input: Array<LeaseRentInput>;
  leaseId: Scalars['String'];
};


export type MutationAddPackageAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  id: Scalars['String'];
};


export type MutationAddRecurringInvoiceAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  id: Scalars['String'];
};


export type MutationAddRecurringInvoicePaymentArgs = {
  input: RecurringInvoicePaymentInput;
};


export type MutationAddRepositoryFilesArgs = {
  destinationId?: InputMaybe<Scalars['String']>;
  files: Array<FileObjectInput>;
};


export type MutationAddRepositoryFolderArgs = {
  destinationId?: InputMaybe<Scalars['String']>;
  isPrivate?: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationAddScheduleAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  scheduleId: Scalars['String'];
};


export type MutationAddScheduleEquipmentArgs = {
  equipmentId: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationAddScheduleProcedureArgs = {
  procedureId: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationAddSubscriptionAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  subscriptionId: Scalars['String'];
};


export type MutationAddTaskAttachmentsArgs = {
  attachments: Array<FileObjectInput>;
  taskId: Scalars['String'];
};


export type MutationAddTaskEquipmentArgs = {
  equipmentId: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationAddTaskProcedureArgs = {
  procedureId: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationAddUserToPropertyArgs = {
  input: UserPropertyAddInput;
};


export type MutationAddWorkOrderEquipmentArgs = {
  input: WorkOrderEquipmentAddInput;
};


export type MutationApproveRoomReservationArgs = {
  reservationId: Scalars['String'];
};


export type MutationArchiveCoisArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationArchiveIncidentsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationArchiveWorkOrdersArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationBulkAssigneeWoArgs = {
  assignedToId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['String']>;
};


export type MutationBulkAssigneeWoTemplateArgs = {
  assignedToId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['String']>;
};


export type MutationBulkPauseRecurringInvoiceArgs = {
  ids: Array<Scalars['String']>;
  pause: Scalars['Boolean'];
};


export type MutationBulkPauseSchedulesArgs = {
  ids: Array<Scalars['String']>;
  pause: Scalars['Boolean'];
};


export type MutationBulkPauseWoTemplateArgs = {
  ids: Array<Scalars['String']>;
  pause: Scalars['Boolean'];
};


export type MutationBulkSkipNextRecurringInvoiceArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationBulkSkipNextSchedulesArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationBulkSkipNextWoTemplateArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationBulkStatusCoisArgs = {
  ids: Array<Scalars['String']>;
  status?: InputMaybe<CoiStatusEnum>;
};


export type MutationBulkStatusGuestsArgs = {
  ids: Array<Scalars['String']>;
  status: GuestStatusEnum;
};


export type MutationBulkStatusIncidentsArgs = {
  ids: Array<Scalars['String']>;
  statusId?: InputMaybe<Scalars['String']>;
};


export type MutationBulkStatusPackagesArgs = {
  ids: Array<Scalars['String']>;
  status?: InputMaybe<PackageStatusType>;
};


export type MutationBulkStatusUserArgs = {
  ids: Array<Scalars['String']>;
  status?: InputMaybe<UserStatuses>;
};


export type MutationBulkStatusVendorAccessArgs = {
  ids: Array<Scalars['String']>;
  status: VendorAccessStatusEnum;
};


export type MutationBulkStatusWoArgs = {
  ids: Array<Scalars['String']>;
  statusId?: InputMaybe<Scalars['String']>;
};


export type MutationCancelRoomReservationArgs = {
  reservationId: Scalars['String'];
};


export type MutationCancelSubscriptionArgs = {
  input: SubscriptionCancelInput;
};


export type MutationCheckSubscriptionTrialArgs = {
  input: SubscriptionTrialInput;
};


export type MutationCompleteTaskArgs = {
  taskId: Scalars['String'];
};


export type MutationCreateArCodeArgs = {
  title: Scalars['String'];
};


export type MutationCreateBuildingArgs = {
  title: Scalars['String'];
};


export type MutationCreateCategoryArgs = {
  input: CategoryInput;
  recordType: CategoryRecordType;
};


export type MutationCreateCategoryGroupArgs = {
  input: CategoryGroupInput;
};


export type MutationCreateChargeArgs = {
  input: ChargeInput;
};


export type MutationCreateChargeCodeArgs = {
  title: Scalars['String'];
};


export type MutationCreateCoiArgs = {
  input: CoiInput;
};


export type MutationCreateCoiEmailArgs = {
  input: CoiEmailInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyPropertyCreateInput;
};


export type MutationCreateCouponArgs = {
  input: CouponInput;
};


export type MutationCreateCustomFieldArgs = {
  input: CustomFieldCreateInput;
};


export type MutationCreateDealArgs = {
  input: DealInput;
};


export type MutationCreateDealCategoryArgs = {
  input: NewDealCategoryInput;
};


export type MutationCreateDeviceArgs = {
  input: DeviceInput;
};


export type MutationCreateDocCategoryArgs = {
  input: DocCategoryInput;
};


export type MutationCreateEmployeeArgs = {
  input: EmployeeInput;
};


export type MutationCreateEquipmentArgs = {
  input: CreateEquipmentInput;
};


export type MutationCreateEquipmentCategoryArgs = {
  input: EquipmentCategoryInput;
};


export type MutationCreateEventArgs = {
  input: EventInput;
};


export type MutationCreateFloorArgs = {
  input: FloorCreateInput;
};


export type MutationCreateGlAccountArgs = {
  title: Scalars['String'];
};


export type MutationCreateGeneaUserCardArgs = {
  input: CreateGeneaUserCardInput;
};


export type MutationCreateGuestWorkOrderFormArgs = {
  input: GuestWoFormInput;
};


export type MutationCreateIncidentArgs = {
  input: IncidentInput;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceInput;
};


export type MutationCreateInvoiceChargeArgs = {
  id: Scalars['String'];
  input: InvoiceChargeInputData;
};


export type MutationCreateLaborRateArgs = {
  input: LaborRateInput;
};


export type MutationCreateLeaseArgs = {
  input: LeaseInput;
};


export type MutationCreateLeaseChargeTypeArgs = {
  title: Scalars['String'];
};


export type MutationCreateMarkupArgs = {
  input: MarkUpInput;
};


export type MutationCreateMaterialArgs = {
  input: MaterialInput;
};


export type MutationCreateMaterialGroupArgs = {
  title: Scalars['String'];
};


export type MutationCreateNewsFeedArgs = {
  input: NewsfeedInput;
};


export type MutationCreatePmCustomIdArgs = {
  title: Scalars['String'];
};


export type MutationCreatePmReportArgs = {
  input: ReportPmInput;
};


export type MutationCreatePackagesArgs = {
  input: Array<PackageCreateInput>;
};


export type MutationCreatePredefinedBroadcastArgs = {
  input: PredefinedBroadcastInput;
};


export type MutationCreatePrinterArgs = {
  input: PrinterInput;
};


export type MutationCreatePriorityArgs = {
  input: PriorityInput;
};


export type MutationCreateProcedureArgs = {
  input: ProcedureInput;
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationCreatePropertyAddonArgs = {
  input: PropertyAddonsInput;
};


export type MutationCreatePublicWorkOrderArgs = {
  input: WorkOrderPublicInput;
};


export type MutationCreateRecurringInvoiceArgs = {
  input: RecurringInvoiceInput;
};


export type MutationCreateReportArgs = {
  input: ReportInput;
};


export type MutationCreateRoomArgs = {
  input: RoomInput;
};


export type MutationCreateRoomReservationArgs = {
  input: RoomReservationInput;
};


export type MutationCreateScheduleArgs = {
  input: SchedulesInput;
};


export type MutationCreateShippingProviderArgs = {
  input: ShippingProviderInput;
};


export type MutationCreateStatusArgs = {
  input: StatusInput;
};


export type MutationCreateSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationCreateSuiteArgs = {
  input: SuiteInput;
};


export type MutationCreateTaskTypeArgs = {
  title: Scalars['String'];
};


export type MutationCreateTaxArgs = {
  input: TaxInput;
};


export type MutationCreateUserArgs = {
  input: UserPropertyCreateInput;
};


export type MutationCreateUserPaymentMethodArgs = {
  paymentMethod: PaymentMethodTypeEnum;
  userId: Scalars['String'];
};


export type MutationCreateWoReviewArgs = {
  input: WorkOrderReviewInput;
};


export type MutationCreateWaiverTemplateArgs = {
  input: WaiverInput;
};


export type MutationCreateWatchlistArgs = {
  input: WatchlistInput;
};


export type MutationCreateWorkOrderArgs = {
  input: WorkOrderInput;
};


export type MutationCreateWorkOrderEmailArgs = {
  input: WorkOrderEmailInput;
};


export type MutationCreateWorkOrderTemplateArgs = {
  input: WorkOrderTemplateInput;
};


export type MutationDeactivateInvoicesArgs = {
  input: DeleteRecordsInput;
};


export type MutationDeleteAmanoSettingsArgs = {
  input: DeleteRecordsInput;
};


export type MutationDeleteDevicesArgs = {
  input: DeleteRecordsInput;
};


export type MutationDeleteEquipmentAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteGeneaUserCardArgs = {
  cardId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationDeleteGuestAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteIncidentAttachmentArgs = {
  attachmentId: Scalars['String'];
  incidentId: Scalars['String'];
};


export type MutationDeletePackageAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeletePackagesArgs = {
  input: DeleteRecordsInput;
};


export type MutationDeletePrintersArgs = {
  input: DeleteRecordsInput;
};


export type MutationDeleteRecurringInvoiceAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteRepositoryFilesArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteRoomReservationAttachmentArgs = {
  attachmentId: Scalars['String'];
  reservationId: Scalars['String'];
};


export type MutationDeleteVendorAccessAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteWoAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteWoTemplateAttachmentArgs = {
  attachmentId: Scalars['String'];
  templateId: Scalars['String'];
};


export type MutationDeleteWatchlistAttachmentArgs = {
  attachmentId: Scalars['String'];
  watchlistId: Scalars['String'];
};


export type MutationDenyRoomReservationArgs = {
  reservationId: Scalars['String'];
};


export type MutationDownloadRepositoryFilesArgs = {
  fileIds: Array<Scalars['String']>;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateInvoicePdfArgs = {
  id: Scalars['String'];
};


export type MutationGenerateRecurringInvoiceArgs = {
  id: Scalars['String'];
};


export type MutationGenerateRoomReservationWoArgs = {
  input: RoomReservationGenerateWoInput;
};


export type MutationGenerateSubscriptionWaiverTextArgs = {
  input: SubscriptionWaiverTextInput;
};


export type MutationGenerateTaskArgs = {
  scheduleId: Scalars['String'];
};


export type MutationGenerateWorkOrderArgs = {
  templateId: Scalars['String'];
};


export type MutationGuestCheckInArgs = {
  guestCode?: InputMaybe<Scalars['Int']>;
  guestId?: InputMaybe<Scalars['String']>;
};


export type MutationGuestWebCheckInArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationHandleStripeOauthArgs = {
  code: Scalars['String'];
  propertyId: Scalars['String'];
};


export type MutationImportParseCoIsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseCompaniesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseDealCategoriesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseDealsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseEquipmentArgs = {
  link: Scalars['String'];
};


export type MutationImportParseEquipmentCategoriesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseFloorsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseIncidentsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseMaterialGroupsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseMaterialsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseProceduresArgs = {
  link: Scalars['String'];
};


export type MutationImportParseRoomsArgs = {
  link: Scalars['String'];
};


export type MutationImportParseSchedulesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseSuitesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseUsersArgs = {
  link: Scalars['String'];
};


export type MutationImportParseWatchlistArgs = {
  link: Scalars['String'];
};


export type MutationImportParseWorkOrderTemplatesArgs = {
  link: Scalars['String'];
};


export type MutationImportParseWorkOrdersArgs = {
  link: Scalars['String'];
};


export type MutationImportStoreCoIsArgs = {
  input: Array<ImportCoiInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreCompaniesArgs = {
  input: Array<ImportCompaniesInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreDealCategoriesArgs = {
  input: Array<ImportDealCategoryInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreDealsArgs = {
  input: Array<ImportDealInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreEquipmentArgs = {
  input: Array<ImportEquipmentInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreEquipmentCategoriesArgs = {
  input: Array<ImportEquipmentCategoryInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreFloorsArgs = {
  input: Array<ImportFloorInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreIncidentsArgs = {
  input: Array<ImportIncidentInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreMaterialGroupsArgs = {
  input: Array<ImportMaterialGroupInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreMaterialsArgs = {
  input: Array<ImportMaterialInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreProceduresArgs = {
  input: Array<ImportProcedureInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreRoomsArgs = {
  input: Array<ImportRoomInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreSchedulesArgs = {
  input: Array<ImportScheduleInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreSuitesArgs = {
  input: Array<ImportSuiteInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreUsersArgs = {
  input: Array<ImportUsersInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreWatchlistArgs = {
  input: Array<ImportWatchlistInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreWorkOrderTemplatesArgs = {
  input: Array<ImportWotInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationImportStoreWorkOrdersArgs = {
  input: Array<ImportWorkOrderInput>;
  skipNotValid?: Scalars['Boolean'];
};


export type MutationIncidentSubscribeArgs = {
  id: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationInvoicePayArgs = {
  input: InvoicePaymentInput;
};


export type MutationInvoicePaymentRefundArgs = {
  amount: Scalars['Float'];
  id: Scalars['String'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['String'];
};


export type MutationMoveRepositoryFilesArgs = {
  destinationId?: InputMaybe<Scalars['String']>;
  fileIds: Array<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
};


export type MutationNewsFeedToggleLikeArgs = {
  newsfeedId: Scalars['String'];
};


export type MutationNotifyGuestArgs = {
  id: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationNotifyVendorAccessArgs = {
  id: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationPairDeviceArgs = {
  deviceId: Scalars['String'];
  input: DevicePairInput;
};


export type MutationPrintGuestBadgeArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationPrintVendorAccessBadgeArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationRedeemDealArgs = {
  dealId: Scalars['String'];
};


export type MutationRefundChargeArgs = {
  input: RefundChargeInput;
};


export type MutationRegisterEventArgs = {
  id: Scalars['String'];
};


export type MutationRemoveArCodesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveBuildingsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCategoriesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCategoryGroupsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveChargeArgs = {
  id: Scalars['String'];
  updateInvoice?: Scalars['Boolean'];
};


export type MutationRemoveChargeCodesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveChargesArgs = {
  input: DeleteRecordsInput;
  updateInvoice?: Scalars['Boolean'];
};


export type MutationRemoveCoiArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCoiEmailsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCommentArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCompaniesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCouponsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCustomFieldsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveDealCategoriesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveDealsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveDocCategoriesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveEmployeesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveEquipmentCategoriesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveEquipmentsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveEventArgs = {
  eventId: Scalars['String'];
  type?: InputMaybe<EventUpdateType>;
};


export type MutationRemoveEventsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveFloorsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveGlAccountsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveGuestWorkOrderFormArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveIncidentsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveIntegrationArgs = {
  input: TogglePropertyIntegrationInput;
};


export type MutationRemoveInvoiceAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationRemoveInvoiceChargesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveLaborRatesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveLeaseAttachmentArgs = {
  attachmentId: Scalars['String'];
  leaseId: Scalars['String'];
};


export type MutationRemoveLeaseChargeTypesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveLeaseRentArgs = {
  leaseId: Scalars['String'];
  rentId: Scalars['String'];
};


export type MutationRemoveLeasesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveMarkupsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveMaterialGroupsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveMaterialsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveNewsFeedsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePmCustomIdsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePredefinedBroadcastsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePrioritiesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveProceduresArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveProductsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePropertyAddonsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveRecurringInvoicePaymentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveRecurringInvoicesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveReportsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveRoomsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveScheduleAttachmentArgs = {
  attachmentId: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationRemoveScheduleEquipmentArgs = {
  equipmentId: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationRemoveScheduleProcedureArgs = {
  procedureId: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationRemoveSchedulesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveShippingProvidersArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveStatusesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveSubscriptionAttachmentArgs = {
  attachmentId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationRemoveSuitesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveTaskAttachmentArgs = {
  attachmentId: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationRemoveTaskEquipmentArgs = {
  equipmentId: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationRemoveTaskProcedureArgs = {
  procedureId: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationRemoveTaskStepAttachmentArgs = {
  attachmentId: Scalars['String'];
  taskStepId: Scalars['String'];
};


export type MutationRemoveTaskTypesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveTasksArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveTaxesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveUserPaymentMethodArgs = {
  input: UserPaymentMethodInput;
};


export type MutationRemoveUserPhoneArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveUserWidgetArgs = {
  id: Scalars['String'];
};


export type MutationRemoveWaiverTemplatesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveWatchlistArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveWorkOrderEmailsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveWorkOrderEquipmentArgs = {
  input: WorkOrderEquipmentRemoveInput;
};


export type MutationRemoveWorkOrderTemplatesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveWorkOrdersArgs = {
  input: DeleteRecordsInput;
};


export type MutationReorderCategoriesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderCustomFieldsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderDealCategoriesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderDocCategoriesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderEmployeesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderFloorsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderLaborRatesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderLeaseChargeTypesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderMarkupsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderMaterialsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderPrioritiesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderRoomsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderStatusesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderSuitesArgs = {
  floorId: Scalars['String'];
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderTableFloorsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderTaxesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationRequestLoginCodeArgs = {
  input: RequestLoginCodeInput;
};


export type MutationResendGuestEmailArgs = {
  id: Scalars['String'];
};


export type MutationResendVendorAccessEmailArgs = {
  id: Scalars['String'];
};


export type MutationResendWelcomeEmailArgs = {
  userIds: Array<Scalars['String']>;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResumeSubscriptionArgs = {
  id: Scalars['String'];
};


export type MutationSaveAmanoSettingsArgs = {
  input: AmanoSettingInput;
};


export type MutationSaveEventRatingArgs = {
  input: EventReviewInput;
};


export type MutationSaveMenuArgs = {
  input: SaveMenuInput;
};


export type MutationSaveUserVerificationPaymentMethodArgs = {
  input: UserVerificationPaymentMethodInput;
};


export type MutationSaveUserWidgetArgs = {
  input: UserDashboardWidgetInput;
};


export type MutationSendBroadcastArgs = {
  input: SendBroadcastInput;
};


export type MutationSendEventMessageArgs = {
  input: EventMessageInput;
};


export type MutationSendInvoiceArgs = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};


export type MutationSendTestMailArgs = {
  input: SendTestMailInput;
};


export type MutationSetPrimaryDeviceArgs = {
  deviceId: Scalars['String'];
};


export type MutationSetTaskStepCustomIdArgs = {
  customId?: InputMaybe<Scalars['String']>;
  predefinedCustomFieldId?: InputMaybe<Scalars['String']>;
  taskStepId: Scalars['String'];
};


export type MutationSetTaskStepValueArgs = {
  taskStepId: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
};


export type MutationSetUserDefaultPaymentMethodArgs = {
  input: UserPaymentMethodInput;
};


export type MutationShareIncidentArgs = {
  input: IncidentShareInput;
};


export type MutationShareInvoiceArgs = {
  emails: Array<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationShareWorkOrderArgs = {
  input: WorkOrderShareInput;
};


export type MutationSkipRecurringInvoiceDateArgs = {
  date: Scalars['String'];
  id: Scalars['String'];
};


export type MutationSkipScheduleDateArgs = {
  date: Scalars['String'];
  scheduleId: Scalars['String'];
};


export type MutationSkipWoTemplateDateArgs = {
  date: Scalars['String'];
  templateId: Scalars['String'];
};


export type MutationStoreDeviceLogArgs = {
  input: DeviceLogCreateInput;
};


export type MutationStoreGuestsArgs = {
  input: StoreGuestsDto;
};


export type MutationStoreIntegrationArgs = {
  input: PropertyIntegrationInput;
};


export type MutationStoreRecentSearchArgs = {
  input: SearchRecentInput;
};


export type MutationStoreVendorAccessArgs = {
  input: StoreVendorAccessInput;
};


export type MutationSyncRoomReservationWoArgs = {
  index: Scalars['Float'];
  reservationId: Scalars['String'];
};


export type MutationTestIntegrationArgs = {
  input: PropertyIntegrationInput;
};


export type MutationToggleArCodeArgs = {
  id: Scalars['String'];
};


export type MutationToggleBuildingArgs = {
  id: Scalars['String'];
};


export type MutationToggleCategoryArgs = {
  id: Scalars['String'];
};


export type MutationToggleCategoryGroupArgs = {
  id: Scalars['String'];
};


export type MutationToggleChargeCodeArgs = {
  id: Scalars['String'];
};


export type MutationToggleCoiEmailArgs = {
  id: Scalars['String'];
};


export type MutationToggleCompanyArgs = {
  companyId: Scalars['String'];
};


export type MutationToggleCustomFieldArgs = {
  input: CustomFieldToggleInput;
};


export type MutationToggleCustomTemplateArgs = {
  type: EmailTemplateType;
};


export type MutationToggleDealArgs = {
  id: Scalars['String'];
};


export type MutationToggleDeviceArgs = {
  deviceId: Scalars['String'];
};


export type MutationToggleEmailTemplateArgs = {
  input: ToggleEmailTemplateInput;
};


export type MutationToggleEmployeeArgs = {
  id: Scalars['String'];
};


export type MutationToggleEquipmentArgs = {
  id: Scalars['String'];
};


export type MutationToggleGlAccountArgs = {
  id: Scalars['String'];
};


export type MutationToggleGeneaDoorsArgs = {
  input: ToggleDoorInput;
};


export type MutationToggleGuestWorkOrderFormArgs = {
  formId: Scalars['String'];
};


export type MutationToggleIntegrationArgs = {
  input: TogglePropertyIntegrationInput;
};


export type MutationToggleLaborRateArgs = {
  id: Scalars['String'];
};


export type MutationToggleLeaseChargeTypeArgs = {
  id: Scalars['String'];
};


export type MutationToggleLoginAuthArgs = {
  input: ToggleLoginAuthInput;
};


export type MutationToggleMarkupArgs = {
  id: Scalars['String'];
};


export type MutationToggleMaterialArgs = {
  id: Scalars['String'];
};


export type MutationToggleMyNotificationArgs = {
  toggleType: EmailToggleEnum;
  type: EmailTemplateType;
};


export type MutationTogglePmCustomIdArgs = {
  id: Scalars['String'];
};


export type MutationTogglePredefinedBroadcastArgs = {
  id: Scalars['String'];
};


export type MutationTogglePriorityArgs = {
  id: Scalars['String'];
};


export type MutationToggleProcedureArgs = {
  id: Scalars['String'];
};


export type MutationToggleProductArgs = {
  id: Scalars['String'];
};


export type MutationToggleRoomArgs = {
  roomId: Scalars['String'];
};


export type MutationToggleScheduleSplitEquipmentOnTaskArgs = {
  scheduleId: Scalars['String'];
};


export type MutationToggleStatusArgs = {
  id: Scalars['String'];
};


export type MutationToggleTaskArgs = {
  taskId: Scalars['String'];
};


export type MutationToggleTaskTypeArgs = {
  id: Scalars['String'];
};


export type MutationToggleTaskWatcherArgs = {
  taskId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationToggleTaxArgs = {
  id: Scalars['String'];
};


export type MutationToggleWatchlistArgs = {
  watchlistId: Scalars['String'];
};


export type MutationToggleWorkOrderEmailArgs = {
  id: Scalars['String'];
};


export type MutationUnArchiveCoisArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationUnArchiveIncidentsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationUnArchiveWorkOrdersArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationUnRegisterEventArgs = {
  id: Scalars['String'];
};


export type MutationUnSyncRoomReservationWoArgs = {
  id: Scalars['String'];
};


export type MutationUpdateArCodeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateAmanoSettingsArgs = {
  id: Scalars['String'];
  input: AmanoSettingInput;
};


export type MutationUpdateBuildingArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String'];
  input: CategoryInput;
};


export type MutationUpdateCategoryGroupArgs = {
  id: Scalars['String'];
  input: CategoryGroupInput;
};


export type MutationUpdateChargeArgs = {
  id: Scalars['String'];
  input: ChargeInputData;
  updateInvoice?: Scalars['Boolean'];
};


export type MutationUpdateChargeCodeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateCoiArgs = {
  coiId: Scalars['String'];
  input: CoiUpdateInput;
};


export type MutationUpdateCoiEmailArgs = {
  id: Scalars['String'];
  input: CoiEmailInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['String'];
  input: CompanyPropertyUpdateInput;
};


export type MutationUpdateCompanyAddressArgs = {
  address?: InputMaybe<AddressInput>;
  companyId: Scalars['String'];
};


export type MutationUpdateCompanyBillingArgs = {
  billing: CompanyBillingInput;
  companyId: Scalars['String'];
};


export type MutationUpdateCompanyPhotoArgs = {
  companyId: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
};


export type MutationUpdateCouponArgs = {
  id: Scalars['String'];
  input: CouponUpdateInput;
};


export type MutationUpdateCustomFieldArgs = {
  id: Scalars['String'];
  input: CustomFieldUpdateInput;
};


export type MutationUpdateDealArgs = {
  dealId: Scalars['String'];
  input: DealUpdateInput;
};


export type MutationUpdateDealCategoryArgs = {
  id: Scalars['String'];
  input: UpdateDealCategoryInput;
};


export type MutationUpdateDeviceArgs = {
  deviceId: Scalars['String'];
  input: DeviceUpdateInput;
};


export type MutationUpdateDocCategoryArgs = {
  id: Scalars['String'];
  input: DocCategoryInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
  type: EmailTemplateType;
};


export type MutationUpdateEmployeeArgs = {
  employeeId: Scalars['String'];
  input: EmployeeInput;
};


export type MutationUpdateEquipmentArgs = {
  id: Scalars['String'];
  input: UpdateEquipmentInput;
};


export type MutationUpdateEquipmentCategoryArgs = {
  id: Scalars['String'];
  input: EquipmentCategoryInput;
};


export type MutationUpdateEventArgs = {
  eventId: Scalars['String'];
  input: EventUpdateInput;
  type?: InputMaybe<EventUpdateType>;
};


export type MutationUpdateFloorArgs = {
  floorId: Scalars['String'];
  input: FloorUpdateInput;
};


export type MutationUpdateGlAccountArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateGeneaProductAccessLinkArgs = {
  input: GeneaAccessGroupProductLinkInput;
};


export type MutationUpdateGeneaSettingsArgs = {
  input: GeneaSettingInput;
};


export type MutationUpdateGeneaTenantLinkArgs = {
  input: UpdateGeneaTenantLinkInput;
};


export type MutationUpdateGeneaUserAvatarArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateGuestSettingsArgs = {
  input: GuestSettingsInput;
};


export type MutationUpdateGuestVisitArgs = {
  id: Scalars['String'];
  input: UpdateGuestDto;
};


export type MutationUpdateGuestWorkOrderFormArgs = {
  formId: Scalars['String'];
  input: GuestWoFormUpdateInput;
};


export type MutationUpdateIncidentArgs = {
  incidentId: Scalars['String'];
  input: IncidentUpdateInput;
};


export type MutationUpdateIncidentCustomFieldArgs = {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['String'];
  input: InvoiceUpdateInput;
};


export type MutationUpdateInvoiceChargeArgs = {
  id: Scalars['String'];
  input: InvoiceChargeInputData;
  updateParent?: Scalars['Boolean'];
};


export type MutationUpdateKioskSettingsArgs = {
  input: KioskSettingsInput;
};


export type MutationUpdateLaborRateArgs = {
  id: Scalars['String'];
  input: LaborRateInput;
};


export type MutationUpdateLeaseArgs = {
  id: Scalars['String'];
  input: LeaseUpdateInput;
};


export type MutationUpdateLeaseChargeTypeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateLeaseRentArgs = {
  input: LeaseRentInput;
  rentId: Scalars['String'];
};


export type MutationUpdateMarkupArgs = {
  id: Scalars['String'];
  input: MarkUpInput;
};


export type MutationUpdateMaterialArgs = {
  id: Scalars['String'];
  input: MaterialInput;
};


export type MutationUpdateMaterialGroupArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateNewsFeedArgs = {
  input: NewsfeedUpdateInput;
  newsfeedId: Scalars['String'];
};


export type MutationUpdatePmCustomIdArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdatePackagesArgs = {
  id: Scalars['String'];
  input: PackageUpdateInput;
};


export type MutationUpdatePortfolioCategoryArgs = {
  input: UpdatePortfolioCategory;
};


export type MutationUpdatePredefinedBroadcastArgs = {
  id: Scalars['String'];
  input: PredefinedBroadcastInput;
};


export type MutationUpdatePrinterArgs = {
  input: PrinterInput;
  printerId: Scalars['String'];
};


export type MutationUpdatePriorityArgs = {
  id: Scalars['String'];
  input: PriorityUpdateInput;
};


export type MutationUpdateProcedureArgs = {
  id: Scalars['String'];
  input: ProcedureInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String'];
  input: ProductInput;
};


export type MutationUpdatePropertyArgs = {
  input: PropertyUpdateInput;
};


export type MutationUpdatePropertyAddonArgs = {
  id: Scalars['String'];
  input: PropertyAddonsInput;
};


export type MutationUpdateRecurringInvoiceArgs = {
  id: Scalars['String'];
  input: RecurringInvoiceUpdateInput;
};


export type MutationUpdateRecurringInvoiceNextGenerationDateArgs = {
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
};


export type MutationUpdateReportSettingsArgs = {
  input: ReportSettingInput;
};


export type MutationUpdateRepositoryFolderArgs = {
  folderId: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationUpdateRoomArgs = {
  input: RoomInput;
  roomId: Scalars['String'];
};


export type MutationUpdateRoomReservationArgs = {
  input: RoomReservationUpdateInput;
  reservationId: Scalars['String'];
};


export type MutationUpdateRoomReservationCustomFieldArgs = {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
};


export type MutationUpdateRoomSettingsArgs = {
  input: RoomSettingsInput;
};


export type MutationUpdateScheduleAssignedToIdArgs = {
  assignedToId?: InputMaybe<Scalars['String']>;
  scheduleId: Scalars['String'];
};


export type MutationUpdateScheduleDueAfterDaysArgs = {
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  scheduleId: Scalars['String'];
};


export type MutationUpdateScheduleNextGenerationDateArgs = {
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
};


export type MutationUpdateScheduleNotesArgs = {
  notes?: InputMaybe<Scalars['String']>;
  scheduleId: Scalars['String'];
};


export type MutationUpdateScheduleRRuleArgs = {
  input: SchedulesUpdateRRuleInput;
  scheduleId: Scalars['String'];
};


export type MutationUpdateScheduleTaskTypeArgs = {
  scheduleId: Scalars['String'];
  taskTypeId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateScheduleTitleArgs = {
  scheduleId: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateShippingProviderArgs = {
  id: Scalars['String'];
  input: ShippingProviderInput;
};


export type MutationUpdateStatusArgs = {
  id: Scalars['String'];
  input: StatusUpdateInput;
};


export type MutationUpdateStripeSettingsArgs = {
  input: StripeSettingsInput;
};


export type MutationUpdateSubscriptionArgs = {
  id: Scalars['String'];
  input: SubscriptionUpdateInput;
};


export type MutationUpdateSubscriptionCouponArgs = {
  couponId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateSuiteArgs = {
  input: SuiteInput;
  suiteId: Scalars['String'];
};


export type MutationUpdateTaskAssignedToArgs = {
  assignedToId?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};


export type MutationUpdateTaskDueDateArgs = {
  dueDate?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};


export type MutationUpdateTaskNotesArgs = {
  notes?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};


export type MutationUpdateTaskProcedureNotesArgs = {
  notes?: InputMaybe<Scalars['String']>;
  taskProcedureId: Scalars['String'];
};


export type MutationUpdateTaskTaskTypeArgs = {
  taskId: Scalars['String'];
  taskTypeId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateTaskTypeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateTaxArgs = {
  id: Scalars['String'];
  input: TaxInput;
};


export type MutationUpdateUserArgs = {
  input: UserPropertyUpdateInput;
  userId: Scalars['String'];
};


export type MutationUpdateUserPhoneArgs = {
  input: UpdateUserPhoneInput;
};


export type MutationUpdateUserPhotoArgs = {
  photo?: InputMaybe<FileObjectInput>;
  userId: Scalars['String'];
};


export type MutationUpdateUserPreferenceArgs = {
  input: UserPropertyPreferenceInput;
};


export type MutationUpdateUserPrinterArgs = {
  printerId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationUpdateUserWidgetsLayoutArgs = {
  input: Array<UpdateUserDashboardWidgetInput>;
};


export type MutationUpdateVendorAccessVisitArgs = {
  id: Scalars['String'];
  input: UpdateVendorAccessInput;
};


export type MutationUpdateWoTemplateNextGenerationDateArgs = {
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
};


export type MutationUpdateWaiverTemplateArgs = {
  id: Scalars['String'];
  input: WaiverUpdateInput;
};


export type MutationUpdateWatchlistArgs = {
  input: WatchlistUpdateInput;
  watchlistId: Scalars['String'];
};


export type MutationUpdateWorkOrderArgs = {
  input: WorkOrderUpdateInput;
  workOrderId: Scalars['String'];
};


export type MutationUpdateWorkOrderCustomFieldArgs = {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
};


export type MutationUpdateWorkOrderEmailArgs = {
  id: Scalars['String'];
  input: WorkOrderEmailInput;
};


export type MutationUpdateWorkOrderTemplateArgs = {
  input: WorkOrderTemplateUpdateInput;
  templateId: Scalars['String'];
};


export type MutationUploadFilesArgs = {
  files: Array<Scalars['Upload']>;
  save?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUploadGuestCsvArgs = {
  files: Array<Scalars['Upload']>;
};


export type MutationValidateCouponArgs = {
  input: CouponValidateInput;
};


export type MutationValidateSubscriptionCouponArgs = {
  input: SubscriptionValidateCouponInput;
};


export type MutationVendorAccessCheckInArgs = {
  vendorCode?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['String']>;
};


export type MutationVendorAccessWebCheckInArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationVerifyPhoneArgs = {
  input: VerifyPhoneInput;
};


export type MutationWorkOrderSubscribeArgs = {
  userId: Scalars['String'];
  workOrderId: Scalars['String'];
};

export type Networks = {
  __typename?: 'Networks';
  available?: Maybe<Array<Scalars['String']>>;
  preferred?: Maybe<Scalars['String']>;
};

export type NewDealCategoryInput = {
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type NewsfeedInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  description: Scalars['String'];
};

export type NewsfeedObject = {
  __typename?: 'NewsfeedObject';
  attachments?: Maybe<Array<FileObject>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  description: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  likesList?: Maybe<Array<UserObject>>;
};

export type NewsfeedUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  description: Scalars['String'];
};

export type NotificationAdditionalObject = {
  __typename?: 'NotificationAdditionalObject';
  key: NotificationAdditionalTypeEnum;
  value: Scalars['String'];
};

export enum NotificationAdditionalTypeEnum {
  Link = 'LINK'
}

export enum NotificationCategoryEnum {
  Activity = 'ACTIVITY',
  Comments = 'COMMENTS',
  Messages = 'MESSAGES'
}

export type NotificationObject = {
  __typename?: 'NotificationObject';
  additional?: Maybe<NotificationAdditionalObject>;
  author?: Maybe<AuthorObject>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  notificationCategory: NotificationCategoryEnum;
  referToRecord?: Maybe<ReferToObject>;
  showToaster: Scalars['Boolean'];
};

export type ObjectAdds = {
  __typename?: 'ObjectAdds';
  html: Scalars['Boolean'];
  key: FieldKeyEnum;
  title: Scalars['String'];
};

export type ObjectStatus = {
  __typename?: 'ObjectStatus';
  color?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PmCustomIdObject = {
  __typename?: 'PMCustomIdObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  title: Scalars['String'];
};

export type PmOptionDropdownInput = {
  items?: InputMaybe<Array<Scalars['String']>>;
  multi?: InputMaybe<Scalars['Boolean']>;
};

export type PmOptionInputInput = {
  type?: PmStepInputType;
  unit?: InputMaybe<Scalars['String']>;
};

export enum PmStepInputType {
  Number = 'NUMBER',
  Text = 'TEXT'
}

export enum PmStepType {
  Attachments = 'ATTACHMENTS',
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Input = 'INPUT'
}

export type PackageBulkObject = {
  __typename?: 'PackageBulkObject';
  data?: Maybe<Array<PackageObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type PackageCreateInput = {
  companyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  packageId: Scalars['String'];
  shippingProviderId?: InputMaybe<Scalars['String']>;
  status?: PackageStatusType;
  suiteId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type PackageObject = {
  __typename?: 'PackageObject';
  attachments?: Maybe<Array<FileObject>>;
  company?: Maybe<CompanyObject>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  id: Scalars['String'];
  index: Scalars['Float'];
  notes: Scalars['String'];
  packageId: Scalars['String'];
  shippingProvider?: Maybe<ShippingProviderObject>;
  status: PackageStatusType;
  suite?: Maybe<SuiteObject>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserObject>;
};

export enum PackageStatusType {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type PackageUpdateInput = {
  companyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['String']>;
  shippingProviderId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PackageStatusType>;
  suiteId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type PaymentMethodDto = {
  __typename?: 'PaymentMethodDTO';
  card?: Maybe<Card>;
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  type?: Maybe<PaymentMethodTypeEnum>;
  us_bank_account?: Maybe<AchDetails>;
  verificationUrl?: Maybe<Scalars['String']>;
};

export enum PaymentMethodTypeEnum {
  Ach = 'ACH',
  Card = 'CARD'
}

export type PaymentObject = {
  __typename?: 'PaymentObject';
  amount: Scalars['Float'];
  charge?: Maybe<StripeChargeObject>;
  company?: Maybe<CompanyObject>;
  couponData: CouponStripeObject;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoice?: Maybe<StripeInvoiceObject>;
  priceData: PriceStripeObject;
  product?: Maybe<ProductItemObject>;
  productData: ProductStripeObject;
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentEnum>;
  user?: Maybe<UserObject>;
};

export enum PaymentStatusEnum {
  Canceled = 'CANCELED',
  Processing = 'PROCESSING',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  Succeeded = 'SUCCEEDED'
}

export enum PaymentTypeEnum {
  Stripe = 'STRIPE',
  WorkOrder = 'WORK_ORDER'
}

export type PaymentsObject = {
  __typename?: 'PaymentsObject';
  amount: Scalars['Float'];
  appFee: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  id: Scalars['String'];
  invoice: InvoiceObject;
  paymentMethod?: Maybe<PaymentMethodDto>;
  refundedAmount: Scalars['Float'];
  status: InvoicePaymentStatusEnum;
  stripeLink?: Maybe<Scalars['String']>;
};

export type PermissionsObject = {
  __typename?: 'PermissionsObject';
  accessFileManagerPrivate?: Maybe<Scalars['Boolean']>;
  addCoi?: Maybe<Scalars['Boolean']>;
  addCompany?: Maybe<Scalars['Boolean']>;
  addCompanyGuest?: Maybe<Scalars['Boolean']>;
  addCompanyIncident?: Maybe<Scalars['Boolean']>;
  addCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  addCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  addCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  addCompanyWatchList?: Maybe<Scalars['Boolean']>;
  addCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  addCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  addEventPost?: Maybe<Scalars['Boolean']>;
  addInternalNotes?: Maybe<Scalars['Boolean']>;
  addMessage?: Maybe<Scalars['Boolean']>;
  addMyGuest?: Maybe<Scalars['Boolean']>;
  addMyIncident?: Maybe<Scalars['Boolean']>;
  addMyRoomReservation?: Maybe<Scalars['Boolean']>;
  addMyVendorAccess?: Maybe<Scalars['Boolean']>;
  addMyWatchList?: Maybe<Scalars['Boolean']>;
  addMyWorkOrder?: Maybe<Scalars['Boolean']>;
  addMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  addNewsFeedPost?: Maybe<Scalars['Boolean']>;
  addNewsFeedPostComment?: Maybe<Scalars['Boolean']>;
  addUser?: Maybe<Scalars['Boolean']>;
  approveGuest?: Maybe<Scalars['Boolean']>;
  approveVendorAccess?: Maybe<Scalars['Boolean']>;
  canCloseWorkOrder?: Maybe<Scalars['Boolean']>;
  cancelCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  checkInGuest?: Maybe<Scalars['Boolean']>;
  checkInVendorAccess?: Maybe<Scalars['Boolean']>;
  controlUserWallet?: Maybe<Scalars['Boolean']>;
  creditCardPayments?: Maybe<Scalars['Boolean']>;
  deactivateCompanyWatchList?: Maybe<Scalars['Boolean']>;
  deactivateMyWatchList?: Maybe<Scalars['Boolean']>;
  deleteCoi?: Maybe<Scalars['Boolean']>;
  deleteCompany?: Maybe<Scalars['Boolean']>;
  deleteCompanyIncident?: Maybe<Scalars['Boolean']>;
  deleteCompanyWatchList?: Maybe<Scalars['Boolean']>;
  deleteCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  deleteCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  deleteMyIncident?: Maybe<Scalars['Boolean']>;
  deleteMyWatchList?: Maybe<Scalars['Boolean']>;
  deleteMyWorkOrder?: Maybe<Scalars['Boolean']>;
  deleteMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersEventPost?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedComment?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedPost?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<Scalars['Boolean']>;
  editOtherUsersEventPost?: Maybe<Scalars['Boolean']>;
  editOtherUsersNewsFeedPost?: Maybe<Scalars['Boolean']>;
  manageAllTasks?: Maybe<Scalars['Boolean']>;
  manageCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  manageConciergeHub?: Maybe<Scalars['Boolean']>;
  manageFileManager?: Maybe<Scalars['Boolean']>;
  manageInvoices?: Maybe<Scalars['Boolean']>;
  manageLease?: Maybe<Scalars['Boolean']>;
  manageMyTasks?: Maybe<Scalars['Boolean']>;
  managePackage?: Maybe<Scalars['Boolean']>;
  managePreventiveMaintenance?: Maybe<Scalars['Boolean']>;
  manageRecurringInvoices?: Maybe<Scalars['Boolean']>;
  manageTaskCharges?: Maybe<Scalars['Boolean']>;
  manageWOCharges?: Maybe<Scalars['Boolean']>;
  manageWOTCharges?: Maybe<Scalars['Boolean']>;
  offlinePayments?: Maybe<Scalars['Boolean']>;
  printBadgeGuest?: Maybe<Scalars['Boolean']>;
  printBadgeVendorAccess?: Maybe<Scalars['Boolean']>;
  propertyAdmin?: Maybe<Scalars['Boolean']>;
  refundSubscriptionCharges?: Maybe<Scalars['Boolean']>;
  toggleGeneaDoor?: Maybe<Scalars['Boolean']>;
  updateCoi?: Maybe<Scalars['Boolean']>;
  updateCoiStatus?: Maybe<Scalars['Boolean']>;
  updateCompany?: Maybe<Scalars['Boolean']>;
  updateCompanyGuest?: Maybe<Scalars['Boolean']>;
  updateCompanyIncident?: Maybe<Scalars['Boolean']>;
  updateCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  updateCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  updateCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  updateCompanyWatchList?: Maybe<Scalars['Boolean']>;
  updateCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  updateCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  updateGeneaCards?: Maybe<Scalars['Boolean']>;
  updateMyGuest?: Maybe<Scalars['Boolean']>;
  updateMyIncident?: Maybe<Scalars['Boolean']>;
  updateMyRoomReservation?: Maybe<Scalars['Boolean']>;
  updateMyVendorAccess?: Maybe<Scalars['Boolean']>;
  updateMyWatchList?: Maybe<Scalars['Boolean']>;
  updateMyWorkOrder?: Maybe<Scalars['Boolean']>;
  updateMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  updateUser?: Maybe<Scalars['Boolean']>;
  updateWorkOrderAssignee?: Maybe<Scalars['Boolean']>;
  updateWorkOrderAssigneeTemplate?: Maybe<Scalars['Boolean']>;
  updateWorkOrderPriority?: Maybe<Scalars['Boolean']>;
  updateWorkOrderPriorityTemplate?: Maybe<Scalars['Boolean']>;
  updateWorkOrderStatus?: Maybe<Scalars['Boolean']>;
  viewAllTasks?: Maybe<Scalars['Boolean']>;
  viewAnalytics?: Maybe<Scalars['Boolean']>;
  viewCoi?: Maybe<Scalars['Boolean']>;
  viewCompanyFullAccessUsers?: Maybe<Scalars['Boolean']>;
  viewCompanyGuest?: Maybe<Scalars['Boolean']>;
  viewCompanyIncident?: Maybe<Scalars['Boolean']>;
  viewCompanyPage?: Maybe<Scalars['Boolean']>;
  viewCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  viewCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  viewCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  viewCompanyWatchList?: Maybe<Scalars['Boolean']>;
  viewCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  viewCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  viewConciergeHub?: Maybe<Scalars['Boolean']>;
  viewFileManager?: Maybe<Scalars['Boolean']>;
  viewGeneaCards?: Maybe<Scalars['Boolean']>;
  viewGeneaDoors?: Maybe<Scalars['Boolean']>;
  viewInternalNotes?: Maybe<Scalars['Boolean']>;
  viewInvoices?: Maybe<Scalars['Boolean']>;
  viewLease?: Maybe<Scalars['Boolean']>;
  viewMessages?: Maybe<Scalars['Boolean']>;
  viewMyGuest?: Maybe<Scalars['Boolean']>;
  viewMyIncident?: Maybe<Scalars['Boolean']>;
  viewMyRoomReservation?: Maybe<Scalars['Boolean']>;
  viewMySubscriptions?: Maybe<Scalars['Boolean']>;
  viewMyTasks?: Maybe<Scalars['Boolean']>;
  viewMyVendorAccess?: Maybe<Scalars['Boolean']>;
  viewMyWatchList?: Maybe<Scalars['Boolean']>;
  viewMyWorkOrder?: Maybe<Scalars['Boolean']>;
  viewMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  viewPackage?: Maybe<Scalars['Boolean']>;
  viewPreventiveMaintenance?: Maybe<Scalars['Boolean']>;
  viewPropertyNewsFeedPost?: Maybe<Scalars['Boolean']>;
  viewRecurringInvoices?: Maybe<Scalars['Boolean']>;
  viewReports?: Maybe<Scalars['Boolean']>;
  viewStackingPlan?: Maybe<Scalars['Boolean']>;
  viewTaskCharges?: Maybe<Scalars['Boolean']>;
  viewUser?: Maybe<Scalars['Boolean']>;
  viewWOCharges?: Maybe<Scalars['Boolean']>;
  viewWOTCharges?: Maybe<Scalars['Boolean']>;
};

export type PopulatedCompanyObject = {
  __typename?: 'PopulatedCompanyObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  photo?: Maybe<FileObject>;
  title: Scalars['String'];
};

export type PortfolioModel = {
  __typename?: 'PortfolioModel';
  active: Scalars['Boolean'];
  background?: Maybe<FileObject>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  logo?: Maybe<FileObject>;
  stripeSettings: PortfolioStripeSettings;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type PortfolioStripeSettings = {
  __typename?: 'PortfolioStripeSettings';
  paymentACHCap?: Maybe<Scalars['Float']>;
  paymentACHFee?: Maybe<Scalars['Float']>;
  paymentACHUnit?: Maybe<ValueUnit>;
  paymentCardFee?: Maybe<Scalars['Float']>;
  paymentCardUnit?: Maybe<ValueUnit>;
};

export type PredefinedBroadcastInput = {
  body?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type PredefinedBroadcastObject = {
  __typename?: 'PredefinedBroadcastObject';
  active: Scalars['Boolean'];
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailBody?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  subject: Scalars['String'];
};

export type PriceBhSettings = {
  __typename?: 'PriceBHSettings';
  dateSelection?: Maybe<Scalars['Boolean']>;
  timeFrom?: Maybe<Scalars['String']>;
  timeTo?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PriceBhSettingsInput = {
  dateSelection?: InputMaybe<Scalars['Boolean']>;
  timeFrom?: InputMaybe<Scalars['String']>;
  timeTo?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The supported billing period for price item. */
export enum PriceBillingPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PriceItemInput = {
  active?: Scalars['Boolean'];
  billingDay?: InputMaybe<Scalars['Int']>;
  billingPeriod?: InputMaybe<PriceBillingPeriod>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  priceSettings?: InputMaybe<PriceBhSettingsInput>;
  title: Scalars['String'];
  trialDays?: InputMaybe<Scalars['Int']>;
  type: PriceType;
};

export type PriceItemObject = {
  __typename?: 'PriceItemObject';
  active: Scalars['Boolean'];
  billingDay?: Maybe<Scalars['Int']>;
  billingPeriod?: Maybe<PriceBillingPeriod>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  price: Scalars['Float'];
  priceSettings?: Maybe<PriceBhSettings>;
  title: Scalars['String'];
  trialDays?: Maybe<Scalars['Int']>;
  type: PriceType;
};

export type PriceStripeObject = {
  __typename?: 'PriceStripeObject';
  billingPeriod?: Maybe<PriceBillingPeriod>;
  id?: Maybe<Scalars['String']>;
  paidPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  type: PriceType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The supported types for price item. */
export enum PriceType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING',
  Trial = 'TRIAL'
}

export type PrinterInput = {
  buildingId?: InputMaybe<Scalars['String']>;
  ipAddress: Scalars['String'];
  modelName: PrinterModelTypes;
  paperType: PrinterPaperTypes;
  title: Scalars['String'];
};

export type PrinterModel = {
  __typename?: 'PrinterModel';
  building?: Maybe<BuildingObject>;
  id: Scalars['String'];
  ipAddress: Scalars['String'];
  modelId?: Maybe<Scalars['Int']>;
  modelName: PrinterModelTypes;
  paperId?: Maybe<Scalars['Int']>;
  paperType: PrinterPaperTypes;
  synced: Scalars['Boolean'];
  title: Scalars['String'];
};

export enum PrinterModelTypes {
  BrlmPrinterModelQl_710W = 'BRLMPrinterModelQL_710W',
  BrlmPrinterModelQl_720Nw = 'BRLMPrinterModelQL_720NW',
  BrlmPrinterModelQl_810W = 'BRLMPrinterModelQL_810W',
  BrlmPrinterModelQl_820Nwb = 'BRLMPrinterModelQL_820NWB',
  BrlmPrinterModelQl_1110Nwb = 'BRLMPrinterModelQL_1110NWB',
  BrlmPrinterModelQl_1115Nwb = 'BRLMPrinterModelQL_1115NWB'
}

export enum PrinterPaperTypes {
  BrlmqlPrintSettingsLabelSizeDieCutW62H100 = 'BRLMQLPrintSettingsLabelSizeDieCutW62H100'
}

export type PriorityInput = {
  color: Scalars['String'];
  recordType: PriorityRecordType;
  title: Scalars['String'];
};

export type PriorityObject = {
  __typename?: 'PriorityObject';
  active: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  recordType: PriorityRecordType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** The supported records type. */
export enum PriorityRecordType {
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type PriorityUpdateInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type ProcedureInput = {
  estimatedLabor?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  sections: Array<SectionInput>;
  title: Scalars['String'];
};

export type ProcedureObject = {
  __typename?: 'ProcedureObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  estimatedLabor?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  index: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  schedulesCount: Scalars['Float'];
  sections?: Maybe<Array<ProcedureSectionObject>>;
  title: Scalars['String'];
};

export type ProcedureSectionObject = {
  __typename?: 'ProcedureSectionObject';
  steps: Array<ProcedureSectionStepObject>;
  title: Scalars['String'];
};

export type ProcedureSectionStepDropdownOptionObject = {
  __typename?: 'ProcedureSectionStepDropdownOptionObject';
  items?: Maybe<Array<Scalars['String']>>;
  multi?: Maybe<Scalars['Boolean']>;
};

export type ProcedureSectionStepInputOptionObject = {
  __typename?: 'ProcedureSectionStepInputOptionObject';
  type?: Maybe<PmStepInputType>;
  unit?: Maybe<Scalars['String']>;
};

export type ProcedureSectionStepObject = {
  __typename?: 'ProcedureSectionStepObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  inputOptions?: Maybe<ProcedureSectionStepInputOptionObject>;
  predefinedCustomField?: Maybe<PmCustomIdObject>;
  title: Scalars['String'];
  type: PmStepType;
};

export type ProductCustomField = {
  __typename?: 'ProductCustomField';
  label: Scalars['String'];
  required: Scalars['Boolean'];
};

export type ProductCustomFieldInput = {
  label: Scalars['String'];
  required: Scalars['Boolean'];
};

export type ProductInput = {
  companies?: InputMaybe<Array<Scalars['String']>>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  customFields?: InputMaybe<Array<ProductCustomFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  prices: Array<PriceItemInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  users?: InputMaybe<Array<Scalars['String']>>;
  waiverTemplateId?: InputMaybe<Scalars['String']>;
};

export type ProductItemObject = {
  __typename?: 'ProductItemObject';
  active: Scalars['Boolean'];
  companies?: Maybe<Array<CompanyObject>>;
  companyTypes?: Maybe<Array<CompanyTypeEnum>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  customFields: Array<ProductCustomField>;
  description?: Maybe<Scalars['String']>;
  geneaAccessGroup?: Maybe<GeneaAccessGroupObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  prices?: Maybe<Array<PriceItemObject>>;
  roles?: Maybe<Array<RoleObject>>;
  stripeAccount?: Maybe<StripeAccountObject>;
  title: Scalars['String'];
  users?: Maybe<Array<UserObject>>;
  waiverTemplate?: Maybe<WaiverTemplateModel>;
};

export type ProductStripeObject = {
  __typename?: 'ProductStripeObject';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum PropertyAddonEnum {
  Email = 'EMAIL',
  Phone = 'PHONE',
  PrimaryContact = 'PRIMARY_CONTACT',
  Text = 'TEXT',
  WorkingHours = 'WORKING_HOURS'
}

export type PropertyAddonObject = {
  __typename?: 'PropertyAddonObject';
  icon: Scalars['String'];
  id: Scalars['String'];
  key: PropertyAddonEnum;
  title: Scalars['String'];
  value: Scalars['String'];
};

export type PropertyAddonsInput = {
  icon: Scalars['String'];
  key: PropertyAddonEnum;
  title: Scalars['String'];
  value: Scalars['String'];
};

export type PropertyAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type PropertyAddressObject = {
  __typename?: 'PropertyAddressObject';
  address?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type PropertyIntegrationInput = {
  keys: Array<IntegrationSettingsInput>;
  type: IntegrationTypeEnum;
};

export type PropertyObject = {
  __typename?: 'PropertyObject';
  active: Scalars['Boolean'];
  address?: Maybe<PropertyAddressObject>;
  bgImg?: Maybe<FileObject>;
  createdAt: Scalars['DateTime'];
  favicon?: Maybe<FileObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  logo?: Maybe<FileObject>;
  primaryColor?: Maybe<Scalars['String']>;
  stripeApiKey?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PropertyUpdateInput = {
  address?: InputMaybe<PropertyAddressInput>;
  bgImg?: InputMaybe<FileObjectInput>;
  favicon?: InputMaybe<FileObjectInput>;
  logo?: InputMaybe<FileObjectInput>;
  primaryColor?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  checkGuestWatchlist: Array<WatchlistObject>;
  checkUserPermissions: Array<Scalars['Boolean']>;
  exportCois: Scalars['String'];
  exportCompanies: Scalars['String'];
  exportDealCategories: Scalars['String'];
  exportDeals: Scalars['String'];
  exportDevices: Scalars['String'];
  exportEquipmentCategories: Scalars['String'];
  exportEquipments: Scalars['String'];
  exportEventAttendance: Scalars['String'];
  exportFloors: Scalars['String'];
  exportGuests: Scalars['String'];
  exportIncidents: Scalars['String'];
  exportMaterialGroups: Scalars['String'];
  exportMaterials: Scalars['String'];
  exportPrinters: Scalars['String'];
  exportProcedures: Scalars['String'];
  exportRooms: Scalars['String'];
  exportSchedules: Scalars['String'];
  exportSuites: Scalars['String'];
  exportUsers: Scalars['String'];
  exportVendorAccessList: Scalars['String'];
  exportWatchlist: Scalars['String'];
  exportWorkOrderTemplates: Scalars['String'];
  exportWorkOrders: Scalars['String'];
  getARCode: ArCodeObject;
  getARCodes: Array<ArCodeObject>;
  getActivityLog: GetActivityLogsObject;
  getAmanoAccessGroup: Array<AmanoAccessGroupObject>;
  getAmanoFacilities: Array<AmanoFacilityObject>;
  getAmanoOccupancyWidget: AmanoOccupancyWidget;
  getAmanoSetting: AmanoSettingsObject;
  getAmanoSettings: GetAmanoSettingsObject;
  getBroadcast: BroadcastObject;
  getBroadcastRecipients: GetBroadcastRecipientsObject;
  getBroadcasts: GetBroadcastsObject;
  getBuilding: BuildingObject;
  getBuildings: GetBuildings;
  getCOIWidget: Array<CoiWidget>;
  getCategories: GetCategories;
  getCategoriesGrouped: GetCategoriesGrouped;
  getCategory: CategoryObject;
  getCategoryGroup: CategoryGroupObject;
  getCategoryGroups: GetCategoryGroups;
  getCharge: ChargeObject;
  getChargeCode: ChargeCodeObject;
  getChargeCodes: Array<ChargeCodeObject>;
  getCoi: CoiObject;
  getCoiEmail: CoiEmailObject;
  getCoiEmails: GetCoiEmailsObject;
  getCois: GetCoiObject;
  getCompanies: GetCompanyObject;
  getCompany: CompanyObject;
  getCoupon: CouponObject;
  getCouponsList: Array<CouponListObject>;
  getCronJobs: Array<CronJobObject>;
  getCustomField: CustomFieldObject;
  getCustomFields: Array<CustomFieldObject>;
  getDeal: DealObject;
  getDealCategories: Array<DealCategoryObject>;
  getDealCategory: DealCategoryObject;
  getDeals: GetDealsObject;
  getDevice: DeviceModel;
  getDeviceKioskSettings: KioskSettingsObject;
  getDeviceLogs: GetDeviceLogs;
  getDeviceProperty: DeviceSettingModel;
  getDeviceQrCode: Scalars['String'];
  getDevices: Array<DeviceModel>;
  getDocCategories: Array<DocCategoryObject>;
  getDocCategory: DocCategoryObject;
  getEmailTemplate: EmailTemplateObject;
  getEmailTemplates: Array<EmailTemplateObject>;
  getEmployee: EmployeeObject;
  getEmployees: GetEmployees;
  getEquipmentCategories: GetEquipmentCategoriesObject;
  getEquipmentCategory: EquipmentCategoryModel;
  getEquipmentList: GetEquipmentsObject;
  getEquipmentListGrouped: GetEquipmentGroupedObject;
  getEquipmentQRCode: Scalars['String'];
  getEquipmentTasks: GetEquipmentTaskObject;
  getEquipmentWorkOrders: GetEquipmentWorkOrderObject;
  getEvent: EventObject;
  getEventAttendance: GetEventAttendancesObject;
  getFilterableCompanies: GetFilterableCompanies;
  getFilterableGroupedCategories: GetFilterableGroupedCategories;
  getFilterablePriorities: Array<FilterablePriorityObject>;
  getFilterableStatuses: Array<FilterableStatusObject>;
  getFloor: FloorObject;
  getFloors: Array<FloorObject>;
  getGLAccount: GlAccountObject;
  getGLAccounts: Array<GlAccountObject>;
  getGeneaAccessGroups: GetGeneaAccessGroups;
  getGeneaAttendanceWidget: Scalars['Float'];
  getGeneaBadgeTypes: Array<GeneaBadgeTypesObject>;
  getGeneaDoors: Array<GeneaDoorObject>;
  getGeneaLocations: Array<GeneaLocationObject>;
  getGeneaSettings: GeneaSettingObject;
  getGeneaTenants: GetGeneaTenants;
  getGeneaUserCards: Array<GeneaUserCardObject>;
  getGuest: GuestModel;
  getGuestQrCode?: Maybe<Scalars['String']>;
  getGuestSettings: GuestSettingsObject;
  getGuestWorkOrderForm: GuestWoFormObject;
  getGuestWorkOrderForms: GetForms;
  getGuests: GetGuestsObject;
  getIncident: IncidentModel;
  getIncidents: GetIncidentsObject;
  getIntegration: IntegrationSetupModel;
  getIntegrations: Array<IntegrationListModel>;
  getInvoice: InvoiceObject;
  getInvoiceCharge: InvoiceChargeObject;
  getInvoiceCharges: Array<InvoiceChargeObject>;
  getInvoicePayment: PaymentsObject;
  getInvoicePayments: Array<PaymentsObject>;
  getInvoices: GetInvoicesObject;
  getKioskSettings: KioskSettingsObject;
  getLaborRate: LaborRateObject;
  getLaborRates: Array<LaborRateObject>;
  getLease: LeaseObject;
  getLeaseChargeType: LeaseChargeTypeObject;
  getLeaseChargeTypes: Array<LeaseChargeTypeObject>;
  getLeases: GetLeases;
  getMarkup: MarkupObject;
  getMarkups: Array<MarkupObject>;
  getMaterial: MaterialObject;
  getMaterialGroup: MaterialGroupObject;
  getMaterialGroups: GetMaterialGroups;
  getMaterials: GetMaterials;
  getMaterialsGrouped: GetMaterialsGrouped;
  getMenu: Array<MenuItemObject>;
  getMenuFeatures: Array<FeatureItemObject>;
  getMobileDevice: DeviceModel;
  getMyNotifications: GetNotifications;
  getMyNotificationsSettings: Array<UserSettingNotificationObject>;
  getMyPortfolios: Array<PortfolioModel>;
  getMyPropertyData: UserObject;
  getMyUnreadNotifications: Array<Scalars['String']>;
  getNewsEvents: Array<EventNewsObject>;
  getNewsFeed: NewsfeedObject;
  getOverlappingCompanies: GetCompanyObject;
  getPMCustomId: PmCustomIdObject;
  getPMCustomIds: Array<PmCustomIdObject>;
  getPackage: PackageObject;
  getPackages: GetPackagesObject;
  getPayment: PaymentObject;
  getPayments: GetPaymentsObject;
  getPredefinedBroadcast: PredefinedBroadcastObject;
  getPredefinedBroadcasts: GetPredefinedBroadcastsObject;
  getPrinter: PrinterModel;
  getPrinters: Array<PrinterModel>;
  getPriorities: Array<PriorityObject>;
  getPriority: PriorityObject;
  getProcedure: ProcedureObject;
  getProcedures: GetProceduresObject;
  getProduct: ProductItemObject;
  getProducts: Array<ProductItemObject>;
  getProperty: PropertyObject;
  getPropertyAddon: PropertyAddonObject;
  getPropertyAddons: Array<PropertyAddonObject>;
  getPublicCategoriesGrouped: GetCategoriesGrouped;
  getPublicEmployees: GetEmployees;
  getPublicFloors: Array<FloorObject>;
  getPublicIntegration: IntegrationSetupModel;
  getPublicPriorities: Array<PriorityObject>;
  getPublicRoomReservationsCalendar: Array<RoomPublicReservationObject>;
  getPublicStatuses: Array<StatusObject>;
  getPublicSuites: GetSuiteObject;
  getRecordActivityLog: GetActivityLogsObject;
  getRecurringInvoice: RecurringInvoiceObject;
  getRecurringInvoiceCharges: Array<ChargeObject>;
  getRecurringInvoicePayments: Array<RecurringInvoicePaymentObject>;
  getRecurringInvoiceRelatedRecords: GetInvoicesObject;
  getRecurringInvoices: GetRecurringInvoicesObject;
  getRecurringInvoicesCalendar: Array<RecurringInvoiceCalendarObject>;
  getReportSettings: ReportSettingsObject;
  getReports: GetReportsObject;
  getRepositoryFiles: GetRepositoryFiles;
  getRoles: GetRolesObject;
  getRoom: RoomObject;
  getRoomReservation: RoomReservationObject;
  getRoomReservationCharges: Array<ChargeObject>;
  getRoomReservations: GetRoomReservationsObject;
  getRoomReservationsCalendar: Array<RoomReservationObject>;
  getRoomSettings: RoomSettingObject;
  getRooms: Array<RoomObject>;
  getSchedule: SchedulesObject;
  getScheduleRelatedRecords: GetTasksObject;
  getSchedules: GetSchedulesObject;
  getSchedulesCalendar: Array<SchedulesCalendarObject>;
  getSearchFeatureFilters: Array<SearchFilterObject>;
  getSearchFeatures: Array<FeatureObject>;
  getSearchRecent: Array<SearchResultObject>;
  getShippingProvider: ShippingProviderObject;
  getShippingProviders: Array<ShippingProviderObject>;
  getSingleEquipment: EquipmentModel;
  getSingleWatchlist: WatchlistObject;
  getStackingPlan: GetStakingPlan;
  getStatus: StatusObject;
  getStatuses: Array<StatusObject>;
  getStripeInvoice: StripeInvoiceObject;
  getStripeInvoices: GetStripeInvoicesObject;
  getStripeSettings: StripeSettingsObject;
  getSubscription: SubscriptionObject;
  getSubscriptionCharges: Array<InvoiceItemObject>;
  getSubscriptions: GetSubscriptionsObject;
  getSuite: SuiteObject;
  getSuites: GetSuiteObject;
  getTask: TaskObject;
  getTaskCharges: Array<ChargeObject>;
  getTaskOpenWidget: TaskOpenWidget;
  getTaskOverdueWidget: TaskOverdueWidget;
  getTaskType: TaskTypeModel;
  getTaskTypes: Array<TaskTypeModel>;
  getTasks: GetTasksObject;
  getTax: TaxObject;
  getTaxes: Array<TaxObject>;
  getUser: UserObject;
  getUserAvailableWidgets: Array<UserAvailableWidgetObject>;
  getUserBuilding: UserBuildingObject;
  getUserCompanies: GetCompanyObject;
  getUserCompany: UserCompanyObject;
  getUserPaymentMethods: Array<PaymentMethodDto>;
  getUserWidgetContent: UserWidgetContents;
  getUserWidgets: Array<UserWidgetObject>;
  getUsers: GetUsersObject;
  getVendorAccess: VendorAccessModel;
  getVendorAccessList: GetVendorAccessListObject;
  getVendorAccessQrCode: Scalars['String'];
  getWOCategoryWidget: Array<WoCategoryWidget>;
  getWORevenueWidget: Array<WoRevenueWidget>;
  getWOReviewsWidget: Array<WoReviewWidget>;
  getWOStatusWidget: Array<WoStatusWidget>;
  getWaiverTemplate: WaiverTemplateModel;
  getWaiverTemplates: Array<WaiverTemplateModel>;
  getWaiverVariables: Array<Scalars['String']>;
  getWatchlist: GetWatchlistObject;
  getWorkOrder: WorkOrderObject;
  getWorkOrderCharges: Array<ChargeObject>;
  getWorkOrderEmail: WorkOrderEmailObject;
  getWorkOrderEmails: GetWorkOrderEmailsObject;
  getWorkOrderEquipment: GetEquipmentsObject;
  getWorkOrderStatusSetting: WorkOrderStatusSettingObject;
  getWorkOrderTemplate: WorkOrderTemplateObject;
  getWorkOrderTemplateCharges: Array<ChargeObject>;
  getWorkOrderTemplateRelatedRecords: GetWorkOrdersObject;
  getWorkOrderTemplates: GetWorkOrderTemplatesObject;
  getWorkOrderTemplatesCalendar: Array<WorkOrderTemplatesCalendarObject>;
  getWorkOrders: GetWorkOrdersObject;
  logCronJobs: Scalars['Boolean'];
  login: LoginObject;
  magicLogin: Scalars['String'];
  me: UserLoggedObject;
  populateBuildings: GetPopulatedBuildings;
  populateCompanies: GetPopulateCompanyObject;
  printEquipmentQRCode: Scalars['Boolean'];
  searchCompanies: Array<CompanySearchObject>;
  searchFeature: SearchResults;
  searchInvoiceCharges: GetInvoiceChargesObject;
  searchStepValues: GetStepValuesObject;
  sendMagicLink: Scalars['Boolean'];
  syncInvoiceFromStripe: Scalars['Boolean'];
  validateCompanyTaxId?: Maybe<CompanyObject>;
  validateLoginCode: LoginObject;
  validateMagicLink: MagicLoginObject;
  validatePortfolioURL: ValidateUrlObject;
  validateUserEmail?: Maybe<UserObject>;
};


export type QueryCheckGuestWatchlistArgs = {
  id: Scalars['String'];
};


export type QueryCheckUserPermissionsArgs = {
  input: UserCheckPermissionsInput;
};


export type QueryExportCoisArgs = {
  archived?: ArchiveStatusEnum;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  expiration?: InputMaybe<CoiExpirationEnum>;
  from?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportDealsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportDevicesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExportEquipmentCategoriesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportEquipmentsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  floorIds?: InputMaybe<Array<Scalars['String']>>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
  search?: InputMaybe<Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryExportEventAttendanceArgs = {
  eventId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportFloorsArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportGuestsArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  hostIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<GuestStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportIncidentsArgs = {
  archived?: ArchiveStatusEnum;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']>>;
  suiteIds?: InputMaybe<Array<Scalars['String']>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportMaterialGroupsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportMaterialsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportPrintersArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryExportProceduresArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportRoomsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportSchedulesArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  taskTypeIds?: InputMaybe<Array<Scalars['String']>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportSuitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  floorId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  types?: InputMaybe<Array<SuiteType>>;
};


export type QueryExportUsersArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  fullAccessBuildingUsers?: UserFullAccessEnum;
  fullAccessCompanyUsers?: UserFullAccessEnum;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortUserFieldEnum;
  sortByDir?: SortDirectionEnum;
  status?: InputMaybe<UserStatuses>;
};


export type QueryExportVendorAccessListArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  hostIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<VendorAccessStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportWatchlistArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportWorkOrderTemplatesArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryExportWorkOrdersArgs = {
  archived?: ArchiveStatusEnum;
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  priorityIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']>>;
  to?: InputMaybe<Scalars['DateTime']>;
  workOrderTemplateId?: InputMaybe<Scalars['String']>;
};


export type QueryGetArCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetArCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivityLogArgs = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  referType?: InputMaybe<ReferToType>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAmanoAccessGroupArgs = {
  facilityId: Scalars['String'];
};


export type QueryGetAmanoOccupancyWidgetArgs = {
  facilityId: Scalars['String'];
};


export type QueryGetAmanoSettingArgs = {
  id: Scalars['String'];
};


export type QueryGetAmanoSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetBroadcastArgs = {
  id: Scalars['String'];
};


export type QueryGetBroadcastRecipientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  broadcastId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetBroadcastsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  types?: InputMaybe<Array<BroadcastTypeEnum>>;
};


export type QueryGetBuildingArgs = {
  id: Scalars['String'];
};


export type QueryGetBuildingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
};


export type QueryGetCoiWidgetArgs = {
  companyId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCategoriesGroupedArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCategoryArgs = {
  id: Scalars['String'];
};


export type QueryGetCategoryGroupArgs = {
  id: Scalars['String'];
};


export type QueryGetCategoryGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetChargeArgs = {
  id: Scalars['String'];
};


export type QueryGetChargeCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetChargeCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCoiArgs = {
  coiId: Scalars['String'];
};


export type QueryGetCoiEmailArgs = {
  id: Scalars['String'];
};


export type QueryGetCoiEmailsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCoisArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: ArchiveStatusEnum;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  expiration?: InputMaybe<CoiExpirationEnum>;
  from?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCompanyArgs = {
  companyId: Scalars['String'];
};


export type QueryGetCouponArgs = {
  id: Scalars['String'];
};


export type QueryGetCustomFieldArgs = {
  id: Scalars['String'];
};


export type QueryGetCustomFieldsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  recordType?: InputMaybe<CustomFieldRecordType>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetDealArgs = {
  dealId: Scalars['String'];
};


export type QueryGetDealCategoryArgs = {
  id: Scalars['String'];
};


export type QueryGetDealsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  expired?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetDeviceArgs = {
  id: Scalars['String'];
};


export type QueryGetDeviceLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetDeviceQrCodeArgs = {
  deviceId: Scalars['String'];
};


export type QueryGetDevicesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDocCategoryArgs = {
  id: Scalars['String'];
};


export type QueryGetEmailTemplateArgs = {
  type: EmailTemplateType;
};


export type QueryGetEmailTemplatesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetEmployeeArgs = {
  id: Scalars['String'];
};


export type QueryGetEmployeesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetEquipmentCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetEquipmentCategoryArgs = {
  id: Scalars['String'];
};


export type QueryGetEquipmentListArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  floorIds?: InputMaybe<Array<Scalars['String']>>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
  search?: InputMaybe<Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
};


export type QueryGetEquipmentListGroupedArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  floorIds?: InputMaybe<Array<Scalars['String']>>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
  search?: InputMaybe<Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
};


export type QueryGetEquipmentQrCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetEquipmentTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  equipmentId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetEquipmentWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  equipmentId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetEventArgs = {
  id: Scalars['String'];
};


export type QueryGetEventAttendanceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetFilterableCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  location: FilterableCompanyLocationType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetFilterableGroupedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  location: FilterableCategoryLocationType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetFilterablePrioritiesArgs = {
  location: FilterablePriorityLocationType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetFilterableStatusesArgs = {
  location: FilterableStatusLocationType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetFloorArgs = {
  floorId: Scalars['String'];
};


export type QueryGetFloorsArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGlAccountArgs = {
  id: Scalars['String'];
};


export type QueryGetGlAccountsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGeneaAccessGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetGeneaTenantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetGeneaUserCardsArgs = {
  userId: Scalars['String'];
};


export type QueryGetGuestArgs = {
  id: Scalars['String'];
};


export type QueryGetGuestQrCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetGuestWorkOrderFormArgs = {
  formId: Scalars['String'];
};


export type QueryGetGuestWorkOrderFormsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetGuestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  hostIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<GuestStatusEnum>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetIncidentArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetIncidentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: ArchiveStatusEnum;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']>>;
  suiteIds?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetIntegrationArgs = {
  type: IntegrationTypeEnum;
};


export type QueryGetInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryGetInvoiceChargeArgs = {
  id: Scalars['String'];
};


export type QueryGetInvoiceChargesArgs = {
  id: Scalars['String'];
};


export type QueryGetInvoicePaymentArgs = {
  id: Scalars['String'];
};


export type QueryGetInvoicePaymentsArgs = {
  invoiceId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  take?: Scalars['Int'];
};


export type QueryGetLaborRateArgs = {
  id: Scalars['String'];
};


export type QueryGetLaborRatesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeaseArgs = {
  leaseId: Scalars['String'];
};


export type QueryGetLeaseChargeTypeArgs = {
  id: Scalars['String'];
};


export type QueryGetLeaseChargeTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeaseStatusEnum>;
  take?: Scalars['Int'];
};


export type QueryGetMarkupArgs = {
  id: Scalars['String'];
};


export type QueryGetMarkupsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetMaterialArgs = {
  id: Scalars['String'];
};


export type QueryGetMaterialGroupArgs = {
  id: Scalars['String'];
};


export type QueryGetMaterialGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetMaterialsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetMaterialsGroupedArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetMenuArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
  location: MenuLocation;
};


export type QueryGetMobileDeviceArgs = {
  id: Scalars['String'];
};


export type QueryGetMyNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  notificationCategory?: InputMaybe<NotificationCategoryEnum>;
  take?: Scalars['Int'];
};


export type QueryGetMyNotificationsSettingsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetMyPropertyDataArgs = {
  propertyId: Scalars['String'];
};


export type QueryGetNewsEventsArgs = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  type?: InputMaybe<EventNewsEnum>;
};


export type QueryGetNewsFeedArgs = {
  newsfeedId: Scalars['String'];
};


export type QueryGetOverlappingCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  userId: Scalars['String'];
};


export type QueryGetPmCustomIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPmCustomIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPackageArgs = {
  id: Scalars['String'];
};


export type QueryGetPackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PackageStatusType>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPaymentArgs = {
  paymentId: Scalars['String'];
};


export type QueryGetPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetPredefinedBroadcastArgs = {
  id: Scalars['String'];
};


export type QueryGetPredefinedBroadcastsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetPrinterArgs = {
  printerId: Scalars['String'];
};


export type QueryGetPrintersArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPrioritiesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  recordType: PriorityRecordType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPriorityArgs = {
  id: Scalars['String'];
};


export type QueryGetProcedureArgs = {
  id: Scalars['String'];
};


export type QueryGetProceduresArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetProductArgs = {
  id: Scalars['String'];
};


export type QueryGetProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPropertyAddonArgs = {
  id: Scalars['String'];
};


export type QueryGetPropertyAddonsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicCategoriesGroupedArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  recordType: CategoryRecordType;
  search: Scalars['String'];
  take?: Scalars['Int'];
};


export type QueryGetPublicEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  propertyId: Scalars['String'];
  search: Scalars['String'];
  take?: Scalars['Int'];
};


export type QueryGetPublicFloorsArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  propertyId: Scalars['String'];
  search: Scalars['String'];
};


export type QueryGetPublicIntegrationArgs = {
  type: IntegrationTypeEnum;
};


export type QueryGetPublicPrioritiesArgs = {
  propertyId: Scalars['String'];
  recordType: PriorityRecordType;
  search: Scalars['String'];
};


export type QueryGetPublicRoomReservationsCalendarArgs = {
  from: Scalars['DateTime'];
  search?: InputMaybe<Scalars['String']>;
  to: Scalars['DateTime'];
};


export type QueryGetPublicStatusesArgs = {
  propertyId: Scalars['String'];
  recordType: StatusRecordType;
  search: Scalars['String'];
};


export type QueryGetPublicSuitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  floorId?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  search: Scalars['String'];
  take?: Scalars['Int'];
  types?: InputMaybe<Array<SuiteType>>;
};


export type QueryGetRecordActivityLogArgs = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  recordId: Scalars['String'];
  referType: ReferToType;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
};


export type QueryGetRecurringInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryGetRecurringInvoiceChargesArgs = {
  id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetRecurringInvoicePaymentsArgs = {
  id: Scalars['String'];
};


export type QueryGetRecurringInvoiceRelatedRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetRecurringInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetRecurringInvoicesCalendarArgs = {
  from: Scalars['DateTime'];
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  to: Scalars['DateTime'];
};


export type QueryGetReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ReportStatus>;
  take?: Scalars['Int'];
  type?: InputMaybe<ReportType>;
};


export type QueryGetRepositoryFilesArgs = {
  folderId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  onlyAssignable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetRoomArgs = {
  roomId: Scalars['String'];
};


export type QueryGetRoomReservationArgs = {
  reservationId: Scalars['String'];
};


export type QueryGetRoomReservationChargesArgs = {
  reservationId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetRoomReservationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RoomReservationStatusEnum>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetRoomReservationsCalendarArgs = {
  from: Scalars['DateTime'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RoomReservationStatusEnum>;
  to: Scalars['DateTime'];
};


export type QueryGetRoomsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetScheduleArgs = {
  scheduleId: Scalars['String'];
};


export type QueryGetScheduleRelatedRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  taskTypeIds?: InputMaybe<Array<Scalars['String']>>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetSchedulesCalendarArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  from: Scalars['DateTime'];
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  taskTypeIds?: InputMaybe<Array<Scalars['String']>>;
  to: Scalars['DateTime'];
};


export type QueryGetSearchFeatureFiltersArgs = {
  feature: SearchFeatureEnum;
};


export type QueryGetSearchFeaturesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetShippingProviderArgs = {
  id: Scalars['String'];
};


export type QueryGetShippingProvidersArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetSingleEquipmentArgs = {
  id: Scalars['String'];
};


export type QueryGetSingleWatchlistArgs = {
  watchlistId: Scalars['String'];
};


export type QueryGetStackingPlanArgs = {
  buildingId: Scalars['String'];
  date: Scalars['String'];
};


export type QueryGetStatusArgs = {
  id: Scalars['String'];
};


export type QueryGetStatusesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  recordType: StatusRecordType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetStripeInvoiceArgs = {
  invoiceId: Scalars['String'];
};


export type QueryGetStripeInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetSubscriptionArgs = {
  id: Scalars['String'];
};


export type QueryGetSubscriptionChargesArgs = {
  id: Scalars['String'];
};


export type QueryGetSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  billingPeriod?: InputMaybe<Array<PriceBillingPeriod>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<SubscriptionStatusEnum>>;
  take?: Scalars['Int'];
};


export type QueryGetSuiteArgs = {
  suiteId: Scalars['String'];
};


export type QueryGetSuitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  floorId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  types?: InputMaybe<Array<SuiteType>>;
};


export type QueryGetTaskArgs = {
  id: Scalars['String'];
};


export type QueryGetTaskChargesArgs = {
  search?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};


export type QueryGetTaskTypeArgs = {
  id: Scalars['String'];
};


export type QueryGetTaskTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedToIds?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  completedFrom?: InputMaybe<Scalars['DateTime']>;
  completedTo?: InputMaybe<Scalars['DateTime']>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  dueDateFrom?: InputMaybe<Scalars['DateTime']>;
  dueDateTo?: InputMaybe<Scalars['DateTime']>;
  equipmentIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatusEnum>;
  take?: Scalars['Int'];
  taskTypeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetTaxArgs = {
  id: Scalars['String'];
};


export type QueryGetTaxesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  userId: Scalars['String'];
};


export type QueryGetUserCompanyArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserPaymentMethodsArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserWidgetContentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetUsersArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  fullAccessBuildingUsers?: UserFullAccessEnum;
  fullAccessCompanyUsers?: UserFullAccessEnum;
  orderByIds?: InputMaybe<Array<Scalars['String']>>;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortUserFieldEnum;
  sortByDir?: SortDirectionEnum;
  status?: InputMaybe<UserStatuses>;
  take?: Scalars['Int'];
};


export type QueryGetVendorAccessArgs = {
  id: Scalars['String'];
};


export type QueryGetVendorAccessListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  hostIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<VendorAccessStatusEnum>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetVendorAccessQrCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetWoCategoryWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoRevenueWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoReviewsWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoStatusWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWaiverTemplateArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverTemplatesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WaiverTypesEnum>;
};


export type QueryGetWatchlistArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetWorkOrderArgs = {
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderChargesArgs = {
  search?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderEmailArgs = {
  id: Scalars['String'];
};


export type QueryGetWorkOrderEmailsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetWorkOrderEquipmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderTemplateArgs = {
  templateId: Scalars['String'];
};


export type QueryGetWorkOrderTemplateChargesArgs = {
  search?: InputMaybe<Scalars['String']>;
  workOrderTemplateId: Scalars['String'];
};


export type QueryGetWorkOrderTemplateRelatedRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  workOrderTemplateId: Scalars['String'];
};


export type QueryGetWorkOrderTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWorkOrderTemplatesCalendarArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from: Scalars['DateTime'];
  recordStatuses?: InputMaybe<Array<RRuleStatuses>>;
  search?: InputMaybe<Scalars['String']>;
  to: Scalars['DateTime'];
};


export type QueryGetWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: ArchiveStatusEnum;
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  priorityIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryLoginArgs = {
  input: LoginInput;
};


export type QueryMagicLoginArgs = {
  input: MagicLoginAuthInput;
};


export type QueryMeArgs = {
  portfolioId: Scalars['String'];
};


export type QueryPopulateBuildingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryPopulateCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryPrintEquipmentQrCodeArgs = {
  id: Scalars['String'];
};


export type QuerySearchCompaniesArgs = {
  title: Scalars['String'];
};


export type QuerySearchFeatureArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  feature: SearchFeatureEnum;
  filter?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QuerySearchInvoiceChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  invoiceId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QuerySearchStepValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  taskTypeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySendMagicLinkArgs = {
  input: MagicLoginInput;
};


export type QuerySyncInvoiceFromStripeArgs = {
  offset: Scalars['Float'];
};


export type QueryValidateCompanyTaxIdArgs = {
  taxId: Scalars['String'];
};


export type QueryValidateLoginCodeArgs = {
  input: LoginCodeInput;
};


export type QueryValidateMagicLinkArgs = {
  code: Scalars['String'];
};


export type QueryValidatePortfolioUrlArgs = {
  url: Scalars['String'];
};


export type QueryValidateUserEmailArgs = {
  email: Scalars['String'];
};

export type RRuleEndObject = {
  __typename?: 'RRuleEndObject';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  type: RRuleEndType;
};

export type RRuleEndObjectInput = {
  count?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['String']>;
  type: RRuleEndType;
};

/** The supported types of category. */
export enum RRuleEndType {
  /** Specific date of end */
  Date = 'date',
  /** Count of iterations */
  Interval = 'interval',
  /** infinity */
  Never = 'never'
}

/** The supported types of date in RRule. */
export enum RRuleFrequencyType {
  /** Every day */
  Daily = 'DAILY',
  /** Every month */
  Monthly = 'MONTHLY',
  /** Every week */
  Weekly = 'WEEKLY',
  /** Every year */
  Yearly = 'YEARLY'
}

/** The supported types of date in RRule. */
export enum RRuleMonthlyTypes {
  /** By number of month day */
  MonthDay = 'monthDay',
  /** By number of week day */
  PosDay = 'posDay'
}

export type RRuleObject = {
  __typename?: 'RRuleObject';
  days?: Maybe<Array<RRuleWeekdays>>;
  end: RRuleEndObject;
  frequency: RRuleFrequencyType;
  interval: Scalars['Int'];
  monthDay?: Maybe<Scalars['Int']>;
  monthlyType?: Maybe<RRuleMonthlyTypes>;
  pos?: Maybe<RRulePos>;
  weekDay?: Maybe<RRuleWeekdays>;
};

export type RRuleObjectInput = {
  days?: InputMaybe<Array<RRuleWeekdays>>;
  end: RRuleEndObjectInput;
  frequency: RRuleFrequencyType;
  interval: Scalars['Int'];
  monthDay?: InputMaybe<Scalars['Int']>;
  monthlyType?: InputMaybe<RRuleMonthlyTypes>;
  pos?: InputMaybe<RRulePos>;
  weekDay?: InputMaybe<RRuleWeekdays>;
};

/** List of positions */
export enum RRulePos {
  First = 'first',
  Fourth = 'fourth',
  Last = 'last',
  Second = 'second',
  Third = 'third'
}

/** The supported statuses for RRule item. */
export enum RRuleStatuses {
  Active = 'active',
  Expired = 'expired',
  Paused = 'paused'
}

/** List of weekdays */
export enum RRuleWeekdays {
  Fr = 'fr',
  Mo = 'mo',
  Sa = 'sa',
  Su = 'su',
  Th = 'th',
  Tu = 'tu',
  We = 'we'
}

export enum RateIntervalEnum {
  HalfHour = 'HALF_HOUR',
  Hour = 'HOUR'
}

export enum RateModelEnum {
  HalfFullDay = 'HALF_FULL_DAY',
  Hourly = 'HOURLY'
}

export type RecordCustomFieldInput = {
  id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
};

export type RecordCustomFieldObject = {
  __typename?: 'RecordCustomFieldObject';
  customField: CustomFieldObject;
  id: Scalars['String'];
  value?: Maybe<Scalars['CustomFieldScalar']>;
};

export type RecurringInvoiceBulkObject = {
  __typename?: 'RecurringInvoiceBulkObject';
  data?: Maybe<Array<RecurringInvoiceObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type RecurringInvoiceCalendarObject = {
  __typename?: 'RecurringInvoiceCalendarObject';
  dates: Array<Scalars['DateTime']>;
  record: RecurringInvoiceObject;
};

export type RecurringInvoiceInput = {
  companyId: Scalars['String'];
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  rruleObject: RRuleObjectInput;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
};

export type RecurringInvoiceObject = {
  __typename?: 'RecurringInvoiceObject';
  attachments?: Maybe<Array<FileObject>>;
  bcc?: Maybe<Array<Scalars['String']>>;
  billTo?: Maybe<Scalars['String']>;
  cc?: Maybe<Array<Scalars['String']>>;
  charges?: Maybe<Scalars['Float']>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueAfterDays?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  excludeDates?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextGenerationDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  paidAmount: Scalars['Float'];
  prevGenerationDate?: Maybe<Scalars['DateTime']>;
  recordStatus: RRuleStatuses;
  rruleObject: RRuleObject;
  rruleText?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  stripeAccount?: Maybe<StripeAccountObject>;
  timezone: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type RecurringInvoicePaymentInput = {
  amount: Scalars['Float'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  recurringInvoiceId: Scalars['String'];
};

export type RecurringInvoicePaymentObject = {
  __typename?: 'RecurringInvoicePaymentObject';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  id: Scalars['String'];
  paymentMethod?: Maybe<PaymentMethodDto>;
};

export type RecurringInvoiceUpdateInput = {
  bcc?: InputMaybe<Array<Scalars['String']>>;
  billTo?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  rruleObject?: InputMaybe<RRuleObjectInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type RedemptionObjectInput = {
  createdAt: Scalars['Float'];
  userId: Scalars['String'];
};

export type ReferToObject = {
  __typename?: 'ReferToObject';
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type: ReferToType;
};

export enum ReferToType {
  Broadcast = 'BROADCAST',
  Coi = 'COI',
  Company = 'COMPANY',
  Deal = 'DEAL',
  Equipment = 'EQUIPMENT',
  Guest = 'GUEST',
  Incident = 'INCIDENT',
  Invoice = 'INVOICE',
  Lease = 'LEASE',
  MeetingHub = 'MEETING_HUB',
  Newsfeed = 'NEWSFEED',
  Other = 'OTHER',
  Package = 'PACKAGE',
  Procedure = 'PROCEDURE',
  RecurringInvoice = 'RECURRING_INVOICE',
  Schedule = 'SCHEDULE',
  Subscription = 'SUBSCRIPTION',
  Suite = 'SUITE',
  Task = 'TASK',
  VendorAccess = 'VENDOR_ACCESS',
  Watchlist = 'WATCHLIST',
  WorkOrder = 'WORK_ORDER',
  WorkOrderTemplate = 'WORK_ORDER_TEMPLATE'
}

export type RefundChargeInput = {
  amount: Scalars['Float'];
  chargeId: Scalars['String'];
};

export type RentSuiteObject = {
  __typename?: 'RentSuiteObject';
  company: CompanyObject;
  endDate: Scalars['String'];
  id: Scalars['String'];
  startDate: Scalars['String'];
};

/** The supported types of charges. */
export enum ReportCharges {
  All = 'all',
  Billable = 'billable',
  NonBillable = 'nonBillable'
}

export type ReportInput = {
  charges: ReportCharges;
  companies?: InputMaybe<Array<Scalars['String']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  from: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  isZeroValues: Scalars['Boolean'];
  to: Scalars['String'];
  type: ReportType;
};

export type ReportModel = {
  __typename?: 'ReportModel';
  charges: ReportCharges;
  companies: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  emails: Array<Scalars['String']>;
  file?: Maybe<FileObject>;
  from: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  isPrivate: Scalars['Boolean'];
  isZeroValues: Scalars['Boolean'];
  status: ReportStatus;
  to: Scalars['String'];
  type: ReportType;
};

export type ReportPmInput = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  from: Scalars['String'];
  to: Scalars['String'];
};

export type ReportSettingInput = {
  groupedChargesARCodeId?: InputMaybe<Scalars['String']>;
  groupedChargesGLCodeId?: InputMaybe<Scalars['String']>;
  invoiceAddress?: InputMaybe<Scalars['String']>;
  invoiceLogo?: InputMaybe<FileObjectInput>;
  yardiPropertyId?: InputMaybe<Scalars['String']>;
};

export type ReportSettingsObject = {
  __typename?: 'ReportSettingsObject';
  groupedChargesARCode?: Maybe<ArCodeObject>;
  groupedChargesGLCode?: Maybe<GlAccountObject>;
  invoiceAddress?: Maybe<Scalars['String']>;
  invoiceLogo?: Maybe<FileObject>;
  yardiPropertyId?: Maybe<Scalars['String']>;
};

/** The supported types for report item. */
export enum ReportStatus {
  Error = 'error',
  Pending = 'pending',
  Ready = 'ready'
}

/** The supported types for report item. */
export enum ReportType {
  PmOverall = 'pmOverall',
  RentStatementBackup = 'rentStatementBackup',
  WorkOrderDetail = 'workOrderDetail',
  WorkOrderJournalExtractGroupedWo = 'workOrderJournalExtractGroupedWO',
  WorkOrderYardi = 'workOrderYardi'
}

export type RepositoryBreadcrumbObject = {
  __typename?: 'RepositoryBreadcrumbObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RepositoryFileObject = {
  __typename?: 'RepositoryFileObject';
  /** Number of files inside of a folder (only for folders) */
  childrenCount?: Maybe<Scalars['Int']>;
  /** File extension, e.g. `.jpg` */
  ext?: Maybe<Scalars['String']>;
  /** String that uniquely identifies the file */
  id: Scalars['String'];
  /** Is a directory, default: false */
  isDir: Scalars['Boolean'];
  /** Is a hidden file, default: false */
  isHidden: Scalars['Boolean'];
  /** Is a private file, default: false */
  isPrivate: Scalars['Boolean'];
  /** Last change date */
  modDate?: Maybe<Scalars['DateTime']>;
  /** Full name, e.g. `MyImage.jpg` */
  name: Scalars['String'];
  /** File size in bytes */
  size?: Maybe<Scalars['Int']>;
  /** Automatically load thumbnail from this URL */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** Full url to file. Empty in case of a folder */
  url?: Maybe<Scalars['String']>;
};

export type RequestLoginCodeInput = {
  type: TwoFaTypeEnum;
  userId: Scalars['String'];
};

export type ResetPasswordInput = {
  code: Scalars['String'];
  password: Scalars['String'];
};

export type RoleObject = {
  __typename?: 'RoleObject';
  active: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  permissions: PermissionsObject;
  portfolioId: Scalars['String'];
  rolesAssignable: Array<RoleObject>;
  templates: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userCount: Scalars['Float'];
};

export type RolePermissionObject = {
  __typename?: 'RolePermissionObject';
  dependencies?: Maybe<Array<Scalars['String']>>;
  key: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type RoleSectionObject = {
  __typename?: 'RoleSectionObject';
  notes?: Maybe<Scalars['String']>;
  permissions: Array<RolePermissionObject>;
  title: Scalars['String'];
};

export type RoomInput = {
  addons?: InputMaybe<Array<Scalars['String']>>;
  amenities?: InputMaybe<Array<AmenityInput>>;
  arCodeId?: InputMaybe<Scalars['String']>;
  bufferTime?: InputMaybe<Scalars['Float']>;
  cancellationPeriod?: InputMaybe<Scalars['Float']>;
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  connectedRooms?: InputMaybe<Array<Scalars['String']>>;
  from: Scalars['String'];
  fullDayRate?: InputMaybe<Scalars['Float']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  halfDayMinutes?: InputMaybe<Scalars['Float']>;
  halfDayRate?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<FileObjectInput>;
  interval?: InputMaybe<RateIntervalEnum>;
  liabilityPolicy?: InputMaybe<Scalars['String']>;
  limitAdvanceDays?: InputMaybe<Scalars['Float']>;
  maxBookingTime?: InputMaybe<Scalars['Float']>;
  maxRate?: InputMaybe<Scalars['Float']>;
  minBookingTime: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  rateModel: RateModelEnum;
  requiresApproval: Scalars['Boolean'];
  size: RoomSizeEnum;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  to: Scalars['String'];
};

export type RoomObject = {
  __typename?: 'RoomObject';
  active: Scalars['Boolean'];
  addons?: Maybe<Array<MaterialObject>>;
  amenities?: Maybe<Array<AmenityModel>>;
  bufferTime?: Maybe<Scalars['Float']>;
  cancellationPeriod?: Maybe<Scalars['Float']>;
  cancellationPolicy?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  connectedRooms?: Maybe<Array<RoomObject>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from: Scalars['String'];
  fullDayRate?: Maybe<Scalars['Float']>;
  halfDayMinutes?: Maybe<Scalars['Float']>;
  halfDayRate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  image?: Maybe<FileObject>;
  index: Scalars['Float'];
  interval?: Maybe<RateIntervalEnum>;
  liabilityPolicy?: Maybe<Scalars['String']>;
  limitAdvanceDays?: Maybe<Scalars['Float']>;
  material: MaterialObject;
  maxBookingTime?: Maybe<Scalars['Float']>;
  maxRate?: Maybe<Scalars['Float']>;
  minBookingTime: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  rate?: Maybe<Scalars['Float']>;
  rateModel: RateModelEnum;
  requiresApproval: Scalars['Boolean'];
  reservations?: Maybe<Array<RoomReservationListObject>>;
  size: RoomSizeEnum;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  to: Scalars['String'];
};

export type RoomPublicReservationObject = {
  __typename?: 'RoomPublicReservationObject';
  date: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['String'];
  room: RoomObject;
  to: Scalars['String'];
};

export type RoomReservationGenerateWoInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  timezone?: Scalars['String'];
};

export type RoomReservationInput = {
  addons?: InputMaybe<Array<Scalars['String']>>;
  attachments?: InputMaybe<Array<FileObjectInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  customFields?: Array<RecordCustomFieldInput>;
  date: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  paymentType?: InputMaybe<PaymentTypeEnum>;
  requestedForId: Scalars['String'];
  roomId: Scalars['String'];
  to: Scalars['String'];
};

export type RoomReservationListObject = {
  __typename?: 'RoomReservationListObject';
  date: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
};

export type RoomReservationObject = {
  __typename?: 'RoomReservationObject';
  attachments?: Maybe<Array<FileObject>>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  customFields: Array<RecordCustomFieldObject>;
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Float'];
  paymentLink?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatusEnum>;
  paymentType?: Maybe<PaymentTypeEnum>;
  requestedFor: UserObject;
  room: RoomObject;
  status: RoomReservationStatusEnum;
  to: Scalars['String'];
  total: Scalars['Float'];
  workOrder?: Maybe<WorkOrderObject>;
};

export enum RoomReservationStatusEnum {
  Active = 'ACTIVE',
  Cancel = 'CANCEL',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type RoomReservationUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  description?: InputMaybe<Scalars['String']>;
};

export type RoomSettingObject = {
  __typename?: 'RoomSettingObject';
  defaultWOCategory?: Maybe<CategoryObject>;
  generateWOOnReservationApprove?: Maybe<Scalars['Boolean']>;
  notifyUsers?: Maybe<Array<UserObject>>;
};

export type RoomSettingsInput = {
  defaultWOCategoryId?: InputMaybe<Scalars['String']>;
  generateWOOnReservationApprove?: InputMaybe<Scalars['Boolean']>;
  notifyUserIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum RoomSizeEnum {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type SaveMenuInput = {
  location: MenuLocation;
  menus: Array<MenuItemInput>;
};

export type SchedulesBulkObject = {
  __typename?: 'SchedulesBulkObject';
  data?: Maybe<Array<SchedulesObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type SchedulesCalendarObject = {
  __typename?: 'SchedulesCalendarObject';
  dates: Array<Scalars['DateTime']>;
  record: SchedulesObject;
};

export type SchedulesInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: Array<FileObjectInput>;
  buildingId: Scalars['String'];
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  equipmentIds?: InputMaybe<Array<Scalars['String']>>;
  notes?: InputMaybe<Scalars['String']>;
  procedureIds: Array<Scalars['String']>;
  rruleObject: RRuleObjectInput;
  splitEquipmentOnTask?: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  taskTypeId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type SchedulesIntervalObject = {
  __typename?: 'SchedulesIntervalObject';
  createdAt: Scalars['DateTime'];
  endTime: Scalars['String'];
  friday: Scalars['Boolean'];
  id: Scalars['String'];
  monday: Scalars['Boolean'];
  saturday: Scalars['Boolean'];
  startTime: Scalars['String'];
  sunday: Scalars['Boolean'];
  thursday: Scalars['Boolean'];
  tuesday: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  wednesday: Scalars['Boolean'];
};

export type SchedulesObject = {
  __typename?: 'SchedulesObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueAfterDays?: Maybe<Scalars['Int']>;
  equipment: Array<EquipmentModel>;
  equipmentCount: Scalars['Float'];
  excludeDates?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextGenerationDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  prevGenerationDate?: Maybe<Scalars['DateTime']>;
  procedureCount: Scalars['Float'];
  procedures: Array<ProcedureObject>;
  recordStatus: RRuleStatuses;
  rruleObject: RRuleObject;
  rruleText?: Maybe<Scalars['String']>;
  splitEquipmentOnTask: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  taskType?: Maybe<TaskTypeModel>;
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type SchedulesUpdateRRuleInput = {
  rruleObject: RRuleObjectInput;
};

export enum SearchFeatureEnum {
  Coi = 'COI',
  Company = 'COMPANY',
  Equipment = 'EQUIPMENT',
  Guest = 'GUEST',
  Incident = 'INCIDENT',
  Procedure = 'PROCEDURE',
  Reservation = 'RESERVATION',
  User = 'USER',
  Vendor = 'VENDOR',
  WorkOrder = 'WORK_ORDER',
  WorkOrderTemplate = 'WORK_ORDER_TEMPLATE'
}

export type SearchFilterObject = {
  __typename?: 'SearchFilterObject';
  description: Scalars['String'];
  key: Scalars['String'];
};

export type SearchRecentInput = {
  feature: SearchFeatureEnum;
  id: Scalars['String'];
};

export type SearchResultObject = {
  __typename?: 'SearchResultObject';
  additionalData?: Maybe<Array<ObjectAdds>>;
  feature: FeatureObject;
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  status: ObjectStatus;
  title: Scalars['String'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  data: Array<SearchResultObject>;
  pagination: CursorPagination;
};

export type SectionInput = {
  steps?: InputMaybe<Array<StepsInput>>;
  title: Scalars['String'];
};

export type SendBroadcastInput = {
  app: Scalars['Boolean'];
  attachments?: InputMaybe<Array<FileObjectInput>>;
  body?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Array<Scalars['String']>>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  email: Scalars['Boolean'];
  emailBody?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  sms: Scalars['Boolean'];
  subject: Scalars['String'];
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type SendTestMailInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
};

export type SetDoorObject = {
  __typename?: 'SetDoorObject';
  doorOperatorType: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type SetScheduleObject = {
  __typename?: 'SetScheduleObject';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type SetsObject = {
  __typename?: 'SetsObject';
  door?: Maybe<SetDoorObject>;
  schedule?: Maybe<SetScheduleObject>;
};

export type ShippingProviderInput = {
  logo?: InputMaybe<FileObjectInput>;
  title: Scalars['String'];
};

export type ShippingProviderObject = {
  __typename?: 'ShippingProviderObject';
  createdAt: Scalars['DateTime'];
  default: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Float'];
  logo?: Maybe<FileObject>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum SortActivityFieldEnum {
  Creation = 'CREATION'
}

export enum SortBuildingFieldEnum {
  Creation = 'CREATION',
  Title = 'TITLE'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortUserFieldEnum {
  Creation = 'CREATION',
  FirstName = 'FIRST_NAME'
}

export type SourceObject = {
  __typename?: 'SourceObject';
  brand: Scalars['String'];
  country: Scalars['String'];
  last4: Scalars['String'];
  name: Scalars['String'];
  object: Scalars['String'];
};

export type StakingPlanFloor = {
  __typename?: 'StakingPlanFloor';
  attachment?: Maybe<FileObject>;
  id: Scalars['String'];
  size: Scalars['Float'];
  suites: Array<StakingPlanSuite>;
  title: Scalars['String'];
};

export type StakingPlanSuite = {
  __typename?: 'StakingPlanSuite';
  attachment?: Maybe<FileObject>;
  id: Scalars['String'];
  rent?: Maybe<RentSuiteObject>;
  size: Scalars['Float'];
  title: Scalars['String'];
  type: SuiteType;
};

export type StatusInput = {
  color: Scalars['String'];
  recordType: StatusRecordType;
  title: Scalars['String'];
};

export type StatusObject = {
  __typename?: 'StatusObject';
  active: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  recordType: StatusRecordType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  workOrderCount: Scalars['Int'];
};

/** The supported records type. */
export enum StatusRecordType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type StatusUpdateInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type StepValuesObject = {
  __typename?: 'StepValuesObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  id: Scalars['String'];
  inputOptions?: Maybe<ProcedureSectionStepInputOptionObject>;
  predefinedCustomField?: Maybe<PmCustomIdObject>;
  task?: Maybe<TaskObject>;
  title: Scalars['String'];
  type: PmStepType;
  value?: Maybe<Scalars['CustomFieldScalar']>;
};

export type StepsInput = {
  customId?: InputMaybe<Scalars['String']>;
  dropdownOptions?: InputMaybe<PmOptionDropdownInput>;
  inputOptions?: InputMaybe<PmOptionInputInput>;
  predefinedCustomFieldId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: PmStepType;
};

export type StoreGuestsDto = {
  buildingId: Scalars['String'];
  guests: Array<ManualGuestInputDto>;
  visit: VisitInputDto;
};

export type StoreVendorAccessInput = {
  buildingId: Scalars['String'];
  coiId: Scalars['String'];
  companyId: Scalars['String'];
  requestedForId: Scalars['String'];
  visit: VisitInput;
};

export type StripeAccountObject = {
  __typename?: 'StripeAccountObject';
  accountId?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  apiKey: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type StripeChargeObject = {
  __typename?: 'StripeChargeObject';
  amount: Scalars['Int'];
  amountRefunded: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
  paymentIntentId?: Maybe<Scalars['String']>;
  receiptUrl?: Maybe<Scalars['String']>;
  source?: Maybe<SourceObject>;
  status: Scalars['String'];
  user?: Maybe<UserObject>;
};

export type StripeInvoiceObject = {
  __typename?: 'StripeInvoiceObject';
  amountDue: Scalars['Float'];
  amountPaid: Scalars['Float'];
  chargeId?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyObject>;
  couponData: CouponStripeObject;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoiceLink?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentObject>;
  paymentId?: Maybe<Scalars['String']>;
  priceData: PriceStripeObject;
  product?: Maybe<ProductItemObject>;
  productData: ProductStripeObject;
  productName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
  type?: Maybe<StripePaymentEnum>;
  user?: Maybe<UserObject>;
  userId?: Maybe<Scalars['String']>;
};

/** The supported types for payment items. */
export enum StripePaymentEnum {
  Amano = 'Amano',
  Fitness = 'Fitness',
  MeetingHub = 'MeetingHub'
}

export type StripeSettingsInput = {
  paymentACHCap?: InputMaybe<Scalars['Float']>;
  paymentACHFee?: InputMaybe<Scalars['Float']>;
  paymentACHUnit?: InputMaybe<ValueUnit>;
  paymentCardFee?: InputMaybe<Scalars['Float']>;
  paymentCardUnit?: InputMaybe<ValueUnit>;
};

export type StripeSettingsObject = {
  __typename?: 'StripeSettingsObject';
  paymentACHCap?: Maybe<Scalars['Float']>;
  paymentACHFee?: Maybe<Scalars['Float']>;
  paymentACHUnit?: Maybe<ValueUnit>;
  paymentCardFee?: Maybe<Scalars['Float']>;
  paymentCardUnit?: Maybe<ValueUnit>;
};

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  clientSecret: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  notificationAdded: NotificationObject;
  unreadNotificationAdded: Scalars['String'];
};


export type SubscriptionNotificationAddedArgs = {
  notificationCategory?: InputMaybe<NotificationCategoryEnum>;
};

/** The supported types for subscription cancel type. */
export enum SubscriptionCancelEnum {
  NextCharge = 'NEXT_CHARGE',
  Now = 'NOW'
}

export type SubscriptionCancelInput = {
  subscriptionId: Scalars['String'];
  type: SubscriptionCancelEnum;
};

export type SubscriptionInput = {
  cardId: Scalars['String'];
  companyId: Scalars['String'];
  coupon?: InputMaybe<Scalars['String']>;
  customFields: Array<SubscriptionProductCustomFieldInput>;
  date?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  requestedForId: Scalars['String'];
  signature?: InputMaybe<Scalars['String']>;
};

export type SubscriptionObject = {
  __typename?: 'SubscriptionObject';
  attachments?: Maybe<Array<FileObject>>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  company: CompanyObject;
  couponData: CouponStripeObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  customFields: Array<SubscriptionProductCustomField>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextChargeDate?: Maybe<Scalars['DateTime']>;
  originalAmount: Scalars['Float'];
  priceData: PriceStripeObject;
  productData: ProductStripeObject;
  requestedFor: UserObject;
  startDate?: Maybe<Scalars['String']>;
  status: SubscriptionStatusEnum;
  subscriptionId: Scalars['String'];
  trialPlanUsed: Scalars['Boolean'];
  type?: Maybe<StripePaymentEnum>;
  waivers?: Maybe<Array<WaiverModel>>;
};

export type SubscriptionProductCustomField = {
  __typename?: 'SubscriptionProductCustomField';
  label: Scalars['String'];
  required: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type SubscriptionProductCustomFieldInput = {
  label: Scalars['String'];
  required: Scalars['Boolean'];
  value?: InputMaybe<Scalars['String']>;
};

/** The supported types for subscription items. */
export enum SubscriptionStatusEnum {
  Active = 'ACTIVE',
  CancelationScheduled = 'CANCELATION_SCHEDULED',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Scheduled = 'SCHEDULED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type SubscriptionTrialInput = {
  productId: Scalars['String'];
  userId: Scalars['String'];
};

export type SubscriptionUpdateInput = {
  coupon?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
};

export type SubscriptionValidateCouponInput = {
  coupon: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type SubscriptionWaiverTextInput = {
  companyId: Scalars['String'];
  priceId: Scalars['String'];
  productId: Scalars['String'];
  userId: Scalars['String'];
  waiverTemplateId: Scalars['String'];
};

export type SubscriptionWaiverTextModel = {
  __typename?: 'SubscriptionWaiverTextModel';
  text: Scalars['String'];
};

export type SuiteInput = {
  attachment?: InputMaybe<FileObjectInput>;
  bomaSize?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<Scalars['String']>;
  floorId: Scalars['String'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  size: Scalars['Float'];
  title: Scalars['String'];
  type: SuiteType;
};

export type SuiteObject = {
  __typename?: 'SuiteObject';
  attachment?: Maybe<FileObject>;
  bomaSize?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
  floor: FloorObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  isPublic: Scalars['Boolean'];
  leases?: Maybe<Array<LeaseObject>>;
  order: Scalars['Int'];
  size: Scalars['Float'];
  title: Scalars['String'];
  type: SuiteType;
};

/** The supported types of suites. */
export enum SuiteType {
  /** Suite type */
  Amenity = 'amenity',
  /** Suite type, excluded form lease logic */
  Mechanical = 'mechanical',
  /** Suite type */
  Tenant = 'tenant'
}

export type TaskObject = {
  __typename?: 'TaskObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  charges?: Maybe<Scalars['Float']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueDate?: Maybe<Scalars['String']>;
  equipment: Array<EquipmentModel>;
  id: Scalars['String'];
  index: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  procedures: Array<TaskProcedureObject>;
  schedule?: Maybe<SchedulesObject>;
  status: TaskStatusEnum;
  systemCompleted: Scalars['Boolean'];
  taskType?: Maybe<TaskTypeModel>;
  title: Scalars['String'];
  userCompleted: Scalars['Boolean'];
  watchers?: Maybe<Array<UserObject>>;
};

export type TaskOpenWidget = {
  __typename?: 'TaskOpenWidget';
  count: Scalars['Int'];
};

export type TaskOverdueWidget = {
  __typename?: 'TaskOverdueWidget';
  count: Scalars['Int'];
};

export type TaskProcedureObject = {
  __typename?: 'TaskProcedureObject';
  estimatedLabor?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isDone: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  procedure?: Maybe<ProcedureObject>;
  procedureId?: Maybe<Scalars['String']>;
  procedureIndex: Scalars['Float'];
  sections: Array<TaskSectionObject>;
  title: Scalars['String'];
};

export type TaskSectionObject = {
  __typename?: 'TaskSectionObject';
  id: Scalars['String'];
  isDone: Scalars['Boolean'];
  steps: Array<TaskStepObject>;
  title: Scalars['String'];
};

export enum TaskStatusEnum {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE'
}

export type TaskStepObject = {
  __typename?: 'TaskStepObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  id: Scalars['String'];
  inputOptions?: Maybe<ProcedureSectionStepInputOptionObject>;
  predefinedCustomField?: Maybe<PmCustomIdObject>;
  title: Scalars['String'];
  type: PmStepType;
  value?: Maybe<Scalars['CustomFieldScalar']>;
};

export type TaskTypeModel = {
  __typename?: 'TaskTypeModel';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  scheduleCount: Scalars['Int'];
  taskCount: Scalars['Int'];
  title: Scalars['String'];
};

export type TaxInput = {
  amount: Scalars['Float'];
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type TaxObject = {
  __typename?: 'TaxObject';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  propertyId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ThreeSecure = {
  __typename?: 'ThreeSecure';
  supported?: Maybe<Scalars['String']>;
};

export enum ToggleDoorEnum {
  Lock = 'LOCK',
  QuickUnlock = 'QUICK_UNLOCK',
  Unlock = 'UNLOCK'
}

export type ToggleDoorInput = {
  id: Scalars['String'];
  type: ToggleDoorEnum;
};

export type ToggleEmailTemplateInput = {
  toggleType: EmailToggleEnum;
  type: EmailTemplateType;
};

export type ToggleLoginAuthInput = {
  type: TwoFaTypeEnum;
  userId: Scalars['String'];
};

export type TogglePropertyIntegrationInput = {
  type: IntegrationTypeEnum;
};

export type TranslationObject = {
  __typename?: 'TranslationObject';
  active: Scalars['Boolean'];
  countryCode: Scalars['String'];
  descriptions: Scalars['TranslationKeysScalar'];
  globalTranslation: GlobalTranslationObject;
  id: Scalars['String'];
  sources: Scalars['TranslationKeysScalar'];
  title: Scalars['String'];
  translations?: Maybe<Scalars['TranslationKeysScalar']>;
};

export type TwoFaObject = {
  __typename?: 'TwoFAObject';
  list: Array<TwoFaTypeEnum>;
  userId: Scalars['String'];
};

export enum TwoFaTypeEnum {
  TwoFaEmail = 'TWO_FA_EMAIL',
  TwoFaPhone = 'TWO_FA_PHONE'
}

export type UpdateDealCategoryInput = {
  icon?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEmailTemplateInput = {
  appActive?: InputMaybe<Scalars['Boolean']>;
  appBody?: InputMaybe<Scalars['String']>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  emailActive?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  smsActive?: InputMaybe<Scalars['Boolean']>;
  smsBody?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type UpdateEquipmentInput = {
  assetTag?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<FileObjectInput>>;
  buildingId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  specificLocation?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGeneaTenantLinkInput = {
  companyId: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
};

export type UpdateGuestDto = {
  guest?: InputMaybe<UpdateManualGuestInputDto>;
  visit?: InputMaybe<UpdateVisitInputDto>;
};

export type UpdateManualGuestInputDto = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  companyId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
};

export type UpdatePortfolioCategory = {
  categoryId: Scalars['String'];
  employeeId?: InputMaybe<Scalars['String']>;
  notifyList?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateUserDashboardWidgetInput = {
  layout: UserDashboardWidgetLayoutInput;
  widgetId: Scalars['String'];
};

export type UpdateUserPhoneInput = {
  code: Scalars['String'];
  enableLoginAuth?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UpdateVendorAccessInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  coiId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  visit?: InputMaybe<UpdateVisitInput>;
};

export type UpdateVisitInput = {
  allDayAccess?: InputMaybe<Scalars['Boolean']>;
  dates?: InputMaybe<Array<Scalars['String']>>;
  endTime?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notifyUsers?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<VendorAccessVisitTypeEnum>;
};

export type UpdateVisitInputDto = {
  allDayAccess?: InputMaybe<Scalars['Boolean']>;
  dates?: InputMaybe<Array<Scalars['String']>>;
  endTime?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notifyUsers?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GuestVisitTypeEnum>;
};

export type UploadFileDto = {
  __typename?: 'UploadFileDTO';
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

export type UserAvailableWidgetObject = {
  __typename?: 'UserAvailableWidgetObject';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: DashboardWidgetEnum;
};

export type UserBuildingObject = {
  __typename?: 'UserBuildingObject';
  /** provided always, first available company in user accessible buildings list, used only if primary building not exist */
  default: BuildingObject;
  /** provided only in case user has select primary building in his settings and its overlap with logged user */
  primary?: Maybe<BuildingObject>;
};

export type UserBulkObject = {
  __typename?: 'UserBulkObject';
  data?: Maybe<Array<UserObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type UserCheckPermissionsInput = {
  permissions: Array<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserCompanyObject = {
  __typename?: 'UserCompanyObject';
  /** provided always, first available company in user accessible companies list, used only if primary company not exist */
  default: CompanyObject;
  /** provided only in case user has select primary company in his settings and its overlap with logged user */
  primary?: Maybe<CompanyObject>;
};

export type UserDashboardWidgetInput = {
  color?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  title: Scalars['String'];
  type: DashboardWidgetEnum;
};

export type UserDashboardWidgetLayoutInput = {
  h: Scalars['Float'];
  w: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UserDataInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** The supported values for get users request. */
export enum UserFullAccessEnum {
  /** List of users without full access accounts */
  Exclude = 'EXCLUDE',
  /** List of users plus full access accounts */
  Include = 'INCLUDE',
  /** List of users only with full access accounts */
  Only = 'ONLY'
}

export type UserLoggedObject = {
  __typename?: 'UserLoggedObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  properties: Array<PropertyObject>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserObject = {
  __typename?: 'UserObject';
  active: Scalars['Boolean'];
  authSecurity?: Maybe<UserSettingObject>;
  buildings: Array<BuildingObject>;
  companies: Array<CompanyObject>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  homepageId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  primaryBuilding?: Maybe<BuildingObject>;
  primaryCompany?: Maybe<CompanyObject>;
  printer?: Maybe<PrinterModel>;
  property: PropertyObject;
  role: RoleObject;
  status: UserStatuses;
  suite?: Maybe<SuiteObject>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserPaymentMethodInput = {
  paymentMethodId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserPropertyAddInput = {
  buildingIds: Array<Scalars['String']>;
  companyIds: Array<Scalars['String']>;
  roleId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserPropertyCreateInput = {
  buildingIds?: Array<Scalars['String']>;
  companyIds?: Array<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<FileObjectInput>;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  status?: InputMaybe<UserStatuses>;
  suiteId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UserPropertyPreferenceInput = {
  homepageId?: InputMaybe<Scalars['String']>;
  printerId?: InputMaybe<Scalars['String']>;
};

export type UserPropertyUpdateInput = {
  buildingIds?: Array<Scalars['String']>;
  companyIds?: Array<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  status?: InputMaybe<UserStatuses>;
  suiteId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UserSettingNotificationObject = {
  __typename?: 'UserSettingNotificationObject';
  appActive: Scalars['Boolean'];
  appUserActive: Scalars['Boolean'];
  category: Scalars['String'];
  emailActive: Scalars['Boolean'];
  emailUserActive: Scalars['Boolean'];
  smsActive: Scalars['Boolean'];
  smsUserActive: Scalars['Boolean'];
  trigger: Scalars['String'];
  type: EmailTemplateType;
};

export type UserSettingObject = {
  __typename?: 'UserSettingObject';
  two_fa_email?: Maybe<Scalars['Boolean']>;
  two_fa_phone?: Maybe<Scalars['Boolean']>;
};

/** The supported types for menu items. */
export enum UserStatuses {
  /** User status which can do anything */
  Active = 'active',
  /** Status which set when user doesnt have role or he is deactivated */
  Deactivated = 'deactivated',
  /** User is deleted */
  Deleted = 'deleted'
}

export type UserVerificationPaymentMethodInput = {
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
  paymentMethodType: PaymentMethodTypeEnum;
  redirectUrl: Scalars['String'];
  setupIntentId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserWidgetContentObject = {
  __typename?: 'UserWidgetContentObject';
  additionalData?: Maybe<Array<ObjectAdds>>;
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  status: ObjectStatus;
  title: Scalars['String'];
};

export type UserWidgetContents = {
  __typename?: 'UserWidgetContents';
  data: Array<UserWidgetContentObject>;
  pagination: CursorPagination;
};

export type UserWidgetLayoutModel = {
  __typename?: 'UserWidgetLayoutModel';
  h: Scalars['Float'];
  w: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UserWidgetObject = {
  __typename?: 'UserWidgetObject';
  color?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['String'];
  layout?: Maybe<UserWidgetLayoutModel>;
  title: Scalars['String'];
  type: DashboardWidgetEnum;
};

export type ValidateUrlObject = {
  __typename?: 'ValidateUrlObject';
  active: Scalars['Boolean'];
  background?: Maybe<FileObject>;
  id?: Maybe<Scalars['String']>;
  logo?: Maybe<FileObject>;
  stripeEnable: Scalars['Boolean'];
  stripePublishableKey?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translation?: Maybe<TranslationObject>;
  translations: Array<TranslationObject>;
  url: Scalars['String'];
};

/** The supported types of value unit. */
export enum ValueUnit {
  /** Amount type */
  Normal = 'normal',
  /** Percentage type */
  Percent = 'percent'
}

export type VendorAccessActionObject = {
  __typename?: 'VendorAccessActionObject';
  data?: Maybe<Array<VendorAccessModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type VendorAccessBulkObject = {
  __typename?: 'VendorAccessBulkObject';
  data?: Maybe<Array<VendorAccessModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type VendorAccessCsvErrorsObject = {
  __typename?: 'VendorAccessCsvErrorsObject';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type VendorAccessModel = {
  __typename?: 'VendorAccessModel';
  attachments?: Maybe<Array<FileObject>>;
  avatar?: Maybe<FileObject>;
  building: BuildingObject;
  code: Scalars['Int'];
  coi: CoiObject;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  requestedFor: UserObject;
  status: VendorAccessStatusEnum;
  visit: VendorAccessVisitModel;
  visitDates?: Maybe<Array<VendorAccessVisitDateObject>>;
};

export type VendorAccessPrintActionObject = {
  __typename?: 'VendorAccessPrintActionObject';
  data?: Maybe<Array<VendorAccessModel>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  notification: Scalars['Boolean'];
  successCount: Scalars['Int'];
};

export enum VendorAccessStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  WaitingForApproval = 'WaitingForApproval'
}

export type VendorAccessVisitDateObject = {
  __typename?: 'VendorAccessVisitDateObject';
  createdAt: Scalars['DateTime'];
  date: Scalars['String'];
  id: Scalars['String'];
  visitId: Scalars['String'];
};

export type VendorAccessVisitModel = {
  __typename?: 'VendorAccessVisitModel';
  allDayAccess?: Maybe<Scalars['Boolean']>;
  checkInDates?: Maybe<Array<Scalars['String']>>;
  dates: Array<VendorAccessVisitDateObject>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  notifyUsers?: Maybe<Array<UserObject>>;
  startTime?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  type: VendorAccessVisitTypeEnum;
  vendorId: Scalars['String'];
};

export enum VendorAccessVisitTypeEnum {
  MultipleDays = 'MultipleDays',
  PeriodRange = 'PeriodRange',
  SingleDay = 'SingleDay'
}

export type VerifyPhoneInput = {
  phone: Scalars['String'];
  userId: Scalars['String'];
};

export type VisitInput = {
  allDayAccess: Scalars['Boolean'];
  dates: Array<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notifyUsers?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  type: VendorAccessVisitTypeEnum;
};

export type VisitInputDto = {
  allDayAccess: Scalars['Boolean'];
  dates: Array<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notifyUsers?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  type: GuestVisitTypeEnum;
};

export type WoCategoryWidget = {
  __typename?: 'WOCategoryWidget';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type WoGuestUserObject = {
  __typename?: 'WOGuestUserObject';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type WoRevenueWidget = {
  __typename?: 'WORevenueWidget';
  laborRevenue: Scalars['Float'];
  markupRevenue: Scalars['Float'];
  materialRevenue: Scalars['Float'];
  name: Scalars['String'];
};

export type WoReviewObject = {
  __typename?: 'WOReviewObject';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  id: Scalars['String'];
  score: Scalars['Int'];
};

export type WoReviewWidget = {
  __typename?: 'WOReviewWidget';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type WoStatusWidget = {
  __typename?: 'WOStatusWidget';
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type WaiverInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
  title: Scalars['String'];
  type: WaiverTypesEnum;
};

export type WaiverModel = {
  __typename?: 'WaiverModel';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  isSigned: Scalars['Boolean'];
  pdf?: Maybe<FileObject>;
  requestedFor: UserObject;
  text: Scalars['String'];
  waiverTemplate: WaiverTemplateModel;
};

export type WaiverTemplateModel = {
  __typename?: 'WaiverTemplateModel';
  createdBy: UserObject;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  text: Scalars['String'];
  title: Scalars['String'];
  type: WaiverTypesEnum;
};

export enum WaiverTypesEnum {
  WaiverStripeProduct = 'WaiverStripeProduct'
}

export type WaiverUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WaiverTypesEnum>;
};

export type WatchlistInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  companyId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  requestedForId: Scalars['String'];
  userPhoto?: InputMaybe<FileObjectInput>;
};

export type WatchlistObject = {
  __typename?: 'WatchlistObject';
  active: Scalars['Boolean'];
  attachments?: Maybe<Array<FileObject>>;
  company: CompanyObject;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Float'];
  lastName: Scalars['String'];
  requestedFor: UserObject;
  userPhoto?: Maybe<FileObject>;
};

export type WatchlistUpdateInput = {
  attachments?: InputMaybe<Array<FileObjectInput>>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  userPhoto?: InputMaybe<FileObjectInput>;
};

export type WorkOrderBulkObject = {
  __typename?: 'WorkOrderBulkObject';
  data?: Maybe<Array<WorkOrderObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type WorkOrderDataInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: Array<FileObjectInput>;
  categoryId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type WorkOrderEmailInput = {
  allowUnknownSender?: Scalars['Boolean'];
  assignedToId?: InputMaybe<Scalars['String']>;
  buildingId: Scalars['String'];
  categoryId: Scalars['String'];
  companyId?: InputMaybe<Scalars['String']>;
  emailSlug?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type WorkOrderEmailObject = {
  __typename?: 'WorkOrderEmailObject';
  active: Scalars['Boolean'];
  allowUnknownSender: Scalars['Boolean'];
  assignedTo?: Maybe<UserObject>;
  building: BuildingObject;
  category: CategoryObject;
  company?: Maybe<CompanyObject>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  email: Scalars['String'];
  emailSlug: Scalars['String'];
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  priority?: Maybe<PriorityObject>;
  requestedFor?: Maybe<UserObject>;
  status?: Maybe<StatusObject>;
  suite?: Maybe<SuiteObject>;
  title: Scalars['String'];
};

export type WorkOrderEquipmentAddInput = {
  equipmentIds: Array<Scalars['String']>;
  workOrderId: Scalars['String'];
};

export type WorkOrderEquipmentRemoveInput = {
  equipmentIds: Array<Scalars['String']>;
  workOrderId: Scalars['String'];
};

export type WorkOrderInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: Array<FileObjectInput>;
  buildingId: Scalars['String'];
  categoryId: Scalars['String'];
  companyId: Scalars['String'];
  customFields?: Array<RecordCustomFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type WorkOrderObject = {
  __typename?: 'WorkOrderObject';
  acknowledged?: Maybe<Scalars['Boolean']>;
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  category: CategoryObject;
  charges?: Maybe<Scalars['Float']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  createdByGuest?: Maybe<WoGuestUserObject>;
  customFields: Array<RecordCustomFieldObject>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  priority?: Maybe<PriorityObject>;
  requestedFor?: Maybe<UserObject>;
  review?: Maybe<WoReviewObject>;
  startDate: Scalars['DateTime'];
  status: StatusObject;
  suite?: Maybe<SuiteObject>;
  timezone: Scalars['String'];
  watchers?: Maybe<Array<UserObject>>;
  workOrderTemplate?: Maybe<WorkOrderTemplateObject>;
};

export type WorkOrderPublicInput = {
  formId: Scalars['String'];
  userData: UserDataInput;
  workOrderData: WorkOrderDataInput;
};

export type WorkOrderReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
  workOrderId: Scalars['String'];
};

export type WorkOrderShareInput = {
  emails: Array<Scalars['String']>;
  workOrderId: Scalars['String'];
};

export type WorkOrderStatusSettingObject = {
  __typename?: 'WorkOrderStatusSettingObject';
  acknowledge?: Maybe<StatusObject>;
  closed: Array<StatusObject>;
  default?: Maybe<StatusObject>;
  rating: Array<StatusObject>;
};

export type WorkOrderTemplateBulkObject = {
  __typename?: 'WorkOrderTemplateBulkObject';
  data?: Maybe<Array<WorkOrderTemplateObject>>;
  errorCount: Scalars['Int'];
  errorMessages?: Maybe<Array<Scalars['String']>>;
  successCount: Scalars['Int'];
};

export type WorkOrderTemplateInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: Array<FileObjectInput>;
  buildingId: Scalars['String'];
  categoryId: Scalars['String'];
  companyId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId: Scalars['String'];
  rruleObject: RRuleObjectInput;
  startDate?: InputMaybe<Scalars['DateTime']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type WorkOrderTemplateObject = {
  __typename?: 'WorkOrderTemplateObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  category: CategoryObject;
  charges?: Maybe<Scalars['Float']>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  description?: Maybe<Scalars['String']>;
  dueAfterDays?: Maybe<Scalars['Int']>;
  excludeDates?: Maybe<Array<Scalars['String']>>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextGenerationDate?: Maybe<Scalars['DateTime']>;
  prevGenerationDate?: Maybe<Scalars['DateTime']>;
  priority?: Maybe<PriorityObject>;
  recordStatus: RRuleStatuses;
  requestedFor?: Maybe<UserObject>;
  rruleObject: RRuleObject;
  rruleText?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  suite?: Maybe<SuiteObject>;
  timezone: Scalars['String'];
};

export type WorkOrderTemplateUpdateInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<FileObjectInput>>;
  categoryId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueAfterDays?: InputMaybe<Scalars['Int']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  rruleObject?: InputMaybe<RRuleObjectInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type WorkOrderTemplatesCalendarObject = {
  __typename?: 'WorkOrderTemplatesCalendarObject';
  dates: Array<Scalars['DateTime']>;
  record: WorkOrderTemplateObject;
};

export type WorkOrderUpdateInput = {
  assignedToId?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<FileObjectInput>>;
  categoryId?: InputMaybe<Scalars['String']>;
  closedAt?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['String']>;
  customFields?: Array<RecordCustomFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['String']>;
  priorityId?: InputMaybe<Scalars['String']>;
  requestedForId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  statusId?: InputMaybe<Scalars['String']>;
  suiteId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ActivityLogCoreFieldsFragment = { __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> };

export type AddCommentMutationVariables = Exact<{
  data: CommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'ActivityLogModel', id: string } };

export type RemoveCommentMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCommentMutation = { __typename?: 'Mutation', removeComment: boolean };

export type GetActivityLogQueryVariables = Exact<{
  activityType?: InputMaybe<ActivityTypeEnum>;
  referType?: InputMaybe<ReferToType>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetActivityLogQuery = { __typename?: 'Query', getActivityLog: { __typename?: 'GetActivityLogsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, referToRecord: { __typename?: 'ReferToObject', id: string, index?: number | null, title?: string | null, type: ReferToType }, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> }> } };

export type GetRecordActivityLogQueryVariables = Exact<{
  activityType?: InputMaybe<ActivityTypeEnum>;
  recordId: Scalars['String'];
  referType: ReferToType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetRecordActivityLogQuery = { __typename?: 'Query', getRecordActivityLog: { __typename?: 'GetActivityLogsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> }> } };

export type AddressFieldsFragment = { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null };

export type AmanoSettingFieldsFragment = { __typename?: 'AmanoSettingsObject', id: string, index: number, accessGroups: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }>, facility: { __typename?: 'AmanoFacilityObject', id: string, name: string }, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null };

export type SaveAmanoSettingsMutationVariables = Exact<{
  data: AmanoSettingInput;
}>;


export type SaveAmanoSettingsMutation = { __typename?: 'Mutation', saveAmanoSettings: { __typename?: 'AmanoSettingsObject', id: string, index: number, accessGroups: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }>, facility: { __typename?: 'AmanoFacilityObject', id: string, name: string }, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null } };

export type UpdateAmanoSettingsMutationVariables = Exact<{
  id: Scalars['String'];
  data: AmanoSettingInput;
}>;


export type UpdateAmanoSettingsMutation = { __typename?: 'Mutation', updateAmanoSettings: { __typename?: 'AmanoSettingsObject', id: string, index: number, accessGroups: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }>, facility: { __typename?: 'AmanoFacilityObject', id: string, name: string }, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null } };

export type DeleteAmanoSettingsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type DeleteAmanoSettingsMutation = { __typename?: 'Mutation', deleteAmanoSettings: boolean };

export type GetAmanoSettingsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAmanoSettingsQuery = { __typename?: 'Query', getAmanoSettings: { __typename?: 'GetAmanoSettingsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'AmanoSettingsObject', id: string, index: number, accessGroups: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }>, facility: { __typename?: 'AmanoFacilityObject', id: string, name: string }, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null }> } };

export type GetAmanoSettingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAmanoSettingQuery = { __typename?: 'Query', getAmanoSetting: { __typename?: 'AmanoSettingsObject', id: string, index: number, accessGroups: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }>, facility: { __typename?: 'AmanoFacilityObject', id: string, name: string }, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null } };

export type GetAmanoFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAmanoFacilitiesQuery = { __typename?: 'Query', getAmanoFacilities: Array<{ __typename?: 'AmanoFacilityObject', id: string, name: string }> };

export type GetAmanoAccessGroupQueryVariables = Exact<{
  facilityId: Scalars['String'];
}>;


export type GetAmanoAccessGroupQuery = { __typename?: 'Query', getAmanoAccessGroup: Array<{ __typename?: 'AmanoAccessGroupObject', id: string, name: string }> };

export type ArCodeCoreFieldsFragment = { __typename?: 'ARCodeObject', id: string, title: string };

export type ArCodeFieldsFragment = { __typename?: 'ARCodeObject', active: boolean, propertyId?: string | null, id: string, title: string };

export type CreateArCodeMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateArCodeMutation = { __typename?: 'Mutation', createARCode: { __typename?: 'ARCodeObject', id: string } };

export type UpdateArCodeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateArCodeMutation = { __typename?: 'Mutation', updateARCode: { __typename?: 'ARCodeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type ToggleArCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleArCodeMutation = { __typename?: 'Mutation', toggleARCode: boolean };

export type RemoveArCodesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveArCodesMutation = { __typename?: 'Mutation', removeARCodes: boolean };

export type GetArCodesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetArCodesTableQuery = { __typename?: 'Query', getARCodes: Array<{ __typename?: 'ARCodeObject', index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetArCodesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetArCodesDropdownQuery = { __typename?: 'Query', getARCodes: Array<{ __typename?: 'ARCodeObject', active: boolean, id: string, title: string }> };

export type GetArCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetArCodeQuery = { __typename?: 'Query', getARCode: { __typename?: 'ARCodeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type SendForgottenPasswordMutationVariables = Exact<{
  data: ForgotPasswordInput;
}>;


export type SendForgottenPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type SendResetPasswordMutationVariables = Exact<{
  data: ResetPasswordInput;
}>;


export type SendResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type RequestLoginCodeMutationVariables = Exact<{
  data: RequestLoginCodeInput;
}>;


export type RequestLoginCodeMutation = { __typename?: 'Mutation', requestLoginCode: boolean };

export type SendMagicLinkQueryVariables = Exact<{
  data: MagicLoginInput;
}>;


export type SendMagicLinkQuery = { __typename?: 'Query', sendMagicLink: boolean };

export type ValidateMagicLoginQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ValidateMagicLoginQuery = { __typename?: 'Query', validateMagicLink: { __typename?: 'MagicLoginObject', email: string, portfolios: Array<{ __typename?: 'PortfolioModel', id: string, title: string, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, background?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type LoginQueryVariables = Exact<{
  data: LoginInput;
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'LoginObject', token?: string | null, twoFA?: { __typename?: 'TwoFAObject', list: Array<TwoFaTypeEnum>, userId: string } | null } };

export type MagicLoginQueryVariables = Exact<{
  data: MagicLoginAuthInput;
}>;


export type MagicLoginQuery = { __typename?: 'Query', magicLogin: string };

export type ValidateLoginCodeQueryVariables = Exact<{
  data: LoginCodeInput;
}>;


export type ValidateLoginCodeQuery = { __typename?: 'Query', validateLoginCode: { __typename?: 'LoginObject', token?: string | null } };

export type BroadcastingCoreFieldsFragment = { __typename?: 'BroadcastObject', id: string, subject: string, body?: string | null, email: boolean, emailBody?: string | null, sms: boolean, app: boolean, createdAt: any, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type SendBroadcastMutationVariables = Exact<{
  data: SendBroadcastInput;
}>;


export type SendBroadcastMutation = { __typename?: 'Mutation', sendBroadcast: { __typename?: 'BroadcastObject', id: string } };

export type GetBroadcastsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<BroadcastTypeEnum> | BroadcastTypeEnum>;
}>;


export type GetBroadcastsQuery = { __typename?: 'Query', getBroadcasts: { __typename?: 'GetBroadcastsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BroadcastObject', id: string, subject: string, body?: string | null, email: boolean, emailBody?: string | null, sms: boolean, app: boolean, createdAt: any, event?: { __typename?: 'EventObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetBroadcastQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBroadcastQuery = { __typename?: 'Query', getBroadcast: { __typename?: 'BroadcastObject', companyTypes?: Array<CompanyTypeEnum> | null, id: string, subject: string, body?: string | null, email: boolean, emailBody?: string | null, sms: boolean, app: boolean, createdAt: any, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, roles?: Array<{ __typename?: 'RoleObject', id: string, title: string }> | null, users?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, event?: { __typename?: 'EventObject', id: string, title: string } | null, attachments: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }>, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type GetBroadcastRecipientsQueryVariables = Exact<{
  broadcastId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetBroadcastRecipientsQuery = { __typename?: 'Query', getBroadcastRecipients: { __typename?: 'GetBroadcastRecipientsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BroadcastRecipientObject', id: string, createdAt: any, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, sms?: { __typename?: 'BroadcastRecipientSMSObject', status: BroadcastDeliveryStatus, message?: string | null } | null, email?: { __typename?: 'BroadcastRecipientEmailObject', status: BroadcastDeliveryStatus, message?: string | null } | null, app?: { __typename?: 'BroadcastRecipientNotificationObject', status: BroadcastDeliveryStatus, message?: string | null } | null }> } };

export type PredefinedBroadcastingFieldsFragment = { __typename?: 'PredefinedBroadcastObject', id: string, subject: string, body?: string | null, emailBody?: string | null };

export type CreatePredefinedBroadcastMutationVariables = Exact<{
  data: PredefinedBroadcastInput;
}>;


export type CreatePredefinedBroadcastMutation = { __typename?: 'Mutation', createPredefinedBroadcast: { __typename?: 'PredefinedBroadcastObject', id: string } };

export type UpdatePredefinedBroadcastMutationVariables = Exact<{
  id: Scalars['String'];
  data: PredefinedBroadcastInput;
}>;


export type UpdatePredefinedBroadcastMutation = { __typename?: 'Mutation', updatePredefinedBroadcast: { __typename?: 'PredefinedBroadcastObject', id: string, subject: string, body?: string | null, emailBody?: string | null } };

export type TogglePredefinedBroadcastMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePredefinedBroadcastMutation = { __typename?: 'Mutation', togglePredefinedBroadcast: boolean };

export type RemovePredefinedBroadcastsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePredefinedBroadcastsMutation = { __typename?: 'Mutation', removePredefinedBroadcasts: boolean };

export type GetPredefinedBroadcastsTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPredefinedBroadcastsTableQuery = { __typename?: 'Query', getPredefinedBroadcasts: { __typename?: 'GetPredefinedBroadcastsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PredefinedBroadcastObject', id: string, subject: string, index: number, active: boolean, createdAt: any }> } };

export type GetPredefinedBroadcastsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeBody: Scalars['Boolean'];
  includeEmailBody: Scalars['Boolean'];
}>;


export type GetPredefinedBroadcastsDropdownQuery = { __typename?: 'Query', getPredefinedBroadcasts: { __typename?: 'GetPredefinedBroadcastsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PredefinedBroadcastObject', id: string, subject: string, active: boolean, body?: string | null, emailBody?: string | null }> } };

export type GetPredefinedBroadcastQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPredefinedBroadcastQuery = { __typename?: 'Query', getPredefinedBroadcast: { __typename?: 'PredefinedBroadcastObject', id: string, subject: string, body?: string | null, emailBody?: string | null } };

export type BuildingCoreFieldsFragment = { __typename?: 'BuildingObject', id: string, title: string };

export type CreateBuildingMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateBuildingMutation = { __typename?: 'Mutation', createBuilding: { __typename?: 'BuildingObject', id: string } };

export type UpdateBuildingMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateBuildingMutation = { __typename?: 'Mutation', updateBuilding: { __typename?: 'BuildingObject', id: string, title: string } };

export type ToggleBuildingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleBuildingMutation = { __typename?: 'Mutation', toggleBuilding: boolean };

export type RemoveBuildingsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveBuildingsMutation = { __typename?: 'Mutation', removeBuildings: boolean };

export type GetBuildingsTableQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetBuildingsTableQuery = { __typename?: 'Query', getBuildings: { __typename?: 'GetBuildings', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BuildingObject', index: number, active: boolean, id: string, title: string }> } };

export type GetBuildingsDropdownQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetBuildingsDropdownQuery = { __typename?: 'Query', getBuildings: { __typename?: 'GetBuildings', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BuildingObject', active: boolean, id: string, title: string }> } };

export type GetBuildingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBuildingQuery = { __typename?: 'Query', getBuilding: { __typename?: 'BuildingObject', id: string, title: string } };

export type PopulateBuildingsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type PopulateBuildingsQuery = { __typename?: 'Query', populateBuildings: { __typename?: 'GetPopulatedBuildings', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BuildingPopulatedObject', id: string, title: string, active: boolean }> } };

export type GetUserBuildingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBuildingQuery = { __typename?: 'Query', getUserBuilding: { __typename?: 'UserBuildingObject', default: { __typename?: 'BuildingObject', id: string, title: string }, primary?: { __typename?: 'BuildingObject', id: string, title: string } | null } };

export type ChargeCodeCoreFieldsFragment = { __typename?: 'ChargeCodeObject', id: string, title: string };

export type ChargeCodeFieldsFragment = { __typename?: 'ChargeCodeObject', active: boolean, propertyId?: string | null, id: string, title: string };

export type CreateChargeCodeMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateChargeCodeMutation = { __typename?: 'Mutation', createChargeCode: { __typename?: 'ChargeCodeObject', id: string } };

export type UpdateChargeCodeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateChargeCodeMutation = { __typename?: 'Mutation', updateChargeCode: { __typename?: 'ChargeCodeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type ToggleChargeCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleChargeCodeMutation = { __typename?: 'Mutation', toggleChargeCode: boolean };

export type RemoveChargeCodesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveChargeCodesMutation = { __typename?: 'Mutation', removeChargeCodes: boolean };

export type GetChargeCodesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetChargeCodesTableQuery = { __typename?: 'Query', getChargeCodes: Array<{ __typename?: 'ChargeCodeObject', index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetChargeCodesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetChargeCodesDropdownQuery = { __typename?: 'Query', getChargeCodes: Array<{ __typename?: 'ChargeCodeObject', active: boolean, id: string, title: string }> };

export type GetChargeCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChargeCodeQuery = { __typename?: 'Query', getChargeCode: { __typename?: 'ChargeCodeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type ChargeFieldsFragment = { __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, invoiceId?: string | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null };

export type CreateChargeMutationVariables = Exact<{
  data: ChargeInput;
}>;


export type CreateChargeMutation = { __typename?: 'Mutation', createCharge: { __typename?: 'ChargeObject', id: string } };

export type UpdateChargeMutationVariables = Exact<{
  id: Scalars['String'];
  data: ChargeInputData;
  updateInvoice?: Scalars['Boolean'];
}>;


export type UpdateChargeMutation = { __typename?: 'Mutation', updateCharge: { __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, invoiceId?: string | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null } };

export type RemoveChargesMutationVariables = Exact<{
  data: DeleteRecordsInput;
  updateInvoice?: Scalars['Boolean'];
}>;


export type RemoveChargesMutation = { __typename?: 'Mutation', removeCharges: boolean };

export type RemoveChargeMutationVariables = Exact<{
  id: Scalars['String'];
  updateInvoice?: Scalars['Boolean'];
}>;


export type RemoveChargeMutation = { __typename?: 'Mutation', removeCharge: boolean };

export type GetChargeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChargeQuery = { __typename?: 'Query', getCharge: { __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, invoiceId?: string | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null } };

export type CoiCoreFieldsFragment = { __typename?: 'CoiObject', id: string, title: string };

export type CoiFieldsFragment = { __typename?: 'CoiObject', note?: string | null, contactEmails: Array<string>, status: CoiStatusEnum, expiration: string, validFrom: string, validTo: string, createdAt: any, id: string, title: string, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachment: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> };

export type CreateCoiMutationVariables = Exact<{
  data: CoiInput;
}>;


export type CreateCoiMutation = { __typename?: 'Mutation', createCoi: { __typename?: 'CoiObject', id: string } };

export type UpdateCoiMutationVariables = Exact<{
  id: Scalars['String'];
  data: CoiUpdateInput;
}>;


export type UpdateCoiMutation = { __typename?: 'Mutation', updateCoi: { __typename?: 'CoiObject', note?: string | null, contactEmails: Array<string>, status: CoiStatusEnum, expiration: string, validFrom: string, validTo: string, createdAt: any, id: string, title: string, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachment: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type BulkStatusCoisMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  status?: InputMaybe<CoiStatusEnum>;
}>;


export type BulkStatusCoisMutation = { __typename?: 'Mutation', bulkStatusCois: { __typename?: 'CoiBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'CoiObject', id: string, status: CoiStatusEnum }> | null } };

export type ArchiveCoisMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ArchiveCoisMutation = { __typename?: 'Mutation', archiveCois: boolean };

export type UnArchiveCoisMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnArchiveCoisMutation = { __typename?: 'Mutation', unArchiveCois: boolean };

export type RemoveCoiMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCoiMutation = { __typename?: 'Mutation', removeCoi: boolean };

export type GetCoisTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum> | CoiStatusEnum>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
  expiration?: InputMaybe<CoiExpirationEnum>;
}>;


export type GetCoisTableQuery = { __typename?: 'Query', getCois: { __typename?: 'GetCoiObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CoiObject', isArchived: boolean, status: CoiStatusEnum, expiration: string, note?: string | null, validFrom: string, validTo: string, createdAt: any, id: string, title: string, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetCoisDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum> | CoiStatusEnum>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
  expiration?: InputMaybe<CoiExpirationEnum>;
}>;


export type GetCoisDropdownQuery = { __typename?: 'Query', getCois: { __typename?: 'GetCoiObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CoiObject', id: string, title: string }> } };

export type GetCoiQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCoiQuery = { __typename?: 'Query', getCoi: { __typename?: 'CoiObject', note?: string | null, contactEmails: Array<string>, status: CoiStatusEnum, expiration: string, validFrom: string, validTo: string, createdAt: any, id: string, title: string, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachment: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type ExportCoisQueryVariables = Exact<{
  statuses?: InputMaybe<Array<CoiStatusEnum> | CoiStatusEnum>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
  expiration?: InputMaybe<CoiExpirationEnum>;
}>;


export type ExportCoisQuery = { __typename?: 'Query', exportCois: string };

export type CoiEmailCoreFieldsFragment = { __typename?: 'CoiEmailObject', id: string, title: string };

export type CoiEmailFieldsFragment = { __typename?: 'CoiEmailObject', email: string, emailSlug: string, contactEmails: Array<string>, status: CoiStatusEnum, allowUnknownSender: boolean, id: string, title: string, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateCoiEmailMutationVariables = Exact<{
  data: CoiEmailInput;
}>;


export type CreateCoiEmailMutation = { __typename?: 'Mutation', createCoiEmail: { __typename?: 'CoiEmailObject', id: string, email: string } };

export type UpdateCoiEmailMutationVariables = Exact<{
  id: Scalars['String'];
  data: CoiEmailInput;
}>;


export type UpdateCoiEmailMutation = { __typename?: 'Mutation', updateCoiEmail: { __typename?: 'CoiEmailObject', email: string, emailSlug: string, contactEmails: Array<string>, status: CoiStatusEnum, allowUnknownSender: boolean, id: string, title: string, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleCoiEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCoiEmailMutation = { __typename?: 'Mutation', toggleCoiEmail: boolean };

export type RemoveCoiEmailsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCoiEmailsMutation = { __typename?: 'Mutation', removeCoiEmails: boolean };

export type GetCoiEmailsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCoiEmailsQuery = { __typename?: 'Query', getCoiEmails: { __typename?: 'GetCoiEmailsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CoiEmailObject', email: string, index: number, active: boolean, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetCoiEmailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCoiEmailQuery = { __typename?: 'Query', getCoiEmail: { __typename?: 'CoiEmailObject', email: string, emailSlug: string, contactEmails: Array<string>, status: CoiStatusEnum, allowUnknownSender: boolean, id: string, title: string, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type CompanyCoreFieldsFragment = { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CompanyFieldsFragment = { __typename?: 'CompanyObject', index: number, taxCode?: string | null, vendorId?: string | null, phone?: string | null, createdAt?: any | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateCompanyMutationVariables = Exact<{
  data: CompanyPropertyCreateInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CompanyObject', id: string } };

export type AddCompanyToPropertyMutationVariables = Exact<{
  data: CompanyPropertyAddInput;
}>;


export type AddCompanyToPropertyMutation = { __typename?: 'Mutation', addCompanyToProperty: { __typename?: 'CompanyObject', id: string } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['String'];
  data: CompanyPropertyUpdateInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyObject', index: number, taxCode?: string | null, vendorId?: string | null, phone?: string | null, createdAt?: any | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateCompanyPhotoMutationVariables = Exact<{
  id: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
}>;


export type UpdateCompanyPhotoMutation = { __typename?: 'Mutation', updateCompanyPhoto: { __typename?: 'CompanyObject', id: string, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateCompanyAddressMutationVariables = Exact<{
  id: Scalars['String'];
  address?: InputMaybe<AddressInput>;
}>;


export type UpdateCompanyAddressMutation = { __typename?: 'Mutation', updateCompanyAddress: { __typename?: 'CompanyObject', id: string, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null } };

export type UpdateCompanyBillingMutationVariables = Exact<{
  id: Scalars['String'];
  billing: CompanyBillingInput;
}>;


export type UpdateCompanyBillingMutation = { __typename?: 'Mutation', updateCompanyBilling: { __typename?: 'CompanyObject', id: string, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null } };

export type ToggleCompanyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCompanyMutation = { __typename?: 'Mutation', toggleCompany: boolean };

export type RemoveCompaniesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCompaniesMutation = { __typename?: 'Mutation', removeCompanies: boolean };

export type GetCompaniesTableQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCompaniesTableQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', index: number, vendorId?: string | null, userCount: number, id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetCompaniesGeneaTableQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCompaniesGeneaTableQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', id: string, title: string, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, geneaTenant?: { __typename?: 'GeneaTenantObject', id: string, title: string } | null }> } };

export type GetCompaniesDropdownQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
  includeBilling: Scalars['Boolean'];
}>;


export type GetCompaniesDropdownQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type PopulateCompaniesQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type PopulateCompaniesQuery = { __typename?: 'Query', populateCompanies: { __typename?: 'GetPopulateCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PopulatedCompanyObject', id: string, title: string, active: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetOverlappingCompaniesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOverlappingCompaniesQuery = { __typename?: 'Query', getOverlappingCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetFilterableCompaniesQueryVariables = Exact<{
  location: FilterableCompanyLocationType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
}>;


export type GetFilterableCompaniesQuery = { __typename?: 'Query', getFilterableCompanies: { __typename?: 'GetFilterableCompanies', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'FilterableCompanyObject', id: string, title: string, active: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'CompanyObject', index: number, taxCode?: string | null, vendorId?: string | null, phone?: string | null, createdAt?: any | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type SearchCompaniesQueryVariables = Exact<{
  title: Scalars['String'];
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', searchCompanies: Array<{ __typename?: 'CompanySearchObject', id: string, title: string, type: CompanyTypeEnum, existInProperty: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> };

export type GetUserCompaniesQueryVariables = Exact<{
  userId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUserCompaniesQuery = { __typename?: 'Query', getUserCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUserCompanyQueryVariables = Exact<{
  userId: Scalars['String'];
  includeBilling: Scalars['Boolean'];
}>;


export type GetUserCompanyQuery = { __typename?: 'Query', getUserCompany: { __typename?: 'UserCompanyObject', default: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, primary?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, billing?: { __typename?: 'CompanyBillObject', email?: string | null, billTo?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ExportCompaniesQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportCompaniesQuery = { __typename?: 'Query', exportCompanies: string };

export type DealCategoryCoreFieldsFragment = { __typename?: 'DealCategoryObject', id: string, title: string };

export type DealCategoryFieldsFragment = { __typename?: 'DealCategoryObject', index: number, icon?: string | null, id: string, title: string };

export type CreateDealCategoryMutationVariables = Exact<{
  data: NewDealCategoryInput;
}>;


export type CreateDealCategoryMutation = { __typename?: 'Mutation', createDealCategory: { __typename?: 'DealCategoryObject', id: string } };

export type UpdateDealCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateDealCategoryInput;
}>;


export type UpdateDealCategoryMutation = { __typename?: 'Mutation', updateDealCategory: { __typename?: 'DealCategoryObject', index: number, icon?: string | null, id: string, title: string } };

export type RemoveDealCategoriesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveDealCategoriesMutation = { __typename?: 'Mutation', removeDealCategories: boolean };

export type ReorderDealCategoriesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderDealCategoriesMutation = { __typename?: 'Mutation', reorderDealCategories: boolean };

export type GetDealCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDealCategoriesQuery = { __typename?: 'Query', getDealCategories: Array<{ __typename?: 'DealCategoryObject', order?: number | null, index: number, icon?: string | null, id: string, title: string }> };

export type GetDealCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDealCategoryQuery = { __typename?: 'Query', getDealCategory: { __typename?: 'DealCategoryObject', index: number, icon?: string | null, id: string, title: string } };

export type ExportDealCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportDealCategoriesQuery = { __typename?: 'Query', exportDealCategories: string };

export type DealFieldsFragment = { __typename?: 'DealObject', id: string, index: number, title: string, active: boolean, code?: string | null, description?: string | null, discount: string, link?: string | null, popupDescription?: string | null, validUntil?: any | null, website: string, category: { __typename?: 'DealCategoryObject', id: string, title: string }, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateDealMutationVariables = Exact<{
  data: DealInput;
}>;


export type CreateDealMutation = { __typename?: 'Mutation', createDeal: { __typename?: 'DealObject', id: string } };

export type UpdateDealMutationVariables = Exact<{
  id: Scalars['String'];
  data: DealUpdateInput;
}>;


export type UpdateDealMutation = { __typename?: 'Mutation', updateDeal: { __typename?: 'DealObject', id: string, index: number, title: string, active: boolean, code?: string | null, description?: string | null, discount: string, link?: string | null, popupDescription?: string | null, validUntil?: any | null, website: string, category: { __typename?: 'DealCategoryObject', id: string, title: string }, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type RemoveDealsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveDealsMutation = { __typename?: 'Mutation', removeDeals: boolean };

export type ToggleDealMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleDealMutation = { __typename?: 'Mutation', toggleDeal: boolean };

export type RedeemDealMutationVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type RedeemDealMutation = { __typename?: 'Mutation', redeemDeal: boolean };

export type GetDealsPublicQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expired?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDealsPublicQuery = { __typename?: 'Query', getDeals: { __typename?: 'GetDealsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'DealObject', id: string, title: string, active: boolean, description?: string | null, discount: string, redemptionCount: number, redemptionUniqCount: number, validUntil?: any | null, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetDealsAdminQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDealsAdminQuery = { __typename?: 'Query', getDeals: { __typename?: 'GetDealsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'DealObject', id: string, index: number, title: string, active: boolean, discount: string, redemptionCount: number, validUntil?: any | null, category: { __typename?: 'DealCategoryObject', id: string, title: string } }> } };

export type GetDealQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDealQuery = { __typename?: 'Query', getDeal: { __typename?: 'DealObject', id: string, index: number, title: string, active: boolean, code?: string | null, description?: string | null, discount: string, link?: string | null, popupDescription?: string | null, validUntil?: any | null, website: string, category: { __typename?: 'DealCategoryObject', id: string, title: string }, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type CouponCoreFieldsFragment = { __typename?: 'CouponObject', id: string, title: string };

export type CouponFieldsFragment = { __typename?: 'CouponObject', discountAmount: number, discountType: DiscountTypeEnum, duration: DurationEnum, durationInMonths?: number | null, id: string, title: string, products?: Array<{ __typename?: 'CouponProductsListObject', id: string, title: string }> | null };

export type CreateCouponMutationVariables = Exact<{
  data: CouponInput;
}>;


export type CreateCouponMutation = { __typename?: 'Mutation', createCoupon: { __typename?: 'CouponObject', id: string } };

export type UpdateCouponMutationVariables = Exact<{
  id: Scalars['String'];
  data: CouponUpdateInput;
}>;


export type UpdateCouponMutation = { __typename?: 'Mutation', updateCoupon: { __typename?: 'CouponObject', discountAmount: number, discountType: DiscountTypeEnum, duration: DurationEnum, durationInMonths?: number | null, id: string, title: string, products?: Array<{ __typename?: 'CouponProductsListObject', id: string, title: string }> | null } };

export type RemoveCouponsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCouponsMutation = { __typename?: 'Mutation', removeCoupons: boolean };

export type GetCouponsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouponsListQuery = { __typename?: 'Query', getCouponsList: Array<{ __typename?: 'CouponListObject', id: string, title: string, createdAt: any, discountAmount: number, discountType: DiscountTypeEnum, duration: DurationEnum }> };

export type GetCouponQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCouponQuery = { __typename?: 'Query', getCoupon: { __typename?: 'CouponObject', discountAmount: number, discountType: DiscountTypeEnum, duration: DurationEnum, durationInMonths?: number | null, id: string, title: string, products?: Array<{ __typename?: 'CouponProductsListObject', id: string, title: string }> | null } };

export type CustomFieldFieldsFragment = { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null };

export type RecordCustomFieldFragment = { __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } };

export type CreateCustomFieldMutationVariables = Exact<{
  data: CustomFieldCreateInput;
}>;


export type CreateCustomFieldMutation = { __typename?: 'Mutation', createCustomField: { __typename?: 'CustomFieldObject', id: string } };

export type UpdateCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
  data: CustomFieldUpdateInput;
}>;


export type UpdateCustomFieldMutation = { __typename?: 'Mutation', updateCustomField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } };

export type ReorderCustomFieldsMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderCustomFieldsMutation = { __typename?: 'Mutation', reorderCustomFields: boolean };

export type ToggleCustomFieldMutationVariables = Exact<{
  data: CustomFieldToggleInput;
}>;


export type ToggleCustomFieldMutation = { __typename?: 'Mutation', toggleCustomField: boolean };

export type RemoveCustomFieldsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCustomFieldsMutation = { __typename?: 'Mutation', removeCustomFields: boolean };

export type GetAdminCustomFieldsTableQueryVariables = Exact<{
  recordType?: InputMaybe<CustomFieldRecordType>;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminCustomFieldsTableQuery = { __typename?: 'Query', getCustomFields: Array<{ __typename?: 'CustomFieldObject', id: string, index: number, key: string, label: string, type: CustomFieldType, active: boolean }> };

export type GetFeatureCustomFieldsQueryVariables = Exact<{
  recordType: CustomFieldRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFeatureCustomFieldsQuery = { __typename?: 'Query', getCustomFields: Array<{ __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null }> };

export type GetCustomFieldQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCustomFieldQuery = { __typename?: 'Query', getCustomField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } };

export type DeviceCoreFieldsFragment = { __typename?: 'DeviceModel', id: string, title: string };

export type DeviceFieldsFragment = { __typename?: 'DeviceModel', appVersion?: string | null, deviceId?: string | null, isActive: boolean, isPrimary: boolean, isPaired: boolean, osVersion?: string | null, id: string, title: string, printer: { __typename?: 'PrinterModel', id: string, title: string } };

export type CreateDeviceMutationVariables = Exact<{
  data: DeviceInput;
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createDevice: { __typename?: 'DeviceModel', id: string } };

export type UpdateDeviceMutationVariables = Exact<{
  id: Scalars['String'];
  data: DeviceUpdateInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice: { __typename?: 'DeviceModel', appVersion?: string | null, deviceId?: string | null, isActive: boolean, isPrimary: boolean, isPaired: boolean, osVersion?: string | null, id: string, title: string, printer: { __typename?: 'PrinterModel', id: string, title: string } } };

export type SetPrimaryDeviceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetPrimaryDeviceMutation = { __typename?: 'Mutation', setPrimaryDevice: { __typename?: 'DeviceModel', appVersion?: string | null, deviceId?: string | null, isActive: boolean, isPrimary: boolean, isPaired: boolean, osVersion?: string | null, id: string, title: string, printer: { __typename?: 'PrinterModel', id: string, title: string } } };

export type ToggleDeviceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleDeviceMutation = { __typename?: 'Mutation', toggleDevice: boolean };

export type DeleteDevicesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type DeleteDevicesMutation = { __typename?: 'Mutation', deleteDevices: boolean };

export type GetDevicesQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDevicesQuery = { __typename?: 'Query', getDevices: Array<{ __typename?: 'DeviceModel', appVersion?: string | null, deviceId?: string | null, isActive: boolean, isPrimary: boolean, isPaired: boolean, osVersion?: string | null, id: string, title: string, printer: { __typename?: 'PrinterModel', id: string, title: string } }> };

export type GetDeviceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDeviceQuery = { __typename?: 'Query', getDevice: { __typename?: 'DeviceModel', appVersion?: string | null, deviceId?: string | null, isActive: boolean, isPrimary: boolean, isPaired: boolean, osVersion?: string | null, id: string, title: string, printer: { __typename?: 'PrinterModel', id: string, title: string } } };

export type GetDeviceQrCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDeviceQrCodeQuery = { __typename?: 'Query', getDeviceQrCode: string };

export type ExportDevicesQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportDevicesQuery = { __typename?: 'Query', exportDevices: string };

export type GetDeviceLogsQueryVariables = Exact<{
  deviceId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetDeviceLogsQuery = { __typename?: 'Query', getDeviceLogs: { __typename?: 'GetDeviceLogs', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'DeviceLogModel', id: string, location?: string | null, message: string, type: DeviceLogType }> } };

export type EmailTemplateFieldsFragment = { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean };

export type UpdateEmailTemplateMutationVariables = Exact<{
  data: UpdateEmailTemplateInput;
  type: EmailTemplateType;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutation', updateEmailTemplate: boolean };

export type ToggleEmailTemplateMutationVariables = Exact<{
  data: ToggleEmailTemplateInput;
}>;


export type ToggleEmailTemplateMutation = { __typename?: 'Mutation', toggleEmailTemplate: boolean };

export type ToggleCustomTemplateMutationVariables = Exact<{
  type: EmailTemplateType;
}>;


export type ToggleCustomTemplateMutation = { __typename?: 'Mutation', toggleCustomTemplate: { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean } };

export type SendTestMailMutationVariables = Exact<{
  data: SendTestMailInput;
}>;


export type SendTestMailMutation = { __typename?: 'Mutation', sendTestMail: boolean };

export type GetEmailTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', getEmailTemplates: Array<{ __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, custom: boolean }> };

export type GetEmailTemplateQueryVariables = Exact<{
  type: EmailTemplateType;
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', getEmailTemplate: { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean } };

export type EmployeeCoreFieldsFragment = { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type EmployeeFieldsFragment = { __typename?: 'EmployeeObject', index: number, active: boolean, id: string, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type CreateEmployeeMutationVariables = Exact<{
  data: EmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'EmployeeObject', id: string } };

export type UpdateEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
  data: EmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'EmployeeObject', index: number, active: boolean, id: string, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type ToggleEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleEmployeeMutation = { __typename?: 'Mutation', toggleEmployee: boolean };

export type RemoveEmployeesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveEmployeesMutation = { __typename?: 'Mutation', removeEmployees: boolean };

export type GetEmployeesTableQueryVariables = Exact<{
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeesTableQuery = { __typename?: 'Query', getEmployees: { __typename?: 'GetEmployees', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EmployeeObject', index: number, active: boolean, id: string, laborRate?: { __typename?: 'LaborRateObject', rate: number, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetEmployeesDropdownQueryVariables = Exact<{
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeLaborRate: Scalars['Boolean'];
  includeLaborRateMarkup: Scalars['Boolean'];
  includeLaborRateGLAccount: Scalars['Boolean'];
  includeLaborRateARCode: Scalars['Boolean'];
  includeLaborRateChargeCode: Scalars['Boolean'];
  includeTax: Scalars['Boolean'];
}>;


export type GetEmployeesDropdownQuery = { __typename?: 'Query', getEmployees: { __typename?: 'GetEmployees', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EmployeeObject', active: boolean, id: string, laborRate?: { __typename?: 'LaborRateObject', rate: number, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } | null, tax?: { __typename?: 'TaxObject', amount: number, id: string, title: string } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetPublicEmployeesQueryVariables = Exact<{
  propertyId: Scalars['String'];
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
}>;


export type GetPublicEmployeesQuery = { __typename?: 'Query', getPublicEmployees: { __typename?: 'GetEmployees', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee: { __typename?: 'EmployeeObject', index: number, active: boolean, id: string, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type FloorCoreFieldsFragment = { __typename?: 'FloorObject', id: string, title: string };

export type FloorFieldsFragment = { __typename?: 'FloorObject', index: number, size: number, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateFloorMutationVariables = Exact<{
  data: FloorCreateInput;
}>;


export type CreateFloorMutation = { __typename?: 'Mutation', createFloor: { __typename?: 'FloorObject', id: string } };

export type UpdateFloorMutationVariables = Exact<{
  id: Scalars['String'];
  data: FloorUpdateInput;
}>;


export type UpdateFloorMutation = { __typename?: 'Mutation', updateFloor: { __typename?: 'FloorObject', index: number, size: number, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type RemoveFloorsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveFloorsMutation = { __typename?: 'Mutation', removeFloors: boolean };

export type ReorderTableFloorsMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderTableFloorsMutation = { __typename?: 'Mutation', reorderTableFloors: boolean };

export type ReorderFloorsMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderFloorsMutation = { __typename?: 'Mutation', reorderFloors: boolean };

export type GetFloorsTableQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFloorsTableQuery = { __typename?: 'Query', getFloors: Array<{ __typename?: 'FloorObject', index: number, size: number, order: number, id: string, title: string }> };

export type GetFloorsOverviewQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetFloorsOverviewQuery = { __typename?: 'Query', getFloors: Array<{ __typename?: 'FloorObject', id: string, title: string, suites?: Array<{ __typename?: 'SuiteObject', id: string, title: string }> | null }> };

export type GetFloorsDropdownQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeSize: Scalars['Boolean'];
}>;


export type GetFloorsDropdownQuery = { __typename?: 'Query', getFloors: Array<{ __typename?: 'FloorObject', size?: number, id: string, title: string }> };

export type GetPublicFloorsQueryVariables = Exact<{
  propertyId: Scalars['String'];
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search: Scalars['String'];
}>;


export type GetPublicFloorsQuery = { __typename?: 'Query', getPublicFloors: Array<{ __typename?: 'FloorObject', id: string, title: string }> };

export type GetFloorQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFloorQuery = { __typename?: 'Query', getFloor: { __typename?: 'FloorObject', index: number, size: number, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ExportFloorsQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportFloorsQuery = { __typename?: 'Query', exportFloors: string };

export type GeneaDoorsFieldsFragment = { __typename?: 'GeneaDoorObject', id: string, name: string, schedule?: string | null, isLocked?: boolean | null, isOnline?: boolean | null, controllerId?: string | null, controllerIsOnline?: string | null, controllerName?: string | null };

export type GeneaTenantCoreFieldsFragment = { __typename?: 'GeneaTenantObject', id: string, title: string };

export type GeneaTenantFieldsFragment = { __typename?: 'GeneaTenantObject', status?: string | null, type?: string | null, id: string, title: string };

export type GeneaUserCardFieldsFragment = { __typename?: 'GeneaUserCardObject', activationTime: any, badgeTypeId: string, deactivationTime?: any | null, id: string, lastUsedAt?: any | null, number: number, status: GeneaUserCardStatusEnum, type: GeneaUserCardTypeEnum };

export type GeneaBadgeTypeFieldsFragment = { __typename?: 'GeneaBadgeTypesObject', description?: string | null, id: string, isDefaultBadgeType: boolean, name: string };

export type GeneaAccessGroupFieldsFragment = { __typename?: 'GeneaAccessGroupObject', id: string, title: string };

export type GeneaSettingsFieldsFragment = { __typename?: 'GeneaSettingObject', email?: string | null, badgeType?: { __typename?: 'GeneaBadgeTypesObject', id: string, name: string } | null };

export type ToggleGeneaDoorsMutationVariables = Exact<{
  data: ToggleDoorInput;
}>;


export type ToggleGeneaDoorsMutation = { __typename?: 'Mutation', toggleGeneaDoors: boolean };

export type UpdateGeneaTenantLinkMutationVariables = Exact<{
  data: UpdateGeneaTenantLinkInput;
}>;


export type UpdateGeneaTenantLinkMutation = { __typename?: 'Mutation', updateGeneaTenantLink: { __typename?: 'CompanyObject', id: string, geneaTenant?: { __typename?: 'GeneaTenantObject', id: string, title: string } | null } };

export type UpdateGeneaProductAccessLinkMutationVariables = Exact<{
  data: GeneaAccessGroupProductLinkInput;
}>;


export type UpdateGeneaProductAccessLinkMutation = { __typename?: 'Mutation', updateGeneaProductAccessLink: { __typename?: 'ProductItemObject', id: string, geneaAccessGroup?: { __typename?: 'GeneaAccessGroupObject', id: string, title: string } | null } };

export type CreateGeneaUserCardMutationVariables = Exact<{
  data: CreateGeneaUserCardInput;
}>;


export type CreateGeneaUserCardMutation = { __typename?: 'Mutation', createGeneaUserCard: { __typename?: 'GeneaUserCardObject', activationTime: any, badgeTypeId: string, deactivationTime?: any | null, id: string, lastUsedAt?: any | null, number: number, status: GeneaUserCardStatusEnum, type: GeneaUserCardTypeEnum } };

export type DeleteGeneaUserCardMutationVariables = Exact<{
  cardId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type DeleteGeneaUserCardMutation = { __typename?: 'Mutation', deleteGeneaUserCard: boolean };

export type UpdateGeneaUserAvatarMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UpdateGeneaUserAvatarMutation = { __typename?: 'Mutation', updateGeneaUserAvatar: boolean };

export type UpdateGeneaSettingsMutationVariables = Exact<{
  data: GeneaSettingInput;
}>;


export type UpdateGeneaSettingsMutation = { __typename?: 'Mutation', updateGeneaSettings: { __typename?: 'GeneaSettingObject', email?: string | null, badgeType?: { __typename?: 'GeneaBadgeTypesObject', id: string, name: string } | null } };

export type GetGeneaDoorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneaDoorsQuery = { __typename?: 'Query', getGeneaDoors: Array<{ __typename?: 'GeneaDoorObject', id: string, name: string, schedule?: string | null, isLocked?: boolean | null, isOnline?: boolean | null, controllerId?: string | null, controllerIsOnline?: string | null, controllerName?: string | null }> };

export type GetGeneaTenantsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGeneaTenantsQuery = { __typename?: 'Query', getGeneaTenants: { __typename?: 'GetGeneaTenants', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'GeneaTenantObject', status?: string | null, type?: string | null, id: string, title: string }> } };

export type GetGeneaUserCardsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetGeneaUserCardsQuery = { __typename?: 'Query', getGeneaUserCards: Array<{ __typename?: 'GeneaUserCardObject', activationTime: any, badgeTypeId: string, deactivationTime?: any | null, id: string, lastUsedAt?: any | null, number: number, status: GeneaUserCardStatusEnum, type: GeneaUserCardTypeEnum }> };

export type GetGeneaBadgeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneaBadgeTypesQuery = { __typename?: 'Query', getGeneaBadgeTypes: Array<{ __typename?: 'GeneaBadgeTypesObject', description?: string | null, id: string, isDefaultBadgeType: boolean, name: string }> };

export type GetGeneaAccessGroupsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGeneaAccessGroupsQuery = { __typename?: 'Query', getGeneaAccessGroups: { __typename?: 'GetGeneaAccessGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'GeneaAccessGroupObject', id: string, title: string }> } };

export type GetGeneaSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneaSettingsQuery = { __typename?: 'Query', getGeneaSettings: { __typename?: 'GeneaSettingObject', email?: string | null, badgeType?: { __typename?: 'GeneaBadgeTypesObject', id: string, name: string } | null } };

export type GlAccountCoreFieldsFragment = { __typename?: 'GLAccountObject', id: string, title: string };

export type GlAccountFieldsFragment = { __typename?: 'GLAccountObject', active: boolean, propertyId?: string | null, id: string, title: string };

export type CreateGlAccountMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateGlAccountMutation = { __typename?: 'Mutation', createGLAccount: { __typename?: 'GLAccountObject', id: string } };

export type UpdateGlAccountMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateGlAccountMutation = { __typename?: 'Mutation', updateGLAccount: { __typename?: 'GLAccountObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type ToggleGlAccountMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleGlAccountMutation = { __typename?: 'Mutation', toggleGLAccount: boolean };

export type RemoveGlAccountsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveGlAccountsMutation = { __typename?: 'Mutation', removeGLAccounts: boolean };

export type GetGlAccountsTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGlAccountsTableQuery = { __typename?: 'Query', getGLAccounts: Array<{ __typename?: 'GLAccountObject', index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetGlAccountsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGlAccountsDropdownQuery = { __typename?: 'Query', getGLAccounts: Array<{ __typename?: 'GLAccountObject', active: boolean, id: string, title: string }> };

export type GetGlAccountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGlAccountQuery = { __typename?: 'Query', getGLAccount: { __typename?: 'GLAccountObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type SearchFeatureFieldsFragment = { __typename?: 'FeatureObject', id: SearchFeatureEnum, title: string };

export type SearchResultFieldsFragment = { __typename?: 'SearchResultObject', id: string, index?: number | null, title: string, status: { __typename?: 'ObjectStatus', title: string, color?: string | null }, feature: { __typename?: 'FeatureObject', id: SearchFeatureEnum, title: string }, additionalData?: Array<{ __typename?: 'ObjectAdds', key: FieldKeyEnum, title: string, html: boolean }> | null };

export type StoreRecentSearchMutationVariables = Exact<{
  data: SearchRecentInput;
}>;


export type StoreRecentSearchMutation = { __typename?: 'Mutation', storeRecentSearch: boolean };

export type GetSearchFeaturesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetSearchFeaturesQuery = { __typename?: 'Query', getSearchFeatures: Array<{ __typename?: 'FeatureObject', id: SearchFeatureEnum, title: string }> };

export type GetSearchFeatureFiltersQueryVariables = Exact<{
  feature: SearchFeatureEnum;
}>;


export type GetSearchFeatureFiltersQuery = { __typename?: 'Query', getSearchFeatureFilters: Array<{ __typename?: 'SearchFilterObject', key: string, description: string }> };

export type GetSearchRecentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchRecentQuery = { __typename?: 'Query', getSearchRecent: Array<{ __typename?: 'SearchResultObject', id: string, index?: number | null, title: string, status: { __typename?: 'ObjectStatus', title: string, color?: string | null }, feature: { __typename?: 'FeatureObject', id: SearchFeatureEnum, title: string }, additionalData?: Array<{ __typename?: 'ObjectAdds', key: FieldKeyEnum, title: string, html: boolean }> | null }> };

export type SearchFeatureQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  feature: SearchFeatureEnum;
}>;


export type SearchFeatureQuery = { __typename?: 'Query', searchFeature: { __typename?: 'SearchResults', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SearchResultObject', id: string, index?: number | null, title: string, status: { __typename?: 'ObjectStatus', title: string, color?: string | null }, feature: { __typename?: 'FeatureObject', id: SearchFeatureEnum, title: string }, additionalData?: Array<{ __typename?: 'ObjectAdds', key: FieldKeyEnum, title: string, html: boolean }> | null }> } };

export type GuestVisitCoreFieldsFragment = { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> };

export type GuestFieldsFragment = { __typename?: 'GuestModel', id: string, companyName?: string | null, email?: string | null, firstName: string, code: number, lastName: string, status: GuestStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type StoreGuestsMutationVariables = Exact<{
  data: StoreGuestsDto;
}>;


export type StoreGuestsMutation = { __typename?: 'Mutation', storeGuests: boolean };

export type UpdateGuestVisitMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateGuestDto;
}>;


export type UpdateGuestVisitMutation = { __typename?: 'Mutation', updateGuestVisit: { __typename?: 'GuestModel', id: string, companyName?: string | null, email?: string | null, firstName: string, code: number, lastName: string, status: GuestStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type UploadGuestCsvMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type UploadGuestCsvMutation = { __typename?: 'Mutation', uploadGuestCsv: Array<{ __typename?: 'GuestCsvObject', companyName?: string | null, email: string, firstName: string, lastName: string, errors?: Array<{ __typename?: 'GuestCsvErrorsObject', field: string, message: string }> | null }> };

export type BulkStatusGuestsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  status: GuestStatusEnum;
}>;


export type BulkStatusGuestsMutation = { __typename?: 'Mutation', bulkStatusGuests: { __typename?: 'GuestBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'GuestModel', id: string, status: GuestStatusEnum }> | null } };

export type GuestWebCheckInMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GuestWebCheckInMutation = { __typename?: 'Mutation', guestWebCheckIn: { __typename?: 'GuestActionObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'GuestModel', id: string, visit: { __typename?: 'GuestVisitModel', id: string, checkInDates?: Array<string> | null } }> | null } };

export type PrintGuestBadgeMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type PrintGuestBadgeMutation = { __typename?: 'Mutation', printGuestBadge: { __typename?: 'GuestPrintActionObject', notification: boolean, errorCount: number, errorMessages?: Array<string> | null, successCount: number } };

export type ResendGuestEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendGuestEmailMutation = { __typename?: 'Mutation', resendGuestEmail: boolean };

export type NotifyGuestMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
}>;


export type NotifyGuestMutation = { __typename?: 'Mutation', notifyGuest: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> };

export type DeleteGuestAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteGuestAttachmentMutation = { __typename?: 'Mutation', deleteGuestAttachment: boolean };

export type GetGuestsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<GuestStatusEnum> | GuestStatusEnum>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hostIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetGuestsQuery = { __typename?: 'Query', getGuests: { __typename?: 'GetGuestsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'GuestModel', id: string, companyName?: string | null, firstName: string, code: number, lastName: string, status: GuestStatusEnum, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> } }> } };

export type GetGuestQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGuestQuery = { __typename?: 'Query', getGuest: { __typename?: 'GuestModel', id: string, companyName?: string | null, email?: string | null, firstName: string, code: number, lastName: string, status: GuestStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetGuestPrintQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGuestPrintQuery = { __typename?: 'Query', getGuest: { __typename?: 'GuestModel', id: string, code: number, companyName?: string | null, firstName: string, lastName: string, status: GuestStatusEnum, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'GuestVisitModel', id: string, type: GuestVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, notes?: string | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'GuestVisitDateObject', date: string }> } } };

export type GetGuestQrCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGuestQrCodeQuery = { __typename?: 'Query', getGuestQrCode?: string | null };

export type ExportGuestsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<GuestStatusEnum> | GuestStatusEnum>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hostIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportGuestsQuery = { __typename?: 'Query', exportGuests: string };

export type GuestSettingsFieldsFragment = { __typename?: 'GuestSettingsObject', printQRCode?: boolean | null, julianDate?: boolean | null, badgeLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type UpdateGuestSettingsMutationVariables = Exact<{
  data: GuestSettingsInput;
}>;


export type UpdateGuestSettingsMutation = { __typename?: 'Mutation', updateGuestSettings: { __typename?: 'GuestSettingsObject', printQRCode?: boolean | null, julianDate?: boolean | null, badgeLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type GetGuestSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGuestSettingsQuery = { __typename?: 'Query', getGuestSettings: { __typename?: 'GuestSettingsObject', printQRCode?: boolean | null, julianDate?: boolean | null, badgeLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ImportErrorFieldsFragment = { __typename?: 'ImportErrorObject', error: string, key: string };

export type ImportUserFieldsFragment = { __typename?: 'ImportUserObject', email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, phone?: string | null, fullAccessBuildings: boolean, fullAccessCompanies: boolean, buildings?: Array<{ __typename?: 'BuildingObject', id: string, title: string }> | null, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, role?: { __typename?: 'RoleObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportCompanyFieldsFragment = { __typename?: 'ImportCompanyObject', title?: string | null, taxCode?: string | null, phone?: string | null, vendorId?: string | null, geneaId?: string | null, type?: CompanyTypeEnum | null, active?: boolean | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportFloorFieldsFragment = { __typename?: 'ImportFloorObject', title?: string | null, size?: number | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportSuiteFieldsFragment = { __typename?: 'ImportSuiteObject', title?: string | null, type?: SuiteType | null, size?: number | null, isPublic?: boolean | null, bomaSize?: number | null, color?: string | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportEquipmentCategoryFieldsFragment = { __typename?: 'ImportEquipmentCategoryObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportEquipmentFieldsFragment = { __typename?: 'ImportEquipmentObject', title?: string | null, assetTag?: string | null, details?: string | null, manufacturer?: string | null, serialNumber?: string | null, specificLocation?: string | null, attachments?: Array<string> | null, active?: boolean | null, category?: { __typename?: 'EquipmentCategoryModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportProcedureFieldsFragment = { __typename?: 'ImportProcedureObject', title?: string | null, estimatedLabor?: number | null, notes?: string | null, sections?: Array<{ __typename?: 'ImportProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ImportProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportScheduleFieldsFragment = { __typename?: 'ImportScheduleObject', title?: string | null, notes?: string | null, splitEquipmentOnTask?: boolean | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, procedures?: Array<{ __typename?: 'ProcedureObject', id: string, title: string }> | null, equipment?: Array<{ __typename?: 'EquipmentModel', id: string, title: string }> | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportMaterialGroupFieldsFragment = { __typename?: 'ImportMaterialGroupObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportMaterialFieldsFragment = { __typename?: 'ImportMaterialObject', title?: string | null, price?: number | null, description?: string | null, active?: boolean | null, group?: { __typename?: 'MaterialGroupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportWorkOrderFieldsFragment = { __typename?: 'ImportWorkOrderObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, dueDate?: string | null, closedAt?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportWorkOrderTemplateFieldsFragment = { __typename?: 'ImportWOTObject', description?: string | null, recordStatus?: RRuleStatuses | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportIncidentFieldsFragment = { __typename?: 'ImportIncidentObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportCoiFieldsFragment = { __typename?: 'ImportCOIObject', title?: string | null, status?: CoiStatusEnum | null, note?: string | null, validFrom?: string | null, validTo?: string | null, attachment?: string | null, contactEmails?: Array<string> | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null };

export type ImportParseUsersMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseUsersMutation = { __typename?: 'Mutation', importParseUsers: Array<{ __typename?: 'ImportUserObject', email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, phone?: string | null, fullAccessBuildings: boolean, fullAccessCompanies: boolean, buildings?: Array<{ __typename?: 'BuildingObject', id: string, title: string }> | null, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, role?: { __typename?: 'RoleObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreUsersMutationVariables = Exact<{
  data: Array<ImportUsersInput> | ImportUsersInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreUsersMutation = { __typename?: 'Mutation', importStoreUsers?: Array<{ __typename?: 'ImportUserObject', email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, phone?: string | null, fullAccessBuildings: boolean, fullAccessCompanies: boolean, buildings?: Array<{ __typename?: 'BuildingObject', id: string, title: string }> | null, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, role?: { __typename?: 'RoleObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseCompaniesMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseCompaniesMutation = { __typename?: 'Mutation', importParseCompanies: Array<{ __typename?: 'ImportCompanyObject', title?: string | null, taxCode?: string | null, phone?: string | null, vendorId?: string | null, geneaId?: string | null, type?: CompanyTypeEnum | null, active?: boolean | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreCompaniesMutationVariables = Exact<{
  data: Array<ImportCompaniesInput> | ImportCompaniesInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreCompaniesMutation = { __typename?: 'Mutation', importStoreCompanies?: Array<{ __typename?: 'ImportCompanyObject', title?: string | null, taxCode?: string | null, phone?: string | null, vendorId?: string | null, geneaId?: string | null, type?: CompanyTypeEnum | null, active?: boolean | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseFloorsMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseFloorsMutation = { __typename?: 'Mutation', importParseFloors: Array<{ __typename?: 'ImportFloorObject', title?: string | null, size?: number | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreFloorsMutationVariables = Exact<{
  data: Array<ImportFloorInput> | ImportFloorInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreFloorsMutation = { __typename?: 'Mutation', importStoreFloors?: Array<{ __typename?: 'ImportFloorObject', title?: string | null, size?: number | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseSuitesMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseSuitesMutation = { __typename?: 'Mutation', importParseSuites: Array<{ __typename?: 'ImportSuiteObject', title?: string | null, type?: SuiteType | null, size?: number | null, isPublic?: boolean | null, bomaSize?: number | null, color?: string | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreSuitesMutationVariables = Exact<{
  data: Array<ImportSuiteInput> | ImportSuiteInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreSuitesMutation = { __typename?: 'Mutation', importStoreSuites?: Array<{ __typename?: 'ImportSuiteObject', title?: string | null, type?: SuiteType | null, size?: number | null, isPublic?: boolean | null, bomaSize?: number | null, color?: string | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseEquipmentCategoriesMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseEquipmentCategoriesMutation = { __typename?: 'Mutation', importParseEquipmentCategories: Array<{ __typename?: 'ImportEquipmentCategoryObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreEquipmentCategoriesMutationVariables = Exact<{
  data: Array<ImportEquipmentCategoryInput> | ImportEquipmentCategoryInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreEquipmentCategoriesMutation = { __typename?: 'Mutation', importStoreEquipmentCategories?: Array<{ __typename?: 'ImportEquipmentCategoryObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseEquipmentMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseEquipmentMutation = { __typename?: 'Mutation', importParseEquipment: Array<{ __typename?: 'ImportEquipmentObject', title?: string | null, assetTag?: string | null, details?: string | null, manufacturer?: string | null, serialNumber?: string | null, specificLocation?: string | null, attachments?: Array<string> | null, active?: boolean | null, category?: { __typename?: 'EquipmentCategoryModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreEquipmentMutationVariables = Exact<{
  data: Array<ImportEquipmentInput> | ImportEquipmentInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreEquipmentMutation = { __typename?: 'Mutation', importStoreEquipment?: Array<{ __typename?: 'ImportEquipmentObject', title?: string | null, assetTag?: string | null, details?: string | null, manufacturer?: string | null, serialNumber?: string | null, specificLocation?: string | null, attachments?: Array<string> | null, active?: boolean | null, category?: { __typename?: 'EquipmentCategoryModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseProceduresMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseProceduresMutation = { __typename?: 'Mutation', importParseProcedures: Array<{ __typename?: 'ImportProcedureObject', title?: string | null, estimatedLabor?: number | null, notes?: string | null, sections?: Array<{ __typename?: 'ImportProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ImportProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreProceduresMutationVariables = Exact<{
  data: Array<ImportProcedureInput> | ImportProcedureInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreProceduresMutation = { __typename?: 'Mutation', importStoreProcedures?: Array<{ __typename?: 'ImportProcedureObject', title?: string | null, estimatedLabor?: number | null, notes?: string | null, sections?: Array<{ __typename?: 'ImportProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ImportProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseSchedulesMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseSchedulesMutation = { __typename?: 'Mutation', importParseSchedules: Array<{ __typename?: 'ImportScheduleObject', title?: string | null, notes?: string | null, splitEquipmentOnTask?: boolean | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, procedures?: Array<{ __typename?: 'ProcedureObject', id: string, title: string }> | null, equipment?: Array<{ __typename?: 'EquipmentModel', id: string, title: string }> | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreSchedulesMutationVariables = Exact<{
  data: Array<ImportScheduleInput> | ImportScheduleInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreSchedulesMutation = { __typename?: 'Mutation', importStoreSchedules?: Array<{ __typename?: 'ImportScheduleObject', title?: string | null, notes?: string | null, splitEquipmentOnTask?: boolean | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, procedures?: Array<{ __typename?: 'ProcedureObject', id: string, title: string }> | null, equipment?: Array<{ __typename?: 'EquipmentModel', id: string, title: string }> | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseMaterialGroupsMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseMaterialGroupsMutation = { __typename?: 'Mutation', importParseMaterialGroups: Array<{ __typename?: 'ImportMaterialGroupObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreMaterialGroupsMutationVariables = Exact<{
  data: Array<ImportMaterialGroupInput> | ImportMaterialGroupInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreMaterialGroupsMutation = { __typename?: 'Mutation', importStoreMaterialGroups?: Array<{ __typename?: 'ImportMaterialGroupObject', title?: string | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseMaterialsMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseMaterialsMutation = { __typename?: 'Mutation', importParseMaterials: Array<{ __typename?: 'ImportMaterialObject', title?: string | null, price?: number | null, description?: string | null, active?: boolean | null, group?: { __typename?: 'MaterialGroupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreMaterialsMutationVariables = Exact<{
  data: Array<ImportMaterialInput> | ImportMaterialInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreMaterialsMutation = { __typename?: 'Mutation', importStoreMaterials?: Array<{ __typename?: 'ImportMaterialObject', title?: string | null, price?: number | null, description?: string | null, active?: boolean | null, group?: { __typename?: 'MaterialGroupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseWorkOrdersMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseWorkOrdersMutation = { __typename?: 'Mutation', importParseWorkOrders: Array<{ __typename?: 'ImportWorkOrderObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, dueDate?: string | null, closedAt?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreWorkOrdersMutationVariables = Exact<{
  data: Array<ImportWorkOrderInput> | ImportWorkOrderInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreWorkOrdersMutation = { __typename?: 'Mutation', importStoreWorkOrders?: Array<{ __typename?: 'ImportWorkOrderObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, dueDate?: string | null, closedAt?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseWorkOrderTemplatesMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseWorkOrderTemplatesMutation = { __typename?: 'Mutation', importParseWorkOrderTemplates: Array<{ __typename?: 'ImportWOTObject', description?: string | null, recordStatus?: RRuleStatuses | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreWorkOrderTemplatesMutationVariables = Exact<{
  data: Array<ImportWotInput> | ImportWotInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreWorkOrderTemplatesMutation = { __typename?: 'Mutation', importStoreWorkOrderTemplates?: Array<{ __typename?: 'ImportWOTObject', description?: string | null, recordStatus?: RRuleStatuses | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, dueAfterDays?: number | null, excludeDates?: Array<string> | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, rruleObject?: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseIncidentsMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseIncidentsMutation = { __typename?: 'Mutation', importParseIncidents: Array<{ __typename?: 'ImportIncidentObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreIncidentsMutationVariables = Exact<{
  data: Array<ImportIncidentInput> | ImportIncidentInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreIncidentsMutation = { __typename?: 'Mutation', importStoreIncidents?: Array<{ __typename?: 'ImportIncidentObject', description?: string | null, attachments?: Array<string> | null, startDate?: string | null, timezone?: string | null, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type ImportParseCoIsMutationVariables = Exact<{
  link: Scalars['String'];
}>;


export type ImportParseCoIsMutation = { __typename?: 'Mutation', importParseCOIs: Array<{ __typename?: 'ImportCOIObject', title?: string | null, status?: CoiStatusEnum | null, note?: string | null, validFrom?: string | null, validTo?: string | null, attachment?: string | null, contactEmails?: Array<string> | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> };

export type ImportStoreCoIsMutationVariables = Exact<{
  data: Array<ImportCoiInput> | ImportCoiInput;
  skipNotValid?: Scalars['Boolean'];
}>;


export type ImportStoreCoIsMutation = { __typename?: 'Mutation', importStoreCOIs?: Array<{ __typename?: 'ImportCOIObject', title?: string | null, status?: CoiStatusEnum | null, note?: string | null, validFrom?: string | null, validTo?: string | null, attachment?: string | null, contactEmails?: Array<string> | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, errors?: Array<{ __typename?: 'ImportErrorObject', error: string, key: string }> | null }> | null };

export type IncidentFieldsFragment = { __typename?: 'IncidentModel', id: string, index: number, description?: string | null, createdAt: any, startDate: any, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, incidentWatchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> };

export type CreateIncidentMutationVariables = Exact<{
  data: IncidentInput;
}>;


export type CreateIncidentMutation = { __typename?: 'Mutation', createIncident: { __typename?: 'IncidentModel', id: string } };

export type UpdateIncidentMutationVariables = Exact<{
  id: Scalars['String'];
  data: IncidentUpdateInput;
}>;


export type UpdateIncidentMutation = { __typename?: 'Mutation', updateIncident: { __typename?: 'IncidentModel', id: string, index: number, description?: string | null, createdAt: any, startDate: any, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, incidentWatchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type BulkStatusIncidentsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
}>;


export type BulkStatusIncidentsMutation = { __typename?: 'Mutation', bulkStatusIncidents: { __typename?: 'IncidentBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'IncidentModel', id: string, status: { __typename?: 'StatusObject', color: string, id: string, title: string } }> | null } };

export type ArchiveIncidentsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ArchiveIncidentsMutation = { __typename?: 'Mutation', archiveIncidents: boolean };

export type UnArchiveIncidentsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnArchiveIncidentsMutation = { __typename?: 'Mutation', unArchiveIncidents: boolean };

export type RemoveIncidentsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveIncidentsMutation = { __typename?: 'Mutation', removeIncidents: boolean };

export type IncidentSubscribeMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
}>;


export type IncidentSubscribeMutation = { __typename?: 'Mutation', incidentSubscribe: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> };

export type ShareIncidentMutationVariables = Exact<{
  data: IncidentShareInput;
}>;


export type ShareIncidentMutation = { __typename?: 'Mutation', shareIncident: boolean };

export type DeleteIncidentAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteIncidentAttachmentMutation = { __typename?: 'Mutation', deleteIncidentAttachment: boolean };

export type UpdateIncidentCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
}>;


export type UpdateIncidentCustomFieldMutation = { __typename?: 'Mutation', updateIncidentCustomField: { __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } } };

export type GetIncidentsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
}>;


export type GetIncidentsQuery = { __typename?: 'Query', getIncidents: { __typename?: 'GetIncidentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'IncidentModel', id: string, index: number, isArchived: boolean, description?: string | null, createdAt: any, startDate: any, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type GetIncidentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetIncidentQuery = { __typename?: 'Query', getIncident: { __typename?: 'IncidentModel', id: string, index: number, description?: string | null, createdAt: any, startDate: any, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, incidentWatchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type ExportIncidentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
}>;


export type ExportIncidentsQuery = { __typename?: 'Query', exportIncidents: string };

export type SetupIntegrationFieldsFragment = { __typename?: 'IntegrationSetupModel', status: boolean, hasIntegration: boolean, type: IntegrationTypeEnum, keys: Array<{ __typename?: 'IntegrationBlocksDTO', key: string, label: string, required: boolean, value?: string | null }> };

export type StoreIntegrationMutationVariables = Exact<{
  data: PropertyIntegrationInput;
}>;


export type StoreIntegrationMutation = { __typename?: 'Mutation', storeIntegration: string };

export type TestIntegrationMutationVariables = Exact<{
  data: PropertyIntegrationInput;
}>;


export type TestIntegrationMutation = { __typename?: 'Mutation', testIntegration: { __typename?: 'IntegrationAuthCheckDTO', successful: boolean } };

export type ToggleIntegrationMutationVariables = Exact<{
  data: TogglePropertyIntegrationInput;
}>;


export type ToggleIntegrationMutation = { __typename?: 'Mutation', toggleIntegration: boolean };

export type RemoveIntegrationMutationVariables = Exact<{
  data: TogglePropertyIntegrationInput;
}>;


export type RemoveIntegrationMutation = { __typename?: 'Mutation', removeIntegration: boolean };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', getIntegrations: Array<{ __typename?: 'IntegrationListModel', hasIntegration: boolean, status: number, type: IntegrationTypeEnum }> };

export type GetSingleIntegrationQueryVariables = Exact<{
  type: IntegrationTypeEnum;
}>;


export type GetSingleIntegrationQuery = { __typename?: 'Query', getIntegration: { __typename?: 'IntegrationSetupModel', status: boolean, hasIntegration: boolean, type: IntegrationTypeEnum, keys: Array<{ __typename?: 'IntegrationBlocksDTO', key: string, label: string, required: boolean, value?: string | null }> } };

export type GetPublicIntegrationQueryVariables = Exact<{
  type: IntegrationTypeEnum;
}>;


export type GetPublicIntegrationQuery = { __typename?: 'Query', getPublicIntegration: { __typename?: 'IntegrationSetupModel', status: boolean, hasIntegration: boolean, type: IntegrationTypeEnum, keys: Array<{ __typename?: 'IntegrationBlocksDTO', key: string, label: string, required: boolean, value?: string | null }> } };

export type InvoiceChargeFieldsFragment = { __typename?: 'InvoiceChargeObject', id: string, type: ChargeEnum, date?: string | null, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, feature?: { __typename?: 'InvoiceFeatureObject', id: string, title?: string | null, type: InvoiceFeatureEnum } | null, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null };

export type CreateInvoiceChargeMutationVariables = Exact<{
  id: Scalars['String'];
  data: InvoiceChargeInputData;
}>;


export type CreateInvoiceChargeMutation = { __typename?: 'Mutation', createInvoiceCharge: { __typename?: 'InvoiceChargeObject', id: string } };

export type AddInvoiceChargesMutationVariables = Exact<{
  id: Scalars['String'];
  chargeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddInvoiceChargesMutation = { __typename?: 'Mutation', addInvoiceCharges: boolean };

export type UpdateInvoiceChargeMutationVariables = Exact<{
  id: Scalars['String'];
  data: InvoiceChargeInputData;
  updateParent?: Scalars['Boolean'];
}>;


export type UpdateInvoiceChargeMutation = { __typename?: 'Mutation', updateInvoiceCharge: { __typename?: 'InvoiceChargeObject', id: string, type: ChargeEnum, date?: string | null, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, feature?: { __typename?: 'InvoiceFeatureObject', id: string, title?: string | null, type: InvoiceFeatureEnum } | null, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null } };

export type RemoveInvoiceChargesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveInvoiceChargesMutation = { __typename?: 'Mutation', removeInvoiceCharges: boolean };

export type GetInvoiceChargesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceChargesQuery = { __typename?: 'Query', getInvoiceCharges: Array<{ __typename?: 'InvoiceChargeObject', id: string, type: ChargeEnum, date?: string | null, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, feature?: { __typename?: 'InvoiceFeatureObject', id: string, index: number, type: InvoiceFeatureEnum, title?: string | null } | null }> };

export type SearchInvoiceChargesQueryVariables = Exact<{
  invoiceId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type SearchInvoiceChargesQuery = { __typename?: 'Query', searchInvoiceCharges: { __typename?: 'GetInvoiceChargesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'InvoiceChargeObject', id: string, type: ChargeEnum, date?: string | null, hours?: number | null, notes?: string | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, feature?: { __typename?: 'InvoiceFeatureObject', id: string, index: number, type: InvoiceFeatureEnum, title?: string | null } | null }> } };

export type GetInvoiceChargeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceChargeQuery = { __typename?: 'Query', getInvoiceCharge: { __typename?: 'InvoiceChargeObject', id: string, type: ChargeEnum, date?: string | null, hours?: number | null, baseTaxable: boolean, markupType?: ValueUnit | null, markupAmount?: number | null, markupTaxable: boolean, taxAmount?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, feature?: { __typename?: 'InvoiceFeatureObject', id: string, title?: string | null, type: InvoiceFeatureEnum } | null, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, laborRate?: { __typename?: 'LaborRateObject', id: string, title: string } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null } };

export type InvoiceFieldsFragment = { __typename?: 'InvoiceObject', index: number, id: string, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, status: InvoiceStatus, notes?: string | null, invoiceDate: any, dueDate: any, lastSentAt?: any | null, totalAmount: number, paidAmount: number, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, file?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateInvoiceMutationVariables = Exact<{
  data: InvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'InvoiceObject', id: string } };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  data: InvoiceUpdateInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'InvoiceObject', index: number, id: string, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, status: InvoiceStatus, notes?: string | null, invoiceDate: any, dueDate: any, lastSentAt?: any | null, totalAmount: number, paidAmount: number, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, file?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ShareInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type ShareInvoiceMutation = { __typename?: 'Mutation', shareInvoice: boolean };

export type SendInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
}>;


export type SendInvoiceMutation = { __typename?: 'Mutation', sendInvoice: boolean };

export type InvoicePayMutationVariables = Exact<{
  data: InvoicePaymentInput;
}>;


export type InvoicePayMutation = { __typename?: 'Mutation', invoicePay: boolean };

export type AddInvoiceAttachmentsMutationVariables = Exact<{
  id: Scalars['String'];
  attachments: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddInvoiceAttachmentsMutation = { __typename?: 'Mutation', addInvoiceAttachments: { __typename?: 'InvoiceObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type RemoveInvoiceAttachmentMutationVariables = Exact<{
  id: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type RemoveInvoiceAttachmentMutation = { __typename?: 'Mutation', removeInvoiceAttachment: { __typename?: 'InvoiceObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type DeactivateInvoicesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type DeactivateInvoicesMutation = { __typename?: 'Mutation', deactivateInvoices: boolean };

export type ActivateInvoicesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type ActivateInvoicesMutation = { __typename?: 'Mutation', activateInvoices: boolean };

export type GetInvoicesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices: { __typename?: 'GetInvoicesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'InvoiceObject', index: number, id: string, status: InvoiceStatus, invoiceDate: any, dueDate: any, lastSentAt?: any | null, totalAmount: number, paidAmount: number, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getInvoice: { __typename?: 'InvoiceObject', index: number, id: string, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, status: InvoiceStatus, notes?: string | null, invoiceDate: any, dueDate: any, lastSentAt?: any | null, totalAmount: number, paidAmount: number, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, file?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type InvoicePaymentFieldsFragment = { __typename?: 'PaymentsObject', id: string, status: InvoicePaymentStatusEnum, amount: number, refundedAmount: number, stripeLink?: string | null, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type InvoicePaymentRefundMutationVariables = Exact<{
  amount: Scalars['Float'];
  id: Scalars['String'];
}>;


export type InvoicePaymentRefundMutation = { __typename?: 'Mutation', invoicePaymentRefund: { __typename?: 'PaymentsObject', id: string, status: InvoicePaymentStatusEnum, amount: number, refundedAmount: number, stripeLink?: string | null, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type GetInvoicePaymentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  invoiceId: Scalars['String'];
}>;


export type GetInvoicePaymentsQuery = { __typename?: 'Query', getInvoicePayments: Array<{ __typename?: 'PaymentsObject', id: string, status: InvoicePaymentStatusEnum, amount: number, refundedAmount: number, stripeLink?: string | null, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetInvoicePaymentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoicePaymentQuery = { __typename?: 'Query', getInvoicePayment: { __typename?: 'PaymentsObject', id: string, status: InvoicePaymentStatusEnum, amount: number, refundedAmount: number, stripeLink?: string | null, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type RecurringInvoicePaymentFieldsFragment = { __typename?: 'RecurringInvoicePaymentObject', id: string, amount: number, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type AddRecurringInvoicePaymentMutationVariables = Exact<{
  data: RecurringInvoicePaymentInput;
}>;


export type AddRecurringInvoicePaymentMutation = { __typename?: 'Mutation', addRecurringInvoicePayment: { __typename?: 'RecurringInvoicePaymentObject', id: string, amount: number, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type RemoveRecurringInvoicePaymentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveRecurringInvoicePaymentMutation = { __typename?: 'Mutation', removeRecurringInvoicePayment: boolean };

export type GetRecurringInvoicePaymentsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRecurringInvoicePaymentsQuery = { __typename?: 'Query', getRecurringInvoicePayments: Array<{ __typename?: 'RecurringInvoicePaymentObject', id: string, amount: number, createdAt: any, paymentMethod?: { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type RecurringInvoiceFieldsFragment = { __typename?: 'RecurringInvoiceObject', id: string, index: number, notes?: string | null, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, recordStatus: RRuleStatuses, totalAmount: number, paidAmount: number, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreateRecurringInvoiceMutationVariables = Exact<{
  data: RecurringInvoiceInput;
}>;


export type CreateRecurringInvoiceMutation = { __typename?: 'Mutation', createRecurringInvoice: { __typename?: 'RecurringInvoiceObject', id: string } };

export type UpdateRecurringInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  data: RecurringInvoiceUpdateInput;
}>;


export type UpdateRecurringInvoiceMutation = { __typename?: 'Mutation', updateRecurringInvoice: { __typename?: 'RecurringInvoiceObject', id: string, index: number, notes?: string | null, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, recordStatus: RRuleStatuses, totalAmount: number, paidAmount: number, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type UpdateRecurringInvoiceNextGenerationDateMutationVariables = Exact<{
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
}>;


export type UpdateRecurringInvoiceNextGenerationDateMutation = { __typename?: 'Mutation', updateRecurringInvoiceNextGenerationDate: { __typename?: 'RecurringInvoiceObject', id: string, nextGenerationDate?: any | null } };

export type RemoveRecurringInvoicesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveRecurringInvoicesMutation = { __typename?: 'Mutation', removeRecurringInvoices: boolean };

export type SkipRecurringInvoiceDateMutationVariables = Exact<{
  id: Scalars['String'];
  date: Scalars['String'];
}>;


export type SkipRecurringInvoiceDateMutation = { __typename?: 'Mutation', skipRecurringInvoiceDate: { __typename?: 'RecurringInvoiceObject', id: string, nextGenerationDate?: any | null, excludeDates?: Array<string> | null } };

export type GenerateRecurringInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GenerateRecurringInvoiceMutation = { __typename?: 'Mutation', generateRecurringInvoice: boolean };

export type BulkPauseRecurringInvoiceMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  pause: Scalars['Boolean'];
}>;


export type BulkPauseRecurringInvoiceMutation = { __typename?: 'Mutation', bulkPauseRecurringInvoice: { __typename?: 'RecurringInvoiceBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'RecurringInvoiceObject', id: string, recordStatus: RRuleStatuses }> | null } };

export type BulkSkipNextRecurringInvoiceMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkSkipNextRecurringInvoiceMutation = { __typename?: 'Mutation', bulkSkipNextRecurringInvoice: { __typename?: 'RecurringInvoiceBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'RecurringInvoiceObject', id: string, recordStatus: RRuleStatuses, nextGenerationDate?: any | null, excludeDates?: Array<string> | null }> | null } };

export type AddRecurringInvoiceAttachmentsMutationVariables = Exact<{
  id: Scalars['String'];
  attachments: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddRecurringInvoiceAttachmentsMutation = { __typename?: 'Mutation', addRecurringInvoiceAttachments: { __typename?: 'RecurringInvoiceObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type DeleteRecurringInvoiceAttachmentMutationVariables = Exact<{
  id: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type DeleteRecurringInvoiceAttachmentMutation = { __typename?: 'Mutation', deleteRecurringInvoiceAttachment: { __typename?: 'RecurringInvoiceObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetRecurringInvoicesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetRecurringInvoicesQuery = { __typename?: 'Query', getRecurringInvoices: { __typename?: 'GetRecurringInvoicesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'RecurringInvoiceObject', id: string, index: number, notes?: string | null, recordStatus: RRuleStatuses, rruleText?: string | null, createdAt: any, startDate: any, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetRecurringInvoicesCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type GetRecurringInvoicesCalendarQuery = { __typename?: 'Query', getRecurringInvoicesCalendar: Array<{ __typename?: 'RecurringInvoiceCalendarObject', dates: Array<any>, record: { __typename?: 'RecurringInvoiceObject', id: string, index: number, recordStatus: RRuleStatuses, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } }> };

export type GetRecurringInvoiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRecurringInvoiceQuery = { __typename?: 'Query', getRecurringInvoice: { __typename?: 'RecurringInvoiceObject', id: string, index: number, notes?: string | null, cc?: Array<string> | null, bcc?: Array<string> | null, email?: string | null, billTo?: string | null, recordStatus: RRuleStatuses, totalAmount: number, paidAmount: number, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetRecurringInvoiceChargesQueryVariables = Exact<{
  id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRecurringInvoiceChargesQuery = { __typename?: 'Query', getRecurringInvoiceCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, billable: boolean, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type GetRecurringInvoiceRelatedRecordsQueryVariables = Exact<{
  id: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRecurringInvoiceRelatedRecordsQuery = { __typename?: 'Query', getRecurringInvoiceRelatedRecords: { __typename?: 'GetInvoicesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'InvoiceObject', id: string, index: number, status: InvoiceStatus, dueDate: any, totalAmount: number, paidAmount: number, lastSentAt?: any | null }> } };

export type CategoryGroupCoreFieldsFragment = { __typename?: 'CategoryGroupObject', id: string, title: string };

export type CategoryGroupFieldsFragment = { __typename?: 'CategoryGroupObject', icon?: string | null, propertyId?: string | null, id: string, title: string };

export type CreateCategoryGroupMutationVariables = Exact<{
  data: CategoryGroupInput;
}>;


export type CreateCategoryGroupMutation = { __typename?: 'Mutation', createCategoryGroup: { __typename?: 'CategoryGroupObject', id: string } };

export type UpdateCategoryGroupMutationVariables = Exact<{
  id: Scalars['String'];
  data: CategoryGroupInput;
}>;


export type UpdateCategoryGroupMutation = { __typename?: 'Mutation', updateCategoryGroup: { __typename?: 'CategoryGroupObject', icon?: string | null, propertyId?: string | null, id: string, title: string } };

export type ToggleCategoryGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCategoryGroupMutation = { __typename?: 'Mutation', toggleCategoryGroup: boolean };

export type RemoveCategoryGroupsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCategoryGroupsMutation = { __typename?: 'Mutation', removeCategoryGroups: boolean };

export type GetCategoryGroupsTableQueryVariables = Exact<{
  recordType: CategoryRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetCategoryGroupsTableQuery = { __typename?: 'Query', getCategoryGroups: { __typename?: 'GetCategoryGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', index: number, icon?: string | null, active: boolean, categoryCount: number, propertyId?: string | null, id: string, title: string }> } };

export type GetCategoryGroupsDropdownQueryVariables = Exact<{
  recordType: CategoryRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetCategoryGroupsDropdownQuery = { __typename?: 'Query', getCategoryGroups: { __typename?: 'GetCategoryGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', icon?: string | null, active: boolean, id: string, title: string }> } };

export type GetCategoryGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryGroupQuery = { __typename?: 'Query', getCategoryGroup: { __typename?: 'CategoryGroupObject', icon?: string | null, propertyId?: string | null, id: string, title: string } };

export type CategoryCoreFieldsFragment = { __typename?: 'CategoryObject', id: string, title: string };

export type CategoryFieldsFragment = { __typename?: 'CategoryObject', propertyId?: string | null, description?: string | null, id: string, title: string, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, employee?: { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, usersNotify?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null };

export type CreateCategoryMutationVariables = Exact<{
  recordType: CategoryRecordType;
  data: CategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryObject', id: string } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  data: CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryObject', propertyId?: string | null, description?: string | null, id: string, title: string, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, employee?: { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, usersNotify?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type UpdatePortfolioCategoryMutationVariables = Exact<{
  data: UpdatePortfolioCategory;
}>;


export type UpdatePortfolioCategoryMutation = { __typename?: 'Mutation', updatePortfolioCategory: { __typename?: 'CategoryObject', id: string, title: string, employee?: { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null, usersNotify?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type ToggleCategoryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCategoryMutation = { __typename?: 'Mutation', toggleCategory: boolean };

export type RemoveCategoriesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCategoriesMutation = { __typename?: 'Mutation', removeCategories: boolean };

export type GetCategoriesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  recordType: CategoryRecordType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetCategoriesTableQuery = { __typename?: 'Query', getCategories: { __typename?: 'GetCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryObject', active: boolean, propertyId?: string | null, index: number, id: string, title: string, employee?: { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null }> } };

export type GetCategoriesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  recordType: CategoryRecordType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeGroup: Scalars['Boolean'];
  includeDescription: Scalars['Boolean'];
  includePriority: Scalars['Boolean'];
  includeEmployee: Scalars['Boolean'];
}>;


export type GetCategoriesDropdownQuery = { __typename?: 'Query', getCategories: { __typename?: 'GetCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryObject', active: boolean, description?: string | null, id: string, title: string, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, employee?: { __typename?: 'EmployeeObject', id: string, laborRate?: { __typename?: 'LaborRateObject', rate: number, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null }> } };

export type GetCategoriesDropdownGroupedQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  recordType: CategoryRecordType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeDescription: Scalars['Boolean'];
  includePriority: Scalars['Boolean'];
  includeEmployee: Scalars['Boolean'];
}>;


export type GetCategoriesDropdownGroupedQuery = { __typename?: 'Query', getCategoriesGrouped: { __typename?: 'GetCategoriesGrouped', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', title: string, icon?: string | null, active: boolean, categories?: Array<{ __typename?: 'CategoryObject', active: boolean, description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, employee?: { __typename?: 'EmployeeObject', id: string, laborRate?: { __typename?: 'LaborRateObject', rate: number, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null } | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null }> | null }> } };

export type GetFilterableGroupedCategoriesQueryVariables = Exact<{
  location: FilterableCategoryLocationType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterableGroupedCategoriesQuery = { __typename?: 'Query', getFilterableGroupedCategories: { __typename?: 'GetFilterableGroupedCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'FilterableGroupedCategoryObject', id: string, title: string, icon?: string | null, active: boolean, isDeleted: boolean, categories: Array<{ __typename?: 'FilterableCategoryObject', id: string, title: string, active: boolean, isDeleted: boolean }> }> } };

export type GetPublicCategoriesGroupedQueryVariables = Exact<{
  propertyId: Scalars['String'];
  recordType: CategoryRecordType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
}>;


export type GetPublicCategoriesGroupedQuery = { __typename?: 'Query', getPublicCategoriesGrouped: { __typename?: 'GetCategoriesGrouped', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', title: string, icon?: string | null, active: boolean, categories?: Array<{ __typename?: 'CategoryObject', id: string, title: string }> | null }> } };

export type GetCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', getCategory: { __typename?: 'CategoryObject', propertyId?: string | null, description?: string | null, id: string, title: string, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, employee?: { __typename?: 'EmployeeObject', id: string, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, usersNotify?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type KioskFieldsFragment = { __typename?: 'KioskSettingsObject', welcomeText?: string | null, welcomeGuestSubtitle?: string | null, kioskBgColor?: string | null, qrCodeCheckIn?: boolean | null, locatorCheckIn?: boolean | null, qrScanCamera?: CameraType | null, qrScanCameraFlip?: boolean | null, selfieCamera?: CameraType | null, selfieCameraFlip?: boolean | null, kioskBgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type UpdateKioskSettingsMutationVariables = Exact<{
  data: KioskSettingsInput;
}>;


export type UpdateKioskSettingsMutation = { __typename?: 'Mutation', updateKioskSettings: { __typename?: 'KioskSettingsObject', welcomeText?: string | null, welcomeGuestSubtitle?: string | null, kioskBgColor?: string | null, qrCodeCheckIn?: boolean | null, locatorCheckIn?: boolean | null, qrScanCamera?: CameraType | null, qrScanCameraFlip?: boolean | null, selfieCamera?: CameraType | null, selfieCameraFlip?: boolean | null, kioskBgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type GetKioskSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKioskSettingsQuery = { __typename?: 'Query', getKioskSettings: { __typename?: 'KioskSettingsObject', welcomeText?: string | null, welcomeGuestSubtitle?: string | null, kioskBgColor?: string | null, qrCodeCheckIn?: boolean | null, locatorCheckIn?: boolean | null, qrScanCamera?: CameraType | null, qrScanCameraFlip?: boolean | null, selfieCamera?: CameraType | null, selfieCameraFlip?: boolean | null, kioskBgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type LaborRateCoreFieldsFragment = { __typename?: 'LaborRateObject', id: string, title: string };

export type LaborRateFieldsFragment = { __typename?: 'LaborRateObject', index: number, rate: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateLaborRateMutationVariables = Exact<{
  data: LaborRateInput;
}>;


export type CreateLaborRateMutation = { __typename?: 'Mutation', createLaborRate: { __typename?: 'LaborRateObject', id: string } };

export type UpdateLaborRateMutationVariables = Exact<{
  id: Scalars['String'];
  data: LaborRateInput;
}>;


export type UpdateLaborRateMutation = { __typename?: 'Mutation', updateLaborRate: { __typename?: 'LaborRateObject', index: number, rate: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleLaborRateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleLaborRateMutation = { __typename?: 'Mutation', toggleLaborRate: boolean };

export type RemoveLaborRatesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveLaborRatesMutation = { __typename?: 'Mutation', removeLaborRates: boolean };

export type GetLaborRatesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLaborRatesTableQuery = { __typename?: 'Query', getLaborRates: Array<{ __typename?: 'LaborRateObject', index: number, active: boolean, rate: number, description?: string | null, propertyId?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetLaborRatesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  includeDescription: Scalars['Boolean'];
  includeMarkup: Scalars['Boolean'];
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetLaborRatesDropdownQuery = { __typename?: 'Query', getLaborRates: Array<{ __typename?: 'LaborRateObject', active: boolean, rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetLaborRateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLaborRateQuery = { __typename?: 'Query', getLaborRate: { __typename?: 'LaborRateObject', index: number, rate: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type LeaseChargeTypeCoreFieldsFragment = { __typename?: 'LeaseChargeTypeObject', id: string, title: string };

export type LeaseChargeTypeFieldsFragment = { __typename?: 'LeaseChargeTypeObject', active: boolean, propertyId?: string | null, id: string, title: string };

export type CreateLeaseChargeTypeMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateLeaseChargeTypeMutation = { __typename?: 'Mutation', createLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', id: string } };

export type UpdateLeaseChargeTypeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateLeaseChargeTypeMutation = { __typename?: 'Mutation', updateLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type ReorderLeaseChargeTypesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderLeaseChargeTypesMutation = { __typename?: 'Mutation', reorderLeaseChargeTypes: boolean };

export type ToggleLeaseChargeTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleLeaseChargeTypeMutation = { __typename?: 'Mutation', toggleLeaseChargeType: boolean };

export type RemoveLeaseChargeTypesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveLeaseChargeTypesMutation = { __typename?: 'Mutation', removeLeaseChargeTypes: boolean };

export type GetLeaseChargeTypesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLeaseChargeTypesTableQuery = { __typename?: 'Query', getLeaseChargeTypes: Array<{ __typename?: 'LeaseChargeTypeObject', index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetLeaseChargeTypesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLeaseChargeTypesDropdownQuery = { __typename?: 'Query', getLeaseChargeTypes: Array<{ __typename?: 'LeaseChargeTypeObject', active: boolean, id: string, title: string }> };

export type GetLeaseChargeTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLeaseChargeTypeQuery = { __typename?: 'Query', getLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', active: boolean, propertyId?: string | null, id: string, title: string } };

export type LeaseRentFieldsFragment = { __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> };

export type LeaseFieldsFragment = { __typename?: 'LeaseObject', id: string, index: number, status: LeaseStatusEnum, leaseEnd: string, leaseStart: string, rentFootage?: number | null, lateFeeAmount?: number | null, lateFeeUnit?: LeaseFeeUnitEnum | null, gracePeriod?: number | null, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }>, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreateLeaseMutationVariables = Exact<{
  data: LeaseInput;
}>;


export type CreateLeaseMutation = { __typename?: 'Mutation', createLease: { __typename?: 'LeaseObject', id: string } };

export type UpdateLeaseMutationVariables = Exact<{
  id: Scalars['String'];
  data: LeaseUpdateInput;
}>;


export type UpdateLeaseMutation = { __typename?: 'Mutation', updateLease: { __typename?: 'LeaseObject', id: string, index: number, status: LeaseStatusEnum, leaseEnd: string, leaseStart: string, rentFootage?: number | null, lateFeeAmount?: number | null, lateFeeUnit?: LeaseFeeUnitEnum | null, gracePeriod?: number | null, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }>, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type RemoveLeasesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveLeasesMutation = { __typename?: 'Mutation', removeLeases: boolean };

export type AddLeaseRentMutationVariables = Exact<{
  leaseId: Scalars['String'];
  input: Array<LeaseRentInput> | LeaseRentInput;
}>;


export type AddLeaseRentMutation = { __typename?: 'Mutation', addLeaseRent: { __typename?: 'LeaseObject', id: string, leaseEnd: string, leaseStart: string, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }> } };

export type UpdateLeaseRentMutationVariables = Exact<{
  rentId: Scalars['String'];
  input: LeaseRentInput;
}>;


export type UpdateLeaseRentMutation = { __typename?: 'Mutation', updateLeaseRent: { __typename?: 'LeaseObject', id: string, leaseEnd: string, leaseStart: string, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }> } };

export type RemoveLeaseRentMutationVariables = Exact<{
  leaseId: Scalars['String'];
  rentId: Scalars['String'];
}>;


export type RemoveLeaseRentMutation = { __typename?: 'Mutation', removeLeaseRent: { __typename?: 'LeaseObject', id: string, leaseEnd: string, leaseStart: string, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }> } };

export type RemoveLeaseAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  leaseId: Scalars['String'];
}>;


export type RemoveLeaseAttachmentMutation = { __typename?: 'Mutation', removeLeaseAttachment: boolean };

export type GetLeasesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeaseStatusEnum>;
}>;


export type GetLeasesQuery = { __typename?: 'Query', getLeases: { __typename?: 'GetLeases', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'LeaseObject', id: string, index: number, status: LeaseStatusEnum, leaseEnd: string, leaseStart: string, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetLeaseQueryVariables = Exact<{
  leaseId: Scalars['String'];
}>;


export type GetLeaseQuery = { __typename?: 'Query', getLease: { __typename?: 'LeaseObject', id: string, index: number, status: LeaseStatusEnum, leaseEnd: string, leaseStart: string, rentFootage?: number | null, lateFeeAmount?: number | null, lateFeeUnit?: LeaseFeeUnitEnum | null, gracePeriod?: number | null, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }>, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rents: Array<{ __typename?: 'LeaseRentObject', id: string, endDate: string, startDate: string, amount: number, chargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string }, suites: Array<{ __typename?: 'SuiteObject', id: string, title: string }> }>, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type MarkupCoreFieldsFragment = { __typename?: 'MarkupObject', id: string, title: string };

export type MarkupFieldsFragment = { __typename?: 'MarkupObject', index: number, type: ValueUnit, amount: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateMarkupMutationVariables = Exact<{
  data: MarkUpInput;
}>;


export type CreateMarkupMutation = { __typename?: 'Mutation', createMarkup: { __typename?: 'MarkupObject', id: string } };

export type UpdateMarkupMutationVariables = Exact<{
  id: Scalars['String'];
  data: MarkUpInput;
}>;


export type UpdateMarkupMutation = { __typename?: 'Mutation', updateMarkup: { __typename?: 'MarkupObject', index: number, type: ValueUnit, amount: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleMarkupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleMarkupMutation = { __typename?: 'Mutation', toggleMarkup: boolean };

export type RemoveMarkupsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveMarkupsMutation = { __typename?: 'Mutation', removeMarkups: boolean };

export type GetMarkupsTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMarkupsTableQuery = { __typename?: 'Query', getMarkups: Array<{ __typename?: 'MarkupObject', index: number, active: boolean, type: ValueUnit, amount: number, description?: string | null, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetMarkupsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetMarkupsDropdownQuery = { __typename?: 'Query', getMarkups: Array<{ __typename?: 'MarkupObject', active: boolean, type: ValueUnit, amount: number, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetMarkupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMarkupQuery = { __typename?: 'Query', getMarkup: { __typename?: 'MarkupObject', index: number, type: ValueUnit, amount: number, active: boolean, description?: string | null, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type MaterialGroupCoreFieldsFragment = { __typename?: 'MaterialGroupObject', id: string, title: string };

export type CreateMaterialGroupMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateMaterialGroupMutation = { __typename?: 'Mutation', createMaterialGroup: { __typename?: 'MaterialGroupObject', id: string } };

export type UpdateMaterialGroupMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateMaterialGroupMutation = { __typename?: 'Mutation', updateMaterialGroup: { __typename?: 'MaterialGroupObject', id: string, title: string } };

export type RemoveMaterialGroupsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveMaterialGroupsMutation = { __typename?: 'Mutation', removeMaterialGroups: boolean };

export type GetMaterialGroupsTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMaterialGroupsTableQuery = { __typename?: 'Query', getMaterialGroups: { __typename?: 'GetMaterialGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'MaterialGroupObject', index: number, categoryCount: number, id: string, title: string }> } };

export type GetMaterialGroupsDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMaterialGroupsDropdownQuery = { __typename?: 'Query', getMaterialGroups: { __typename?: 'GetMaterialGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'MaterialGroupObject', id: string, title: string }> } };

export type GetMaterialGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaterialGroupQuery = { __typename?: 'Query', getMaterialGroup: { __typename?: 'MaterialGroupObject', id: string, title: string } };

export type ExportMaterialGroupsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportMaterialGroupsQuery = { __typename?: 'Query', exportMaterialGroups: string };

export type MaterialCoreFieldsFragment = { __typename?: 'MaterialObject', id: string, title: string };

export type MaterialFieldsFragment = { __typename?: 'MaterialObject', index: number, active: boolean, price?: number | null, description?: string | null, id: string, title: string, group: { __typename?: 'MaterialGroupObject', id: string, title: string }, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateMaterialMutationVariables = Exact<{
  data: MaterialInput;
}>;


export type CreateMaterialMutation = { __typename?: 'Mutation', createMaterial: { __typename?: 'MaterialObject', id: string } };

export type UpdateMaterialMutationVariables = Exact<{
  id: Scalars['String'];
  data: MaterialInput;
}>;


export type UpdateMaterialMutation = { __typename?: 'Mutation', updateMaterial: { __typename?: 'MaterialObject', index: number, active: boolean, price?: number | null, description?: string | null, id: string, title: string, group: { __typename?: 'MaterialGroupObject', id: string, title: string }, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleMaterialMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleMaterialMutation = { __typename?: 'Mutation', toggleMaterial: boolean };

export type RemoveMaterialsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveMaterialsMutation = { __typename?: 'Mutation', removeMaterials: boolean };

export type GetMaterialsTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMaterialsTableQuery = { __typename?: 'Query', getMaterials: { __typename?: 'GetMaterials', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'MaterialObject', index: number, active: boolean, price?: number | null, description?: string | null, id: string, title: string, group: { __typename?: 'MaterialGroupObject', id: string, title: string }, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> } };

export type GetMaterialsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeGroup: Scalars['Boolean'];
  includeMarkup: Scalars['Boolean'];
  includeTax: Scalars['Boolean'];
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetMaterialsDropdownQuery = { __typename?: 'Query', getMaterials: { __typename?: 'GetMaterials', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'MaterialObject', active: boolean, price?: number | null, id: string, title: string, group?: { __typename?: 'MaterialGroupObject', id: string, title: string }, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null, tax?: { __typename?: 'TaxObject', amount: number, id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> } };

export type GetMaterialsDropdownGroupedQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  includeMarkup: Scalars['Boolean'];
  includeTax: Scalars['Boolean'];
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetMaterialsDropdownGroupedQuery = { __typename?: 'Query', getMaterialsGrouped: { __typename?: 'GetMaterialsGrouped', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'MaterialGroupObject', title: string, materials?: Array<{ __typename?: 'MaterialObject', active: boolean, price?: number | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null, tax?: { __typename?: 'TaxObject', amount: number, id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> | null }> } };

export type GetMaterialQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaterialQuery = { __typename?: 'Query', getMaterial: { __typename?: 'MaterialObject', index: number, active: boolean, price?: number | null, description?: string | null, id: string, title: string, group: { __typename?: 'MaterialGroupObject', id: string, title: string }, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, tax?: { __typename?: 'TaxObject', id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ExportMaterialsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportMaterialsQuery = { __typename?: 'Query', exportMaterials: string };

export type SaveMenuMutationVariables = Exact<{
  data: SaveMenuInput;
}>;


export type SaveMenuMutation = { __typename?: 'Mutation', saveMenu: boolean };

export type GetMenuQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  location: MenuLocation;
}>;


export type GetMenuQuery = { __typename?: 'Query', getMenu: Array<{ __typename?: 'MenuItemObject', currentId: string, title: string, type: MenuTypes, featureId?: string | null, url?: string | null, embedBody?: string | null, icon?: string | null, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null, children?: Array<{ __typename?: 'MenuItemObject', currentId: string, title: string, type: MenuTypes, featureId?: string | null, url?: string | null, embedBody?: string | null, icon?: string | null, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null, children?: Array<{ __typename?: 'MenuItemObject', currentId: string, title: string, type: MenuTypes, featureId?: string | null, url?: string | null, embedBody?: string | null, icon?: string | null, product?: { __typename?: 'ProductItemObject', id: string, title: string } | null }> | null }> | null }> };

export type GetMenuFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenuFeaturesQuery = { __typename?: 'Query', getMenuFeatures: Array<{ __typename?: 'FeatureItemObject', id: string, title: string, mobile: boolean, web: boolean, webUrl: string, anyPermissions?: boolean | null, minPermissions?: Array<{ __typename?: 'MinPermissionObject', key: string }> | null }> };

export type NewsfeedCoreFieldsFragment = { __typename?: 'NewsfeedObject', id: string, description: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type NewsfeedFieldsFragment = { __typename?: 'NewsfeedObject', createdAt: any, id: string, description: string, likesList?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type EventFieldsFragment = { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateNewsfeedMutationVariables = Exact<{
  data: NewsfeedInput;
}>;


export type CreateNewsfeedMutation = { __typename?: 'Mutation', createNewsFeed: { __typename?: 'NewsfeedObject', id: string } };

export type UpdateNewsfeedMutationVariables = Exact<{
  id: Scalars['String'];
  data: NewsfeedUpdateInput;
}>;


export type UpdateNewsfeedMutation = { __typename?: 'Mutation', updateNewsFeed: { __typename?: 'NewsfeedObject', id: string, description: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type NewsfeedToggleLikeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type NewsfeedToggleLikeMutation = { __typename?: 'Mutation', newsFeedToggleLike: { __typename?: 'NewsfeedObject', id: string, likesList?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null } };

export type RemoveNewsfeedsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveNewsfeedsMutation = { __typename?: 'Mutation', removeNewsFeeds: boolean };

export type CreateEventMutationVariables = Exact<{
  data: EventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'EventObject', id: string } };

export type RegisterEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RegisterEventMutation = { __typename?: 'Mutation', registerEvent: { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type UnRegisterEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnRegisterEventMutation = { __typename?: 'Mutation', unRegisterEvent: { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type SaveEventRatingMutationVariables = Exact<{
  data: EventReviewInput;
}>;


export type SaveEventRatingMutation = { __typename?: 'Mutation', saveEventRating: { __typename?: 'EventObject', id: string, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null } };

export type SendEventMessageMutationVariables = Exact<{
  data: EventMessageInput;
}>;


export type SendEventMessageMutation = { __typename?: 'Mutation', sendEventMessage: boolean };

export type UpdateEventMutationVariables = Exact<{
  eventId: Scalars['String'];
  data: EventUpdateInput;
  type?: EventUpdateType;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type RemoveEventMutationVariables = Exact<{
  eventId: Scalars['String'];
  type?: EventUpdateType;
}>;


export type RemoveEventMutation = { __typename?: 'Mutation', removeEvent: boolean };

export type GetNewsEventsQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  type?: InputMaybe<EventNewsEnum>;
}>;


export type GetNewsEventsQuery = { __typename?: 'Query', getNewsEvents: Array<{ __typename?: 'EventNewsObject', type: EventNewsEnum, event?: { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } | null, news?: { __typename?: 'NewsfeedObject', createdAt: any, id: string, description: string, likesList?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } | null }> };

export type GetNewsFeedQueryVariables = Exact<{
  newsfeedId: Scalars['String'];
}>;


export type GetNewsFeedQuery = { __typename?: 'Query', getNewsFeed: { __typename?: 'NewsfeedObject', id: string, description: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'EventObject', id: string, title: string, description: string, location?: string | null, eventDate: string, startTime: string, timezone: string, eventLength?: number | null, repeatId?: string | null, capacity?: number | null, capacityAvailable?: number | null, showCapacity: boolean, registration: boolean, isRegistered: boolean, averageRating?: number | null, userRating?: { __typename?: 'EventAttendanceObject', id: string, score?: number | null, comment?: string | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type GetEventAttendanceQueryVariables = Exact<{
  eventId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEventAttendanceQuery = { __typename?: 'Query', getEventAttendance: { __typename?: 'GetEventAttendancesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EventAttendanceObject', id: string, createdAt: any, score?: number | null, comment?: string | null, user: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type ExportEventAttendanceQueryVariables = Exact<{
  eventId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportEventAttendanceQuery = { __typename?: 'Query', exportEventAttendance: string };

export type NotificationFieldsFragment = { __typename?: 'NotificationObject', id: string, createdAt: any, isRead: boolean, message: string, notificationCategory: NotificationCategoryEnum, showToaster: boolean, referToRecord?: { __typename?: 'ReferToObject', id: string, index?: number | null, title?: string | null, type: ReferToType } | null, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, additional?: { __typename?: 'NotificationAdditionalObject', key: NotificationAdditionalTypeEnum, value: string } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: boolean };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type GetMyNotificationsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  notificationCategory?: InputMaybe<NotificationCategoryEnum>;
}>;


export type GetMyNotificationsQuery = { __typename?: 'Query', getMyNotifications: { __typename?: 'GetNotifications', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'NotificationObject', id: string, createdAt: any, isRead: boolean, message: string, notificationCategory: NotificationCategoryEnum, showToaster: boolean, referToRecord?: { __typename?: 'ReferToObject', id: string, index?: number | null, title?: string | null, type: ReferToType } | null, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, additional?: { __typename?: 'NotificationAdditionalObject', key: NotificationAdditionalTypeEnum, value: string } | null }> } };

export type GetMyUnreadNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUnreadNotificationsQuery = { __typename?: 'Query', getMyUnreadNotifications: Array<string> };

export type OnNotificationAddedSubscriptionVariables = Exact<{
  notificationCategory?: InputMaybe<NotificationCategoryEnum>;
}>;


export type OnNotificationAddedSubscription = { __typename?: 'Subscription', notificationAdded: { __typename?: 'NotificationObject', id: string, createdAt: any, isRead: boolean, message: string, notificationCategory: NotificationCategoryEnum, showToaster: boolean, referToRecord?: { __typename?: 'ReferToObject', id: string, index?: number | null, title?: string | null, type: ReferToType } | null, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, status: UserStatuses, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, additional?: { __typename?: 'NotificationAdditionalObject', key: NotificationAdditionalTypeEnum, value: string } | null } };

export type PackageFieldsFragment = { __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreatePackagesMutationVariables = Exact<{
  data: Array<PackageCreateInput> | PackageCreateInput;
}>;


export type CreatePackagesMutation = { __typename?: 'Mutation', createPackages: Array<{ __typename?: 'PackageObject', id: string }> };

export type UpdatePackagesMutationVariables = Exact<{
  id: Scalars['String'];
  data: PackageUpdateInput;
}>;


export type UpdatePackagesMutation = { __typename?: 'Mutation', updatePackages: { __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type DeletePackagesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type DeletePackagesMutation = { __typename?: 'Mutation', deletePackages: boolean };

export type BulkStatusPackagesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  status: PackageStatusType;
}>;


export type BulkStatusPackagesMutation = { __typename?: 'Mutation', bulkStatusPackages: { __typename?: 'PackageBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'PackageObject', id: string, status: PackageStatusType }> | null } };

export type DeletePackageAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeletePackageAttachmentMutation = { __typename?: 'Mutation', deletePackageAttachment: { __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type AddPackageAttachmentsMutationVariables = Exact<{
  attachments: Array<FileObjectInput> | FileObjectInput;
  id: Scalars['String'];
}>;


export type AddPackageAttachmentsMutation = { __typename?: 'Mutation', addPackageAttachments: { __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetPackagesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PackageStatusType>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPackagesQuery = { __typename?: 'Query', getPackages: { __typename?: 'GetPackagesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null }> } };

export type GetPackageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPackageQuery = { __typename?: 'Query', getPackage: { __typename?: 'PackageObject', id: string, index: number, status: PackageStatusType, notes: string, packageId: string, createdAt: any, shippingProvider?: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type PaginationFieldsFragment = { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number };

export type PaymentFieldsFragment = { __typename?: 'PaymentObject', id: string, status: string, createdAt: any, startDate?: string | null, type?: StripePaymentEnum | null, subscriptionId?: string | null, productData: { __typename?: 'ProductStripeObject', title: string }, priceData: { __typename?: 'PriceStripeObject', title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, invoice?: { __typename?: 'StripeInvoiceObject', id: string, invoiceNumber?: string | null } | null, charge?: { __typename?: 'StripeChargeObject', id: string, source?: { __typename?: 'SourceObject', name: string, brand: string, last4: string } | null } | null };

export type GetPaymentsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPaymentsQuery = { __typename?: 'Query', getPayments: { __typename?: 'GetPaymentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PaymentObject', id: string, status: string, createdAt: any, startDate?: string | null, type?: StripePaymentEnum | null, subscriptionId?: string | null, productData: { __typename?: 'ProductStripeObject', title: string }, priceData: { __typename?: 'PriceStripeObject', title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', getPayment: { __typename?: 'PaymentObject', id: string, status: string, createdAt: any, startDate?: string | null, type?: StripePaymentEnum | null, subscriptionId?: string | null, productData: { __typename?: 'ProductStripeObject', title: string }, priceData: { __typename?: 'PriceStripeObject', title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, invoice?: { __typename?: 'StripeInvoiceObject', id: string, invoiceNumber?: string | null } | null, charge?: { __typename?: 'StripeChargeObject', id: string, source?: { __typename?: 'SourceObject', name: string, brand: string, last4: string } | null } | null } };

export type ValidatePortfolioUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ValidatePortfolioUrlQuery = { __typename?: 'Query', validatePortfolioURL: { __typename?: 'ValidateUrlObject', id?: string | null, title?: string | null, url: string, stripePublishableKey?: string | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, background?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, translation?: { __typename?: 'TranslationObject', id: string, title: string, countryCode: string, sources: any, translations?: any | null } | null, translations: Array<{ __typename?: 'TranslationObject', id: string, title: string, countryCode: string, sources: any, translations?: any | null }> } };

export type PmCustomIdCoreFieldsFragment = { __typename?: 'PMCustomIdObject', id: string, title: string };

export type CreatePmCustomIdMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreatePmCustomIdMutation = { __typename?: 'Mutation', createPMCustomId: { __typename?: 'PMCustomIdObject', id: string } };

export type UpdatePmCustomIdMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdatePmCustomIdMutation = { __typename?: 'Mutation', updatePMCustomId: { __typename?: 'PMCustomIdObject', id: string, title: string } };

export type TogglePmCustomIdMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePmCustomIdMutation = { __typename?: 'Mutation', togglePMCustomId: boolean };

export type RemovePmCustomIdsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePmCustomIdsMutation = { __typename?: 'Mutation', removePMCustomIds: boolean };

export type GetPmCustomIdsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPmCustomIdsQuery = { __typename?: 'Query', getPMCustomIds: Array<{ __typename?: 'PMCustomIdObject', index: number, active: boolean, createdAt: any, id: string, title: string }> };

export type GetPmCustomIdsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPmCustomIdsDropdownQuery = { __typename?: 'Query', getPMCustomIds: Array<{ __typename?: 'PMCustomIdObject', index: number, active: boolean, id: string, title: string }> };

export type GetPmCustomIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPmCustomIdQuery = { __typename?: 'Query', getPMCustomId: { __typename?: 'PMCustomIdObject', id: string, title: string } };

export type EquipmentCategoryCoreFieldsFragment = { __typename?: 'EquipmentCategoryModel', id: string, title: string };

export type CreateEquipmentCategoryMutationVariables = Exact<{
  data: EquipmentCategoryInput;
}>;


export type CreateEquipmentCategoryMutation = { __typename?: 'Mutation', createEquipmentCategory: { __typename?: 'EquipmentCategoryModel', id: string } };

export type UpdateEquipmentCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  data: EquipmentCategoryInput;
}>;


export type UpdateEquipmentCategoryMutation = { __typename?: 'Mutation', updateEquipmentCategory: { __typename?: 'EquipmentCategoryModel', id: string, title: string } };

export type RemoveEquipmentCategoriesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveEquipmentCategoriesMutation = { __typename?: 'Mutation', removeEquipmentCategories: boolean };

export type GetEquipmentCategoriesTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEquipmentCategoriesTableQuery = { __typename?: 'Query', getEquipmentCategories: { __typename?: 'GetEquipmentCategoriesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentCategoryModel', index: number, equipmentCount?: number | null, id: string, title: string }> } };

export type GetEquipmentCategoriesDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEquipmentCategoriesDropdownQuery = { __typename?: 'Query', getEquipmentCategories: { __typename?: 'GetEquipmentCategoriesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentCategoryModel', id: string, title: string }> } };

export type GetEquipmentCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEquipmentCategoryQuery = { __typename?: 'Query', getEquipmentCategory: { __typename?: 'EquipmentCategoryModel', id: string, title: string } };

export type ExportEquipmentCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportEquipmentCategoriesQuery = { __typename?: 'Query', exportEquipmentCategories: string };

export type EquipmentCoreFieldsFragment = { __typename?: 'EquipmentModel', id: string, title: string };

export type EquipmentFieldsFragment = { __typename?: 'EquipmentModel', index: number, active: boolean, specificLocation?: string | null, assetTag?: string | null, serialNumber?: string | null, manufacturer?: string | null, details?: string | null, id: string, title: string, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreateEquipmentMutationVariables = Exact<{
  data: CreateEquipmentInput;
}>;


export type CreateEquipmentMutation = { __typename?: 'Mutation', createEquipment: { __typename?: 'EquipmentModel', id: string } };

export type UpdateEquipmentMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateEquipmentInput;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipment: { __typename?: 'EquipmentModel', index: number, active: boolean, specificLocation?: string | null, assetTag?: string | null, serialNumber?: string | null, manufacturer?: string | null, details?: string | null, id: string, title: string, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type ToggleEquipmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleEquipmentMutation = { __typename?: 'Mutation', toggleEquipment: boolean };

export type RemoveEquipmentsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveEquipmentsMutation = { __typename?: 'Mutation', removeEquipments: boolean };

export type DeleteEquipmentAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteEquipmentAttachmentMutation = { __typename?: 'Mutation', deleteEquipmentAttachment: boolean };

export type GetEquipmentListTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  floorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
}>;


export type GetEquipmentListTableQuery = { __typename?: 'Query', getEquipmentList: { __typename?: 'GetEquipmentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, specificLocation?: string | null, assetTag?: string | null, serialNumber?: string | null, manufacturer?: string | null, id: string, title: string, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type GetEquipmentListDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  floorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
  includeCategory: Scalars['Boolean'];
}>;


export type GetEquipmentListDropdownQuery = { __typename?: 'Query', getEquipmentList: { __typename?: 'GetEquipmentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentModel', active: boolean, id: string, title: string, category?: { __typename?: 'EquipmentCategoryModel', id: string, title: string } }> } };

export type GetEquipmentListDropdownGroupedQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  floorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
}>;


export type GetEquipmentListDropdownGroupedQuery = { __typename?: 'Query', getEquipmentListGrouped: { __typename?: 'GetEquipmentGroupedObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentCategoryModel', title: string, equipmentList?: Array<{ __typename?: 'EquipmentModel', active: boolean, id: string, title: string }> | null }> } };

export type GetSingleEquipmentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSingleEquipmentQuery = { __typename?: 'Query', getSingleEquipment: { __typename?: 'EquipmentModel', index: number, active: boolean, specificLocation?: string | null, assetTag?: string | null, serialNumber?: string | null, manufacturer?: string | null, details?: string | null, id: string, title: string, building?: { __typename?: 'BuildingObject', id: string, title: string } | null, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetEquipmentTasksQueryVariables = Exact<{
  equipmentId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEquipmentTasksQuery = { __typename?: 'Query', getEquipmentTasks: { __typename?: 'GetEquipmentTaskObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'TaskObject', index: number, status: TaskStatusEnum, createdAt: any, completedAt?: any | null, id: string, title: string, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetEquipmentWorkOrdersQueryVariables = Exact<{
  equipmentId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEquipmentWorkOrdersQuery = { __typename?: 'Query', getEquipmentWorkOrders: { __typename?: 'GetEquipmentWorkOrderObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderObject', id: string, index: number, createdAt: any, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetEquipmentQrCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEquipmentQrCodeQuery = { __typename?: 'Query', getEquipmentQRCode: string };

export type PrintEquipmentQrCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PrintEquipmentQrCodeQuery = { __typename?: 'Query', printEquipmentQRCode: boolean };

export type ExportEquipmentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  floorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  suiteIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  nonBuildingRecords?: EquipmentNonBuildingEnum;
}>;


export type ExportEquipmentsQuery = { __typename?: 'Query', exportEquipments: string };

export type ProcedureCoreFieldsFragment = { __typename?: 'ProcedureObject', id: string, title: string };

export type ProcedureFieldsFragment = { __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, notes?: string | null, createdAt: any, id: string, title: string, sections?: Array<{ __typename?: 'ProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type CreateProcedureMutationVariables = Exact<{
  data: ProcedureInput;
}>;


export type CreateProcedureMutation = { __typename?: 'Mutation', createProcedure: { __typename?: 'ProcedureObject', id: string } };

export type UpdateProcedureMutationVariables = Exact<{
  id: Scalars['String'];
  data: ProcedureInput;
}>;


export type UpdateProcedureMutation = { __typename?: 'Mutation', updateProcedure: { __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, notes?: string | null, createdAt: any, id: string, title: string, sections?: Array<{ __typename?: 'ProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type ToggleProcedureMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleProcedureMutation = { __typename?: 'Mutation', toggleProcedure: boolean };

export type RemoveProceduresMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveProceduresMutation = { __typename?: 'Mutation', removeProcedures: boolean };

export type GetProceduresTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProceduresTableQuery = { __typename?: 'Query', getProcedures: { __typename?: 'GetProceduresObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, schedulesCount: number, id: string, title: string }> } };

export type GetProceduresDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProceduresDropdownQuery = { __typename?: 'Query', getProcedures: { __typename?: 'GetProceduresObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ProcedureObject', active: boolean, id: string, title: string }> } };

export type GetProcedureQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProcedureQuery = { __typename?: 'Query', getProcedure: { __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, notes?: string | null, createdAt: any, id: string, title: string, sections?: Array<{ __typename?: 'ProcedureSectionObject', title: string, steps: Array<{ __typename?: 'ProcedureSectionStepObject', title: string, type: PmStepType, customId?: string | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', unit?: string | null, type?: PmStepInputType | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type ExportProceduresQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportProceduresQuery = { __typename?: 'Query', exportProcedures: string };

export type ScheduleProcedureFieldsFragment = { __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, id: string, title: string };

export type ScheduleEquipmentFieldsFragment = { __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null };

export type ScheduleCoreFieldsFragment = { __typename?: 'SchedulesObject', id: string, title: string };

export type ScheduleFieldsFragment = { __typename?: 'SchedulesObject', index: number, recordStatus: RRuleStatuses, notes?: string | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, dueAfterDays?: number | null, splitEquipmentOnTask: boolean, createdAt: any, startDate: any, timezone: string, rruleText?: string | null, id: string, title: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }>, procedures: Array<{ __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, id: string, title: string }>, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreateScheduleMutationVariables = Exact<{
  data: SchedulesInput;
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule: { __typename?: 'SchedulesObject', id: string } };

export type UpdateScheduleTitleMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateScheduleTitleMutation = { __typename?: 'Mutation', updateScheduleTitle: { __typename?: 'SchedulesObject', id: string, title: string } };

export type UpdateScheduleNotesMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScheduleNotesMutation = { __typename?: 'Mutation', updateScheduleNotes: { __typename?: 'SchedulesObject', id: string, notes?: string | null } };

export type UpdateScheduleNextGenerationDateMutationVariables = Exact<{
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
}>;


export type UpdateScheduleNextGenerationDateMutation = { __typename?: 'Mutation', updateScheduleNextGenerationDate: { __typename?: 'SchedulesObject', id: string, nextGenerationDate?: any | null } };

export type UpdateScheduleRRuleMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  input: SchedulesUpdateRRuleInput;
}>;


export type UpdateScheduleRRuleMutation = { __typename?: 'Mutation', updateScheduleRRule: { __typename?: 'SchedulesObject', id: string, rruleText?: string | null, recordStatus: RRuleStatuses, nextGenerationDate?: any | null, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } } } };

export type UpdateScheduleAssignedToIdMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  assignedToId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScheduleAssignedToIdMutation = { __typename?: 'Mutation', updateScheduleAssignedToId: { __typename?: 'SchedulesObject', id: string, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type UpdateScheduleDueAfterDaysMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  dueAfterDays?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateScheduleDueAfterDaysMutation = { __typename?: 'Mutation', updateScheduleDueAfterDays: { __typename?: 'SchedulesObject', id: string, dueAfterDays?: number | null } };

export type UpdateScheduleTaskTypeMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  taskTypeId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateScheduleTaskTypeMutation = { __typename?: 'Mutation', updateScheduleTaskType: { __typename?: 'SchedulesObject', id: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null } };

export type AddScheduleAttachmentsMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  attachments: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddScheduleAttachmentsMutation = { __typename?: 'Mutation', addScheduleAttachments: { __typename?: 'SchedulesObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type RemoveScheduleAttachmentMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type RemoveScheduleAttachmentMutation = { __typename?: 'Mutation', removeScheduleAttachment: { __typename?: 'SchedulesObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type ToggleScheduleSplitEquipmentOnTaskMutationVariables = Exact<{
  scheduleId: Scalars['String'];
}>;


export type ToggleScheduleSplitEquipmentOnTaskMutation = { __typename?: 'Mutation', toggleScheduleSplitEquipmentOnTask: { __typename?: 'SchedulesObject', id: string, splitEquipmentOnTask: boolean } };

export type AddScheduleProcedureMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  procedureId: Scalars['String'];
}>;


export type AddScheduleProcedureMutation = { __typename?: 'Mutation', addScheduleProcedure: { __typename?: 'SchedulesObject', id: string, procedureCount: number, procedures: Array<{ __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, id: string, title: string }> } };

export type RemoveScheduleProcedureMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  procedureId: Scalars['String'];
}>;


export type RemoveScheduleProcedureMutation = { __typename?: 'Mutation', removeScheduleProcedure: { __typename?: 'SchedulesObject', id: string, procedureCount: number, procedures: Array<{ __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, id: string, title: string }> } };

export type AddScheduleEquipmentMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  equipmentId: Scalars['String'];
}>;


export type AddScheduleEquipmentMutation = { __typename?: 'Mutation', addScheduleEquipment: { __typename?: 'SchedulesObject', id: string, equipmentCount: number, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type RemoveScheduleEquipmentMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  equipmentId: Scalars['String'];
}>;


export type RemoveScheduleEquipmentMutation = { __typename?: 'Mutation', removeScheduleEquipment: { __typename?: 'SchedulesObject', id: string, equipmentCount: number, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type GenerateTaskMutationVariables = Exact<{
  scheduleId: Scalars['String'];
}>;


export type GenerateTaskMutation = { __typename?: 'Mutation', generateTask: boolean };

export type SkipScheduleDateMutationVariables = Exact<{
  scheduleId: Scalars['String'];
  date: Scalars['String'];
}>;


export type SkipScheduleDateMutation = { __typename?: 'Mutation', skipScheduleDate: { __typename?: 'SchedulesObject', id: string, nextGenerationDate?: any | null, excludeDates?: Array<string> | null } };

export type BulkPauseSchedulesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  pause: Scalars['Boolean'];
}>;


export type BulkPauseSchedulesMutation = { __typename?: 'Mutation', bulkPauseSchedules: { __typename?: 'SchedulesBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'SchedulesObject', id: string, recordStatus: RRuleStatuses }> | null } };

export type BulkSkipNextSchedulesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkSkipNextSchedulesMutation = { __typename?: 'Mutation', bulkSkipNextSchedules: { __typename?: 'SchedulesBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'SchedulesObject', id: string, recordStatus: RRuleStatuses, nextGenerationDate?: any | null, excludeDates?: Array<string> | null }> | null } };

export type RemoveSchedulesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveSchedulesMutation = { __typename?: 'Mutation', removeSchedules: boolean };

export type GetSchedulesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taskTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetSchedulesQuery = { __typename?: 'Query', getSchedules: { __typename?: 'GetSchedulesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SchedulesObject', index: number, recordStatus: RRuleStatuses, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, equipmentCount: number, procedureCount: number, createdAt: any, startDate: any, timezone: string, rruleText?: string | null, id: string, title: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetSchedulesCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  taskTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetSchedulesCalendarQuery = { __typename?: 'Query', getSchedulesCalendar: Array<{ __typename?: 'SchedulesCalendarObject', dates: Array<any>, record: { __typename?: 'SchedulesObject', index: number, recordStatus: RRuleStatuses, id: string, title: string } }> };

export type GetScheduleQueryVariables = Exact<{
  scheduleId: Scalars['String'];
}>;


export type GetScheduleQuery = { __typename?: 'Query', getSchedule: { __typename?: 'SchedulesObject', index: number, recordStatus: RRuleStatuses, notes?: string | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, dueAfterDays?: number | null, splitEquipmentOnTask: boolean, createdAt: any, startDate: any, timezone: string, rruleText?: string | null, id: string, title: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }>, procedures: Array<{ __typename?: 'ProcedureObject', index: number, active: boolean, estimatedLabor?: number | null, id: string, title: string }>, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetScheduleRelatedRecordsQueryVariables = Exact<{
  id: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetScheduleRelatedRecordsQuery = { __typename?: 'Query', getScheduleRelatedRecords: { __typename?: 'GetTasksObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'TaskObject', id: string, index: number, status: TaskStatusEnum, title: string, createdAt: any, charges?: number | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type ExportSchedulesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  taskTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type ExportSchedulesQuery = { __typename?: 'Query', exportSchedules: string };

export type TaskTypeCoreFieldsFragment = { __typename?: 'TaskTypeModel', id: string, title: string };

export type CreateTaskTypeMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateTaskTypeMutation = { __typename?: 'Mutation', createTaskType: { __typename?: 'TaskTypeModel', id: string } };

export type UpdateTaskTypeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateTaskTypeMutation = { __typename?: 'Mutation', updateTaskType: { __typename?: 'TaskTypeModel', id: string, title: string } };

export type ToggleTaskTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleTaskTypeMutation = { __typename?: 'Mutation', toggleTaskType: boolean };

export type RemoveTaskTypesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveTaskTypesMutation = { __typename?: 'Mutation', removeTaskTypes: boolean };

export type GetTaskTypesQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskTypesQuery = { __typename?: 'Query', getTaskTypes: Array<{ __typename?: 'TaskTypeModel', index: number, active: boolean, scheduleCount: number, taskCount: number, createdAt: any, id: string, title: string }> };

export type GetTaskTypesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskTypesDropdownQuery = { __typename?: 'Query', getTaskTypes: Array<{ __typename?: 'TaskTypeModel', index: number, active: boolean, id: string, title: string }> };

export type GetTaskTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskTypeQuery = { __typename?: 'Query', getTaskType: { __typename?: 'TaskTypeModel', id: string, title: string } };

export type TaskProcedureFieldsFragment = { __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> };

export type TaskEquipmentFieldsFragment = { __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null };

export type TaskCoreFieldsFragment = { __typename?: 'TaskObject', id: string, title: string };

export type TaskFieldsFragment = { __typename?: 'TaskObject', index: number, status: TaskStatusEnum, systemCompleted: boolean, userCompleted: boolean, notes?: string | null, createdAt: any, completedAt?: any | null, dueDate?: string | null, id: string, title: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, schedule?: { __typename?: 'SchedulesObject', id: string, title: string } | null, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }>, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }>, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type ToggleTaskWatcherMutationVariables = Exact<{
  taskId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type ToggleTaskWatcherMutation = { __typename?: 'Mutation', toggleTaskWatcher: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> };

export type UpdateTaskNotesMutationVariables = Exact<{
  taskId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaskNotesMutation = { __typename?: 'Mutation', updateTaskNotes: { __typename?: 'TaskObject', id: string, notes?: string | null } };

export type UpdateTaskAssignedToMutationVariables = Exact<{
  taskId: Scalars['String'];
  assignedToId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaskAssignedToMutation = { __typename?: 'Mutation', updateTaskAssignedTo: { __typename?: 'TaskObject', id: string, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type UpdateTaskDueDateMutationVariables = Exact<{
  taskId: Scalars['String'];
  dueDate?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaskDueDateMutation = { __typename?: 'Mutation', updateTaskDueDate: { __typename?: 'TaskObject', id: string, dueDate?: string | null, status: TaskStatusEnum } };

export type UpdateTaskTaskTypeMutationVariables = Exact<{
  taskId: Scalars['String'];
  taskTypeId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaskTaskTypeMutation = { __typename?: 'Mutation', updateTaskTaskType: { __typename?: 'TaskObject', id: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null } };

export type UpdateTaskProcedureNotesMutationVariables = Exact<{
  taskProcedureId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaskProcedureNotesMutation = { __typename?: 'Mutation', updateTaskProcedureNotes: { __typename?: 'TaskObject', id: string, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type AddTaskAttachmentsMutationVariables = Exact<{
  taskId: Scalars['String'];
  attachments: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddTaskAttachmentsMutation = { __typename?: 'Mutation', addTaskAttachments: { __typename?: 'TaskObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type RemoveTaskAttachmentMutationVariables = Exact<{
  taskId: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type RemoveTaskAttachmentMutation = { __typename?: 'Mutation', removeTaskAttachment: { __typename?: 'TaskObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type AddTaskEquipmentMutationVariables = Exact<{
  taskId: Scalars['String'];
  equipmentId: Scalars['String'];
}>;


export type AddTaskEquipmentMutation = { __typename?: 'Mutation', addTaskEquipment: { __typename?: 'TaskObject', id: string, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type RemoveTaskEquipmentMutationVariables = Exact<{
  taskId: Scalars['String'];
  equipmentId: Scalars['String'];
}>;


export type RemoveTaskEquipmentMutation = { __typename?: 'Mutation', removeTaskEquipment: { __typename?: 'TaskObject', id: string, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type AddTaskProcedureMutationVariables = Exact<{
  taskId: Scalars['String'];
  procedureId: Scalars['String'];
}>;


export type AddTaskProcedureMutation = { __typename?: 'Mutation', addTaskProcedure: { __typename?: 'TaskObject', id: string, status: TaskStatusEnum, systemCompleted: boolean, completedAt?: any | null, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type RemoveTaskProcedureMutationVariables = Exact<{
  taskId: Scalars['String'];
  procedureId: Scalars['String'];
}>;


export type RemoveTaskProcedureMutation = { __typename?: 'Mutation', removeTaskProcedure: { __typename?: 'TaskObject', id: string, status: TaskStatusEnum, systemCompleted: boolean, completedAt?: any | null, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type ToggleTaskMutationVariables = Exact<{
  taskId: Scalars['String'];
}>;


export type ToggleTaskMutation = { __typename?: 'Mutation', toggleTask: { __typename?: 'TaskObject', id: string, status: TaskStatusEnum, userCompleted: boolean, completedAt?: any | null, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type SetTaskStepValueMutationVariables = Exact<{
  taskStepId: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
}>;


export type SetTaskStepValueMutation = { __typename?: 'Mutation', setTaskStepValue: { __typename?: 'TaskObject', id: string, status: TaskStatusEnum, systemCompleted: boolean, completedAt?: any | null, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type SetTaskStepCustomIdMutationVariables = Exact<{
  taskStepId: Scalars['String'];
  customId?: InputMaybe<Scalars['String']>;
  predefinedCustomFieldId?: InputMaybe<Scalars['String']>;
}>;


export type SetTaskStepCustomIdMutation = { __typename?: 'Mutation', setTaskStepCustomId: { __typename?: 'TaskObject', id: string, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type RemoveTaskStepAttachmentMutationVariables = Exact<{
  taskStepId: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type RemoveTaskStepAttachmentMutation = { __typename?: 'Mutation', removeTaskStepAttachment: { __typename?: 'TaskObject', id: string, status: TaskStatusEnum, systemCompleted: boolean, completedAt?: any | null, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }> } };

export type RemoveTasksMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveTasksMutation = { __typename?: 'Mutation', removeTasks: boolean };

export type GetTasksQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taskTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  completedFrom?: InputMaybe<Scalars['DateTime']>;
  completedTo?: InputMaybe<Scalars['DateTime']>;
  dueDateFrom?: InputMaybe<Scalars['DateTime']>;
  dueDateTo?: InputMaybe<Scalars['DateTime']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  assignedToIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  equipmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  status?: InputMaybe<TaskStatusEnum>;
}>;


export type GetTasksQuery = { __typename?: 'Query', getTasks: { __typename?: 'GetTasksObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'TaskObject', index: number, status: TaskStatusEnum, notes?: string | null, charges?: number | null, createdAt: any, completedAt?: any | null, dueDate?: string | null, id: string, title: string, equipment: Array<{ __typename?: 'EquipmentModel', id: string, title: string }>, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaskQuery = { __typename?: 'Query', getTask: { __typename?: 'TaskObject', index: number, status: TaskStatusEnum, systemCompleted: boolean, userCompleted: boolean, notes?: string | null, createdAt: any, completedAt?: any | null, dueDate?: string | null, id: string, title: string, taskType?: { __typename?: 'TaskTypeModel', id: string, title: string } | null, building: { __typename?: 'BuildingObject', id: string, title: string }, schedule?: { __typename?: 'SchedulesObject', id: string, title: string } | null, equipment: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }>, procedures: Array<{ __typename?: 'TaskProcedureObject', id: string, procedureId?: string | null, title: string, notes?: string | null, isDone: boolean, estimatedLabor?: number | null, sections: Array<{ __typename?: 'TaskSectionObject', id: string, title: string, isDone: boolean, steps: Array<{ __typename?: 'TaskStepObject', id: string, customId?: string | null, title: string, type: PmStepType, value?: any | null, predefinedCustomField?: { __typename?: 'PMCustomIdObject', id: string, title: string } | null, inputOptions?: { __typename?: 'ProcedureSectionStepInputOptionObject', type?: PmStepInputType | null, unit?: string | null } | null, dropdownOptions?: { __typename?: 'ProcedureSectionStepDropdownOptionObject', multi?: boolean | null, items?: Array<string> | null } | null }> }> }>, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetTaskChargesQueryVariables = Exact<{
  taskId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskChargesQuery = { __typename?: 'Query', getTaskCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, invoiceId?: string | null, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type PrinterCoreFieldsFragment = { __typename?: 'PrinterModel', id: string, title: string };

export type PrinterFieldsFragment = { __typename?: 'PrinterModel', ipAddress: string, modelName: PrinterModelTypes, paperType: PrinterPaperTypes, id: string, title: string };

export type CreatePrinterMutationVariables = Exact<{
  data: PrinterInput;
}>;


export type CreatePrinterMutation = { __typename?: 'Mutation', createPrinter: { __typename?: 'PrinterModel', id: string } };

export type UpdatePrinterMutationVariables = Exact<{
  id: Scalars['String'];
  data: PrinterInput;
}>;


export type UpdatePrinterMutation = { __typename?: 'Mutation', updatePrinter: { __typename?: 'PrinterModel', ipAddress: string, modelName: PrinterModelTypes, paperType: PrinterPaperTypes, id: string, title: string } };

export type DeletePrintersMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type DeletePrintersMutation = { __typename?: 'Mutation', deletePrinters: boolean };

export type SyncPrintersMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPrintersMutation = { __typename?: 'Mutation', syncPrinters: boolean };

export type GetPrintersTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrintersTableQuery = { __typename?: 'Query', getPrinters: Array<{ __typename?: 'PrinterModel', synced: boolean, ipAddress: string, modelName: PrinterModelTypes, paperType: PrinterPaperTypes, id: string, title: string }> };

export type GetPrintersDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrintersDropdownQuery = { __typename?: 'Query', getPrinters: Array<{ __typename?: 'PrinterModel', id: string, title: string }> };

export type GetPrinterQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrinterQuery = { __typename?: 'Query', getPrinter: { __typename?: 'PrinterModel', ipAddress: string, modelName: PrinterModelTypes, paperType: PrinterPaperTypes, id: string, title: string } };

export type ExportPrintersQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportPrintersQuery = { __typename?: 'Query', exportPrinters: string };

export type PriorityCoreFieldsFragment = { __typename?: 'PriorityObject', id: string, title: string };

export type PriorityFieldsFragment = { __typename?: 'PriorityObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string };

export type CreatePriorityMutationVariables = Exact<{
  data: PriorityInput;
}>;


export type CreatePriorityMutation = { __typename?: 'Mutation', createPriority: { __typename?: 'PriorityObject', id: string } };

export type UpdatePriorityMutationVariables = Exact<{
  id: Scalars['String'];
  data: PriorityUpdateInput;
}>;


export type UpdatePriorityMutation = { __typename?: 'Mutation', updatePriority: { __typename?: 'PriorityObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string } };

export type ReorderPrioritiesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderPrioritiesMutation = { __typename?: 'Mutation', reorderPriorities: boolean };

export type TogglePriorityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePriorityMutation = { __typename?: 'Mutation', togglePriority: boolean };

export type RemovePrioritiesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePrioritiesMutation = { __typename?: 'Mutation', removePriorities: boolean };

export type GetPrioritiesTableQueryVariables = Exact<{
  recordType: PriorityRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPrioritiesTableQuery = { __typename?: 'Query', getPriorities: Array<{ __typename?: 'PriorityObject', color: string, index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetPrioritiesDropdownQueryVariables = Exact<{
  recordType: PriorityRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPrioritiesDropdownQuery = { __typename?: 'Query', getPriorities: Array<{ __typename?: 'PriorityObject', color: string, active: boolean, id: string, title: string }> };

export type GetFilterablePrioritiesQueryVariables = Exact<{
  location: FilterablePriorityLocationType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterablePrioritiesQuery = { __typename?: 'Query', getFilterablePriorities: Array<{ __typename?: 'FilterablePriorityObject', id: string, title: string, color?: string | null, active: boolean, isDeleted: boolean }> };

export type GetPublicPrioritiesQueryVariables = Exact<{
  propertyId: Scalars['String'];
  recordType: PriorityRecordType;
  search: Scalars['String'];
}>;


export type GetPublicPrioritiesQuery = { __typename?: 'Query', getPublicPriorities: Array<{ __typename?: 'PriorityObject', color: string, id: string, title: string }> };

export type GetPriorityQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPriorityQuery = { __typename?: 'Query', getPriority: { __typename?: 'PriorityObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string } };

export type ProductPriceCoreFieldsFragment = { __typename?: 'PriceItemObject', id: string, title: string };

export type ProductPriceFieldsFragment = { __typename?: 'PriceItemObject', active: boolean, billingPeriod?: PriceBillingPeriod | null, billingDay?: number | null, description?: string | null, price: number, trialDays?: number | null, type: PriceType, id: string, title: string, priceSettings?: { __typename?: 'PriceBHSettings', dateSelection?: boolean | null, timeFrom?: string | null, timeTo?: string | null, timezone?: string | null } | null };

export type ProductCoreFieldsFragment = { __typename?: 'ProductItemObject', id: string, title: string };

export type ProductFieldsFragment = { __typename?: 'ProductItemObject', active: boolean, description?: string | null, createdAt: any, companyTypes?: Array<CompanyTypeEnum> | null, id: string, title: string, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, waiverTemplate?: { __typename?: 'WaiverTemplateModel', id: string, title: string } | null, customFields: Array<{ __typename?: 'ProductCustomField', label: string, required: boolean }>, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, users?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, roles?: Array<{ __typename?: 'RoleObject', id: string, title: string }> | null, prices?: Array<{ __typename?: 'PriceItemObject', active: boolean, billingPeriod?: PriceBillingPeriod | null, billingDay?: number | null, description?: string | null, price: number, trialDays?: number | null, type: PriceType, id: string, title: string, priceSettings?: { __typename?: 'PriceBHSettings', dateSelection?: boolean | null, timeFrom?: string | null, timeTo?: string | null, timezone?: string | null } | null }> | null };

export type CreateProductMutationVariables = Exact<{
  data: ProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductItemObject', id: string } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String'];
  data: ProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductItemObject', active: boolean, description?: string | null, createdAt: any, companyTypes?: Array<CompanyTypeEnum> | null, id: string, title: string, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, waiverTemplate?: { __typename?: 'WaiverTemplateModel', id: string, title: string } | null, customFields: Array<{ __typename?: 'ProductCustomField', label: string, required: boolean }>, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, users?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, roles?: Array<{ __typename?: 'RoleObject', id: string, title: string }> | null, prices?: Array<{ __typename?: 'PriceItemObject', active: boolean, billingPeriod?: PriceBillingPeriod | null, billingDay?: number | null, description?: string | null, price: number, trialDays?: number | null, type: PriceType, id: string, title: string, priceSettings?: { __typename?: 'PriceBHSettings', dateSelection?: boolean | null, timeFrom?: string | null, timeTo?: string | null, timezone?: string | null } | null }> | null } };

export type ToggleProductMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleProductMutation = { __typename?: 'Mutation', toggleProduct: boolean };

export type RemoveProductsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveProductsMutation = { __typename?: 'Mutation', removeProducts: boolean };

export type GetProductsPublicQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductsPublicQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'ProductItemObject', id: string, title: string }> };

export type GetProductsAdminQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductsAdminQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'ProductItemObject', active: boolean, createdAt: any, id: string, title: string, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetProductsGeneaTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductsGeneaTableQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'ProductItemObject', id: string, title: string, geneaAccessGroup?: { __typename?: 'GeneaAccessGroupObject', id: string, title: string } | null }> };

export type GetProductsDropdownQueryVariables = Exact<{
  admin?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductsDropdownQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'ProductItemObject', active: boolean, id: string, title: string }> };

export type GetProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct: { __typename?: 'ProductItemObject', active: boolean, description?: string | null, createdAt: any, companyTypes?: Array<CompanyTypeEnum> | null, id: string, title: string, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, waiverTemplate?: { __typename?: 'WaiverTemplateModel', id: string, title: string } | null, customFields: Array<{ __typename?: 'ProductCustomField', label: string, required: boolean }>, companies?: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, users?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null, roles?: Array<{ __typename?: 'RoleObject', id: string, title: string }> | null, prices?: Array<{ __typename?: 'PriceItemObject', active: boolean, billingPeriod?: PriceBillingPeriod | null, billingDay?: number | null, description?: string | null, price: number, trialDays?: number | null, type: PriceType, id: string, title: string, priceSettings?: { __typename?: 'PriceBHSettings', dateSelection?: boolean | null, timeFrom?: string | null, timeTo?: string | null, timezone?: string | null } | null }> | null } };

export type PropertyCoreFieldsFragment = { __typename?: 'PropertyObject', id: string, title: string, active: boolean, timezone: string, primaryColor?: string | null, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, address?: { __typename?: 'PropertyAddressObject', address?: string | null, longitude?: number | null, latitude?: number | null } | null };

export type UpdatePropertyMutationVariables = Exact<{
  data: PropertyUpdateInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, timezone: string, primaryColor?: string | null, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, address?: { __typename?: 'PropertyAddressObject', address?: string | null, longitude?: number | null, latitude?: number | null } | null } };

export type GetMyPropertyDataQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;


export type GetMyPropertyDataQuery = { __typename?: 'Query', getMyPropertyData: { __typename?: 'UserObject', homepageId?: string | null, id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, role: { __typename?: 'RoleObject', id: string, title: string, permissions: { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, addInternalNotes?: boolean | null, viewInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null } }, printer?: { __typename?: 'PrinterModel', id: string, title: string } | null, property: { __typename?: 'PropertyObject', stripeApiKey?: string | null, id: string, title: string, active: boolean, timezone: string, primaryColor?: string | null, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, address?: { __typename?: 'PropertyAddressObject', address?: string | null, longitude?: number | null, latitude?: number | null } | null }, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type GetPropertyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyQuery = { __typename?: 'Query', getProperty: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, timezone: string, primaryColor?: string | null, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, address?: { __typename?: 'PropertyAddressObject', address?: string | null, longitude?: number | null, latitude?: number | null } | null } };

export type PropertyAddonFieldsFragment = { __typename?: 'PropertyAddonObject', id: string, key: PropertyAddonEnum, title: string, icon: string, value: string };

export type CreatePropertyAddonMutationVariables = Exact<{
  data: PropertyAddonsInput;
}>;


export type CreatePropertyAddonMutation = { __typename?: 'Mutation', createPropertyAddon: { __typename?: 'PropertyAddonObject', id: string } };

export type UpdatePropertyAddonMutationVariables = Exact<{
  id: Scalars['String'];
  data: PropertyAddonsInput;
}>;


export type UpdatePropertyAddonMutation = { __typename?: 'Mutation', updatePropertyAddon: { __typename?: 'PropertyAddonObject', id: string, key: PropertyAddonEnum, title: string, icon: string, value: string } };

export type RemovePropertyAddonsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePropertyAddonsMutation = { __typename?: 'Mutation', removePropertyAddons: boolean };

export type GetPropertyAddonsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPropertyAddonsQuery = { __typename?: 'Query', getPropertyAddons: Array<{ __typename?: 'PropertyAddonObject', id: string, key: PropertyAddonEnum, title: string, icon: string, value: string }> };

export type GetPropertyAddonQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPropertyAddonQuery = { __typename?: 'Query', getPropertyAddon: { __typename?: 'PropertyAddonObject', id: string, key: PropertyAddonEnum, title: string, icon: string, value: string } };

export type CreateReportMutationVariables = Exact<{
  data: ReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'ReportModel', id: string } };

export type CreatePmReportMutationVariables = Exact<{
  data: ReportPmInput;
}>;


export type CreatePmReportMutation = { __typename?: 'Mutation', createPMReport: { __typename?: 'ReportModel', id: string } };

export type RemoveReportsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveReportsMutation = { __typename?: 'Mutation', removeReports: boolean };

export type GetReportsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ReportType>;
  status?: InputMaybe<ReportStatus>;
}>;


export type GetReportsQuery = { __typename?: 'Query', getReports: { __typename?: 'GetReportsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ReportModel', id: string, index: number, companies: Array<string>, createdAt: any, from: string, to: string, isPrivate: boolean, status: ReportStatus, type: ReportType, file?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type ReportingSettingsFieldsFragment = { __typename?: 'ReportSettingsObject', invoiceAddress?: string | null, yardiPropertyId?: string | null, invoiceLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, groupedChargesARCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, groupedChargesGLCode?: { __typename?: 'GLAccountObject', id: string, title: string } | null };

export type UpdateReportSettingsMutationVariables = Exact<{
  data: ReportSettingInput;
}>;


export type UpdateReportSettingsMutation = { __typename?: 'Mutation', updateReportSettings: { __typename?: 'ReportSettingsObject', invoiceAddress?: string | null, yardiPropertyId?: string | null, invoiceLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, groupedChargesARCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, groupedChargesGLCode?: { __typename?: 'GLAccountObject', id: string, title: string } | null } };

export type GetReportSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportSettingsQuery = { __typename?: 'Query', getReportSettings: { __typename?: 'ReportSettingsObject', invoiceAddress?: string | null, yardiPropertyId?: string | null, invoiceLogo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, groupedChargesARCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, groupedChargesGLCode?: { __typename?: 'GLAccountObject', id: string, title: string } | null } };

export type RepositoryFileFieldsFragment = { __typename?: 'RepositoryFileObject', id: string, name: string, url?: string | null, size?: number | null, isDir: boolean, isPrivate: boolean, thumbnailUrl?: string | null, childrenCount?: number | null };

export type AddRepositoryFolderMutationVariables = Exact<{
  destinationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  isPrivate: Scalars['Boolean'];
}>;


export type AddRepositoryFolderMutation = { __typename?: 'Mutation', addRepositoryFolder: boolean };

export type UpdateRepositoryFolderMutationVariables = Exact<{
  folderId: Scalars['String'];
  name: Scalars['String'];
  isPrivate: Scalars['Boolean'];
}>;


export type UpdateRepositoryFolderMutation = { __typename?: 'Mutation', updateRepositoryFolder: boolean };

export type AddRepositoryFilesMutationVariables = Exact<{
  destinationId?: InputMaybe<Scalars['String']>;
  files: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddRepositoryFilesMutation = { __typename?: 'Mutation', addRepositoryFiles: boolean };

export type MoveRepositoryFilesMutationVariables = Exact<{
  sourceId?: InputMaybe<Scalars['String']>;
  destinationId?: InputMaybe<Scalars['String']>;
  fileIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MoveRepositoryFilesMutation = { __typename?: 'Mutation', moveRepositoryFiles: boolean };

export type DownloadRepositoryFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DownloadRepositoryFilesMutation = { __typename?: 'Mutation', downloadRepositoryFiles: string };

export type DeleteRepositoryFilesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteRepositoryFilesMutation = { __typename?: 'Mutation', deleteRepositoryFiles: boolean };

export type GetRepositoryFilesQueryVariables = Exact<{
  folderId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRepositoryFilesQuery = { __typename?: 'Query', getRepositoryFiles: { __typename?: 'GetRepositoryFiles', breadcrumbs: Array<{ __typename?: 'RepositoryBreadcrumbObject', id: string, name: string }>, files: Array<{ __typename?: 'RepositoryFileObject', id: string, name: string, url?: string | null, size?: number | null, isDir: boolean, isPrivate: boolean, thumbnailUrl?: string | null, childrenCount?: number | null }> } };

export type AllRolePermissionsFragment = { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, addInternalNotes?: boolean | null, viewInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null };

export type RoleCoreFieldsFragment = { __typename?: 'RoleObject', id: string, title: string };

export type GetRolesDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  onlyAssignable?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRolesDropdownQuery = { __typename?: 'Query', getRoles: { __typename?: 'GetRolesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'RoleObject', active: boolean, id: string, title: string }> } };

export type RoomReservationFieldsFragment = { __typename?: 'RoomReservationObject', id: string, index: number, from: string, to: string, date: string, status: RoomReservationStatusEnum, total: number, paymentType?: PaymentTypeEnum | null, paymentStatus?: PaymentStatusEnum | null, paymentLink?: string | null, description?: string | null, createdAt: any, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, room: { __typename?: 'RoomObject', cancellationPeriod?: number | null, id: string, title: string }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> };

export type CreateRoomReservationMutationVariables = Exact<{
  data: RoomReservationInput;
}>;


export type CreateRoomReservationMutation = { __typename?: 'Mutation', createRoomReservation: { __typename?: 'RoomReservationObject', id: string } };

export type UpdateRoomReservationMutationVariables = Exact<{
  id: Scalars['String'];
  data: RoomReservationUpdateInput;
}>;


export type UpdateRoomReservationMutation = { __typename?: 'Mutation', updateRoomReservation: { __typename?: 'RoomReservationObject', id: string, index: number, from: string, to: string, date: string, status: RoomReservationStatusEnum, total: number, paymentType?: PaymentTypeEnum | null, paymentStatus?: PaymentStatusEnum | null, paymentLink?: string | null, description?: string | null, createdAt: any, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, room: { __typename?: 'RoomObject', cancellationPeriod?: number | null, id: string, title: string }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type ApproveRoomReservationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApproveRoomReservationMutation = { __typename?: 'Mutation', approveRoomReservation: boolean };

export type DenyRoomReservationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DenyRoomReservationMutation = { __typename?: 'Mutation', denyRoomReservation: boolean };

export type CancelRoomReservationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelRoomReservationMutation = { __typename?: 'Mutation', cancelRoomReservation: boolean };

export type DeleteRoomReservationAttachmentsMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteRoomReservationAttachmentsMutation = { __typename?: 'Mutation', deleteRoomReservationAttachment: boolean };

export type GenerateRoomReservationWoMutationVariables = Exact<{
  data: RoomReservationGenerateWoInput;
}>;


export type GenerateRoomReservationWoMutation = { __typename?: 'Mutation', generateRoomReservationWO: { __typename?: 'RoomReservationObject', id: string, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null } };

export type SyncRoomReservationWoMutationVariables = Exact<{
  id: Scalars['String'];
  index: Scalars['Float'];
}>;


export type SyncRoomReservationWoMutation = { __typename?: 'Mutation', syncRoomReservationWO: { __typename?: 'RoomReservationObject', id: string, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null } };

export type UnsyncRoomReservationWoMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnsyncRoomReservationWoMutation = { __typename?: 'Mutation', unSyncRoomReservationWO: { __typename?: 'RoomReservationObject', id: string, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null } };

export type UpdateRoomReservationCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
}>;


export type UpdateRoomReservationCustomFieldMutation = { __typename?: 'Mutation', updateRoomReservationCustomField: { __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } } };

export type GetRoomReservationsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<RoomReservationStatusEnum>;
}>;


export type GetRoomReservationsQuery = { __typename?: 'Query', getRoomReservations: { __typename?: 'GetRoomReservationsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'RoomReservationObject', id: string, index: number, from: string, to: string, date: string, status: RoomReservationStatusEnum, total: number, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, room: { __typename?: 'RoomObject', cancellationPeriod?: number | null, id: string, title: string } }> } };

export type GetRoomReservationsCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  status?: InputMaybe<RoomReservationStatusEnum>;
}>;


export type GetRoomReservationsCalendarQuery = { __typename?: 'Query', getRoomReservationsCalendar: Array<{ __typename?: 'RoomReservationObject', id: string, from: string, to: string, date: string, status: RoomReservationStatusEnum, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, room: { __typename?: 'RoomObject', color?: string | null, id: string, title: string } }> };

export type GetPublicRoomReservationsCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type GetPublicRoomReservationsCalendarQuery = { __typename?: 'Query', getPublicRoomReservationsCalendar: Array<{ __typename?: 'RoomPublicReservationObject', id: string, from: string, to: string, date: string, room: { __typename?: 'RoomObject', color?: string | null, size: RoomSizeEnum, id: string, title: string } }> };

export type GetRoomReservationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRoomReservationQuery = { __typename?: 'Query', getRoomReservation: { __typename?: 'RoomReservationObject', id: string, index: number, from: string, to: string, date: string, status: RoomReservationStatusEnum, total: number, paymentType?: PaymentTypeEnum | null, paymentStatus?: PaymentStatusEnum | null, paymentLink?: string | null, description?: string | null, createdAt: any, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, room: { __typename?: 'RoomObject', cancellationPeriod?: number | null, id: string, title: string }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, workOrder?: { __typename?: 'WorkOrderObject', id: string, index: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type GetRoomReservationChargesQueryVariables = Exact<{
  reservationId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRoomReservationChargesQuery = { __typename?: 'Query', getRoomReservationCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, hours?: number | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type RoomCoreFieldsFragment = { __typename?: 'RoomObject', id: string, title: string };

export type RoomFieldsFragment = { __typename?: 'RoomObject', index: number, active: boolean, subtitle?: string | null, size: RoomSizeEnum, color?: string | null, cancellationPeriod?: number | null, minBookingTime: number, maxBookingTime?: number | null, from: string, to: string, limitAdvanceDays?: number | null, bufferTime?: number | null, rateModel: RateModelEnum, rate?: number | null, maxRate?: number | null, interval?: RateIntervalEnum | null, halfDayRate?: number | null, fullDayRate?: number | null, halfDayMinutes?: number | null, liabilityPolicy?: string | null, cancellationPolicy?: string | null, notes?: string | null, requiresApproval: boolean, id: string, title: string, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, amenities?: Array<{ __typename?: 'AmenityModel', icon: string, name: string }> | null, material: { __typename?: 'MaterialObject', id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }, addons?: Array<{ __typename?: 'MaterialObject', price?: number | null, description?: string | null, id: string, title: string }> | null, connectedRooms?: Array<{ __typename?: 'RoomObject', id: string, title: string }> | null };

export type CreateRoomMutationVariables = Exact<{
  data: RoomInput;
}>;


export type CreateRoomMutation = { __typename?: 'Mutation', createRoom: { __typename?: 'RoomObject', id: string } };

export type UpdateRoomMutationVariables = Exact<{
  id: Scalars['String'];
  data: RoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'RoomObject', index: number, active: boolean, subtitle?: string | null, size: RoomSizeEnum, color?: string | null, cancellationPeriod?: number | null, minBookingTime: number, maxBookingTime?: number | null, from: string, to: string, limitAdvanceDays?: number | null, bufferTime?: number | null, rateModel: RateModelEnum, rate?: number | null, maxRate?: number | null, interval?: RateIntervalEnum | null, halfDayRate?: number | null, fullDayRate?: number | null, halfDayMinutes?: number | null, liabilityPolicy?: string | null, cancellationPolicy?: string | null, notes?: string | null, requiresApproval: boolean, id: string, title: string, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, amenities?: Array<{ __typename?: 'AmenityModel', icon: string, name: string }> | null, material: { __typename?: 'MaterialObject', id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }, addons?: Array<{ __typename?: 'MaterialObject', price?: number | null, description?: string | null, id: string, title: string }> | null, connectedRooms?: Array<{ __typename?: 'RoomObject', id: string, title: string }> | null } };

export type ToggleRoomMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleRoomMutation = { __typename?: 'Mutation', toggleRoom: boolean };

export type RemoveRoomsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveRoomsMutation = { __typename?: 'Mutation', removeRooms: boolean };

export type ReorderRoomsMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderRoomsMutation = { __typename?: 'Mutation', reorderRooms: boolean };

export type GetAllRoomsSelectorQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['String'];
}>;


export type GetAllRoomsSelectorQuery = { __typename?: 'Query', getRooms: Array<{ __typename?: 'RoomObject', active: boolean, subtitle?: string | null, size: RoomSizeEnum, color?: string | null, minBookingTime: number, maxBookingTime?: number | null, from: string, to: string, limitAdvanceDays?: number | null, id: string, title: string, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, amenities?: Array<{ __typename?: 'AmenityModel', icon: string, name: string }> | null, reservations?: Array<{ __typename?: 'RoomReservationListObject', date: string, from: string, to: string }> | null }> };

export type GetAllRoomsAdminQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAllRoomsAdminQuery = { __typename?: 'Query', getRooms: Array<{ __typename?: 'RoomObject', index: number, active: boolean, subtitle?: string | null, from: string, to: string, id: string, title: string }> };

export type GetAllRoomsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllRoomsDropdownQuery = { __typename?: 'Query', getRooms: Array<{ __typename?: 'RoomObject', active: boolean, id: string, title: string }> };

export type GetRoomSelectorQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRoomSelectorQuery = { __typename?: 'Query', getRoom: { __typename?: 'RoomObject', subtitle?: string | null, size: RoomSizeEnum, rateModel: RateModelEnum, rate?: number | null, maxRate?: number | null, interval?: RateIntervalEnum | null, halfDayRate?: number | null, fullDayRate?: number | null, halfDayMinutes?: number | null, liabilityPolicy?: string | null, cancellationPolicy?: string | null, notes?: string | null, requiresApproval: boolean, id: string, title: string, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, addons?: Array<{ __typename?: 'MaterialObject', price?: number | null, description?: string | null, id: string, title: string }> | null } };

export type GetRoomAdminQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRoomAdminQuery = { __typename?: 'Query', getRoom: { __typename?: 'RoomObject', index: number, active: boolean, subtitle?: string | null, size: RoomSizeEnum, color?: string | null, cancellationPeriod?: number | null, minBookingTime: number, maxBookingTime?: number | null, from: string, to: string, limitAdvanceDays?: number | null, bufferTime?: number | null, rateModel: RateModelEnum, rate?: number | null, maxRate?: number | null, interval?: RateIntervalEnum | null, halfDayRate?: number | null, fullDayRate?: number | null, halfDayMinutes?: number | null, liabilityPolicy?: string | null, cancellationPolicy?: string | null, notes?: string | null, requiresApproval: boolean, id: string, title: string, image?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, amenities?: Array<{ __typename?: 'AmenityModel', icon: string, name: string }> | null, material: { __typename?: 'MaterialObject', id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }, addons?: Array<{ __typename?: 'MaterialObject', price?: number | null, description?: string | null, id: string, title: string }> | null, connectedRooms?: Array<{ __typename?: 'RoomObject', id: string, title: string }> | null } };

export type ExportRoomsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportRoomsQuery = { __typename?: 'Query', exportRooms: string };

export type RoomSettingsFieldsFragment = { __typename?: 'RoomSettingObject', generateWOOnReservationApprove?: boolean | null, defaultWOCategory?: { __typename?: 'CategoryObject', id: string, title: string } | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null };

export type UpdateRoomSettingsMutationVariables = Exact<{
  data: RoomSettingsInput;
}>;


export type UpdateRoomSettingsMutation = { __typename?: 'Mutation', updateRoomSettings: { __typename?: 'RoomSettingObject', generateWOOnReservationApprove?: boolean | null, defaultWOCategory?: { __typename?: 'CategoryObject', id: string, title: string } | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type GetRoomSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomSettingsQuery = { __typename?: 'Query', getRoomSettings: { __typename?: 'RoomSettingObject', generateWOOnReservationApprove?: boolean | null, defaultWOCategory?: { __typename?: 'CategoryObject', id: string, title: string } | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type RRuleFieldsFragment = { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } };

export type ShippingProviderFieldsFragment = { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateShippingProviderMutationVariables = Exact<{
  data: ShippingProviderInput;
}>;


export type CreateShippingProviderMutation = { __typename?: 'Mutation', createShippingProvider: { __typename?: 'ShippingProviderObject', id: string } };

export type UpdateShippingProviderMutationVariables = Exact<{
  id: Scalars['String'];
  data: ShippingProviderInput;
}>;


export type UpdateShippingProviderMutation = { __typename?: 'Mutation', updateShippingProvider: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type RemoveShippingProvidersMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveShippingProvidersMutation = { __typename?: 'Mutation', removeShippingProviders: boolean };

export type GetShippingProvidersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetShippingProvidersQuery = { __typename?: 'Query', getShippingProviders: Array<{ __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> };

export type GetShippingProviderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShippingProviderQuery = { __typename?: 'Query', getShippingProvider: { __typename?: 'ShippingProviderObject', id: string, index: number, title: string, createdAt: any, updatedAt: any, default: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type StackingPlanSuiteFieldsFragment = { __typename?: 'StakingPlanSuite', id: string, title: string, size: number, type: SuiteType, rent?: { __typename?: 'RentSuiteObject', id: string, startDate: string, endDate: string, company: { __typename?: 'CompanyObject', id: string, title: string } } | null, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type StackingPlanFloorFieldsFragment = { __typename?: 'StakingPlanFloor', id: string, title: string, size: number, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, suites: Array<{ __typename?: 'StakingPlanSuite', id: string, title: string, size: number, type: SuiteType, rent?: { __typename?: 'RentSuiteObject', id: string, startDate: string, endDate: string, company: { __typename?: 'CompanyObject', id: string, title: string } } | null, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> };

export type GetStackingPlanQueryVariables = Exact<{
  date: Scalars['String'];
  buildingId: Scalars['String'];
}>;


export type GetStackingPlanQuery = { __typename?: 'Query', getStackingPlan: { __typename?: 'GetStakingPlan', years: Array<string>, floors: Array<{ __typename?: 'StakingPlanFloor', id: string, title: string, size: number, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, suites: Array<{ __typename?: 'StakingPlanSuite', id: string, title: string, size: number, type: SuiteType, rent?: { __typename?: 'RentSuiteObject', id: string, startDate: string, endDate: string, company: { __typename?: 'CompanyObject', id: string, title: string } } | null, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> }> } };

export type StatusCoreFieldsFragment = { __typename?: 'StatusObject', id: string, title: string };

export type StatusFieldsFragment = { __typename?: 'StatusObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string };

export type CreateStatusMutationVariables = Exact<{
  data: StatusInput;
}>;


export type CreateStatusMutation = { __typename?: 'Mutation', createStatus: { __typename?: 'StatusObject', id: string } };

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['String'];
  data: StatusUpdateInput;
}>;


export type UpdateStatusMutation = { __typename?: 'Mutation', updateStatus: { __typename?: 'StatusObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string } };

export type ReorderStatusesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderStatusesMutation = { __typename?: 'Mutation', reorderStatuses: boolean };

export type ToggleStatusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleStatusMutation = { __typename?: 'Mutation', toggleStatus: boolean };

export type RemoveStatusesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveStatusesMutation = { __typename?: 'Mutation', removeStatuses: boolean };

export type GetStatusesTableQueryVariables = Exact<{
  recordType: StatusRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetStatusesTableQuery = { __typename?: 'Query', getStatuses: Array<{ __typename?: 'StatusObject', color: string, index: number, active: boolean, propertyId?: string | null, id: string, title: string }> };

export type GetStatusesDropdownQueryVariables = Exact<{
  recordType: StatusRecordType;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetStatusesDropdownQuery = { __typename?: 'Query', getStatuses: Array<{ __typename?: 'StatusObject', color: string, active: boolean, id: string, title: string }> };

export type GetPublicStatusesQueryVariables = Exact<{
  propertyId: Scalars['String'];
  recordType: StatusRecordType;
  search: Scalars['String'];
}>;


export type GetPublicStatusesQuery = { __typename?: 'Query', getPublicStatuses: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> };

export type GetFilterableStatusesQueryVariables = Exact<{
  location: FilterableStatusLocationType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterableStatusesQuery = { __typename?: 'Query', getFilterableStatuses: Array<{ __typename?: 'FilterableStatusObject', id: string, title: string, color?: string | null, active: boolean, isDeleted: boolean }> };

export type GetStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStatusQuery = { __typename?: 'Query', getStatus: { __typename?: 'StatusObject', color: string, active: boolean, propertyId?: string | null, id: string, title: string } };

export type StripeInvoiceFieldsFragment = { __typename?: 'StripeInvoiceObject', id: string, amountDue: number, amountPaid: number, createdAt: any, invoiceNumber?: string | null, invoiceLink?: string | null, status: string, subscriptionId?: string | null, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', title: string }, payment?: { __typename?: 'PaymentObject', id: string, status: string, amount: number, createdAt: any } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type GetStripeInvoicesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetStripeInvoicesQuery = { __typename?: 'Query', getStripeInvoices: { __typename?: 'GetStripeInvoicesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'StripeInvoiceObject', id: string, amountDue: number, amountPaid: number, createdAt: any, invoiceNumber?: string | null, status: string, subscriptionId?: string | null, paymentId?: string | null, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', title: string }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetStripeInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type GetStripeInvoiceQuery = { __typename?: 'Query', getStripeInvoice: { __typename?: 'StripeInvoiceObject', id: string, amountDue: number, amountPaid: number, createdAt: any, invoiceNumber?: string | null, invoiceLink?: string | null, status: string, subscriptionId?: string | null, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', title: string }, payment?: { __typename?: 'PaymentObject', id: string, status: string, amount: number, createdAt: any } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type HandleStripeOauthMutationVariables = Exact<{
  propertyId: Scalars['String'];
  code: Scalars['String'];
}>;


export type HandleStripeOauthMutation = { __typename?: 'Mutation', handleStripeOauth: boolean };

export type StripeSettingsFieldsFragment = { __typename?: 'StripeSettingsObject', paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null, paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null };

export type UpdateStripeSettingsMutationVariables = Exact<{
  data: StripeSettingsInput;
}>;


export type UpdateStripeSettingsMutation = { __typename?: 'Mutation', updateStripeSettings: { __typename?: 'StripeSettingsObject', paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null, paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null } };

export type GetStripeSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeSettingsQuery = { __typename?: 'Query', getStripeSettings: { __typename?: 'StripeSettingsObject', paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null, paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null } };

export type GetSubscriptionChargesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubscriptionChargesQuery = { __typename?: 'Query', getSubscriptionCharges: Array<{ __typename?: 'InvoiceItemObject', id: string, invoiceLink?: string | null, charges: Array<{ __typename?: 'ChargeItemObject', id: string, amount: number, amountRefunded: number, refunded: boolean, description?: string | null, createdAt: any }> }> };

export type SubscriptionFieldsFragment = { __typename?: 'SubscriptionObject', index: number, id: string, canceledAt?: any | null, createdAt: any, startDate?: string | null, nextChargeDate?: any | null, status: SubscriptionStatusEnum, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', id?: string | null, title: string, active?: boolean | null }, priceData: { __typename?: 'PriceStripeObject', id?: string | null, title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, waivers?: Array<{ __typename?: 'WaiverModel', id: string, active: boolean, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, waiverTemplate: { __typename?: 'WaiverTemplateModel', id: string, title: string } }> | null, customFields: Array<{ __typename?: 'SubscriptionProductCustomField', label: string, value?: string | null }> };

export type CreateSubscriptionMutationVariables = Exact<{
  data: SubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription?: { __typename?: 'SubscriptionObject', id: string } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
  data: SubscriptionUpdateInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'SubscriptionObject', index: number, id: string, canceledAt?: any | null, createdAt: any, startDate?: string | null, nextChargeDate?: any | null, status: SubscriptionStatusEnum, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', id?: string | null, title: string, active?: boolean | null }, priceData: { __typename?: 'PriceStripeObject', id?: string | null, title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, waivers?: Array<{ __typename?: 'WaiverModel', id: string, active: boolean, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, waiverTemplate: { __typename?: 'WaiverTemplateModel', id: string, title: string } }> | null, customFields: Array<{ __typename?: 'SubscriptionProductCustomField', label: string, value?: string | null }> } };

export type CancelSubscriptionMutationVariables = Exact<{
  data: SubscriptionCancelInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'SubscriptionObject', index: number, id: string, canceledAt?: any | null, createdAt: any, startDate?: string | null, nextChargeDate?: any | null, status: SubscriptionStatusEnum, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', id?: string | null, title: string, active?: boolean | null }, priceData: { __typename?: 'PriceStripeObject', id?: string | null, title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, waivers?: Array<{ __typename?: 'WaiverModel', id: string, active: boolean, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, waiverTemplate: { __typename?: 'WaiverTemplateModel', id: string, title: string } }> | null, customFields: Array<{ __typename?: 'SubscriptionProductCustomField', label: string, value?: string | null }> } };

export type RefundChargeMutationVariables = Exact<{
  data: RefundChargeInput;
}>;


export type RefundChargeMutation = { __typename?: 'Mutation', refundCharge: boolean };

export type CheckSubscriptionTrialMutationVariables = Exact<{
  data: SubscriptionTrialInput;
}>;


export type CheckSubscriptionTrialMutation = { __typename?: 'Mutation', checkSubscriptionTrial: boolean };

export type GenerateSubscriptionWaiverTextMutationVariables = Exact<{
  data: SubscriptionWaiverTextInput;
}>;


export type GenerateSubscriptionWaiverTextMutation = { __typename?: 'Mutation', generateSubscriptionWaiverText: { __typename?: 'SubscriptionWaiverTextModel', text: string } };

export type ValidateCouponMutationVariables = Exact<{
  data: CouponValidateInput;
}>;


export type ValidateCouponMutation = { __typename?: 'Mutation', validateCoupon: { __typename?: 'CouponValidationObject', discount: number, price: number, total: number } };

export type AddSubscriptionAttachmentsMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  attachments: Array<FileObjectInput> | FileObjectInput;
}>;


export type AddSubscriptionAttachmentsMutation = { __typename?: 'Mutation', addSubscriptionAttachments: { __typename?: 'SubscriptionObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type RemoveSubscriptionAttachmentMutationVariables = Exact<{
  id: Scalars['String'];
  attachmentId: Scalars['String'];
}>;


export type RemoveSubscriptionAttachmentMutation = { __typename?: 'Mutation', removeSubscriptionAttachment: { __typename?: 'SubscriptionObject', id: string, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetSubscriptionsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<SubscriptionStatusEnum> | SubscriptionStatusEnum>;
  billingPeriod?: InputMaybe<Array<PriceBillingPeriod> | PriceBillingPeriod>;
}>;


export type GetSubscriptionsQuery = { __typename?: 'Query', getSubscriptions: { __typename?: 'GetSubscriptionsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SubscriptionObject', index: number, id: string, canceledAt?: any | null, createdAt: any, startDate?: string | null, nextChargeDate?: any | null, status: SubscriptionStatusEnum, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', id?: string | null, title: string, active?: boolean | null }, priceData: { __typename?: 'PriceStripeObject', id?: string | null, title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubscriptionQuery = { __typename?: 'Query', getSubscription: { __typename?: 'SubscriptionObject', index: number, id: string, canceledAt?: any | null, createdAt: any, startDate?: string | null, nextChargeDate?: any | null, status: SubscriptionStatusEnum, type?: StripePaymentEnum | null, productData: { __typename?: 'ProductStripeObject', id?: string | null, title: string, active?: boolean | null }, priceData: { __typename?: 'PriceStripeObject', id?: string | null, title: string, paidPrice?: number | null, billingPeriod?: PriceBillingPeriod | null, type: PriceType }, couponData: { __typename?: 'CouponStripeObject', id?: string | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, waivers?: Array<{ __typename?: 'WaiverModel', id: string, active: boolean, pdf?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, waiverTemplate: { __typename?: 'WaiverTemplateModel', id: string, title: string } }> | null, customFields: Array<{ __typename?: 'SubscriptionProductCustomField', label: string, value?: string | null }> } };

export type SuiteCoreFieldsFragment = { __typename?: 'SuiteObject', id: string, title: string };

export type SuiteFieldsFragment = { __typename?: 'SuiteObject', index: number, type: SuiteType, size: number, bomaSize?: number | null, color?: string | null, isPublic: boolean, id: string, title: string, floor: { __typename?: 'FloorObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateSuiteMutationVariables = Exact<{
  data: SuiteInput;
}>;


export type CreateSuiteMutation = { __typename?: 'Mutation', createSuite: { __typename?: 'SuiteObject', id: string } };

export type UpdateSuiteMutationVariables = Exact<{
  id: Scalars['String'];
  data: SuiteInput;
}>;


export type UpdateSuiteMutation = { __typename?: 'Mutation', updateSuite: { __typename?: 'SuiteObject', index: number, type: SuiteType, size: number, bomaSize?: number | null, color?: string | null, isPublic: boolean, id: string, title: string, floor: { __typename?: 'FloorObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type RemoveSuitesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveSuitesMutation = { __typename?: 'Mutation', removeSuites: boolean };

export type ReorderSuitesMutationVariables = Exact<{
  floorId: Scalars['String'];
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderSuitesMutation = { __typename?: 'Mutation', reorderSuites: boolean };

export type GetSuitesTableQueryVariables = Exact<{
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<SuiteType> | SuiteType>;
  floorId?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetSuitesTableQuery = { __typename?: 'Query', getSuites: { __typename?: 'GetSuiteObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SuiteObject', index: number, type: SuiteType, size: number, isPublic: boolean, id: string, title: string, floor: { __typename?: 'FloorObject', id: string, title: string } }> } };

export type GetSuitesDropdownQueryVariables = Exact<{
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<SuiteType> | SuiteType>;
  floorId?: InputMaybe<Scalars['String']>;
  includeFloor: Scalars['Boolean'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetSuitesDropdownQuery = { __typename?: 'Query', getSuites: { __typename?: 'GetSuiteObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SuiteObject', type: SuiteType, id: string, title: string, floor?: { __typename?: 'FloorObject', id: string, title: string } }> } };

export type GetPublicSuitesQueryVariables = Exact<{
  propertyId: Scalars['String'];
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<SuiteType> | SuiteType>;
  floorId?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
}>;


export type GetPublicSuitesQuery = { __typename?: 'Query', getPublicSuites: { __typename?: 'GetSuiteObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'SuiteObject', type: SuiteType, id: string, title: string }> } };

export type GetSuiteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSuiteQuery = { __typename?: 'Query', getSuite: { __typename?: 'SuiteObject', index: number, type: SuiteType, size: number, bomaSize?: number | null, color?: string | null, isPublic: boolean, id: string, title: string, floor: { __typename?: 'FloorObject', id: string, title: string }, attachment?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ExportSuitesQueryVariables = Exact<{
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<SuiteType> | SuiteType>;
  floorId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExportSuitesQuery = { __typename?: 'Query', exportSuites: string };

export type TaxCoreFieldsFragment = { __typename?: 'TaxObject', id: string, title: string };

export type TaxFieldsFragment = { __typename?: 'TaxObject', amount: number, active: boolean, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateTaxMutationVariables = Exact<{
  data: TaxInput;
}>;


export type CreateTaxMutation = { __typename?: 'Mutation', createTax: { __typename?: 'TaxObject', id: string } };

export type UpdateTaxMutationVariables = Exact<{
  id: Scalars['String'];
  data: TaxInput;
}>;


export type UpdateTaxMutation = { __typename?: 'Mutation', updateTax: { __typename?: 'TaxObject', amount: number, active: boolean, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleTaxMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleTaxMutation = { __typename?: 'Mutation', toggleTax: boolean };

export type RemoveTaxesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveTaxesMutation = { __typename?: 'Mutation', removeTaxes: boolean };

export type GetTaxesTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTaxesTableQuery = { __typename?: 'Query', getTaxes: Array<{ __typename?: 'TaxObject', index: number, active: boolean, amount: number, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetTaxesDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetTaxesDropdownQuery = { __typename?: 'Query', getTaxes: Array<{ __typename?: 'TaxObject', active: boolean, amount: number, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetTaxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaxQuery = { __typename?: 'Query', getTax: { __typename?: 'TaxObject', amount: number, active: boolean, propertyId?: string | null, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type TranslationCoreFieldsFragment = { __typename?: 'TranslationObject', id: string, title: string };

export type TranslationFieldsFragment = { __typename?: 'TranslationObject', id: string, title: string, countryCode: string, sources: any, translations?: any | null };

export type FileFieldsFragment = { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string };

export type UploadFilesMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  save?: InputMaybe<Scalars['Boolean']>;
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', uploadFiles: Array<{ __typename?: 'UploadFileDTO', name: string, size: number, url: string }> };

export type UserPaymentMethodFieldsFragment = { __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null };

export type CreateUserPaymentMethodMutationVariables = Exact<{
  userId: Scalars['String'];
  paymentMethod: PaymentMethodTypeEnum;
}>;


export type CreateUserPaymentMethodMutation = { __typename?: 'Mutation', createUserPaymentMethod: { __typename?: 'StripeSetupIntent', clientSecret: string } };

export type SaveUserVerificationPaymentMethodMutationVariables = Exact<{
  data: UserVerificationPaymentMethodInput;
}>;


export type SaveUserVerificationPaymentMethodMutation = { __typename?: 'Mutation', saveUserVerificationPaymentMethod: boolean };

export type SetUserDefaultPaymentMethodMutationVariables = Exact<{
  data: UserPaymentMethodInput;
}>;


export type SetUserDefaultPaymentMethodMutation = { __typename?: 'Mutation', setUserDefaultPaymentMethod: boolean };

export type RemoveUserPaymentMethodMutationVariables = Exact<{
  data: UserPaymentMethodInput;
}>;


export type RemoveUserPaymentMethodMutation = { __typename?: 'Mutation', removeUserPaymentMethod: boolean };

export type GetUserPaymentMethodsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserPaymentMethodsQuery = { __typename?: 'Query', getUserPaymentMethods: Array<{ __typename?: 'PaymentMethodDTO', id: string, type?: PaymentMethodTypeEnum | null, isPrimary: boolean, verificationUrl?: string | null, card?: { __typename?: 'Card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, us_bank_account?: { __typename?: 'ACHDetails', bank_name?: string | null, routing_number?: string | null, last4?: string | null, account_type?: string | null, account_holder_type?: string | null } | null }> };

export type UserWidgetFieldsFragment = { __typename?: 'UserWidgetObject', id: string, title: string, color?: string | null, icon: string, type: DashboardWidgetEnum, layout?: { __typename?: 'UserWidgetLayoutModel', x: number, y: number, w: number, h: number } | null };

export type SaveUserWidgetMutationVariables = Exact<{
  data: UserDashboardWidgetInput;
}>;


export type SaveUserWidgetMutation = { __typename?: 'Mutation', saveUserWidget: { __typename?: 'UserWidgetObject', id: string } };

export type UpdateUserWidgetsLayoutMutationVariables = Exact<{
  data: Array<UpdateUserDashboardWidgetInput> | UpdateUserDashboardWidgetInput;
}>;


export type UpdateUserWidgetsLayoutMutation = { __typename?: 'Mutation', updateUserWidgetsLayout: boolean };

export type RemoveUserWidgetMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserWidgetMutation = { __typename?: 'Mutation', removeUserWidget: boolean };

export type GetUserAvailableWidgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAvailableWidgetsQuery = { __typename?: 'Query', getUserAvailableWidgets: Array<{ __typename?: 'UserAvailableWidgetObject', type: DashboardWidgetEnum, title?: string | null, icon?: string | null }> };

export type GetUserWidgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWidgetsQuery = { __typename?: 'Query', getUserWidgets: Array<{ __typename?: 'UserWidgetObject', id: string, title: string, color?: string | null, icon: string, type: DashboardWidgetEnum, layout?: { __typename?: 'UserWidgetLayoutModel', x: number, y: number, w: number, h: number } | null }> };

export type GetUserWidgetContentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserWidgetContentQuery = { __typename?: 'Query', getUserWidgetContent: { __typename?: 'UserWidgetContents', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'UserWidgetContentObject', id: string, index?: number | null, title: string, status: { __typename?: 'ObjectStatus', title: string, color?: string | null }, additionalData?: Array<{ __typename?: 'ObjectAdds', key: FieldKeyEnum, title: string, html: boolean }> | null }> } };

export type LoggedInUserFieldsFragment = { __typename?: 'UserLoggedObject', id: string, properties: Array<{ __typename?: 'PropertyObject', id: string, title: string, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> };

export type UserCoreFieldsFragment = { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type UserFieldsFragment = { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, buildings: Array<{ __typename?: 'BuildingObject', id: string, title: string }>, primaryBuilding?: { __typename?: 'BuildingObject', id: string, title: string } | null, companies: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }>, primaryCompany?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, role: { __typename?: 'RoleObject', id: string, title: string }, authSecurity?: { __typename?: 'UserSettingObject', two_fa_email?: boolean | null, two_fa_phone?: boolean | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateUserMutationVariables = Exact<{
  data: UserPropertyCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserObject', id: string } };

export type AddUserToPropertyMutationVariables = Exact<{
  data: UserPropertyAddInput;
}>;


export type AddUserToPropertyMutation = { __typename?: 'Mutation', addUserToProperty: { __typename?: 'UserObject', id: string } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  data: UserPropertyUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, buildings: Array<{ __typename?: 'BuildingObject', id: string, title: string }>, primaryBuilding?: { __typename?: 'BuildingObject', id: string, title: string } | null, companies: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }>, primaryCompany?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, role: { __typename?: 'RoleObject', id: string, title: string }, authSecurity?: { __typename?: 'UserSettingObject', two_fa_email?: boolean | null, two_fa_phone?: boolean | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateUserPhotoMutationVariables = Exact<{
  id: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
}>;


export type UpdateUserPhotoMutation = { __typename?: 'Mutation', updateUserPhoto: { __typename?: 'UserObject', id: string, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type BulkStatusUserMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  status?: InputMaybe<UserStatuses>;
}>;


export type BulkStatusUserMutation = { __typename?: 'Mutation', bulkStatusUser: { __typename?: 'UserBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'UserObject', id: string, status: UserStatuses }> | null } };

export type UpdateUserPrinterMutationVariables = Exact<{
  id: Scalars['String'];
  printerId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPrinterMutation = { __typename?: 'Mutation', updateUserPrinter: { __typename?: 'UserObject', id: string, printer?: { __typename?: 'PrinterModel', id: string, title: string } | null } };

export type UpdateUserPreferenceMutationVariables = Exact<{
  data: UserPropertyPreferenceInput;
}>;


export type UpdateUserPreferenceMutation = { __typename?: 'Mutation', updateUserPreference: { __typename?: 'UserObject', homepageId?: string | null, printer?: { __typename?: 'PrinterModel', id: string, title: string } | null } };

export type ToggleLoginAuthMutationVariables = Exact<{
  data: ToggleLoginAuthInput;
}>;


export type ToggleLoginAuthMutation = { __typename?: 'Mutation', toggleLoginAuth: boolean };

export type VerifyPhoneMutationVariables = Exact<{
  data: VerifyPhoneInput;
}>;


export type VerifyPhoneMutation = { __typename?: 'Mutation', verifyPhone: boolean };

export type UpdateUserPhoneMutationVariables = Exact<{
  data: UpdateUserPhoneInput;
}>;


export type UpdateUserPhoneMutation = { __typename?: 'Mutation', updateUserPhone: boolean };

export type RemoveUserPhoneMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveUserPhoneMutation = { __typename?: 'Mutation', removeUserPhone: boolean };

export type ToggleMyNotificationMutationVariables = Exact<{
  toggleType: EmailToggleEnum;
  type: EmailTemplateType;
}>;


export type ToggleMyNotificationMutation = { __typename?: 'Mutation', toggleMyNotification: boolean };

export type ResendWelcomeEmailMutationVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ResendWelcomeEmailMutation = { __typename?: 'Mutation', resendWelcomeEmail: boolean };

export type MeQueryVariables = Exact<{
  portfolioId: Scalars['String'];
}>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserLoggedObject', id: string, properties: Array<{ __typename?: 'PropertyObject', id: string, title: string, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUsersTableQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatuses>;
  search?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  fullAccessBuildingUsers?: InputMaybe<UserFullAccessEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  fullAccessCompanyUsers?: InputMaybe<UserFullAccessEnum>;
  sortBy?: SortUserFieldEnum;
  sortByDir?: SortDirectionEnum;
  orderByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetUsersTableQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'UserObject', index: number, id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, buildings: Array<{ __typename?: 'BuildingObject', id: string, title: string }>, role: { __typename?: 'RoleObject', id: string, title: string }, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUsersDropdownQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatuses>;
  search?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  fullAccessBuildingUsers?: InputMaybe<UserFullAccessEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  fullAccessCompanyUsers?: UserFullAccessEnum;
  sortBy?: SortUserFieldEnum;
  sortByDir?: SortDirectionEnum;
  orderByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetUsersDropdownQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, buildings: Array<{ __typename?: 'BuildingObject', id: string, title: string }>, primaryBuilding?: { __typename?: 'BuildingObject', id: string, title: string } | null, companies: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }>, primaryCompany?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, role: { __typename?: 'RoleObject', id: string, title: string }, authSecurity?: { __typename?: 'UserSettingObject', two_fa_email?: boolean | null, two_fa_phone?: boolean | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ValidateUserEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ValidateUserEmailQuery = { __typename?: 'Query', validateUserEmail?: { __typename?: 'UserObject', id: string, firstName: string, lastName: string } | null };

export type CheckUserPermissionsQueryVariables = Exact<{
  data: UserCheckPermissionsInput;
}>;


export type CheckUserPermissionsQuery = { __typename?: 'Query', checkUserPermissions: Array<boolean> };

export type GetMyNotificationsSettingsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMyNotificationsSettingsQuery = { __typename?: 'Query', getMyNotificationsSettings: Array<{ __typename?: 'UserSettingNotificationObject', trigger: string, type: EmailTemplateType, category: string, appActive: boolean, appUserActive: boolean, emailActive: boolean, emailUserActive: boolean, smsActive: boolean, smsUserActive: boolean }> };

export type ExportUsersQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<UserStatuses>;
  search?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryBuildingId?: InputMaybe<Scalars['String']>;
  fullAccessBuildingUsers?: InputMaybe<UserFullAccessEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  primaryCompanyId?: InputMaybe<Scalars['String']>;
  fullAccessCompanyUsers?: InputMaybe<UserFullAccessEnum>;
  sortBy?: SortUserFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type ExportUsersQuery = { __typename?: 'Query', exportUsers: string };

export type VendorAccessVisitCoreFieldsFragment = { __typename?: 'VendorAccessVisitModel', id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> };

export type VendorAccessFieldsFragment = { __typename?: 'VendorAccessModel', id: string, code: number, status: VendorAccessStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, coi: { __typename?: 'CoiObject', status: CoiStatusEnum, id: string, title: string }, visit: { __typename?: 'VendorAccessVisitModel', notes?: string | null, id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type StoreVendorAccessMutationVariables = Exact<{
  data: StoreVendorAccessInput;
}>;


export type StoreVendorAccessMutation = { __typename?: 'Mutation', storeVendorAccess: boolean };

export type UpdateVendorAccessVisitMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateVendorAccessInput;
}>;


export type UpdateVendorAccessVisitMutation = { __typename?: 'Mutation', updateVendorAccessVisit: { __typename?: 'VendorAccessModel', id: string, code: number, status: VendorAccessStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, coi: { __typename?: 'CoiObject', status: CoiStatusEnum, id: string, title: string }, visit: { __typename?: 'VendorAccessVisitModel', notes?: string | null, id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type BulkStatusVendorAccessMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  status: VendorAccessStatusEnum;
}>;


export type BulkStatusVendorAccessMutation = { __typename?: 'Mutation', bulkStatusVendorAccess: { __typename?: 'VendorAccessBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'VendorAccessModel', id: string, status: VendorAccessStatusEnum }> | null } };

export type VendorAccessWebCheckInMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type VendorAccessWebCheckInMutation = { __typename?: 'Mutation', vendorAccessWebCheckIn: { __typename?: 'VendorAccessActionObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'VendorAccessModel', id: string, visit: { __typename?: 'VendorAccessVisitModel', id: string, checkInDates?: Array<string> | null } }> | null } };

export type PrintVendorAccessBadgeMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type PrintVendorAccessBadgeMutation = { __typename?: 'Mutation', printVendorAccessBadge: { __typename?: 'VendorAccessPrintActionObject', notification: boolean, errorCount: number, errorMessages?: Array<string> | null, successCount: number } };

export type NotifyVendorAccessMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
}>;


export type NotifyVendorAccessMutation = { __typename?: 'Mutation', notifyVendorAccess: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> };

export type DeleteVendorAccessAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteVendorAccessAttachmentMutation = { __typename?: 'Mutation', deleteVendorAccessAttachment: boolean };

export type GetVendorAccessListQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hostIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<VendorAccessStatusEnum> | VendorAccessStatusEnum>;
}>;


export type GetVendorAccessListQuery = { __typename?: 'Query', getVendorAccessList: { __typename?: 'GetVendorAccessListObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'VendorAccessModel', id: string, code: number, status: VendorAccessStatusEnum, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, coi: { __typename?: 'CoiObject', id: string, title: string }, visit: { __typename?: 'VendorAccessVisitModel', id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> } }> } };

export type GetVendorAccessQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVendorAccessQuery = { __typename?: 'Query', getVendorAccess: { __typename?: 'VendorAccessModel', id: string, code: number, status: VendorAccessStatusEnum, createdAt: any, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, coi: { __typename?: 'CoiObject', status: CoiStatusEnum, id: string, title: string }, visit: { __typename?: 'VendorAccessVisitModel', notes?: string | null, id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, notifyUsers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetVendorAccessPrintQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVendorAccessPrintQuery = { __typename?: 'Query', getVendorAccess: { __typename?: 'VendorAccessModel', id: string, code: number, status: VendorAccessStatusEnum, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, visit: { __typename?: 'VendorAccessVisitModel', id: string, type: VendorAccessVisitTypeEnum, startTime?: string | null, endTime?: string | null, timezone: string, checkInDates?: Array<string> | null, allDayAccess?: boolean | null, dates: Array<{ __typename?: 'VendorAccessVisitDateObject', date: string }> } } };

export type GetVendorAccessQrCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVendorAccessQrCodeQuery = { __typename?: 'Query', getVendorAccessQrCode: string };

export type ExportVendorAccessListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hostIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<VendorAccessStatusEnum> | VendorAccessStatusEnum>;
}>;


export type ExportVendorAccessListQuery = { __typename?: 'Query', exportVendorAccessList: string };

export type WaiverTemplateCoreFieldsFragment = { __typename?: 'WaiverTemplateModel', id: string, title: string };

export type WaiverTemplateFieldsFragment = { __typename?: 'WaiverTemplateModel', text: string, isActive: boolean, isPublic: boolean, type: WaiverTypesEnum, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type CreateWaiverTemplateMutationVariables = Exact<{
  data: WaiverInput;
}>;


export type CreateWaiverTemplateMutation = { __typename?: 'Mutation', createWaiverTemplate: { __typename?: 'WaiverTemplateModel', id: string } };

export type UpdateWaiverTemplateMutationVariables = Exact<{
  id: Scalars['String'];
  data: WaiverUpdateInput;
}>;


export type UpdateWaiverTemplateMutation = { __typename?: 'Mutation', updateWaiverTemplate: { __typename?: 'WaiverTemplateModel', text: string, isActive: boolean, isPublic: boolean, type: WaiverTypesEnum, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type RemoveWaiverTemplatesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveWaiverTemplatesMutation = { __typename?: 'Mutation', removeWaiverTemplates: boolean };

export type GetWaiverTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WaiverTypesEnum>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetWaiverTemplatesQuery = { __typename?: 'Query', getWaiverTemplates: Array<{ __typename?: 'WaiverTemplateModel', text: string, isActive: boolean, isPublic: boolean, type: WaiverTypesEnum, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> };

export type GetWaiverTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWaiverTemplateQuery = { __typename?: 'Query', getWaiverTemplate: { __typename?: 'WaiverTemplateModel', text: string, isActive: boolean, isPublic: boolean, type: WaiverTypesEnum, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type GetWaiverVariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaiverVariablesQuery = { __typename?: 'Query', getWaiverVariables: Array<string> };

export type WatchlistCoreFieldsFragment = { __typename?: 'WatchlistObject', index: number, id: string, active: boolean, firstName: string, lastName: string, description?: string | null, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type WatchlistFieldsFragment = { __typename?: 'WatchlistObject', index: number, id: string, active: boolean, firstName: string, lastName: string, description?: string | null, createdAt?: any | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateWatchlistMutationVariables = Exact<{
  data: WatchlistInput;
}>;


export type CreateWatchlistMutation = { __typename?: 'Mutation', createWatchlist: { __typename?: 'WatchlistObject', id: string } };

export type UpdateWatchlistMutationVariables = Exact<{
  id: Scalars['String'];
  data: WatchlistUpdateInput;
}>;


export type UpdateWatchlistMutation = { __typename?: 'Mutation', updateWatchlist: { __typename?: 'WatchlistObject', index: number, id: string, active: boolean, firstName: string, lastName: string, description?: string | null, createdAt?: any | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ToggleWatchlistMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleWatchlistMutation = { __typename?: 'Mutation', toggleWatchlist: boolean };

export type RemoveWatchlistMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveWatchlistMutation = { __typename?: 'Mutation', removeWatchlist: boolean };

export type DeleteWatchlistAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteWatchlistAttachmentMutation = { __typename?: 'Mutation', deleteWatchlistAttachment: boolean };

export type GetWatchlistQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWatchlistQuery = { __typename?: 'Query', getWatchlist: { __typename?: 'GetWatchlistObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WatchlistObject', index: number, id: string, active: boolean, firstName: string, lastName: string, description?: string | null, createdAt?: any | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetSingleWatchlistQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSingleWatchlistQuery = { __typename?: 'Query', getSingleWatchlist: { __typename?: 'WatchlistObject', index: number, id: string, active: boolean, firstName: string, lastName: string, description?: string | null, createdAt?: any | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type CheckGuestWatchlistQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckGuestWatchlistQuery = { __typename?: 'Query', checkGuestWatchlist: Array<{ __typename?: 'WatchlistObject', id: string, firstName: string, lastName: string, userPhoto?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> };

export type ExportWatchlistQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportWatchlistQuery = { __typename?: 'Query', exportWatchlist: string };

export type GetWorkOrderStatusWidgetQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderStatusWidgetQuery = { __typename?: 'Query', getWOStatusWidget: Array<{ __typename?: 'WOStatusWidget', name: string, count: number, percentage: number, color: string }> };

export type GetWorkOrderReviewsWidgetQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderReviewsWidgetQuery = { __typename?: 'Query', getWOReviewsWidget: Array<{ __typename?: 'WOReviewWidget', name: string, count: number }> };

export type GetWorkOrderRevenueWidgetQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderRevenueWidgetQuery = { __typename?: 'Query', getWORevenueWidget: Array<{ __typename?: 'WORevenueWidget', name: string, laborRevenue: number, markupRevenue: number, materialRevenue: number }> };

export type GetWorkOrderCategoryWidgetQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderCategoryWidgetQuery = { __typename?: 'Query', getWOCategoryWidget: Array<{ __typename?: 'WOCategoryWidget', name: string, count: number }> };

export type GetCoiWidgetQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
}>;


export type GetCoiWidgetQuery = { __typename?: 'Query', getCOIWidget: Array<{ __typename?: 'COIWidget', name: CoiWidgetStatusEnum, count: number, percentage: number }> };

export type GetTaskOpenWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskOpenWidgetQuery = { __typename?: 'Query', getTaskOpenWidget: { __typename?: 'TaskOpenWidget', count: number } };

export type GetTaskOverdueWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskOverdueWidgetQuery = { __typename?: 'Query', getTaskOverdueWidget: { __typename?: 'TaskOverdueWidget', count: number } };

export type GetGeneaAttendanceWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneaAttendanceWidgetQuery = { __typename?: 'Query', getGeneaAttendanceWidget: number };

export type GetAmanoOccupancyWidgetQueryVariables = Exact<{
  facilityId: Scalars['String'];
}>;


export type GetAmanoOccupancyWidgetQuery = { __typename?: 'Query', getAmanoOccupancyWidget: { __typename?: 'AmanoOccupancyWidget', contract?: { __typename?: 'AmanoOccupancyGroupObject', occupied: number } | null, transient?: { __typename?: 'AmanoOccupancyGroupObject', occupied: number } | null, overall?: { __typename?: 'AmanoOccupancyGroupObject', occupied: number, available: number } | null } };

export type WorkOrderTemplateFieldsFragment = { __typename?: 'WorkOrderTemplateObject', id: string, index: number, description?: string | null, recordStatus: RRuleStatuses, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null };

export type CreateWorkOrderTemplateMutationVariables = Exact<{
  data: WorkOrderTemplateInput;
}>;


export type CreateWorkOrderTemplateMutation = { __typename?: 'Mutation', createWorkOrderTemplate: { __typename?: 'WorkOrderTemplateObject', id: string } };

export type UpdateWorkOrderTemplateMutationVariables = Exact<{
  templateId: Scalars['String'];
  data: WorkOrderTemplateUpdateInput;
}>;


export type UpdateWorkOrderTemplateMutation = { __typename?: 'Mutation', updateWorkOrderTemplate: { __typename?: 'WorkOrderTemplateObject', id: string, index: number, description?: string | null, recordStatus: RRuleStatuses, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type UpdateWoTemplateNextGenerationDateMutationVariables = Exact<{
  id: Scalars['String'];
  nextGenerationDate: Scalars['DateTime'];
}>;


export type UpdateWoTemplateNextGenerationDateMutation = { __typename?: 'Mutation', updateWOTemplateNextGenerationDate: { __typename?: 'WorkOrderTemplateObject', id: string, nextGenerationDate?: any | null } };

export type RemoveWorkOrderTemplatesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveWorkOrderTemplatesMutation = { __typename?: 'Mutation', removeWorkOrderTemplates: boolean };

export type SkipWoTemplateDateMutationVariables = Exact<{
  templateId: Scalars['String'];
  date: Scalars['String'];
}>;


export type SkipWoTemplateDateMutation = { __typename?: 'Mutation', skipWOTemplateDate: { __typename?: 'WorkOrderTemplateObject', id: string, nextGenerationDate?: any | null, excludeDates?: Array<string> | null } };

export type GenerateWorkOrderMutationVariables = Exact<{
  templateId: Scalars['String'];
}>;


export type GenerateWorkOrderMutation = { __typename?: 'Mutation', generateWorkOrder: boolean };

export type BulkPauseWoTemplateMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  pause: Scalars['Boolean'];
}>;


export type BulkPauseWoTemplateMutation = { __typename?: 'Mutation', bulkPauseWOTemplate: { __typename?: 'WorkOrderTemplateBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'WorkOrderTemplateObject', id: string, recordStatus: RRuleStatuses }> | null } };

export type BulkSkipNextWoTemplateMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkSkipNextWoTemplateMutation = { __typename?: 'Mutation', bulkSkipNextWOTemplate: { __typename?: 'WorkOrderTemplateBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'WorkOrderTemplateObject', id: string, recordStatus: RRuleStatuses, nextGenerationDate?: any | null, excludeDates?: Array<string> | null }> | null } };

export type DeleteWoTemplateAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  templateId: Scalars['String'];
}>;


export type DeleteWoTemplateAttachmentMutation = { __typename?: 'Mutation', deleteWOTemplateAttachment: boolean };

export type GetWorkOrderTemplatesQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWorkOrderTemplatesQuery = { __typename?: 'Query', getWorkOrderTemplates: { __typename?: 'GetWorkOrderTemplatesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderTemplateObject', id: string, index: number, description?: string | null, recordStatus: RRuleStatuses, rruleText?: string | null, createdAt: any, startDate: any, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } }> } };

export type GetWorkOrderTemplatesCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWorkOrderTemplatesCalendarQuery = { __typename?: 'Query', getWorkOrderTemplatesCalendar: Array<{ __typename?: 'WorkOrderTemplatesCalendarObject', dates: Array<any>, record: { __typename?: 'WorkOrderTemplateObject', id: string, index: number, recordStatus: RRuleStatuses, category: { __typename?: 'CategoryObject', id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } }> };

export type GetWorkOrderTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWorkOrderTemplateQuery = { __typename?: 'Query', getWorkOrderTemplate: { __typename?: 'WorkOrderTemplateObject', id: string, index: number, description?: string | null, recordStatus: RRuleStatuses, createdAt: any, startDate: any, dueAfterDays?: number | null, nextGenerationDate?: any | null, prevGenerationDate?: any | null, excludeDates?: Array<string> | null, timezone: string, charges?: number | null, rruleText?: string | null, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, rruleObject: { __typename?: 'RRuleObject', frequency: RRuleFrequencyType, interval: number, monthlyType?: RRuleMonthlyTypes | null, weekDay?: RRuleWeekdays | null, monthDay?: number | null, pos?: RRulePos | null, days?: Array<RRuleWeekdays> | null, end: { __typename?: 'RRuleEndObject', count?: number | null, date?: string | null, type: RRuleEndType } }, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null } };

export type GetWorkOrderTemplateChargesQueryVariables = Exact<{
  workOrderTemplateId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderTemplateChargesQuery = { __typename?: 'Query', getWorkOrderTemplateCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, billable: boolean, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type GetWorkOrderTemplateRelatedRecordsQueryVariables = Exact<{
  workOrderTemplateId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderTemplateRelatedRecordsQuery = { __typename?: 'Query', getWorkOrderTemplateRelatedRecords: { __typename?: 'GetWorkOrdersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderObject', id: string, index: number, createdAt: any, charges?: number | null, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type ExportWorkOrderTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  recordStatuses?: InputMaybe<Array<RRuleStatuses> | RRuleStatuses>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportWorkOrderTemplatesQuery = { __typename?: 'Query', exportWorkOrderTemplates: string };

export type WorkOrderEmailCoreFieldsFragment = { __typename?: 'WorkOrderEmailObject', id: string, title: string };

export type WorkOrderEmailFieldsFragment = { __typename?: 'WorkOrderEmailObject', email: string, emailSlug: string, allowUnknownSender: boolean, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category: { __typename?: 'CategoryObject', id: string, title: string }, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null };

export type CreateWorkOrderEmailMutationVariables = Exact<{
  data: WorkOrderEmailInput;
}>;


export type CreateWorkOrderEmailMutation = { __typename?: 'Mutation', createWorkOrderEmail: { __typename?: 'WorkOrderEmailObject', id: string, email: string } };

export type UpdateWorkOrderEmailMutationVariables = Exact<{
  id: Scalars['String'];
  data: WorkOrderEmailInput;
}>;


export type UpdateWorkOrderEmailMutation = { __typename?: 'Mutation', updateWorkOrderEmail: { __typename?: 'WorkOrderEmailObject', email: string, emailSlug: string, allowUnknownSender: boolean, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category: { __typename?: 'CategoryObject', id: string, title: string }, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null } };

export type ToggleWorkOrderEmailMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleWorkOrderEmailMutation = { __typename?: 'Mutation', toggleWorkOrderEmail: boolean };

export type RemoveWorkOrderEmailsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveWorkOrderEmailsMutation = { __typename?: 'Mutation', removeWorkOrderEmails: boolean };

export type GetWorkOrderEmailsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetWorkOrderEmailsQuery = { __typename?: 'Query', getWorkOrderEmails: { __typename?: 'GetWorkOrderEmailsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderEmailObject', email: string, index: number, active: boolean, id: string, title: string, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, building: { __typename?: 'BuildingObject', id: string, title: string } }> } };

export type GetWorkOrderEmailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWorkOrderEmailQuery = { __typename?: 'Query', getWorkOrderEmail: { __typename?: 'WorkOrderEmailObject', email: string, emailSlug: string, allowUnknownSender: boolean, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category: { __typename?: 'CategoryObject', id: string, title: string }, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null } };

export type WorkOrderGuestFormCoreFieldsFragment = { __typename?: 'GuestWOFormObject', id: string, title: string };

export type WorkOrderGuestFormFieldsFragment = { __typename?: 'GuestWOFormObject', subTitle?: string | null, hasStatus: boolean, statusRequired: boolean, hasPriority: boolean, priorityRequired: boolean, hasAssignee: boolean, assigneeRequired: boolean, hasFloor: boolean, floorRequired: boolean, hasSuite: boolean, suiteRequired: boolean, hasAttachments: boolean, attachmentsRequired: boolean, attachmentTypes: Array<string>, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignee?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null };

export type CreateGuestWorkOrderFormMutationVariables = Exact<{
  data: GuestWoFormInput;
}>;


export type CreateGuestWorkOrderFormMutation = { __typename?: 'Mutation', createGuestWorkOrderForm: { __typename?: 'GuestWOFormObject', id: string } };

export type UpdateGuestWorkOrderFormMutationVariables = Exact<{
  formId: Scalars['String'];
  data: GuestWoFormUpdateInput;
}>;


export type UpdateGuestWorkOrderFormMutation = { __typename?: 'Mutation', updateGuestWorkOrderForm: { __typename?: 'GuestWOFormObject', subTitle?: string | null, hasStatus: boolean, statusRequired: boolean, hasPriority: boolean, priorityRequired: boolean, hasAssignee: boolean, assigneeRequired: boolean, hasFloor: boolean, floorRequired: boolean, hasSuite: boolean, suiteRequired: boolean, hasAttachments: boolean, attachmentsRequired: boolean, attachmentTypes: Array<string>, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignee?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null } };

export type ToggleGuestWorkOrderFormMutationVariables = Exact<{
  formId: Scalars['String'];
}>;


export type ToggleGuestWorkOrderFormMutation = { __typename?: 'Mutation', toggleGuestWorkOrderForm: boolean };

export type RemoveGuestWorkOrderFormMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveGuestWorkOrderFormMutation = { __typename?: 'Mutation', removeGuestWorkOrderForm: boolean };

export type CreatePublicWorkOrderMutationVariables = Exact<{
  data: WorkOrderPublicInput;
}>;


export type CreatePublicWorkOrderMutation = { __typename?: 'Mutation', createPublicWorkOrder: boolean };

export type GetGuestWorkOrderFormsQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGuestWorkOrderFormsQuery = { __typename?: 'Query', getGuestWorkOrderForms: { __typename?: 'GetForms', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'GuestWOFormObject', index: number, subTitle?: string | null, active: boolean, id: string, title: string, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, building: { __typename?: 'BuildingObject', id: string, title: string } }> } };

export type GetGuestWorkOrderFormQueryVariables = Exact<{
  formId: Scalars['String'];
}>;


export type GetGuestWorkOrderFormQuery = { __typename?: 'Query', getGuestWorkOrderForm: { __typename?: 'GuestWOFormObject', subTitle?: string | null, hasStatus: boolean, statusRequired: boolean, hasPriority: boolean, priorityRequired: boolean, hasAssignee: boolean, assigneeRequired: boolean, hasFloor: boolean, floorRequired: boolean, hasSuite: boolean, suiteRequired: boolean, hasAttachments: boolean, attachmentsRequired: boolean, attachmentTypes: Array<string>, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, requestedFor: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company?: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignee?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null } };

export type GetPublicGuestWorkOrderFormQueryVariables = Exact<{
  formId: Scalars['String'];
}>;


export type GetPublicGuestWorkOrderFormQuery = { __typename?: 'Query', getGuestWorkOrderForm: { __typename?: 'GuestWOFormObject', subTitle?: string | null, propertyId: string, hasStatus: boolean, statusRequired: boolean, hasPriority: boolean, priorityRequired: boolean, hasAssignee: boolean, assigneeRequired: boolean, hasFloor: boolean, floorRequired: boolean, hasSuite: boolean, suiteRequired: boolean, hasAttachments: boolean, attachmentsRequired: boolean, attachmentTypes: Array<string>, id: string, title: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category?: { __typename?: 'CategoryObject', id: string, title: string } | null, status?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, assignee?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null } };

export type WorkOrdersStatusSettingsFieldsFragment = { __typename?: 'WorkOrderStatusSettingObject', acknowledge?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, closed: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }>, default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, rating: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> };

export type GetWorkOrderStatusSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkOrderStatusSettingsQuery = { __typename?: 'Query', getWorkOrderStatusSetting: { __typename?: 'WorkOrderStatusSettingObject', acknowledge?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, closed: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }>, default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, rating: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> } };

export type WorkOrderFieldsFragment = { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, workOrderTemplate?: { __typename?: 'WorkOrderTemplateObject', id: string, index: number } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> };

export type CreateWorkOrderMutationVariables = Exact<{
  data: WorkOrderInput;
}>;


export type CreateWorkOrderMutation = { __typename?: 'Mutation', createWorkOrder: { __typename?: 'WorkOrderObject', id: string } };

export type UpdateWorkOrderMutationVariables = Exact<{
  id: Scalars['String'];
  data: WorkOrderUpdateInput;
}>;


export type UpdateWorkOrderMutation = { __typename?: 'Mutation', updateWorkOrder: { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, workOrderTemplate?: { __typename?: 'WorkOrderTemplateObject', id: string, index: number } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type BulkStatusWoMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
}>;


export type BulkStatusWoMutation = { __typename?: 'Mutation', bulkStatusWO: { __typename?: 'WorkOrderBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'WorkOrderObject', id: string, closedAt?: any | null, status: { __typename?: 'StatusObject', color: string, id: string, title: string } }> | null } };

export type BulkAssigneeWoMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  assignedToId?: InputMaybe<Scalars['String']>;
}>;


export type BulkAssigneeWoMutation = { __typename?: 'Mutation', bulkAssigneeWO: { __typename?: 'WorkOrderBulkObject', errorCount: number, errorMessages?: Array<string> | null, successCount: number, data?: Array<{ __typename?: 'WorkOrderObject', id: string, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> | null } };

export type ArchiveWorkOrdersMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ArchiveWorkOrdersMutation = { __typename?: 'Mutation', archiveWorkOrders: boolean };

export type UnArchiveWorkOrdersMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnArchiveWorkOrdersMutation = { __typename?: 'Mutation', unArchiveWorkOrders: boolean };

export type RemoveWorkOrdersMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveWorkOrdersMutation = { __typename?: 'Mutation', removeWorkOrders: boolean };

export type DeleteWoAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteWoAttachmentMutation = { __typename?: 'Mutation', deleteWOAttachment: boolean };

export type CreateWoReviewMutationVariables = Exact<{
  data: WorkOrderReviewInput;
}>;


export type CreateWoReviewMutation = { __typename?: 'Mutation', createWOReview: boolean };

export type WorkOrderSubscribeMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
}>;


export type WorkOrderSubscribeMutation = { __typename?: 'Mutation', workOrderSubscribe: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> };

export type AcknowledgeWorkOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AcknowledgeWorkOrderMutation = { __typename?: 'Mutation', acknowledgeWorkOrder: { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, workOrderTemplate?: { __typename?: 'WorkOrderTemplateObject', id: string, index: number } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type ShareWorkOrderMutationVariables = Exact<{
  data: WorkOrderShareInput;
}>;


export type ShareWorkOrderMutation = { __typename?: 'Mutation', shareWorkOrder: boolean };

export type AddWorkOrderEquipmentMutationVariables = Exact<{
  data: WorkOrderEquipmentAddInput;
}>;


export type AddWorkOrderEquipmentMutation = { __typename?: 'Mutation', addWorkOrderEquipment: boolean };

export type RemoveWorkOrderEquipmentMutationVariables = Exact<{
  data: WorkOrderEquipmentRemoveInput;
}>;


export type RemoveWorkOrderEquipmentMutation = { __typename?: 'Mutation', removeWorkOrderEquipment: boolean };

export type UpdateWorkOrderCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldScalar']>;
}>;


export type UpdateWorkOrderCustomFieldMutation = { __typename?: 'Mutation', updateWorkOrderCustomField: { __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } } };

export type GetWorkOrdersQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  assigneeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  priorityIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  archived?: ArchiveStatusEnum;
}>;


export type GetWorkOrdersQuery = { __typename?: 'Query', getWorkOrders: { __typename?: 'GetWorkOrdersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderObject', id: string, index: number, isArchived: boolean, description?: string | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, timezone: string, charges?: number | null, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, workOrderTemplate?: { __typename?: 'WorkOrderTemplateObject', id: string, index: number } | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null }> } };

export type GetWorkOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWorkOrderQuery = { __typename?: 'Query', getWorkOrder: { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, building: { __typename?: 'BuildingObject', id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, workOrderTemplate?: { __typename?: 'WorkOrderTemplateObject', id: string, index: number } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null, customFields: Array<{ __typename?: 'RecordCustomFieldObject', id: string, value?: any | null, customField: { __typename?: 'CustomFieldObject', id: string, key: string, label: string, type: CustomFieldType, required: boolean, active: boolean, inputOptions?: { __typename?: 'CustomFieldOptionInputObject', type?: CustomFieldInputType | null } | null, dropdownOptions?: { __typename?: 'CustomFieldOptionDropdownObject', type?: CustomFieldDropdownType | null, multi?: boolean | null, items?: Array<string> | null } | null, rangeDatepickerOptions?: { __typename?: 'CustomFieldOptionRangeDatePickerObject', separate?: boolean | null } | null } }> } };

export type GetWorkOrderChargesQueryVariables = Exact<{
  workOrderId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderChargesQuery = { __typename?: 'Query', getWorkOrderCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, invoiceId?: string | null, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, title?: string | null, status: UserStatuses, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type GetWorkOrderEquipmentQueryVariables = Exact<{
  workOrderId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderEquipmentQuery = { __typename?: 'Query', getWorkOrderEquipment: { __typename?: 'GetEquipmentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export type ExportWorkOrdersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  workOrderTemplateId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  assigneeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  priorityIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  archived?: ArchiveStatusEnum;
}>;


export type ExportWorkOrdersQuery = { __typename?: 'Query', exportWorkOrders: string };

export const FileFieldsFragmentDoc = gql`
    fragment FileFields on FileObject {
  id
  name
  size
  url
}
    `;
export const ActivityLogCoreFieldsFragmentDoc = gql`
    fragment ActivityLogCoreFields on ActivityLogModel {
  id
  activityType
  internal
  author {
    id
    firstName
    lastName
    status
    photo {
      ...FileFields
    }
  }
  changeLog {
    action
    text
  }
  createdAt
}
    ${FileFieldsFragmentDoc}`;
export const ProductCoreFieldsFragmentDoc = gql`
    fragment ProductCoreFields on ProductItemObject {
  id
  title
}
    `;
export const AmanoSettingFieldsFragmentDoc = gql`
    fragment AmanoSettingFields on AmanoSettingsObject {
  id
  index
  accessGroups {
    id
    name
  }
  facility {
    id
    name
  }
  product {
    ...ProductCoreFields
  }
}
    ${ProductCoreFieldsFragmentDoc}`;
export const ArCodeCoreFieldsFragmentDoc = gql`
    fragment ARCodeCoreFields on ARCodeObject {
  id
  title
}
    `;
export const ArCodeFieldsFragmentDoc = gql`
    fragment ARCodeFields on ARCodeObject {
  ...ARCodeCoreFields
  active
  propertyId
}
    ${ArCodeCoreFieldsFragmentDoc}`;
export const UserCoreFieldsFragmentDoc = gql`
    fragment UserCoreFields on UserObject {
  id
  email
  firstName
  lastName
  title
  status
  phone
  photo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const BroadcastingCoreFieldsFragmentDoc = gql`
    fragment BroadcastingCoreFields on BroadcastObject {
  id
  subject
  body
  email
  emailBody
  sms
  app
  createdAt
  createdBy {
    ...UserCoreFields
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export const PredefinedBroadcastingFieldsFragmentDoc = gql`
    fragment PredefinedBroadcastingFields on PredefinedBroadcastObject {
  id
  subject
  body
  emailBody
}
    `;
export const ChargeCodeCoreFieldsFragmentDoc = gql`
    fragment ChargeCodeCoreFields on ChargeCodeObject {
  id
  title
}
    `;
export const ChargeCodeFieldsFragmentDoc = gql`
    fragment ChargeCodeFields on ChargeCodeObject {
  ...ChargeCodeCoreFields
  active
  propertyId
}
    ${ChargeCodeCoreFieldsFragmentDoc}`;
export const LaborRateCoreFieldsFragmentDoc = gql`
    fragment LaborRateCoreFields on LaborRateObject {
  id
  title
}
    `;
export const MaterialCoreFieldsFragmentDoc = gql`
    fragment MaterialCoreFields on MaterialObject {
  id
  title
}
    `;
export const MarkupCoreFieldsFragmentDoc = gql`
    fragment MarkupCoreFields on MarkupObject {
  id
  title
}
    `;
export const TaxCoreFieldsFragmentDoc = gql`
    fragment TaxCoreFields on TaxObject {
  id
  title
}
    `;
export const ChargeFieldsFragmentDoc = gql`
    fragment ChargeFields on ChargeObject {
  id
  type
  date
  billable
  employeeUser {
    ...UserCoreFields
  }
  hours
  laborRate {
    ...LaborRateCoreFields
  }
  material {
    ...MaterialCoreFields
  }
  baseTaxable
  markup {
    ...MarkupCoreFields
  }
  markupType
  markupAmount
  invoiceId
  markupTaxable
  tax {
    ...TaxCoreFields
  }
  taxAmount
  notes
  price
  quantity
  total
}
    ${UserCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}`;
export const CoiCoreFieldsFragmentDoc = gql`
    fragment CoiCoreFields on CoiObject {
  id
  title
}
    `;
export const CompanyCoreFieldsFragmentDoc = gql`
    fragment CompanyCoreFields on CompanyObject {
  id
  title
  active
  type
  photo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const CustomFieldFieldsFragmentDoc = gql`
    fragment CustomFieldFields on CustomFieldObject {
  id
  key
  label
  type
  required
  active
  inputOptions {
    type
  }
  dropdownOptions {
    type
    multi
    items
  }
  rangeDatepickerOptions {
    separate
  }
}
    `;
export const RecordCustomFieldFragmentDoc = gql`
    fragment RecordCustomField on RecordCustomFieldObject {
  id
  value
  customField {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;
export const CoiFieldsFragmentDoc = gql`
    fragment CoiFields on CoiObject {
  ...CoiCoreFields
  note
  contactEmails
  status
  expiration
  validFrom
  validTo
  createdAt
  company {
    ...CompanyCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  attachment {
    ...FileFields
  }
  customFields {
    ...RecordCustomField
  }
}
    ${CoiCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${RecordCustomFieldFragmentDoc}`;
export const CoiEmailCoreFieldsFragmentDoc = gql`
    fragment CoiEmailCoreFields on CoiEmailObject {
  id
  title
}
    `;
export const CoiEmailFieldsFragmentDoc = gql`
    fragment CoiEmailFields on CoiEmailObject {
  ...CoiEmailCoreFields
  company {
    ...CompanyCoreFields
  }
  email
  emailSlug
  contactEmails
  status
  allowUnknownSender
}
    ${CoiEmailCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;
export const BuildingCoreFieldsFragmentDoc = gql`
    fragment BuildingCoreFields on BuildingObject {
  id
  title
}
    `;
export const FloorCoreFieldsFragmentDoc = gql`
    fragment FloorCoreFields on FloorObject {
  id
  title
}
    `;
export const SuiteCoreFieldsFragmentDoc = gql`
    fragment SuiteCoreFields on SuiteObject {
  id
  title
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  address
  city
  country
  zip
  state
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on CompanyObject {
  ...CompanyCoreFields
  index
  taxCode
  vendorId
  building {
    ...BuildingCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  phone
  createdAt
  address {
    ...AddressFields
  }
  billing {
    email
    billTo
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;
export const DealCategoryCoreFieldsFragmentDoc = gql`
    fragment DealCategoryCoreFields on DealCategoryObject {
  id
  title
}
    `;
export const DealCategoryFieldsFragmentDoc = gql`
    fragment DealCategoryFields on DealCategoryObject {
  ...DealCategoryCoreFields
  index
  icon
}
    ${DealCategoryCoreFieldsFragmentDoc}`;
export const DealFieldsFragmentDoc = gql`
    fragment DealFields on DealObject {
  id
  index
  title
  active
  category {
    ...DealCategoryCoreFields
  }
  code
  description
  discount
  image {
    ...FileFields
  }
  link
  pdf {
    ...FileFields
  }
  popupDescription
  validUntil
  website
}
    ${DealCategoryCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const CouponCoreFieldsFragmentDoc = gql`
    fragment CouponCoreFields on CouponObject {
  id
  title
}
    `;
export const CouponFieldsFragmentDoc = gql`
    fragment CouponFields on CouponObject {
  ...CouponCoreFields
  discountAmount
  discountType
  duration
  durationInMonths
  products {
    id
    title
  }
}
    ${CouponCoreFieldsFragmentDoc}`;
export const DeviceCoreFieldsFragmentDoc = gql`
    fragment DeviceCoreFields on DeviceModel {
  id
  title
}
    `;
export const PrinterCoreFieldsFragmentDoc = gql`
    fragment PrinterCoreFields on PrinterModel {
  id
  title
}
    `;
export const DeviceFieldsFragmentDoc = gql`
    fragment DeviceFields on DeviceModel {
  ...DeviceCoreFields
  appVersion
  deviceId
  isActive
  isPrimary
  isPaired
  osVersion
  printer {
    ...PrinterCoreFields
  }
}
    ${DeviceCoreFieldsFragmentDoc}
${PrinterCoreFieldsFragmentDoc}`;
export const EmailTemplateFieldsFragmentDoc = gql`
    fragment EmailTemplateFields on EmailTemplateObject {
  category
  trigger
  type
  appActive
  smsActive
  emailActive
  appBody
  smsBody
  emailBody
  subject
  bcc
  cc
  localParams
  globalParams
  custom
}
    `;
export const EmployeeCoreFieldsFragmentDoc = gql`
    fragment EmployeeCoreFields on EmployeeObject {
  id
  user {
    ...UserCoreFields
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on EmployeeObject {
  ...EmployeeCoreFields
  index
  active
  laborRate {
    ...LaborRateCoreFields
  }
  tax {
    ...TaxCoreFields
  }
}
    ${EmployeeCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}`;
export const FloorFieldsFragmentDoc = gql`
    fragment FloorFields on FloorObject {
  ...FloorCoreFields
  index
  building {
    ...BuildingCoreFields
  }
  size
  attachment {
    ...FileFields
  }
}
    ${FloorCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const GeneaDoorsFieldsFragmentDoc = gql`
    fragment GeneaDoorsFields on GeneaDoorObject {
  id
  name
  schedule
  isLocked
  isOnline
  controllerId
  controllerIsOnline
  controllerName
}
    `;
export const GeneaTenantCoreFieldsFragmentDoc = gql`
    fragment GeneaTenantCoreFields on GeneaTenantObject {
  id
  title
}
    `;
export const GeneaTenantFieldsFragmentDoc = gql`
    fragment GeneaTenantFields on GeneaTenantObject {
  ...GeneaTenantCoreFields
  status
  type
}
    ${GeneaTenantCoreFieldsFragmentDoc}`;
export const GeneaUserCardFieldsFragmentDoc = gql`
    fragment GeneaUserCardFields on GeneaUserCardObject {
  activationTime
  badgeTypeId
  deactivationTime
  id
  lastUsedAt
  number
  status
  type
}
    `;
export const GeneaBadgeTypeFieldsFragmentDoc = gql`
    fragment GeneaBadgeTypeFields on GeneaBadgeTypesObject {
  description
  id
  isDefaultBadgeType
  name
}
    `;
export const GeneaAccessGroupFieldsFragmentDoc = gql`
    fragment GeneaAccessGroupFields on GeneaAccessGroupObject {
  id
  title
}
    `;
export const GeneaSettingsFieldsFragmentDoc = gql`
    fragment GeneaSettingsFields on GeneaSettingObject {
  email
  badgeType {
    id
    name
  }
}
    `;
export const GlAccountCoreFieldsFragmentDoc = gql`
    fragment GLAccountCoreFields on GLAccountObject {
  id
  title
}
    `;
export const GlAccountFieldsFragmentDoc = gql`
    fragment GLAccountFields on GLAccountObject {
  ...GLAccountCoreFields
  active
  propertyId
}
    ${GlAccountCoreFieldsFragmentDoc}`;
export const SearchFeatureFieldsFragmentDoc = gql`
    fragment SearchFeatureFields on FeatureObject {
  id
  title
}
    `;
export const SearchResultFieldsFragmentDoc = gql`
    fragment SearchResultFields on SearchResultObject {
  id
  index
  title
  status {
    title
    color
  }
  feature {
    ...SearchFeatureFields
  }
  additionalData {
    key
    title
    html
  }
}
    ${SearchFeatureFieldsFragmentDoc}`;
export const GuestVisitCoreFieldsFragmentDoc = gql`
    fragment GuestVisitCoreFields on GuestVisitModel {
  id
  type
  dates {
    date
  }
  startTime
  endTime
  timezone
  checkInDates
  notes
  allDayAccess
}
    `;
export const GuestFieldsFragmentDoc = gql`
    fragment GuestFields on GuestModel {
  id
  companyName
  email
  firstName
  code
  lastName
  status
  building {
    ...BuildingCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  visit {
    ...GuestVisitCoreFields
    notifyUsers {
      id
      firstName
      lastName
    }
  }
  attachments {
    ...FileFields
  }
  createdAt
}
    ${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${GuestVisitCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const GuestSettingsFieldsFragmentDoc = gql`
    fragment GuestSettingsFields on GuestSettingsObject {
  badgeLogo {
    ...FileFields
  }
  printQRCode
  julianDate
}
    ${FileFieldsFragmentDoc}`;
export const RoleCoreFieldsFragmentDoc = gql`
    fragment RoleCoreFields on RoleObject {
  id
  title
}
    `;
export const ImportErrorFieldsFragmentDoc = gql`
    fragment ImportErrorFields on ImportErrorObject {
  error
  key
}
    `;
export const ImportUserFieldsFragmentDoc = gql`
    fragment ImportUserFields on ImportUserObject {
  email
  firstName
  lastName
  title
  phone
  fullAccessBuildings
  buildings {
    ...BuildingCoreFields
  }
  fullAccessCompanies
  companies {
    ...CompanyCoreFields
  }
  role {
    ...RoleCoreFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportCompanyFieldsFragmentDoc = gql`
    fragment ImportCompanyFields on ImportCompanyObject {
  title
  taxCode
  phone
  vendorId
  geneaId
  type
  active
  errors {
    ...ImportErrorFields
  }
}
    ${ImportErrorFieldsFragmentDoc}`;
export const ImportFloorFieldsFragmentDoc = gql`
    fragment ImportFloorFields on ImportFloorObject {
  building {
    ...BuildingCoreFields
  }
  title
  size
  errors {
    ...ImportErrorFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportSuiteFieldsFragmentDoc = gql`
    fragment ImportSuiteFields on ImportSuiteObject {
  title
  type
  size
  isPublic
  bomaSize
  color
  floor {
    ...FloorCoreFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${FloorCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportEquipmentCategoryFieldsFragmentDoc = gql`
    fragment ImportEquipmentCategoryFields on ImportEquipmentCategoryObject {
  title
  errors {
    ...ImportErrorFields
  }
}
    ${ImportErrorFieldsFragmentDoc}`;
export const EquipmentCategoryCoreFieldsFragmentDoc = gql`
    fragment EquipmentCategoryCoreFields on EquipmentCategoryModel {
  id
  title
}
    `;
export const ImportEquipmentFieldsFragmentDoc = gql`
    fragment ImportEquipmentFields on ImportEquipmentObject {
  title
  assetTag
  details
  manufacturer
  serialNumber
  specificLocation
  attachments
  active
  category {
    ...EquipmentCategoryCoreFields
  }
  building {
    ...BuildingCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${EquipmentCategoryCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportProcedureFieldsFragmentDoc = gql`
    fragment ImportProcedureFields on ImportProcedureObject {
  title
  estimatedLabor
  notes
  sections {
    title
    steps {
      title
      type
      predefinedCustomField {
        id
        title
      }
      customId
      inputOptions {
        unit
        type
      }
      dropdownOptions {
        multi
        items
      }
    }
  }
  errors {
    ...ImportErrorFields
  }
}
    ${ImportErrorFieldsFragmentDoc}`;
export const TaskTypeCoreFieldsFragmentDoc = gql`
    fragment TaskTypeCoreFields on TaskTypeModel {
  id
  title
}
    `;
export const ProcedureCoreFieldsFragmentDoc = gql`
    fragment ProcedureCoreFields on ProcedureObject {
  id
  title
}
    `;
export const EquipmentCoreFieldsFragmentDoc = gql`
    fragment EquipmentCoreFields on EquipmentModel {
  id
  title
}
    `;
export const RRuleFieldsFragmentDoc = gql`
    fragment RRuleFields on RRuleObject {
  frequency
  interval
  end {
    count
    date
    type
  }
  monthlyType
  weekDay
  monthDay
  pos
  days
}
    `;
export const ImportScheduleFieldsFragmentDoc = gql`
    fragment ImportScheduleFields on ImportScheduleObject {
  title
  notes
  splitEquipmentOnTask
  taskType {
    ...TaskTypeCoreFields
  }
  building {
    ...BuildingCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  procedures {
    ...ProcedureCoreFields
  }
  equipment {
    ...EquipmentCoreFields
  }
  rruleObject {
    ...RRuleFields
  }
  startDate
  timezone
  dueAfterDays
  excludeDates
  errors {
    ...ImportErrorFields
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${ProcedureCoreFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${RRuleFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportMaterialGroupFieldsFragmentDoc = gql`
    fragment ImportMaterialGroupFields on ImportMaterialGroupObject {
  title
  errors {
    ...ImportErrorFields
  }
}
    ${ImportErrorFieldsFragmentDoc}`;
export const MaterialGroupCoreFieldsFragmentDoc = gql`
    fragment MaterialGroupCoreFields on MaterialGroupObject {
  id
  title
}
    `;
export const ImportMaterialFieldsFragmentDoc = gql`
    fragment ImportMaterialFields on ImportMaterialObject {
  title
  price
  description
  active
  group {
    ...MaterialGroupCoreFields
  }
  tax {
    ...TaxCoreFields
  }
  markup {
    ...MarkupCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${MaterialGroupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const CategoryCoreFieldsFragmentDoc = gql`
    fragment CategoryCoreFields on CategoryObject {
  id
  title
}
    `;
export const PriorityCoreFieldsFragmentDoc = gql`
    fragment PriorityCoreFields on PriorityObject {
  id
  title
}
    `;
export const StatusCoreFieldsFragmentDoc = gql`
    fragment StatusCoreFields on StatusObject {
  id
  title
}
    `;
export const ImportWorkOrderFieldsFragmentDoc = gql`
    fragment ImportWorkOrderFields on ImportWorkOrderObject {
  description
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  priority {
    ...PriorityCoreFields
    color
  }
  status {
    ...StatusCoreFields
    color
  }
  attachments
  startDate
  dueDate
  closedAt
  timezone
  errors {
    ...ImportErrorFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportWorkOrderTemplateFieldsFragmentDoc = gql`
    fragment ImportWorkOrderTemplateFields on ImportWOTObject {
  description
  recordStatus
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  priority {
    ...PriorityCoreFields
    color
  }
  attachments
  startDate
  timezone
  dueAfterDays
  excludeDates
  rruleObject {
    ...RRuleFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${RRuleFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportIncidentFieldsFragmentDoc = gql`
    fragment ImportIncidentFields on ImportIncidentObject {
  description
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  status {
    ...StatusCoreFields
    color
  }
  attachments
  startDate
  timezone
  errors {
    ...ImportErrorFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const ImportCoiFieldsFragmentDoc = gql`
    fragment ImportCOIFields on ImportCOIObject {
  title
  status
  note
  validFrom
  validTo
  attachment
  contactEmails
  company {
    ...CompanyCoreFields
  }
  errors {
    ...ImportErrorFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${ImportErrorFieldsFragmentDoc}`;
export const IncidentFieldsFragmentDoc = gql`
    fragment IncidentFields on IncidentModel {
  id
  index
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  status {
    ...StatusCoreFields
    color
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  description
  createdAt
  startDate
  timezone
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  attachments {
    ...FileFields
  }
  incidentWatchers {
    id
    firstName
    lastName
  }
  customFields {
    ...RecordCustomField
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${RecordCustomFieldFragmentDoc}`;
export const SetupIntegrationFieldsFragmentDoc = gql`
    fragment SetupIntegrationFields on IntegrationSetupModel {
  status
  hasIntegration
  type
  keys {
    key
    label
    required
    value
  }
}
    `;
export const InvoiceChargeFieldsFragmentDoc = gql`
    fragment InvoiceChargeFields on InvoiceChargeObject {
  id
  type
  date
  feature {
    id
    title
    type
  }
  employeeUser {
    ...UserCoreFields
  }
  hours
  laborRate {
    ...LaborRateCoreFields
  }
  material {
    ...MaterialCoreFields
  }
  baseTaxable
  markup {
    ...MarkupCoreFields
  }
  markupType
  markupAmount
  markupTaxable
  tax {
    ...TaxCoreFields
  }
  taxAmount
  notes
  price
  quantity
  total
}
    ${UserCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}`;
export const InvoiceFieldsFragmentDoc = gql`
    fragment InvoiceFields on InvoiceObject {
  index
  id
  cc
  bcc
  email
  billTo
  status
  notes
  invoiceDate
  dueDate
  lastSentAt
  totalAmount
  paidAmount
  company {
    ...CompanyCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  attachments {
    ...FileFields
  }
  file {
    ...FileFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const UserPaymentMethodFieldsFragmentDoc = gql`
    fragment UserPaymentMethodFields on PaymentMethodDTO {
  id
  type
  isPrimary
  verificationUrl
  card {
    brand
    country
    exp_month
    exp_year
    last4
  }
  us_bank_account {
    bank_name
    routing_number
    last4
    account_type
    account_holder_type
  }
}
    `;
export const InvoicePaymentFieldsFragmentDoc = gql`
    fragment InvoicePaymentFields on PaymentsObject {
  id
  status
  paymentMethod {
    ...UserPaymentMethodFields
  }
  amount
  refundedAmount
  stripeLink
  createdAt
  createdBy {
    ...UserCoreFields
  }
}
    ${UserPaymentMethodFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const RecurringInvoicePaymentFieldsFragmentDoc = gql`
    fragment RecurringInvoicePaymentFields on RecurringInvoicePaymentObject {
  id
  paymentMethod {
    ...UserPaymentMethodFields
  }
  amount
  createdAt
  createdBy {
    ...UserCoreFields
  }
}
    ${UserPaymentMethodFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const RecurringInvoiceFieldsFragmentDoc = gql`
    fragment RecurringInvoiceFields on RecurringInvoiceObject {
  id
  index
  notes
  cc
  bcc
  email
  billTo
  recordStatus
  totalAmount
  paidAmount
  company {
    ...CompanyCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  createdAt
  startDate
  dueAfterDays
  nextGenerationDate
  prevGenerationDate
  excludeDates
  timezone
  charges
  rruleText
  rruleObject {
    ...RRuleFields
  }
  attachments {
    ...FileFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${RRuleFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const CategoryGroupCoreFieldsFragmentDoc = gql`
    fragment CategoryGroupCoreFields on CategoryGroupObject {
  id
  title
}
    `;
export const CategoryGroupFieldsFragmentDoc = gql`
    fragment CategoryGroupFields on CategoryGroupObject {
  ...CategoryGroupCoreFields
  icon
  propertyId
}
    ${CategoryGroupCoreFieldsFragmentDoc}`;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on CategoryObject {
  ...CategoryCoreFields
  propertyId
  description
  group {
    ...CategoryGroupCoreFields
  }
  employee {
    ...EmployeeCoreFields
  }
  defaultPriority {
    ...PriorityCoreFields
    color
  }
  usersNotify {
    ...UserCoreFields
  }
}
    ${CategoryCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const KioskFieldsFragmentDoc = gql`
    fragment KioskFields on KioskSettingsObject {
  welcomeText
  welcomeGuestSubtitle
  kioskBgColor
  kioskBgImg {
    ...FileFields
  }
  qrCodeCheckIn
  locatorCheckIn
  qrScanCamera
  qrScanCameraFlip
  selfieCamera
  selfieCameraFlip
}
    ${FileFieldsFragmentDoc}`;
export const LaborRateFieldsFragmentDoc = gql`
    fragment LaborRateFields on LaborRateObject {
  ...LaborRateCoreFields
  index
  rate
  active
  description
  propertyId
  markup {
    ...MarkupCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const LeaseChargeTypeCoreFieldsFragmentDoc = gql`
    fragment LeaseChargeTypeCoreFields on LeaseChargeTypeObject {
  id
  title
}
    `;
export const LeaseChargeTypeFieldsFragmentDoc = gql`
    fragment LeaseChargeTypeFields on LeaseChargeTypeObject {
  ...LeaseChargeTypeCoreFields
  active
  propertyId
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}`;
export const LeaseRentFieldsFragmentDoc = gql`
    fragment LeaseRentFields on LeaseRentObject {
  id
  chargeType {
    ...LeaseChargeTypeCoreFields
  }
  endDate
  startDate
  amount
  suites {
    ...SuiteCoreFields
  }
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;
export const LeaseFieldsFragmentDoc = gql`
    fragment LeaseFields on LeaseObject {
  id
  index
  status
  leaseEnd
  leaseStart
  rentFootage
  lateFeeAmount
  lateFeeUnit
  gracePeriod
  createdAt
  company {
    ...CompanyCoreFields
  }
  suites {
    ...SuiteCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  rents {
    ...LeaseRentFields
  }
  attachments {
    ...FileFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${LeaseRentFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const MarkupFieldsFragmentDoc = gql`
    fragment MarkupFields on MarkupObject {
  ...MarkupCoreFields
  index
  type
  amount
  active
  description
  propertyId
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const MaterialFieldsFragmentDoc = gql`
    fragment MaterialFields on MaterialObject {
  ...MaterialCoreFields
  index
  active
  price
  description
  group {
    ...MaterialGroupCoreFields
  }
  markup {
    ...MarkupCoreFields
  }
  tax {
    ...TaxCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${MaterialCoreFieldsFragmentDoc}
${MaterialGroupCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const NewsfeedCoreFieldsFragmentDoc = gql`
    fragment NewsfeedCoreFields on NewsfeedObject {
  id
  description
  attachments {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const NewsfeedFieldsFragmentDoc = gql`
    fragment NewsfeedFields on NewsfeedObject {
  ...NewsfeedCoreFields
  likesList {
    id
    firstName
    lastName
  }
  createdBy {
    ...UserCoreFields
  }
  createdAt
}
    ${NewsfeedCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const EventFieldsFragmentDoc = gql`
    fragment EventFields on EventObject {
  id
  title
  description
  location
  eventDate
  startTime
  timezone
  eventLength
  repeatId
  capacity
  capacityAvailable
  showCapacity
  registration
  isRegistered
  averageRating
  userRating {
    id
    score
    comment
  }
  attachments {
    ...FileFields
  }
  createdBy {
    ...UserCoreFields
  }
}
    ${FileFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on NotificationObject {
  id
  createdAt
  isRead
  message
  notificationCategory
  showToaster
  referToRecord {
    id
    index
    title
    type
  }
  author {
    id
    firstName
    lastName
    status
    photo {
      ...FileFields
    }
  }
  additional {
    key
    value
  }
}
    ${FileFieldsFragmentDoc}`;
export const ShippingProviderFieldsFragmentDoc = gql`
    fragment ShippingProviderFields on ShippingProviderObject {
  id
  index
  title
  logo {
    ...FileFields
  }
  createdAt
  updatedAt
  default
}
    ${FileFieldsFragmentDoc}`;
export const PackageFieldsFragmentDoc = gql`
    fragment PackageFields on PackageObject {
  id
  index
  status
  notes
  packageId
  createdAt
  shippingProvider {
    ...ShippingProviderFields
  }
  company {
    ...CompanyCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  user {
    ...UserCoreFields
  }
  attachments {
    ...FileFields
  }
}
    ${ShippingProviderFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const PaginationFieldsFragmentDoc = gql`
    fragment PaginationFields on CursorPagination {
  endCursor
  startCursor
  hasNextPage
  hasPreviousPage
  totalCount
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on PaymentObject {
  id
  status
  createdAt
  startDate
  type
  subscriptionId
  productData {
    title
  }
  priceData {
    title
    paidPrice
    billingPeriod
    type
  }
  couponData {
    id
  }
  company {
    ...CompanyCoreFields
  }
  user {
    ...UserCoreFields
  }
  invoice {
    id
    invoiceNumber
  }
  charge {
    id
    source {
      name
      brand
      last4
    }
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const PmCustomIdCoreFieldsFragmentDoc = gql`
    fragment PMCustomIdCoreFields on PMCustomIdObject {
  id
  title
}
    `;
export const EquipmentFieldsFragmentDoc = gql`
    fragment EquipmentFields on EquipmentModel {
  ...EquipmentCoreFields
  index
  active
  building {
    ...BuildingCoreFields
  }
  category {
    ...EquipmentCategoryCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  specificLocation
  assetTag
  serialNumber
  manufacturer
  details
  attachments {
    ...FileFields
  }
}
    ${EquipmentCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const ProcedureFieldsFragmentDoc = gql`
    fragment ProcedureFields on ProcedureObject {
  ...ProcedureCoreFields
  index
  active
  estimatedLabor
  notes
  sections {
    title
    steps {
      title
      type
      predefinedCustomField {
        id
        title
      }
      customId
      inputOptions {
        unit
        type
      }
      dropdownOptions {
        multi
        items
      }
    }
  }
  createdBy {
    ...UserCoreFields
  }
  createdAt
}
    ${ProcedureCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const ScheduleCoreFieldsFragmentDoc = gql`
    fragment ScheduleCoreFields on SchedulesObject {
  id
  title
}
    `;
export const ScheduleEquipmentFieldsFragmentDoc = gql`
    fragment ScheduleEquipmentFields on EquipmentModel {
  ...EquipmentCoreFields
  index
  active
  category {
    ...EquipmentCategoryCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
}
    ${EquipmentCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;
export const ScheduleProcedureFieldsFragmentDoc = gql`
    fragment ScheduleProcedureFields on ProcedureObject {
  ...ProcedureCoreFields
  index
  active
  estimatedLabor
}
    ${ProcedureCoreFieldsFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on SchedulesObject {
  ...ScheduleCoreFields
  index
  recordStatus
  notes
  nextGenerationDate
  prevGenerationDate
  excludeDates
  dueAfterDays
  splitEquipmentOnTask
  taskType {
    ...TaskTypeCoreFields
  }
  building {
    ...BuildingCoreFields
  }
  equipment {
    ...ScheduleEquipmentFields
  }
  procedures {
    ...ScheduleProcedureFields
  }
  assignedTo {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  createdAt
  startDate
  timezone
  rruleText
  rruleObject {
    ...RRuleFields
  }
  attachments {
    ...FileFields
  }
}
    ${ScheduleCoreFieldsFragmentDoc}
${TaskTypeCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${ScheduleEquipmentFieldsFragmentDoc}
${ScheduleProcedureFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${RRuleFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const TaskCoreFieldsFragmentDoc = gql`
    fragment TaskCoreFields on TaskObject {
  id
  title
}
    `;
export const TaskEquipmentFieldsFragmentDoc = gql`
    fragment TaskEquipmentFields on EquipmentModel {
  ...EquipmentCoreFields
  index
  active
  category {
    ...EquipmentCategoryCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
}
    ${EquipmentCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;
export const TaskProcedureFieldsFragmentDoc = gql`
    fragment TaskProcedureFields on TaskProcedureObject {
  id
  procedureId
  title
  notes
  isDone
  estimatedLabor
  sections {
    id
    title
    isDone
    steps {
      id
      predefinedCustomField {
        id
        title
      }
      customId
      title
      type
      value
      inputOptions {
        type
        unit
      }
      dropdownOptions {
        multi
        items
      }
    }
  }
}
    `;
export const TaskFieldsFragmentDoc = gql`
    fragment TaskFields on TaskObject {
  ...TaskCoreFields
  index
  status
  systemCompleted
  userCompleted
  notes
  createdAt
  completedAt
  dueDate
  taskType {
    ...TaskTypeCoreFields
  }
  building {
    ...BuildingCoreFields
  }
  schedule {
    ...ScheduleCoreFields
  }
  equipment {
    ...TaskEquipmentFields
  }
  procedures {
    ...TaskProcedureFields
  }
  watchers {
    id
    firstName
    lastName
  }
  assignedTo {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  attachments {
    ...FileFields
  }
}
    ${TaskCoreFieldsFragmentDoc}
${TaskTypeCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${ScheduleCoreFieldsFragmentDoc}
${TaskEquipmentFieldsFragmentDoc}
${TaskProcedureFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const PrinterFieldsFragmentDoc = gql`
    fragment PrinterFields on PrinterModel {
  ...PrinterCoreFields
  ipAddress
  modelName
  paperType
}
    ${PrinterCoreFieldsFragmentDoc}`;
export const PriorityFieldsFragmentDoc = gql`
    fragment PriorityFields on PriorityObject {
  ...PriorityCoreFields
  color
  active
  propertyId
}
    ${PriorityCoreFieldsFragmentDoc}`;
export const WaiverTemplateCoreFieldsFragmentDoc = gql`
    fragment WaiverTemplateCoreFields on WaiverTemplateModel {
  id
  title
}
    `;
export const ProductPriceCoreFieldsFragmentDoc = gql`
    fragment ProductPriceCoreFields on PriceItemObject {
  id
  title
}
    `;
export const ProductPriceFieldsFragmentDoc = gql`
    fragment ProductPriceFields on PriceItemObject {
  ...ProductPriceCoreFields
  active
  billingPeriod
  billingDay
  description
  price
  trialDays
  type
  priceSettings {
    dateSelection
    timeFrom
    timeTo
    timezone
  }
}
    ${ProductPriceCoreFieldsFragmentDoc}`;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on ProductItemObject {
  ...ProductCoreFields
  active
  description
  createdAt
  createdBy {
    ...UserCoreFields
  }
  waiverTemplate {
    ...WaiverTemplateCoreFields
  }
  customFields {
    label
    required
  }
  companyTypes
  companies {
    ...CompanyCoreFields
  }
  users {
    ...UserCoreFields
  }
  roles {
    id
    title
  }
  prices {
    ...ProductPriceFields
  }
}
    ${ProductCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${WaiverTemplateCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${ProductPriceFieldsFragmentDoc}`;
export const PropertyCoreFieldsFragmentDoc = gql`
    fragment PropertyCoreFields on PropertyObject {
  id
  title
  active
  timezone
  primaryColor
  bgImg {
    ...FileFields
  }
  logo {
    ...FileFields
  }
  favicon {
    ...FileFields
  }
  address {
    address
    longitude
    latitude
  }
}
    ${FileFieldsFragmentDoc}`;
export const PropertyAddonFieldsFragmentDoc = gql`
    fragment PropertyAddonFields on PropertyAddonObject {
  id
  key
  title
  icon
  value
}
    `;
export const ReportingSettingsFieldsFragmentDoc = gql`
    fragment ReportingSettingsFields on ReportSettingsObject {
  invoiceAddress
  yardiPropertyId
  invoiceLogo {
    ...FileFields
  }
  groupedChargesARCode {
    ...ARCodeCoreFields
  }
  groupedChargesGLCode {
    ...GLAccountCoreFields
  }
}
    ${FileFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}`;
export const RepositoryFileFieldsFragmentDoc = gql`
    fragment RepositoryFileFields on RepositoryFileObject {
  id
  name
  url
  size
  isDir
  isPrivate
  thumbnailUrl
  childrenCount
}
    `;
export const AllRolePermissionsFragmentDoc = gql`
    fragment AllRolePermissions on PermissionsObject {
  viewPropertyNewsFeedPost
  addNewsFeedPost
  editOtherUsersNewsFeedPost
  deleteOtherUsersNewsFeedPost
  addNewsFeedPostComment
  deleteOtherUsersNewsFeedComment
  addEventPost
  editOtherUsersEventPost
  deleteOtherUsersEventPost
  viewMyGuest
  viewCompanyGuest
  addMyGuest
  addCompanyGuest
  approveGuest
  updateMyGuest
  updateCompanyGuest
  checkInGuest
  printBadgeGuest
  viewMyVendorAccess
  viewCompanyVendorAccess
  addMyVendorAccess
  addCompanyVendorAccess
  approveVendorAccess
  updateMyVendorAccess
  updateCompanyVendorAccess
  checkInVendorAccess
  printBadgeVendorAccess
  viewMyWatchList
  viewCompanyWatchList
  addMyWatchList
  addCompanyWatchList
  updateMyWatchList
  updateCompanyWatchList
  deactivateMyWatchList
  deactivateCompanyWatchList
  deleteMyWatchList
  deleteCompanyWatchList
  viewMyRoomReservation
  viewCompanyRoomReservation
  addMyRoomReservation
  addCompanyRoomReservation
  updateMyRoomReservation
  updateCompanyRoomReservation
  manageCompanyRoomReservation
  viewMyIncident
  viewCompanyIncident
  addMyIncident
  addCompanyIncident
  updateMyIncident
  updateCompanyIncident
  deleteMyIncident
  deleteCompanyIncident
  viewMyWorkOrder
  viewCompanyWorkOrder
  addMyWorkOrder
  addCompanyWorkOrder
  updateMyWorkOrder
  updateCompanyWorkOrder
  updateWorkOrderStatus
  updateWorkOrderAssignee
  updateWorkOrderPriority
  canCloseWorkOrder
  deleteMyWorkOrder
  deleteCompanyWorkOrder
  viewWOCharges
  manageWOCharges
  viewMyWorkOrderTemplate
  viewCompanyWorkOrderTemplate
  addMyWorkOrderTemplate
  addCompanyWorkOrderTemplate
  updateMyWorkOrderTemplate
  updateCompanyWorkOrderTemplate
  updateWorkOrderAssigneeTemplate
  updateWorkOrderPriorityTemplate
  deleteMyWorkOrderTemplate
  deleteCompanyWorkOrderTemplate
  viewWOTCharges
  manageWOTCharges
  viewUser
  viewCompanyFullAccessUsers
  addUser
  updateUser
  deleteUser
  controlUserWallet
  viewCompanyPage
  addCompany
  updateCompany
  deleteCompany
  viewMySubscriptions
  viewCompanySubscriptions
  addCompanySubscriptions
  updateCompanySubscriptions
  cancelCompanySubscriptions
  refundSubscriptionCharges
  viewMessages
  addMessage
  viewGeneaCards
  updateGeneaCards
  viewGeneaDoors
  toggleGeneaDoor
  viewConciergeHub
  manageConciergeHub
  viewReports
  viewCoi
  addCoi
  updateCoi
  deleteCoi
  updateCoiStatus
  viewPreventiveMaintenance
  managePreventiveMaintenance
  viewMyTasks
  viewAllTasks
  manageMyTasks
  manageAllTasks
  viewTaskCharges
  manageTaskCharges
  viewLease
  manageLease
  viewAnalytics
  viewStackingPlan
  offlinePayments
  creditCardPayments
  propertyAdmin
  addInternalNotes
  viewInternalNotes
  viewFileManager
  manageFileManager
  accessFileManagerPrivate
  viewInvoices
  manageInvoices
  viewRecurringInvoices
  manageRecurringInvoices
  viewPackage
  managePackage
}
    `;
export const RoomCoreFieldsFragmentDoc = gql`
    fragment RoomCoreFields on RoomObject {
  id
  title
}
    `;
export const RoomReservationFieldsFragmentDoc = gql`
    fragment RoomReservationFields on RoomReservationObject {
  id
  index
  from
  to
  date
  status
  total
  paymentType
  paymentStatus
  paymentLink
  description
  createdAt
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  room {
    ...RoomCoreFields
    cancellationPeriod
  }
  attachments {
    ...FileFields
  }
  workOrder {
    id
    index
  }
  customFields {
    ...RecordCustomField
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${RoomCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${RecordCustomFieldFragmentDoc}`;
export const RoomFieldsFragmentDoc = gql`
    fragment RoomFields on RoomObject {
  ...RoomCoreFields
  index
  active
  subtitle
  size
  image {
    ...FileFields
  }
  color
  amenities {
    icon
    name
  }
  cancellationPeriod
  minBookingTime
  maxBookingTime
  from
  to
  limitAdvanceDays
  bufferTime
  material {
    ...MaterialCoreFields
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
  addons {
    ...MaterialCoreFields
    price
    description
  }
  rateModel
  rate
  maxRate
  interval
  halfDayRate
  fullDayRate
  halfDayMinutes
  liabilityPolicy
  cancellationPolicy
  notes
  requiresApproval
  connectedRooms {
    ...RoomCoreFields
  }
}
    ${RoomCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const RoomSettingsFieldsFragmentDoc = gql`
    fragment RoomSettingsFields on RoomSettingObject {
  generateWOOnReservationApprove
  defaultWOCategory {
    ...CategoryCoreFields
  }
  notifyUsers {
    ...UserCoreFields
  }
}
    ${CategoryCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const StackingPlanSuiteFieldsFragmentDoc = gql`
    fragment StackingPlanSuiteFields on StakingPlanSuite {
  id
  title
  size
  type
  rent {
    id
    startDate
    endDate
    company {
      id
      title
    }
  }
  attachment {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const StackingPlanFloorFieldsFragmentDoc = gql`
    fragment StackingPlanFloorFields on StakingPlanFloor {
  id
  title
  size
  attachment {
    ...FileFields
  }
  suites {
    ...StackingPlanSuiteFields
  }
}
    ${FileFieldsFragmentDoc}
${StackingPlanSuiteFieldsFragmentDoc}`;
export const StatusFieldsFragmentDoc = gql`
    fragment StatusFields on StatusObject {
  ...StatusCoreFields
  color
  active
  propertyId
}
    ${StatusCoreFieldsFragmentDoc}`;
export const StripeInvoiceFieldsFragmentDoc = gql`
    fragment StripeInvoiceFields on StripeInvoiceObject {
  id
  amountDue
  amountPaid
  createdAt
  invoiceNumber
  invoiceLink
  status
  subscriptionId
  type
  productData {
    title
  }
  payment {
    id
    status
    amount
    createdAt
  }
  company {
    ...CompanyCoreFields
  }
  user {
    ...UserCoreFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const StripeSettingsFieldsFragmentDoc = gql`
    fragment StripeSettingsFields on StripeSettingsObject {
  paymentCardFee
  paymentCardUnit
  paymentACHFee
  paymentACHUnit
  paymentACHCap
}
    `;
export const SubscriptionFieldsFragmentDoc = gql`
    fragment SubscriptionFields on SubscriptionObject {
  index
  id
  canceledAt
  createdAt
  startDate
  nextChargeDate
  status
  type
  productData {
    id
    title
    active
  }
  priceData {
    id
    title
    paidPrice
    billingPeriod
    type
  }
  couponData {
    id
  }
  requestedFor {
    ...UserCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  attachments {
    ...FileFields
  }
  waivers {
    id
    active
    pdf {
      ...FileFields
    }
    waiverTemplate {
      ...WaiverTemplateCoreFields
    }
  }
  customFields {
    label
    value
  }
}
    ${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${WaiverTemplateCoreFieldsFragmentDoc}`;
export const SuiteFieldsFragmentDoc = gql`
    fragment SuiteFields on SuiteObject {
  ...SuiteCoreFields
  index
  type
  size
  bomaSize
  color
  floor {
    ...FloorCoreFields
  }
  isPublic
  attachment {
    ...FileFields
  }
}
    ${SuiteCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const TaxFieldsFragmentDoc = gql`
    fragment TaxFields on TaxObject {
  ...TaxCoreFields
  amount
  active
  propertyId
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const TranslationCoreFieldsFragmentDoc = gql`
    fragment TranslationCoreFields on TranslationObject {
  id
  title
}
    `;
export const TranslationFieldsFragmentDoc = gql`
    fragment TranslationFields on TranslationObject {
  id
  title
  countryCode
  sources
  translations
}
    `;
export const UserWidgetFieldsFragmentDoc = gql`
    fragment UserWidgetFields on UserWidgetObject {
  id
  title
  color
  icon
  type
  layout {
    x
    y
    w
    h
  }
}
    `;
export const LoggedInUserFieldsFragmentDoc = gql`
    fragment LoggedInUserFields on UserLoggedObject {
  id
  properties {
    id
    title
    bgImg {
      ...FileFields
    }
    logo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserObject {
  ...UserCoreFields
  buildings {
    ...BuildingCoreFields
  }
  primaryBuilding {
    ...BuildingCoreFields
  }
  companies {
    ...CompanyCoreFields
  }
  primaryCompany {
    ...CompanyCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  role {
    ...RoleCoreFields
  }
  authSecurity {
    two_fa_email
    two_fa_phone
  }
  lastLoginAt
}
    ${UserCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}`;
export const VendorAccessVisitCoreFieldsFragmentDoc = gql`
    fragment VendorAccessVisitCoreFields on VendorAccessVisitModel {
  id
  type
  dates {
    date
  }
  startTime
  endTime
  timezone
  checkInDates
  allDayAccess
}
    `;
export const VendorAccessFieldsFragmentDoc = gql`
    fragment VendorAccessFields on VendorAccessModel {
  id
  code
  status
  building {
    ...BuildingCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  coi {
    ...CoiCoreFields
    status
  }
  visit {
    ...VendorAccessVisitCoreFields
    notes
    notifyUsers {
      id
      firstName
      lastName
    }
  }
  attachments {
    ...FileFields
  }
  createdAt
}
    ${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${CoiCoreFieldsFragmentDoc}
${VendorAccessVisitCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const WaiverTemplateFieldsFragmentDoc = gql`
    fragment WaiverTemplateFields on WaiverTemplateModel {
  ...WaiverTemplateCoreFields
  text
  createdBy {
    ...UserCoreFields
  }
  isActive
  isPublic
  type
}
    ${WaiverTemplateCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export const WatchlistCoreFieldsFragmentDoc = gql`
    fragment WatchlistCoreFields on WatchlistObject {
  index
  id
  active
  firstName
  lastName
  description
  createdAt
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  userPhoto {
    ...FileFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const WatchlistFieldsFragmentDoc = gql`
    fragment WatchlistFields on WatchlistObject {
  ...WatchlistCoreFields
  attachments {
    ...FileFields
  }
}
    ${WatchlistCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const WorkOrderTemplateFieldsFragmentDoc = gql`
    fragment WorkOrderTemplateFields on WorkOrderTemplateObject {
  id
  index
  description
  recordStatus
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  priority {
    ...PriorityCoreFields
    color
  }
  requestedFor {
    ...UserCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  createdAt
  startDate
  dueAfterDays
  nextGenerationDate
  prevGenerationDate
  excludeDates
  timezone
  charges
  rruleText
  rruleObject {
    ...RRuleFields
  }
  attachments {
    ...FileFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${RRuleFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const WorkOrderEmailCoreFieldsFragmentDoc = gql`
    fragment WorkOrderEmailCoreFields on WorkOrderEmailObject {
  id
  title
}
    `;
export const WorkOrderEmailFieldsFragmentDoc = gql`
    fragment WorkOrderEmailFields on WorkOrderEmailObject {
  ...WorkOrderEmailCoreFields
  email
  emailSlug
  building {
    ...BuildingCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  status {
    ...StatusCoreFields
    color
  }
  priority {
    ...PriorityCoreFields
    color
  }
  assignedTo {
    ...UserCoreFields
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  allowUnknownSender
}
    ${WorkOrderEmailCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;
export const WorkOrderGuestFormCoreFieldsFragmentDoc = gql`
    fragment WorkOrderGuestFormCoreFields on GuestWOFormObject {
  id
  title
}
    `;
export const WorkOrderGuestFormFieldsFragmentDoc = gql`
    fragment WorkOrderGuestFormFields on GuestWOFormObject {
  ...WorkOrderGuestFormCoreFields
  building {
    ...BuildingCoreFields
  }
  subTitle
  requestedFor {
    ...UserCoreFields
  }
  company {
    ...CompanyCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  hasStatus
  statusRequired
  status {
    ...StatusCoreFields
    color
  }
  hasPriority
  priorityRequired
  priority {
    ...PriorityCoreFields
    color
  }
  hasAssignee
  assigneeRequired
  assignee {
    ...UserCoreFields
  }
  hasFloor
  floorRequired
  floor {
    ...FloorCoreFields
  }
  hasSuite
  suiteRequired
  suite {
    ...SuiteCoreFields
  }
  hasAttachments
  attachmentsRequired
  attachmentTypes
}
    ${WorkOrderGuestFormCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;
export const WorkOrdersStatusSettingsFieldsFragmentDoc = gql`
    fragment WorkOrdersStatusSettingsFields on WorkOrderStatusSettingObject {
  acknowledge {
    ...StatusCoreFields
    color
  }
  closed {
    ...StatusCoreFields
    color
  }
  default {
    ...StatusCoreFields
    color
  }
  rating {
    ...StatusCoreFields
    color
  }
}
    ${StatusCoreFieldsFragmentDoc}`;
export const WorkOrderFieldsFragmentDoc = gql`
    fragment WorkOrderFields on WorkOrderObject {
  id
  index
  building {
    ...BuildingCoreFields
  }
  category {
    ...CategoryCoreFields
  }
  status {
    ...StatusCoreFields
    color
  }
  priority {
    ...PriorityCoreFields
    color
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  createdByGuest {
    firstName
    lastName
    email
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  description
  acknowledged
  createdAt
  closedAt
  startDate
  dueDate
  charges
  timezone
  workOrderTemplate {
    id
    index
  }
  attachments {
    ...FileFields
  }
  watchers {
    id
    firstName
    lastName
  }
  review {
    id
    comment
    score
  }
  customFields {
    ...RecordCustomField
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${RecordCustomFieldFragmentDoc}`;
export const AddCommentDocument = gql`
    mutation addComment($data: CommentInput!) {
  addComment(input: $data) {
    id
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const RemoveCommentDocument = gql`
    mutation removeComment($data: DeleteRecordsInput!) {
  removeComment(input: $data)
}
    `;
export type RemoveCommentMutationFn = Apollo.MutationFunction<RemoveCommentMutation, RemoveCommentMutationVariables>;

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentMutation, RemoveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentMutation, RemoveCommentMutationVariables>(RemoveCommentDocument, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult = Apollo.MutationResult<RemoveCommentMutation>;
export type RemoveCommentMutationOptions = Apollo.BaseMutationOptions<RemoveCommentMutation, RemoveCommentMutationVariables>;
export const GetActivityLogDocument = gql`
    query getActivityLog($activityType: ActivityTypeEnum, $referType: ReferToType, $take: Int! = 10, $after: String, $before: String, $search: String, $userId: String, $from: DateTime, $to: DateTime, $sortBy: SortActivityFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getActivityLog(
    activityType: $activityType
    referType: $referType
    take: $take
    after: $after
    before: $before
    search: $search
    userId: $userId
    from: $from
    to: $to
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...ActivityLogCoreFields
      referToRecord {
        id
        index
        title
        type
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ActivityLogCoreFieldsFragmentDoc}`;

/**
 * __useGetActivityLogQuery__
 *
 * To run a query within a React component, call `useGetActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogQuery({
 *   variables: {
 *      activityType: // value for 'activityType'
 *      referType: // value for 'referType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      userId: // value for 'userId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetActivityLogQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
      }
export function useGetActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export type GetActivityLogQueryHookResult = ReturnType<typeof useGetActivityLogQuery>;
export type GetActivityLogLazyQueryHookResult = ReturnType<typeof useGetActivityLogLazyQuery>;
export type GetActivityLogQueryResult = Apollo.QueryResult<GetActivityLogQuery, GetActivityLogQueryVariables>;
export const GetRecordActivityLogDocument = gql`
    query getRecordActivityLog($activityType: ActivityTypeEnum, $recordId: String!, $referType: ReferToType!, $take: Int! = 10, $after: String, $before: String, $sortBy: SortActivityFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getRecordActivityLog(
    activityType: $activityType
    recordId: $recordId
    referType: $referType
    take: $take
    after: $after
    before: $before
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...ActivityLogCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ActivityLogCoreFieldsFragmentDoc}`;

/**
 * __useGetRecordActivityLogQuery__
 *
 * To run a query within a React component, call `useGetRecordActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordActivityLogQuery({
 *   variables: {
 *      activityType: // value for 'activityType'
 *      recordId: // value for 'recordId'
 *      referType: // value for 'referType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetRecordActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>(GetRecordActivityLogDocument, options);
      }
export function useGetRecordActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>(GetRecordActivityLogDocument, options);
        }
export type GetRecordActivityLogQueryHookResult = ReturnType<typeof useGetRecordActivityLogQuery>;
export type GetRecordActivityLogLazyQueryHookResult = ReturnType<typeof useGetRecordActivityLogLazyQuery>;
export type GetRecordActivityLogQueryResult = Apollo.QueryResult<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>;
export const SaveAmanoSettingsDocument = gql`
    mutation saveAmanoSettings($data: AmanoSettingInput!) {
  saveAmanoSettings(input: $data) {
    ...AmanoSettingFields
  }
}
    ${AmanoSettingFieldsFragmentDoc}`;
export type SaveAmanoSettingsMutationFn = Apollo.MutationFunction<SaveAmanoSettingsMutation, SaveAmanoSettingsMutationVariables>;

/**
 * __useSaveAmanoSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAmanoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAmanoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAmanoSettingsMutation, { data, loading, error }] = useSaveAmanoSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveAmanoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAmanoSettingsMutation, SaveAmanoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAmanoSettingsMutation, SaveAmanoSettingsMutationVariables>(SaveAmanoSettingsDocument, options);
      }
export type SaveAmanoSettingsMutationHookResult = ReturnType<typeof useSaveAmanoSettingsMutation>;
export type SaveAmanoSettingsMutationResult = Apollo.MutationResult<SaveAmanoSettingsMutation>;
export type SaveAmanoSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAmanoSettingsMutation, SaveAmanoSettingsMutationVariables>;
export const UpdateAmanoSettingsDocument = gql`
    mutation updateAmanoSettings($id: String!, $data: AmanoSettingInput!) {
  updateAmanoSettings(id: $id, input: $data) {
    ...AmanoSettingFields
  }
}
    ${AmanoSettingFieldsFragmentDoc}`;
export type UpdateAmanoSettingsMutationFn = Apollo.MutationFunction<UpdateAmanoSettingsMutation, UpdateAmanoSettingsMutationVariables>;

/**
 * __useUpdateAmanoSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAmanoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmanoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmanoSettingsMutation, { data, loading, error }] = useUpdateAmanoSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAmanoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmanoSettingsMutation, UpdateAmanoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmanoSettingsMutation, UpdateAmanoSettingsMutationVariables>(UpdateAmanoSettingsDocument, options);
      }
export type UpdateAmanoSettingsMutationHookResult = ReturnType<typeof useUpdateAmanoSettingsMutation>;
export type UpdateAmanoSettingsMutationResult = Apollo.MutationResult<UpdateAmanoSettingsMutation>;
export type UpdateAmanoSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAmanoSettingsMutation, UpdateAmanoSettingsMutationVariables>;
export const DeleteAmanoSettingsDocument = gql`
    mutation deleteAmanoSettings($data: DeleteRecordsInput!) {
  deleteAmanoSettings(input: $data)
}
    `;
export type DeleteAmanoSettingsMutationFn = Apollo.MutationFunction<DeleteAmanoSettingsMutation, DeleteAmanoSettingsMutationVariables>;

/**
 * __useDeleteAmanoSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteAmanoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmanoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmanoSettingsMutation, { data, loading, error }] = useDeleteAmanoSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteAmanoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmanoSettingsMutation, DeleteAmanoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAmanoSettingsMutation, DeleteAmanoSettingsMutationVariables>(DeleteAmanoSettingsDocument, options);
      }
export type DeleteAmanoSettingsMutationHookResult = ReturnType<typeof useDeleteAmanoSettingsMutation>;
export type DeleteAmanoSettingsMutationResult = Apollo.MutationResult<DeleteAmanoSettingsMutation>;
export type DeleteAmanoSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteAmanoSettingsMutation, DeleteAmanoSettingsMutationVariables>;
export const GetAmanoSettingsDocument = gql`
    query getAmanoSettings($take: Int! = 10, $after: String, $before: String, $search: String) {
  getAmanoSettings(take: $take, after: $after, before: $before, search: $search) {
    pagination {
      ...PaginationFields
    }
    data {
      ...AmanoSettingFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${AmanoSettingFieldsFragmentDoc}`;

/**
 * __useGetAmanoSettingsQuery__
 *
 * To run a query within a React component, call `useGetAmanoSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmanoSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmanoSettingsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAmanoSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAmanoSettingsQuery, GetAmanoSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmanoSettingsQuery, GetAmanoSettingsQueryVariables>(GetAmanoSettingsDocument, options);
      }
export function useGetAmanoSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmanoSettingsQuery, GetAmanoSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmanoSettingsQuery, GetAmanoSettingsQueryVariables>(GetAmanoSettingsDocument, options);
        }
export type GetAmanoSettingsQueryHookResult = ReturnType<typeof useGetAmanoSettingsQuery>;
export type GetAmanoSettingsLazyQueryHookResult = ReturnType<typeof useGetAmanoSettingsLazyQuery>;
export type GetAmanoSettingsQueryResult = Apollo.QueryResult<GetAmanoSettingsQuery, GetAmanoSettingsQueryVariables>;
export const GetAmanoSettingDocument = gql`
    query getAmanoSetting($id: String!) {
  getAmanoSetting(id: $id) {
    ...AmanoSettingFields
  }
}
    ${AmanoSettingFieldsFragmentDoc}`;

/**
 * __useGetAmanoSettingQuery__
 *
 * To run a query within a React component, call `useGetAmanoSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmanoSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmanoSettingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAmanoSettingQuery(baseOptions: Apollo.QueryHookOptions<GetAmanoSettingQuery, GetAmanoSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmanoSettingQuery, GetAmanoSettingQueryVariables>(GetAmanoSettingDocument, options);
      }
export function useGetAmanoSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmanoSettingQuery, GetAmanoSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmanoSettingQuery, GetAmanoSettingQueryVariables>(GetAmanoSettingDocument, options);
        }
export type GetAmanoSettingQueryHookResult = ReturnType<typeof useGetAmanoSettingQuery>;
export type GetAmanoSettingLazyQueryHookResult = ReturnType<typeof useGetAmanoSettingLazyQuery>;
export type GetAmanoSettingQueryResult = Apollo.QueryResult<GetAmanoSettingQuery, GetAmanoSettingQueryVariables>;
export const GetAmanoFacilitiesDocument = gql`
    query getAmanoFacilities {
  getAmanoFacilities {
    id
    name
  }
}
    `;

/**
 * __useGetAmanoFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetAmanoFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmanoFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmanoFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAmanoFacilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAmanoFacilitiesQuery, GetAmanoFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmanoFacilitiesQuery, GetAmanoFacilitiesQueryVariables>(GetAmanoFacilitiesDocument, options);
      }
export function useGetAmanoFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmanoFacilitiesQuery, GetAmanoFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmanoFacilitiesQuery, GetAmanoFacilitiesQueryVariables>(GetAmanoFacilitiesDocument, options);
        }
export type GetAmanoFacilitiesQueryHookResult = ReturnType<typeof useGetAmanoFacilitiesQuery>;
export type GetAmanoFacilitiesLazyQueryHookResult = ReturnType<typeof useGetAmanoFacilitiesLazyQuery>;
export type GetAmanoFacilitiesQueryResult = Apollo.QueryResult<GetAmanoFacilitiesQuery, GetAmanoFacilitiesQueryVariables>;
export const GetAmanoAccessGroupDocument = gql`
    query getAmanoAccessGroup($facilityId: String!) {
  getAmanoAccessGroup(facilityId: $facilityId) {
    id
    name
  }
}
    `;

/**
 * __useGetAmanoAccessGroupQuery__
 *
 * To run a query within a React component, call `useGetAmanoAccessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmanoAccessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmanoAccessGroupQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetAmanoAccessGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAmanoAccessGroupQuery, GetAmanoAccessGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmanoAccessGroupQuery, GetAmanoAccessGroupQueryVariables>(GetAmanoAccessGroupDocument, options);
      }
export function useGetAmanoAccessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmanoAccessGroupQuery, GetAmanoAccessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmanoAccessGroupQuery, GetAmanoAccessGroupQueryVariables>(GetAmanoAccessGroupDocument, options);
        }
export type GetAmanoAccessGroupQueryHookResult = ReturnType<typeof useGetAmanoAccessGroupQuery>;
export type GetAmanoAccessGroupLazyQueryHookResult = ReturnType<typeof useGetAmanoAccessGroupLazyQuery>;
export type GetAmanoAccessGroupQueryResult = Apollo.QueryResult<GetAmanoAccessGroupQuery, GetAmanoAccessGroupQueryVariables>;
export const CreateArCodeDocument = gql`
    mutation createARCode($title: String!) {
  createARCode(title: $title) {
    id
  }
}
    `;
export type CreateArCodeMutationFn = Apollo.MutationFunction<CreateArCodeMutation, CreateArCodeMutationVariables>;

/**
 * __useCreateArCodeMutation__
 *
 * To run a mutation, you first call `useCreateArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArCodeMutation, { data, loading, error }] = useCreateArCodeMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateArCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateArCodeMutation, CreateArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArCodeMutation, CreateArCodeMutationVariables>(CreateArCodeDocument, options);
      }
export type CreateArCodeMutationHookResult = ReturnType<typeof useCreateArCodeMutation>;
export type CreateArCodeMutationResult = Apollo.MutationResult<CreateArCodeMutation>;
export type CreateArCodeMutationOptions = Apollo.BaseMutationOptions<CreateArCodeMutation, CreateArCodeMutationVariables>;
export const UpdateArCodeDocument = gql`
    mutation updateARCode($id: String!, $title: String!) {
  updateARCode(id: $id, title: $title) {
    ...ARCodeFields
  }
}
    ${ArCodeFieldsFragmentDoc}`;
export type UpdateArCodeMutationFn = Apollo.MutationFunction<UpdateArCodeMutation, UpdateArCodeMutationVariables>;

/**
 * __useUpdateArCodeMutation__
 *
 * To run a mutation, you first call `useUpdateArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArCodeMutation, { data, loading, error }] = useUpdateArCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateArCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArCodeMutation, UpdateArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArCodeMutation, UpdateArCodeMutationVariables>(UpdateArCodeDocument, options);
      }
export type UpdateArCodeMutationHookResult = ReturnType<typeof useUpdateArCodeMutation>;
export type UpdateArCodeMutationResult = Apollo.MutationResult<UpdateArCodeMutation>;
export type UpdateArCodeMutationOptions = Apollo.BaseMutationOptions<UpdateArCodeMutation, UpdateArCodeMutationVariables>;
export const ToggleArCodeDocument = gql`
    mutation toggleARCode($id: String!) {
  toggleARCode(id: $id)
}
    `;
export type ToggleArCodeMutationFn = Apollo.MutationFunction<ToggleArCodeMutation, ToggleArCodeMutationVariables>;

/**
 * __useToggleArCodeMutation__
 *
 * To run a mutation, you first call `useToggleArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArCodeMutation, { data, loading, error }] = useToggleArCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleArCodeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArCodeMutation, ToggleArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArCodeMutation, ToggleArCodeMutationVariables>(ToggleArCodeDocument, options);
      }
export type ToggleArCodeMutationHookResult = ReturnType<typeof useToggleArCodeMutation>;
export type ToggleArCodeMutationResult = Apollo.MutationResult<ToggleArCodeMutation>;
export type ToggleArCodeMutationOptions = Apollo.BaseMutationOptions<ToggleArCodeMutation, ToggleArCodeMutationVariables>;
export const RemoveArCodesDocument = gql`
    mutation removeARCodes($data: DeleteRecordsInput!) {
  removeARCodes(input: $data)
}
    `;
export type RemoveArCodesMutationFn = Apollo.MutationFunction<RemoveArCodesMutation, RemoveArCodesMutationVariables>;

/**
 * __useRemoveArCodesMutation__
 *
 * To run a mutation, you first call `useRemoveArCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArCodesMutation, { data, loading, error }] = useRemoveArCodesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveArCodesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArCodesMutation, RemoveArCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArCodesMutation, RemoveArCodesMutationVariables>(RemoveArCodesDocument, options);
      }
export type RemoveArCodesMutationHookResult = ReturnType<typeof useRemoveArCodesMutation>;
export type RemoveArCodesMutationResult = Apollo.MutationResult<RemoveArCodesMutation>;
export type RemoveArCodesMutationOptions = Apollo.BaseMutationOptions<RemoveArCodesMutation, RemoveArCodesMutationVariables>;
export const GetArCodesTableDocument = gql`
    query getARCodesTable($active: Boolean, $search: String) {
  getARCodes(active: $active, search: $search) {
    ...ARCodeCoreFields
    index
    active
    propertyId
  }
}
    ${ArCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetArCodesTableQuery__
 *
 * To run a query within a React component, call `useGetArCodesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetArCodesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetArCodesTableQuery, GetArCodesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodesTableQuery, GetArCodesTableQueryVariables>(GetArCodesTableDocument, options);
      }
export function useGetArCodesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodesTableQuery, GetArCodesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodesTableQuery, GetArCodesTableQueryVariables>(GetArCodesTableDocument, options);
        }
export type GetArCodesTableQueryHookResult = ReturnType<typeof useGetArCodesTableQuery>;
export type GetArCodesTableLazyQueryHookResult = ReturnType<typeof useGetArCodesTableLazyQuery>;
export type GetArCodesTableQueryResult = Apollo.QueryResult<GetArCodesTableQuery, GetArCodesTableQueryVariables>;
export const GetArCodesDropdownDocument = gql`
    query getARCodesDropdown($active: Boolean, $search: String) {
  getARCodes(active: $active, search: $search) {
    ...ARCodeCoreFields
    active
  }
}
    ${ArCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetArCodesDropdownQuery__
 *
 * To run a query within a React component, call `useGetArCodesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetArCodesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>(GetArCodesDropdownDocument, options);
      }
export function useGetArCodesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>(GetArCodesDropdownDocument, options);
        }
export type GetArCodesDropdownQueryHookResult = ReturnType<typeof useGetArCodesDropdownQuery>;
export type GetArCodesDropdownLazyQueryHookResult = ReturnType<typeof useGetArCodesDropdownLazyQuery>;
export type GetArCodesDropdownQueryResult = Apollo.QueryResult<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>;
export const GetArCodeDocument = gql`
    query getARCode($id: String!) {
  getARCode(id: $id) {
    ...ARCodeFields
  }
}
    ${ArCodeFieldsFragmentDoc}`;

/**
 * __useGetArCodeQuery__
 *
 * To run a query within a React component, call `useGetArCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArCodeQuery(baseOptions: Apollo.QueryHookOptions<GetArCodeQuery, GetArCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodeQuery, GetArCodeQueryVariables>(GetArCodeDocument, options);
      }
export function useGetArCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodeQuery, GetArCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodeQuery, GetArCodeQueryVariables>(GetArCodeDocument, options);
        }
export type GetArCodeQueryHookResult = ReturnType<typeof useGetArCodeQuery>;
export type GetArCodeLazyQueryHookResult = ReturnType<typeof useGetArCodeLazyQuery>;
export type GetArCodeQueryResult = Apollo.QueryResult<GetArCodeQuery, GetArCodeQueryVariables>;
export const SendForgottenPasswordDocument = gql`
    mutation sendForgottenPassword($data: ForgotPasswordInput!) {
  forgotPassword(input: $data)
}
    `;
export type SendForgottenPasswordMutationFn = Apollo.MutationFunction<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>;

/**
 * __useSendForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useSendForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForgottenPasswordMutation, { data, loading, error }] = useSendForgottenPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendForgottenPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>(SendForgottenPasswordDocument, options);
      }
export type SendForgottenPasswordMutationHookResult = ReturnType<typeof useSendForgottenPasswordMutation>;
export type SendForgottenPasswordMutationResult = Apollo.MutationResult<SendForgottenPasswordMutation>;
export type SendForgottenPasswordMutationOptions = Apollo.BaseMutationOptions<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>;
export const SendResetPasswordDocument = gql`
    mutation sendResetPassword($data: ResetPasswordInput!) {
  resetPassword(input: $data)
}
    `;
export type SendResetPasswordMutationFn = Apollo.MutationFunction<SendResetPasswordMutation, SendResetPasswordMutationVariables>;

/**
 * __useSendResetPasswordMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordMutation, { data, loading, error }] = useSendResetPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordMutation, SendResetPasswordMutationVariables>(SendResetPasswordDocument, options);
      }
export type SendResetPasswordMutationHookResult = ReturnType<typeof useSendResetPasswordMutation>;
export type SendResetPasswordMutationResult = Apollo.MutationResult<SendResetPasswordMutation>;
export type SendResetPasswordMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>;
export const RequestLoginCodeDocument = gql`
    mutation requestLoginCode($data: RequestLoginCodeInput!) {
  requestLoginCode(input: $data)
}
    `;
export type RequestLoginCodeMutationFn = Apollo.MutationFunction<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>;

/**
 * __useRequestLoginCodeMutation__
 *
 * To run a mutation, you first call `useRequestLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLoginCodeMutation, { data, loading, error }] = useRequestLoginCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>(RequestLoginCodeDocument, options);
      }
export type RequestLoginCodeMutationHookResult = ReturnType<typeof useRequestLoginCodeMutation>;
export type RequestLoginCodeMutationResult = Apollo.MutationResult<RequestLoginCodeMutation>;
export type RequestLoginCodeMutationOptions = Apollo.BaseMutationOptions<RequestLoginCodeMutation, RequestLoginCodeMutationVariables>;
export const SendMagicLinkDocument = gql`
    query sendMagicLink($data: MagicLoginInput!) {
  sendMagicLink(input: $data)
}
    `;

/**
 * __useSendMagicLinkQuery__
 *
 * To run a query within a React component, call `useSendMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendMagicLinkQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendMagicLinkQuery(baseOptions: Apollo.QueryHookOptions<SendMagicLinkQuery, SendMagicLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendMagicLinkQuery, SendMagicLinkQueryVariables>(SendMagicLinkDocument, options);
      }
export function useSendMagicLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendMagicLinkQuery, SendMagicLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendMagicLinkQuery, SendMagicLinkQueryVariables>(SendMagicLinkDocument, options);
        }
export type SendMagicLinkQueryHookResult = ReturnType<typeof useSendMagicLinkQuery>;
export type SendMagicLinkLazyQueryHookResult = ReturnType<typeof useSendMagicLinkLazyQuery>;
export type SendMagicLinkQueryResult = Apollo.QueryResult<SendMagicLinkQuery, SendMagicLinkQueryVariables>;
export const ValidateMagicLoginDocument = gql`
    query validateMagicLogin($code: String!) {
  validateMagicLink(code: $code) {
    email
    portfolios {
      id
      title
      url
      logo {
        ...FileFields
      }
      background {
        ...FileFields
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useValidateMagicLoginQuery__
 *
 * To run a query within a React component, call `useValidateMagicLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateMagicLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateMagicLoginQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateMagicLoginQuery(baseOptions: Apollo.QueryHookOptions<ValidateMagicLoginQuery, ValidateMagicLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateMagicLoginQuery, ValidateMagicLoginQueryVariables>(ValidateMagicLoginDocument, options);
      }
export function useValidateMagicLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateMagicLoginQuery, ValidateMagicLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateMagicLoginQuery, ValidateMagicLoginQueryVariables>(ValidateMagicLoginDocument, options);
        }
export type ValidateMagicLoginQueryHookResult = ReturnType<typeof useValidateMagicLoginQuery>;
export type ValidateMagicLoginLazyQueryHookResult = ReturnType<typeof useValidateMagicLoginLazyQuery>;
export type ValidateMagicLoginQueryResult = Apollo.QueryResult<ValidateMagicLoginQuery, ValidateMagicLoginQueryVariables>;
export const LoginDocument = gql`
    query login($data: LoginInput!) {
  login(input: $data) {
    token
    twoFA {
      list
      userId
    }
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export const MagicLoginDocument = gql`
    query magicLogin($data: MagicLoginAuthInput!) {
  magicLogin(input: $data)
}
    `;

/**
 * __useMagicLoginQuery__
 *
 * To run a query within a React component, call `useMagicLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagicLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagicLoginQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMagicLoginQuery(baseOptions: Apollo.QueryHookOptions<MagicLoginQuery, MagicLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagicLoginQuery, MagicLoginQueryVariables>(MagicLoginDocument, options);
      }
export function useMagicLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagicLoginQuery, MagicLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagicLoginQuery, MagicLoginQueryVariables>(MagicLoginDocument, options);
        }
export type MagicLoginQueryHookResult = ReturnType<typeof useMagicLoginQuery>;
export type MagicLoginLazyQueryHookResult = ReturnType<typeof useMagicLoginLazyQuery>;
export type MagicLoginQueryResult = Apollo.QueryResult<MagicLoginQuery, MagicLoginQueryVariables>;
export const ValidateLoginCodeDocument = gql`
    query validateLoginCode($data: LoginCodeInput!) {
  validateLoginCode(input: $data) {
    token
  }
}
    `;

/**
 * __useValidateLoginCodeQuery__
 *
 * To run a query within a React component, call `useValidateLoginCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLoginCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLoginCodeQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useValidateLoginCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateLoginCodeQuery, ValidateLoginCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateLoginCodeQuery, ValidateLoginCodeQueryVariables>(ValidateLoginCodeDocument, options);
      }
export function useValidateLoginCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLoginCodeQuery, ValidateLoginCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateLoginCodeQuery, ValidateLoginCodeQueryVariables>(ValidateLoginCodeDocument, options);
        }
export type ValidateLoginCodeQueryHookResult = ReturnType<typeof useValidateLoginCodeQuery>;
export type ValidateLoginCodeLazyQueryHookResult = ReturnType<typeof useValidateLoginCodeLazyQuery>;
export type ValidateLoginCodeQueryResult = Apollo.QueryResult<ValidateLoginCodeQuery, ValidateLoginCodeQueryVariables>;
export const SendBroadcastDocument = gql`
    mutation sendBroadcast($data: SendBroadcastInput!) {
  sendBroadcast(input: $data) {
    id
  }
}
    `;
export type SendBroadcastMutationFn = Apollo.MutationFunction<SendBroadcastMutation, SendBroadcastMutationVariables>;

/**
 * __useSendBroadcastMutation__
 *
 * To run a mutation, you first call `useSendBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBroadcastMutation, { data, loading, error }] = useSendBroadcastMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<SendBroadcastMutation, SendBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBroadcastMutation, SendBroadcastMutationVariables>(SendBroadcastDocument, options);
      }
export type SendBroadcastMutationHookResult = ReturnType<typeof useSendBroadcastMutation>;
export type SendBroadcastMutationResult = Apollo.MutationResult<SendBroadcastMutation>;
export type SendBroadcastMutationOptions = Apollo.BaseMutationOptions<SendBroadcastMutation, SendBroadcastMutationVariables>;
export const GetBroadcastsDocument = gql`
    query getBroadcasts($take: Int! = 10, $after: String, $before: String, $createdByIds: [String!], $search: String, $types: [BroadcastTypeEnum!]) {
  getBroadcasts(
    take: $take
    after: $after
    before: $before
    createdByIds: $createdByIds
    search: $search
    types: $types
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...BroadcastingCoreFields
      event {
        id
        title
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BroadcastingCoreFieldsFragmentDoc}`;

/**
 * __useGetBroadcastsQuery__
 *
 * To run a query within a React component, call `useGetBroadcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      createdByIds: // value for 'createdByIds'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetBroadcastsQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastsQuery, GetBroadcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastsQuery, GetBroadcastsQueryVariables>(GetBroadcastsDocument, options);
      }
export function useGetBroadcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastsQuery, GetBroadcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastsQuery, GetBroadcastsQueryVariables>(GetBroadcastsDocument, options);
        }
export type GetBroadcastsQueryHookResult = ReturnType<typeof useGetBroadcastsQuery>;
export type GetBroadcastsLazyQueryHookResult = ReturnType<typeof useGetBroadcastsLazyQuery>;
export type GetBroadcastsQueryResult = Apollo.QueryResult<GetBroadcastsQuery, GetBroadcastsQueryVariables>;
export const GetBroadcastDocument = gql`
    query getBroadcast($id: String!) {
  getBroadcast(id: $id) {
    ...BroadcastingCoreFields
    companyTypes
    companies {
      ...CompanyCoreFields
    }
    roles {
      ...RoleCoreFields
    }
    users {
      ...UserCoreFields
    }
    event {
      id
      title
    }
    attachments {
      ...FileFields
    }
  }
}
    ${BroadcastingCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetBroadcastQuery__
 *
 * To run a query within a React component, call `useGetBroadcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBroadcastQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastQuery, GetBroadcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GetBroadcastDocument, options);
      }
export function useGetBroadcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastQuery, GetBroadcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastQuery, GetBroadcastQueryVariables>(GetBroadcastDocument, options);
        }
export type GetBroadcastQueryHookResult = ReturnType<typeof useGetBroadcastQuery>;
export type GetBroadcastLazyQueryHookResult = ReturnType<typeof useGetBroadcastLazyQuery>;
export type GetBroadcastQueryResult = Apollo.QueryResult<GetBroadcastQuery, GetBroadcastQueryVariables>;
export const GetBroadcastRecipientsDocument = gql`
    query getBroadcastRecipients($broadcastId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getBroadcastRecipients(
    broadcastId: $broadcastId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      createdAt
      user {
        ...UserCoreFields
      }
      sms {
        status
        message
      }
      email {
        status
        message
      }
      app {
        status
        message
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetBroadcastRecipientsQuery__
 *
 * To run a query within a React component, call `useGetBroadcastRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastRecipientsQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetBroadcastRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastRecipientsQuery, GetBroadcastRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastRecipientsQuery, GetBroadcastRecipientsQueryVariables>(GetBroadcastRecipientsDocument, options);
      }
export function useGetBroadcastRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastRecipientsQuery, GetBroadcastRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastRecipientsQuery, GetBroadcastRecipientsQueryVariables>(GetBroadcastRecipientsDocument, options);
        }
export type GetBroadcastRecipientsQueryHookResult = ReturnType<typeof useGetBroadcastRecipientsQuery>;
export type GetBroadcastRecipientsLazyQueryHookResult = ReturnType<typeof useGetBroadcastRecipientsLazyQuery>;
export type GetBroadcastRecipientsQueryResult = Apollo.QueryResult<GetBroadcastRecipientsQuery, GetBroadcastRecipientsQueryVariables>;
export const CreatePredefinedBroadcastDocument = gql`
    mutation createPredefinedBroadcast($data: PredefinedBroadcastInput!) {
  createPredefinedBroadcast(input: $data) {
    id
  }
}
    `;
export type CreatePredefinedBroadcastMutationFn = Apollo.MutationFunction<CreatePredefinedBroadcastMutation, CreatePredefinedBroadcastMutationVariables>;

/**
 * __useCreatePredefinedBroadcastMutation__
 *
 * To run a mutation, you first call `useCreatePredefinedBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePredefinedBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPredefinedBroadcastMutation, { data, loading, error }] = useCreatePredefinedBroadcastMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePredefinedBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<CreatePredefinedBroadcastMutation, CreatePredefinedBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePredefinedBroadcastMutation, CreatePredefinedBroadcastMutationVariables>(CreatePredefinedBroadcastDocument, options);
      }
export type CreatePredefinedBroadcastMutationHookResult = ReturnType<typeof useCreatePredefinedBroadcastMutation>;
export type CreatePredefinedBroadcastMutationResult = Apollo.MutationResult<CreatePredefinedBroadcastMutation>;
export type CreatePredefinedBroadcastMutationOptions = Apollo.BaseMutationOptions<CreatePredefinedBroadcastMutation, CreatePredefinedBroadcastMutationVariables>;
export const UpdatePredefinedBroadcastDocument = gql`
    mutation updatePredefinedBroadcast($id: String!, $data: PredefinedBroadcastInput!) {
  updatePredefinedBroadcast(id: $id, input: $data) {
    ...PredefinedBroadcastingFields
  }
}
    ${PredefinedBroadcastingFieldsFragmentDoc}`;
export type UpdatePredefinedBroadcastMutationFn = Apollo.MutationFunction<UpdatePredefinedBroadcastMutation, UpdatePredefinedBroadcastMutationVariables>;

/**
 * __useUpdatePredefinedBroadcastMutation__
 *
 * To run a mutation, you first call `useUpdatePredefinedBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePredefinedBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePredefinedBroadcastMutation, { data, loading, error }] = useUpdatePredefinedBroadcastMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePredefinedBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePredefinedBroadcastMutation, UpdatePredefinedBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePredefinedBroadcastMutation, UpdatePredefinedBroadcastMutationVariables>(UpdatePredefinedBroadcastDocument, options);
      }
export type UpdatePredefinedBroadcastMutationHookResult = ReturnType<typeof useUpdatePredefinedBroadcastMutation>;
export type UpdatePredefinedBroadcastMutationResult = Apollo.MutationResult<UpdatePredefinedBroadcastMutation>;
export type UpdatePredefinedBroadcastMutationOptions = Apollo.BaseMutationOptions<UpdatePredefinedBroadcastMutation, UpdatePredefinedBroadcastMutationVariables>;
export const TogglePredefinedBroadcastDocument = gql`
    mutation togglePredefinedBroadcast($id: String!) {
  togglePredefinedBroadcast(id: $id)
}
    `;
export type TogglePredefinedBroadcastMutationFn = Apollo.MutationFunction<TogglePredefinedBroadcastMutation, TogglePredefinedBroadcastMutationVariables>;

/**
 * __useTogglePredefinedBroadcastMutation__
 *
 * To run a mutation, you first call `useTogglePredefinedBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePredefinedBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePredefinedBroadcastMutation, { data, loading, error }] = useTogglePredefinedBroadcastMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePredefinedBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<TogglePredefinedBroadcastMutation, TogglePredefinedBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePredefinedBroadcastMutation, TogglePredefinedBroadcastMutationVariables>(TogglePredefinedBroadcastDocument, options);
      }
export type TogglePredefinedBroadcastMutationHookResult = ReturnType<typeof useTogglePredefinedBroadcastMutation>;
export type TogglePredefinedBroadcastMutationResult = Apollo.MutationResult<TogglePredefinedBroadcastMutation>;
export type TogglePredefinedBroadcastMutationOptions = Apollo.BaseMutationOptions<TogglePredefinedBroadcastMutation, TogglePredefinedBroadcastMutationVariables>;
export const RemovePredefinedBroadcastsDocument = gql`
    mutation removePredefinedBroadcasts($data: DeleteRecordsInput!) {
  removePredefinedBroadcasts(input: $data)
}
    `;
export type RemovePredefinedBroadcastsMutationFn = Apollo.MutationFunction<RemovePredefinedBroadcastsMutation, RemovePredefinedBroadcastsMutationVariables>;

/**
 * __useRemovePredefinedBroadcastsMutation__
 *
 * To run a mutation, you first call `useRemovePredefinedBroadcastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePredefinedBroadcastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePredefinedBroadcastsMutation, { data, loading, error }] = useRemovePredefinedBroadcastsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePredefinedBroadcastsMutation(baseOptions?: Apollo.MutationHookOptions<RemovePredefinedBroadcastsMutation, RemovePredefinedBroadcastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePredefinedBroadcastsMutation, RemovePredefinedBroadcastsMutationVariables>(RemovePredefinedBroadcastsDocument, options);
      }
export type RemovePredefinedBroadcastsMutationHookResult = ReturnType<typeof useRemovePredefinedBroadcastsMutation>;
export type RemovePredefinedBroadcastsMutationResult = Apollo.MutationResult<RemovePredefinedBroadcastsMutation>;
export type RemovePredefinedBroadcastsMutationOptions = Apollo.BaseMutationOptions<RemovePredefinedBroadcastsMutation, RemovePredefinedBroadcastsMutationVariables>;
export const GetPredefinedBroadcastsTableDocument = gql`
    query getPredefinedBroadcastsTable($active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getPredefinedBroadcasts(
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getPredefinedBroadcastsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      id
      subject
      index
      active
      createdAt
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetPredefinedBroadcastsTableQuery__
 *
 * To run a query within a React component, call `useGetPredefinedBroadcastsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPredefinedBroadcastsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPredefinedBroadcastsTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPredefinedBroadcastsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetPredefinedBroadcastsTableQuery, GetPredefinedBroadcastsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPredefinedBroadcastsTableQuery, GetPredefinedBroadcastsTableQueryVariables>(GetPredefinedBroadcastsTableDocument, options);
      }
export function useGetPredefinedBroadcastsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPredefinedBroadcastsTableQuery, GetPredefinedBroadcastsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPredefinedBroadcastsTableQuery, GetPredefinedBroadcastsTableQueryVariables>(GetPredefinedBroadcastsTableDocument, options);
        }
export type GetPredefinedBroadcastsTableQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastsTableQuery>;
export type GetPredefinedBroadcastsTableLazyQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastsTableLazyQuery>;
export type GetPredefinedBroadcastsTableQueryResult = Apollo.QueryResult<GetPredefinedBroadcastsTableQuery, GetPredefinedBroadcastsTableQueryVariables>;
export const GetPredefinedBroadcastsDropdownDocument = gql`
    query getPredefinedBroadcastsDropdown($active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $includeBody: Boolean!, $includeEmailBody: Boolean!) {
  getPredefinedBroadcasts(
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getPredefinedBroadcastsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      id
      subject
      active
      body @include(if: $includeBody)
      emailBody @include(if: $includeEmailBody)
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetPredefinedBroadcastsDropdownQuery__
 *
 * To run a query within a React component, call `useGetPredefinedBroadcastsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPredefinedBroadcastsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPredefinedBroadcastsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeBody: // value for 'includeBody'
 *      includeEmailBody: // value for 'includeEmailBody'
 *   },
 * });
 */
export function useGetPredefinedBroadcastsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetPredefinedBroadcastsDropdownQuery, GetPredefinedBroadcastsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPredefinedBroadcastsDropdownQuery, GetPredefinedBroadcastsDropdownQueryVariables>(GetPredefinedBroadcastsDropdownDocument, options);
      }
export function useGetPredefinedBroadcastsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPredefinedBroadcastsDropdownQuery, GetPredefinedBroadcastsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPredefinedBroadcastsDropdownQuery, GetPredefinedBroadcastsDropdownQueryVariables>(GetPredefinedBroadcastsDropdownDocument, options);
        }
export type GetPredefinedBroadcastsDropdownQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastsDropdownQuery>;
export type GetPredefinedBroadcastsDropdownLazyQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastsDropdownLazyQuery>;
export type GetPredefinedBroadcastsDropdownQueryResult = Apollo.QueryResult<GetPredefinedBroadcastsDropdownQuery, GetPredefinedBroadcastsDropdownQueryVariables>;
export const GetPredefinedBroadcastDocument = gql`
    query getPredefinedBroadcast($id: String!) {
  getPredefinedBroadcast(id: $id) {
    ...PredefinedBroadcastingFields
  }
}
    ${PredefinedBroadcastingFieldsFragmentDoc}`;

/**
 * __useGetPredefinedBroadcastQuery__
 *
 * To run a query within a React component, call `useGetPredefinedBroadcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPredefinedBroadcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPredefinedBroadcastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPredefinedBroadcastQuery(baseOptions: Apollo.QueryHookOptions<GetPredefinedBroadcastQuery, GetPredefinedBroadcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPredefinedBroadcastQuery, GetPredefinedBroadcastQueryVariables>(GetPredefinedBroadcastDocument, options);
      }
export function useGetPredefinedBroadcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPredefinedBroadcastQuery, GetPredefinedBroadcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPredefinedBroadcastQuery, GetPredefinedBroadcastQueryVariables>(GetPredefinedBroadcastDocument, options);
        }
export type GetPredefinedBroadcastQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastQuery>;
export type GetPredefinedBroadcastLazyQueryHookResult = ReturnType<typeof useGetPredefinedBroadcastLazyQuery>;
export type GetPredefinedBroadcastQueryResult = Apollo.QueryResult<GetPredefinedBroadcastQuery, GetPredefinedBroadcastQueryVariables>;
export const CreateBuildingDocument = gql`
    mutation createBuilding($title: String!) {
  createBuilding(title: $title) {
    id
  }
}
    `;
export type CreateBuildingMutationFn = Apollo.MutationFunction<CreateBuildingMutation, CreateBuildingMutationVariables>;

/**
 * __useCreateBuildingMutation__
 *
 * To run a mutation, you first call `useCreateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingMutation, { data, loading, error }] = useCreateBuildingMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingMutation, CreateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingMutation, CreateBuildingMutationVariables>(CreateBuildingDocument, options);
      }
export type CreateBuildingMutationHookResult = ReturnType<typeof useCreateBuildingMutation>;
export type CreateBuildingMutationResult = Apollo.MutationResult<CreateBuildingMutation>;
export type CreateBuildingMutationOptions = Apollo.BaseMutationOptions<CreateBuildingMutation, CreateBuildingMutationVariables>;
export const UpdateBuildingDocument = gql`
    mutation updateBuilding($id: String!, $title: String!) {
  updateBuilding(id: $id, title: $title) {
    ...BuildingCoreFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}`;
export type UpdateBuildingMutationFn = Apollo.MutationFunction<UpdateBuildingMutation, UpdateBuildingMutationVariables>;

/**
 * __useUpdateBuildingMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingMutation, { data, loading, error }] = useUpdateBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingMutation, UpdateBuildingMutationVariables>(UpdateBuildingDocument, options);
      }
export type UpdateBuildingMutationHookResult = ReturnType<typeof useUpdateBuildingMutation>;
export type UpdateBuildingMutationResult = Apollo.MutationResult<UpdateBuildingMutation>;
export type UpdateBuildingMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>;
export const ToggleBuildingDocument = gql`
    mutation toggleBuilding($id: String!) {
  toggleBuilding(id: $id)
}
    `;
export type ToggleBuildingMutationFn = Apollo.MutationFunction<ToggleBuildingMutation, ToggleBuildingMutationVariables>;

/**
 * __useToggleBuildingMutation__
 *
 * To run a mutation, you first call `useToggleBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBuildingMutation, { data, loading, error }] = useToggleBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleBuildingMutation(baseOptions?: Apollo.MutationHookOptions<ToggleBuildingMutation, ToggleBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleBuildingMutation, ToggleBuildingMutationVariables>(ToggleBuildingDocument, options);
      }
export type ToggleBuildingMutationHookResult = ReturnType<typeof useToggleBuildingMutation>;
export type ToggleBuildingMutationResult = Apollo.MutationResult<ToggleBuildingMutation>;
export type ToggleBuildingMutationOptions = Apollo.BaseMutationOptions<ToggleBuildingMutation, ToggleBuildingMutationVariables>;
export const RemoveBuildingsDocument = gql`
    mutation removeBuildings($data: DeleteRecordsInput!) {
  removeBuildings(input: $data)
}
    `;
export type RemoveBuildingsMutationFn = Apollo.MutationFunction<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>;

/**
 * __useRemoveBuildingsMutation__
 *
 * To run a mutation, you first call `useRemoveBuildingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBuildingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBuildingsMutation, { data, loading, error }] = useRemoveBuildingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveBuildingsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>(RemoveBuildingsDocument, options);
      }
export type RemoveBuildingsMutationHookResult = ReturnType<typeof useRemoveBuildingsMutation>;
export type RemoveBuildingsMutationResult = Apollo.MutationResult<RemoveBuildingsMutation>;
export type RemoveBuildingsMutationOptions = Apollo.BaseMutationOptions<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>;
export const GetBuildingsTableDocument = gql`
    query getBuildingsTable($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $sortBy: SortBuildingFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getBuildings(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) @connection(key: "getBuildingsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...BuildingCoreFields
      index
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingsTableQuery__
 *
 * To run a query within a React component, call `useGetBuildingsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsTableQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetBuildingsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>(GetBuildingsTableDocument, options);
      }
export function useGetBuildingsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>(GetBuildingsTableDocument, options);
        }
export type GetBuildingsTableQueryHookResult = ReturnType<typeof useGetBuildingsTableQuery>;
export type GetBuildingsTableLazyQueryHookResult = ReturnType<typeof useGetBuildingsTableLazyQuery>;
export type GetBuildingsTableQueryResult = Apollo.QueryResult<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>;
export const GetBuildingsDropdownDocument = gql`
    query getBuildingsDropdown($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $sortBy: SortBuildingFieldEnum! = TITLE, $sortByDir: SortDirectionEnum! = ASC) {
  getBuildings(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) @connection(key: "getBuildingsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...BuildingCoreFields
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingsDropdownQuery__
 *
 * To run a query within a React component, call `useGetBuildingsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsDropdownQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetBuildingsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>(GetBuildingsDropdownDocument, options);
      }
export function useGetBuildingsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>(GetBuildingsDropdownDocument, options);
        }
export type GetBuildingsDropdownQueryHookResult = ReturnType<typeof useGetBuildingsDropdownQuery>;
export type GetBuildingsDropdownLazyQueryHookResult = ReturnType<typeof useGetBuildingsDropdownLazyQuery>;
export type GetBuildingsDropdownQueryResult = Apollo.QueryResult<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>;
export const GetBuildingDocument = gql`
    query getBuilding($id: String!) {
  getBuilding(id: $id) {
    ...BuildingCoreFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingQuery__
 *
 * To run a query within a React component, call `useGetBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBuildingQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingQuery, GetBuildingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingQuery, GetBuildingQueryVariables>(GetBuildingDocument, options);
      }
export function useGetBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingQuery, GetBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingQuery, GetBuildingQueryVariables>(GetBuildingDocument, options);
        }
export type GetBuildingQueryHookResult = ReturnType<typeof useGetBuildingQuery>;
export type GetBuildingLazyQueryHookResult = ReturnType<typeof useGetBuildingLazyQuery>;
export type GetBuildingQueryResult = Apollo.QueryResult<GetBuildingQuery, GetBuildingQueryVariables>;
export const PopulateBuildingsDocument = gql`
    query populateBuildings($ids: [String!]!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  populateBuildings(
    ids: $ids
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __usePopulateBuildingsQuery__
 *
 * To run a query within a React component, call `usePopulateBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopulateBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopulateBuildingsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePopulateBuildingsQuery(baseOptions: Apollo.QueryHookOptions<PopulateBuildingsQuery, PopulateBuildingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopulateBuildingsQuery, PopulateBuildingsQueryVariables>(PopulateBuildingsDocument, options);
      }
export function usePopulateBuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopulateBuildingsQuery, PopulateBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopulateBuildingsQuery, PopulateBuildingsQueryVariables>(PopulateBuildingsDocument, options);
        }
export type PopulateBuildingsQueryHookResult = ReturnType<typeof usePopulateBuildingsQuery>;
export type PopulateBuildingsLazyQueryHookResult = ReturnType<typeof usePopulateBuildingsLazyQuery>;
export type PopulateBuildingsQueryResult = Apollo.QueryResult<PopulateBuildingsQuery, PopulateBuildingsQueryVariables>;
export const GetUserBuildingDocument = gql`
    query getUserBuilding {
  getUserBuilding {
    default {
      ...BuildingCoreFields
    }
    primary {
      ...BuildingCoreFields
    }
  }
}
    ${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetUserBuildingQuery__
 *
 * To run a query within a React component, call `useGetUserBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBuildingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserBuildingQuery(baseOptions?: Apollo.QueryHookOptions<GetUserBuildingQuery, GetUserBuildingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBuildingQuery, GetUserBuildingQueryVariables>(GetUserBuildingDocument, options);
      }
export function useGetUserBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBuildingQuery, GetUserBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBuildingQuery, GetUserBuildingQueryVariables>(GetUserBuildingDocument, options);
        }
export type GetUserBuildingQueryHookResult = ReturnType<typeof useGetUserBuildingQuery>;
export type GetUserBuildingLazyQueryHookResult = ReturnType<typeof useGetUserBuildingLazyQuery>;
export type GetUserBuildingQueryResult = Apollo.QueryResult<GetUserBuildingQuery, GetUserBuildingQueryVariables>;
export const CreateChargeCodeDocument = gql`
    mutation createChargeCode($title: String!) {
  createChargeCode(title: $title) {
    id
  }
}
    `;
export type CreateChargeCodeMutationFn = Apollo.MutationFunction<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>;

/**
 * __useCreateChargeCodeMutation__
 *
 * To run a mutation, you first call `useCreateChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargeCodeMutation, { data, loading, error }] = useCreateChargeCodeMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>(CreateChargeCodeDocument, options);
      }
export type CreateChargeCodeMutationHookResult = ReturnType<typeof useCreateChargeCodeMutation>;
export type CreateChargeCodeMutationResult = Apollo.MutationResult<CreateChargeCodeMutation>;
export type CreateChargeCodeMutationOptions = Apollo.BaseMutationOptions<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>;
export const UpdateChargeCodeDocument = gql`
    mutation updateChargeCode($id: String!, $title: String!) {
  updateChargeCode(id: $id, title: $title) {
    ...ChargeCodeFields
  }
}
    ${ChargeCodeFieldsFragmentDoc}`;
export type UpdateChargeCodeMutationFn = Apollo.MutationFunction<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>;

/**
 * __useUpdateChargeCodeMutation__
 *
 * To run a mutation, you first call `useUpdateChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChargeCodeMutation, { data, loading, error }] = useUpdateChargeCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>(UpdateChargeCodeDocument, options);
      }
export type UpdateChargeCodeMutationHookResult = ReturnType<typeof useUpdateChargeCodeMutation>;
export type UpdateChargeCodeMutationResult = Apollo.MutationResult<UpdateChargeCodeMutation>;
export type UpdateChargeCodeMutationOptions = Apollo.BaseMutationOptions<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>;
export const ToggleChargeCodeDocument = gql`
    mutation toggleChargeCode($id: String!) {
  toggleChargeCode(id: $id)
}
    `;
export type ToggleChargeCodeMutationFn = Apollo.MutationFunction<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>;

/**
 * __useToggleChargeCodeMutation__
 *
 * To run a mutation, you first call `useToggleChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChargeCodeMutation, { data, loading, error }] = useToggleChargeCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>(ToggleChargeCodeDocument, options);
      }
export type ToggleChargeCodeMutationHookResult = ReturnType<typeof useToggleChargeCodeMutation>;
export type ToggleChargeCodeMutationResult = Apollo.MutationResult<ToggleChargeCodeMutation>;
export type ToggleChargeCodeMutationOptions = Apollo.BaseMutationOptions<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>;
export const RemoveChargeCodesDocument = gql`
    mutation removeChargeCodes($data: DeleteRecordsInput!) {
  removeChargeCodes(input: $data)
}
    `;
export type RemoveChargeCodesMutationFn = Apollo.MutationFunction<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>;

/**
 * __useRemoveChargeCodesMutation__
 *
 * To run a mutation, you first call `useRemoveChargeCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChargeCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChargeCodesMutation, { data, loading, error }] = useRemoveChargeCodesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveChargeCodesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>(RemoveChargeCodesDocument, options);
      }
export type RemoveChargeCodesMutationHookResult = ReturnType<typeof useRemoveChargeCodesMutation>;
export type RemoveChargeCodesMutationResult = Apollo.MutationResult<RemoveChargeCodesMutation>;
export type RemoveChargeCodesMutationOptions = Apollo.BaseMutationOptions<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>;
export const GetChargeCodesTableDocument = gql`
    query getChargeCodesTable($active: Boolean, $search: String) {
  getChargeCodes(active: $active, search: $search) {
    ...ChargeCodeCoreFields
    index
    active
    propertyId
  }
}
    ${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetChargeCodesTableQuery__
 *
 * To run a query within a React component, call `useGetChargeCodesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetChargeCodesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>(GetChargeCodesTableDocument, options);
      }
export function useGetChargeCodesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>(GetChargeCodesTableDocument, options);
        }
export type GetChargeCodesTableQueryHookResult = ReturnType<typeof useGetChargeCodesTableQuery>;
export type GetChargeCodesTableLazyQueryHookResult = ReturnType<typeof useGetChargeCodesTableLazyQuery>;
export type GetChargeCodesTableQueryResult = Apollo.QueryResult<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>;
export const GetChargeCodesDropdownDocument = gql`
    query getChargeCodesDropdown($active: Boolean, $search: String) {
  getChargeCodes(active: $active, search: $search) {
    ...ChargeCodeCoreFields
    active
  }
}
    ${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetChargeCodesDropdownQuery__
 *
 * To run a query within a React component, call `useGetChargeCodesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetChargeCodesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>(GetChargeCodesDropdownDocument, options);
      }
export function useGetChargeCodesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>(GetChargeCodesDropdownDocument, options);
        }
export type GetChargeCodesDropdownQueryHookResult = ReturnType<typeof useGetChargeCodesDropdownQuery>;
export type GetChargeCodesDropdownLazyQueryHookResult = ReturnType<typeof useGetChargeCodesDropdownLazyQuery>;
export type GetChargeCodesDropdownQueryResult = Apollo.QueryResult<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>;
export const GetChargeCodeDocument = gql`
    query getChargeCode($id: String!) {
  getChargeCode(id: $id) {
    ...ChargeCodeFields
  }
}
    ${ChargeCodeFieldsFragmentDoc}`;

/**
 * __useGetChargeCodeQuery__
 *
 * To run a query within a React component, call `useGetChargeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChargeCodeQuery(baseOptions: Apollo.QueryHookOptions<GetChargeCodeQuery, GetChargeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodeQuery, GetChargeCodeQueryVariables>(GetChargeCodeDocument, options);
      }
export function useGetChargeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodeQuery, GetChargeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodeQuery, GetChargeCodeQueryVariables>(GetChargeCodeDocument, options);
        }
export type GetChargeCodeQueryHookResult = ReturnType<typeof useGetChargeCodeQuery>;
export type GetChargeCodeLazyQueryHookResult = ReturnType<typeof useGetChargeCodeLazyQuery>;
export type GetChargeCodeQueryResult = Apollo.QueryResult<GetChargeCodeQuery, GetChargeCodeQueryVariables>;
export const CreateChargeDocument = gql`
    mutation createCharge($data: ChargeInput!) {
  createCharge(input: $data) {
    id
  }
}
    `;
export type CreateChargeMutationFn = Apollo.MutationFunction<CreateChargeMutation, CreateChargeMutationVariables>;

/**
 * __useCreateChargeMutation__
 *
 * To run a mutation, you first call `useCreateChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargeMutation, { data, loading, error }] = useCreateChargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateChargeMutation, CreateChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChargeMutation, CreateChargeMutationVariables>(CreateChargeDocument, options);
      }
export type CreateChargeMutationHookResult = ReturnType<typeof useCreateChargeMutation>;
export type CreateChargeMutationResult = Apollo.MutationResult<CreateChargeMutation>;
export type CreateChargeMutationOptions = Apollo.BaseMutationOptions<CreateChargeMutation, CreateChargeMutationVariables>;
export const UpdateChargeDocument = gql`
    mutation updateCharge($id: String!, $data: ChargeInputData!, $updateInvoice: Boolean! = false) {
  updateCharge(id: $id, input: $data, updateInvoice: $updateInvoice) {
    ...ChargeFields
  }
}
    ${ChargeFieldsFragmentDoc}`;
export type UpdateChargeMutationFn = Apollo.MutationFunction<UpdateChargeMutation, UpdateChargeMutationVariables>;

/**
 * __useUpdateChargeMutation__
 *
 * To run a mutation, you first call `useUpdateChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChargeMutation, { data, loading, error }] = useUpdateChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      updateInvoice: // value for 'updateInvoice'
 *   },
 * });
 */
export function useUpdateChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChargeMutation, UpdateChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChargeMutation, UpdateChargeMutationVariables>(UpdateChargeDocument, options);
      }
export type UpdateChargeMutationHookResult = ReturnType<typeof useUpdateChargeMutation>;
export type UpdateChargeMutationResult = Apollo.MutationResult<UpdateChargeMutation>;
export type UpdateChargeMutationOptions = Apollo.BaseMutationOptions<UpdateChargeMutation, UpdateChargeMutationVariables>;
export const RemoveChargesDocument = gql`
    mutation removeCharges($data: DeleteRecordsInput!, $updateInvoice: Boolean! = false) {
  removeCharges(input: $data, updateInvoice: $updateInvoice)
}
    `;
export type RemoveChargesMutationFn = Apollo.MutationFunction<RemoveChargesMutation, RemoveChargesMutationVariables>;

/**
 * __useRemoveChargesMutation__
 *
 * To run a mutation, you first call `useRemoveChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChargesMutation, { data, loading, error }] = useRemoveChargesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateInvoice: // value for 'updateInvoice'
 *   },
 * });
 */
export function useRemoveChargesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChargesMutation, RemoveChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChargesMutation, RemoveChargesMutationVariables>(RemoveChargesDocument, options);
      }
export type RemoveChargesMutationHookResult = ReturnType<typeof useRemoveChargesMutation>;
export type RemoveChargesMutationResult = Apollo.MutationResult<RemoveChargesMutation>;
export type RemoveChargesMutationOptions = Apollo.BaseMutationOptions<RemoveChargesMutation, RemoveChargesMutationVariables>;
export const RemoveChargeDocument = gql`
    mutation removeCharge($id: String!, $updateInvoice: Boolean! = false) {
  removeCharge(id: $id, updateInvoice: $updateInvoice)
}
    `;
export type RemoveChargeMutationFn = Apollo.MutationFunction<RemoveChargeMutation, RemoveChargeMutationVariables>;

/**
 * __useRemoveChargeMutation__
 *
 * To run a mutation, you first call `useRemoveChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChargeMutation, { data, loading, error }] = useRemoveChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateInvoice: // value for 'updateInvoice'
 *   },
 * });
 */
export function useRemoveChargeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChargeMutation, RemoveChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChargeMutation, RemoveChargeMutationVariables>(RemoveChargeDocument, options);
      }
export type RemoveChargeMutationHookResult = ReturnType<typeof useRemoveChargeMutation>;
export type RemoveChargeMutationResult = Apollo.MutationResult<RemoveChargeMutation>;
export type RemoveChargeMutationOptions = Apollo.BaseMutationOptions<RemoveChargeMutation, RemoveChargeMutationVariables>;
export const GetChargeDocument = gql`
    query getCharge($id: String!) {
  getCharge(id: $id) {
    ...ChargeFields
  }
}
    ${ChargeFieldsFragmentDoc}`;

/**
 * __useGetChargeQuery__
 *
 * To run a query within a React component, call `useGetChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChargeQuery(baseOptions: Apollo.QueryHookOptions<GetChargeQuery, GetChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeQuery, GetChargeQueryVariables>(GetChargeDocument, options);
      }
export function useGetChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeQuery, GetChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeQuery, GetChargeQueryVariables>(GetChargeDocument, options);
        }
export type GetChargeQueryHookResult = ReturnType<typeof useGetChargeQuery>;
export type GetChargeLazyQueryHookResult = ReturnType<typeof useGetChargeLazyQuery>;
export type GetChargeQueryResult = Apollo.QueryResult<GetChargeQuery, GetChargeQueryVariables>;
export const CreateCoiDocument = gql`
    mutation createCoi($data: COIInput!) {
  createCoi(input: $data) {
    id
  }
}
    `;
export type CreateCoiMutationFn = Apollo.MutationFunction<CreateCoiMutation, CreateCoiMutationVariables>;

/**
 * __useCreateCoiMutation__
 *
 * To run a mutation, you first call `useCreateCoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoiMutation, { data, loading, error }] = useCreateCoiMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCoiMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoiMutation, CreateCoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoiMutation, CreateCoiMutationVariables>(CreateCoiDocument, options);
      }
export type CreateCoiMutationHookResult = ReturnType<typeof useCreateCoiMutation>;
export type CreateCoiMutationResult = Apollo.MutationResult<CreateCoiMutation>;
export type CreateCoiMutationOptions = Apollo.BaseMutationOptions<CreateCoiMutation, CreateCoiMutationVariables>;
export const UpdateCoiDocument = gql`
    mutation updateCoi($id: String!, $data: COIUpdateInput!) {
  updateCoi(coiId: $id, input: $data) {
    ...CoiFields
  }
}
    ${CoiFieldsFragmentDoc}`;
export type UpdateCoiMutationFn = Apollo.MutationFunction<UpdateCoiMutation, UpdateCoiMutationVariables>;

/**
 * __useUpdateCoiMutation__
 *
 * To run a mutation, you first call `useUpdateCoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoiMutation, { data, loading, error }] = useUpdateCoiMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCoiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoiMutation, UpdateCoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoiMutation, UpdateCoiMutationVariables>(UpdateCoiDocument, options);
      }
export type UpdateCoiMutationHookResult = ReturnType<typeof useUpdateCoiMutation>;
export type UpdateCoiMutationResult = Apollo.MutationResult<UpdateCoiMutation>;
export type UpdateCoiMutationOptions = Apollo.BaseMutationOptions<UpdateCoiMutation, UpdateCoiMutationVariables>;
export const BulkStatusCoisDocument = gql`
    mutation bulkStatusCois($ids: [String!]!, $status: CoiStatusEnum) {
  bulkStatusCois(ids: $ids, status: $status) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status
    }
  }
}
    `;
export type BulkStatusCoisMutationFn = Apollo.MutationFunction<BulkStatusCoisMutation, BulkStatusCoisMutationVariables>;

/**
 * __useBulkStatusCoisMutation__
 *
 * To run a mutation, you first call `useBulkStatusCoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusCoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusCoisMutation, { data, loading, error }] = useBulkStatusCoisMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkStatusCoisMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusCoisMutation, BulkStatusCoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusCoisMutation, BulkStatusCoisMutationVariables>(BulkStatusCoisDocument, options);
      }
export type BulkStatusCoisMutationHookResult = ReturnType<typeof useBulkStatusCoisMutation>;
export type BulkStatusCoisMutationResult = Apollo.MutationResult<BulkStatusCoisMutation>;
export type BulkStatusCoisMutationOptions = Apollo.BaseMutationOptions<BulkStatusCoisMutation, BulkStatusCoisMutationVariables>;
export const ArchiveCoisDocument = gql`
    mutation archiveCois($ids: [String!]!) {
  archiveCois(ids: $ids)
}
    `;
export type ArchiveCoisMutationFn = Apollo.MutationFunction<ArchiveCoisMutation, ArchiveCoisMutationVariables>;

/**
 * __useArchiveCoisMutation__
 *
 * To run a mutation, you first call `useArchiveCoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCoisMutation, { data, loading, error }] = useArchiveCoisMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveCoisMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCoisMutation, ArchiveCoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCoisMutation, ArchiveCoisMutationVariables>(ArchiveCoisDocument, options);
      }
export type ArchiveCoisMutationHookResult = ReturnType<typeof useArchiveCoisMutation>;
export type ArchiveCoisMutationResult = Apollo.MutationResult<ArchiveCoisMutation>;
export type ArchiveCoisMutationOptions = Apollo.BaseMutationOptions<ArchiveCoisMutation, ArchiveCoisMutationVariables>;
export const UnArchiveCoisDocument = gql`
    mutation unArchiveCois($ids: [String!]!) {
  unArchiveCois(ids: $ids)
}
    `;
export type UnArchiveCoisMutationFn = Apollo.MutationFunction<UnArchiveCoisMutation, UnArchiveCoisMutationVariables>;

/**
 * __useUnArchiveCoisMutation__
 *
 * To run a mutation, you first call `useUnArchiveCoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveCoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveCoisMutation, { data, loading, error }] = useUnArchiveCoisMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnArchiveCoisMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveCoisMutation, UnArchiveCoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveCoisMutation, UnArchiveCoisMutationVariables>(UnArchiveCoisDocument, options);
      }
export type UnArchiveCoisMutationHookResult = ReturnType<typeof useUnArchiveCoisMutation>;
export type UnArchiveCoisMutationResult = Apollo.MutationResult<UnArchiveCoisMutation>;
export type UnArchiveCoisMutationOptions = Apollo.BaseMutationOptions<UnArchiveCoisMutation, UnArchiveCoisMutationVariables>;
export const RemoveCoiDocument = gql`
    mutation removeCoi($data: DeleteRecordsInput!) {
  removeCoi(input: $data)
}
    `;
export type RemoveCoiMutationFn = Apollo.MutationFunction<RemoveCoiMutation, RemoveCoiMutationVariables>;

/**
 * __useRemoveCoiMutation__
 *
 * To run a mutation, you first call `useRemoveCoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoiMutation, { data, loading, error }] = useRemoveCoiMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCoiMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoiMutation, RemoveCoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoiMutation, RemoveCoiMutationVariables>(RemoveCoiDocument, options);
      }
export type RemoveCoiMutationHookResult = ReturnType<typeof useRemoveCoiMutation>;
export type RemoveCoiMutationResult = Apollo.MutationResult<RemoveCoiMutation>;
export type RemoveCoiMutationOptions = Apollo.BaseMutationOptions<RemoveCoiMutation, RemoveCoiMutationVariables>;
export const GetCoisTableDocument = gql`
    query getCoisTable($take: Int! = 10, $after: String, $before: String, $statuses: [CoiStatusEnum!], $search: String, $to: DateTime, $from: DateTime, $companyTypes: [CompanyTypeEnum!], $companyIds: [String!], $createdByIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED, $expiration: CoiExpirationEnum) {
  getCois(
    take: $take
    after: $after
    before: $before
    statuses: $statuses
    search: $search
    to: $to
    from: $from
    companyTypes: $companyTypes
    companyIds: $companyIds
    createdByIds: $createdByIds
    archived: $archived
    expiration: $expiration
  ) @connection(key: "getCoisTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CoiCoreFields
      isArchived
      status
      expiration
      note
      validFrom
      validTo
      createdAt
      company {
        ...CompanyCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CoiCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetCoisTableQuery__
 *
 * To run a query within a React component, call `useGetCoisTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoisTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoisTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      companyTypes: // value for 'companyTypes'
 *      companyIds: // value for 'companyIds'
 *      createdByIds: // value for 'createdByIds'
 *      archived: // value for 'archived'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useGetCoisTableQuery(baseOptions?: Apollo.QueryHookOptions<GetCoisTableQuery, GetCoisTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoisTableQuery, GetCoisTableQueryVariables>(GetCoisTableDocument, options);
      }
export function useGetCoisTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoisTableQuery, GetCoisTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoisTableQuery, GetCoisTableQueryVariables>(GetCoisTableDocument, options);
        }
export type GetCoisTableQueryHookResult = ReturnType<typeof useGetCoisTableQuery>;
export type GetCoisTableLazyQueryHookResult = ReturnType<typeof useGetCoisTableLazyQuery>;
export type GetCoisTableQueryResult = Apollo.QueryResult<GetCoisTableQuery, GetCoisTableQueryVariables>;
export const GetCoisDropdownDocument = gql`
    query getCoisDropdown($take: Int! = 10, $after: String, $before: String, $statuses: [CoiStatusEnum!], $search: String, $to: DateTime, $from: DateTime, $companyIds: [String!], $createdByIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED, $expiration: CoiExpirationEnum) {
  getCois(
    take: $take
    after: $after
    before: $before
    statuses: $statuses
    search: $search
    to: $to
    from: $from
    companyIds: $companyIds
    createdByIds: $createdByIds
    archived: $archived
    expiration: $expiration
  ) @connection(key: "getCoisDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CoiCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CoiCoreFieldsFragmentDoc}`;

/**
 * __useGetCoisDropdownQuery__
 *
 * To run a query within a React component, call `useGetCoisDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoisDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoisDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      companyIds: // value for 'companyIds'
 *      createdByIds: // value for 'createdByIds'
 *      archived: // value for 'archived'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useGetCoisDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetCoisDropdownQuery, GetCoisDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoisDropdownQuery, GetCoisDropdownQueryVariables>(GetCoisDropdownDocument, options);
      }
export function useGetCoisDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoisDropdownQuery, GetCoisDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoisDropdownQuery, GetCoisDropdownQueryVariables>(GetCoisDropdownDocument, options);
        }
export type GetCoisDropdownQueryHookResult = ReturnType<typeof useGetCoisDropdownQuery>;
export type GetCoisDropdownLazyQueryHookResult = ReturnType<typeof useGetCoisDropdownLazyQuery>;
export type GetCoisDropdownQueryResult = Apollo.QueryResult<GetCoisDropdownQuery, GetCoisDropdownQueryVariables>;
export const GetCoiDocument = gql`
    query getCoi($id: String!) {
  getCoi(coiId: $id) {
    ...CoiFields
  }
}
    ${CoiFieldsFragmentDoc}`;

/**
 * __useGetCoiQuery__
 *
 * To run a query within a React component, call `useGetCoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoiQuery(baseOptions: Apollo.QueryHookOptions<GetCoiQuery, GetCoiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiQuery, GetCoiQueryVariables>(GetCoiDocument, options);
      }
export function useGetCoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiQuery, GetCoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiQuery, GetCoiQueryVariables>(GetCoiDocument, options);
        }
export type GetCoiQueryHookResult = ReturnType<typeof useGetCoiQuery>;
export type GetCoiLazyQueryHookResult = ReturnType<typeof useGetCoiLazyQuery>;
export type GetCoiQueryResult = Apollo.QueryResult<GetCoiQuery, GetCoiQueryVariables>;
export const ExportCoisDocument = gql`
    query exportCois($statuses: [CoiStatusEnum!], $search: String, $to: DateTime, $from: DateTime, $companyTypes: [CompanyTypeEnum!], $companyIds: [String!], $createdByIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED, $expiration: CoiExpirationEnum) {
  exportCois(
    statuses: $statuses
    search: $search
    to: $to
    from: $from
    companyTypes: $companyTypes
    companyIds: $companyIds
    createdByIds: $createdByIds
    archived: $archived
    expiration: $expiration
  )
}
    `;

/**
 * __useExportCoisQuery__
 *
 * To run a query within a React component, call `useExportCoisQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCoisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCoisQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      companyTypes: // value for 'companyTypes'
 *      companyIds: // value for 'companyIds'
 *      createdByIds: // value for 'createdByIds'
 *      archived: // value for 'archived'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useExportCoisQuery(baseOptions?: Apollo.QueryHookOptions<ExportCoisQuery, ExportCoisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCoisQuery, ExportCoisQueryVariables>(ExportCoisDocument, options);
      }
export function useExportCoisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCoisQuery, ExportCoisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCoisQuery, ExportCoisQueryVariables>(ExportCoisDocument, options);
        }
export type ExportCoisQueryHookResult = ReturnType<typeof useExportCoisQuery>;
export type ExportCoisLazyQueryHookResult = ReturnType<typeof useExportCoisLazyQuery>;
export type ExportCoisQueryResult = Apollo.QueryResult<ExportCoisQuery, ExportCoisQueryVariables>;
export const CreateCoiEmailDocument = gql`
    mutation createCoiEmail($data: CoiEmailInput!) {
  createCoiEmail(input: $data) {
    id
    email
  }
}
    `;
export type CreateCoiEmailMutationFn = Apollo.MutationFunction<CreateCoiEmailMutation, CreateCoiEmailMutationVariables>;

/**
 * __useCreateCoiEmailMutation__
 *
 * To run a mutation, you first call `useCreateCoiEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoiEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoiEmailMutation, { data, loading, error }] = useCreateCoiEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCoiEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoiEmailMutation, CreateCoiEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoiEmailMutation, CreateCoiEmailMutationVariables>(CreateCoiEmailDocument, options);
      }
export type CreateCoiEmailMutationHookResult = ReturnType<typeof useCreateCoiEmailMutation>;
export type CreateCoiEmailMutationResult = Apollo.MutationResult<CreateCoiEmailMutation>;
export type CreateCoiEmailMutationOptions = Apollo.BaseMutationOptions<CreateCoiEmailMutation, CreateCoiEmailMutationVariables>;
export const UpdateCoiEmailDocument = gql`
    mutation updateCoiEmail($id: String!, $data: CoiEmailInput!) {
  updateCoiEmail(id: $id, input: $data) {
    ...CoiEmailFields
  }
}
    ${CoiEmailFieldsFragmentDoc}`;
export type UpdateCoiEmailMutationFn = Apollo.MutationFunction<UpdateCoiEmailMutation, UpdateCoiEmailMutationVariables>;

/**
 * __useUpdateCoiEmailMutation__
 *
 * To run a mutation, you first call `useUpdateCoiEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoiEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoiEmailMutation, { data, loading, error }] = useUpdateCoiEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCoiEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoiEmailMutation, UpdateCoiEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoiEmailMutation, UpdateCoiEmailMutationVariables>(UpdateCoiEmailDocument, options);
      }
export type UpdateCoiEmailMutationHookResult = ReturnType<typeof useUpdateCoiEmailMutation>;
export type UpdateCoiEmailMutationResult = Apollo.MutationResult<UpdateCoiEmailMutation>;
export type UpdateCoiEmailMutationOptions = Apollo.BaseMutationOptions<UpdateCoiEmailMutation, UpdateCoiEmailMutationVariables>;
export const ToggleCoiEmailDocument = gql`
    mutation toggleCoiEmail($id: String!) {
  toggleCoiEmail(id: $id)
}
    `;
export type ToggleCoiEmailMutationFn = Apollo.MutationFunction<ToggleCoiEmailMutation, ToggleCoiEmailMutationVariables>;

/**
 * __useToggleCoiEmailMutation__
 *
 * To run a mutation, you first call `useToggleCoiEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCoiEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCoiEmailMutation, { data, loading, error }] = useToggleCoiEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCoiEmailMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCoiEmailMutation, ToggleCoiEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCoiEmailMutation, ToggleCoiEmailMutationVariables>(ToggleCoiEmailDocument, options);
      }
export type ToggleCoiEmailMutationHookResult = ReturnType<typeof useToggleCoiEmailMutation>;
export type ToggleCoiEmailMutationResult = Apollo.MutationResult<ToggleCoiEmailMutation>;
export type ToggleCoiEmailMutationOptions = Apollo.BaseMutationOptions<ToggleCoiEmailMutation, ToggleCoiEmailMutationVariables>;
export const RemoveCoiEmailsDocument = gql`
    mutation removeCoiEmails($data: DeleteRecordsInput!) {
  removeCoiEmails(input: $data)
}
    `;
export type RemoveCoiEmailsMutationFn = Apollo.MutationFunction<RemoveCoiEmailsMutation, RemoveCoiEmailsMutationVariables>;

/**
 * __useRemoveCoiEmailsMutation__
 *
 * To run a mutation, you first call `useRemoveCoiEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoiEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoiEmailsMutation, { data, loading, error }] = useRemoveCoiEmailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCoiEmailsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoiEmailsMutation, RemoveCoiEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoiEmailsMutation, RemoveCoiEmailsMutationVariables>(RemoveCoiEmailsDocument, options);
      }
export type RemoveCoiEmailsMutationHookResult = ReturnType<typeof useRemoveCoiEmailsMutation>;
export type RemoveCoiEmailsMutationResult = Apollo.MutationResult<RemoveCoiEmailsMutation>;
export type RemoveCoiEmailsMutationOptions = Apollo.BaseMutationOptions<RemoveCoiEmailsMutation, RemoveCoiEmailsMutationVariables>;
export const GetCoiEmailsDocument = gql`
    query getCoiEmails($take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getCoiEmails(
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...CoiEmailCoreFields
      email
      index
      active
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CoiEmailCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetCoiEmailsQuery__
 *
 * To run a query within a React component, call `useGetCoiEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiEmailsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCoiEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCoiEmailsQuery, GetCoiEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiEmailsQuery, GetCoiEmailsQueryVariables>(GetCoiEmailsDocument, options);
      }
export function useGetCoiEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiEmailsQuery, GetCoiEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiEmailsQuery, GetCoiEmailsQueryVariables>(GetCoiEmailsDocument, options);
        }
export type GetCoiEmailsQueryHookResult = ReturnType<typeof useGetCoiEmailsQuery>;
export type GetCoiEmailsLazyQueryHookResult = ReturnType<typeof useGetCoiEmailsLazyQuery>;
export type GetCoiEmailsQueryResult = Apollo.QueryResult<GetCoiEmailsQuery, GetCoiEmailsQueryVariables>;
export const GetCoiEmailDocument = gql`
    query getCoiEmail($id: String!) {
  getCoiEmail(id: $id) {
    ...CoiEmailFields
  }
}
    ${CoiEmailFieldsFragmentDoc}`;

/**
 * __useGetCoiEmailQuery__
 *
 * To run a query within a React component, call `useGetCoiEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoiEmailQuery(baseOptions: Apollo.QueryHookOptions<GetCoiEmailQuery, GetCoiEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiEmailQuery, GetCoiEmailQueryVariables>(GetCoiEmailDocument, options);
      }
export function useGetCoiEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiEmailQuery, GetCoiEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiEmailQuery, GetCoiEmailQueryVariables>(GetCoiEmailDocument, options);
        }
export type GetCoiEmailQueryHookResult = ReturnType<typeof useGetCoiEmailQuery>;
export type GetCoiEmailLazyQueryHookResult = ReturnType<typeof useGetCoiEmailLazyQuery>;
export type GetCoiEmailQueryResult = Apollo.QueryResult<GetCoiEmailQuery, GetCoiEmailQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($data: CompanyPropertyCreateInput!) {
  createCompany(input: $data) {
    id
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const AddCompanyToPropertyDocument = gql`
    mutation addCompanyToProperty($data: CompanyPropertyAddInput!) {
  addCompanyToProperty(input: $data) {
    id
  }
}
    `;
export type AddCompanyToPropertyMutationFn = Apollo.MutationFunction<AddCompanyToPropertyMutation, AddCompanyToPropertyMutationVariables>;

/**
 * __useAddCompanyToPropertyMutation__
 *
 * To run a mutation, you first call `useAddCompanyToPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToPropertyMutation, { data, loading, error }] = useAddCompanyToPropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCompanyToPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyToPropertyMutation, AddCompanyToPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyToPropertyMutation, AddCompanyToPropertyMutationVariables>(AddCompanyToPropertyDocument, options);
      }
export type AddCompanyToPropertyMutationHookResult = ReturnType<typeof useAddCompanyToPropertyMutation>;
export type AddCompanyToPropertyMutationResult = Apollo.MutationResult<AddCompanyToPropertyMutation>;
export type AddCompanyToPropertyMutationOptions = Apollo.BaseMutationOptions<AddCompanyToPropertyMutation, AddCompanyToPropertyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: String!, $data: CompanyPropertyUpdateInput!) {
  updateCompany(companyId: $id, input: $data) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyPhotoDocument = gql`
    mutation updateCompanyPhoto($id: String!, $photo: FileObjectInput) {
  updateCompanyPhoto(companyId: $id, photo: $photo) {
    id
    photo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type UpdateCompanyPhotoMutationFn = Apollo.MutationFunction<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>;

/**
 * __useUpdateCompanyPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyPhotoMutation, { data, loading, error }] = useUpdateCompanyPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateCompanyPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>(UpdateCompanyPhotoDocument, options);
      }
export type UpdateCompanyPhotoMutationHookResult = ReturnType<typeof useUpdateCompanyPhotoMutation>;
export type UpdateCompanyPhotoMutationResult = Apollo.MutationResult<UpdateCompanyPhotoMutation>;
export type UpdateCompanyPhotoMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>;
export const UpdateCompanyAddressDocument = gql`
    mutation updateCompanyAddress($id: String!, $address: AddressInput) {
  updateCompanyAddress(companyId: $id, address: $address) {
    id
    address {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type UpdateCompanyAddressMutationFn = Apollo.MutationFunction<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>;

/**
 * __useUpdateCompanyAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAddressMutation, { data, loading, error }] = useUpdateCompanyAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateCompanyAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>(UpdateCompanyAddressDocument, options);
      }
export type UpdateCompanyAddressMutationHookResult = ReturnType<typeof useUpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationResult = Apollo.MutationResult<UpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>;
export const UpdateCompanyBillingDocument = gql`
    mutation updateCompanyBilling($id: String!, $billing: CompanyBillingInput!) {
  updateCompanyBilling(companyId: $id, billing: $billing) {
    id
    billing {
      email
      billTo
    }
  }
}
    `;
export type UpdateCompanyBillingMutationFn = Apollo.MutationFunction<UpdateCompanyBillingMutation, UpdateCompanyBillingMutationVariables>;

/**
 * __useUpdateCompanyBillingMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyBillingMutation, { data, loading, error }] = useUpdateCompanyBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      billing: // value for 'billing'
 *   },
 * });
 */
export function useUpdateCompanyBillingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyBillingMutation, UpdateCompanyBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyBillingMutation, UpdateCompanyBillingMutationVariables>(UpdateCompanyBillingDocument, options);
      }
export type UpdateCompanyBillingMutationHookResult = ReturnType<typeof useUpdateCompanyBillingMutation>;
export type UpdateCompanyBillingMutationResult = Apollo.MutationResult<UpdateCompanyBillingMutation>;
export type UpdateCompanyBillingMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyBillingMutation, UpdateCompanyBillingMutationVariables>;
export const ToggleCompanyDocument = gql`
    mutation toggleCompany($id: String!) {
  toggleCompany(companyId: $id)
}
    `;
export type ToggleCompanyMutationFn = Apollo.MutationFunction<ToggleCompanyMutation, ToggleCompanyMutationVariables>;

/**
 * __useToggleCompanyMutation__
 *
 * To run a mutation, you first call `useToggleCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCompanyMutation, { data, loading, error }] = useToggleCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCompanyMutation, ToggleCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCompanyMutation, ToggleCompanyMutationVariables>(ToggleCompanyDocument, options);
      }
export type ToggleCompanyMutationHookResult = ReturnType<typeof useToggleCompanyMutation>;
export type ToggleCompanyMutationResult = Apollo.MutationResult<ToggleCompanyMutation>;
export type ToggleCompanyMutationOptions = Apollo.BaseMutationOptions<ToggleCompanyMutation, ToggleCompanyMutationVariables>;
export const RemoveCompaniesDocument = gql`
    mutation removeCompanies($data: DeleteRecordsInput!) {
  removeCompanies(input: $data)
}
    `;
export type RemoveCompaniesMutationFn = Apollo.MutationFunction<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>;

/**
 * __useRemoveCompaniesMutation__
 *
 * To run a mutation, you first call `useRemoveCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompaniesMutation, { data, loading, error }] = useRemoveCompaniesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>(RemoveCompaniesDocument, options);
      }
export type RemoveCompaniesMutationHookResult = ReturnType<typeof useRemoveCompaniesMutation>;
export type RemoveCompaniesMutationResult = Apollo.MutationResult<RemoveCompaniesMutation>;
export type RemoveCompaniesMutationOptions = Apollo.BaseMutationOptions<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>;
export const GetCompaniesTableDocument = gql`
    query getCompaniesTable($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!], $active: Boolean) {
  getCompanies(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    companyTypes: $companyTypes
    active: $active
  ) @connection(key: "getCompaniesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
      index
      vendorId
      userCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetCompaniesTableQuery__
 *
 * To run a query within a React component, call `useGetCompaniesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesTableQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCompaniesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>(GetCompaniesTableDocument, options);
      }
export function useGetCompaniesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>(GetCompaniesTableDocument, options);
        }
export type GetCompaniesTableQueryHookResult = ReturnType<typeof useGetCompaniesTableQuery>;
export type GetCompaniesTableLazyQueryHookResult = ReturnType<typeof useGetCompaniesTableLazyQuery>;
export type GetCompaniesTableQueryResult = Apollo.QueryResult<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>;
export const GetCompaniesGeneaTableDocument = gql`
    query getCompaniesGeneaTable($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!], $active: Boolean) {
  getCompanies(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    companyTypes: $companyTypes
    active: $active
  ) @connection(key: "getCompaniesGeneaTable") {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      photo {
        ...FileFields
      }
      geneaTenant {
        ...GeneaTenantCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${GeneaTenantCoreFieldsFragmentDoc}`;

/**
 * __useGetCompaniesGeneaTableQuery__
 *
 * To run a query within a React component, call `useGetCompaniesGeneaTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesGeneaTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesGeneaTableQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCompaniesGeneaTableQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesGeneaTableQuery, GetCompaniesGeneaTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesGeneaTableQuery, GetCompaniesGeneaTableQueryVariables>(GetCompaniesGeneaTableDocument, options);
      }
export function useGetCompaniesGeneaTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesGeneaTableQuery, GetCompaniesGeneaTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesGeneaTableQuery, GetCompaniesGeneaTableQueryVariables>(GetCompaniesGeneaTableDocument, options);
        }
export type GetCompaniesGeneaTableQueryHookResult = ReturnType<typeof useGetCompaniesGeneaTableQuery>;
export type GetCompaniesGeneaTableLazyQueryHookResult = ReturnType<typeof useGetCompaniesGeneaTableLazyQuery>;
export type GetCompaniesGeneaTableQueryResult = Apollo.QueryResult<GetCompaniesGeneaTableQuery, GetCompaniesGeneaTableQueryVariables>;
export const GetCompaniesDropdownDocument = gql`
    query getCompaniesDropdown($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!], $active: Boolean, $includeBilling: Boolean!) {
  getCompanies(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    companyTypes: $companyTypes
    active: $active
  ) @connection(key: "getCompaniesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
      billing @include(if: $includeBilling) {
        email
        billTo
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetCompaniesDropdownQuery__
 *
 * To run a query within a React component, call `useGetCompaniesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesDropdownQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *      includeBilling: // value for 'includeBilling'
 *   },
 * });
 */
export function useGetCompaniesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>(GetCompaniesDropdownDocument, options);
      }
export function useGetCompaniesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>(GetCompaniesDropdownDocument, options);
        }
export type GetCompaniesDropdownQueryHookResult = ReturnType<typeof useGetCompaniesDropdownQuery>;
export type GetCompaniesDropdownLazyQueryHookResult = ReturnType<typeof useGetCompaniesDropdownLazyQuery>;
export type GetCompaniesDropdownQueryResult = Apollo.QueryResult<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>;
export const PopulateCompaniesDocument = gql`
    query populateCompanies($ids: [String!]!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  populateCompanies(
    ids: $ids
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      active
      photo {
        ...FileFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __usePopulateCompaniesQuery__
 *
 * To run a query within a React component, call `usePopulateCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopulateCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopulateCompaniesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePopulateCompaniesQuery(baseOptions: Apollo.QueryHookOptions<PopulateCompaniesQuery, PopulateCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopulateCompaniesQuery, PopulateCompaniesQueryVariables>(PopulateCompaniesDocument, options);
      }
export function usePopulateCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopulateCompaniesQuery, PopulateCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopulateCompaniesQuery, PopulateCompaniesQueryVariables>(PopulateCompaniesDocument, options);
        }
export type PopulateCompaniesQueryHookResult = ReturnType<typeof usePopulateCompaniesQuery>;
export type PopulateCompaniesLazyQueryHookResult = ReturnType<typeof usePopulateCompaniesLazyQuery>;
export type PopulateCompaniesQueryResult = Apollo.QueryResult<PopulateCompaniesQuery, PopulateCompaniesQueryVariables>;
export const GetOverlappingCompaniesDocument = gql`
    query getOverlappingCompanies($take: Int! = 10, $after: String, $before: String, $search: String, $userId: String!, $companyTypes: [CompanyTypeEnum!], $active: Boolean) {
  getOverlappingCompanies(
    take: $take
    after: $after
    before: $before
    search: $search
    userId: $userId
    companyTypes: $companyTypes
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetOverlappingCompaniesQuery__
 *
 * To run a query within a React component, call `useGetOverlappingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverlappingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverlappingCompaniesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      userId: // value for 'userId'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetOverlappingCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetOverlappingCompaniesQuery, GetOverlappingCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverlappingCompaniesQuery, GetOverlappingCompaniesQueryVariables>(GetOverlappingCompaniesDocument, options);
      }
export function useGetOverlappingCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverlappingCompaniesQuery, GetOverlappingCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverlappingCompaniesQuery, GetOverlappingCompaniesQueryVariables>(GetOverlappingCompaniesDocument, options);
        }
export type GetOverlappingCompaniesQueryHookResult = ReturnType<typeof useGetOverlappingCompaniesQuery>;
export type GetOverlappingCompaniesLazyQueryHookResult = ReturnType<typeof useGetOverlappingCompaniesLazyQuery>;
export type GetOverlappingCompaniesQueryResult = Apollo.QueryResult<GetOverlappingCompaniesQuery, GetOverlappingCompaniesQueryVariables>;
export const GetFilterableCompaniesDocument = gql`
    query getFilterableCompanies($location: FilterableCompanyLocationType!, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!]) {
  getFilterableCompanies(
    location: $location
    take: $take
    after: $after
    before: $before
    search: $search
    companyTypes: $companyTypes
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      active
      photo {
        ...FileFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetFilterableCompaniesQuery__
 *
 * To run a query within a React component, call `useGetFilterableCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterableCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterableCompaniesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *   },
 * });
 */
export function useGetFilterableCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterableCompaniesQuery, GetFilterableCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterableCompaniesQuery, GetFilterableCompaniesQueryVariables>(GetFilterableCompaniesDocument, options);
      }
export function useGetFilterableCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterableCompaniesQuery, GetFilterableCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterableCompaniesQuery, GetFilterableCompaniesQueryVariables>(GetFilterableCompaniesDocument, options);
        }
export type GetFilterableCompaniesQueryHookResult = ReturnType<typeof useGetFilterableCompaniesQuery>;
export type GetFilterableCompaniesLazyQueryHookResult = ReturnType<typeof useGetFilterableCompaniesLazyQuery>;
export type GetFilterableCompaniesQueryResult = Apollo.QueryResult<GetFilterableCompaniesQuery, GetFilterableCompaniesQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: String!) {
  getCompany(companyId: $id) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const SearchCompaniesDocument = gql`
    query searchCompanies($title: String!) {
  searchCompanies(title: $title) {
    id
    title
    type
    existInProperty
    photo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useSearchCompaniesQuery(baseOptions: Apollo.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
      }
export function useSearchCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(SearchCompaniesDocument, options);
        }
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesQueryResult = Apollo.QueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export const GetUserCompaniesDocument = gql`
    query getUserCompanies($userId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!], $active: Boolean) {
  getUserCompanies(
    userId: $userId
    take: $take
    after: $after
    before: $before
    search: $search
    companyTypes: $companyTypes
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetUserCompaniesQuery__
 *
 * To run a query within a React component, call `useGetUserCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCompaniesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>(GetUserCompaniesDocument, options);
      }
export function useGetUserCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>(GetUserCompaniesDocument, options);
        }
export type GetUserCompaniesQueryHookResult = ReturnType<typeof useGetUserCompaniesQuery>;
export type GetUserCompaniesLazyQueryHookResult = ReturnType<typeof useGetUserCompaniesLazyQuery>;
export type GetUserCompaniesQueryResult = Apollo.QueryResult<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>;
export const GetUserCompanyDocument = gql`
    query getUserCompany($userId: String!, $includeBilling: Boolean!) {
  getUserCompany(userId: $userId) {
    default {
      ...CompanyCoreFields
      billing @include(if: $includeBilling) {
        email
        billTo
      }
    }
    primary {
      ...CompanyCoreFields
      billing @include(if: $includeBilling) {
        email
        billTo
      }
    }
  }
}
    ${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetUserCompanyQuery__
 *
 * To run a query within a React component, call `useGetUserCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCompanyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeBilling: // value for 'includeBilling'
 *   },
 * });
 */
export function useGetUserCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetUserCompanyQuery, GetUserCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCompanyQuery, GetUserCompanyQueryVariables>(GetUserCompanyDocument, options);
      }
export function useGetUserCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCompanyQuery, GetUserCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCompanyQuery, GetUserCompanyQueryVariables>(GetUserCompanyDocument, options);
        }
export type GetUserCompanyQueryHookResult = ReturnType<typeof useGetUserCompanyQuery>;
export type GetUserCompanyLazyQueryHookResult = ReturnType<typeof useGetUserCompanyLazyQuery>;
export type GetUserCompanyQueryResult = Apollo.QueryResult<GetUserCompanyQuery, GetUserCompanyQueryVariables>;
export const ExportCompaniesDocument = gql`
    query exportCompanies($admin: Boolean = false, $search: String, $companyTypes: [CompanyTypeEnum!], $active: Boolean) {
  exportCompanies(
    admin: $admin
    search: $search
    companyTypes: $companyTypes
    active: $active
  )
}
    `;

/**
 * __useExportCompaniesQuery__
 *
 * To run a query within a React component, call `useExportCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCompaniesQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useExportCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ExportCompaniesQuery, ExportCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCompaniesQuery, ExportCompaniesQueryVariables>(ExportCompaniesDocument, options);
      }
export function useExportCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCompaniesQuery, ExportCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCompaniesQuery, ExportCompaniesQueryVariables>(ExportCompaniesDocument, options);
        }
export type ExportCompaniesQueryHookResult = ReturnType<typeof useExportCompaniesQuery>;
export type ExportCompaniesLazyQueryHookResult = ReturnType<typeof useExportCompaniesLazyQuery>;
export type ExportCompaniesQueryResult = Apollo.QueryResult<ExportCompaniesQuery, ExportCompaniesQueryVariables>;
export const CreateDealCategoryDocument = gql`
    mutation createDealCategory($data: NewDealCategoryInput!) {
  createDealCategory(input: $data) {
    id
  }
}
    `;
export type CreateDealCategoryMutationFn = Apollo.MutationFunction<CreateDealCategoryMutation, CreateDealCategoryMutationVariables>;

/**
 * __useCreateDealCategoryMutation__
 *
 * To run a mutation, you first call `useCreateDealCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealCategoryMutation, { data, loading, error }] = useCreateDealCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDealCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDealCategoryMutation, CreateDealCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDealCategoryMutation, CreateDealCategoryMutationVariables>(CreateDealCategoryDocument, options);
      }
export type CreateDealCategoryMutationHookResult = ReturnType<typeof useCreateDealCategoryMutation>;
export type CreateDealCategoryMutationResult = Apollo.MutationResult<CreateDealCategoryMutation>;
export type CreateDealCategoryMutationOptions = Apollo.BaseMutationOptions<CreateDealCategoryMutation, CreateDealCategoryMutationVariables>;
export const UpdateDealCategoryDocument = gql`
    mutation updateDealCategory($id: String!, $data: UpdateDealCategoryInput!) {
  updateDealCategory(id: $id, input: $data) {
    ...DealCategoryFields
  }
}
    ${DealCategoryFieldsFragmentDoc}`;
export type UpdateDealCategoryMutationFn = Apollo.MutationFunction<UpdateDealCategoryMutation, UpdateDealCategoryMutationVariables>;

/**
 * __useUpdateDealCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateDealCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealCategoryMutation, { data, loading, error }] = useUpdateDealCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDealCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealCategoryMutation, UpdateDealCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealCategoryMutation, UpdateDealCategoryMutationVariables>(UpdateDealCategoryDocument, options);
      }
export type UpdateDealCategoryMutationHookResult = ReturnType<typeof useUpdateDealCategoryMutation>;
export type UpdateDealCategoryMutationResult = Apollo.MutationResult<UpdateDealCategoryMutation>;
export type UpdateDealCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateDealCategoryMutation, UpdateDealCategoryMutationVariables>;
export const RemoveDealCategoriesDocument = gql`
    mutation removeDealCategories($data: DeleteRecordsInput!) {
  removeDealCategories(input: $data)
}
    `;
export type RemoveDealCategoriesMutationFn = Apollo.MutationFunction<RemoveDealCategoriesMutation, RemoveDealCategoriesMutationVariables>;

/**
 * __useRemoveDealCategoriesMutation__
 *
 * To run a mutation, you first call `useRemoveDealCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDealCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDealCategoriesMutation, { data, loading, error }] = useRemoveDealCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveDealCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDealCategoriesMutation, RemoveDealCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDealCategoriesMutation, RemoveDealCategoriesMutationVariables>(RemoveDealCategoriesDocument, options);
      }
export type RemoveDealCategoriesMutationHookResult = ReturnType<typeof useRemoveDealCategoriesMutation>;
export type RemoveDealCategoriesMutationResult = Apollo.MutationResult<RemoveDealCategoriesMutation>;
export type RemoveDealCategoriesMutationOptions = Apollo.BaseMutationOptions<RemoveDealCategoriesMutation, RemoveDealCategoriesMutationVariables>;
export const ReorderDealCategoriesDocument = gql`
    mutation reorderDealCategories($id: String!, $secondId: String!) {
  reorderDealCategories(id: $id, secondId: $secondId)
}
    `;
export type ReorderDealCategoriesMutationFn = Apollo.MutationFunction<ReorderDealCategoriesMutation, ReorderDealCategoriesMutationVariables>;

/**
 * __useReorderDealCategoriesMutation__
 *
 * To run a mutation, you first call `useReorderDealCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderDealCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderDealCategoriesMutation, { data, loading, error }] = useReorderDealCategoriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderDealCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderDealCategoriesMutation, ReorderDealCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderDealCategoriesMutation, ReorderDealCategoriesMutationVariables>(ReorderDealCategoriesDocument, options);
      }
export type ReorderDealCategoriesMutationHookResult = ReturnType<typeof useReorderDealCategoriesMutation>;
export type ReorderDealCategoriesMutationResult = Apollo.MutationResult<ReorderDealCategoriesMutation>;
export type ReorderDealCategoriesMutationOptions = Apollo.BaseMutationOptions<ReorderDealCategoriesMutation, ReorderDealCategoriesMutationVariables>;
export const GetDealCategoriesDocument = gql`
    query getDealCategories {
  getDealCategories {
    ...DealCategoryFields
    order
  }
}
    ${DealCategoryFieldsFragmentDoc}`;

/**
 * __useGetDealCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDealCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDealCategoriesQuery, GetDealCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealCategoriesQuery, GetDealCategoriesQueryVariables>(GetDealCategoriesDocument, options);
      }
export function useGetDealCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealCategoriesQuery, GetDealCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealCategoriesQuery, GetDealCategoriesQueryVariables>(GetDealCategoriesDocument, options);
        }
export type GetDealCategoriesQueryHookResult = ReturnType<typeof useGetDealCategoriesQuery>;
export type GetDealCategoriesLazyQueryHookResult = ReturnType<typeof useGetDealCategoriesLazyQuery>;
export type GetDealCategoriesQueryResult = Apollo.QueryResult<GetDealCategoriesQuery, GetDealCategoriesQueryVariables>;
export const GetDealCategoryDocument = gql`
    query getDealCategory($id: String!) {
  getDealCategory(id: $id) {
    ...DealCategoryFields
  }
}
    ${DealCategoryFieldsFragmentDoc}`;

/**
 * __useGetDealCategoryQuery__
 *
 * To run a query within a React component, call `useGetDealCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDealCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetDealCategoryQuery, GetDealCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealCategoryQuery, GetDealCategoryQueryVariables>(GetDealCategoryDocument, options);
      }
export function useGetDealCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealCategoryQuery, GetDealCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealCategoryQuery, GetDealCategoryQueryVariables>(GetDealCategoryDocument, options);
        }
export type GetDealCategoryQueryHookResult = ReturnType<typeof useGetDealCategoryQuery>;
export type GetDealCategoryLazyQueryHookResult = ReturnType<typeof useGetDealCategoryLazyQuery>;
export type GetDealCategoryQueryResult = Apollo.QueryResult<GetDealCategoryQuery, GetDealCategoryQueryVariables>;
export const ExportDealCategoriesDocument = gql`
    query exportDealCategories {
  exportDealCategories
}
    `;

/**
 * __useExportDealCategoriesQuery__
 *
 * To run a query within a React component, call `useExportDealCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDealCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDealCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportDealCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ExportDealCategoriesQuery, ExportDealCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDealCategoriesQuery, ExportDealCategoriesQueryVariables>(ExportDealCategoriesDocument, options);
      }
export function useExportDealCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDealCategoriesQuery, ExportDealCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDealCategoriesQuery, ExportDealCategoriesQueryVariables>(ExportDealCategoriesDocument, options);
        }
export type ExportDealCategoriesQueryHookResult = ReturnType<typeof useExportDealCategoriesQuery>;
export type ExportDealCategoriesLazyQueryHookResult = ReturnType<typeof useExportDealCategoriesLazyQuery>;
export type ExportDealCategoriesQueryResult = Apollo.QueryResult<ExportDealCategoriesQuery, ExportDealCategoriesQueryVariables>;
export const CreateDealDocument = gql`
    mutation createDeal($data: DealInput!) {
  createDeal(input: $data) {
    id
  }
}
    `;
export type CreateDealMutationFn = Apollo.MutationFunction<CreateDealMutation, CreateDealMutationVariables>;

/**
 * __useCreateDealMutation__
 *
 * To run a mutation, you first call `useCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealMutation, { data, loading, error }] = useCreateDealMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDealMutation(baseOptions?: Apollo.MutationHookOptions<CreateDealMutation, CreateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDealMutation, CreateDealMutationVariables>(CreateDealDocument, options);
      }
export type CreateDealMutationHookResult = ReturnType<typeof useCreateDealMutation>;
export type CreateDealMutationResult = Apollo.MutationResult<CreateDealMutation>;
export type CreateDealMutationOptions = Apollo.BaseMutationOptions<CreateDealMutation, CreateDealMutationVariables>;
export const UpdateDealDocument = gql`
    mutation updateDeal($id: String!, $data: DealUpdateInput!) {
  updateDeal(dealId: $id, input: $data) {
    ...DealFields
  }
}
    ${DealFieldsFragmentDoc}`;
export type UpdateDealMutationFn = Apollo.MutationFunction<UpdateDealMutation, UpdateDealMutationVariables>;

/**
 * __useUpdateDealMutation__
 *
 * To run a mutation, you first call `useUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealMutation, { data, loading, error }] = useUpdateDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDealMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealMutation, UpdateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealMutation, UpdateDealMutationVariables>(UpdateDealDocument, options);
      }
export type UpdateDealMutationHookResult = ReturnType<typeof useUpdateDealMutation>;
export type UpdateDealMutationResult = Apollo.MutationResult<UpdateDealMutation>;
export type UpdateDealMutationOptions = Apollo.BaseMutationOptions<UpdateDealMutation, UpdateDealMutationVariables>;
export const RemoveDealsDocument = gql`
    mutation removeDeals($data: DeleteRecordsInput!) {
  removeDeals(input: $data)
}
    `;
export type RemoveDealsMutationFn = Apollo.MutationFunction<RemoveDealsMutation, RemoveDealsMutationVariables>;

/**
 * __useRemoveDealsMutation__
 *
 * To run a mutation, you first call `useRemoveDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDealsMutation, { data, loading, error }] = useRemoveDealsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveDealsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDealsMutation, RemoveDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDealsMutation, RemoveDealsMutationVariables>(RemoveDealsDocument, options);
      }
export type RemoveDealsMutationHookResult = ReturnType<typeof useRemoveDealsMutation>;
export type RemoveDealsMutationResult = Apollo.MutationResult<RemoveDealsMutation>;
export type RemoveDealsMutationOptions = Apollo.BaseMutationOptions<RemoveDealsMutation, RemoveDealsMutationVariables>;
export const ToggleDealDocument = gql`
    mutation toggleDeal($id: String!) {
  toggleDeal(id: $id)
}
    `;
export type ToggleDealMutationFn = Apollo.MutationFunction<ToggleDealMutation, ToggleDealMutationVariables>;

/**
 * __useToggleDealMutation__
 *
 * To run a mutation, you first call `useToggleDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDealMutation, { data, loading, error }] = useToggleDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleDealMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDealMutation, ToggleDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleDealMutation, ToggleDealMutationVariables>(ToggleDealDocument, options);
      }
export type ToggleDealMutationHookResult = ReturnType<typeof useToggleDealMutation>;
export type ToggleDealMutationResult = Apollo.MutationResult<ToggleDealMutation>;
export type ToggleDealMutationOptions = Apollo.BaseMutationOptions<ToggleDealMutation, ToggleDealMutationVariables>;
export const RedeemDealDocument = gql`
    mutation redeemDeal($dealId: String!) {
  redeemDeal(dealId: $dealId)
}
    `;
export type RedeemDealMutationFn = Apollo.MutationFunction<RedeemDealMutation, RedeemDealMutationVariables>;

/**
 * __useRedeemDealMutation__
 *
 * To run a mutation, you first call `useRedeemDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemDealMutation, { data, loading, error }] = useRedeemDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useRedeemDealMutation(baseOptions?: Apollo.MutationHookOptions<RedeemDealMutation, RedeemDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemDealMutation, RedeemDealMutationVariables>(RedeemDealDocument, options);
      }
export type RedeemDealMutationHookResult = ReturnType<typeof useRedeemDealMutation>;
export type RedeemDealMutationResult = Apollo.MutationResult<RedeemDealMutation>;
export type RedeemDealMutationOptions = Apollo.BaseMutationOptions<RedeemDealMutation, RedeemDealMutationVariables>;
export const GetDealsPublicDocument = gql`
    query getDealsPublic($categoryIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $expired: Boolean) {
  getDeals(
    categoryIds: $categoryIds
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
    expired: $expired
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      active
      description
      discount
      redemptionCount
      redemptionUniqCount
      validUntil
      image {
        ...FileFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetDealsPublicQuery__
 *
 * To run a query within a React component, call `useGetDealsPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsPublicQuery({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      expired: // value for 'expired'
 *   },
 * });
 */
export function useGetDealsPublicQuery(baseOptions?: Apollo.QueryHookOptions<GetDealsPublicQuery, GetDealsPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsPublicQuery, GetDealsPublicQueryVariables>(GetDealsPublicDocument, options);
      }
export function useGetDealsPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsPublicQuery, GetDealsPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsPublicQuery, GetDealsPublicQueryVariables>(GetDealsPublicDocument, options);
        }
export type GetDealsPublicQueryHookResult = ReturnType<typeof useGetDealsPublicQuery>;
export type GetDealsPublicLazyQueryHookResult = ReturnType<typeof useGetDealsPublicLazyQuery>;
export type GetDealsPublicQueryResult = Apollo.QueryResult<GetDealsPublicQuery, GetDealsPublicQueryVariables>;
export const GetDealsAdminDocument = gql`
    query getDealsAdmin($categoryIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getDeals(
    categoryIds: $categoryIds
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      title
      active
      category {
        ...DealCategoryCoreFields
      }
      discount
      redemptionCount
      validUntil
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${DealCategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetDealsAdminQuery__
 *
 * To run a query within a React component, call `useGetDealsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsAdminQuery({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetDealsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetDealsAdminQuery, GetDealsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsAdminQuery, GetDealsAdminQueryVariables>(GetDealsAdminDocument, options);
      }
export function useGetDealsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsAdminQuery, GetDealsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsAdminQuery, GetDealsAdminQueryVariables>(GetDealsAdminDocument, options);
        }
export type GetDealsAdminQueryHookResult = ReturnType<typeof useGetDealsAdminQuery>;
export type GetDealsAdminLazyQueryHookResult = ReturnType<typeof useGetDealsAdminLazyQuery>;
export type GetDealsAdminQueryResult = Apollo.QueryResult<GetDealsAdminQuery, GetDealsAdminQueryVariables>;
export const GetDealDocument = gql`
    query getDeal($id: String!) {
  getDeal(dealId: $id) {
    ...DealFields
  }
}
    ${DealFieldsFragmentDoc}`;

/**
 * __useGetDealQuery__
 *
 * To run a query within a React component, call `useGetDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDealQuery(baseOptions: Apollo.QueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
      }
export function useGetDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealQuery, GetDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealQuery, GetDealQueryVariables>(GetDealDocument, options);
        }
export type GetDealQueryHookResult = ReturnType<typeof useGetDealQuery>;
export type GetDealLazyQueryHookResult = ReturnType<typeof useGetDealLazyQuery>;
export type GetDealQueryResult = Apollo.QueryResult<GetDealQuery, GetDealQueryVariables>;
export const CreateCouponDocument = gql`
    mutation createCoupon($data: CouponInput!) {
  createCoupon(input: $data) {
    id
  }
}
    `;
export type CreateCouponMutationFn = Apollo.MutationFunction<CreateCouponMutation, CreateCouponMutationVariables>;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCouponMutation(baseOptions?: Apollo.MutationHookOptions<CreateCouponMutation, CreateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCouponMutation, CreateCouponMutationVariables>(CreateCouponDocument, options);
      }
export type CreateCouponMutationHookResult = ReturnType<typeof useCreateCouponMutation>;
export type CreateCouponMutationResult = Apollo.MutationResult<CreateCouponMutation>;
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables>;
export const UpdateCouponDocument = gql`
    mutation updateCoupon($id: String!, $data: CouponUpdateInput!) {
  updateCoupon(id: $id, input: $data) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;
export type UpdateCouponMutationFn = Apollo.MutationFunction<UpdateCouponMutation, UpdateCouponMutationVariables>;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCouponMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCouponMutation, UpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCouponMutation, UpdateCouponMutationVariables>(UpdateCouponDocument, options);
      }
export type UpdateCouponMutationHookResult = ReturnType<typeof useUpdateCouponMutation>;
export type UpdateCouponMutationResult = Apollo.MutationResult<UpdateCouponMutation>;
export type UpdateCouponMutationOptions = Apollo.BaseMutationOptions<UpdateCouponMutation, UpdateCouponMutationVariables>;
export const RemoveCouponsDocument = gql`
    mutation removeCoupons($data: DeleteRecordsInput!) {
  removeCoupons(input: $data)
}
    `;
export type RemoveCouponsMutationFn = Apollo.MutationFunction<RemoveCouponsMutation, RemoveCouponsMutationVariables>;

/**
 * __useRemoveCouponsMutation__
 *
 * To run a mutation, you first call `useRemoveCouponsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponsMutation, { data, loading, error }] = useRemoveCouponsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCouponsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponsMutation, RemoveCouponsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCouponsMutation, RemoveCouponsMutationVariables>(RemoveCouponsDocument, options);
      }
export type RemoveCouponsMutationHookResult = ReturnType<typeof useRemoveCouponsMutation>;
export type RemoveCouponsMutationResult = Apollo.MutationResult<RemoveCouponsMutation>;
export type RemoveCouponsMutationOptions = Apollo.BaseMutationOptions<RemoveCouponsMutation, RemoveCouponsMutationVariables>;
export const GetCouponsListDocument = gql`
    query getCouponsList {
  getCouponsList {
    id
    title
    createdAt
    discountAmount
    discountType
    duration
  }
}
    `;

/**
 * __useGetCouponsListQuery__
 *
 * To run a query within a React component, call `useGetCouponsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCouponsListQuery(baseOptions?: Apollo.QueryHookOptions<GetCouponsListQuery, GetCouponsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponsListQuery, GetCouponsListQueryVariables>(GetCouponsListDocument, options);
      }
export function useGetCouponsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponsListQuery, GetCouponsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponsListQuery, GetCouponsListQueryVariables>(GetCouponsListDocument, options);
        }
export type GetCouponsListQueryHookResult = ReturnType<typeof useGetCouponsListQuery>;
export type GetCouponsListLazyQueryHookResult = ReturnType<typeof useGetCouponsListLazyQuery>;
export type GetCouponsListQueryResult = Apollo.QueryResult<GetCouponsListQuery, GetCouponsListQueryVariables>;
export const GetCouponDocument = gql`
    query getCoupon($id: String!) {
  getCoupon(id: $id) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;

/**
 * __useGetCouponQuery__
 *
 * To run a query within a React component, call `useGetCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCouponQuery(baseOptions: Apollo.QueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
      }
export function useGetCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export type GetCouponQueryHookResult = ReturnType<typeof useGetCouponQuery>;
export type GetCouponLazyQueryHookResult = ReturnType<typeof useGetCouponLazyQuery>;
export type GetCouponQueryResult = Apollo.QueryResult<GetCouponQuery, GetCouponQueryVariables>;
export const CreateCustomFieldDocument = gql`
    mutation createCustomField($data: CustomFieldCreateInput!) {
  createCustomField(input: $data) {
    id
  }
}
    `;
export type CreateCustomFieldMutationFn = Apollo.MutationFunction<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;

/**
 * __useCreateCustomFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldMutation, { data, loading, error }] = useCreateCustomFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, options);
      }
export type CreateCustomFieldMutationHookResult = ReturnType<typeof useCreateCustomFieldMutation>;
export type CreateCustomFieldMutationResult = Apollo.MutationResult<CreateCustomFieldMutation>;
export type CreateCustomFieldMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;
export const UpdateCustomFieldDocument = gql`
    mutation updateCustomField($id: String!, $data: CustomFieldUpdateInput!) {
  updateCustomField(id: $id, input: $data) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;
export type UpdateCustomFieldMutationFn = Apollo.MutationFunction<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;

/**
 * __useUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldMutation, { data, loading, error }] = useUpdateCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>(UpdateCustomFieldDocument, options);
      }
export type UpdateCustomFieldMutationHookResult = ReturnType<typeof useUpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationResult = Apollo.MutationResult<UpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;
export const ReorderCustomFieldsDocument = gql`
    mutation reorderCustomFields($id: String!, $secondId: String!) {
  reorderCustomFields(id: $id, secondId: $secondId)
}
    `;
export type ReorderCustomFieldsMutationFn = Apollo.MutationFunction<ReorderCustomFieldsMutation, ReorderCustomFieldsMutationVariables>;

/**
 * __useReorderCustomFieldsMutation__
 *
 * To run a mutation, you first call `useReorderCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCustomFieldsMutation, { data, loading, error }] = useReorderCustomFieldsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCustomFieldsMutation, ReorderCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCustomFieldsMutation, ReorderCustomFieldsMutationVariables>(ReorderCustomFieldsDocument, options);
      }
export type ReorderCustomFieldsMutationHookResult = ReturnType<typeof useReorderCustomFieldsMutation>;
export type ReorderCustomFieldsMutationResult = Apollo.MutationResult<ReorderCustomFieldsMutation>;
export type ReorderCustomFieldsMutationOptions = Apollo.BaseMutationOptions<ReorderCustomFieldsMutation, ReorderCustomFieldsMutationVariables>;
export const ToggleCustomFieldDocument = gql`
    mutation toggleCustomField($data: CustomFieldToggleInput!) {
  toggleCustomField(input: $data)
}
    `;
export type ToggleCustomFieldMutationFn = Apollo.MutationFunction<ToggleCustomFieldMutation, ToggleCustomFieldMutationVariables>;

/**
 * __useToggleCustomFieldMutation__
 *
 * To run a mutation, you first call `useToggleCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCustomFieldMutation, { data, loading, error }] = useToggleCustomFieldMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCustomFieldMutation, ToggleCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCustomFieldMutation, ToggleCustomFieldMutationVariables>(ToggleCustomFieldDocument, options);
      }
export type ToggleCustomFieldMutationHookResult = ReturnType<typeof useToggleCustomFieldMutation>;
export type ToggleCustomFieldMutationResult = Apollo.MutationResult<ToggleCustomFieldMutation>;
export type ToggleCustomFieldMutationOptions = Apollo.BaseMutationOptions<ToggleCustomFieldMutation, ToggleCustomFieldMutationVariables>;
export const RemoveCustomFieldsDocument = gql`
    mutation removeCustomFields($data: DeleteRecordsInput!) {
  removeCustomFields(input: $data)
}
    `;
export type RemoveCustomFieldsMutationFn = Apollo.MutationFunction<RemoveCustomFieldsMutation, RemoveCustomFieldsMutationVariables>;

/**
 * __useRemoveCustomFieldsMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldsMutation, { data, loading, error }] = useRemoveCustomFieldsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldsMutation, RemoveCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldsMutation, RemoveCustomFieldsMutationVariables>(RemoveCustomFieldsDocument, options);
      }
export type RemoveCustomFieldsMutationHookResult = ReturnType<typeof useRemoveCustomFieldsMutation>;
export type RemoveCustomFieldsMutationResult = Apollo.MutationResult<RemoveCustomFieldsMutation>;
export type RemoveCustomFieldsMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldsMutation, RemoveCustomFieldsMutationVariables>;
export const GetAdminCustomFieldsTableDocument = gql`
    query getAdminCustomFieldsTable($recordType: CustomFieldRecordType, $active: Boolean, $search: String) {
  getCustomFields(recordType: $recordType, active: $active, search: $search) {
    id
    index
    key
    label
    type
    active
  }
}
    `;

/**
 * __useGetAdminCustomFieldsTableQuery__
 *
 * To run a query within a React component, call `useGetAdminCustomFieldsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCustomFieldsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCustomFieldsTableQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAdminCustomFieldsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminCustomFieldsTableQuery, GetAdminCustomFieldsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminCustomFieldsTableQuery, GetAdminCustomFieldsTableQueryVariables>(GetAdminCustomFieldsTableDocument, options);
      }
export function useGetAdminCustomFieldsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCustomFieldsTableQuery, GetAdminCustomFieldsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminCustomFieldsTableQuery, GetAdminCustomFieldsTableQueryVariables>(GetAdminCustomFieldsTableDocument, options);
        }
export type GetAdminCustomFieldsTableQueryHookResult = ReturnType<typeof useGetAdminCustomFieldsTableQuery>;
export type GetAdminCustomFieldsTableLazyQueryHookResult = ReturnType<typeof useGetAdminCustomFieldsTableLazyQuery>;
export type GetAdminCustomFieldsTableQueryResult = Apollo.QueryResult<GetAdminCustomFieldsTableQuery, GetAdminCustomFieldsTableQueryVariables>;
export const GetFeatureCustomFieldsDocument = gql`
    query getFeatureCustomFields($recordType: CustomFieldRecordType!, $active: Boolean, $search: String) {
  getCustomFields(recordType: $recordType, active: $active, search: $search) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useGetFeatureCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetFeatureCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureCustomFieldsQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFeatureCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureCustomFieldsQuery, GetFeatureCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureCustomFieldsQuery, GetFeatureCustomFieldsQueryVariables>(GetFeatureCustomFieldsDocument, options);
      }
export function useGetFeatureCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureCustomFieldsQuery, GetFeatureCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureCustomFieldsQuery, GetFeatureCustomFieldsQueryVariables>(GetFeatureCustomFieldsDocument, options);
        }
export type GetFeatureCustomFieldsQueryHookResult = ReturnType<typeof useGetFeatureCustomFieldsQuery>;
export type GetFeatureCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetFeatureCustomFieldsLazyQuery>;
export type GetFeatureCustomFieldsQueryResult = Apollo.QueryResult<GetFeatureCustomFieldsQuery, GetFeatureCustomFieldsQueryVariables>;
export const GetCustomFieldDocument = gql`
    query getCustomField($id: String!) {
  getCustomField(id: $id) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useGetCustomFieldQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomFieldQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFieldQuery, GetCustomFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldQuery, GetCustomFieldQueryVariables>(GetCustomFieldDocument, options);
      }
export function useGetCustomFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldQuery, GetCustomFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldQuery, GetCustomFieldQueryVariables>(GetCustomFieldDocument, options);
        }
export type GetCustomFieldQueryHookResult = ReturnType<typeof useGetCustomFieldQuery>;
export type GetCustomFieldLazyQueryHookResult = ReturnType<typeof useGetCustomFieldLazyQuery>;
export type GetCustomFieldQueryResult = Apollo.QueryResult<GetCustomFieldQuery, GetCustomFieldQueryVariables>;
export const CreateDeviceDocument = gql`
    mutation createDevice($data: DeviceInput!) {
  createDevice(input: $data) {
    id
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const UpdateDeviceDocument = gql`
    mutation updateDevice($id: String!, $data: DeviceUpdateInput!) {
  updateDevice(deviceId: $id, input: $data) {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<UpdateDeviceMutation, UpdateDeviceMutationVariables>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument, options);
      }
export type UpdateDeviceMutationHookResult = ReturnType<typeof useUpdateDeviceMutation>;
export type UpdateDeviceMutationResult = Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const SetPrimaryDeviceDocument = gql`
    mutation setPrimaryDevice($id: String!) {
  setPrimaryDevice(deviceId: $id) {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;
export type SetPrimaryDeviceMutationFn = Apollo.MutationFunction<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>;

/**
 * __useSetPrimaryDeviceMutation__
 *
 * To run a mutation, you first call `useSetPrimaryDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryDeviceMutation, { data, loading, error }] = useSetPrimaryDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>(SetPrimaryDeviceDocument, options);
      }
export type SetPrimaryDeviceMutationHookResult = ReturnType<typeof useSetPrimaryDeviceMutation>;
export type SetPrimaryDeviceMutationResult = Apollo.MutationResult<SetPrimaryDeviceMutation>;
export type SetPrimaryDeviceMutationOptions = Apollo.BaseMutationOptions<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>;
export const ToggleDeviceDocument = gql`
    mutation toggleDevice($id: String!) {
  toggleDevice(deviceId: $id)
}
    `;
export type ToggleDeviceMutationFn = Apollo.MutationFunction<ToggleDeviceMutation, ToggleDeviceMutationVariables>;

/**
 * __useToggleDeviceMutation__
 *
 * To run a mutation, you first call `useToggleDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDeviceMutation, { data, loading, error }] = useToggleDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleDeviceMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDeviceMutation, ToggleDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleDeviceMutation, ToggleDeviceMutationVariables>(ToggleDeviceDocument, options);
      }
export type ToggleDeviceMutationHookResult = ReturnType<typeof useToggleDeviceMutation>;
export type ToggleDeviceMutationResult = Apollo.MutationResult<ToggleDeviceMutation>;
export type ToggleDeviceMutationOptions = Apollo.BaseMutationOptions<ToggleDeviceMutation, ToggleDeviceMutationVariables>;
export const DeleteDevicesDocument = gql`
    mutation deleteDevices($data: DeleteRecordsInput!) {
  deleteDevices(input: $data)
}
    `;
export type DeleteDevicesMutationFn = Apollo.MutationFunction<DeleteDevicesMutation, DeleteDevicesMutationVariables>;

/**
 * __useDeleteDevicesMutation__
 *
 * To run a mutation, you first call `useDeleteDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDevicesMutation, { data, loading, error }] = useDeleteDevicesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteDevicesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDevicesMutation, DeleteDevicesMutationVariables>(DeleteDevicesDocument, options);
      }
export type DeleteDevicesMutationHookResult = ReturnType<typeof useDeleteDevicesMutation>;
export type DeleteDevicesMutationResult = Apollo.MutationResult<DeleteDevicesMutation>;
export type DeleteDevicesMutationOptions = Apollo.BaseMutationOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>;
export const GetDevicesDocument = gql`
    query getDevices($active: Boolean) {
  getDevices(active: $active) {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;

/**
 * __useGetDevicesQuery__
 *
 * To run a query within a React component, call `useGetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetDevicesQuery(baseOptions?: Apollo.QueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevicesQuery, GetDevicesQueryVariables>(GetDevicesDocument, options);
      }
export function useGetDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevicesQuery, GetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevicesQuery, GetDevicesQueryVariables>(GetDevicesDocument, options);
        }
export type GetDevicesQueryHookResult = ReturnType<typeof useGetDevicesQuery>;
export type GetDevicesLazyQueryHookResult = ReturnType<typeof useGetDevicesLazyQuery>;
export type GetDevicesQueryResult = Apollo.QueryResult<GetDevicesQuery, GetDevicesQueryVariables>;
export const GetDeviceDocument = gql`
    query getDevice($id: String!) {
  getDevice(id: $id) {
    ...DeviceFields
  }
}
    ${DeviceFieldsFragmentDoc}`;

/**
 * __useGetDeviceQuery__
 *
 * To run a query within a React component, call `useGetDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, options);
      }
export function useGetDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, options);
        }
export type GetDeviceQueryHookResult = ReturnType<typeof useGetDeviceQuery>;
export type GetDeviceLazyQueryHookResult = ReturnType<typeof useGetDeviceLazyQuery>;
export type GetDeviceQueryResult = Apollo.QueryResult<GetDeviceQuery, GetDeviceQueryVariables>;
export const GetDeviceQrCodeDocument = gql`
    query getDeviceQrCode($id: String!) {
  getDeviceQrCode(deviceId: $id)
}
    `;

/**
 * __useGetDeviceQrCodeQuery__
 *
 * To run a query within a React component, call `useGetDeviceQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceQrCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceQrCodeQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceQrCodeQuery, GetDeviceQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceQrCodeQuery, GetDeviceQrCodeQueryVariables>(GetDeviceQrCodeDocument, options);
      }
export function useGetDeviceQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceQrCodeQuery, GetDeviceQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceQrCodeQuery, GetDeviceQrCodeQueryVariables>(GetDeviceQrCodeDocument, options);
        }
export type GetDeviceQrCodeQueryHookResult = ReturnType<typeof useGetDeviceQrCodeQuery>;
export type GetDeviceQrCodeLazyQueryHookResult = ReturnType<typeof useGetDeviceQrCodeLazyQuery>;
export type GetDeviceQrCodeQueryResult = Apollo.QueryResult<GetDeviceQrCodeQuery, GetDeviceQrCodeQueryVariables>;
export const ExportDevicesDocument = gql`
    query exportDevices($active: Boolean) {
  exportDevices(active: $active)
}
    `;

/**
 * __useExportDevicesQuery__
 *
 * To run a query within a React component, call `useExportDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDevicesQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useExportDevicesQuery(baseOptions?: Apollo.QueryHookOptions<ExportDevicesQuery, ExportDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDevicesQuery, ExportDevicesQueryVariables>(ExportDevicesDocument, options);
      }
export function useExportDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDevicesQuery, ExportDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDevicesQuery, ExportDevicesQueryVariables>(ExportDevicesDocument, options);
        }
export type ExportDevicesQueryHookResult = ReturnType<typeof useExportDevicesQuery>;
export type ExportDevicesLazyQueryHookResult = ReturnType<typeof useExportDevicesLazyQuery>;
export type ExportDevicesQueryResult = Apollo.QueryResult<ExportDevicesQuery, ExportDevicesQueryVariables>;
export const GetDeviceLogsDocument = gql`
    query getDeviceLogs($deviceId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getDeviceLogs(
    deviceId: $deviceId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      location
      message
      type
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetDeviceLogsQuery__
 *
 * To run a query within a React component, call `useGetDeviceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceLogsQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDeviceLogsQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceLogsQuery, GetDeviceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceLogsQuery, GetDeviceLogsQueryVariables>(GetDeviceLogsDocument, options);
      }
export function useGetDeviceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceLogsQuery, GetDeviceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceLogsQuery, GetDeviceLogsQueryVariables>(GetDeviceLogsDocument, options);
        }
export type GetDeviceLogsQueryHookResult = ReturnType<typeof useGetDeviceLogsQuery>;
export type GetDeviceLogsLazyQueryHookResult = ReturnType<typeof useGetDeviceLogsLazyQuery>;
export type GetDeviceLogsQueryResult = Apollo.QueryResult<GetDeviceLogsQuery, GetDeviceLogsQueryVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation updateEmailTemplate($data: UpdateEmailTemplateInput!, $type: EmailTemplateType!) {
  updateEmailTemplate(input: $data, type: $type)
}
    `;
export type UpdateEmailTemplateMutationFn = Apollo.MutationFunction<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
      }
export type UpdateEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationResult = Apollo.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const ToggleEmailTemplateDocument = gql`
    mutation toggleEmailTemplate($data: ToggleEmailTemplateInput!) {
  toggleEmailTemplate(input: $data)
}
    `;
export type ToggleEmailTemplateMutationFn = Apollo.MutationFunction<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>;

/**
 * __useToggleEmailTemplateMutation__
 *
 * To run a mutation, you first call `useToggleEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEmailTemplateMutation, { data, loading, error }] = useToggleEmailTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>(ToggleEmailTemplateDocument, options);
      }
export type ToggleEmailTemplateMutationHookResult = ReturnType<typeof useToggleEmailTemplateMutation>;
export type ToggleEmailTemplateMutationResult = Apollo.MutationResult<ToggleEmailTemplateMutation>;
export type ToggleEmailTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>;
export const ToggleCustomTemplateDocument = gql`
    mutation toggleCustomTemplate($type: EmailTemplateType!) {
  toggleCustomTemplate(type: $type) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type ToggleCustomTemplateMutationFn = Apollo.MutationFunction<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>;

/**
 * __useToggleCustomTemplateMutation__
 *
 * To run a mutation, you first call `useToggleCustomTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCustomTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCustomTemplateMutation, { data, loading, error }] = useToggleCustomTemplateMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useToggleCustomTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>(ToggleCustomTemplateDocument, options);
      }
export type ToggleCustomTemplateMutationHookResult = ReturnType<typeof useToggleCustomTemplateMutation>;
export type ToggleCustomTemplateMutationResult = Apollo.MutationResult<ToggleCustomTemplateMutation>;
export type ToggleCustomTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>;
export const SendTestMailDocument = gql`
    mutation sendTestMail($data: SendTestMailInput!) {
  sendTestMail(input: $data)
}
    `;
export type SendTestMailMutationFn = Apollo.MutationFunction<SendTestMailMutation, SendTestMailMutationVariables>;

/**
 * __useSendTestMailMutation__
 *
 * To run a mutation, you first call `useSendTestMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestMailMutation, { data, loading, error }] = useSendTestMailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendTestMailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestMailMutation, SendTestMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestMailMutation, SendTestMailMutationVariables>(SendTestMailDocument, options);
      }
export type SendTestMailMutationHookResult = ReturnType<typeof useSendTestMailMutation>;
export type SendTestMailMutationResult = Apollo.MutationResult<SendTestMailMutation>;
export type SendTestMailMutationOptions = Apollo.BaseMutationOptions<SendTestMailMutation, SendTestMailMutationVariables>;
export const GetEmailTemplatesDocument = gql`
    query getEmailTemplates($search: String) {
  getEmailTemplates(search: $search) {
    category
    trigger
    type
    appActive
    smsActive
    emailActive
    custom
  }
}
    `;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
      }
export function useGetEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export const GetEmailTemplateDocument = gql`
    query getEmailTemplate($type: EmailTemplateType!) {
  getEmailTemplate(type: $type) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
      }
export function useGetEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export type GetEmailTemplateQueryHookResult = ReturnType<typeof useGetEmailTemplateQuery>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateLazyQuery>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($data: EmployeeInput!) {
  createEmployee(input: $data) {
    id
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($id: String!, $data: EmployeeInput!) {
  updateEmployee(employeeId: $id, input: $data) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const ToggleEmployeeDocument = gql`
    mutation toggleEmployee($id: String!) {
  toggleEmployee(id: $id)
}
    `;
export type ToggleEmployeeMutationFn = Apollo.MutationFunction<ToggleEmployeeMutation, ToggleEmployeeMutationVariables>;

/**
 * __useToggleEmployeeMutation__
 *
 * To run a mutation, you first call `useToggleEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEmployeeMutation, { data, loading, error }] = useToggleEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleEmployeeMutation, ToggleEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleEmployeeMutation, ToggleEmployeeMutationVariables>(ToggleEmployeeDocument, options);
      }
export type ToggleEmployeeMutationHookResult = ReturnType<typeof useToggleEmployeeMutation>;
export type ToggleEmployeeMutationResult = Apollo.MutationResult<ToggleEmployeeMutation>;
export type ToggleEmployeeMutationOptions = Apollo.BaseMutationOptions<ToggleEmployeeMutation, ToggleEmployeeMutationVariables>;
export const RemoveEmployeesDocument = gql`
    mutation removeEmployees($data: DeleteRecordsInput!) {
  removeEmployees(input: $data)
}
    `;
export type RemoveEmployeesMutationFn = Apollo.MutationFunction<RemoveEmployeesMutation, RemoveEmployeesMutationVariables>;

/**
 * __useRemoveEmployeesMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeesMutation, { data, loading, error }] = useRemoveEmployeesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeesMutation, RemoveEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeesMutation, RemoveEmployeesMutationVariables>(RemoveEmployeesDocument, options);
      }
export type RemoveEmployeesMutationHookResult = ReturnType<typeof useRemoveEmployeesMutation>;
export type RemoveEmployeesMutationResult = Apollo.MutationResult<RemoveEmployeesMutation>;
export type RemoveEmployeesMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeesMutation, RemoveEmployeesMutationVariables>;
export const GetEmployeesTableDocument = gql`
    query getEmployeesTable($buildingIds: [String!], $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getEmployees(
    buildingIds: $buildingIds
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getEmployeesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EmployeeCoreFields
      index
      active
      laborRate {
        ...LaborRateCoreFields
        rate
        markup {
          ...MarkupCoreFields
        }
        glAccount {
          ...GLAccountCoreFields
        }
        arCode {
          ...ARCodeCoreFields
        }
        chargeCode {
          ...ChargeCodeCoreFields
        }
      }
      tax {
        ...TaxCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}`;

/**
 * __useGetEmployeesTableQuery__
 *
 * To run a query within a React component, call `useGetEmployeesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesTableQuery({
 *   variables: {
 *      buildingIds: // value for 'buildingIds'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmployeesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>(GetEmployeesTableDocument, options);
      }
export function useGetEmployeesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>(GetEmployeesTableDocument, options);
        }
export type GetEmployeesTableQueryHookResult = ReturnType<typeof useGetEmployeesTableQuery>;
export type GetEmployeesTableLazyQueryHookResult = ReturnType<typeof useGetEmployeesTableLazyQuery>;
export type GetEmployeesTableQueryResult = Apollo.QueryResult<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>;
export const GetEmployeesDropdownDocument = gql`
    query getEmployeesDropdown($buildingIds: [String!], $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $includeLaborRate: Boolean!, $includeLaborRateMarkup: Boolean!, $includeLaborRateGLAccount: Boolean!, $includeLaborRateARCode: Boolean!, $includeLaborRateChargeCode: Boolean!, $includeTax: Boolean!) {
  getEmployees(
    buildingIds: $buildingIds
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getEmployeesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EmployeeCoreFields
      active
      laborRate @include(if: $includeLaborRate) {
        ...LaborRateCoreFields
        rate
        markup @include(if: $includeLaborRateMarkup) {
          ...MarkupCoreFields
          type
          amount
        }
        glAccount @include(if: $includeLaborRateGLAccount) {
          ...GLAccountCoreFields
        }
        arCode @include(if: $includeLaborRateARCode) {
          ...ARCodeCoreFields
        }
        chargeCode @include(if: $includeLaborRateChargeCode) {
          ...ChargeCodeCoreFields
        }
      }
      tax @include(if: $includeTax) {
        ...TaxCoreFields
        amount
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}`;

/**
 * __useGetEmployeesDropdownQuery__
 *
 * To run a query within a React component, call `useGetEmployeesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesDropdownQuery({
 *   variables: {
 *      buildingIds: // value for 'buildingIds'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeLaborRate: // value for 'includeLaborRate'
 *      includeLaborRateMarkup: // value for 'includeLaborRateMarkup'
 *      includeLaborRateGLAccount: // value for 'includeLaborRateGLAccount'
 *      includeLaborRateARCode: // value for 'includeLaborRateARCode'
 *      includeLaborRateChargeCode: // value for 'includeLaborRateChargeCode'
 *      includeTax: // value for 'includeTax'
 *   },
 * });
 */
export function useGetEmployeesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesDropdownQuery, GetEmployeesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesDropdownQuery, GetEmployeesDropdownQueryVariables>(GetEmployeesDropdownDocument, options);
      }
export function useGetEmployeesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesDropdownQuery, GetEmployeesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesDropdownQuery, GetEmployeesDropdownQueryVariables>(GetEmployeesDropdownDocument, options);
        }
export type GetEmployeesDropdownQueryHookResult = ReturnType<typeof useGetEmployeesDropdownQuery>;
export type GetEmployeesDropdownLazyQueryHookResult = ReturnType<typeof useGetEmployeesDropdownLazyQuery>;
export type GetEmployeesDropdownQueryResult = Apollo.QueryResult<GetEmployeesDropdownQuery, GetEmployeesDropdownQueryVariables>;
export const GetPublicEmployeesDocument = gql`
    query getPublicEmployees($propertyId: String!, $buildingIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String!) {
  getPublicEmployees(
    propertyId: $propertyId
    buildingIds: $buildingIds
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...EmployeeCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicEmployeesQuery__
 *
 * To run a query within a React component, call `useGetPublicEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicEmployeesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      buildingIds: // value for 'buildingIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicEmployeesQuery, GetPublicEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicEmployeesQuery, GetPublicEmployeesQueryVariables>(GetPublicEmployeesDocument, options);
      }
export function useGetPublicEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicEmployeesQuery, GetPublicEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicEmployeesQuery, GetPublicEmployeesQueryVariables>(GetPublicEmployeesDocument, options);
        }
export type GetPublicEmployeesQueryHookResult = ReturnType<typeof useGetPublicEmployeesQuery>;
export type GetPublicEmployeesLazyQueryHookResult = ReturnType<typeof useGetPublicEmployeesLazyQuery>;
export type GetPublicEmployeesQueryResult = Apollo.QueryResult<GetPublicEmployeesQuery, GetPublicEmployeesQueryVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($id: String!) {
  getEmployee(id: $id) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const CreateFloorDocument = gql`
    mutation createFloor($data: FloorCreateInput!) {
  createFloor(input: $data) {
    id
  }
}
    `;
export type CreateFloorMutationFn = Apollo.MutationFunction<CreateFloorMutation, CreateFloorMutationVariables>;

/**
 * __useCreateFloorMutation__
 *
 * To run a mutation, you first call `useCreateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorMutation, { data, loading, error }] = useCreateFloorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFloorMutation(baseOptions?: Apollo.MutationHookOptions<CreateFloorMutation, CreateFloorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFloorMutation, CreateFloorMutationVariables>(CreateFloorDocument, options);
      }
export type CreateFloorMutationHookResult = ReturnType<typeof useCreateFloorMutation>;
export type CreateFloorMutationResult = Apollo.MutationResult<CreateFloorMutation>;
export type CreateFloorMutationOptions = Apollo.BaseMutationOptions<CreateFloorMutation, CreateFloorMutationVariables>;
export const UpdateFloorDocument = gql`
    mutation updateFloor($id: String!, $data: FloorUpdateInput!) {
  updateFloor(floorId: $id, input: $data) {
    ...FloorFields
  }
}
    ${FloorFieldsFragmentDoc}`;
export type UpdateFloorMutationFn = Apollo.MutationFunction<UpdateFloorMutation, UpdateFloorMutationVariables>;

/**
 * __useUpdateFloorMutation__
 *
 * To run a mutation, you first call `useUpdateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFloorMutation, { data, loading, error }] = useUpdateFloorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFloorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFloorMutation, UpdateFloorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFloorMutation, UpdateFloorMutationVariables>(UpdateFloorDocument, options);
      }
export type UpdateFloorMutationHookResult = ReturnType<typeof useUpdateFloorMutation>;
export type UpdateFloorMutationResult = Apollo.MutationResult<UpdateFloorMutation>;
export type UpdateFloorMutationOptions = Apollo.BaseMutationOptions<UpdateFloorMutation, UpdateFloorMutationVariables>;
export const RemoveFloorsDocument = gql`
    mutation removeFloors($data: DeleteRecordsInput!) {
  removeFloors(input: $data)
}
    `;
export type RemoveFloorsMutationFn = Apollo.MutationFunction<RemoveFloorsMutation, RemoveFloorsMutationVariables>;

/**
 * __useRemoveFloorsMutation__
 *
 * To run a mutation, you first call `useRemoveFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFloorsMutation, { data, loading, error }] = useRemoveFloorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveFloorsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFloorsMutation, RemoveFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFloorsMutation, RemoveFloorsMutationVariables>(RemoveFloorsDocument, options);
      }
export type RemoveFloorsMutationHookResult = ReturnType<typeof useRemoveFloorsMutation>;
export type RemoveFloorsMutationResult = Apollo.MutationResult<RemoveFloorsMutation>;
export type RemoveFloorsMutationOptions = Apollo.BaseMutationOptions<RemoveFloorsMutation, RemoveFloorsMutationVariables>;
export const ReorderTableFloorsDocument = gql`
    mutation reorderTableFloors($id: String!, $secondId: String!) {
  reorderTableFloors(id: $id, secondId: $secondId)
}
    `;
export type ReorderTableFloorsMutationFn = Apollo.MutationFunction<ReorderTableFloorsMutation, ReorderTableFloorsMutationVariables>;

/**
 * __useReorderTableFloorsMutation__
 *
 * To run a mutation, you first call `useReorderTableFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTableFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTableFloorsMutation, { data, loading, error }] = useReorderTableFloorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderTableFloorsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderTableFloorsMutation, ReorderTableFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderTableFloorsMutation, ReorderTableFloorsMutationVariables>(ReorderTableFloorsDocument, options);
      }
export type ReorderTableFloorsMutationHookResult = ReturnType<typeof useReorderTableFloorsMutation>;
export type ReorderTableFloorsMutationResult = Apollo.MutationResult<ReorderTableFloorsMutation>;
export type ReorderTableFloorsMutationOptions = Apollo.BaseMutationOptions<ReorderTableFloorsMutation, ReorderTableFloorsMutationVariables>;
export const ReorderFloorsDocument = gql`
    mutation reorderFloors($id: String!, $secondId: String!) {
  reorderFloors(id: $id, secondId: $secondId)
}
    `;
export type ReorderFloorsMutationFn = Apollo.MutationFunction<ReorderFloorsMutation, ReorderFloorsMutationVariables>;

/**
 * __useReorderFloorsMutation__
 *
 * To run a mutation, you first call `useReorderFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFloorsMutation, { data, loading, error }] = useReorderFloorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderFloorsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderFloorsMutation, ReorderFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderFloorsMutation, ReorderFloorsMutationVariables>(ReorderFloorsDocument, options);
      }
export type ReorderFloorsMutationHookResult = ReturnType<typeof useReorderFloorsMutation>;
export type ReorderFloorsMutationResult = Apollo.MutationResult<ReorderFloorsMutation>;
export type ReorderFloorsMutationOptions = Apollo.BaseMutationOptions<ReorderFloorsMutation, ReorderFloorsMutationVariables>;
export const GetFloorsTableDocument = gql`
    query getFloorsTable($admin: Boolean = false, $buildingIds: [String!], $search: String) {
  getFloors(admin: $admin, buildingIds: $buildingIds, search: $search) {
    ...FloorCoreFields
    index
    size
    order
  }
}
    ${FloorCoreFieldsFragmentDoc}`;

/**
 * __useGetFloorsTableQuery__
 *
 * To run a query within a React component, call `useGetFloorsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFloorsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFloorsTableQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      buildingIds: // value for 'buildingIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFloorsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetFloorsTableQuery, GetFloorsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFloorsTableQuery, GetFloorsTableQueryVariables>(GetFloorsTableDocument, options);
      }
export function useGetFloorsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFloorsTableQuery, GetFloorsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFloorsTableQuery, GetFloorsTableQueryVariables>(GetFloorsTableDocument, options);
        }
export type GetFloorsTableQueryHookResult = ReturnType<typeof useGetFloorsTableQuery>;
export type GetFloorsTableLazyQueryHookResult = ReturnType<typeof useGetFloorsTableLazyQuery>;
export type GetFloorsTableQueryResult = Apollo.QueryResult<GetFloorsTableQuery, GetFloorsTableQueryVariables>;
export const GetFloorsOverviewDocument = gql`
    query getFloorsOverview($admin: Boolean = false, $buildingIds: [String!]!) {
  getFloors(admin: $admin, buildingIds: $buildingIds) {
    ...FloorCoreFields
    suites {
      ...SuiteCoreFields
    }
  }
}
    ${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetFloorsOverviewQuery__
 *
 * To run a query within a React component, call `useGetFloorsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFloorsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFloorsOverviewQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      buildingIds: // value for 'buildingIds'
 *   },
 * });
 */
export function useGetFloorsOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetFloorsOverviewQuery, GetFloorsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFloorsOverviewQuery, GetFloorsOverviewQueryVariables>(GetFloorsOverviewDocument, options);
      }
export function useGetFloorsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFloorsOverviewQuery, GetFloorsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFloorsOverviewQuery, GetFloorsOverviewQueryVariables>(GetFloorsOverviewDocument, options);
        }
export type GetFloorsOverviewQueryHookResult = ReturnType<typeof useGetFloorsOverviewQuery>;
export type GetFloorsOverviewLazyQueryHookResult = ReturnType<typeof useGetFloorsOverviewLazyQuery>;
export type GetFloorsOverviewQueryResult = Apollo.QueryResult<GetFloorsOverviewQuery, GetFloorsOverviewQueryVariables>;
export const GetFloorsDropdownDocument = gql`
    query getFloorsDropdown($admin: Boolean = false, $buildingIds: [String!], $search: String, $includeSize: Boolean!) {
  getFloors(admin: $admin, buildingIds: $buildingIds, search: $search) {
    ...FloorCoreFields
    size @include(if: $includeSize)
  }
}
    ${FloorCoreFieldsFragmentDoc}`;

/**
 * __useGetFloorsDropdownQuery__
 *
 * To run a query within a React component, call `useGetFloorsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFloorsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFloorsDropdownQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      buildingIds: // value for 'buildingIds'
 *      search: // value for 'search'
 *      includeSize: // value for 'includeSize'
 *   },
 * });
 */
export function useGetFloorsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetFloorsDropdownQuery, GetFloorsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFloorsDropdownQuery, GetFloorsDropdownQueryVariables>(GetFloorsDropdownDocument, options);
      }
export function useGetFloorsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFloorsDropdownQuery, GetFloorsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFloorsDropdownQuery, GetFloorsDropdownQueryVariables>(GetFloorsDropdownDocument, options);
        }
export type GetFloorsDropdownQueryHookResult = ReturnType<typeof useGetFloorsDropdownQuery>;
export type GetFloorsDropdownLazyQueryHookResult = ReturnType<typeof useGetFloorsDropdownLazyQuery>;
export type GetFloorsDropdownQueryResult = Apollo.QueryResult<GetFloorsDropdownQuery, GetFloorsDropdownQueryVariables>;
export const GetPublicFloorsDocument = gql`
    query getPublicFloors($propertyId: String!, $buildingIds: [String!], $search: String!) {
  getPublicFloors(
    propertyId: $propertyId
    buildingIds: $buildingIds
    search: $search
  ) {
    ...FloorCoreFields
  }
}
    ${FloorCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicFloorsQuery__
 *
 * To run a query within a React component, call `useGetPublicFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicFloorsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      buildingIds: // value for 'buildingIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicFloorsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicFloorsQuery, GetPublicFloorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicFloorsQuery, GetPublicFloorsQueryVariables>(GetPublicFloorsDocument, options);
      }
export function useGetPublicFloorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicFloorsQuery, GetPublicFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicFloorsQuery, GetPublicFloorsQueryVariables>(GetPublicFloorsDocument, options);
        }
export type GetPublicFloorsQueryHookResult = ReturnType<typeof useGetPublicFloorsQuery>;
export type GetPublicFloorsLazyQueryHookResult = ReturnType<typeof useGetPublicFloorsLazyQuery>;
export type GetPublicFloorsQueryResult = Apollo.QueryResult<GetPublicFloorsQuery, GetPublicFloorsQueryVariables>;
export const GetFloorDocument = gql`
    query getFloor($id: String!) {
  getFloor(floorId: $id) {
    ...FloorFields
  }
}
    ${FloorFieldsFragmentDoc}`;

/**
 * __useGetFloorQuery__
 *
 * To run a query within a React component, call `useGetFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFloorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFloorQuery(baseOptions: Apollo.QueryHookOptions<GetFloorQuery, GetFloorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFloorQuery, GetFloorQueryVariables>(GetFloorDocument, options);
      }
export function useGetFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFloorQuery, GetFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFloorQuery, GetFloorQueryVariables>(GetFloorDocument, options);
        }
export type GetFloorQueryHookResult = ReturnType<typeof useGetFloorQuery>;
export type GetFloorLazyQueryHookResult = ReturnType<typeof useGetFloorLazyQuery>;
export type GetFloorQueryResult = Apollo.QueryResult<GetFloorQuery, GetFloorQueryVariables>;
export const ExportFloorsDocument = gql`
    query exportFloors($admin: Boolean = false, $buildingIds: [String!], $search: String) {
  exportFloors(admin: $admin, buildingIds: $buildingIds, search: $search)
}
    `;

/**
 * __useExportFloorsQuery__
 *
 * To run a query within a React component, call `useExportFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportFloorsQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      buildingIds: // value for 'buildingIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportFloorsQuery(baseOptions?: Apollo.QueryHookOptions<ExportFloorsQuery, ExportFloorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportFloorsQuery, ExportFloorsQueryVariables>(ExportFloorsDocument, options);
      }
export function useExportFloorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportFloorsQuery, ExportFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportFloorsQuery, ExportFloorsQueryVariables>(ExportFloorsDocument, options);
        }
export type ExportFloorsQueryHookResult = ReturnType<typeof useExportFloorsQuery>;
export type ExportFloorsLazyQueryHookResult = ReturnType<typeof useExportFloorsLazyQuery>;
export type ExportFloorsQueryResult = Apollo.QueryResult<ExportFloorsQuery, ExportFloorsQueryVariables>;
export const ToggleGeneaDoorsDocument = gql`
    mutation toggleGeneaDoors($data: ToggleDoorInput!) {
  toggleGeneaDoors(input: $data)
}
    `;
export type ToggleGeneaDoorsMutationFn = Apollo.MutationFunction<ToggleGeneaDoorsMutation, ToggleGeneaDoorsMutationVariables>;

/**
 * __useToggleGeneaDoorsMutation__
 *
 * To run a mutation, you first call `useToggleGeneaDoorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGeneaDoorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGeneaDoorsMutation, { data, loading, error }] = useToggleGeneaDoorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleGeneaDoorsMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGeneaDoorsMutation, ToggleGeneaDoorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGeneaDoorsMutation, ToggleGeneaDoorsMutationVariables>(ToggleGeneaDoorsDocument, options);
      }
export type ToggleGeneaDoorsMutationHookResult = ReturnType<typeof useToggleGeneaDoorsMutation>;
export type ToggleGeneaDoorsMutationResult = Apollo.MutationResult<ToggleGeneaDoorsMutation>;
export type ToggleGeneaDoorsMutationOptions = Apollo.BaseMutationOptions<ToggleGeneaDoorsMutation, ToggleGeneaDoorsMutationVariables>;
export const UpdateGeneaTenantLinkDocument = gql`
    mutation updateGeneaTenantLink($data: UpdateGeneaTenantLinkInput!) {
  updateGeneaTenantLink(input: $data) {
    id
    geneaTenant {
      ...GeneaTenantCoreFields
    }
  }
}
    ${GeneaTenantCoreFieldsFragmentDoc}`;
export type UpdateGeneaTenantLinkMutationFn = Apollo.MutationFunction<UpdateGeneaTenantLinkMutation, UpdateGeneaTenantLinkMutationVariables>;

/**
 * __useUpdateGeneaTenantLinkMutation__
 *
 * To run a mutation, you first call `useUpdateGeneaTenantLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneaTenantLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneaTenantLinkMutation, { data, loading, error }] = useUpdateGeneaTenantLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGeneaTenantLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneaTenantLinkMutation, UpdateGeneaTenantLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneaTenantLinkMutation, UpdateGeneaTenantLinkMutationVariables>(UpdateGeneaTenantLinkDocument, options);
      }
export type UpdateGeneaTenantLinkMutationHookResult = ReturnType<typeof useUpdateGeneaTenantLinkMutation>;
export type UpdateGeneaTenantLinkMutationResult = Apollo.MutationResult<UpdateGeneaTenantLinkMutation>;
export type UpdateGeneaTenantLinkMutationOptions = Apollo.BaseMutationOptions<UpdateGeneaTenantLinkMutation, UpdateGeneaTenantLinkMutationVariables>;
export const UpdateGeneaProductAccessLinkDocument = gql`
    mutation updateGeneaProductAccessLink($data: GeneaAccessGroupProductLinkInput!) {
  updateGeneaProductAccessLink(input: $data) {
    id
    geneaAccessGroup {
      ...GeneaAccessGroupFields
    }
  }
}
    ${GeneaAccessGroupFieldsFragmentDoc}`;
export type UpdateGeneaProductAccessLinkMutationFn = Apollo.MutationFunction<UpdateGeneaProductAccessLinkMutation, UpdateGeneaProductAccessLinkMutationVariables>;

/**
 * __useUpdateGeneaProductAccessLinkMutation__
 *
 * To run a mutation, you first call `useUpdateGeneaProductAccessLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneaProductAccessLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneaProductAccessLinkMutation, { data, loading, error }] = useUpdateGeneaProductAccessLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGeneaProductAccessLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneaProductAccessLinkMutation, UpdateGeneaProductAccessLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneaProductAccessLinkMutation, UpdateGeneaProductAccessLinkMutationVariables>(UpdateGeneaProductAccessLinkDocument, options);
      }
export type UpdateGeneaProductAccessLinkMutationHookResult = ReturnType<typeof useUpdateGeneaProductAccessLinkMutation>;
export type UpdateGeneaProductAccessLinkMutationResult = Apollo.MutationResult<UpdateGeneaProductAccessLinkMutation>;
export type UpdateGeneaProductAccessLinkMutationOptions = Apollo.BaseMutationOptions<UpdateGeneaProductAccessLinkMutation, UpdateGeneaProductAccessLinkMutationVariables>;
export const CreateGeneaUserCardDocument = gql`
    mutation createGeneaUserCard($data: CreateGeneaUserCardInput!) {
  createGeneaUserCard(input: $data) {
    ...GeneaUserCardFields
  }
}
    ${GeneaUserCardFieldsFragmentDoc}`;
export type CreateGeneaUserCardMutationFn = Apollo.MutationFunction<CreateGeneaUserCardMutation, CreateGeneaUserCardMutationVariables>;

/**
 * __useCreateGeneaUserCardMutation__
 *
 * To run a mutation, you first call `useCreateGeneaUserCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneaUserCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeneaUserCardMutation, { data, loading, error }] = useCreateGeneaUserCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGeneaUserCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeneaUserCardMutation, CreateGeneaUserCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeneaUserCardMutation, CreateGeneaUserCardMutationVariables>(CreateGeneaUserCardDocument, options);
      }
export type CreateGeneaUserCardMutationHookResult = ReturnType<typeof useCreateGeneaUserCardMutation>;
export type CreateGeneaUserCardMutationResult = Apollo.MutationResult<CreateGeneaUserCardMutation>;
export type CreateGeneaUserCardMutationOptions = Apollo.BaseMutationOptions<CreateGeneaUserCardMutation, CreateGeneaUserCardMutationVariables>;
export const DeleteGeneaUserCardDocument = gql`
    mutation deleteGeneaUserCard($cardId: String!, $userId: String!) {
  deleteGeneaUserCard(cardId: $cardId, userId: $userId)
}
    `;
export type DeleteGeneaUserCardMutationFn = Apollo.MutationFunction<DeleteGeneaUserCardMutation, DeleteGeneaUserCardMutationVariables>;

/**
 * __useDeleteGeneaUserCardMutation__
 *
 * To run a mutation, you first call `useDeleteGeneaUserCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGeneaUserCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeneaUserCardMutation, { data, loading, error }] = useDeleteGeneaUserCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteGeneaUserCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGeneaUserCardMutation, DeleteGeneaUserCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGeneaUserCardMutation, DeleteGeneaUserCardMutationVariables>(DeleteGeneaUserCardDocument, options);
      }
export type DeleteGeneaUserCardMutationHookResult = ReturnType<typeof useDeleteGeneaUserCardMutation>;
export type DeleteGeneaUserCardMutationResult = Apollo.MutationResult<DeleteGeneaUserCardMutation>;
export type DeleteGeneaUserCardMutationOptions = Apollo.BaseMutationOptions<DeleteGeneaUserCardMutation, DeleteGeneaUserCardMutationVariables>;
export const UpdateGeneaUserAvatarDocument = gql`
    mutation updateGeneaUserAvatar($userId: String!) {
  updateGeneaUserAvatar(userId: $userId)
}
    `;
export type UpdateGeneaUserAvatarMutationFn = Apollo.MutationFunction<UpdateGeneaUserAvatarMutation, UpdateGeneaUserAvatarMutationVariables>;

/**
 * __useUpdateGeneaUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateGeneaUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneaUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneaUserAvatarMutation, { data, loading, error }] = useUpdateGeneaUserAvatarMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateGeneaUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneaUserAvatarMutation, UpdateGeneaUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneaUserAvatarMutation, UpdateGeneaUserAvatarMutationVariables>(UpdateGeneaUserAvatarDocument, options);
      }
export type UpdateGeneaUserAvatarMutationHookResult = ReturnType<typeof useUpdateGeneaUserAvatarMutation>;
export type UpdateGeneaUserAvatarMutationResult = Apollo.MutationResult<UpdateGeneaUserAvatarMutation>;
export type UpdateGeneaUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateGeneaUserAvatarMutation, UpdateGeneaUserAvatarMutationVariables>;
export const UpdateGeneaSettingsDocument = gql`
    mutation updateGeneaSettings($data: GeneaSettingInput!) {
  updateGeneaSettings(input: $data) {
    ...GeneaSettingsFields
  }
}
    ${GeneaSettingsFieldsFragmentDoc}`;
export type UpdateGeneaSettingsMutationFn = Apollo.MutationFunction<UpdateGeneaSettingsMutation, UpdateGeneaSettingsMutationVariables>;

/**
 * __useUpdateGeneaSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateGeneaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneaSettingsMutation, { data, loading, error }] = useUpdateGeneaSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGeneaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneaSettingsMutation, UpdateGeneaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneaSettingsMutation, UpdateGeneaSettingsMutationVariables>(UpdateGeneaSettingsDocument, options);
      }
export type UpdateGeneaSettingsMutationHookResult = ReturnType<typeof useUpdateGeneaSettingsMutation>;
export type UpdateGeneaSettingsMutationResult = Apollo.MutationResult<UpdateGeneaSettingsMutation>;
export type UpdateGeneaSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateGeneaSettingsMutation, UpdateGeneaSettingsMutationVariables>;
export const GetGeneaDoorsDocument = gql`
    query getGeneaDoors {
  getGeneaDoors {
    ...GeneaDoorsFields
  }
}
    ${GeneaDoorsFieldsFragmentDoc}`;

/**
 * __useGetGeneaDoorsQuery__
 *
 * To run a query within a React component, call `useGetGeneaDoorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaDoorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaDoorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneaDoorsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaDoorsQuery, GetGeneaDoorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaDoorsQuery, GetGeneaDoorsQueryVariables>(GetGeneaDoorsDocument, options);
      }
export function useGetGeneaDoorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaDoorsQuery, GetGeneaDoorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaDoorsQuery, GetGeneaDoorsQueryVariables>(GetGeneaDoorsDocument, options);
        }
export type GetGeneaDoorsQueryHookResult = ReturnType<typeof useGetGeneaDoorsQuery>;
export type GetGeneaDoorsLazyQueryHookResult = ReturnType<typeof useGetGeneaDoorsLazyQuery>;
export type GetGeneaDoorsQueryResult = Apollo.QueryResult<GetGeneaDoorsQuery, GetGeneaDoorsQueryVariables>;
export const GetGeneaTenantsDocument = gql`
    query getGeneaTenants($take: Int! = 10, $after: String, $before: String, $search: String) {
  getGeneaTenants(take: $take, after: $after, before: $before, search: $search) {
    pagination {
      ...PaginationFields
    }
    data {
      ...GeneaTenantFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${GeneaTenantFieldsFragmentDoc}`;

/**
 * __useGetGeneaTenantsQuery__
 *
 * To run a query within a React component, call `useGetGeneaTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaTenantsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGeneaTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaTenantsQuery, GetGeneaTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaTenantsQuery, GetGeneaTenantsQueryVariables>(GetGeneaTenantsDocument, options);
      }
export function useGetGeneaTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaTenantsQuery, GetGeneaTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaTenantsQuery, GetGeneaTenantsQueryVariables>(GetGeneaTenantsDocument, options);
        }
export type GetGeneaTenantsQueryHookResult = ReturnType<typeof useGetGeneaTenantsQuery>;
export type GetGeneaTenantsLazyQueryHookResult = ReturnType<typeof useGetGeneaTenantsLazyQuery>;
export type GetGeneaTenantsQueryResult = Apollo.QueryResult<GetGeneaTenantsQuery, GetGeneaTenantsQueryVariables>;
export const GetGeneaUserCardsDocument = gql`
    query getGeneaUserCards($userId: String!) {
  getGeneaUserCards(userId: $userId) {
    ...GeneaUserCardFields
  }
}
    ${GeneaUserCardFieldsFragmentDoc}`;

/**
 * __useGetGeneaUserCardsQuery__
 *
 * To run a query within a React component, call `useGetGeneaUserCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaUserCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaUserCardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGeneaUserCardsQuery(baseOptions: Apollo.QueryHookOptions<GetGeneaUserCardsQuery, GetGeneaUserCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaUserCardsQuery, GetGeneaUserCardsQueryVariables>(GetGeneaUserCardsDocument, options);
      }
export function useGetGeneaUserCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaUserCardsQuery, GetGeneaUserCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaUserCardsQuery, GetGeneaUserCardsQueryVariables>(GetGeneaUserCardsDocument, options);
        }
export type GetGeneaUserCardsQueryHookResult = ReturnType<typeof useGetGeneaUserCardsQuery>;
export type GetGeneaUserCardsLazyQueryHookResult = ReturnType<typeof useGetGeneaUserCardsLazyQuery>;
export type GetGeneaUserCardsQueryResult = Apollo.QueryResult<GetGeneaUserCardsQuery, GetGeneaUserCardsQueryVariables>;
export const GetGeneaBadgeTypesDocument = gql`
    query getGeneaBadgeTypes {
  getGeneaBadgeTypes {
    ...GeneaBadgeTypeFields
  }
}
    ${GeneaBadgeTypeFieldsFragmentDoc}`;

/**
 * __useGetGeneaBadgeTypesQuery__
 *
 * To run a query within a React component, call `useGetGeneaBadgeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaBadgeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaBadgeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneaBadgeTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaBadgeTypesQuery, GetGeneaBadgeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaBadgeTypesQuery, GetGeneaBadgeTypesQueryVariables>(GetGeneaBadgeTypesDocument, options);
      }
export function useGetGeneaBadgeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaBadgeTypesQuery, GetGeneaBadgeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaBadgeTypesQuery, GetGeneaBadgeTypesQueryVariables>(GetGeneaBadgeTypesDocument, options);
        }
export type GetGeneaBadgeTypesQueryHookResult = ReturnType<typeof useGetGeneaBadgeTypesQuery>;
export type GetGeneaBadgeTypesLazyQueryHookResult = ReturnType<typeof useGetGeneaBadgeTypesLazyQuery>;
export type GetGeneaBadgeTypesQueryResult = Apollo.QueryResult<GetGeneaBadgeTypesQuery, GetGeneaBadgeTypesQueryVariables>;
export const GetGeneaAccessGroupsDocument = gql`
    query getGeneaAccessGroups($take: Int! = 10, $after: String, $before: String, $search: String) {
  getGeneaAccessGroups(
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...GeneaAccessGroupFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${GeneaAccessGroupFieldsFragmentDoc}`;

/**
 * __useGetGeneaAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetGeneaAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaAccessGroupsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGeneaAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaAccessGroupsQuery, GetGeneaAccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaAccessGroupsQuery, GetGeneaAccessGroupsQueryVariables>(GetGeneaAccessGroupsDocument, options);
      }
export function useGetGeneaAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaAccessGroupsQuery, GetGeneaAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaAccessGroupsQuery, GetGeneaAccessGroupsQueryVariables>(GetGeneaAccessGroupsDocument, options);
        }
export type GetGeneaAccessGroupsQueryHookResult = ReturnType<typeof useGetGeneaAccessGroupsQuery>;
export type GetGeneaAccessGroupsLazyQueryHookResult = ReturnType<typeof useGetGeneaAccessGroupsLazyQuery>;
export type GetGeneaAccessGroupsQueryResult = Apollo.QueryResult<GetGeneaAccessGroupsQuery, GetGeneaAccessGroupsQueryVariables>;
export const GetGeneaSettingsDocument = gql`
    query getGeneaSettings {
  getGeneaSettings {
    ...GeneaSettingsFields
  }
}
    ${GeneaSettingsFieldsFragmentDoc}`;

/**
 * __useGetGeneaSettingsQuery__
 *
 * To run a query within a React component, call `useGetGeneaSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneaSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaSettingsQuery, GetGeneaSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaSettingsQuery, GetGeneaSettingsQueryVariables>(GetGeneaSettingsDocument, options);
      }
export function useGetGeneaSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaSettingsQuery, GetGeneaSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaSettingsQuery, GetGeneaSettingsQueryVariables>(GetGeneaSettingsDocument, options);
        }
export type GetGeneaSettingsQueryHookResult = ReturnType<typeof useGetGeneaSettingsQuery>;
export type GetGeneaSettingsLazyQueryHookResult = ReturnType<typeof useGetGeneaSettingsLazyQuery>;
export type GetGeneaSettingsQueryResult = Apollo.QueryResult<GetGeneaSettingsQuery, GetGeneaSettingsQueryVariables>;
export const CreateGlAccountDocument = gql`
    mutation createGLAccount($title: String!) {
  createGLAccount(title: $title) {
    id
  }
}
    `;
export type CreateGlAccountMutationFn = Apollo.MutationFunction<CreateGlAccountMutation, CreateGlAccountMutationVariables>;

/**
 * __useCreateGlAccountMutation__
 *
 * To run a mutation, you first call `useCreateGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlAccountMutation, { data, loading, error }] = useCreateGlAccountMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlAccountMutation, CreateGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlAccountMutation, CreateGlAccountMutationVariables>(CreateGlAccountDocument, options);
      }
export type CreateGlAccountMutationHookResult = ReturnType<typeof useCreateGlAccountMutation>;
export type CreateGlAccountMutationResult = Apollo.MutationResult<CreateGlAccountMutation>;
export type CreateGlAccountMutationOptions = Apollo.BaseMutationOptions<CreateGlAccountMutation, CreateGlAccountMutationVariables>;
export const UpdateGlAccountDocument = gql`
    mutation updateGLAccount($id: String!, $title: String!) {
  updateGLAccount(id: $id, title: $title) {
    ...GLAccountFields
  }
}
    ${GlAccountFieldsFragmentDoc}`;
export type UpdateGlAccountMutationFn = Apollo.MutationFunction<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>;

/**
 * __useUpdateGlAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlAccountMutation, { data, loading, error }] = useUpdateGlAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>(UpdateGlAccountDocument, options);
      }
export type UpdateGlAccountMutationHookResult = ReturnType<typeof useUpdateGlAccountMutation>;
export type UpdateGlAccountMutationResult = Apollo.MutationResult<UpdateGlAccountMutation>;
export type UpdateGlAccountMutationOptions = Apollo.BaseMutationOptions<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>;
export const ToggleGlAccountDocument = gql`
    mutation toggleGLAccount($id: String!) {
  toggleGLAccount(id: $id)
}
    `;
export type ToggleGlAccountMutationFn = Apollo.MutationFunction<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>;

/**
 * __useToggleGlAccountMutation__
 *
 * To run a mutation, you first call `useToggleGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGlAccountMutation, { data, loading, error }] = useToggleGlAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>(ToggleGlAccountDocument, options);
      }
export type ToggleGlAccountMutationHookResult = ReturnType<typeof useToggleGlAccountMutation>;
export type ToggleGlAccountMutationResult = Apollo.MutationResult<ToggleGlAccountMutation>;
export type ToggleGlAccountMutationOptions = Apollo.BaseMutationOptions<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>;
export const RemoveGlAccountsDocument = gql`
    mutation removeGLAccounts($data: DeleteRecordsInput!) {
  removeGLAccounts(input: $data)
}
    `;
export type RemoveGlAccountsMutationFn = Apollo.MutationFunction<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>;

/**
 * __useRemoveGlAccountsMutation__
 *
 * To run a mutation, you first call `useRemoveGlAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGlAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGlAccountsMutation, { data, loading, error }] = useRemoveGlAccountsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGlAccountsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>(RemoveGlAccountsDocument, options);
      }
export type RemoveGlAccountsMutationHookResult = ReturnType<typeof useRemoveGlAccountsMutation>;
export type RemoveGlAccountsMutationResult = Apollo.MutationResult<RemoveGlAccountsMutation>;
export type RemoveGlAccountsMutationOptions = Apollo.BaseMutationOptions<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>;
export const GetGlAccountsTableDocument = gql`
    query getGLAccountsTable($active: Boolean, $search: String) {
  getGLAccounts(active: $active, search: $search) {
    ...GLAccountCoreFields
    index
    active
    propertyId
  }
}
    ${GlAccountCoreFieldsFragmentDoc}`;

/**
 * __useGetGlAccountsTableQuery__
 *
 * To run a query within a React component, call `useGetGlAccountsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountsTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGlAccountsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>(GetGlAccountsTableDocument, options);
      }
export function useGetGlAccountsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>(GetGlAccountsTableDocument, options);
        }
export type GetGlAccountsTableQueryHookResult = ReturnType<typeof useGetGlAccountsTableQuery>;
export type GetGlAccountsTableLazyQueryHookResult = ReturnType<typeof useGetGlAccountsTableLazyQuery>;
export type GetGlAccountsTableQueryResult = Apollo.QueryResult<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>;
export const GetGlAccountsDropdownDocument = gql`
    query getGLAccountsDropdown($active: Boolean, $search: String) {
  getGLAccounts(active: $active, search: $search) {
    ...GLAccountCoreFields
    active
  }
}
    ${GlAccountCoreFieldsFragmentDoc}`;

/**
 * __useGetGlAccountsDropdownQuery__
 *
 * To run a query within a React component, call `useGetGlAccountsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGlAccountsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>(GetGlAccountsDropdownDocument, options);
      }
export function useGetGlAccountsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>(GetGlAccountsDropdownDocument, options);
        }
export type GetGlAccountsDropdownQueryHookResult = ReturnType<typeof useGetGlAccountsDropdownQuery>;
export type GetGlAccountsDropdownLazyQueryHookResult = ReturnType<typeof useGetGlAccountsDropdownLazyQuery>;
export type GetGlAccountsDropdownQueryResult = Apollo.QueryResult<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>;
export const GetGlAccountDocument = gql`
    query getGLAccount($id: String!) {
  getGLAccount(id: $id) {
    ...GLAccountFields
  }
}
    ${GlAccountFieldsFragmentDoc}`;

/**
 * __useGetGlAccountQuery__
 *
 * To run a query within a React component, call `useGetGlAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGlAccountQuery(baseOptions: Apollo.QueryHookOptions<GetGlAccountQuery, GetGlAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountQuery, GetGlAccountQueryVariables>(GetGlAccountDocument, options);
      }
export function useGetGlAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountQuery, GetGlAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountQuery, GetGlAccountQueryVariables>(GetGlAccountDocument, options);
        }
export type GetGlAccountQueryHookResult = ReturnType<typeof useGetGlAccountQuery>;
export type GetGlAccountLazyQueryHookResult = ReturnType<typeof useGetGlAccountLazyQuery>;
export type GetGlAccountQueryResult = Apollo.QueryResult<GetGlAccountQuery, GetGlAccountQueryVariables>;
export const StoreRecentSearchDocument = gql`
    mutation storeRecentSearch($data: SearchRecentInput!) {
  storeRecentSearch(input: $data)
}
    `;
export type StoreRecentSearchMutationFn = Apollo.MutationFunction<StoreRecentSearchMutation, StoreRecentSearchMutationVariables>;

/**
 * __useStoreRecentSearchMutation__
 *
 * To run a mutation, you first call `useStoreRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeRecentSearchMutation, { data, loading, error }] = useStoreRecentSearchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStoreRecentSearchMutation(baseOptions?: Apollo.MutationHookOptions<StoreRecentSearchMutation, StoreRecentSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreRecentSearchMutation, StoreRecentSearchMutationVariables>(StoreRecentSearchDocument, options);
      }
export type StoreRecentSearchMutationHookResult = ReturnType<typeof useStoreRecentSearchMutation>;
export type StoreRecentSearchMutationResult = Apollo.MutationResult<StoreRecentSearchMutation>;
export type StoreRecentSearchMutationOptions = Apollo.BaseMutationOptions<StoreRecentSearchMutation, StoreRecentSearchMutationVariables>;
export const GetSearchFeaturesDocument = gql`
    query getSearchFeatures($search: String) {
  getSearchFeatures(search: $search) {
    ...SearchFeatureFields
  }
}
    ${SearchFeatureFieldsFragmentDoc}`;

/**
 * __useGetSearchFeaturesQuery__
 *
 * To run a query within a React component, call `useGetSearchFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFeaturesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSearchFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchFeaturesQuery, GetSearchFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFeaturesQuery, GetSearchFeaturesQueryVariables>(GetSearchFeaturesDocument, options);
      }
export function useGetSearchFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFeaturesQuery, GetSearchFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFeaturesQuery, GetSearchFeaturesQueryVariables>(GetSearchFeaturesDocument, options);
        }
export type GetSearchFeaturesQueryHookResult = ReturnType<typeof useGetSearchFeaturesQuery>;
export type GetSearchFeaturesLazyQueryHookResult = ReturnType<typeof useGetSearchFeaturesLazyQuery>;
export type GetSearchFeaturesQueryResult = Apollo.QueryResult<GetSearchFeaturesQuery, GetSearchFeaturesQueryVariables>;
export const GetSearchFeatureFiltersDocument = gql`
    query getSearchFeatureFilters($feature: SearchFeatureEnum!) {
  getSearchFeatureFilters(feature: $feature) {
    key
    description
  }
}
    `;

/**
 * __useGetSearchFeatureFiltersQuery__
 *
 * To run a query within a React component, call `useGetSearchFeatureFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFeatureFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFeatureFiltersQuery({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useGetSearchFeatureFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetSearchFeatureFiltersQuery, GetSearchFeatureFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFeatureFiltersQuery, GetSearchFeatureFiltersQueryVariables>(GetSearchFeatureFiltersDocument, options);
      }
export function useGetSearchFeatureFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFeatureFiltersQuery, GetSearchFeatureFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFeatureFiltersQuery, GetSearchFeatureFiltersQueryVariables>(GetSearchFeatureFiltersDocument, options);
        }
export type GetSearchFeatureFiltersQueryHookResult = ReturnType<typeof useGetSearchFeatureFiltersQuery>;
export type GetSearchFeatureFiltersLazyQueryHookResult = ReturnType<typeof useGetSearchFeatureFiltersLazyQuery>;
export type GetSearchFeatureFiltersQueryResult = Apollo.QueryResult<GetSearchFeatureFiltersQuery, GetSearchFeatureFiltersQueryVariables>;
export const GetSearchRecentDocument = gql`
    query getSearchRecent {
  getSearchRecent {
    ...SearchResultFields
  }
}
    ${SearchResultFieldsFragmentDoc}`;

/**
 * __useGetSearchRecentQuery__
 *
 * To run a query within a React component, call `useGetSearchRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchRecentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchRecentQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchRecentQuery, GetSearchRecentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchRecentQuery, GetSearchRecentQueryVariables>(GetSearchRecentDocument, options);
      }
export function useGetSearchRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchRecentQuery, GetSearchRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchRecentQuery, GetSearchRecentQueryVariables>(GetSearchRecentDocument, options);
        }
export type GetSearchRecentQueryHookResult = ReturnType<typeof useGetSearchRecentQuery>;
export type GetSearchRecentLazyQueryHookResult = ReturnType<typeof useGetSearchRecentLazyQuery>;
export type GetSearchRecentQueryResult = Apollo.QueryResult<GetSearchRecentQuery, GetSearchRecentQueryVariables>;
export const SearchFeatureDocument = gql`
    query searchFeature($take: Int! = 10, $after: String, $before: String, $search: String, $filter: String, $feature: SearchFeatureEnum!) {
  searchFeature(
    take: $take
    after: $after
    before: $before
    search: $search
    filter: $filter
    feature: $feature
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...SearchResultFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${SearchResultFieldsFragmentDoc}`;

/**
 * __useSearchFeatureQuery__
 *
 * To run a query within a React component, call `useSearchFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFeatureQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useSearchFeatureQuery(baseOptions: Apollo.QueryHookOptions<SearchFeatureQuery, SearchFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFeatureQuery, SearchFeatureQueryVariables>(SearchFeatureDocument, options);
      }
export function useSearchFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFeatureQuery, SearchFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFeatureQuery, SearchFeatureQueryVariables>(SearchFeatureDocument, options);
        }
export type SearchFeatureQueryHookResult = ReturnType<typeof useSearchFeatureQuery>;
export type SearchFeatureLazyQueryHookResult = ReturnType<typeof useSearchFeatureLazyQuery>;
export type SearchFeatureQueryResult = Apollo.QueryResult<SearchFeatureQuery, SearchFeatureQueryVariables>;
export const StoreGuestsDocument = gql`
    mutation storeGuests($data: StoreGuestsDTO!) {
  storeGuests(input: $data)
}
    `;
export type StoreGuestsMutationFn = Apollo.MutationFunction<StoreGuestsMutation, StoreGuestsMutationVariables>;

/**
 * __useStoreGuestsMutation__
 *
 * To run a mutation, you first call `useStoreGuestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreGuestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeGuestsMutation, { data, loading, error }] = useStoreGuestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStoreGuestsMutation(baseOptions?: Apollo.MutationHookOptions<StoreGuestsMutation, StoreGuestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreGuestsMutation, StoreGuestsMutationVariables>(StoreGuestsDocument, options);
      }
export type StoreGuestsMutationHookResult = ReturnType<typeof useStoreGuestsMutation>;
export type StoreGuestsMutationResult = Apollo.MutationResult<StoreGuestsMutation>;
export type StoreGuestsMutationOptions = Apollo.BaseMutationOptions<StoreGuestsMutation, StoreGuestsMutationVariables>;
export const UpdateGuestVisitDocument = gql`
    mutation updateGuestVisit($id: String!, $data: UpdateGuestDTO!) {
  updateGuestVisit(id: $id, input: $data) {
    ...GuestFields
  }
}
    ${GuestFieldsFragmentDoc}`;
export type UpdateGuestVisitMutationFn = Apollo.MutationFunction<UpdateGuestVisitMutation, UpdateGuestVisitMutationVariables>;

/**
 * __useUpdateGuestVisitMutation__
 *
 * To run a mutation, you first call `useUpdateGuestVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestVisitMutation, { data, loading, error }] = useUpdateGuestVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGuestVisitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuestVisitMutation, UpdateGuestVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuestVisitMutation, UpdateGuestVisitMutationVariables>(UpdateGuestVisitDocument, options);
      }
export type UpdateGuestVisitMutationHookResult = ReturnType<typeof useUpdateGuestVisitMutation>;
export type UpdateGuestVisitMutationResult = Apollo.MutationResult<UpdateGuestVisitMutation>;
export type UpdateGuestVisitMutationOptions = Apollo.BaseMutationOptions<UpdateGuestVisitMutation, UpdateGuestVisitMutationVariables>;
export const UploadGuestCsvDocument = gql`
    mutation uploadGuestCsv($files: [Upload!]!) {
  uploadGuestCsv(files: $files) {
    companyName
    email
    firstName
    lastName
    errors {
      field
      message
    }
  }
}
    `;
export type UploadGuestCsvMutationFn = Apollo.MutationFunction<UploadGuestCsvMutation, UploadGuestCsvMutationVariables>;

/**
 * __useUploadGuestCsvMutation__
 *
 * To run a mutation, you first call `useUploadGuestCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGuestCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGuestCsvMutation, { data, loading, error }] = useUploadGuestCsvMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadGuestCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadGuestCsvMutation, UploadGuestCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGuestCsvMutation, UploadGuestCsvMutationVariables>(UploadGuestCsvDocument, options);
      }
export type UploadGuestCsvMutationHookResult = ReturnType<typeof useUploadGuestCsvMutation>;
export type UploadGuestCsvMutationResult = Apollo.MutationResult<UploadGuestCsvMutation>;
export type UploadGuestCsvMutationOptions = Apollo.BaseMutationOptions<UploadGuestCsvMutation, UploadGuestCsvMutationVariables>;
export const BulkStatusGuestsDocument = gql`
    mutation bulkStatusGuests($ids: [String!]!, $status: GuestStatusEnum!) {
  bulkStatusGuests(ids: $ids, status: $status) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status
    }
  }
}
    `;
export type BulkStatusGuestsMutationFn = Apollo.MutationFunction<BulkStatusGuestsMutation, BulkStatusGuestsMutationVariables>;

/**
 * __useBulkStatusGuestsMutation__
 *
 * To run a mutation, you first call `useBulkStatusGuestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusGuestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusGuestsMutation, { data, loading, error }] = useBulkStatusGuestsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkStatusGuestsMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusGuestsMutation, BulkStatusGuestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusGuestsMutation, BulkStatusGuestsMutationVariables>(BulkStatusGuestsDocument, options);
      }
export type BulkStatusGuestsMutationHookResult = ReturnType<typeof useBulkStatusGuestsMutation>;
export type BulkStatusGuestsMutationResult = Apollo.MutationResult<BulkStatusGuestsMutation>;
export type BulkStatusGuestsMutationOptions = Apollo.BaseMutationOptions<BulkStatusGuestsMutation, BulkStatusGuestsMutationVariables>;
export const GuestWebCheckInDocument = gql`
    mutation guestWebCheckIn($ids: [String!]!) {
  guestWebCheckIn(ids: $ids) {
    errorCount
    errorMessages
    successCount
    data {
      id
      visit {
        id
        checkInDates
      }
    }
  }
}
    `;
export type GuestWebCheckInMutationFn = Apollo.MutationFunction<GuestWebCheckInMutation, GuestWebCheckInMutationVariables>;

/**
 * __useGuestWebCheckInMutation__
 *
 * To run a mutation, you first call `useGuestWebCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestWebCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestWebCheckInMutation, { data, loading, error }] = useGuestWebCheckInMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGuestWebCheckInMutation(baseOptions?: Apollo.MutationHookOptions<GuestWebCheckInMutation, GuestWebCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestWebCheckInMutation, GuestWebCheckInMutationVariables>(GuestWebCheckInDocument, options);
      }
export type GuestWebCheckInMutationHookResult = ReturnType<typeof useGuestWebCheckInMutation>;
export type GuestWebCheckInMutationResult = Apollo.MutationResult<GuestWebCheckInMutation>;
export type GuestWebCheckInMutationOptions = Apollo.BaseMutationOptions<GuestWebCheckInMutation, GuestWebCheckInMutationVariables>;
export const PrintGuestBadgeDocument = gql`
    mutation printGuestBadge($ids: [String!]!) {
  printGuestBadge(ids: $ids) {
    notification
    errorCount
    errorMessages
    successCount
  }
}
    `;
export type PrintGuestBadgeMutationFn = Apollo.MutationFunction<PrintGuestBadgeMutation, PrintGuestBadgeMutationVariables>;

/**
 * __usePrintGuestBadgeMutation__
 *
 * To run a mutation, you first call `usePrintGuestBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintGuestBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printGuestBadgeMutation, { data, loading, error }] = usePrintGuestBadgeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePrintGuestBadgeMutation(baseOptions?: Apollo.MutationHookOptions<PrintGuestBadgeMutation, PrintGuestBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintGuestBadgeMutation, PrintGuestBadgeMutationVariables>(PrintGuestBadgeDocument, options);
      }
export type PrintGuestBadgeMutationHookResult = ReturnType<typeof usePrintGuestBadgeMutation>;
export type PrintGuestBadgeMutationResult = Apollo.MutationResult<PrintGuestBadgeMutation>;
export type PrintGuestBadgeMutationOptions = Apollo.BaseMutationOptions<PrintGuestBadgeMutation, PrintGuestBadgeMutationVariables>;
export const ResendGuestEmailDocument = gql`
    mutation resendGuestEmail($id: String!) {
  resendGuestEmail(id: $id)
}
    `;
export type ResendGuestEmailMutationFn = Apollo.MutationFunction<ResendGuestEmailMutation, ResendGuestEmailMutationVariables>;

/**
 * __useResendGuestEmailMutation__
 *
 * To run a mutation, you first call `useResendGuestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendGuestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendGuestEmailMutation, { data, loading, error }] = useResendGuestEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendGuestEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendGuestEmailMutation, ResendGuestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendGuestEmailMutation, ResendGuestEmailMutationVariables>(ResendGuestEmailDocument, options);
      }
export type ResendGuestEmailMutationHookResult = ReturnType<typeof useResendGuestEmailMutation>;
export type ResendGuestEmailMutationResult = Apollo.MutationResult<ResendGuestEmailMutation>;
export type ResendGuestEmailMutationOptions = Apollo.BaseMutationOptions<ResendGuestEmailMutation, ResendGuestEmailMutationVariables>;
export const NotifyGuestDocument = gql`
    mutation notifyGuest($id: String!, $userId: String!) {
  notifyGuest(id: $id, userId: $userId) {
    id
    firstName
    lastName
  }
}
    `;
export type NotifyGuestMutationFn = Apollo.MutationFunction<NotifyGuestMutation, NotifyGuestMutationVariables>;

/**
 * __useNotifyGuestMutation__
 *
 * To run a mutation, you first call `useNotifyGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyGuestMutation, { data, loading, error }] = useNotifyGuestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotifyGuestMutation(baseOptions?: Apollo.MutationHookOptions<NotifyGuestMutation, NotifyGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyGuestMutation, NotifyGuestMutationVariables>(NotifyGuestDocument, options);
      }
export type NotifyGuestMutationHookResult = ReturnType<typeof useNotifyGuestMutation>;
export type NotifyGuestMutationResult = Apollo.MutationResult<NotifyGuestMutation>;
export type NotifyGuestMutationOptions = Apollo.BaseMutationOptions<NotifyGuestMutation, NotifyGuestMutationVariables>;
export const DeleteGuestAttachmentDocument = gql`
    mutation deleteGuestAttachment($attachmentId: String!, $id: String!) {
  deleteGuestAttachment(attachmentId: $attachmentId, id: $id)
}
    `;
export type DeleteGuestAttachmentMutationFn = Apollo.MutationFunction<DeleteGuestAttachmentMutation, DeleteGuestAttachmentMutationVariables>;

/**
 * __useDeleteGuestAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteGuestAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGuestAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGuestAttachmentMutation, { data, loading, error }] = useDeleteGuestAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGuestAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGuestAttachmentMutation, DeleteGuestAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGuestAttachmentMutation, DeleteGuestAttachmentMutationVariables>(DeleteGuestAttachmentDocument, options);
      }
export type DeleteGuestAttachmentMutationHookResult = ReturnType<typeof useDeleteGuestAttachmentMutation>;
export type DeleteGuestAttachmentMutationResult = Apollo.MutationResult<DeleteGuestAttachmentMutation>;
export type DeleteGuestAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteGuestAttachmentMutation, DeleteGuestAttachmentMutationVariables>;
export const GetGuestsDocument = gql`
    query getGuests($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $statuses: [GuestStatusEnum!], $to: DateTime, $from: DateTime, $companyIds: [String!], $hostIds: [String!]) {
  getGuests(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    statuses: $statuses
    to: $to
    from: $from
    companyIds: $companyIds
    hostIds: $hostIds
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      companyName
      firstName
      code
      lastName
      status
      building {
        ...BuildingCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      company {
        ...CompanyCoreFields
      }
      visit {
        ...GuestVisitCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${GuestVisitCoreFieldsFragmentDoc}`;

/**
 * __useGetGuestsQuery__
 *
 * To run a query within a React component, call `useGetGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      statuses: // value for 'statuses'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      companyIds: // value for 'companyIds'
 *      hostIds: // value for 'hostIds'
 *   },
 * });
 */
export function useGetGuestsQuery(baseOptions?: Apollo.QueryHookOptions<GetGuestsQuery, GetGuestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestsQuery, GetGuestsQueryVariables>(GetGuestsDocument, options);
      }
export function useGetGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestsQuery, GetGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestsQuery, GetGuestsQueryVariables>(GetGuestsDocument, options);
        }
export type GetGuestsQueryHookResult = ReturnType<typeof useGetGuestsQuery>;
export type GetGuestsLazyQueryHookResult = ReturnType<typeof useGetGuestsLazyQuery>;
export type GetGuestsQueryResult = Apollo.QueryResult<GetGuestsQuery, GetGuestsQueryVariables>;
export const GetGuestDocument = gql`
    query getGuest($id: String!) {
  getGuest(id: $id) {
    ...GuestFields
  }
}
    ${GuestFieldsFragmentDoc}`;

/**
 * __useGetGuestQuery__
 *
 * To run a query within a React component, call `useGetGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuestQuery(baseOptions: Apollo.QueryHookOptions<GetGuestQuery, GetGuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestQuery, GetGuestQueryVariables>(GetGuestDocument, options);
      }
export function useGetGuestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestQuery, GetGuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestQuery, GetGuestQueryVariables>(GetGuestDocument, options);
        }
export type GetGuestQueryHookResult = ReturnType<typeof useGetGuestQuery>;
export type GetGuestLazyQueryHookResult = ReturnType<typeof useGetGuestLazyQuery>;
export type GetGuestQueryResult = Apollo.QueryResult<GetGuestQuery, GetGuestQueryVariables>;
export const GetGuestPrintDocument = gql`
    query getGuestPrint($id: String!) {
  getGuest(id: $id) {
    id
    code
    companyName
    firstName
    lastName
    status
    requestedFor {
      ...UserCoreFields
    }
    company {
      ...CompanyCoreFields
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
    }
    visit {
      ...GuestVisitCoreFields
    }
  }
}
    ${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${GuestVisitCoreFieldsFragmentDoc}`;

/**
 * __useGetGuestPrintQuery__
 *
 * To run a query within a React component, call `useGetGuestPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestPrintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuestPrintQuery(baseOptions: Apollo.QueryHookOptions<GetGuestPrintQuery, GetGuestPrintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestPrintQuery, GetGuestPrintQueryVariables>(GetGuestPrintDocument, options);
      }
export function useGetGuestPrintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestPrintQuery, GetGuestPrintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestPrintQuery, GetGuestPrintQueryVariables>(GetGuestPrintDocument, options);
        }
export type GetGuestPrintQueryHookResult = ReturnType<typeof useGetGuestPrintQuery>;
export type GetGuestPrintLazyQueryHookResult = ReturnType<typeof useGetGuestPrintLazyQuery>;
export type GetGuestPrintQueryResult = Apollo.QueryResult<GetGuestPrintQuery, GetGuestPrintQueryVariables>;
export const GetGuestQrCodeDocument = gql`
    query getGuestQrCode($id: String!) {
  getGuestQrCode(id: $id)
}
    `;

/**
 * __useGetGuestQrCodeQuery__
 *
 * To run a query within a React component, call `useGetGuestQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestQrCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuestQrCodeQuery(baseOptions: Apollo.QueryHookOptions<GetGuestQrCodeQuery, GetGuestQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestQrCodeQuery, GetGuestQrCodeQueryVariables>(GetGuestQrCodeDocument, options);
      }
export function useGetGuestQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestQrCodeQuery, GetGuestQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestQrCodeQuery, GetGuestQrCodeQueryVariables>(GetGuestQrCodeDocument, options);
        }
export type GetGuestQrCodeQueryHookResult = ReturnType<typeof useGetGuestQrCodeQuery>;
export type GetGuestQrCodeLazyQueryHookResult = ReturnType<typeof useGetGuestQrCodeLazyQuery>;
export type GetGuestQrCodeQueryResult = Apollo.QueryResult<GetGuestQrCodeQuery, GetGuestQrCodeQueryVariables>;
export const ExportGuestsDocument = gql`
    query exportGuests($search: String, $statuses: [GuestStatusEnum!], $to: DateTime, $from: DateTime, $buildingIds: [String!], $companyIds: [String!], $hostIds: [String!]) {
  exportGuests(
    search: $search
    statuses: $statuses
    to: $to
    from: $from
    buildingIds: $buildingIds
    companyIds: $companyIds
    hostIds: $hostIds
  )
}
    `;

/**
 * __useExportGuestsQuery__
 *
 * To run a query within a React component, call `useExportGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportGuestsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      buildingIds: // value for 'buildingIds'
 *      companyIds: // value for 'companyIds'
 *      hostIds: // value for 'hostIds'
 *   },
 * });
 */
export function useExportGuestsQuery(baseOptions?: Apollo.QueryHookOptions<ExportGuestsQuery, ExportGuestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportGuestsQuery, ExportGuestsQueryVariables>(ExportGuestsDocument, options);
      }
export function useExportGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportGuestsQuery, ExportGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportGuestsQuery, ExportGuestsQueryVariables>(ExportGuestsDocument, options);
        }
export type ExportGuestsQueryHookResult = ReturnType<typeof useExportGuestsQuery>;
export type ExportGuestsLazyQueryHookResult = ReturnType<typeof useExportGuestsLazyQuery>;
export type ExportGuestsQueryResult = Apollo.QueryResult<ExportGuestsQuery, ExportGuestsQueryVariables>;
export const UpdateGuestSettingsDocument = gql`
    mutation updateGuestSettings($data: GuestSettingsInput!) {
  updateGuestSettings(input: $data) {
    ...GuestSettingsFields
  }
}
    ${GuestSettingsFieldsFragmentDoc}`;
export type UpdateGuestSettingsMutationFn = Apollo.MutationFunction<UpdateGuestSettingsMutation, UpdateGuestSettingsMutationVariables>;

/**
 * __useUpdateGuestSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateGuestSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestSettingsMutation, { data, loading, error }] = useUpdateGuestSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGuestSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuestSettingsMutation, UpdateGuestSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuestSettingsMutation, UpdateGuestSettingsMutationVariables>(UpdateGuestSettingsDocument, options);
      }
export type UpdateGuestSettingsMutationHookResult = ReturnType<typeof useUpdateGuestSettingsMutation>;
export type UpdateGuestSettingsMutationResult = Apollo.MutationResult<UpdateGuestSettingsMutation>;
export type UpdateGuestSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateGuestSettingsMutation, UpdateGuestSettingsMutationVariables>;
export const GetGuestSettingsDocument = gql`
    query getGuestSettings {
  getGuestSettings {
    ...GuestSettingsFields
  }
}
    ${GuestSettingsFieldsFragmentDoc}`;

/**
 * __useGetGuestSettingsQuery__
 *
 * To run a query within a React component, call `useGetGuestSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGuestSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetGuestSettingsQuery, GetGuestSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestSettingsQuery, GetGuestSettingsQueryVariables>(GetGuestSettingsDocument, options);
      }
export function useGetGuestSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestSettingsQuery, GetGuestSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestSettingsQuery, GetGuestSettingsQueryVariables>(GetGuestSettingsDocument, options);
        }
export type GetGuestSettingsQueryHookResult = ReturnType<typeof useGetGuestSettingsQuery>;
export type GetGuestSettingsLazyQueryHookResult = ReturnType<typeof useGetGuestSettingsLazyQuery>;
export type GetGuestSettingsQueryResult = Apollo.QueryResult<GetGuestSettingsQuery, GetGuestSettingsQueryVariables>;
export const ImportParseUsersDocument = gql`
    mutation importParseUsers($link: String!) {
  importParseUsers(link: $link) {
    ...ImportUserFields
  }
}
    ${ImportUserFieldsFragmentDoc}`;
export type ImportParseUsersMutationFn = Apollo.MutationFunction<ImportParseUsersMutation, ImportParseUsersMutationVariables>;

/**
 * __useImportParseUsersMutation__
 *
 * To run a mutation, you first call `useImportParseUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseUsersMutation, { data, loading, error }] = useImportParseUsersMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseUsersMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseUsersMutation, ImportParseUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseUsersMutation, ImportParseUsersMutationVariables>(ImportParseUsersDocument, options);
      }
export type ImportParseUsersMutationHookResult = ReturnType<typeof useImportParseUsersMutation>;
export type ImportParseUsersMutationResult = Apollo.MutationResult<ImportParseUsersMutation>;
export type ImportParseUsersMutationOptions = Apollo.BaseMutationOptions<ImportParseUsersMutation, ImportParseUsersMutationVariables>;
export const ImportStoreUsersDocument = gql`
    mutation importStoreUsers($data: [ImportUsersInput!]!, $skipNotValid: Boolean! = false) {
  importStoreUsers(input: $data, skipNotValid: $skipNotValid) {
    ...ImportUserFields
  }
}
    ${ImportUserFieldsFragmentDoc}`;
export type ImportStoreUsersMutationFn = Apollo.MutationFunction<ImportStoreUsersMutation, ImportStoreUsersMutationVariables>;

/**
 * __useImportStoreUsersMutation__
 *
 * To run a mutation, you first call `useImportStoreUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreUsersMutation, { data, loading, error }] = useImportStoreUsersMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreUsersMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreUsersMutation, ImportStoreUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreUsersMutation, ImportStoreUsersMutationVariables>(ImportStoreUsersDocument, options);
      }
export type ImportStoreUsersMutationHookResult = ReturnType<typeof useImportStoreUsersMutation>;
export type ImportStoreUsersMutationResult = Apollo.MutationResult<ImportStoreUsersMutation>;
export type ImportStoreUsersMutationOptions = Apollo.BaseMutationOptions<ImportStoreUsersMutation, ImportStoreUsersMutationVariables>;
export const ImportParseCompaniesDocument = gql`
    mutation importParseCompanies($link: String!) {
  importParseCompanies(link: $link) {
    ...ImportCompanyFields
  }
}
    ${ImportCompanyFieldsFragmentDoc}`;
export type ImportParseCompaniesMutationFn = Apollo.MutationFunction<ImportParseCompaniesMutation, ImportParseCompaniesMutationVariables>;

/**
 * __useImportParseCompaniesMutation__
 *
 * To run a mutation, you first call `useImportParseCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseCompaniesMutation, { data, loading, error }] = useImportParseCompaniesMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseCompaniesMutation, ImportParseCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseCompaniesMutation, ImportParseCompaniesMutationVariables>(ImportParseCompaniesDocument, options);
      }
export type ImportParseCompaniesMutationHookResult = ReturnType<typeof useImportParseCompaniesMutation>;
export type ImportParseCompaniesMutationResult = Apollo.MutationResult<ImportParseCompaniesMutation>;
export type ImportParseCompaniesMutationOptions = Apollo.BaseMutationOptions<ImportParseCompaniesMutation, ImportParseCompaniesMutationVariables>;
export const ImportStoreCompaniesDocument = gql`
    mutation importStoreCompanies($data: [ImportCompaniesInput!]!, $skipNotValid: Boolean! = false) {
  importStoreCompanies(input: $data, skipNotValid: $skipNotValid) {
    ...ImportCompanyFields
  }
}
    ${ImportCompanyFieldsFragmentDoc}`;
export type ImportStoreCompaniesMutationFn = Apollo.MutationFunction<ImportStoreCompaniesMutation, ImportStoreCompaniesMutationVariables>;

/**
 * __useImportStoreCompaniesMutation__
 *
 * To run a mutation, you first call `useImportStoreCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreCompaniesMutation, { data, loading, error }] = useImportStoreCompaniesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreCompaniesMutation, ImportStoreCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreCompaniesMutation, ImportStoreCompaniesMutationVariables>(ImportStoreCompaniesDocument, options);
      }
export type ImportStoreCompaniesMutationHookResult = ReturnType<typeof useImportStoreCompaniesMutation>;
export type ImportStoreCompaniesMutationResult = Apollo.MutationResult<ImportStoreCompaniesMutation>;
export type ImportStoreCompaniesMutationOptions = Apollo.BaseMutationOptions<ImportStoreCompaniesMutation, ImportStoreCompaniesMutationVariables>;
export const ImportParseFloorsDocument = gql`
    mutation importParseFloors($link: String!) {
  importParseFloors(link: $link) {
    ...ImportFloorFields
  }
}
    ${ImportFloorFieldsFragmentDoc}`;
export type ImportParseFloorsMutationFn = Apollo.MutationFunction<ImportParseFloorsMutation, ImportParseFloorsMutationVariables>;

/**
 * __useImportParseFloorsMutation__
 *
 * To run a mutation, you first call `useImportParseFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseFloorsMutation, { data, loading, error }] = useImportParseFloorsMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseFloorsMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseFloorsMutation, ImportParseFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseFloorsMutation, ImportParseFloorsMutationVariables>(ImportParseFloorsDocument, options);
      }
export type ImportParseFloorsMutationHookResult = ReturnType<typeof useImportParseFloorsMutation>;
export type ImportParseFloorsMutationResult = Apollo.MutationResult<ImportParseFloorsMutation>;
export type ImportParseFloorsMutationOptions = Apollo.BaseMutationOptions<ImportParseFloorsMutation, ImportParseFloorsMutationVariables>;
export const ImportStoreFloorsDocument = gql`
    mutation importStoreFloors($data: [ImportFloorInput!]!, $skipNotValid: Boolean! = false) {
  importStoreFloors(input: $data, skipNotValid: $skipNotValid) {
    ...ImportFloorFields
  }
}
    ${ImportFloorFieldsFragmentDoc}`;
export type ImportStoreFloorsMutationFn = Apollo.MutationFunction<ImportStoreFloorsMutation, ImportStoreFloorsMutationVariables>;

/**
 * __useImportStoreFloorsMutation__
 *
 * To run a mutation, you first call `useImportStoreFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreFloorsMutation, { data, loading, error }] = useImportStoreFloorsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreFloorsMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreFloorsMutation, ImportStoreFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreFloorsMutation, ImportStoreFloorsMutationVariables>(ImportStoreFloorsDocument, options);
      }
export type ImportStoreFloorsMutationHookResult = ReturnType<typeof useImportStoreFloorsMutation>;
export type ImportStoreFloorsMutationResult = Apollo.MutationResult<ImportStoreFloorsMutation>;
export type ImportStoreFloorsMutationOptions = Apollo.BaseMutationOptions<ImportStoreFloorsMutation, ImportStoreFloorsMutationVariables>;
export const ImportParseSuitesDocument = gql`
    mutation importParseSuites($link: String!) {
  importParseSuites(link: $link) {
    ...ImportSuiteFields
  }
}
    ${ImportSuiteFieldsFragmentDoc}`;
export type ImportParseSuitesMutationFn = Apollo.MutationFunction<ImportParseSuitesMutation, ImportParseSuitesMutationVariables>;

/**
 * __useImportParseSuitesMutation__
 *
 * To run a mutation, you first call `useImportParseSuitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseSuitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseSuitesMutation, { data, loading, error }] = useImportParseSuitesMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseSuitesMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseSuitesMutation, ImportParseSuitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseSuitesMutation, ImportParseSuitesMutationVariables>(ImportParseSuitesDocument, options);
      }
export type ImportParseSuitesMutationHookResult = ReturnType<typeof useImportParseSuitesMutation>;
export type ImportParseSuitesMutationResult = Apollo.MutationResult<ImportParseSuitesMutation>;
export type ImportParseSuitesMutationOptions = Apollo.BaseMutationOptions<ImportParseSuitesMutation, ImportParseSuitesMutationVariables>;
export const ImportStoreSuitesDocument = gql`
    mutation importStoreSuites($data: [ImportSuiteInput!]!, $skipNotValid: Boolean! = false) {
  importStoreSuites(input: $data, skipNotValid: $skipNotValid) {
    ...ImportSuiteFields
  }
}
    ${ImportSuiteFieldsFragmentDoc}`;
export type ImportStoreSuitesMutationFn = Apollo.MutationFunction<ImportStoreSuitesMutation, ImportStoreSuitesMutationVariables>;

/**
 * __useImportStoreSuitesMutation__
 *
 * To run a mutation, you first call `useImportStoreSuitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreSuitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreSuitesMutation, { data, loading, error }] = useImportStoreSuitesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreSuitesMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreSuitesMutation, ImportStoreSuitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreSuitesMutation, ImportStoreSuitesMutationVariables>(ImportStoreSuitesDocument, options);
      }
export type ImportStoreSuitesMutationHookResult = ReturnType<typeof useImportStoreSuitesMutation>;
export type ImportStoreSuitesMutationResult = Apollo.MutationResult<ImportStoreSuitesMutation>;
export type ImportStoreSuitesMutationOptions = Apollo.BaseMutationOptions<ImportStoreSuitesMutation, ImportStoreSuitesMutationVariables>;
export const ImportParseEquipmentCategoriesDocument = gql`
    mutation importParseEquipmentCategories($link: String!) {
  importParseEquipmentCategories(link: $link) {
    ...ImportEquipmentCategoryFields
  }
}
    ${ImportEquipmentCategoryFieldsFragmentDoc}`;
export type ImportParseEquipmentCategoriesMutationFn = Apollo.MutationFunction<ImportParseEquipmentCategoriesMutation, ImportParseEquipmentCategoriesMutationVariables>;

/**
 * __useImportParseEquipmentCategoriesMutation__
 *
 * To run a mutation, you first call `useImportParseEquipmentCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseEquipmentCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseEquipmentCategoriesMutation, { data, loading, error }] = useImportParseEquipmentCategoriesMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseEquipmentCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseEquipmentCategoriesMutation, ImportParseEquipmentCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseEquipmentCategoriesMutation, ImportParseEquipmentCategoriesMutationVariables>(ImportParseEquipmentCategoriesDocument, options);
      }
export type ImportParseEquipmentCategoriesMutationHookResult = ReturnType<typeof useImportParseEquipmentCategoriesMutation>;
export type ImportParseEquipmentCategoriesMutationResult = Apollo.MutationResult<ImportParseEquipmentCategoriesMutation>;
export type ImportParseEquipmentCategoriesMutationOptions = Apollo.BaseMutationOptions<ImportParseEquipmentCategoriesMutation, ImportParseEquipmentCategoriesMutationVariables>;
export const ImportStoreEquipmentCategoriesDocument = gql`
    mutation importStoreEquipmentCategories($data: [ImportEquipmentCategoryInput!]!, $skipNotValid: Boolean! = false) {
  importStoreEquipmentCategories(input: $data, skipNotValid: $skipNotValid) {
    ...ImportEquipmentCategoryFields
  }
}
    ${ImportEquipmentCategoryFieldsFragmentDoc}`;
export type ImportStoreEquipmentCategoriesMutationFn = Apollo.MutationFunction<ImportStoreEquipmentCategoriesMutation, ImportStoreEquipmentCategoriesMutationVariables>;

/**
 * __useImportStoreEquipmentCategoriesMutation__
 *
 * To run a mutation, you first call `useImportStoreEquipmentCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreEquipmentCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreEquipmentCategoriesMutation, { data, loading, error }] = useImportStoreEquipmentCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreEquipmentCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreEquipmentCategoriesMutation, ImportStoreEquipmentCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreEquipmentCategoriesMutation, ImportStoreEquipmentCategoriesMutationVariables>(ImportStoreEquipmentCategoriesDocument, options);
      }
export type ImportStoreEquipmentCategoriesMutationHookResult = ReturnType<typeof useImportStoreEquipmentCategoriesMutation>;
export type ImportStoreEquipmentCategoriesMutationResult = Apollo.MutationResult<ImportStoreEquipmentCategoriesMutation>;
export type ImportStoreEquipmentCategoriesMutationOptions = Apollo.BaseMutationOptions<ImportStoreEquipmentCategoriesMutation, ImportStoreEquipmentCategoriesMutationVariables>;
export const ImportParseEquipmentDocument = gql`
    mutation importParseEquipment($link: String!) {
  importParseEquipment(link: $link) {
    ...ImportEquipmentFields
  }
}
    ${ImportEquipmentFieldsFragmentDoc}`;
export type ImportParseEquipmentMutationFn = Apollo.MutationFunction<ImportParseEquipmentMutation, ImportParseEquipmentMutationVariables>;

/**
 * __useImportParseEquipmentMutation__
 *
 * To run a mutation, you first call `useImportParseEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseEquipmentMutation, { data, loading, error }] = useImportParseEquipmentMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseEquipmentMutation, ImportParseEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseEquipmentMutation, ImportParseEquipmentMutationVariables>(ImportParseEquipmentDocument, options);
      }
export type ImportParseEquipmentMutationHookResult = ReturnType<typeof useImportParseEquipmentMutation>;
export type ImportParseEquipmentMutationResult = Apollo.MutationResult<ImportParseEquipmentMutation>;
export type ImportParseEquipmentMutationOptions = Apollo.BaseMutationOptions<ImportParseEquipmentMutation, ImportParseEquipmentMutationVariables>;
export const ImportStoreEquipmentDocument = gql`
    mutation importStoreEquipment($data: [ImportEquipmentInput!]!, $skipNotValid: Boolean! = false) {
  importStoreEquipment(input: $data, skipNotValid: $skipNotValid) {
    ...ImportEquipmentFields
  }
}
    ${ImportEquipmentFieldsFragmentDoc}`;
export type ImportStoreEquipmentMutationFn = Apollo.MutationFunction<ImportStoreEquipmentMutation, ImportStoreEquipmentMutationVariables>;

/**
 * __useImportStoreEquipmentMutation__
 *
 * To run a mutation, you first call `useImportStoreEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreEquipmentMutation, { data, loading, error }] = useImportStoreEquipmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreEquipmentMutation, ImportStoreEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreEquipmentMutation, ImportStoreEquipmentMutationVariables>(ImportStoreEquipmentDocument, options);
      }
export type ImportStoreEquipmentMutationHookResult = ReturnType<typeof useImportStoreEquipmentMutation>;
export type ImportStoreEquipmentMutationResult = Apollo.MutationResult<ImportStoreEquipmentMutation>;
export type ImportStoreEquipmentMutationOptions = Apollo.BaseMutationOptions<ImportStoreEquipmentMutation, ImportStoreEquipmentMutationVariables>;
export const ImportParseProceduresDocument = gql`
    mutation importParseProcedures($link: String!) {
  importParseProcedures(link: $link) {
    ...ImportProcedureFields
  }
}
    ${ImportProcedureFieldsFragmentDoc}`;
export type ImportParseProceduresMutationFn = Apollo.MutationFunction<ImportParseProceduresMutation, ImportParseProceduresMutationVariables>;

/**
 * __useImportParseProceduresMutation__
 *
 * To run a mutation, you first call `useImportParseProceduresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseProceduresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseProceduresMutation, { data, loading, error }] = useImportParseProceduresMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseProceduresMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseProceduresMutation, ImportParseProceduresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseProceduresMutation, ImportParseProceduresMutationVariables>(ImportParseProceduresDocument, options);
      }
export type ImportParseProceduresMutationHookResult = ReturnType<typeof useImportParseProceduresMutation>;
export type ImportParseProceduresMutationResult = Apollo.MutationResult<ImportParseProceduresMutation>;
export type ImportParseProceduresMutationOptions = Apollo.BaseMutationOptions<ImportParseProceduresMutation, ImportParseProceduresMutationVariables>;
export const ImportStoreProceduresDocument = gql`
    mutation importStoreProcedures($data: [ImportProcedureInput!]!, $skipNotValid: Boolean! = false) {
  importStoreProcedures(input: $data, skipNotValid: $skipNotValid) {
    ...ImportProcedureFields
  }
}
    ${ImportProcedureFieldsFragmentDoc}`;
export type ImportStoreProceduresMutationFn = Apollo.MutationFunction<ImportStoreProceduresMutation, ImportStoreProceduresMutationVariables>;

/**
 * __useImportStoreProceduresMutation__
 *
 * To run a mutation, you first call `useImportStoreProceduresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreProceduresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreProceduresMutation, { data, loading, error }] = useImportStoreProceduresMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreProceduresMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreProceduresMutation, ImportStoreProceduresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreProceduresMutation, ImportStoreProceduresMutationVariables>(ImportStoreProceduresDocument, options);
      }
export type ImportStoreProceduresMutationHookResult = ReturnType<typeof useImportStoreProceduresMutation>;
export type ImportStoreProceduresMutationResult = Apollo.MutationResult<ImportStoreProceduresMutation>;
export type ImportStoreProceduresMutationOptions = Apollo.BaseMutationOptions<ImportStoreProceduresMutation, ImportStoreProceduresMutationVariables>;
export const ImportParseSchedulesDocument = gql`
    mutation importParseSchedules($link: String!) {
  importParseSchedules(link: $link) {
    ...ImportScheduleFields
  }
}
    ${ImportScheduleFieldsFragmentDoc}`;
export type ImportParseSchedulesMutationFn = Apollo.MutationFunction<ImportParseSchedulesMutation, ImportParseSchedulesMutationVariables>;

/**
 * __useImportParseSchedulesMutation__
 *
 * To run a mutation, you first call `useImportParseSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseSchedulesMutation, { data, loading, error }] = useImportParseSchedulesMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseSchedulesMutation, ImportParseSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseSchedulesMutation, ImportParseSchedulesMutationVariables>(ImportParseSchedulesDocument, options);
      }
export type ImportParseSchedulesMutationHookResult = ReturnType<typeof useImportParseSchedulesMutation>;
export type ImportParseSchedulesMutationResult = Apollo.MutationResult<ImportParseSchedulesMutation>;
export type ImportParseSchedulesMutationOptions = Apollo.BaseMutationOptions<ImportParseSchedulesMutation, ImportParseSchedulesMutationVariables>;
export const ImportStoreSchedulesDocument = gql`
    mutation importStoreSchedules($data: [ImportScheduleInput!]!, $skipNotValid: Boolean! = false) {
  importStoreSchedules(input: $data, skipNotValid: $skipNotValid) {
    ...ImportScheduleFields
  }
}
    ${ImportScheduleFieldsFragmentDoc}`;
export type ImportStoreSchedulesMutationFn = Apollo.MutationFunction<ImportStoreSchedulesMutation, ImportStoreSchedulesMutationVariables>;

/**
 * __useImportStoreSchedulesMutation__
 *
 * To run a mutation, you first call `useImportStoreSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreSchedulesMutation, { data, loading, error }] = useImportStoreSchedulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreSchedulesMutation, ImportStoreSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreSchedulesMutation, ImportStoreSchedulesMutationVariables>(ImportStoreSchedulesDocument, options);
      }
export type ImportStoreSchedulesMutationHookResult = ReturnType<typeof useImportStoreSchedulesMutation>;
export type ImportStoreSchedulesMutationResult = Apollo.MutationResult<ImportStoreSchedulesMutation>;
export type ImportStoreSchedulesMutationOptions = Apollo.BaseMutationOptions<ImportStoreSchedulesMutation, ImportStoreSchedulesMutationVariables>;
export const ImportParseMaterialGroupsDocument = gql`
    mutation importParseMaterialGroups($link: String!) {
  importParseMaterialGroups(link: $link) {
    ...ImportMaterialGroupFields
  }
}
    ${ImportMaterialGroupFieldsFragmentDoc}`;
export type ImportParseMaterialGroupsMutationFn = Apollo.MutationFunction<ImportParseMaterialGroupsMutation, ImportParseMaterialGroupsMutationVariables>;

/**
 * __useImportParseMaterialGroupsMutation__
 *
 * To run a mutation, you first call `useImportParseMaterialGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseMaterialGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseMaterialGroupsMutation, { data, loading, error }] = useImportParseMaterialGroupsMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseMaterialGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseMaterialGroupsMutation, ImportParseMaterialGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseMaterialGroupsMutation, ImportParseMaterialGroupsMutationVariables>(ImportParseMaterialGroupsDocument, options);
      }
export type ImportParseMaterialGroupsMutationHookResult = ReturnType<typeof useImportParseMaterialGroupsMutation>;
export type ImportParseMaterialGroupsMutationResult = Apollo.MutationResult<ImportParseMaterialGroupsMutation>;
export type ImportParseMaterialGroupsMutationOptions = Apollo.BaseMutationOptions<ImportParseMaterialGroupsMutation, ImportParseMaterialGroupsMutationVariables>;
export const ImportStoreMaterialGroupsDocument = gql`
    mutation importStoreMaterialGroups($data: [ImportMaterialGroupInput!]!, $skipNotValid: Boolean! = false) {
  importStoreMaterialGroups(input: $data, skipNotValid: $skipNotValid) {
    ...ImportMaterialGroupFields
  }
}
    ${ImportMaterialGroupFieldsFragmentDoc}`;
export type ImportStoreMaterialGroupsMutationFn = Apollo.MutationFunction<ImportStoreMaterialGroupsMutation, ImportStoreMaterialGroupsMutationVariables>;

/**
 * __useImportStoreMaterialGroupsMutation__
 *
 * To run a mutation, you first call `useImportStoreMaterialGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreMaterialGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreMaterialGroupsMutation, { data, loading, error }] = useImportStoreMaterialGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreMaterialGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreMaterialGroupsMutation, ImportStoreMaterialGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreMaterialGroupsMutation, ImportStoreMaterialGroupsMutationVariables>(ImportStoreMaterialGroupsDocument, options);
      }
export type ImportStoreMaterialGroupsMutationHookResult = ReturnType<typeof useImportStoreMaterialGroupsMutation>;
export type ImportStoreMaterialGroupsMutationResult = Apollo.MutationResult<ImportStoreMaterialGroupsMutation>;
export type ImportStoreMaterialGroupsMutationOptions = Apollo.BaseMutationOptions<ImportStoreMaterialGroupsMutation, ImportStoreMaterialGroupsMutationVariables>;
export const ImportParseMaterialsDocument = gql`
    mutation importParseMaterials($link: String!) {
  importParseMaterials(link: $link) {
    ...ImportMaterialFields
  }
}
    ${ImportMaterialFieldsFragmentDoc}`;
export type ImportParseMaterialsMutationFn = Apollo.MutationFunction<ImportParseMaterialsMutation, ImportParseMaterialsMutationVariables>;

/**
 * __useImportParseMaterialsMutation__
 *
 * To run a mutation, you first call `useImportParseMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseMaterialsMutation, { data, loading, error }] = useImportParseMaterialsMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseMaterialsMutation, ImportParseMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseMaterialsMutation, ImportParseMaterialsMutationVariables>(ImportParseMaterialsDocument, options);
      }
export type ImportParseMaterialsMutationHookResult = ReturnType<typeof useImportParseMaterialsMutation>;
export type ImportParseMaterialsMutationResult = Apollo.MutationResult<ImportParseMaterialsMutation>;
export type ImportParseMaterialsMutationOptions = Apollo.BaseMutationOptions<ImportParseMaterialsMutation, ImportParseMaterialsMutationVariables>;
export const ImportStoreMaterialsDocument = gql`
    mutation importStoreMaterials($data: [ImportMaterialInput!]!, $skipNotValid: Boolean! = false) {
  importStoreMaterials(input: $data, skipNotValid: $skipNotValid) {
    ...ImportMaterialFields
  }
}
    ${ImportMaterialFieldsFragmentDoc}`;
export type ImportStoreMaterialsMutationFn = Apollo.MutationFunction<ImportStoreMaterialsMutation, ImportStoreMaterialsMutationVariables>;

/**
 * __useImportStoreMaterialsMutation__
 *
 * To run a mutation, you first call `useImportStoreMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreMaterialsMutation, { data, loading, error }] = useImportStoreMaterialsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreMaterialsMutation, ImportStoreMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreMaterialsMutation, ImportStoreMaterialsMutationVariables>(ImportStoreMaterialsDocument, options);
      }
export type ImportStoreMaterialsMutationHookResult = ReturnType<typeof useImportStoreMaterialsMutation>;
export type ImportStoreMaterialsMutationResult = Apollo.MutationResult<ImportStoreMaterialsMutation>;
export type ImportStoreMaterialsMutationOptions = Apollo.BaseMutationOptions<ImportStoreMaterialsMutation, ImportStoreMaterialsMutationVariables>;
export const ImportParseWorkOrdersDocument = gql`
    mutation importParseWorkOrders($link: String!) {
  importParseWorkOrders(link: $link) {
    ...ImportWorkOrderFields
  }
}
    ${ImportWorkOrderFieldsFragmentDoc}`;
export type ImportParseWorkOrdersMutationFn = Apollo.MutationFunction<ImportParseWorkOrdersMutation, ImportParseWorkOrdersMutationVariables>;

/**
 * __useImportParseWorkOrdersMutation__
 *
 * To run a mutation, you first call `useImportParseWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseWorkOrdersMutation, { data, loading, error }] = useImportParseWorkOrdersMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseWorkOrdersMutation, ImportParseWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseWorkOrdersMutation, ImportParseWorkOrdersMutationVariables>(ImportParseWorkOrdersDocument, options);
      }
export type ImportParseWorkOrdersMutationHookResult = ReturnType<typeof useImportParseWorkOrdersMutation>;
export type ImportParseWorkOrdersMutationResult = Apollo.MutationResult<ImportParseWorkOrdersMutation>;
export type ImportParseWorkOrdersMutationOptions = Apollo.BaseMutationOptions<ImportParseWorkOrdersMutation, ImportParseWorkOrdersMutationVariables>;
export const ImportStoreWorkOrdersDocument = gql`
    mutation importStoreWorkOrders($data: [ImportWorkOrderInput!]!, $skipNotValid: Boolean! = false) {
  importStoreWorkOrders(input: $data, skipNotValid: $skipNotValid) {
    ...ImportWorkOrderFields
  }
}
    ${ImportWorkOrderFieldsFragmentDoc}`;
export type ImportStoreWorkOrdersMutationFn = Apollo.MutationFunction<ImportStoreWorkOrdersMutation, ImportStoreWorkOrdersMutationVariables>;

/**
 * __useImportStoreWorkOrdersMutation__
 *
 * To run a mutation, you first call `useImportStoreWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreWorkOrdersMutation, { data, loading, error }] = useImportStoreWorkOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreWorkOrdersMutation, ImportStoreWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreWorkOrdersMutation, ImportStoreWorkOrdersMutationVariables>(ImportStoreWorkOrdersDocument, options);
      }
export type ImportStoreWorkOrdersMutationHookResult = ReturnType<typeof useImportStoreWorkOrdersMutation>;
export type ImportStoreWorkOrdersMutationResult = Apollo.MutationResult<ImportStoreWorkOrdersMutation>;
export type ImportStoreWorkOrdersMutationOptions = Apollo.BaseMutationOptions<ImportStoreWorkOrdersMutation, ImportStoreWorkOrdersMutationVariables>;
export const ImportParseWorkOrderTemplatesDocument = gql`
    mutation importParseWorkOrderTemplates($link: String!) {
  importParseWorkOrderTemplates(link: $link) {
    ...ImportWorkOrderTemplateFields
  }
}
    ${ImportWorkOrderTemplateFieldsFragmentDoc}`;
export type ImportParseWorkOrderTemplatesMutationFn = Apollo.MutationFunction<ImportParseWorkOrderTemplatesMutation, ImportParseWorkOrderTemplatesMutationVariables>;

/**
 * __useImportParseWorkOrderTemplatesMutation__
 *
 * To run a mutation, you first call `useImportParseWorkOrderTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseWorkOrderTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseWorkOrderTemplatesMutation, { data, loading, error }] = useImportParseWorkOrderTemplatesMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseWorkOrderTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseWorkOrderTemplatesMutation, ImportParseWorkOrderTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseWorkOrderTemplatesMutation, ImportParseWorkOrderTemplatesMutationVariables>(ImportParseWorkOrderTemplatesDocument, options);
      }
export type ImportParseWorkOrderTemplatesMutationHookResult = ReturnType<typeof useImportParseWorkOrderTemplatesMutation>;
export type ImportParseWorkOrderTemplatesMutationResult = Apollo.MutationResult<ImportParseWorkOrderTemplatesMutation>;
export type ImportParseWorkOrderTemplatesMutationOptions = Apollo.BaseMutationOptions<ImportParseWorkOrderTemplatesMutation, ImportParseWorkOrderTemplatesMutationVariables>;
export const ImportStoreWorkOrderTemplatesDocument = gql`
    mutation importStoreWorkOrderTemplates($data: [ImportWOTInput!]!, $skipNotValid: Boolean! = false) {
  importStoreWorkOrderTemplates(input: $data, skipNotValid: $skipNotValid) {
    ...ImportWorkOrderTemplateFields
  }
}
    ${ImportWorkOrderTemplateFieldsFragmentDoc}`;
export type ImportStoreWorkOrderTemplatesMutationFn = Apollo.MutationFunction<ImportStoreWorkOrderTemplatesMutation, ImportStoreWorkOrderTemplatesMutationVariables>;

/**
 * __useImportStoreWorkOrderTemplatesMutation__
 *
 * To run a mutation, you first call `useImportStoreWorkOrderTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreWorkOrderTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreWorkOrderTemplatesMutation, { data, loading, error }] = useImportStoreWorkOrderTemplatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreWorkOrderTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreWorkOrderTemplatesMutation, ImportStoreWorkOrderTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreWorkOrderTemplatesMutation, ImportStoreWorkOrderTemplatesMutationVariables>(ImportStoreWorkOrderTemplatesDocument, options);
      }
export type ImportStoreWorkOrderTemplatesMutationHookResult = ReturnType<typeof useImportStoreWorkOrderTemplatesMutation>;
export type ImportStoreWorkOrderTemplatesMutationResult = Apollo.MutationResult<ImportStoreWorkOrderTemplatesMutation>;
export type ImportStoreWorkOrderTemplatesMutationOptions = Apollo.BaseMutationOptions<ImportStoreWorkOrderTemplatesMutation, ImportStoreWorkOrderTemplatesMutationVariables>;
export const ImportParseIncidentsDocument = gql`
    mutation importParseIncidents($link: String!) {
  importParseIncidents(link: $link) {
    ...ImportIncidentFields
  }
}
    ${ImportIncidentFieldsFragmentDoc}`;
export type ImportParseIncidentsMutationFn = Apollo.MutationFunction<ImportParseIncidentsMutation, ImportParseIncidentsMutationVariables>;

/**
 * __useImportParseIncidentsMutation__
 *
 * To run a mutation, you first call `useImportParseIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseIncidentsMutation, { data, loading, error }] = useImportParseIncidentsMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseIncidentsMutation, ImportParseIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseIncidentsMutation, ImportParseIncidentsMutationVariables>(ImportParseIncidentsDocument, options);
      }
export type ImportParseIncidentsMutationHookResult = ReturnType<typeof useImportParseIncidentsMutation>;
export type ImportParseIncidentsMutationResult = Apollo.MutationResult<ImportParseIncidentsMutation>;
export type ImportParseIncidentsMutationOptions = Apollo.BaseMutationOptions<ImportParseIncidentsMutation, ImportParseIncidentsMutationVariables>;
export const ImportStoreIncidentsDocument = gql`
    mutation importStoreIncidents($data: [ImportIncidentInput!]!, $skipNotValid: Boolean! = false) {
  importStoreIncidents(input: $data, skipNotValid: $skipNotValid) {
    ...ImportIncidentFields
  }
}
    ${ImportIncidentFieldsFragmentDoc}`;
export type ImportStoreIncidentsMutationFn = Apollo.MutationFunction<ImportStoreIncidentsMutation, ImportStoreIncidentsMutationVariables>;

/**
 * __useImportStoreIncidentsMutation__
 *
 * To run a mutation, you first call `useImportStoreIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreIncidentsMutation, { data, loading, error }] = useImportStoreIncidentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreIncidentsMutation, ImportStoreIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreIncidentsMutation, ImportStoreIncidentsMutationVariables>(ImportStoreIncidentsDocument, options);
      }
export type ImportStoreIncidentsMutationHookResult = ReturnType<typeof useImportStoreIncidentsMutation>;
export type ImportStoreIncidentsMutationResult = Apollo.MutationResult<ImportStoreIncidentsMutation>;
export type ImportStoreIncidentsMutationOptions = Apollo.BaseMutationOptions<ImportStoreIncidentsMutation, ImportStoreIncidentsMutationVariables>;
export const ImportParseCoIsDocument = gql`
    mutation importParseCOIs($link: String!) {
  importParseCOIs(link: $link) {
    ...ImportCOIFields
  }
}
    ${ImportCoiFieldsFragmentDoc}`;
export type ImportParseCoIsMutationFn = Apollo.MutationFunction<ImportParseCoIsMutation, ImportParseCoIsMutationVariables>;

/**
 * __useImportParseCoIsMutation__
 *
 * To run a mutation, you first call `useImportParseCoIsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportParseCoIsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importParseCoIsMutation, { data, loading, error }] = useImportParseCoIsMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportParseCoIsMutation(baseOptions?: Apollo.MutationHookOptions<ImportParseCoIsMutation, ImportParseCoIsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportParseCoIsMutation, ImportParseCoIsMutationVariables>(ImportParseCoIsDocument, options);
      }
export type ImportParseCoIsMutationHookResult = ReturnType<typeof useImportParseCoIsMutation>;
export type ImportParseCoIsMutationResult = Apollo.MutationResult<ImportParseCoIsMutation>;
export type ImportParseCoIsMutationOptions = Apollo.BaseMutationOptions<ImportParseCoIsMutation, ImportParseCoIsMutationVariables>;
export const ImportStoreCoIsDocument = gql`
    mutation importStoreCOIs($data: [ImportCOIInput!]!, $skipNotValid: Boolean! = false) {
  importStoreCOIs(input: $data, skipNotValid: $skipNotValid) {
    ...ImportCOIFields
  }
}
    ${ImportCoiFieldsFragmentDoc}`;
export type ImportStoreCoIsMutationFn = Apollo.MutationFunction<ImportStoreCoIsMutation, ImportStoreCoIsMutationVariables>;

/**
 * __useImportStoreCoIsMutation__
 *
 * To run a mutation, you first call `useImportStoreCoIsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportStoreCoIsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importStoreCoIsMutation, { data, loading, error }] = useImportStoreCoIsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      skipNotValid: // value for 'skipNotValid'
 *   },
 * });
 */
export function useImportStoreCoIsMutation(baseOptions?: Apollo.MutationHookOptions<ImportStoreCoIsMutation, ImportStoreCoIsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportStoreCoIsMutation, ImportStoreCoIsMutationVariables>(ImportStoreCoIsDocument, options);
      }
export type ImportStoreCoIsMutationHookResult = ReturnType<typeof useImportStoreCoIsMutation>;
export type ImportStoreCoIsMutationResult = Apollo.MutationResult<ImportStoreCoIsMutation>;
export type ImportStoreCoIsMutationOptions = Apollo.BaseMutationOptions<ImportStoreCoIsMutation, ImportStoreCoIsMutationVariables>;
export const CreateIncidentDocument = gql`
    mutation createIncident($data: IncidentInput!) {
  createIncident(input: $data) {
    id
  }
}
    `;
export type CreateIncidentMutationFn = Apollo.MutationFunction<CreateIncidentMutation, CreateIncidentMutationVariables>;

/**
 * __useCreateIncidentMutation__
 *
 * To run a mutation, you first call `useCreateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentMutation, { data, loading, error }] = useCreateIncidentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentMutation, CreateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentMutation, CreateIncidentMutationVariables>(CreateIncidentDocument, options);
      }
export type CreateIncidentMutationHookResult = ReturnType<typeof useCreateIncidentMutation>;
export type CreateIncidentMutationResult = Apollo.MutationResult<CreateIncidentMutation>;
export type CreateIncidentMutationOptions = Apollo.BaseMutationOptions<CreateIncidentMutation, CreateIncidentMutationVariables>;
export const UpdateIncidentDocument = gql`
    mutation updateIncident($id: String!, $data: IncidentUpdateInput!) {
  updateIncident(incidentId: $id, input: $data) {
    ...IncidentFields
  }
}
    ${IncidentFieldsFragmentDoc}`;
export type UpdateIncidentMutationFn = Apollo.MutationFunction<UpdateIncidentMutation, UpdateIncidentMutationVariables>;

/**
 * __useUpdateIncidentMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentMutation, { data, loading, error }] = useUpdateIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentMutation, UpdateIncidentMutationVariables>(UpdateIncidentDocument, options);
      }
export type UpdateIncidentMutationHookResult = ReturnType<typeof useUpdateIncidentMutation>;
export type UpdateIncidentMutationResult = Apollo.MutationResult<UpdateIncidentMutation>;
export type UpdateIncidentMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>;
export const BulkStatusIncidentsDocument = gql`
    mutation bulkStatusIncidents($ids: [String!]!, $statusId: String) {
  bulkStatusIncidents(ids: $ids, statusId: $statusId) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status {
        ...StatusCoreFields
        color
      }
    }
  }
}
    ${StatusCoreFieldsFragmentDoc}`;
export type BulkStatusIncidentsMutationFn = Apollo.MutationFunction<BulkStatusIncidentsMutation, BulkStatusIncidentsMutationVariables>;

/**
 * __useBulkStatusIncidentsMutation__
 *
 * To run a mutation, you first call `useBulkStatusIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusIncidentsMutation, { data, loading, error }] = useBulkStatusIncidentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useBulkStatusIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusIncidentsMutation, BulkStatusIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusIncidentsMutation, BulkStatusIncidentsMutationVariables>(BulkStatusIncidentsDocument, options);
      }
export type BulkStatusIncidentsMutationHookResult = ReturnType<typeof useBulkStatusIncidentsMutation>;
export type BulkStatusIncidentsMutationResult = Apollo.MutationResult<BulkStatusIncidentsMutation>;
export type BulkStatusIncidentsMutationOptions = Apollo.BaseMutationOptions<BulkStatusIncidentsMutation, BulkStatusIncidentsMutationVariables>;
export const ArchiveIncidentsDocument = gql`
    mutation archiveIncidents($ids: [String!]!) {
  archiveIncidents(ids: $ids)
}
    `;
export type ArchiveIncidentsMutationFn = Apollo.MutationFunction<ArchiveIncidentsMutation, ArchiveIncidentsMutationVariables>;

/**
 * __useArchiveIncidentsMutation__
 *
 * To run a mutation, you first call `useArchiveIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveIncidentsMutation, { data, loading, error }] = useArchiveIncidentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveIncidentsMutation, ArchiveIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveIncidentsMutation, ArchiveIncidentsMutationVariables>(ArchiveIncidentsDocument, options);
      }
export type ArchiveIncidentsMutationHookResult = ReturnType<typeof useArchiveIncidentsMutation>;
export type ArchiveIncidentsMutationResult = Apollo.MutationResult<ArchiveIncidentsMutation>;
export type ArchiveIncidentsMutationOptions = Apollo.BaseMutationOptions<ArchiveIncidentsMutation, ArchiveIncidentsMutationVariables>;
export const UnArchiveIncidentsDocument = gql`
    mutation unArchiveIncidents($ids: [String!]!) {
  unArchiveIncidents(ids: $ids)
}
    `;
export type UnArchiveIncidentsMutationFn = Apollo.MutationFunction<UnArchiveIncidentsMutation, UnArchiveIncidentsMutationVariables>;

/**
 * __useUnArchiveIncidentsMutation__
 *
 * To run a mutation, you first call `useUnArchiveIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveIncidentsMutation, { data, loading, error }] = useUnArchiveIncidentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnArchiveIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveIncidentsMutation, UnArchiveIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveIncidentsMutation, UnArchiveIncidentsMutationVariables>(UnArchiveIncidentsDocument, options);
      }
export type UnArchiveIncidentsMutationHookResult = ReturnType<typeof useUnArchiveIncidentsMutation>;
export type UnArchiveIncidentsMutationResult = Apollo.MutationResult<UnArchiveIncidentsMutation>;
export type UnArchiveIncidentsMutationOptions = Apollo.BaseMutationOptions<UnArchiveIncidentsMutation, UnArchiveIncidentsMutationVariables>;
export const RemoveIncidentsDocument = gql`
    mutation removeIncidents($data: DeleteRecordsInput!) {
  removeIncidents(input: $data)
}
    `;
export type RemoveIncidentsMutationFn = Apollo.MutationFunction<RemoveIncidentsMutation, RemoveIncidentsMutationVariables>;

/**
 * __useRemoveIncidentsMutation__
 *
 * To run a mutation, you first call `useRemoveIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIncidentsMutation, { data, loading, error }] = useRemoveIncidentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIncidentsMutation, RemoveIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIncidentsMutation, RemoveIncidentsMutationVariables>(RemoveIncidentsDocument, options);
      }
export type RemoveIncidentsMutationHookResult = ReturnType<typeof useRemoveIncidentsMutation>;
export type RemoveIncidentsMutationResult = Apollo.MutationResult<RemoveIncidentsMutation>;
export type RemoveIncidentsMutationOptions = Apollo.BaseMutationOptions<RemoveIncidentsMutation, RemoveIncidentsMutationVariables>;
export const IncidentSubscribeDocument = gql`
    mutation incidentSubscribe($id: String!, $userId: String!) {
  incidentSubscribe(id: $id, userId: $userId) {
    id
    firstName
    lastName
  }
}
    `;
export type IncidentSubscribeMutationFn = Apollo.MutationFunction<IncidentSubscribeMutation, IncidentSubscribeMutationVariables>;

/**
 * __useIncidentSubscribeMutation__
 *
 * To run a mutation, you first call `useIncidentSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncidentSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incidentSubscribeMutation, { data, loading, error }] = useIncidentSubscribeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useIncidentSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<IncidentSubscribeMutation, IncidentSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncidentSubscribeMutation, IncidentSubscribeMutationVariables>(IncidentSubscribeDocument, options);
      }
export type IncidentSubscribeMutationHookResult = ReturnType<typeof useIncidentSubscribeMutation>;
export type IncidentSubscribeMutationResult = Apollo.MutationResult<IncidentSubscribeMutation>;
export type IncidentSubscribeMutationOptions = Apollo.BaseMutationOptions<IncidentSubscribeMutation, IncidentSubscribeMutationVariables>;
export const ShareIncidentDocument = gql`
    mutation shareIncident($data: IncidentShareInput!) {
  shareIncident(input: $data)
}
    `;
export type ShareIncidentMutationFn = Apollo.MutationFunction<ShareIncidentMutation, ShareIncidentMutationVariables>;

/**
 * __useShareIncidentMutation__
 *
 * To run a mutation, you first call `useShareIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareIncidentMutation, { data, loading, error }] = useShareIncidentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useShareIncidentMutation(baseOptions?: Apollo.MutationHookOptions<ShareIncidentMutation, ShareIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareIncidentMutation, ShareIncidentMutationVariables>(ShareIncidentDocument, options);
      }
export type ShareIncidentMutationHookResult = ReturnType<typeof useShareIncidentMutation>;
export type ShareIncidentMutationResult = Apollo.MutationResult<ShareIncidentMutation>;
export type ShareIncidentMutationOptions = Apollo.BaseMutationOptions<ShareIncidentMutation, ShareIncidentMutationVariables>;
export const DeleteIncidentAttachmentDocument = gql`
    mutation deleteIncidentAttachment($attachmentId: String!, $id: String!) {
  deleteIncidentAttachment(attachmentId: $attachmentId, incidentId: $id)
}
    `;
export type DeleteIncidentAttachmentMutationFn = Apollo.MutationFunction<DeleteIncidentAttachmentMutation, DeleteIncidentAttachmentMutationVariables>;

/**
 * __useDeleteIncidentAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteIncidentAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncidentAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncidentAttachmentMutation, { data, loading, error }] = useDeleteIncidentAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIncidentAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncidentAttachmentMutation, DeleteIncidentAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncidentAttachmentMutation, DeleteIncidentAttachmentMutationVariables>(DeleteIncidentAttachmentDocument, options);
      }
export type DeleteIncidentAttachmentMutationHookResult = ReturnType<typeof useDeleteIncidentAttachmentMutation>;
export type DeleteIncidentAttachmentMutationResult = Apollo.MutationResult<DeleteIncidentAttachmentMutation>;
export type DeleteIncidentAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteIncidentAttachmentMutation, DeleteIncidentAttachmentMutationVariables>;
export const UpdateIncidentCustomFieldDocument = gql`
    mutation updateIncidentCustomField($id: String!, $value: CustomFieldScalar) {
  updateIncidentCustomField(id: $id, value: $value) {
    id
    value
    customField {
      ...CustomFieldFields
    }
  }
}
    ${CustomFieldFieldsFragmentDoc}`;
export type UpdateIncidentCustomFieldMutationFn = Apollo.MutationFunction<UpdateIncidentCustomFieldMutation, UpdateIncidentCustomFieldMutationVariables>;

/**
 * __useUpdateIncidentCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentCustomFieldMutation, { data, loading, error }] = useUpdateIncidentCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateIncidentCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentCustomFieldMutation, UpdateIncidentCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentCustomFieldMutation, UpdateIncidentCustomFieldMutationVariables>(UpdateIncidentCustomFieldDocument, options);
      }
export type UpdateIncidentCustomFieldMutationHookResult = ReturnType<typeof useUpdateIncidentCustomFieldMutation>;
export type UpdateIncidentCustomFieldMutationResult = Apollo.MutationResult<UpdateIncidentCustomFieldMutation>;
export type UpdateIncidentCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentCustomFieldMutation, UpdateIncidentCustomFieldMutationVariables>;
export const GetIncidentsDocument = gql`
    query getIncidents($take: Int! = 10, $after: String, $before: String, $search: String, $statusIds: [String!], $buildingIds: [String!], $to: DateTime, $from: DateTime, $categoryIds: [String!], $companyIds: [String!], $suiteIds: [String!], $requestedForIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED) {
  getIncidents(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    statusIds: $statusIds
    to: $to
    from: $from
    categoryIds: $categoryIds
    companyIds: $companyIds
    suiteIds: $suiteIds
    requestedForIds: $requestedForIds
    archived: $archived
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      isArchived
      building {
        ...BuildingCoreFields
      }
      category {
        ...CategoryCoreFields
      }
      status {
        ...StatusCoreFields
        color
      }
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      description
      createdAt
      startDate
      timezone
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetIncidentsQuery__
 *
 * To run a query within a React component, call `useGetIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      statusIds: // value for 'statusIds'
 *      buildingIds: // value for 'buildingIds'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *      suiteIds: // value for 'suiteIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<GetIncidentsQuery, GetIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentsQuery, GetIncidentsQueryVariables>(GetIncidentsDocument, options);
      }
export function useGetIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentsQuery, GetIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentsQuery, GetIncidentsQueryVariables>(GetIncidentsDocument, options);
        }
export type GetIncidentsQueryHookResult = ReturnType<typeof useGetIncidentsQuery>;
export type GetIncidentsLazyQueryHookResult = ReturnType<typeof useGetIncidentsLazyQuery>;
export type GetIncidentsQueryResult = Apollo.QueryResult<GetIncidentsQuery, GetIncidentsQueryVariables>;
export const GetIncidentDocument = gql`
    query getIncident($id: String!) {
  getIncident(incidentId: $id) {
    ...IncidentFields
  }
}
    ${IncidentFieldsFragmentDoc}`;

/**
 * __useGetIncidentQuery__
 *
 * To run a query within a React component, call `useGetIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIncidentQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
      }
export function useGetIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
        }
export type GetIncidentQueryHookResult = ReturnType<typeof useGetIncidentQuery>;
export type GetIncidentLazyQueryHookResult = ReturnType<typeof useGetIncidentLazyQuery>;
export type GetIncidentQueryResult = Apollo.QueryResult<GetIncidentQuery, GetIncidentQueryVariables>;
export const ExportIncidentsDocument = gql`
    query exportIncidents($search: String, $to: DateTime, $from: DateTime, $buildingIds: [String!], $categoryIds: [String!], $companyIds: [String!], $statusIds: [String!], $requestedForIds: [String!], $suiteIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED) {
  exportIncidents(
    search: $search
    to: $to
    from: $from
    buildingIds: $buildingIds
    categoryIds: $categoryIds
    companyIds: $companyIds
    statusIds: $statusIds
    requestedForIds: $requestedForIds
    suiteIds: $suiteIds
    archived: $archived
  )
}
    `;

/**
 * __useExportIncidentsQuery__
 *
 * To run a query within a React component, call `useExportIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportIncidentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      buildingIds: // value for 'buildingIds'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *      statusIds: // value for 'statusIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      suiteIds: // value for 'suiteIds'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useExportIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<ExportIncidentsQuery, ExportIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportIncidentsQuery, ExportIncidentsQueryVariables>(ExportIncidentsDocument, options);
      }
export function useExportIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportIncidentsQuery, ExportIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportIncidentsQuery, ExportIncidentsQueryVariables>(ExportIncidentsDocument, options);
        }
export type ExportIncidentsQueryHookResult = ReturnType<typeof useExportIncidentsQuery>;
export type ExportIncidentsLazyQueryHookResult = ReturnType<typeof useExportIncidentsLazyQuery>;
export type ExportIncidentsQueryResult = Apollo.QueryResult<ExportIncidentsQuery, ExportIncidentsQueryVariables>;
export const StoreIntegrationDocument = gql`
    mutation storeIntegration($data: PropertyIntegrationInput!) {
  storeIntegration(input: $data)
}
    `;
export type StoreIntegrationMutationFn = Apollo.MutationFunction<StoreIntegrationMutation, StoreIntegrationMutationVariables>;

/**
 * __useStoreIntegrationMutation__
 *
 * To run a mutation, you first call `useStoreIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeIntegrationMutation, { data, loading, error }] = useStoreIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStoreIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<StoreIntegrationMutation, StoreIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreIntegrationMutation, StoreIntegrationMutationVariables>(StoreIntegrationDocument, options);
      }
export type StoreIntegrationMutationHookResult = ReturnType<typeof useStoreIntegrationMutation>;
export type StoreIntegrationMutationResult = Apollo.MutationResult<StoreIntegrationMutation>;
export type StoreIntegrationMutationOptions = Apollo.BaseMutationOptions<StoreIntegrationMutation, StoreIntegrationMutationVariables>;
export const TestIntegrationDocument = gql`
    mutation testIntegration($data: PropertyIntegrationInput!) {
  testIntegration(input: $data) {
    successful
  }
}
    `;
export type TestIntegrationMutationFn = Apollo.MutationFunction<TestIntegrationMutation, TestIntegrationMutationVariables>;

/**
 * __useTestIntegrationMutation__
 *
 * To run a mutation, you first call `useTestIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testIntegrationMutation, { data, loading, error }] = useTestIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTestIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<TestIntegrationMutation, TestIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestIntegrationMutation, TestIntegrationMutationVariables>(TestIntegrationDocument, options);
      }
export type TestIntegrationMutationHookResult = ReturnType<typeof useTestIntegrationMutation>;
export type TestIntegrationMutationResult = Apollo.MutationResult<TestIntegrationMutation>;
export type TestIntegrationMutationOptions = Apollo.BaseMutationOptions<TestIntegrationMutation, TestIntegrationMutationVariables>;
export const ToggleIntegrationDocument = gql`
    mutation toggleIntegration($data: TogglePropertyIntegrationInput!) {
  toggleIntegration(input: $data)
}
    `;
export type ToggleIntegrationMutationFn = Apollo.MutationFunction<ToggleIntegrationMutation, ToggleIntegrationMutationVariables>;

/**
 * __useToggleIntegrationMutation__
 *
 * To run a mutation, you first call `useToggleIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIntegrationMutation, { data, loading, error }] = useToggleIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleIntegrationMutation, ToggleIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleIntegrationMutation, ToggleIntegrationMutationVariables>(ToggleIntegrationDocument, options);
      }
export type ToggleIntegrationMutationHookResult = ReturnType<typeof useToggleIntegrationMutation>;
export type ToggleIntegrationMutationResult = Apollo.MutationResult<ToggleIntegrationMutation>;
export type ToggleIntegrationMutationOptions = Apollo.BaseMutationOptions<ToggleIntegrationMutation, ToggleIntegrationMutationVariables>;
export const RemoveIntegrationDocument = gql`
    mutation removeIntegration($data: TogglePropertyIntegrationInput!) {
  removeIntegration(input: $data)
}
    `;
export type RemoveIntegrationMutationFn = Apollo.MutationFunction<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>;

/**
 * __useRemoveIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationMutation, { data, loading, error }] = useRemoveIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>(RemoveIntegrationDocument, options);
      }
export type RemoveIntegrationMutationHookResult = ReturnType<typeof useRemoveIntegrationMutation>;
export type RemoveIntegrationMutationResult = Apollo.MutationResult<RemoveIntegrationMutation>;
export type RemoveIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>;
export const GetIntegrationsDocument = gql`
    query getIntegrations {
  getIntegrations {
    hasIntegration
    status
    type
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetSingleIntegrationDocument = gql`
    query getSingleIntegration($type: IntegrationTypeEnum!) {
  getIntegration(type: $type) {
    ...SetupIntegrationFields
  }
}
    ${SetupIntegrationFieldsFragmentDoc}`;

/**
 * __useGetSingleIntegrationQuery__
 *
 * To run a query within a React component, call `useGetSingleIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleIntegrationQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSingleIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetSingleIntegrationQuery, GetSingleIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleIntegrationQuery, GetSingleIntegrationQueryVariables>(GetSingleIntegrationDocument, options);
      }
export function useGetSingleIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleIntegrationQuery, GetSingleIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleIntegrationQuery, GetSingleIntegrationQueryVariables>(GetSingleIntegrationDocument, options);
        }
export type GetSingleIntegrationQueryHookResult = ReturnType<typeof useGetSingleIntegrationQuery>;
export type GetSingleIntegrationLazyQueryHookResult = ReturnType<typeof useGetSingleIntegrationLazyQuery>;
export type GetSingleIntegrationQueryResult = Apollo.QueryResult<GetSingleIntegrationQuery, GetSingleIntegrationQueryVariables>;
export const GetPublicIntegrationDocument = gql`
    query getPublicIntegration($type: IntegrationTypeEnum!) {
  getPublicIntegration(type: $type) {
    ...SetupIntegrationFields
  }
}
    ${SetupIntegrationFieldsFragmentDoc}`;

/**
 * __useGetPublicIntegrationQuery__
 *
 * To run a query within a React component, call `useGetPublicIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicIntegrationQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPublicIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetPublicIntegrationQuery, GetPublicIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicIntegrationQuery, GetPublicIntegrationQueryVariables>(GetPublicIntegrationDocument, options);
      }
export function useGetPublicIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicIntegrationQuery, GetPublicIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicIntegrationQuery, GetPublicIntegrationQueryVariables>(GetPublicIntegrationDocument, options);
        }
export type GetPublicIntegrationQueryHookResult = ReturnType<typeof useGetPublicIntegrationQuery>;
export type GetPublicIntegrationLazyQueryHookResult = ReturnType<typeof useGetPublicIntegrationLazyQuery>;
export type GetPublicIntegrationQueryResult = Apollo.QueryResult<GetPublicIntegrationQuery, GetPublicIntegrationQueryVariables>;
export const CreateInvoiceChargeDocument = gql`
    mutation createInvoiceCharge($id: String!, $data: InvoiceChargeInputData!) {
  createInvoiceCharge(id: $id, input: $data) {
    id
  }
}
    `;
export type CreateInvoiceChargeMutationFn = Apollo.MutationFunction<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>;

/**
 * __useCreateInvoiceChargeMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceChargeMutation, { data, loading, error }] = useCreateInvoiceChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInvoiceChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>(CreateInvoiceChargeDocument, options);
      }
export type CreateInvoiceChargeMutationHookResult = ReturnType<typeof useCreateInvoiceChargeMutation>;
export type CreateInvoiceChargeMutationResult = Apollo.MutationResult<CreateInvoiceChargeMutation>;
export type CreateInvoiceChargeMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>;
export const AddInvoiceChargesDocument = gql`
    mutation addInvoiceCharges($id: String!, $chargeIds: [String!]!) {
  addInvoiceCharges(id: $id, chargeIds: $chargeIds)
}
    `;
export type AddInvoiceChargesMutationFn = Apollo.MutationFunction<AddInvoiceChargesMutation, AddInvoiceChargesMutationVariables>;

/**
 * __useAddInvoiceChargesMutation__
 *
 * To run a mutation, you first call `useAddInvoiceChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvoiceChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvoiceChargesMutation, { data, loading, error }] = useAddInvoiceChargesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chargeIds: // value for 'chargeIds'
 *   },
 * });
 */
export function useAddInvoiceChargesMutation(baseOptions?: Apollo.MutationHookOptions<AddInvoiceChargesMutation, AddInvoiceChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvoiceChargesMutation, AddInvoiceChargesMutationVariables>(AddInvoiceChargesDocument, options);
      }
export type AddInvoiceChargesMutationHookResult = ReturnType<typeof useAddInvoiceChargesMutation>;
export type AddInvoiceChargesMutationResult = Apollo.MutationResult<AddInvoiceChargesMutation>;
export type AddInvoiceChargesMutationOptions = Apollo.BaseMutationOptions<AddInvoiceChargesMutation, AddInvoiceChargesMutationVariables>;
export const UpdateInvoiceChargeDocument = gql`
    mutation updateInvoiceCharge($id: String!, $data: InvoiceChargeInputData!, $updateParent: Boolean! = false) {
  updateInvoiceCharge(id: $id, input: $data, updateParent: $updateParent) {
    ...InvoiceChargeFields
  }
}
    ${InvoiceChargeFieldsFragmentDoc}`;
export type UpdateInvoiceChargeMutationFn = Apollo.MutationFunction<UpdateInvoiceChargeMutation, UpdateInvoiceChargeMutationVariables>;

/**
 * __useUpdateInvoiceChargeMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceChargeMutation, { data, loading, error }] = useUpdateInvoiceChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      updateParent: // value for 'updateParent'
 *   },
 * });
 */
export function useUpdateInvoiceChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceChargeMutation, UpdateInvoiceChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceChargeMutation, UpdateInvoiceChargeMutationVariables>(UpdateInvoiceChargeDocument, options);
      }
export type UpdateInvoiceChargeMutationHookResult = ReturnType<typeof useUpdateInvoiceChargeMutation>;
export type UpdateInvoiceChargeMutationResult = Apollo.MutationResult<UpdateInvoiceChargeMutation>;
export type UpdateInvoiceChargeMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceChargeMutation, UpdateInvoiceChargeMutationVariables>;
export const RemoveInvoiceChargesDocument = gql`
    mutation removeInvoiceCharges($data: DeleteRecordsInput!) {
  removeInvoiceCharges(input: $data)
}
    `;
export type RemoveInvoiceChargesMutationFn = Apollo.MutationFunction<RemoveInvoiceChargesMutation, RemoveInvoiceChargesMutationVariables>;

/**
 * __useRemoveInvoiceChargesMutation__
 *
 * To run a mutation, you first call `useRemoveInvoiceChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvoiceChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvoiceChargesMutation, { data, loading, error }] = useRemoveInvoiceChargesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveInvoiceChargesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvoiceChargesMutation, RemoveInvoiceChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvoiceChargesMutation, RemoveInvoiceChargesMutationVariables>(RemoveInvoiceChargesDocument, options);
      }
export type RemoveInvoiceChargesMutationHookResult = ReturnType<typeof useRemoveInvoiceChargesMutation>;
export type RemoveInvoiceChargesMutationResult = Apollo.MutationResult<RemoveInvoiceChargesMutation>;
export type RemoveInvoiceChargesMutationOptions = Apollo.BaseMutationOptions<RemoveInvoiceChargesMutation, RemoveInvoiceChargesMutationVariables>;
export const GetInvoiceChargesDocument = gql`
    query getInvoiceCharges($id: String!) {
  getInvoiceCharges(id: $id) {
    id
    type
    date
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
    feature {
      id
      index
      type
      title
    }
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetInvoiceChargesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceChargesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceChargesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceChargesQuery, GetInvoiceChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceChargesQuery, GetInvoiceChargesQueryVariables>(GetInvoiceChargesDocument, options);
      }
export function useGetInvoiceChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceChargesQuery, GetInvoiceChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceChargesQuery, GetInvoiceChargesQueryVariables>(GetInvoiceChargesDocument, options);
        }
export type GetInvoiceChargesQueryHookResult = ReturnType<typeof useGetInvoiceChargesQuery>;
export type GetInvoiceChargesLazyQueryHookResult = ReturnType<typeof useGetInvoiceChargesLazyQuery>;
export type GetInvoiceChargesQueryResult = Apollo.QueryResult<GetInvoiceChargesQuery, GetInvoiceChargesQueryVariables>;
export const SearchInvoiceChargesDocument = gql`
    query searchInvoiceCharges($invoiceId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $from: DateTime, $to: DateTime) {
  searchInvoiceCharges(
    invoiceId: $invoiceId
    take: $take
    after: $after
    before: $before
    search: $search
    from: $from
    to: $to
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      type
      date
      employeeUser {
        ...UserCoreFields
      }
      hours
      material {
        ...MaterialCoreFields
      }
      notes
      total
      feature {
        id
        index
        type
        title
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useSearchInvoiceChargesQuery__
 *
 * To run a query within a React component, call `useSearchInvoiceChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvoiceChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvoiceChargesQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSearchInvoiceChargesQuery(baseOptions: Apollo.QueryHookOptions<SearchInvoiceChargesQuery, SearchInvoiceChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInvoiceChargesQuery, SearchInvoiceChargesQueryVariables>(SearchInvoiceChargesDocument, options);
      }
export function useSearchInvoiceChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInvoiceChargesQuery, SearchInvoiceChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInvoiceChargesQuery, SearchInvoiceChargesQueryVariables>(SearchInvoiceChargesDocument, options);
        }
export type SearchInvoiceChargesQueryHookResult = ReturnType<typeof useSearchInvoiceChargesQuery>;
export type SearchInvoiceChargesLazyQueryHookResult = ReturnType<typeof useSearchInvoiceChargesLazyQuery>;
export type SearchInvoiceChargesQueryResult = Apollo.QueryResult<SearchInvoiceChargesQuery, SearchInvoiceChargesQueryVariables>;
export const GetInvoiceChargeDocument = gql`
    query getInvoiceCharge($id: String!) {
  getInvoiceCharge(id: $id) {
    ...InvoiceChargeFields
  }
}
    ${InvoiceChargeFieldsFragmentDoc}`;

/**
 * __useGetInvoiceChargeQuery__
 *
 * To run a query within a React component, call `useGetInvoiceChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceChargeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceChargeQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceChargeQuery, GetInvoiceChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceChargeQuery, GetInvoiceChargeQueryVariables>(GetInvoiceChargeDocument, options);
      }
export function useGetInvoiceChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceChargeQuery, GetInvoiceChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceChargeQuery, GetInvoiceChargeQueryVariables>(GetInvoiceChargeDocument, options);
        }
export type GetInvoiceChargeQueryHookResult = ReturnType<typeof useGetInvoiceChargeQuery>;
export type GetInvoiceChargeLazyQueryHookResult = ReturnType<typeof useGetInvoiceChargeLazyQuery>;
export type GetInvoiceChargeQueryResult = Apollo.QueryResult<GetInvoiceChargeQuery, GetInvoiceChargeQueryVariables>;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($data: InvoiceInput!) {
  createInvoice(input: $data) {
    id
  }
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation updateInvoice($id: String!, $data: InvoiceUpdateInput!) {
  updateInvoice(id: $id, input: $data) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const ShareInvoiceDocument = gql`
    mutation shareInvoice($id: String!, $emails: [String!]!) {
  shareInvoice(id: $id, emails: $emails)
}
    `;
export type ShareInvoiceMutationFn = Apollo.MutationFunction<ShareInvoiceMutation, ShareInvoiceMutationVariables>;

/**
 * __useShareInvoiceMutation__
 *
 * To run a mutation, you first call `useShareInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareInvoiceMutation, { data, loading, error }] = useShareInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useShareInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ShareInvoiceMutation, ShareInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareInvoiceMutation, ShareInvoiceMutationVariables>(ShareInvoiceDocument, options);
      }
export type ShareInvoiceMutationHookResult = ReturnType<typeof useShareInvoiceMutation>;
export type ShareInvoiceMutationResult = Apollo.MutationResult<ShareInvoiceMutation>;
export type ShareInvoiceMutationOptions = Apollo.BaseMutationOptions<ShareInvoiceMutation, ShareInvoiceMutationVariables>;
export const SendInvoiceDocument = gql`
    mutation sendInvoice($id: String!, $subject: String, $body: String) {
  sendInvoice(id: $id, subject: $subject, body: $body)
}
    `;
export type SendInvoiceMutationFn = Apollo.MutationFunction<SendInvoiceMutation, SendInvoiceMutationVariables>;

/**
 * __useSendInvoiceMutation__
 *
 * To run a mutation, you first call `useSendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceMutation, { data, loading, error }] = useSendInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceMutation, SendInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceMutation, SendInvoiceMutationVariables>(SendInvoiceDocument, options);
      }
export type SendInvoiceMutationHookResult = ReturnType<typeof useSendInvoiceMutation>;
export type SendInvoiceMutationResult = Apollo.MutationResult<SendInvoiceMutation>;
export type SendInvoiceMutationOptions = Apollo.BaseMutationOptions<SendInvoiceMutation, SendInvoiceMutationVariables>;
export const InvoicePayDocument = gql`
    mutation invoicePay($data: InvoicePaymentInput!) {
  invoicePay(input: $data)
}
    `;
export type InvoicePayMutationFn = Apollo.MutationFunction<InvoicePayMutation, InvoicePayMutationVariables>;

/**
 * __useInvoicePayMutation__
 *
 * To run a mutation, you first call `useInvoicePayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePayMutation, { data, loading, error }] = useInvoicePayMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInvoicePayMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePayMutation, InvoicePayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePayMutation, InvoicePayMutationVariables>(InvoicePayDocument, options);
      }
export type InvoicePayMutationHookResult = ReturnType<typeof useInvoicePayMutation>;
export type InvoicePayMutationResult = Apollo.MutationResult<InvoicePayMutation>;
export type InvoicePayMutationOptions = Apollo.BaseMutationOptions<InvoicePayMutation, InvoicePayMutationVariables>;
export const AddInvoiceAttachmentsDocument = gql`
    mutation addInvoiceAttachments($id: String!, $attachments: [FileObjectInput!]!) {
  addInvoiceAttachments(id: $id, attachments: $attachments) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type AddInvoiceAttachmentsMutationFn = Apollo.MutationFunction<AddInvoiceAttachmentsMutation, AddInvoiceAttachmentsMutationVariables>;

/**
 * __useAddInvoiceAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddInvoiceAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvoiceAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvoiceAttachmentsMutation, { data, loading, error }] = useAddInvoiceAttachmentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddInvoiceAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddInvoiceAttachmentsMutation, AddInvoiceAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvoiceAttachmentsMutation, AddInvoiceAttachmentsMutationVariables>(AddInvoiceAttachmentsDocument, options);
      }
export type AddInvoiceAttachmentsMutationHookResult = ReturnType<typeof useAddInvoiceAttachmentsMutation>;
export type AddInvoiceAttachmentsMutationResult = Apollo.MutationResult<AddInvoiceAttachmentsMutation>;
export type AddInvoiceAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddInvoiceAttachmentsMutation, AddInvoiceAttachmentsMutationVariables>;
export const RemoveInvoiceAttachmentDocument = gql`
    mutation removeInvoiceAttachment($id: String!, $attachmentId: String!) {
  removeInvoiceAttachment(id: $id, attachmentId: $attachmentId) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type RemoveInvoiceAttachmentMutationFn = Apollo.MutationFunction<RemoveInvoiceAttachmentMutation, RemoveInvoiceAttachmentMutationVariables>;

/**
 * __useRemoveInvoiceAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveInvoiceAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvoiceAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvoiceAttachmentMutation, { data, loading, error }] = useRemoveInvoiceAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveInvoiceAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvoiceAttachmentMutation, RemoveInvoiceAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvoiceAttachmentMutation, RemoveInvoiceAttachmentMutationVariables>(RemoveInvoiceAttachmentDocument, options);
      }
export type RemoveInvoiceAttachmentMutationHookResult = ReturnType<typeof useRemoveInvoiceAttachmentMutation>;
export type RemoveInvoiceAttachmentMutationResult = Apollo.MutationResult<RemoveInvoiceAttachmentMutation>;
export type RemoveInvoiceAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveInvoiceAttachmentMutation, RemoveInvoiceAttachmentMutationVariables>;
export const DeactivateInvoicesDocument = gql`
    mutation deactivateInvoices($data: DeleteRecordsInput!) {
  deactivateInvoices(input: $data)
}
    `;
export type DeactivateInvoicesMutationFn = Apollo.MutationFunction<DeactivateInvoicesMutation, DeactivateInvoicesMutationVariables>;

/**
 * __useDeactivateInvoicesMutation__
 *
 * To run a mutation, you first call `useDeactivateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateInvoicesMutation, { data, loading, error }] = useDeactivateInvoicesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeactivateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateInvoicesMutation, DeactivateInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateInvoicesMutation, DeactivateInvoicesMutationVariables>(DeactivateInvoicesDocument, options);
      }
export type DeactivateInvoicesMutationHookResult = ReturnType<typeof useDeactivateInvoicesMutation>;
export type DeactivateInvoicesMutationResult = Apollo.MutationResult<DeactivateInvoicesMutation>;
export type DeactivateInvoicesMutationOptions = Apollo.BaseMutationOptions<DeactivateInvoicesMutation, DeactivateInvoicesMutationVariables>;
export const ActivateInvoicesDocument = gql`
    mutation activateInvoices($data: DeleteRecordsInput!) {
  activateInvoices(input: $data)
}
    `;
export type ActivateInvoicesMutationFn = Apollo.MutationFunction<ActivateInvoicesMutation, ActivateInvoicesMutationVariables>;

/**
 * __useActivateInvoicesMutation__
 *
 * To run a mutation, you first call `useActivateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateInvoicesMutation, { data, loading, error }] = useActivateInvoicesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useActivateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ActivateInvoicesMutation, ActivateInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateInvoicesMutation, ActivateInvoicesMutationVariables>(ActivateInvoicesDocument, options);
      }
export type ActivateInvoicesMutationHookResult = ReturnType<typeof useActivateInvoicesMutation>;
export type ActivateInvoicesMutationResult = Apollo.MutationResult<ActivateInvoicesMutation>;
export type ActivateInvoicesMutationOptions = Apollo.BaseMutationOptions<ActivateInvoicesMutation, ActivateInvoicesMutationVariables>;
export const GetInvoicesDocument = gql`
    query getInvoices($take: Int! = 10, $after: String, $before: String, $search: String, $statuses: [InvoiceStatus!]) {
  getInvoices(
    take: $take
    after: $after
    before: $before
    search: $search
    statuses: $statuses
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      index
      id
      status
      invoiceDate
      dueDate
      lastSentAt
      totalAmount
      paidAmount
      company {
        ...CompanyCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceDocument = gql`
    query getInvoice($id: String!) {
  getInvoice(id: $id) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const InvoicePaymentRefundDocument = gql`
    mutation invoicePaymentRefund($amount: Float!, $id: String!) {
  invoicePaymentRefund(amount: $amount, id: $id) {
    ...InvoicePaymentFields
  }
}
    ${InvoicePaymentFieldsFragmentDoc}`;
export type InvoicePaymentRefundMutationFn = Apollo.MutationFunction<InvoicePaymentRefundMutation, InvoicePaymentRefundMutationVariables>;

/**
 * __useInvoicePaymentRefundMutation__
 *
 * To run a mutation, you first call `useInvoicePaymentRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePaymentRefundMutation, { data, loading, error }] = useInvoicePaymentRefundMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoicePaymentRefundMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePaymentRefundMutation, InvoicePaymentRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePaymentRefundMutation, InvoicePaymentRefundMutationVariables>(InvoicePaymentRefundDocument, options);
      }
export type InvoicePaymentRefundMutationHookResult = ReturnType<typeof useInvoicePaymentRefundMutation>;
export type InvoicePaymentRefundMutationResult = Apollo.MutationResult<InvoicePaymentRefundMutation>;
export type InvoicePaymentRefundMutationOptions = Apollo.BaseMutationOptions<InvoicePaymentRefundMutation, InvoicePaymentRefundMutationVariables>;
export const GetInvoicePaymentsDocument = gql`
    query getInvoicePayments($search: String, $invoiceId: String!) {
  getInvoicePayments(search: $search, invoiceId: $invoiceId) {
    ...InvoicePaymentFields
  }
}
    ${InvoicePaymentFieldsFragmentDoc}`;

/**
 * __useGetInvoicePaymentsQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentsQuery, GetInvoicePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentsQuery, GetInvoicePaymentsQueryVariables>(GetInvoicePaymentsDocument, options);
      }
export function useGetInvoicePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentsQuery, GetInvoicePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentsQuery, GetInvoicePaymentsQueryVariables>(GetInvoicePaymentsDocument, options);
        }
export type GetInvoicePaymentsQueryHookResult = ReturnType<typeof useGetInvoicePaymentsQuery>;
export type GetInvoicePaymentsLazyQueryHookResult = ReturnType<typeof useGetInvoicePaymentsLazyQuery>;
export type GetInvoicePaymentsQueryResult = Apollo.QueryResult<GetInvoicePaymentsQuery, GetInvoicePaymentsQueryVariables>;
export const GetInvoicePaymentDocument = gql`
    query getInvoicePayment($id: String!) {
  getInvoicePayment(id: $id) {
    ...InvoicePaymentFields
  }
}
    ${InvoicePaymentFieldsFragmentDoc}`;

/**
 * __useGetInvoicePaymentQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoicePaymentQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentQuery, GetInvoicePaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentQuery, GetInvoicePaymentQueryVariables>(GetInvoicePaymentDocument, options);
      }
export function useGetInvoicePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentQuery, GetInvoicePaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentQuery, GetInvoicePaymentQueryVariables>(GetInvoicePaymentDocument, options);
        }
export type GetInvoicePaymentQueryHookResult = ReturnType<typeof useGetInvoicePaymentQuery>;
export type GetInvoicePaymentLazyQueryHookResult = ReturnType<typeof useGetInvoicePaymentLazyQuery>;
export type GetInvoicePaymentQueryResult = Apollo.QueryResult<GetInvoicePaymentQuery, GetInvoicePaymentQueryVariables>;
export const AddRecurringInvoicePaymentDocument = gql`
    mutation addRecurringInvoicePayment($data: RecurringInvoicePaymentInput!) {
  addRecurringInvoicePayment(input: $data) {
    ...RecurringInvoicePaymentFields
  }
}
    ${RecurringInvoicePaymentFieldsFragmentDoc}`;
export type AddRecurringInvoicePaymentMutationFn = Apollo.MutationFunction<AddRecurringInvoicePaymentMutation, AddRecurringInvoicePaymentMutationVariables>;

/**
 * __useAddRecurringInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useAddRecurringInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecurringInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecurringInvoicePaymentMutation, { data, loading, error }] = useAddRecurringInvoicePaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddRecurringInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddRecurringInvoicePaymentMutation, AddRecurringInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecurringInvoicePaymentMutation, AddRecurringInvoicePaymentMutationVariables>(AddRecurringInvoicePaymentDocument, options);
      }
export type AddRecurringInvoicePaymentMutationHookResult = ReturnType<typeof useAddRecurringInvoicePaymentMutation>;
export type AddRecurringInvoicePaymentMutationResult = Apollo.MutationResult<AddRecurringInvoicePaymentMutation>;
export type AddRecurringInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<AddRecurringInvoicePaymentMutation, AddRecurringInvoicePaymentMutationVariables>;
export const RemoveRecurringInvoicePaymentDocument = gql`
    mutation removeRecurringInvoicePayment($id: String!) {
  removeRecurringInvoicePayment(id: $id)
}
    `;
export type RemoveRecurringInvoicePaymentMutationFn = Apollo.MutationFunction<RemoveRecurringInvoicePaymentMutation, RemoveRecurringInvoicePaymentMutationVariables>;

/**
 * __useRemoveRecurringInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useRemoveRecurringInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecurringInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecurringInvoicePaymentMutation, { data, loading, error }] = useRemoveRecurringInvoicePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRecurringInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRecurringInvoicePaymentMutation, RemoveRecurringInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRecurringInvoicePaymentMutation, RemoveRecurringInvoicePaymentMutationVariables>(RemoveRecurringInvoicePaymentDocument, options);
      }
export type RemoveRecurringInvoicePaymentMutationHookResult = ReturnType<typeof useRemoveRecurringInvoicePaymentMutation>;
export type RemoveRecurringInvoicePaymentMutationResult = Apollo.MutationResult<RemoveRecurringInvoicePaymentMutation>;
export type RemoveRecurringInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<RemoveRecurringInvoicePaymentMutation, RemoveRecurringInvoicePaymentMutationVariables>;
export const GetRecurringInvoicePaymentsDocument = gql`
    query getRecurringInvoicePayments($id: String!) {
  getRecurringInvoicePayments(id: $id) {
    ...RecurringInvoicePaymentFields
  }
}
    ${RecurringInvoicePaymentFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoicePaymentsQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoicePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoicePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoicePaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecurringInvoicePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringInvoicePaymentsQuery, GetRecurringInvoicePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoicePaymentsQuery, GetRecurringInvoicePaymentsQueryVariables>(GetRecurringInvoicePaymentsDocument, options);
      }
export function useGetRecurringInvoicePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoicePaymentsQuery, GetRecurringInvoicePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoicePaymentsQuery, GetRecurringInvoicePaymentsQueryVariables>(GetRecurringInvoicePaymentsDocument, options);
        }
export type GetRecurringInvoicePaymentsQueryHookResult = ReturnType<typeof useGetRecurringInvoicePaymentsQuery>;
export type GetRecurringInvoicePaymentsLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoicePaymentsLazyQuery>;
export type GetRecurringInvoicePaymentsQueryResult = Apollo.QueryResult<GetRecurringInvoicePaymentsQuery, GetRecurringInvoicePaymentsQueryVariables>;
export const CreateRecurringInvoiceDocument = gql`
    mutation createRecurringInvoice($data: RecurringInvoiceInput!) {
  createRecurringInvoice(input: $data) {
    id
  }
}
    `;
export type CreateRecurringInvoiceMutationFn = Apollo.MutationFunction<CreateRecurringInvoiceMutation, CreateRecurringInvoiceMutationVariables>;

/**
 * __useCreateRecurringInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateRecurringInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringInvoiceMutation, { data, loading, error }] = useCreateRecurringInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRecurringInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringInvoiceMutation, CreateRecurringInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringInvoiceMutation, CreateRecurringInvoiceMutationVariables>(CreateRecurringInvoiceDocument, options);
      }
export type CreateRecurringInvoiceMutationHookResult = ReturnType<typeof useCreateRecurringInvoiceMutation>;
export type CreateRecurringInvoiceMutationResult = Apollo.MutationResult<CreateRecurringInvoiceMutation>;
export type CreateRecurringInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateRecurringInvoiceMutation, CreateRecurringInvoiceMutationVariables>;
export const UpdateRecurringInvoiceDocument = gql`
    mutation updateRecurringInvoice($id: String!, $data: RecurringInvoiceUpdateInput!) {
  updateRecurringInvoice(id: $id, input: $data) {
    ...RecurringInvoiceFields
  }
}
    ${RecurringInvoiceFieldsFragmentDoc}`;
export type UpdateRecurringInvoiceMutationFn = Apollo.MutationFunction<UpdateRecurringInvoiceMutation, UpdateRecurringInvoiceMutationVariables>;

/**
 * __useUpdateRecurringInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringInvoiceMutation, { data, loading, error }] = useUpdateRecurringInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRecurringInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringInvoiceMutation, UpdateRecurringInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringInvoiceMutation, UpdateRecurringInvoiceMutationVariables>(UpdateRecurringInvoiceDocument, options);
      }
export type UpdateRecurringInvoiceMutationHookResult = ReturnType<typeof useUpdateRecurringInvoiceMutation>;
export type UpdateRecurringInvoiceMutationResult = Apollo.MutationResult<UpdateRecurringInvoiceMutation>;
export type UpdateRecurringInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringInvoiceMutation, UpdateRecurringInvoiceMutationVariables>;
export const UpdateRecurringInvoiceNextGenerationDateDocument = gql`
    mutation updateRecurringInvoiceNextGenerationDate($id: String!, $nextGenerationDate: DateTime!) {
  updateRecurringInvoiceNextGenerationDate(
    id: $id
    nextGenerationDate: $nextGenerationDate
  ) {
    id
    nextGenerationDate
  }
}
    `;
export type UpdateRecurringInvoiceNextGenerationDateMutationFn = Apollo.MutationFunction<UpdateRecurringInvoiceNextGenerationDateMutation, UpdateRecurringInvoiceNextGenerationDateMutationVariables>;

/**
 * __useUpdateRecurringInvoiceNextGenerationDateMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringInvoiceNextGenerationDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringInvoiceNextGenerationDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringInvoiceNextGenerationDateMutation, { data, loading, error }] = useUpdateRecurringInvoiceNextGenerationDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nextGenerationDate: // value for 'nextGenerationDate'
 *   },
 * });
 */
export function useUpdateRecurringInvoiceNextGenerationDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringInvoiceNextGenerationDateMutation, UpdateRecurringInvoiceNextGenerationDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringInvoiceNextGenerationDateMutation, UpdateRecurringInvoiceNextGenerationDateMutationVariables>(UpdateRecurringInvoiceNextGenerationDateDocument, options);
      }
export type UpdateRecurringInvoiceNextGenerationDateMutationHookResult = ReturnType<typeof useUpdateRecurringInvoiceNextGenerationDateMutation>;
export type UpdateRecurringInvoiceNextGenerationDateMutationResult = Apollo.MutationResult<UpdateRecurringInvoiceNextGenerationDateMutation>;
export type UpdateRecurringInvoiceNextGenerationDateMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringInvoiceNextGenerationDateMutation, UpdateRecurringInvoiceNextGenerationDateMutationVariables>;
export const RemoveRecurringInvoicesDocument = gql`
    mutation removeRecurringInvoices($data: DeleteRecordsInput!) {
  removeRecurringInvoices(input: $data)
}
    `;
export type RemoveRecurringInvoicesMutationFn = Apollo.MutationFunction<RemoveRecurringInvoicesMutation, RemoveRecurringInvoicesMutationVariables>;

/**
 * __useRemoveRecurringInvoicesMutation__
 *
 * To run a mutation, you first call `useRemoveRecurringInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecurringInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecurringInvoicesMutation, { data, loading, error }] = useRemoveRecurringInvoicesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveRecurringInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRecurringInvoicesMutation, RemoveRecurringInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRecurringInvoicesMutation, RemoveRecurringInvoicesMutationVariables>(RemoveRecurringInvoicesDocument, options);
      }
export type RemoveRecurringInvoicesMutationHookResult = ReturnType<typeof useRemoveRecurringInvoicesMutation>;
export type RemoveRecurringInvoicesMutationResult = Apollo.MutationResult<RemoveRecurringInvoicesMutation>;
export type RemoveRecurringInvoicesMutationOptions = Apollo.BaseMutationOptions<RemoveRecurringInvoicesMutation, RemoveRecurringInvoicesMutationVariables>;
export const SkipRecurringInvoiceDateDocument = gql`
    mutation skipRecurringInvoiceDate($id: String!, $date: String!) {
  skipRecurringInvoiceDate(id: $id, date: $date) {
    id
    nextGenerationDate
    excludeDates
  }
}
    `;
export type SkipRecurringInvoiceDateMutationFn = Apollo.MutationFunction<SkipRecurringInvoiceDateMutation, SkipRecurringInvoiceDateMutationVariables>;

/**
 * __useSkipRecurringInvoiceDateMutation__
 *
 * To run a mutation, you first call `useSkipRecurringInvoiceDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipRecurringInvoiceDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipRecurringInvoiceDateMutation, { data, loading, error }] = useSkipRecurringInvoiceDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSkipRecurringInvoiceDateMutation(baseOptions?: Apollo.MutationHookOptions<SkipRecurringInvoiceDateMutation, SkipRecurringInvoiceDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipRecurringInvoiceDateMutation, SkipRecurringInvoiceDateMutationVariables>(SkipRecurringInvoiceDateDocument, options);
      }
export type SkipRecurringInvoiceDateMutationHookResult = ReturnType<typeof useSkipRecurringInvoiceDateMutation>;
export type SkipRecurringInvoiceDateMutationResult = Apollo.MutationResult<SkipRecurringInvoiceDateMutation>;
export type SkipRecurringInvoiceDateMutationOptions = Apollo.BaseMutationOptions<SkipRecurringInvoiceDateMutation, SkipRecurringInvoiceDateMutationVariables>;
export const GenerateRecurringInvoiceDocument = gql`
    mutation generateRecurringInvoice($id: String!) {
  generateRecurringInvoice(id: $id)
}
    `;
export type GenerateRecurringInvoiceMutationFn = Apollo.MutationFunction<GenerateRecurringInvoiceMutation, GenerateRecurringInvoiceMutationVariables>;

/**
 * __useGenerateRecurringInvoiceMutation__
 *
 * To run a mutation, you first call `useGenerateRecurringInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRecurringInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRecurringInvoiceMutation, { data, loading, error }] = useGenerateRecurringInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateRecurringInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRecurringInvoiceMutation, GenerateRecurringInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRecurringInvoiceMutation, GenerateRecurringInvoiceMutationVariables>(GenerateRecurringInvoiceDocument, options);
      }
export type GenerateRecurringInvoiceMutationHookResult = ReturnType<typeof useGenerateRecurringInvoiceMutation>;
export type GenerateRecurringInvoiceMutationResult = Apollo.MutationResult<GenerateRecurringInvoiceMutation>;
export type GenerateRecurringInvoiceMutationOptions = Apollo.BaseMutationOptions<GenerateRecurringInvoiceMutation, GenerateRecurringInvoiceMutationVariables>;
export const BulkPauseRecurringInvoiceDocument = gql`
    mutation bulkPauseRecurringInvoice($ids: [String!]!, $pause: Boolean!) {
  bulkPauseRecurringInvoice(ids: $ids, pause: $pause) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
    }
  }
}
    `;
export type BulkPauseRecurringInvoiceMutationFn = Apollo.MutationFunction<BulkPauseRecurringInvoiceMutation, BulkPauseRecurringInvoiceMutationVariables>;

/**
 * __useBulkPauseRecurringInvoiceMutation__
 *
 * To run a mutation, you first call `useBulkPauseRecurringInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPauseRecurringInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPauseRecurringInvoiceMutation, { data, loading, error }] = useBulkPauseRecurringInvoiceMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      pause: // value for 'pause'
 *   },
 * });
 */
export function useBulkPauseRecurringInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<BulkPauseRecurringInvoiceMutation, BulkPauseRecurringInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPauseRecurringInvoiceMutation, BulkPauseRecurringInvoiceMutationVariables>(BulkPauseRecurringInvoiceDocument, options);
      }
export type BulkPauseRecurringInvoiceMutationHookResult = ReturnType<typeof useBulkPauseRecurringInvoiceMutation>;
export type BulkPauseRecurringInvoiceMutationResult = Apollo.MutationResult<BulkPauseRecurringInvoiceMutation>;
export type BulkPauseRecurringInvoiceMutationOptions = Apollo.BaseMutationOptions<BulkPauseRecurringInvoiceMutation, BulkPauseRecurringInvoiceMutationVariables>;
export const BulkSkipNextRecurringInvoiceDocument = gql`
    mutation bulkSkipNextRecurringInvoice($ids: [String!]!) {
  bulkSkipNextRecurringInvoice(ids: $ids) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
      nextGenerationDate
      excludeDates
    }
  }
}
    `;
export type BulkSkipNextRecurringInvoiceMutationFn = Apollo.MutationFunction<BulkSkipNextRecurringInvoiceMutation, BulkSkipNextRecurringInvoiceMutationVariables>;

/**
 * __useBulkSkipNextRecurringInvoiceMutation__
 *
 * To run a mutation, you first call `useBulkSkipNextRecurringInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSkipNextRecurringInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSkipNextRecurringInvoiceMutation, { data, loading, error }] = useBulkSkipNextRecurringInvoiceMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkSkipNextRecurringInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<BulkSkipNextRecurringInvoiceMutation, BulkSkipNextRecurringInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSkipNextRecurringInvoiceMutation, BulkSkipNextRecurringInvoiceMutationVariables>(BulkSkipNextRecurringInvoiceDocument, options);
      }
export type BulkSkipNextRecurringInvoiceMutationHookResult = ReturnType<typeof useBulkSkipNextRecurringInvoiceMutation>;
export type BulkSkipNextRecurringInvoiceMutationResult = Apollo.MutationResult<BulkSkipNextRecurringInvoiceMutation>;
export type BulkSkipNextRecurringInvoiceMutationOptions = Apollo.BaseMutationOptions<BulkSkipNextRecurringInvoiceMutation, BulkSkipNextRecurringInvoiceMutationVariables>;
export const AddRecurringInvoiceAttachmentsDocument = gql`
    mutation addRecurringInvoiceAttachments($id: String!, $attachments: [FileObjectInput!]!) {
  addRecurringInvoiceAttachments(id: $id, attachments: $attachments) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type AddRecurringInvoiceAttachmentsMutationFn = Apollo.MutationFunction<AddRecurringInvoiceAttachmentsMutation, AddRecurringInvoiceAttachmentsMutationVariables>;

/**
 * __useAddRecurringInvoiceAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddRecurringInvoiceAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecurringInvoiceAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecurringInvoiceAttachmentsMutation, { data, loading, error }] = useAddRecurringInvoiceAttachmentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddRecurringInvoiceAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddRecurringInvoiceAttachmentsMutation, AddRecurringInvoiceAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecurringInvoiceAttachmentsMutation, AddRecurringInvoiceAttachmentsMutationVariables>(AddRecurringInvoiceAttachmentsDocument, options);
      }
export type AddRecurringInvoiceAttachmentsMutationHookResult = ReturnType<typeof useAddRecurringInvoiceAttachmentsMutation>;
export type AddRecurringInvoiceAttachmentsMutationResult = Apollo.MutationResult<AddRecurringInvoiceAttachmentsMutation>;
export type AddRecurringInvoiceAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddRecurringInvoiceAttachmentsMutation, AddRecurringInvoiceAttachmentsMutationVariables>;
export const DeleteRecurringInvoiceAttachmentDocument = gql`
    mutation deleteRecurringInvoiceAttachment($id: String!, $attachmentId: String!) {
  deleteRecurringInvoiceAttachment(id: $id, attachmentId: $attachmentId) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type DeleteRecurringInvoiceAttachmentMutationFn = Apollo.MutationFunction<DeleteRecurringInvoiceAttachmentMutation, DeleteRecurringInvoiceAttachmentMutationVariables>;

/**
 * __useDeleteRecurringInvoiceAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringInvoiceAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringInvoiceAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringInvoiceAttachmentMutation, { data, loading, error }] = useDeleteRecurringInvoiceAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteRecurringInvoiceAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringInvoiceAttachmentMutation, DeleteRecurringInvoiceAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringInvoiceAttachmentMutation, DeleteRecurringInvoiceAttachmentMutationVariables>(DeleteRecurringInvoiceAttachmentDocument, options);
      }
export type DeleteRecurringInvoiceAttachmentMutationHookResult = ReturnType<typeof useDeleteRecurringInvoiceAttachmentMutation>;
export type DeleteRecurringInvoiceAttachmentMutationResult = Apollo.MutationResult<DeleteRecurringInvoiceAttachmentMutation>;
export type DeleteRecurringInvoiceAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringInvoiceAttachmentMutation, DeleteRecurringInvoiceAttachmentMutationVariables>;
export const GetRecurringInvoicesDocument = gql`
    query getRecurringInvoices($take: Int! = 10, $after: String, $before: String, $search: String, $recordStatuses: [RRuleStatuses!], $from: DateTime, $to: DateTime) {
  getRecurringInvoices(
    take: $take
    after: $after
    before: $before
    search: $search
    recordStatuses: $recordStatuses
    from: $from
    to: $to
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      notes
      recordStatus
      rruleText
      company {
        ...CompanyCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      createdAt
      startDate
      nextGenerationDate
      prevGenerationDate
      excludeDates
      timezone
      charges
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoicesQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoicesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      recordStatuses: // value for 'recordStatuses'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetRecurringInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetRecurringInvoicesQuery, GetRecurringInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoicesQuery, GetRecurringInvoicesQueryVariables>(GetRecurringInvoicesDocument, options);
      }
export function useGetRecurringInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoicesQuery, GetRecurringInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoicesQuery, GetRecurringInvoicesQueryVariables>(GetRecurringInvoicesDocument, options);
        }
export type GetRecurringInvoicesQueryHookResult = ReturnType<typeof useGetRecurringInvoicesQuery>;
export type GetRecurringInvoicesLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoicesLazyQuery>;
export type GetRecurringInvoicesQueryResult = Apollo.QueryResult<GetRecurringInvoicesQuery, GetRecurringInvoicesQueryVariables>;
export const GetRecurringInvoicesCalendarDocument = gql`
    query getRecurringInvoicesCalendar($search: String, $recordStatuses: [RRuleStatuses!], $from: DateTime!, $to: DateTime!) {
  getRecurringInvoicesCalendar(
    search: $search
    recordStatuses: $recordStatuses
    from: $from
    to: $to
  ) {
    dates
    record {
      id
      index
      recordStatus
      company {
        ...CompanyCoreFields
      }
    }
  }
}
    ${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoicesCalendarQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoicesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoicesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoicesCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *      recordStatuses: // value for 'recordStatuses'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetRecurringInvoicesCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringInvoicesCalendarQuery, GetRecurringInvoicesCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoicesCalendarQuery, GetRecurringInvoicesCalendarQueryVariables>(GetRecurringInvoicesCalendarDocument, options);
      }
export function useGetRecurringInvoicesCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoicesCalendarQuery, GetRecurringInvoicesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoicesCalendarQuery, GetRecurringInvoicesCalendarQueryVariables>(GetRecurringInvoicesCalendarDocument, options);
        }
export type GetRecurringInvoicesCalendarQueryHookResult = ReturnType<typeof useGetRecurringInvoicesCalendarQuery>;
export type GetRecurringInvoicesCalendarLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoicesCalendarLazyQuery>;
export type GetRecurringInvoicesCalendarQueryResult = Apollo.QueryResult<GetRecurringInvoicesCalendarQuery, GetRecurringInvoicesCalendarQueryVariables>;
export const GetRecurringInvoiceDocument = gql`
    query getRecurringInvoice($id: String!) {
  getRecurringInvoice(id: $id) {
    ...RecurringInvoiceFields
  }
}
    ${RecurringInvoiceFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoiceQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecurringInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringInvoiceQuery, GetRecurringInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoiceQuery, GetRecurringInvoiceQueryVariables>(GetRecurringInvoiceDocument, options);
      }
export function useGetRecurringInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoiceQuery, GetRecurringInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoiceQuery, GetRecurringInvoiceQueryVariables>(GetRecurringInvoiceDocument, options);
        }
export type GetRecurringInvoiceQueryHookResult = ReturnType<typeof useGetRecurringInvoiceQuery>;
export type GetRecurringInvoiceLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoiceLazyQuery>;
export type GetRecurringInvoiceQueryResult = Apollo.QueryResult<GetRecurringInvoiceQuery, GetRecurringInvoiceQueryVariables>;
export const GetRecurringInvoiceChargesDocument = gql`
    query getRecurringInvoiceCharges($id: String!, $search: String) {
  getRecurringInvoiceCharges(id: $id, search: $search) {
    id
    type
    billable
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoiceChargesQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoiceChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoiceChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoiceChargesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRecurringInvoiceChargesQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringInvoiceChargesQuery, GetRecurringInvoiceChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoiceChargesQuery, GetRecurringInvoiceChargesQueryVariables>(GetRecurringInvoiceChargesDocument, options);
      }
export function useGetRecurringInvoiceChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoiceChargesQuery, GetRecurringInvoiceChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoiceChargesQuery, GetRecurringInvoiceChargesQueryVariables>(GetRecurringInvoiceChargesDocument, options);
        }
export type GetRecurringInvoiceChargesQueryHookResult = ReturnType<typeof useGetRecurringInvoiceChargesQuery>;
export type GetRecurringInvoiceChargesLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoiceChargesLazyQuery>;
export type GetRecurringInvoiceChargesQueryResult = Apollo.QueryResult<GetRecurringInvoiceChargesQuery, GetRecurringInvoiceChargesQueryVariables>;
export const GetRecurringInvoiceRelatedRecordsDocument = gql`
    query getRecurringInvoiceRelatedRecords($id: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getRecurringInvoiceRelatedRecords(
    id: $id
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      status
      dueDate
      totalAmount
      paidAmount
      lastSentAt
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetRecurringInvoiceRelatedRecordsQuery__
 *
 * To run a query within a React component, call `useGetRecurringInvoiceRelatedRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringInvoiceRelatedRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringInvoiceRelatedRecordsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRecurringInvoiceRelatedRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringInvoiceRelatedRecordsQuery, GetRecurringInvoiceRelatedRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringInvoiceRelatedRecordsQuery, GetRecurringInvoiceRelatedRecordsQueryVariables>(GetRecurringInvoiceRelatedRecordsDocument, options);
      }
export function useGetRecurringInvoiceRelatedRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringInvoiceRelatedRecordsQuery, GetRecurringInvoiceRelatedRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringInvoiceRelatedRecordsQuery, GetRecurringInvoiceRelatedRecordsQueryVariables>(GetRecurringInvoiceRelatedRecordsDocument, options);
        }
export type GetRecurringInvoiceRelatedRecordsQueryHookResult = ReturnType<typeof useGetRecurringInvoiceRelatedRecordsQuery>;
export type GetRecurringInvoiceRelatedRecordsLazyQueryHookResult = ReturnType<typeof useGetRecurringInvoiceRelatedRecordsLazyQuery>;
export type GetRecurringInvoiceRelatedRecordsQueryResult = Apollo.QueryResult<GetRecurringInvoiceRelatedRecordsQuery, GetRecurringInvoiceRelatedRecordsQueryVariables>;
export const CreateCategoryGroupDocument = gql`
    mutation createCategoryGroup($data: CategoryGroupInput!) {
  createCategoryGroup(input: $data) {
    id
  }
}
    `;
export type CreateCategoryGroupMutationFn = Apollo.MutationFunction<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>;

/**
 * __useCreateCategoryGroupMutation__
 *
 * To run a mutation, you first call `useCreateCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryGroupMutation, { data, loading, error }] = useCreateCategoryGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>(CreateCategoryGroupDocument, options);
      }
export type CreateCategoryGroupMutationHookResult = ReturnType<typeof useCreateCategoryGroupMutation>;
export type CreateCategoryGroupMutationResult = Apollo.MutationResult<CreateCategoryGroupMutation>;
export type CreateCategoryGroupMutationOptions = Apollo.BaseMutationOptions<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>;
export const UpdateCategoryGroupDocument = gql`
    mutation updateCategoryGroup($id: String!, $data: CategoryGroupInput!) {
  updateCategoryGroup(id: $id, input: $data) {
    ...CategoryGroupFields
  }
}
    ${CategoryGroupFieldsFragmentDoc}`;
export type UpdateCategoryGroupMutationFn = Apollo.MutationFunction<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>;

/**
 * __useUpdateCategoryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryGroupMutation, { data, loading, error }] = useUpdateCategoryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>(UpdateCategoryGroupDocument, options);
      }
export type UpdateCategoryGroupMutationHookResult = ReturnType<typeof useUpdateCategoryGroupMutation>;
export type UpdateCategoryGroupMutationResult = Apollo.MutationResult<UpdateCategoryGroupMutation>;
export type UpdateCategoryGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>;
export const ToggleCategoryGroupDocument = gql`
    mutation toggleCategoryGroup($id: String!) {
  toggleCategoryGroup(id: $id)
}
    `;
export type ToggleCategoryGroupMutationFn = Apollo.MutationFunction<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>;

/**
 * __useToggleCategoryGroupMutation__
 *
 * To run a mutation, you first call `useToggleCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCategoryGroupMutation, { data, loading, error }] = useToggleCategoryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>(ToggleCategoryGroupDocument, options);
      }
export type ToggleCategoryGroupMutationHookResult = ReturnType<typeof useToggleCategoryGroupMutation>;
export type ToggleCategoryGroupMutationResult = Apollo.MutationResult<ToggleCategoryGroupMutation>;
export type ToggleCategoryGroupMutationOptions = Apollo.BaseMutationOptions<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>;
export const RemoveCategoryGroupsDocument = gql`
    mutation removeCategoryGroups($data: DeleteRecordsInput!) {
  removeCategoryGroups(input: $data)
}
    `;
export type RemoveCategoryGroupsMutationFn = Apollo.MutationFunction<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>;

/**
 * __useRemoveCategoryGroupsMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryGroupsMutation, { data, loading, error }] = useRemoveCategoryGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCategoryGroupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>(RemoveCategoryGroupsDocument, options);
      }
export type RemoveCategoryGroupsMutationHookResult = ReturnType<typeof useRemoveCategoryGroupsMutation>;
export type RemoveCategoryGroupsMutationResult = Apollo.MutationResult<RemoveCategoryGroupsMutation>;
export type RemoveCategoryGroupsMutationOptions = Apollo.BaseMutationOptions<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>;
export const GetCategoryGroupsTableDocument = gql`
    query getCategoryGroupsTable($recordType: CategoryRecordType!, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getCategoryGroups(
    recordType: $recordType
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getCategoryGroupsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryGroupCoreFields
      index
      icon
      active
      categoryCount
      propertyId
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupsTableQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupsTableQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCategoryGroupsTableQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>(GetCategoryGroupsTableDocument, options);
      }
export function useGetCategoryGroupsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>(GetCategoryGroupsTableDocument, options);
        }
export type GetCategoryGroupsTableQueryHookResult = ReturnType<typeof useGetCategoryGroupsTableQuery>;
export type GetCategoryGroupsTableLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupsTableLazyQuery>;
export type GetCategoryGroupsTableQueryResult = Apollo.QueryResult<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>;
export const GetCategoryGroupsDropdownDocument = gql`
    query getCategoryGroupsDropdown($recordType: CategoryRecordType!, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getCategoryGroups(
    recordType: $recordType
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getCategoryGroupsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryGroupCoreFields
      icon
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupsDropdownQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupsDropdownQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCategoryGroupsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>(GetCategoryGroupsDropdownDocument, options);
      }
export function useGetCategoryGroupsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>(GetCategoryGroupsDropdownDocument, options);
        }
export type GetCategoryGroupsDropdownQueryHookResult = ReturnType<typeof useGetCategoryGroupsDropdownQuery>;
export type GetCategoryGroupsDropdownLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupsDropdownLazyQuery>;
export type GetCategoryGroupsDropdownQueryResult = Apollo.QueryResult<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>;
export const GetCategoryGroupDocument = gql`
    query getCategoryGroup($id: String!) {
  getCategoryGroup(id: $id) {
    ...CategoryGroupFields
  }
}
    ${CategoryGroupFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>(GetCategoryGroupDocument, options);
      }
export function useGetCategoryGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>(GetCategoryGroupDocument, options);
        }
export type GetCategoryGroupQueryHookResult = ReturnType<typeof useGetCategoryGroupQuery>;
export type GetCategoryGroupLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupLazyQuery>;
export type GetCategoryGroupQueryResult = Apollo.QueryResult<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation createCategory($recordType: CategoryRecordType!, $data: CategoryInput!) {
  createCategory(recordType: $recordType, input: $data) {
    id
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($id: String!, $data: CategoryInput!) {
  updateCategory(id: $id, input: $data) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdatePortfolioCategoryDocument = gql`
    mutation updatePortfolioCategory($data: UpdatePortfolioCategory!) {
  updatePortfolioCategory(input: $data) {
    ...CategoryCoreFields
    employee {
      ...EmployeeCoreFields
    }
    usersNotify {
      ...UserCoreFields
    }
  }
}
    ${CategoryCoreFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;
export type UpdatePortfolioCategoryMutationFn = Apollo.MutationFunction<UpdatePortfolioCategoryMutation, UpdatePortfolioCategoryMutationVariables>;

/**
 * __useUpdatePortfolioCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioCategoryMutation, { data, loading, error }] = useUpdatePortfolioCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePortfolioCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioCategoryMutation, UpdatePortfolioCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioCategoryMutation, UpdatePortfolioCategoryMutationVariables>(UpdatePortfolioCategoryDocument, options);
      }
export type UpdatePortfolioCategoryMutationHookResult = ReturnType<typeof useUpdatePortfolioCategoryMutation>;
export type UpdatePortfolioCategoryMutationResult = Apollo.MutationResult<UpdatePortfolioCategoryMutation>;
export type UpdatePortfolioCategoryMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioCategoryMutation, UpdatePortfolioCategoryMutationVariables>;
export const ToggleCategoryDocument = gql`
    mutation toggleCategory($id: String!) {
  toggleCategory(id: $id)
}
    `;
export type ToggleCategoryMutationFn = Apollo.MutationFunction<ToggleCategoryMutation, ToggleCategoryMutationVariables>;

/**
 * __useToggleCategoryMutation__
 *
 * To run a mutation, you first call `useToggleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCategoryMutation, { data, loading, error }] = useToggleCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCategoryMutation, ToggleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCategoryMutation, ToggleCategoryMutationVariables>(ToggleCategoryDocument, options);
      }
export type ToggleCategoryMutationHookResult = ReturnType<typeof useToggleCategoryMutation>;
export type ToggleCategoryMutationResult = Apollo.MutationResult<ToggleCategoryMutation>;
export type ToggleCategoryMutationOptions = Apollo.BaseMutationOptions<ToggleCategoryMutation, ToggleCategoryMutationVariables>;
export const RemoveCategoriesDocument = gql`
    mutation removeCategories($data: DeleteRecordsInput!) {
  removeCategories(input: $data)
}
    `;
export type RemoveCategoriesMutationFn = Apollo.MutationFunction<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>;

/**
 * __useRemoveCategoriesMutation__
 *
 * To run a mutation, you first call `useRemoveCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoriesMutation, { data, loading, error }] = useRemoveCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>(RemoveCategoriesDocument, options);
      }
export type RemoveCategoriesMutationHookResult = ReturnType<typeof useRemoveCategoriesMutation>;
export type RemoveCategoriesMutationResult = Apollo.MutationResult<RemoveCategoriesMutation>;
export type RemoveCategoriesMutationOptions = Apollo.BaseMutationOptions<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>;
export const GetCategoriesTableDocument = gql`
    query getCategoriesTable($active: Boolean, $recordType: CategoryRecordType!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getCategories(
    active: $active
    recordType: $recordType
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getCategoriesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryCoreFields
      active
      propertyId
      index
      employee {
        ...EmployeeCoreFields
      }
      group {
        ...CategoryGroupCoreFields
      }
      defaultPriority {
        ...PriorityCoreFields
        color
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesTableQuery__
 *
 * To run a query within a React component, call `useGetCategoriesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      recordType: // value for 'recordType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCategoriesTableQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>(GetCategoriesTableDocument, options);
      }
export function useGetCategoriesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>(GetCategoriesTableDocument, options);
        }
export type GetCategoriesTableQueryHookResult = ReturnType<typeof useGetCategoriesTableQuery>;
export type GetCategoriesTableLazyQueryHookResult = ReturnType<typeof useGetCategoriesTableLazyQuery>;
export type GetCategoriesTableQueryResult = Apollo.QueryResult<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>;
export const GetCategoriesDropdownDocument = gql`
    query getCategoriesDropdown($active: Boolean, $recordType: CategoryRecordType!, $take: Int! = 10, $after: String, $before: String, $search: String, $includeGroup: Boolean!, $includeDescription: Boolean!, $includePriority: Boolean!, $includeEmployee: Boolean!) {
  getCategories(
    active: $active
    recordType: $recordType
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getCategoriesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryCoreFields
      active
      description @include(if: $includeDescription)
      group @include(if: $includeGroup) {
        ...CategoryGroupCoreFields
      }
      defaultPriority @include(if: $includePriority) {
        ...PriorityCoreFields
        color
      }
      employee @include(if: $includeEmployee) {
        ...EmployeeCoreFields
        laborRate {
          ...LaborRateCoreFields
          rate
          markup {
            ...MarkupCoreFields
            type
            amount
          }
        }
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesDropdownQuery__
 *
 * To run a query within a React component, call `useGetCategoriesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      recordType: // value for 'recordType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeGroup: // value for 'includeGroup'
 *      includeDescription: // value for 'includeDescription'
 *      includePriority: // value for 'includePriority'
 *      includeEmployee: // value for 'includeEmployee'
 *   },
 * });
 */
export function useGetCategoriesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>(GetCategoriesDropdownDocument, options);
      }
export function useGetCategoriesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>(GetCategoriesDropdownDocument, options);
        }
export type GetCategoriesDropdownQueryHookResult = ReturnType<typeof useGetCategoriesDropdownQuery>;
export type GetCategoriesDropdownLazyQueryHookResult = ReturnType<typeof useGetCategoriesDropdownLazyQuery>;
export type GetCategoriesDropdownQueryResult = Apollo.QueryResult<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>;
export const GetCategoriesDropdownGroupedDocument = gql`
    query getCategoriesDropdownGrouped($active: Boolean, $recordType: CategoryRecordType!, $take: Int! = 10, $after: String, $before: String, $search: String, $includeDescription: Boolean!, $includePriority: Boolean!, $includeEmployee: Boolean!) {
  getCategoriesGrouped(
    active: $active
    recordType: $recordType
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      title
      icon
      active
      categories {
        ...CategoryCoreFields
        active
        description @include(if: $includeDescription)
        defaultPriority @include(if: $includePriority) {
          ...PriorityCoreFields
          color
        }
        employee @include(if: $includeEmployee) {
          ...EmployeeCoreFields
          laborRate {
            ...LaborRateCoreFields
            rate
            markup {
              ...MarkupCoreFields
              type
              amount
            }
          }
        }
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${EmployeeCoreFieldsFragmentDoc}
${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesDropdownGroupedQuery__
 *
 * To run a query within a React component, call `useGetCategoriesDropdownGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesDropdownGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesDropdownGroupedQuery({
 *   variables: {
 *      active: // value for 'active'
 *      recordType: // value for 'recordType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeDescription: // value for 'includeDescription'
 *      includePriority: // value for 'includePriority'
 *      includeEmployee: // value for 'includeEmployee'
 *   },
 * });
 */
export function useGetCategoriesDropdownGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>(GetCategoriesDropdownGroupedDocument, options);
      }
export function useGetCategoriesDropdownGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>(GetCategoriesDropdownGroupedDocument, options);
        }
export type GetCategoriesDropdownGroupedQueryHookResult = ReturnType<typeof useGetCategoriesDropdownGroupedQuery>;
export type GetCategoriesDropdownGroupedLazyQueryHookResult = ReturnType<typeof useGetCategoriesDropdownGroupedLazyQuery>;
export type GetCategoriesDropdownGroupedQueryResult = Apollo.QueryResult<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>;
export const GetFilterableGroupedCategoriesDocument = gql`
    query getFilterableGroupedCategories($location: FilterableCategoryLocationType!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getFilterableGroupedCategories(
    location: $location
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      icon
      active
      isDeleted
      categories {
        id
        title
        active
        isDeleted
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetFilterableGroupedCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFilterableGroupedCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterableGroupedCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterableGroupedCategoriesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterableGroupedCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>(GetFilterableGroupedCategoriesDocument, options);
      }
export function useGetFilterableGroupedCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>(GetFilterableGroupedCategoriesDocument, options);
        }
export type GetFilterableGroupedCategoriesQueryHookResult = ReturnType<typeof useGetFilterableGroupedCategoriesQuery>;
export type GetFilterableGroupedCategoriesLazyQueryHookResult = ReturnType<typeof useGetFilterableGroupedCategoriesLazyQuery>;
export type GetFilterableGroupedCategoriesQueryResult = Apollo.QueryResult<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>;
export const GetPublicCategoriesGroupedDocument = gql`
    query getPublicCategoriesGrouped($propertyId: String!, $recordType: CategoryRecordType!, $take: Int! = 10, $after: String, $before: String, $search: String!) {
  getPublicCategoriesGrouped(
    propertyId: $propertyId
    recordType: $recordType
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      title
      icon
      active
      categories {
        ...CategoryCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicCategoriesGroupedQuery__
 *
 * To run a query within a React component, call `useGetPublicCategoriesGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCategoriesGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCategoriesGroupedQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      recordType: // value for 'recordType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicCategoriesGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCategoriesGroupedQuery, GetPublicCategoriesGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCategoriesGroupedQuery, GetPublicCategoriesGroupedQueryVariables>(GetPublicCategoriesGroupedDocument, options);
      }
export function useGetPublicCategoriesGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCategoriesGroupedQuery, GetPublicCategoriesGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCategoriesGroupedQuery, GetPublicCategoriesGroupedQueryVariables>(GetPublicCategoriesGroupedDocument, options);
        }
export type GetPublicCategoriesGroupedQueryHookResult = ReturnType<typeof useGetPublicCategoriesGroupedQuery>;
export type GetPublicCategoriesGroupedLazyQueryHookResult = ReturnType<typeof useGetPublicCategoriesGroupedLazyQuery>;
export type GetPublicCategoriesGroupedQueryResult = Apollo.QueryResult<GetPublicCategoriesGroupedQuery, GetPublicCategoriesGroupedQueryVariables>;
export const GetCategoryDocument = gql`
    query getCategory($id: String!) {
  getCategory(id: $id) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const UpdateKioskSettingsDocument = gql`
    mutation updateKioskSettings($data: KioskSettingsInput!) {
  updateKioskSettings(input: $data) {
    ...KioskFields
  }
}
    ${KioskFieldsFragmentDoc}`;
export type UpdateKioskSettingsMutationFn = Apollo.MutationFunction<UpdateKioskSettingsMutation, UpdateKioskSettingsMutationVariables>;

/**
 * __useUpdateKioskSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateKioskSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKioskSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKioskSettingsMutation, { data, loading, error }] = useUpdateKioskSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateKioskSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKioskSettingsMutation, UpdateKioskSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKioskSettingsMutation, UpdateKioskSettingsMutationVariables>(UpdateKioskSettingsDocument, options);
      }
export type UpdateKioskSettingsMutationHookResult = ReturnType<typeof useUpdateKioskSettingsMutation>;
export type UpdateKioskSettingsMutationResult = Apollo.MutationResult<UpdateKioskSettingsMutation>;
export type UpdateKioskSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateKioskSettingsMutation, UpdateKioskSettingsMutationVariables>;
export const GetKioskSettingsDocument = gql`
    query getKioskSettings {
  getKioskSettings {
    ...KioskFields
  }
}
    ${KioskFieldsFragmentDoc}`;

/**
 * __useGetKioskSettingsQuery__
 *
 * To run a query within a React component, call `useGetKioskSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKioskSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKioskSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKioskSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetKioskSettingsQuery, GetKioskSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKioskSettingsQuery, GetKioskSettingsQueryVariables>(GetKioskSettingsDocument, options);
      }
export function useGetKioskSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKioskSettingsQuery, GetKioskSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKioskSettingsQuery, GetKioskSettingsQueryVariables>(GetKioskSettingsDocument, options);
        }
export type GetKioskSettingsQueryHookResult = ReturnType<typeof useGetKioskSettingsQuery>;
export type GetKioskSettingsLazyQueryHookResult = ReturnType<typeof useGetKioskSettingsLazyQuery>;
export type GetKioskSettingsQueryResult = Apollo.QueryResult<GetKioskSettingsQuery, GetKioskSettingsQueryVariables>;
export const CreateLaborRateDocument = gql`
    mutation createLaborRate($data: LaborRateInput!) {
  createLaborRate(input: $data) {
    id
  }
}
    `;
export type CreateLaborRateMutationFn = Apollo.MutationFunction<CreateLaborRateMutation, CreateLaborRateMutationVariables>;

/**
 * __useCreateLaborRateMutation__
 *
 * To run a mutation, you first call `useCreateLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaborRateMutation, { data, loading, error }] = useCreateLaborRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateLaborRateMutation, CreateLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLaborRateMutation, CreateLaborRateMutationVariables>(CreateLaborRateDocument, options);
      }
export type CreateLaborRateMutationHookResult = ReturnType<typeof useCreateLaborRateMutation>;
export type CreateLaborRateMutationResult = Apollo.MutationResult<CreateLaborRateMutation>;
export type CreateLaborRateMutationOptions = Apollo.BaseMutationOptions<CreateLaborRateMutation, CreateLaborRateMutationVariables>;
export const UpdateLaborRateDocument = gql`
    mutation updateLaborRate($id: String!, $data: LaborRateInput!) {
  updateLaborRate(id: $id, input: $data) {
    ...LaborRateFields
  }
}
    ${LaborRateFieldsFragmentDoc}`;
export type UpdateLaborRateMutationFn = Apollo.MutationFunction<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>;

/**
 * __useUpdateLaborRateMutation__
 *
 * To run a mutation, you first call `useUpdateLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaborRateMutation, { data, loading, error }] = useUpdateLaborRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>(UpdateLaborRateDocument, options);
      }
export type UpdateLaborRateMutationHookResult = ReturnType<typeof useUpdateLaborRateMutation>;
export type UpdateLaborRateMutationResult = Apollo.MutationResult<UpdateLaborRateMutation>;
export type UpdateLaborRateMutationOptions = Apollo.BaseMutationOptions<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>;
export const ToggleLaborRateDocument = gql`
    mutation toggleLaborRate($id: String!) {
  toggleLaborRate(id: $id)
}
    `;
export type ToggleLaborRateMutationFn = Apollo.MutationFunction<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>;

/**
 * __useToggleLaborRateMutation__
 *
 * To run a mutation, you first call `useToggleLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLaborRateMutation, { data, loading, error }] = useToggleLaborRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>(ToggleLaborRateDocument, options);
      }
export type ToggleLaborRateMutationHookResult = ReturnType<typeof useToggleLaborRateMutation>;
export type ToggleLaborRateMutationResult = Apollo.MutationResult<ToggleLaborRateMutation>;
export type ToggleLaborRateMutationOptions = Apollo.BaseMutationOptions<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>;
export const RemoveLaborRatesDocument = gql`
    mutation removeLaborRates($data: DeleteRecordsInput!) {
  removeLaborRates(input: $data)
}
    `;
export type RemoveLaborRatesMutationFn = Apollo.MutationFunction<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>;

/**
 * __useRemoveLaborRatesMutation__
 *
 * To run a mutation, you first call `useRemoveLaborRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaborRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaborRatesMutation, { data, loading, error }] = useRemoveLaborRatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLaborRatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>(RemoveLaborRatesDocument, options);
      }
export type RemoveLaborRatesMutationHookResult = ReturnType<typeof useRemoveLaborRatesMutation>;
export type RemoveLaborRatesMutationResult = Apollo.MutationResult<RemoveLaborRatesMutation>;
export type RemoveLaborRatesMutationOptions = Apollo.BaseMutationOptions<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>;
export const GetLaborRatesTableDocument = gql`
    query getLaborRatesTable($active: Boolean, $search: String) {
  getLaborRates(active: $active, search: $search) {
    ...LaborRateCoreFields
    index
    active
    rate
    description
    propertyId
    markup {
      ...MarkupCoreFields
    }
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetLaborRatesTableQuery__
 *
 * To run a query within a React component, call `useGetLaborRatesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRatesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRatesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLaborRatesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>(GetLaborRatesTableDocument, options);
      }
export function useGetLaborRatesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>(GetLaborRatesTableDocument, options);
        }
export type GetLaborRatesTableQueryHookResult = ReturnType<typeof useGetLaborRatesTableQuery>;
export type GetLaborRatesTableLazyQueryHookResult = ReturnType<typeof useGetLaborRatesTableLazyQuery>;
export type GetLaborRatesTableQueryResult = Apollo.QueryResult<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>;
export const GetLaborRatesDropdownDocument = gql`
    query getLaborRatesDropdown($active: Boolean, $search: String, $includeDescription: Boolean!, $includeMarkup: Boolean!, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getLaborRates(active: $active, search: $search) {
    ...LaborRateCoreFields
    active
    rate
    description @include(if: $includeDescription)
    markup @include(if: $includeMarkup) {
      ...MarkupCoreFields
      type
      amount
    }
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetLaborRatesDropdownQuery__
 *
 * To run a query within a React component, call `useGetLaborRatesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRatesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRatesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      includeDescription: // value for 'includeDescription'
 *      includeMarkup: // value for 'includeMarkup'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetLaborRatesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>(GetLaborRatesDropdownDocument, options);
      }
export function useGetLaborRatesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>(GetLaborRatesDropdownDocument, options);
        }
export type GetLaborRatesDropdownQueryHookResult = ReturnType<typeof useGetLaborRatesDropdownQuery>;
export type GetLaborRatesDropdownLazyQueryHookResult = ReturnType<typeof useGetLaborRatesDropdownLazyQuery>;
export type GetLaborRatesDropdownQueryResult = Apollo.QueryResult<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>;
export const GetLaborRateDocument = gql`
    query getLaborRate($id: String!) {
  getLaborRate(id: $id) {
    ...LaborRateFields
  }
}
    ${LaborRateFieldsFragmentDoc}`;

/**
 * __useGetLaborRateQuery__
 *
 * To run a query within a React component, call `useGetLaborRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaborRateQuery(baseOptions: Apollo.QueryHookOptions<GetLaborRateQuery, GetLaborRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRateQuery, GetLaborRateQueryVariables>(GetLaborRateDocument, options);
      }
export function useGetLaborRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRateQuery, GetLaborRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRateQuery, GetLaborRateQueryVariables>(GetLaborRateDocument, options);
        }
export type GetLaborRateQueryHookResult = ReturnType<typeof useGetLaborRateQuery>;
export type GetLaborRateLazyQueryHookResult = ReturnType<typeof useGetLaborRateLazyQuery>;
export type GetLaborRateQueryResult = Apollo.QueryResult<GetLaborRateQuery, GetLaborRateQueryVariables>;
export const CreateLeaseChargeTypeDocument = gql`
    mutation createLeaseChargeType($title: String!) {
  createLeaseChargeType(title: $title) {
    id
  }
}
    `;
export type CreateLeaseChargeTypeMutationFn = Apollo.MutationFunction<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>;

/**
 * __useCreateLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useCreateLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaseChargeTypeMutation, { data, loading, error }] = useCreateLeaseChargeTypeMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>(CreateLeaseChargeTypeDocument, options);
      }
export type CreateLeaseChargeTypeMutationHookResult = ReturnType<typeof useCreateLeaseChargeTypeMutation>;
export type CreateLeaseChargeTypeMutationResult = Apollo.MutationResult<CreateLeaseChargeTypeMutation>;
export type CreateLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>;
export const UpdateLeaseChargeTypeDocument = gql`
    mutation updateLeaseChargeType($id: String!, $title: String!) {
  updateLeaseChargeType(id: $id, title: $title) {
    ...LeaseChargeTypeFields
  }
}
    ${LeaseChargeTypeFieldsFragmentDoc}`;
export type UpdateLeaseChargeTypeMutationFn = Apollo.MutationFunction<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>;

/**
 * __useUpdateLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaseChargeTypeMutation, { data, loading, error }] = useUpdateLeaseChargeTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>(UpdateLeaseChargeTypeDocument, options);
      }
export type UpdateLeaseChargeTypeMutationHookResult = ReturnType<typeof useUpdateLeaseChargeTypeMutation>;
export type UpdateLeaseChargeTypeMutationResult = Apollo.MutationResult<UpdateLeaseChargeTypeMutation>;
export type UpdateLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>;
export const ReorderLeaseChargeTypesDocument = gql`
    mutation reorderLeaseChargeTypes($id: String!, $secondId: String!) {
  reorderLeaseChargeTypes(id: $id, secondId: $secondId)
}
    `;
export type ReorderLeaseChargeTypesMutationFn = Apollo.MutationFunction<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>;

/**
 * __useReorderLeaseChargeTypesMutation__
 *
 * To run a mutation, you first call `useReorderLeaseChargeTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLeaseChargeTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLeaseChargeTypesMutation, { data, loading, error }] = useReorderLeaseChargeTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderLeaseChargeTypesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>(ReorderLeaseChargeTypesDocument, options);
      }
export type ReorderLeaseChargeTypesMutationHookResult = ReturnType<typeof useReorderLeaseChargeTypesMutation>;
export type ReorderLeaseChargeTypesMutationResult = Apollo.MutationResult<ReorderLeaseChargeTypesMutation>;
export type ReorderLeaseChargeTypesMutationOptions = Apollo.BaseMutationOptions<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>;
export const ToggleLeaseChargeTypeDocument = gql`
    mutation toggleLeaseChargeType($id: String!) {
  toggleLeaseChargeType(id: $id)
}
    `;
export type ToggleLeaseChargeTypeMutationFn = Apollo.MutationFunction<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>;

/**
 * __useToggleLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useToggleLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLeaseChargeTypeMutation, { data, loading, error }] = useToggleLeaseChargeTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>(ToggleLeaseChargeTypeDocument, options);
      }
export type ToggleLeaseChargeTypeMutationHookResult = ReturnType<typeof useToggleLeaseChargeTypeMutation>;
export type ToggleLeaseChargeTypeMutationResult = Apollo.MutationResult<ToggleLeaseChargeTypeMutation>;
export type ToggleLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>;
export const RemoveLeaseChargeTypesDocument = gql`
    mutation removeLeaseChargeTypes($data: DeleteRecordsInput!) {
  removeLeaseChargeTypes(input: $data)
}
    `;
export type RemoveLeaseChargeTypesMutationFn = Apollo.MutationFunction<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>;

/**
 * __useRemoveLeaseChargeTypesMutation__
 *
 * To run a mutation, you first call `useRemoveLeaseChargeTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeaseChargeTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeaseChargeTypesMutation, { data, loading, error }] = useRemoveLeaseChargeTypesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLeaseChargeTypesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>(RemoveLeaseChargeTypesDocument, options);
      }
export type RemoveLeaseChargeTypesMutationHookResult = ReturnType<typeof useRemoveLeaseChargeTypesMutation>;
export type RemoveLeaseChargeTypesMutationResult = Apollo.MutationResult<RemoveLeaseChargeTypesMutation>;
export type RemoveLeaseChargeTypesMutationOptions = Apollo.BaseMutationOptions<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>;
export const GetLeaseChargeTypesTableDocument = gql`
    query getLeaseChargeTypesTable($active: Boolean, $search: String) {
  getLeaseChargeTypes(active: $active, search: $search) {
    ...LeaseChargeTypeCoreFields
    index
    active
    propertyId
  }
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}`;

/**
 * __useGetLeaseChargeTypesTableQuery__
 *
 * To run a query within a React component, call `useGetLeaseChargeTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseChargeTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseChargeTypesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLeaseChargeTypesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>(GetLeaseChargeTypesTableDocument, options);
      }
export function useGetLeaseChargeTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>(GetLeaseChargeTypesTableDocument, options);
        }
export type GetLeaseChargeTypesTableQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesTableQuery>;
export type GetLeaseChargeTypesTableLazyQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesTableLazyQuery>;
export type GetLeaseChargeTypesTableQueryResult = Apollo.QueryResult<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>;
export const GetLeaseChargeTypesDropdownDocument = gql`
    query getLeaseChargeTypesDropdown($active: Boolean, $search: String) {
  getLeaseChargeTypes(active: $active, search: $search) {
    ...LeaseChargeTypeCoreFields
    active
  }
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}`;

/**
 * __useGetLeaseChargeTypesDropdownQuery__
 *
 * To run a query within a React component, call `useGetLeaseChargeTypesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseChargeTypesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseChargeTypesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLeaseChargeTypesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetLeaseChargeTypesDropdownQuery, GetLeaseChargeTypesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseChargeTypesDropdownQuery, GetLeaseChargeTypesDropdownQueryVariables>(GetLeaseChargeTypesDropdownDocument, options);
      }
export function useGetLeaseChargeTypesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseChargeTypesDropdownQuery, GetLeaseChargeTypesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseChargeTypesDropdownQuery, GetLeaseChargeTypesDropdownQueryVariables>(GetLeaseChargeTypesDropdownDocument, options);
        }
export type GetLeaseChargeTypesDropdownQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesDropdownQuery>;
export type GetLeaseChargeTypesDropdownLazyQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesDropdownLazyQuery>;
export type GetLeaseChargeTypesDropdownQueryResult = Apollo.QueryResult<GetLeaseChargeTypesDropdownQuery, GetLeaseChargeTypesDropdownQueryVariables>;
export const GetLeaseChargeTypeDocument = gql`
    query getLeaseChargeType($id: String!) {
  getLeaseChargeType(id: $id) {
    ...LeaseChargeTypeFields
  }
}
    ${LeaseChargeTypeFieldsFragmentDoc}`;

/**
 * __useGetLeaseChargeTypeQuery__
 *
 * To run a query within a React component, call `useGetLeaseChargeTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseChargeTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseChargeTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeaseChargeTypeQuery(baseOptions: Apollo.QueryHookOptions<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>(GetLeaseChargeTypeDocument, options);
      }
export function useGetLeaseChargeTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>(GetLeaseChargeTypeDocument, options);
        }
export type GetLeaseChargeTypeQueryHookResult = ReturnType<typeof useGetLeaseChargeTypeQuery>;
export type GetLeaseChargeTypeLazyQueryHookResult = ReturnType<typeof useGetLeaseChargeTypeLazyQuery>;
export type GetLeaseChargeTypeQueryResult = Apollo.QueryResult<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>;
export const CreateLeaseDocument = gql`
    mutation createLease($data: LeaseInput!) {
  createLease(input: $data) {
    id
  }
}
    `;
export type CreateLeaseMutationFn = Apollo.MutationFunction<CreateLeaseMutation, CreateLeaseMutationVariables>;

/**
 * __useCreateLeaseMutation__
 *
 * To run a mutation, you first call `useCreateLeaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaseMutation, { data, loading, error }] = useCreateLeaseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLeaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaseMutation, CreateLeaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaseMutation, CreateLeaseMutationVariables>(CreateLeaseDocument, options);
      }
export type CreateLeaseMutationHookResult = ReturnType<typeof useCreateLeaseMutation>;
export type CreateLeaseMutationResult = Apollo.MutationResult<CreateLeaseMutation>;
export type CreateLeaseMutationOptions = Apollo.BaseMutationOptions<CreateLeaseMutation, CreateLeaseMutationVariables>;
export const UpdateLeaseDocument = gql`
    mutation updateLease($id: String!, $data: LeaseUpdateInput!) {
  updateLease(id: $id, input: $data) {
    ...LeaseFields
  }
}
    ${LeaseFieldsFragmentDoc}`;
export type UpdateLeaseMutationFn = Apollo.MutationFunction<UpdateLeaseMutation, UpdateLeaseMutationVariables>;

/**
 * __useUpdateLeaseMutation__
 *
 * To run a mutation, you first call `useUpdateLeaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaseMutation, { data, loading, error }] = useUpdateLeaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLeaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaseMutation, UpdateLeaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaseMutation, UpdateLeaseMutationVariables>(UpdateLeaseDocument, options);
      }
export type UpdateLeaseMutationHookResult = ReturnType<typeof useUpdateLeaseMutation>;
export type UpdateLeaseMutationResult = Apollo.MutationResult<UpdateLeaseMutation>;
export type UpdateLeaseMutationOptions = Apollo.BaseMutationOptions<UpdateLeaseMutation, UpdateLeaseMutationVariables>;
export const RemoveLeasesDocument = gql`
    mutation removeLeases($data: DeleteRecordsInput!) {
  removeLeases(input: $data)
}
    `;
export type RemoveLeasesMutationFn = Apollo.MutationFunction<RemoveLeasesMutation, RemoveLeasesMutationVariables>;

/**
 * __useRemoveLeasesMutation__
 *
 * To run a mutation, you first call `useRemoveLeasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeasesMutation, { data, loading, error }] = useRemoveLeasesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLeasesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeasesMutation, RemoveLeasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeasesMutation, RemoveLeasesMutationVariables>(RemoveLeasesDocument, options);
      }
export type RemoveLeasesMutationHookResult = ReturnType<typeof useRemoveLeasesMutation>;
export type RemoveLeasesMutationResult = Apollo.MutationResult<RemoveLeasesMutation>;
export type RemoveLeasesMutationOptions = Apollo.BaseMutationOptions<RemoveLeasesMutation, RemoveLeasesMutationVariables>;
export const AddLeaseRentDocument = gql`
    mutation addLeaseRent($leaseId: String!, $input: [LeaseRentInput!]!) {
  addLeaseRent(leaseId: $leaseId, input: $input) {
    id
    leaseEnd
    leaseStart
    suites {
      ...SuiteCoreFields
    }
    rents {
      ...LeaseRentFields
    }
  }
}
    ${SuiteCoreFieldsFragmentDoc}
${LeaseRentFieldsFragmentDoc}`;
export type AddLeaseRentMutationFn = Apollo.MutationFunction<AddLeaseRentMutation, AddLeaseRentMutationVariables>;

/**
 * __useAddLeaseRentMutation__
 *
 * To run a mutation, you first call `useAddLeaseRentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeaseRentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeaseRentMutation, { data, loading, error }] = useAddLeaseRentMutation({
 *   variables: {
 *      leaseId: // value for 'leaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLeaseRentMutation(baseOptions?: Apollo.MutationHookOptions<AddLeaseRentMutation, AddLeaseRentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLeaseRentMutation, AddLeaseRentMutationVariables>(AddLeaseRentDocument, options);
      }
export type AddLeaseRentMutationHookResult = ReturnType<typeof useAddLeaseRentMutation>;
export type AddLeaseRentMutationResult = Apollo.MutationResult<AddLeaseRentMutation>;
export type AddLeaseRentMutationOptions = Apollo.BaseMutationOptions<AddLeaseRentMutation, AddLeaseRentMutationVariables>;
export const UpdateLeaseRentDocument = gql`
    mutation updateLeaseRent($rentId: String!, $input: LeaseRentInput!) {
  updateLeaseRent(rentId: $rentId, input: $input) {
    id
    leaseEnd
    leaseStart
    suites {
      ...SuiteCoreFields
    }
    rents {
      ...LeaseRentFields
    }
  }
}
    ${SuiteCoreFieldsFragmentDoc}
${LeaseRentFieldsFragmentDoc}`;
export type UpdateLeaseRentMutationFn = Apollo.MutationFunction<UpdateLeaseRentMutation, UpdateLeaseRentMutationVariables>;

/**
 * __useUpdateLeaseRentMutation__
 *
 * To run a mutation, you first call `useUpdateLeaseRentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaseRentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaseRentMutation, { data, loading, error }] = useUpdateLeaseRentMutation({
 *   variables: {
 *      rentId: // value for 'rentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaseRentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaseRentMutation, UpdateLeaseRentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaseRentMutation, UpdateLeaseRentMutationVariables>(UpdateLeaseRentDocument, options);
      }
export type UpdateLeaseRentMutationHookResult = ReturnType<typeof useUpdateLeaseRentMutation>;
export type UpdateLeaseRentMutationResult = Apollo.MutationResult<UpdateLeaseRentMutation>;
export type UpdateLeaseRentMutationOptions = Apollo.BaseMutationOptions<UpdateLeaseRentMutation, UpdateLeaseRentMutationVariables>;
export const RemoveLeaseRentDocument = gql`
    mutation removeLeaseRent($leaseId: String!, $rentId: String!) {
  removeLeaseRent(leaseId: $leaseId, rentId: $rentId) {
    id
    leaseEnd
    leaseStart
    suites {
      ...SuiteCoreFields
    }
    rents {
      ...LeaseRentFields
    }
  }
}
    ${SuiteCoreFieldsFragmentDoc}
${LeaseRentFieldsFragmentDoc}`;
export type RemoveLeaseRentMutationFn = Apollo.MutationFunction<RemoveLeaseRentMutation, RemoveLeaseRentMutationVariables>;

/**
 * __useRemoveLeaseRentMutation__
 *
 * To run a mutation, you first call `useRemoveLeaseRentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeaseRentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeaseRentMutation, { data, loading, error }] = useRemoveLeaseRentMutation({
 *   variables: {
 *      leaseId: // value for 'leaseId'
 *      rentId: // value for 'rentId'
 *   },
 * });
 */
export function useRemoveLeaseRentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeaseRentMutation, RemoveLeaseRentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeaseRentMutation, RemoveLeaseRentMutationVariables>(RemoveLeaseRentDocument, options);
      }
export type RemoveLeaseRentMutationHookResult = ReturnType<typeof useRemoveLeaseRentMutation>;
export type RemoveLeaseRentMutationResult = Apollo.MutationResult<RemoveLeaseRentMutation>;
export type RemoveLeaseRentMutationOptions = Apollo.BaseMutationOptions<RemoveLeaseRentMutation, RemoveLeaseRentMutationVariables>;
export const RemoveLeaseAttachmentDocument = gql`
    mutation removeLeaseAttachment($attachmentId: String!, $leaseId: String!) {
  removeLeaseAttachment(attachmentId: $attachmentId, leaseId: $leaseId)
}
    `;
export type RemoveLeaseAttachmentMutationFn = Apollo.MutationFunction<RemoveLeaseAttachmentMutation, RemoveLeaseAttachmentMutationVariables>;

/**
 * __useRemoveLeaseAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveLeaseAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeaseAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeaseAttachmentMutation, { data, loading, error }] = useRemoveLeaseAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      leaseId: // value for 'leaseId'
 *   },
 * });
 */
export function useRemoveLeaseAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeaseAttachmentMutation, RemoveLeaseAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeaseAttachmentMutation, RemoveLeaseAttachmentMutationVariables>(RemoveLeaseAttachmentDocument, options);
      }
export type RemoveLeaseAttachmentMutationHookResult = ReturnType<typeof useRemoveLeaseAttachmentMutation>;
export type RemoveLeaseAttachmentMutationResult = Apollo.MutationResult<RemoveLeaseAttachmentMutation>;
export type RemoveLeaseAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveLeaseAttachmentMutation, RemoveLeaseAttachmentMutationVariables>;
export const GetLeasesDocument = gql`
    query getLeases($take: Int! = 10, $after: String, $before: String, $search: String, $status: LeaseStatusEnum) {
  getLeases(
    take: $take
    after: $after
    before: $before
    search: $search
    status: $status
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      status
      leaseEnd
      leaseStart
      createdAt
      company {
        ...CompanyCoreFields
      }
      suites {
        ...SuiteCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetLeasesQuery__
 *
 * To run a query within a React component, call `useGetLeasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeasesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetLeasesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeasesQuery, GetLeasesQueryVariables>(GetLeasesDocument, options);
      }
export function useGetLeasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeasesQuery, GetLeasesQueryVariables>(GetLeasesDocument, options);
        }
export type GetLeasesQueryHookResult = ReturnType<typeof useGetLeasesQuery>;
export type GetLeasesLazyQueryHookResult = ReturnType<typeof useGetLeasesLazyQuery>;
export type GetLeasesQueryResult = Apollo.QueryResult<GetLeasesQuery, GetLeasesQueryVariables>;
export const GetLeaseDocument = gql`
    query getLease($leaseId: String!) {
  getLease(leaseId: $leaseId) {
    ...LeaseFields
  }
}
    ${LeaseFieldsFragmentDoc}`;

/**
 * __useGetLeaseQuery__
 *
 * To run a query within a React component, call `useGetLeaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseQuery({
 *   variables: {
 *      leaseId: // value for 'leaseId'
 *   },
 * });
 */
export function useGetLeaseQuery(baseOptions: Apollo.QueryHookOptions<GetLeaseQuery, GetLeaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseQuery, GetLeaseQueryVariables>(GetLeaseDocument, options);
      }
export function useGetLeaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseQuery, GetLeaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseQuery, GetLeaseQueryVariables>(GetLeaseDocument, options);
        }
export type GetLeaseQueryHookResult = ReturnType<typeof useGetLeaseQuery>;
export type GetLeaseLazyQueryHookResult = ReturnType<typeof useGetLeaseLazyQuery>;
export type GetLeaseQueryResult = Apollo.QueryResult<GetLeaseQuery, GetLeaseQueryVariables>;
export const CreateMarkupDocument = gql`
    mutation createMarkup($data: MarkUpInput!) {
  createMarkup(input: $data) {
    id
  }
}
    `;
export type CreateMarkupMutationFn = Apollo.MutationFunction<CreateMarkupMutation, CreateMarkupMutationVariables>;

/**
 * __useCreateMarkupMutation__
 *
 * To run a mutation, you first call `useCreateMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarkupMutation, { data, loading, error }] = useCreateMarkupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMarkupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarkupMutation, CreateMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarkupMutation, CreateMarkupMutationVariables>(CreateMarkupDocument, options);
      }
export type CreateMarkupMutationHookResult = ReturnType<typeof useCreateMarkupMutation>;
export type CreateMarkupMutationResult = Apollo.MutationResult<CreateMarkupMutation>;
export type CreateMarkupMutationOptions = Apollo.BaseMutationOptions<CreateMarkupMutation, CreateMarkupMutationVariables>;
export const UpdateMarkupDocument = gql`
    mutation updateMarkup($id: String!, $data: MarkUpInput!) {
  updateMarkup(id: $id, input: $data) {
    ...MarkupFields
  }
}
    ${MarkupFieldsFragmentDoc}`;
export type UpdateMarkupMutationFn = Apollo.MutationFunction<UpdateMarkupMutation, UpdateMarkupMutationVariables>;

/**
 * __useUpdateMarkupMutation__
 *
 * To run a mutation, you first call `useUpdateMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarkupMutation, { data, loading, error }] = useUpdateMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMarkupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarkupMutation, UpdateMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarkupMutation, UpdateMarkupMutationVariables>(UpdateMarkupDocument, options);
      }
export type UpdateMarkupMutationHookResult = ReturnType<typeof useUpdateMarkupMutation>;
export type UpdateMarkupMutationResult = Apollo.MutationResult<UpdateMarkupMutation>;
export type UpdateMarkupMutationOptions = Apollo.BaseMutationOptions<UpdateMarkupMutation, UpdateMarkupMutationVariables>;
export const ToggleMarkupDocument = gql`
    mutation toggleMarkup($id: String!) {
  toggleMarkup(id: $id)
}
    `;
export type ToggleMarkupMutationFn = Apollo.MutationFunction<ToggleMarkupMutation, ToggleMarkupMutationVariables>;

/**
 * __useToggleMarkupMutation__
 *
 * To run a mutation, you first call `useToggleMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMarkupMutation, { data, loading, error }] = useToggleMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleMarkupMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMarkupMutation, ToggleMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMarkupMutation, ToggleMarkupMutationVariables>(ToggleMarkupDocument, options);
      }
export type ToggleMarkupMutationHookResult = ReturnType<typeof useToggleMarkupMutation>;
export type ToggleMarkupMutationResult = Apollo.MutationResult<ToggleMarkupMutation>;
export type ToggleMarkupMutationOptions = Apollo.BaseMutationOptions<ToggleMarkupMutation, ToggleMarkupMutationVariables>;
export const RemoveMarkupsDocument = gql`
    mutation removeMarkups($data: DeleteRecordsInput!) {
  removeMarkups(input: $data)
}
    `;
export type RemoveMarkupsMutationFn = Apollo.MutationFunction<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>;

/**
 * __useRemoveMarkupsMutation__
 *
 * To run a mutation, you first call `useRemoveMarkupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarkupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarkupsMutation, { data, loading, error }] = useRemoveMarkupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveMarkupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>(RemoveMarkupsDocument, options);
      }
export type RemoveMarkupsMutationHookResult = ReturnType<typeof useRemoveMarkupsMutation>;
export type RemoveMarkupsMutationResult = Apollo.MutationResult<RemoveMarkupsMutation>;
export type RemoveMarkupsMutationOptions = Apollo.BaseMutationOptions<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>;
export const GetMarkupsTableDocument = gql`
    query getMarkupsTable($active: Boolean, $search: String) {
  getMarkups(active: $active, search: $search) {
    ...MarkupCoreFields
    index
    active
    type
    amount
    description
    propertyId
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMarkupsTableQuery__
 *
 * To run a query within a React component, call `useGetMarkupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupsTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMarkupsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>(GetMarkupsTableDocument, options);
      }
export function useGetMarkupsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>(GetMarkupsTableDocument, options);
        }
export type GetMarkupsTableQueryHookResult = ReturnType<typeof useGetMarkupsTableQuery>;
export type GetMarkupsTableLazyQueryHookResult = ReturnType<typeof useGetMarkupsTableLazyQuery>;
export type GetMarkupsTableQueryResult = Apollo.QueryResult<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>;
export const GetMarkupsDropdownDocument = gql`
    query getMarkupsDropdown($active: Boolean, $search: String, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getMarkups(active: $active, search: $search) {
    ...MarkupCoreFields
    active
    type
    amount
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMarkupsDropdownQuery__
 *
 * To run a query within a React component, call `useGetMarkupsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetMarkupsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>(GetMarkupsDropdownDocument, options);
      }
export function useGetMarkupsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>(GetMarkupsDropdownDocument, options);
        }
export type GetMarkupsDropdownQueryHookResult = ReturnType<typeof useGetMarkupsDropdownQuery>;
export type GetMarkupsDropdownLazyQueryHookResult = ReturnType<typeof useGetMarkupsDropdownLazyQuery>;
export type GetMarkupsDropdownQueryResult = Apollo.QueryResult<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>;
export const GetMarkupDocument = gql`
    query getMarkup($id: String!) {
  getMarkup(id: $id) {
    ...MarkupFields
  }
}
    ${MarkupFieldsFragmentDoc}`;

/**
 * __useGetMarkupQuery__
 *
 * To run a query within a React component, call `useGetMarkupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMarkupQuery(baseOptions: Apollo.QueryHookOptions<GetMarkupQuery, GetMarkupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupQuery, GetMarkupQueryVariables>(GetMarkupDocument, options);
      }
export function useGetMarkupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupQuery, GetMarkupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupQuery, GetMarkupQueryVariables>(GetMarkupDocument, options);
        }
export type GetMarkupQueryHookResult = ReturnType<typeof useGetMarkupQuery>;
export type GetMarkupLazyQueryHookResult = ReturnType<typeof useGetMarkupLazyQuery>;
export type GetMarkupQueryResult = Apollo.QueryResult<GetMarkupQuery, GetMarkupQueryVariables>;
export const CreateMaterialGroupDocument = gql`
    mutation createMaterialGroup($title: String!) {
  createMaterialGroup(title: $title) {
    id
  }
}
    `;
export type CreateMaterialGroupMutationFn = Apollo.MutationFunction<CreateMaterialGroupMutation, CreateMaterialGroupMutationVariables>;

/**
 * __useCreateMaterialGroupMutation__
 *
 * To run a mutation, you first call `useCreateMaterialGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterialGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterialGroupMutation, { data, loading, error }] = useCreateMaterialGroupMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateMaterialGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMaterialGroupMutation, CreateMaterialGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMaterialGroupMutation, CreateMaterialGroupMutationVariables>(CreateMaterialGroupDocument, options);
      }
export type CreateMaterialGroupMutationHookResult = ReturnType<typeof useCreateMaterialGroupMutation>;
export type CreateMaterialGroupMutationResult = Apollo.MutationResult<CreateMaterialGroupMutation>;
export type CreateMaterialGroupMutationOptions = Apollo.BaseMutationOptions<CreateMaterialGroupMutation, CreateMaterialGroupMutationVariables>;
export const UpdateMaterialGroupDocument = gql`
    mutation updateMaterialGroup($id: String!, $title: String!) {
  updateMaterialGroup(id: $id, title: $title) {
    ...MaterialGroupCoreFields
  }
}
    ${MaterialGroupCoreFieldsFragmentDoc}`;
export type UpdateMaterialGroupMutationFn = Apollo.MutationFunction<UpdateMaterialGroupMutation, UpdateMaterialGroupMutationVariables>;

/**
 * __useUpdateMaterialGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialGroupMutation, { data, loading, error }] = useUpdateMaterialGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateMaterialGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMaterialGroupMutation, UpdateMaterialGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMaterialGroupMutation, UpdateMaterialGroupMutationVariables>(UpdateMaterialGroupDocument, options);
      }
export type UpdateMaterialGroupMutationHookResult = ReturnType<typeof useUpdateMaterialGroupMutation>;
export type UpdateMaterialGroupMutationResult = Apollo.MutationResult<UpdateMaterialGroupMutation>;
export type UpdateMaterialGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMaterialGroupMutation, UpdateMaterialGroupMutationVariables>;
export const RemoveMaterialGroupsDocument = gql`
    mutation removeMaterialGroups($data: DeleteRecordsInput!) {
  removeMaterialGroups(input: $data)
}
    `;
export type RemoveMaterialGroupsMutationFn = Apollo.MutationFunction<RemoveMaterialGroupsMutation, RemoveMaterialGroupsMutationVariables>;

/**
 * __useRemoveMaterialGroupsMutation__
 *
 * To run a mutation, you first call `useRemoveMaterialGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMaterialGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMaterialGroupsMutation, { data, loading, error }] = useRemoveMaterialGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveMaterialGroupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMaterialGroupsMutation, RemoveMaterialGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMaterialGroupsMutation, RemoveMaterialGroupsMutationVariables>(RemoveMaterialGroupsDocument, options);
      }
export type RemoveMaterialGroupsMutationHookResult = ReturnType<typeof useRemoveMaterialGroupsMutation>;
export type RemoveMaterialGroupsMutationResult = Apollo.MutationResult<RemoveMaterialGroupsMutation>;
export type RemoveMaterialGroupsMutationOptions = Apollo.BaseMutationOptions<RemoveMaterialGroupsMutation, RemoveMaterialGroupsMutationVariables>;
export const GetMaterialGroupsTableDocument = gql`
    query getMaterialGroupsTable($take: Int! = 10, $after: String, $before: String, $search: String) {
  getMaterialGroups(take: $take, after: $after, before: $before, search: $search) @connection(key: "getMaterialGroupsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...MaterialGroupCoreFields
      index
      categoryCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${MaterialGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialGroupsTableQuery__
 *
 * To run a query within a React component, call `useGetMaterialGroupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialGroupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialGroupsTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMaterialGroupsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialGroupsTableQuery, GetMaterialGroupsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialGroupsTableQuery, GetMaterialGroupsTableQueryVariables>(GetMaterialGroupsTableDocument, options);
      }
export function useGetMaterialGroupsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialGroupsTableQuery, GetMaterialGroupsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialGroupsTableQuery, GetMaterialGroupsTableQueryVariables>(GetMaterialGroupsTableDocument, options);
        }
export type GetMaterialGroupsTableQueryHookResult = ReturnType<typeof useGetMaterialGroupsTableQuery>;
export type GetMaterialGroupsTableLazyQueryHookResult = ReturnType<typeof useGetMaterialGroupsTableLazyQuery>;
export type GetMaterialGroupsTableQueryResult = Apollo.QueryResult<GetMaterialGroupsTableQuery, GetMaterialGroupsTableQueryVariables>;
export const GetMaterialGroupsDropdownDocument = gql`
    query getMaterialGroupsDropdown($take: Int! = 10, $after: String, $before: String, $search: String) {
  getMaterialGroups(take: $take, after: $after, before: $before, search: $search) @connection(key: "getMaterialGroupsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...MaterialGroupCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${MaterialGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialGroupsDropdownQuery__
 *
 * To run a query within a React component, call `useGetMaterialGroupsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialGroupsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialGroupsDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMaterialGroupsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialGroupsDropdownQuery, GetMaterialGroupsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialGroupsDropdownQuery, GetMaterialGroupsDropdownQueryVariables>(GetMaterialGroupsDropdownDocument, options);
      }
export function useGetMaterialGroupsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialGroupsDropdownQuery, GetMaterialGroupsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialGroupsDropdownQuery, GetMaterialGroupsDropdownQueryVariables>(GetMaterialGroupsDropdownDocument, options);
        }
export type GetMaterialGroupsDropdownQueryHookResult = ReturnType<typeof useGetMaterialGroupsDropdownQuery>;
export type GetMaterialGroupsDropdownLazyQueryHookResult = ReturnType<typeof useGetMaterialGroupsDropdownLazyQuery>;
export type GetMaterialGroupsDropdownQueryResult = Apollo.QueryResult<GetMaterialGroupsDropdownQuery, GetMaterialGroupsDropdownQueryVariables>;
export const GetMaterialGroupDocument = gql`
    query getMaterialGroup($id: String!) {
  getMaterialGroup(id: $id) {
    ...MaterialGroupCoreFields
  }
}
    ${MaterialGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialGroupQuery__
 *
 * To run a query within a React component, call `useGetMaterialGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaterialGroupQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialGroupQuery, GetMaterialGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialGroupQuery, GetMaterialGroupQueryVariables>(GetMaterialGroupDocument, options);
      }
export function useGetMaterialGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialGroupQuery, GetMaterialGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialGroupQuery, GetMaterialGroupQueryVariables>(GetMaterialGroupDocument, options);
        }
export type GetMaterialGroupQueryHookResult = ReturnType<typeof useGetMaterialGroupQuery>;
export type GetMaterialGroupLazyQueryHookResult = ReturnType<typeof useGetMaterialGroupLazyQuery>;
export type GetMaterialGroupQueryResult = Apollo.QueryResult<GetMaterialGroupQuery, GetMaterialGroupQueryVariables>;
export const ExportMaterialGroupsDocument = gql`
    query exportMaterialGroups($search: String) {
  exportMaterialGroups(search: $search)
}
    `;

/**
 * __useExportMaterialGroupsQuery__
 *
 * To run a query within a React component, call `useExportMaterialGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMaterialGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMaterialGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportMaterialGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ExportMaterialGroupsQuery, ExportMaterialGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMaterialGroupsQuery, ExportMaterialGroupsQueryVariables>(ExportMaterialGroupsDocument, options);
      }
export function useExportMaterialGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMaterialGroupsQuery, ExportMaterialGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMaterialGroupsQuery, ExportMaterialGroupsQueryVariables>(ExportMaterialGroupsDocument, options);
        }
export type ExportMaterialGroupsQueryHookResult = ReturnType<typeof useExportMaterialGroupsQuery>;
export type ExportMaterialGroupsLazyQueryHookResult = ReturnType<typeof useExportMaterialGroupsLazyQuery>;
export type ExportMaterialGroupsQueryResult = Apollo.QueryResult<ExportMaterialGroupsQuery, ExportMaterialGroupsQueryVariables>;
export const CreateMaterialDocument = gql`
    mutation createMaterial($data: MaterialInput!) {
  createMaterial(input: $data) {
    id
  }
}
    `;
export type CreateMaterialMutationFn = Apollo.MutationFunction<CreateMaterialMutation, CreateMaterialMutationVariables>;

/**
 * __useCreateMaterialMutation__
 *
 * To run a mutation, you first call `useCreateMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaterialMutation, { data, loading, error }] = useCreateMaterialMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMaterialMutation(baseOptions?: Apollo.MutationHookOptions<CreateMaterialMutation, CreateMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMaterialMutation, CreateMaterialMutationVariables>(CreateMaterialDocument, options);
      }
export type CreateMaterialMutationHookResult = ReturnType<typeof useCreateMaterialMutation>;
export type CreateMaterialMutationResult = Apollo.MutationResult<CreateMaterialMutation>;
export type CreateMaterialMutationOptions = Apollo.BaseMutationOptions<CreateMaterialMutation, CreateMaterialMutationVariables>;
export const UpdateMaterialDocument = gql`
    mutation updateMaterial($id: String!, $data: MaterialInput!) {
  updateMaterial(id: $id, input: $data) {
    ...MaterialFields
  }
}
    ${MaterialFieldsFragmentDoc}`;
export type UpdateMaterialMutationFn = Apollo.MutationFunction<UpdateMaterialMutation, UpdateMaterialMutationVariables>;

/**
 * __useUpdateMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialMutation, { data, loading, error }] = useUpdateMaterialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMaterialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMaterialMutation, UpdateMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMaterialMutation, UpdateMaterialMutationVariables>(UpdateMaterialDocument, options);
      }
export type UpdateMaterialMutationHookResult = ReturnType<typeof useUpdateMaterialMutation>;
export type UpdateMaterialMutationResult = Apollo.MutationResult<UpdateMaterialMutation>;
export type UpdateMaterialMutationOptions = Apollo.BaseMutationOptions<UpdateMaterialMutation, UpdateMaterialMutationVariables>;
export const ToggleMaterialDocument = gql`
    mutation toggleMaterial($id: String!) {
  toggleMaterial(id: $id)
}
    `;
export type ToggleMaterialMutationFn = Apollo.MutationFunction<ToggleMaterialMutation, ToggleMaterialMutationVariables>;

/**
 * __useToggleMaterialMutation__
 *
 * To run a mutation, you first call `useToggleMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMaterialMutation, { data, loading, error }] = useToggleMaterialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleMaterialMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMaterialMutation, ToggleMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMaterialMutation, ToggleMaterialMutationVariables>(ToggleMaterialDocument, options);
      }
export type ToggleMaterialMutationHookResult = ReturnType<typeof useToggleMaterialMutation>;
export type ToggleMaterialMutationResult = Apollo.MutationResult<ToggleMaterialMutation>;
export type ToggleMaterialMutationOptions = Apollo.BaseMutationOptions<ToggleMaterialMutation, ToggleMaterialMutationVariables>;
export const RemoveMaterialsDocument = gql`
    mutation removeMaterials($data: DeleteRecordsInput!) {
  removeMaterials(input: $data)
}
    `;
export type RemoveMaterialsMutationFn = Apollo.MutationFunction<RemoveMaterialsMutation, RemoveMaterialsMutationVariables>;

/**
 * __useRemoveMaterialsMutation__
 *
 * To run a mutation, you first call `useRemoveMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMaterialsMutation, { data, loading, error }] = useRemoveMaterialsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMaterialsMutation, RemoveMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMaterialsMutation, RemoveMaterialsMutationVariables>(RemoveMaterialsDocument, options);
      }
export type RemoveMaterialsMutationHookResult = ReturnType<typeof useRemoveMaterialsMutation>;
export type RemoveMaterialsMutationResult = Apollo.MutationResult<RemoveMaterialsMutation>;
export type RemoveMaterialsMutationOptions = Apollo.BaseMutationOptions<RemoveMaterialsMutation, RemoveMaterialsMutationVariables>;
export const GetMaterialsTableDocument = gql`
    query getMaterialsTable($active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getMaterials(
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getMaterialsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...MaterialCoreFields
      index
      active
      price
      description
      group {
        ...MaterialGroupCoreFields
      }
      markup {
        ...MarkupCoreFields
      }
      tax {
        ...TaxCoreFields
      }
      glAccount {
        ...GLAccountCoreFields
      }
      arCode {
        ...ARCodeCoreFields
      }
      chargeCode {
        ...ChargeCodeCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${MaterialGroupCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialsTableQuery__
 *
 * To run a query within a React component, call `useGetMaterialsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMaterialsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialsTableQuery, GetMaterialsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsTableQuery, GetMaterialsTableQueryVariables>(GetMaterialsTableDocument, options);
      }
export function useGetMaterialsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsTableQuery, GetMaterialsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsTableQuery, GetMaterialsTableQueryVariables>(GetMaterialsTableDocument, options);
        }
export type GetMaterialsTableQueryHookResult = ReturnType<typeof useGetMaterialsTableQuery>;
export type GetMaterialsTableLazyQueryHookResult = ReturnType<typeof useGetMaterialsTableLazyQuery>;
export type GetMaterialsTableQueryResult = Apollo.QueryResult<GetMaterialsTableQuery, GetMaterialsTableQueryVariables>;
export const GetMaterialsDropdownDocument = gql`
    query getMaterialsDropdown($active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $includeGroup: Boolean!, $includeMarkup: Boolean!, $includeTax: Boolean!, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getMaterials(
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getMaterialsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...MaterialCoreFields
      active
      price
      group @include(if: $includeGroup) {
        ...MaterialGroupCoreFields
      }
      markup @include(if: $includeMarkup) {
        ...MarkupCoreFields
        type
        amount
      }
      tax @include(if: $includeTax) {
        ...TaxCoreFields
        amount
      }
      glAccount @include(if: $includeGLAccount) {
        ...GLAccountCoreFields
      }
      arCode @include(if: $includeARCode) {
        ...ARCodeCoreFields
      }
      chargeCode @include(if: $includeChargeCode) {
        ...ChargeCodeCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${MaterialGroupCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialsDropdownQuery__
 *
 * To run a query within a React component, call `useGetMaterialsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeGroup: // value for 'includeGroup'
 *      includeMarkup: // value for 'includeMarkup'
 *      includeTax: // value for 'includeTax'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetMaterialsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialsDropdownQuery, GetMaterialsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsDropdownQuery, GetMaterialsDropdownQueryVariables>(GetMaterialsDropdownDocument, options);
      }
export function useGetMaterialsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsDropdownQuery, GetMaterialsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsDropdownQuery, GetMaterialsDropdownQueryVariables>(GetMaterialsDropdownDocument, options);
        }
export type GetMaterialsDropdownQueryHookResult = ReturnType<typeof useGetMaterialsDropdownQuery>;
export type GetMaterialsDropdownLazyQueryHookResult = ReturnType<typeof useGetMaterialsDropdownLazyQuery>;
export type GetMaterialsDropdownQueryResult = Apollo.QueryResult<GetMaterialsDropdownQuery, GetMaterialsDropdownQueryVariables>;
export const GetMaterialsDropdownGroupedDocument = gql`
    query getMaterialsDropdownGrouped($active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $includeMarkup: Boolean!, $includeTax: Boolean!, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getMaterialsGrouped(
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      title
      materials {
        ...MaterialCoreFields
        active
        price
        markup @include(if: $includeMarkup) {
          ...MarkupCoreFields
          type
          amount
        }
        tax @include(if: $includeTax) {
          ...TaxCoreFields
          amount
        }
        glAccount @include(if: $includeGLAccount) {
          ...GLAccountCoreFields
        }
        arCode @include(if: $includeARCode) {
          ...ARCodeCoreFields
        }
        chargeCode @include(if: $includeChargeCode) {
          ...ChargeCodeCoreFields
        }
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMaterialsDropdownGroupedQuery__
 *
 * To run a query within a React component, call `useGetMaterialsDropdownGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsDropdownGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsDropdownGroupedQuery({
 *   variables: {
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      includeMarkup: // value for 'includeMarkup'
 *      includeTax: // value for 'includeTax'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetMaterialsDropdownGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialsDropdownGroupedQuery, GetMaterialsDropdownGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsDropdownGroupedQuery, GetMaterialsDropdownGroupedQueryVariables>(GetMaterialsDropdownGroupedDocument, options);
      }
export function useGetMaterialsDropdownGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsDropdownGroupedQuery, GetMaterialsDropdownGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsDropdownGroupedQuery, GetMaterialsDropdownGroupedQueryVariables>(GetMaterialsDropdownGroupedDocument, options);
        }
export type GetMaterialsDropdownGroupedQueryHookResult = ReturnType<typeof useGetMaterialsDropdownGroupedQuery>;
export type GetMaterialsDropdownGroupedLazyQueryHookResult = ReturnType<typeof useGetMaterialsDropdownGroupedLazyQuery>;
export type GetMaterialsDropdownGroupedQueryResult = Apollo.QueryResult<GetMaterialsDropdownGroupedQuery, GetMaterialsDropdownGroupedQueryVariables>;
export const GetMaterialDocument = gql`
    query getMaterial($id: String!) {
  getMaterial(id: $id) {
    ...MaterialFields
  }
}
    ${MaterialFieldsFragmentDoc}`;

/**
 * __useGetMaterialQuery__
 *
 * To run a query within a React component, call `useGetMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaterialQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialQuery, GetMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialQuery, GetMaterialQueryVariables>(GetMaterialDocument, options);
      }
export function useGetMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialQuery, GetMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialQuery, GetMaterialQueryVariables>(GetMaterialDocument, options);
        }
export type GetMaterialQueryHookResult = ReturnType<typeof useGetMaterialQuery>;
export type GetMaterialLazyQueryHookResult = ReturnType<typeof useGetMaterialLazyQuery>;
export type GetMaterialQueryResult = Apollo.QueryResult<GetMaterialQuery, GetMaterialQueryVariables>;
export const ExportMaterialsDocument = gql`
    query exportMaterials($active: Boolean, $search: String) {
  exportMaterials(active: $active, search: $search)
}
    `;

/**
 * __useExportMaterialsQuery__
 *
 * To run a query within a React component, call `useExportMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMaterialsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<ExportMaterialsQuery, ExportMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMaterialsQuery, ExportMaterialsQueryVariables>(ExportMaterialsDocument, options);
      }
export function useExportMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMaterialsQuery, ExportMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMaterialsQuery, ExportMaterialsQueryVariables>(ExportMaterialsDocument, options);
        }
export type ExportMaterialsQueryHookResult = ReturnType<typeof useExportMaterialsQuery>;
export type ExportMaterialsLazyQueryHookResult = ReturnType<typeof useExportMaterialsLazyQuery>;
export type ExportMaterialsQueryResult = Apollo.QueryResult<ExportMaterialsQuery, ExportMaterialsQueryVariables>;
export const SaveMenuDocument = gql`
    mutation saveMenu($data: SaveMenuInput!) {
  saveMenu(input: $data)
}
    `;
export type SaveMenuMutationFn = Apollo.MutationFunction<SaveMenuMutation, SaveMenuMutationVariables>;

/**
 * __useSaveMenuMutation__
 *
 * To run a mutation, you first call `useSaveMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMenuMutation, { data, loading, error }] = useSaveMenuMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveMenuMutation(baseOptions?: Apollo.MutationHookOptions<SaveMenuMutation, SaveMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMenuMutation, SaveMenuMutationVariables>(SaveMenuDocument, options);
      }
export type SaveMenuMutationHookResult = ReturnType<typeof useSaveMenuMutation>;
export type SaveMenuMutationResult = Apollo.MutationResult<SaveMenuMutation>;
export type SaveMenuMutationOptions = Apollo.BaseMutationOptions<SaveMenuMutation, SaveMenuMutationVariables>;
export const GetMenuDocument = gql`
    query getMenu($admin: Boolean = false, $location: MenuLocation!) {
  getMenu(admin: $admin, location: $location) {
    currentId
    title
    type
    featureId
    product {
      ...ProductCoreFields
    }
    url
    embedBody
    icon
    children {
      currentId
      title
      type
      featureId
      product {
        ...ProductCoreFields
      }
      url
      embedBody
      icon
      children {
        currentId
        title
        type
        featureId
        product {
          ...ProductCoreFields
        }
        url
        embedBody
        icon
      }
    }
  }
}
    ${ProductCoreFieldsFragmentDoc}`;

/**
 * __useGetMenuQuery__
 *
 * To run a query within a React component, call `useGetMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetMenuQuery(baseOptions: Apollo.QueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
      }
export function useGetMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
        }
export type GetMenuQueryHookResult = ReturnType<typeof useGetMenuQuery>;
export type GetMenuLazyQueryHookResult = ReturnType<typeof useGetMenuLazyQuery>;
export type GetMenuQueryResult = Apollo.QueryResult<GetMenuQuery, GetMenuQueryVariables>;
export const GetMenuFeaturesDocument = gql`
    query getMenuFeatures {
  getMenuFeatures {
    id
    title
    mobile
    web
    webUrl
    minPermissions {
      key
    }
    anyPermissions
  }
}
    `;

/**
 * __useGetMenuFeaturesQuery__
 *
 * To run a query within a React component, call `useGetMenuFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuFeaturesQuery, GetMenuFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuFeaturesQuery, GetMenuFeaturesQueryVariables>(GetMenuFeaturesDocument, options);
      }
export function useGetMenuFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuFeaturesQuery, GetMenuFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuFeaturesQuery, GetMenuFeaturesQueryVariables>(GetMenuFeaturesDocument, options);
        }
export type GetMenuFeaturesQueryHookResult = ReturnType<typeof useGetMenuFeaturesQuery>;
export type GetMenuFeaturesLazyQueryHookResult = ReturnType<typeof useGetMenuFeaturesLazyQuery>;
export type GetMenuFeaturesQueryResult = Apollo.QueryResult<GetMenuFeaturesQuery, GetMenuFeaturesQueryVariables>;
export const CreateNewsfeedDocument = gql`
    mutation createNewsfeed($data: NewsfeedInput!) {
  createNewsFeed(input: $data) {
    id
  }
}
    `;
export type CreateNewsfeedMutationFn = Apollo.MutationFunction<CreateNewsfeedMutation, CreateNewsfeedMutationVariables>;

/**
 * __useCreateNewsfeedMutation__
 *
 * To run a mutation, you first call `useCreateNewsfeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsfeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsfeedMutation, { data, loading, error }] = useCreateNewsfeedMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewsfeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsfeedMutation, CreateNewsfeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsfeedMutation, CreateNewsfeedMutationVariables>(CreateNewsfeedDocument, options);
      }
export type CreateNewsfeedMutationHookResult = ReturnType<typeof useCreateNewsfeedMutation>;
export type CreateNewsfeedMutationResult = Apollo.MutationResult<CreateNewsfeedMutation>;
export type CreateNewsfeedMutationOptions = Apollo.BaseMutationOptions<CreateNewsfeedMutation, CreateNewsfeedMutationVariables>;
export const UpdateNewsfeedDocument = gql`
    mutation updateNewsfeed($id: String!, $data: NewsfeedUpdateInput!) {
  updateNewsFeed(newsfeedId: $id, input: $data) {
    ...NewsfeedCoreFields
  }
}
    ${NewsfeedCoreFieldsFragmentDoc}`;
export type UpdateNewsfeedMutationFn = Apollo.MutationFunction<UpdateNewsfeedMutation, UpdateNewsfeedMutationVariables>;

/**
 * __useUpdateNewsfeedMutation__
 *
 * To run a mutation, you first call `useUpdateNewsfeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsfeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsfeedMutation, { data, loading, error }] = useUpdateNewsfeedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNewsfeedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsfeedMutation, UpdateNewsfeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsfeedMutation, UpdateNewsfeedMutationVariables>(UpdateNewsfeedDocument, options);
      }
export type UpdateNewsfeedMutationHookResult = ReturnType<typeof useUpdateNewsfeedMutation>;
export type UpdateNewsfeedMutationResult = Apollo.MutationResult<UpdateNewsfeedMutation>;
export type UpdateNewsfeedMutationOptions = Apollo.BaseMutationOptions<UpdateNewsfeedMutation, UpdateNewsfeedMutationVariables>;
export const NewsfeedToggleLikeDocument = gql`
    mutation newsfeedToggleLike($id: String!) {
  newsFeedToggleLike(newsfeedId: $id) {
    id
    likesList {
      id
      firstName
      lastName
    }
  }
}
    `;
export type NewsfeedToggleLikeMutationFn = Apollo.MutationFunction<NewsfeedToggleLikeMutation, NewsfeedToggleLikeMutationVariables>;

/**
 * __useNewsfeedToggleLikeMutation__
 *
 * To run a mutation, you first call `useNewsfeedToggleLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsfeedToggleLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsfeedToggleLikeMutation, { data, loading, error }] = useNewsfeedToggleLikeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsfeedToggleLikeMutation(baseOptions?: Apollo.MutationHookOptions<NewsfeedToggleLikeMutation, NewsfeedToggleLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewsfeedToggleLikeMutation, NewsfeedToggleLikeMutationVariables>(NewsfeedToggleLikeDocument, options);
      }
export type NewsfeedToggleLikeMutationHookResult = ReturnType<typeof useNewsfeedToggleLikeMutation>;
export type NewsfeedToggleLikeMutationResult = Apollo.MutationResult<NewsfeedToggleLikeMutation>;
export type NewsfeedToggleLikeMutationOptions = Apollo.BaseMutationOptions<NewsfeedToggleLikeMutation, NewsfeedToggleLikeMutationVariables>;
export const RemoveNewsfeedsDocument = gql`
    mutation removeNewsfeeds($data: DeleteRecordsInput!) {
  removeNewsFeeds(input: $data)
}
    `;
export type RemoveNewsfeedsMutationFn = Apollo.MutationFunction<RemoveNewsfeedsMutation, RemoveNewsfeedsMutationVariables>;

/**
 * __useRemoveNewsfeedsMutation__
 *
 * To run a mutation, you first call `useRemoveNewsfeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNewsfeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNewsfeedsMutation, { data, loading, error }] = useRemoveNewsfeedsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveNewsfeedsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNewsfeedsMutation, RemoveNewsfeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNewsfeedsMutation, RemoveNewsfeedsMutationVariables>(RemoveNewsfeedsDocument, options);
      }
export type RemoveNewsfeedsMutationHookResult = ReturnType<typeof useRemoveNewsfeedsMutation>;
export type RemoveNewsfeedsMutationResult = Apollo.MutationResult<RemoveNewsfeedsMutation>;
export type RemoveNewsfeedsMutationOptions = Apollo.BaseMutationOptions<RemoveNewsfeedsMutation, RemoveNewsfeedsMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($data: EventInput!) {
  createEvent(input: $data) {
    id
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const RegisterEventDocument = gql`
    mutation registerEvent($id: String!) {
  registerEvent(id: $id) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;
export type RegisterEventMutationFn = Apollo.MutationFunction<RegisterEventMutation, RegisterEventMutationVariables>;

/**
 * __useRegisterEventMutation__
 *
 * To run a mutation, you first call `useRegisterEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEventMutation, { data, loading, error }] = useRegisterEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisterEventMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEventMutation, RegisterEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEventMutation, RegisterEventMutationVariables>(RegisterEventDocument, options);
      }
export type RegisterEventMutationHookResult = ReturnType<typeof useRegisterEventMutation>;
export type RegisterEventMutationResult = Apollo.MutationResult<RegisterEventMutation>;
export type RegisterEventMutationOptions = Apollo.BaseMutationOptions<RegisterEventMutation, RegisterEventMutationVariables>;
export const UnRegisterEventDocument = gql`
    mutation unRegisterEvent($id: String!) {
  unRegisterEvent(id: $id) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;
export type UnRegisterEventMutationFn = Apollo.MutationFunction<UnRegisterEventMutation, UnRegisterEventMutationVariables>;

/**
 * __useUnRegisterEventMutation__
 *
 * To run a mutation, you first call `useUnRegisterEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnRegisterEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unRegisterEventMutation, { data, loading, error }] = useUnRegisterEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnRegisterEventMutation(baseOptions?: Apollo.MutationHookOptions<UnRegisterEventMutation, UnRegisterEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnRegisterEventMutation, UnRegisterEventMutationVariables>(UnRegisterEventDocument, options);
      }
export type UnRegisterEventMutationHookResult = ReturnType<typeof useUnRegisterEventMutation>;
export type UnRegisterEventMutationResult = Apollo.MutationResult<UnRegisterEventMutation>;
export type UnRegisterEventMutationOptions = Apollo.BaseMutationOptions<UnRegisterEventMutation, UnRegisterEventMutationVariables>;
export const SaveEventRatingDocument = gql`
    mutation saveEventRating($data: EventReviewInput!) {
  saveEventRating(input: $data) {
    id
    averageRating
    userRating {
      id
      score
      comment
    }
  }
}
    `;
export type SaveEventRatingMutationFn = Apollo.MutationFunction<SaveEventRatingMutation, SaveEventRatingMutationVariables>;

/**
 * __useSaveEventRatingMutation__
 *
 * To run a mutation, you first call `useSaveEventRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventRatingMutation, { data, loading, error }] = useSaveEventRatingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveEventRatingMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventRatingMutation, SaveEventRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventRatingMutation, SaveEventRatingMutationVariables>(SaveEventRatingDocument, options);
      }
export type SaveEventRatingMutationHookResult = ReturnType<typeof useSaveEventRatingMutation>;
export type SaveEventRatingMutationResult = Apollo.MutationResult<SaveEventRatingMutation>;
export type SaveEventRatingMutationOptions = Apollo.BaseMutationOptions<SaveEventRatingMutation, SaveEventRatingMutationVariables>;
export const SendEventMessageDocument = gql`
    mutation sendEventMessage($data: EventMessageInput!) {
  sendEventMessage(input: $data)
}
    `;
export type SendEventMessageMutationFn = Apollo.MutationFunction<SendEventMessageMutation, SendEventMessageMutationVariables>;

/**
 * __useSendEventMessageMutation__
 *
 * To run a mutation, you first call `useSendEventMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventMessageMutation, { data, loading, error }] = useSendEventMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendEventMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendEventMessageMutation, SendEventMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventMessageMutation, SendEventMessageMutationVariables>(SendEventMessageDocument, options);
      }
export type SendEventMessageMutationHookResult = ReturnType<typeof useSendEventMessageMutation>;
export type SendEventMessageMutationResult = Apollo.MutationResult<SendEventMessageMutation>;
export type SendEventMessageMutationOptions = Apollo.BaseMutationOptions<SendEventMessageMutation, SendEventMessageMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($eventId: String!, $data: EventUpdateInput!, $type: EventUpdateType! = SINGLE) {
  updateEvent(eventId: $eventId, input: $data, type: $type) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const RemoveEventDocument = gql`
    mutation removeEvent($eventId: String!, $type: EventUpdateType! = SINGLE) {
  removeEvent(eventId: $eventId, type: $type)
}
    `;
export type RemoveEventMutationFn = Apollo.MutationFunction<RemoveEventMutation, RemoveEventMutationVariables>;

/**
 * __useRemoveEventMutation__
 *
 * To run a mutation, you first call `useRemoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventMutation, { data, loading, error }] = useRemoveEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventMutation, RemoveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventMutation, RemoveEventMutationVariables>(RemoveEventDocument, options);
      }
export type RemoveEventMutationHookResult = ReturnType<typeof useRemoveEventMutation>;
export type RemoveEventMutationResult = Apollo.MutationResult<RemoveEventMutation>;
export type RemoveEventMutationOptions = Apollo.BaseMutationOptions<RemoveEventMutation, RemoveEventMutationVariables>;
export const GetNewsEventsDocument = gql`
    query getNewsEvents($from: DateTime!, $to: DateTime!, $type: EventNewsEnum) {
  getNewsEvents(from: $from, to: $to, type: $type) {
    type
    event {
      ...EventFields
    }
    news {
      ...NewsfeedFields
    }
  }
}
    ${EventFieldsFragmentDoc}
${NewsfeedFieldsFragmentDoc}`;

/**
 * __useGetNewsEventsQuery__
 *
 * To run a query within a React component, call `useGetNewsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsEventsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetNewsEventsQuery(baseOptions: Apollo.QueryHookOptions<GetNewsEventsQuery, GetNewsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsEventsQuery, GetNewsEventsQueryVariables>(GetNewsEventsDocument, options);
      }
export function useGetNewsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsEventsQuery, GetNewsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsEventsQuery, GetNewsEventsQueryVariables>(GetNewsEventsDocument, options);
        }
export type GetNewsEventsQueryHookResult = ReturnType<typeof useGetNewsEventsQuery>;
export type GetNewsEventsLazyQueryHookResult = ReturnType<typeof useGetNewsEventsLazyQuery>;
export type GetNewsEventsQueryResult = Apollo.QueryResult<GetNewsEventsQuery, GetNewsEventsQueryVariables>;
export const GetNewsFeedDocument = gql`
    query getNewsFeed($newsfeedId: String!) {
  getNewsFeed(newsfeedId: $newsfeedId) {
    ...NewsfeedCoreFields
  }
}
    ${NewsfeedCoreFieldsFragmentDoc}`;

/**
 * __useGetNewsFeedQuery__
 *
 * To run a query within a React component, call `useGetNewsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsFeedQuery({
 *   variables: {
 *      newsfeedId: // value for 'newsfeedId'
 *   },
 * });
 */
export function useGetNewsFeedQuery(baseOptions: Apollo.QueryHookOptions<GetNewsFeedQuery, GetNewsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsFeedQuery, GetNewsFeedQueryVariables>(GetNewsFeedDocument, options);
      }
export function useGetNewsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsFeedQuery, GetNewsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsFeedQuery, GetNewsFeedQueryVariables>(GetNewsFeedDocument, options);
        }
export type GetNewsFeedQueryHookResult = ReturnType<typeof useGetNewsFeedQuery>;
export type GetNewsFeedLazyQueryHookResult = ReturnType<typeof useGetNewsFeedLazyQuery>;
export type GetNewsFeedQueryResult = Apollo.QueryResult<GetNewsFeedQuery, GetNewsFeedQueryVariables>;
export const GetEventDocument = gql`
    query getEvent($id: String!) {
  getEvent(id: $id) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventAttendanceDocument = gql`
    query getEventAttendance($eventId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getEventAttendance(
    eventId: $eventId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      createdAt
      user {
        ...UserCoreFields
      }
      score
      comment
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetEventAttendanceQuery__
 *
 * To run a query within a React component, call `useGetEventAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendanceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEventAttendanceQuery(baseOptions: Apollo.QueryHookOptions<GetEventAttendanceQuery, GetEventAttendanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAttendanceQuery, GetEventAttendanceQueryVariables>(GetEventAttendanceDocument, options);
      }
export function useGetEventAttendanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAttendanceQuery, GetEventAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAttendanceQuery, GetEventAttendanceQueryVariables>(GetEventAttendanceDocument, options);
        }
export type GetEventAttendanceQueryHookResult = ReturnType<typeof useGetEventAttendanceQuery>;
export type GetEventAttendanceLazyQueryHookResult = ReturnType<typeof useGetEventAttendanceLazyQuery>;
export type GetEventAttendanceQueryResult = Apollo.QueryResult<GetEventAttendanceQuery, GetEventAttendanceQueryVariables>;
export const ExportEventAttendanceDocument = gql`
    query exportEventAttendance($eventId: String!, $search: String) {
  exportEventAttendance(eventId: $eventId, search: $search)
}
    `;

/**
 * __useExportEventAttendanceQuery__
 *
 * To run a query within a React component, call `useExportEventAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEventAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEventAttendanceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportEventAttendanceQuery(baseOptions: Apollo.QueryHookOptions<ExportEventAttendanceQuery, ExportEventAttendanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEventAttendanceQuery, ExportEventAttendanceQueryVariables>(ExportEventAttendanceDocument, options);
      }
export function useExportEventAttendanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEventAttendanceQuery, ExportEventAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEventAttendanceQuery, ExportEventAttendanceQueryVariables>(ExportEventAttendanceDocument, options);
        }
export type ExportEventAttendanceQueryHookResult = ReturnType<typeof useExportEventAttendanceQuery>;
export type ExportEventAttendanceLazyQueryHookResult = ReturnType<typeof useExportEventAttendanceLazyQuery>;
export type ExportEventAttendanceQueryResult = Apollo.QueryResult<ExportEventAttendanceQuery, ExportEventAttendanceQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($id: String!) {
  markNotificationAsRead(id: $id)
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  markAllNotificationsAsRead
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($take: Int! = 10, $after: String, $before: String, $notificationCategory: NotificationCategoryEnum) {
  getMyNotifications(
    take: $take
    after: $after
    before: $before
    notificationCategory: $notificationCategory
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...NotificationFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${NotificationFieldsFragmentDoc}`;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      notificationCategory: // value for 'notificationCategory'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetMyUnreadNotificationsDocument = gql`
    query getMyUnreadNotifications {
  getMyUnreadNotifications
}
    `;

/**
 * __useGetMyUnreadNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyUnreadNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUnreadNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUnreadNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUnreadNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyUnreadNotificationsQuery, GetMyUnreadNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUnreadNotificationsQuery, GetMyUnreadNotificationsQueryVariables>(GetMyUnreadNotificationsDocument, options);
      }
export function useGetMyUnreadNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUnreadNotificationsQuery, GetMyUnreadNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUnreadNotificationsQuery, GetMyUnreadNotificationsQueryVariables>(GetMyUnreadNotificationsDocument, options);
        }
export type GetMyUnreadNotificationsQueryHookResult = ReturnType<typeof useGetMyUnreadNotificationsQuery>;
export type GetMyUnreadNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyUnreadNotificationsLazyQuery>;
export type GetMyUnreadNotificationsQueryResult = Apollo.QueryResult<GetMyUnreadNotificationsQuery, GetMyUnreadNotificationsQueryVariables>;
export const OnNotificationAddedDocument = gql`
    subscription OnNotificationAdded($notificationCategory: NotificationCategoryEnum) {
  notificationAdded(notificationCategory: $notificationCategory) {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useOnNotificationAddedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationAddedSubscription({
 *   variables: {
 *      notificationCategory: // value for 'notificationCategory'
 *   },
 * });
 */
export function useOnNotificationAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNotificationAddedSubscription, OnNotificationAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationAddedSubscription, OnNotificationAddedSubscriptionVariables>(OnNotificationAddedDocument, options);
      }
export type OnNotificationAddedSubscriptionHookResult = ReturnType<typeof useOnNotificationAddedSubscription>;
export type OnNotificationAddedSubscriptionResult = Apollo.SubscriptionResult<OnNotificationAddedSubscription>;
export const CreatePackagesDocument = gql`
    mutation createPackages($data: [PackageCreateInput!]!) {
  createPackages(input: $data) {
    id
  }
}
    `;
export type CreatePackagesMutationFn = Apollo.MutationFunction<CreatePackagesMutation, CreatePackagesMutationVariables>;

/**
 * __useCreatePackagesMutation__
 *
 * To run a mutation, you first call `useCreatePackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackagesMutation, { data, loading, error }] = useCreatePackagesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePackagesMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackagesMutation, CreatePackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackagesMutation, CreatePackagesMutationVariables>(CreatePackagesDocument, options);
      }
export type CreatePackagesMutationHookResult = ReturnType<typeof useCreatePackagesMutation>;
export type CreatePackagesMutationResult = Apollo.MutationResult<CreatePackagesMutation>;
export type CreatePackagesMutationOptions = Apollo.BaseMutationOptions<CreatePackagesMutation, CreatePackagesMutationVariables>;
export const UpdatePackagesDocument = gql`
    mutation updatePackages($id: String!, $data: PackageUpdateInput!) {
  updatePackages(id: $id, input: $data) {
    ...PackageFields
  }
}
    ${PackageFieldsFragmentDoc}`;
export type UpdatePackagesMutationFn = Apollo.MutationFunction<UpdatePackagesMutation, UpdatePackagesMutationVariables>;

/**
 * __useUpdatePackagesMutation__
 *
 * To run a mutation, you first call `useUpdatePackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackagesMutation, { data, loading, error }] = useUpdatePackagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePackagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackagesMutation, UpdatePackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackagesMutation, UpdatePackagesMutationVariables>(UpdatePackagesDocument, options);
      }
export type UpdatePackagesMutationHookResult = ReturnType<typeof useUpdatePackagesMutation>;
export type UpdatePackagesMutationResult = Apollo.MutationResult<UpdatePackagesMutation>;
export type UpdatePackagesMutationOptions = Apollo.BaseMutationOptions<UpdatePackagesMutation, UpdatePackagesMutationVariables>;
export const DeletePackagesDocument = gql`
    mutation deletePackages($data: DeleteRecordsInput!) {
  deletePackages(input: $data)
}
    `;
export type DeletePackagesMutationFn = Apollo.MutationFunction<DeletePackagesMutation, DeletePackagesMutationVariables>;

/**
 * __useDeletePackagesMutation__
 *
 * To run a mutation, you first call `useDeletePackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackagesMutation, { data, loading, error }] = useDeletePackagesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePackagesMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackagesMutation, DeletePackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackagesMutation, DeletePackagesMutationVariables>(DeletePackagesDocument, options);
      }
export type DeletePackagesMutationHookResult = ReturnType<typeof useDeletePackagesMutation>;
export type DeletePackagesMutationResult = Apollo.MutationResult<DeletePackagesMutation>;
export type DeletePackagesMutationOptions = Apollo.BaseMutationOptions<DeletePackagesMutation, DeletePackagesMutationVariables>;
export const BulkStatusPackagesDocument = gql`
    mutation bulkStatusPackages($ids: [String!]!, $status: PackageStatusType!) {
  bulkStatusPackages(ids: $ids, status: $status) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status
    }
  }
}
    `;
export type BulkStatusPackagesMutationFn = Apollo.MutationFunction<BulkStatusPackagesMutation, BulkStatusPackagesMutationVariables>;

/**
 * __useBulkStatusPackagesMutation__
 *
 * To run a mutation, you first call `useBulkStatusPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusPackagesMutation, { data, loading, error }] = useBulkStatusPackagesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkStatusPackagesMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusPackagesMutation, BulkStatusPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusPackagesMutation, BulkStatusPackagesMutationVariables>(BulkStatusPackagesDocument, options);
      }
export type BulkStatusPackagesMutationHookResult = ReturnType<typeof useBulkStatusPackagesMutation>;
export type BulkStatusPackagesMutationResult = Apollo.MutationResult<BulkStatusPackagesMutation>;
export type BulkStatusPackagesMutationOptions = Apollo.BaseMutationOptions<BulkStatusPackagesMutation, BulkStatusPackagesMutationVariables>;
export const DeletePackageAttachmentDocument = gql`
    mutation deletePackageAttachment($attachmentId: String!, $id: String!) {
  deletePackageAttachment(attachmentId: $attachmentId, id: $id) {
    ...PackageFields
  }
}
    ${PackageFieldsFragmentDoc}`;
export type DeletePackageAttachmentMutationFn = Apollo.MutationFunction<DeletePackageAttachmentMutation, DeletePackageAttachmentMutationVariables>;

/**
 * __useDeletePackageAttachmentMutation__
 *
 * To run a mutation, you first call `useDeletePackageAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageAttachmentMutation, { data, loading, error }] = useDeletePackageAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageAttachmentMutation, DeletePackageAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageAttachmentMutation, DeletePackageAttachmentMutationVariables>(DeletePackageAttachmentDocument, options);
      }
export type DeletePackageAttachmentMutationHookResult = ReturnType<typeof useDeletePackageAttachmentMutation>;
export type DeletePackageAttachmentMutationResult = Apollo.MutationResult<DeletePackageAttachmentMutation>;
export type DeletePackageAttachmentMutationOptions = Apollo.BaseMutationOptions<DeletePackageAttachmentMutation, DeletePackageAttachmentMutationVariables>;
export const AddPackageAttachmentsDocument = gql`
    mutation addPackageAttachments($attachments: [FileObjectInput!]!, $id: String!) {
  addPackageAttachments(attachments: $attachments, id: $id) {
    ...PackageFields
  }
}
    ${PackageFieldsFragmentDoc}`;
export type AddPackageAttachmentsMutationFn = Apollo.MutationFunction<AddPackageAttachmentsMutation, AddPackageAttachmentsMutationVariables>;

/**
 * __useAddPackageAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddPackageAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageAttachmentsMutation, { data, loading, error }] = useAddPackageAttachmentsMutation({
 *   variables: {
 *      attachments: // value for 'attachments'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddPackageAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageAttachmentsMutation, AddPackageAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageAttachmentsMutation, AddPackageAttachmentsMutationVariables>(AddPackageAttachmentsDocument, options);
      }
export type AddPackageAttachmentsMutationHookResult = ReturnType<typeof useAddPackageAttachmentsMutation>;
export type AddPackageAttachmentsMutationResult = Apollo.MutationResult<AddPackageAttachmentsMutation>;
export type AddPackageAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddPackageAttachmentsMutation, AddPackageAttachmentsMutationVariables>;
export const GetPackagesDocument = gql`
    query getPackages($take: Int! = 10, $after: String, $before: String, $search: String, $status: PackageStatusType, $companyIds: [String!], $userIds: [String!]) {
  getPackages(
    take: $take
    after: $after
    before: $before
    search: $search
    status: $status
    companyIds: $companyIds
    userIds: $userIds
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...PackageFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PackageFieldsFragmentDoc}`;

/**
 * __useGetPackagesQuery__
 *
 * To run a query within a React component, call `useGetPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      companyIds: // value for 'companyIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagesQuery, GetPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesQuery, GetPackagesQueryVariables>(GetPackagesDocument, options);
      }
export function useGetPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesQuery, GetPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesQuery, GetPackagesQueryVariables>(GetPackagesDocument, options);
        }
export type GetPackagesQueryHookResult = ReturnType<typeof useGetPackagesQuery>;
export type GetPackagesLazyQueryHookResult = ReturnType<typeof useGetPackagesLazyQuery>;
export type GetPackagesQueryResult = Apollo.QueryResult<GetPackagesQuery, GetPackagesQueryVariables>;
export const GetPackageDocument = gql`
    query getPackage($id: String!) {
  getPackage(id: $id) {
    ...PackageFields
  }
}
    ${PackageFieldsFragmentDoc}`;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<GetPackageQuery, GetPackageQueryVariables>;
export const GetPaymentsDocument = gql`
    query getPayments($take: Int! = 10, $after: String, $before: String, $search: String) {
  getPayments(take: $take, after: $after, before: $before, search: $search) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      status
      createdAt
      startDate
      type
      subscriptionId
      productData {
        title
      }
      priceData {
        title
        paidPrice
        billingPeriod
        type
      }
      couponData {
        id
      }
      company {
        ...CompanyCoreFields
      }
      user {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetPaymentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
      }
export function useGetPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
        }
export type GetPaymentsQueryHookResult = ReturnType<typeof useGetPaymentsQuery>;
export type GetPaymentsLazyQueryHookResult = ReturnType<typeof useGetPaymentsLazyQuery>;
export type GetPaymentsQueryResult = Apollo.QueryResult<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetPaymentDocument = gql`
    query getPayment($paymentId: String!) {
  getPayment(paymentId: $paymentId) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const ValidatePortfolioUrlDocument = gql`
    query validatePortfolioURL($url: String!) {
  validatePortfolioURL(url: $url) {
    id
    title
    url
    stripePublishableKey
    logo {
      ...FileFields
    }
    background {
      ...FileFields
    }
    translation {
      ...TranslationFields
    }
    translations {
      ...TranslationFields
    }
  }
}
    ${FileFieldsFragmentDoc}
${TranslationFieldsFragmentDoc}`;

/**
 * __useValidatePortfolioUrlQuery__
 *
 * To run a query within a React component, call `useValidatePortfolioUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePortfolioUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePortfolioUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useValidatePortfolioUrlQuery(baseOptions: Apollo.QueryHookOptions<ValidatePortfolioUrlQuery, ValidatePortfolioUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePortfolioUrlQuery, ValidatePortfolioUrlQueryVariables>(ValidatePortfolioUrlDocument, options);
      }
export function useValidatePortfolioUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePortfolioUrlQuery, ValidatePortfolioUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePortfolioUrlQuery, ValidatePortfolioUrlQueryVariables>(ValidatePortfolioUrlDocument, options);
        }
export type ValidatePortfolioUrlQueryHookResult = ReturnType<typeof useValidatePortfolioUrlQuery>;
export type ValidatePortfolioUrlLazyQueryHookResult = ReturnType<typeof useValidatePortfolioUrlLazyQuery>;
export type ValidatePortfolioUrlQueryResult = Apollo.QueryResult<ValidatePortfolioUrlQuery, ValidatePortfolioUrlQueryVariables>;
export const CreatePmCustomIdDocument = gql`
    mutation createPMCustomId($title: String!) {
  createPMCustomId(title: $title) {
    id
  }
}
    `;
export type CreatePmCustomIdMutationFn = Apollo.MutationFunction<CreatePmCustomIdMutation, CreatePmCustomIdMutationVariables>;

/**
 * __useCreatePmCustomIdMutation__
 *
 * To run a mutation, you first call `useCreatePmCustomIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePmCustomIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPmCustomIdMutation, { data, loading, error }] = useCreatePmCustomIdMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreatePmCustomIdMutation(baseOptions?: Apollo.MutationHookOptions<CreatePmCustomIdMutation, CreatePmCustomIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePmCustomIdMutation, CreatePmCustomIdMutationVariables>(CreatePmCustomIdDocument, options);
      }
export type CreatePmCustomIdMutationHookResult = ReturnType<typeof useCreatePmCustomIdMutation>;
export type CreatePmCustomIdMutationResult = Apollo.MutationResult<CreatePmCustomIdMutation>;
export type CreatePmCustomIdMutationOptions = Apollo.BaseMutationOptions<CreatePmCustomIdMutation, CreatePmCustomIdMutationVariables>;
export const UpdatePmCustomIdDocument = gql`
    mutation updatePMCustomId($id: String!, $title: String!) {
  updatePMCustomId(id: $id, title: $title) {
    ...PMCustomIdCoreFields
  }
}
    ${PmCustomIdCoreFieldsFragmentDoc}`;
export type UpdatePmCustomIdMutationFn = Apollo.MutationFunction<UpdatePmCustomIdMutation, UpdatePmCustomIdMutationVariables>;

/**
 * __useUpdatePmCustomIdMutation__
 *
 * To run a mutation, you first call `useUpdatePmCustomIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePmCustomIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePmCustomIdMutation, { data, loading, error }] = useUpdatePmCustomIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdatePmCustomIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePmCustomIdMutation, UpdatePmCustomIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePmCustomIdMutation, UpdatePmCustomIdMutationVariables>(UpdatePmCustomIdDocument, options);
      }
export type UpdatePmCustomIdMutationHookResult = ReturnType<typeof useUpdatePmCustomIdMutation>;
export type UpdatePmCustomIdMutationResult = Apollo.MutationResult<UpdatePmCustomIdMutation>;
export type UpdatePmCustomIdMutationOptions = Apollo.BaseMutationOptions<UpdatePmCustomIdMutation, UpdatePmCustomIdMutationVariables>;
export const TogglePmCustomIdDocument = gql`
    mutation togglePMCustomId($id: String!) {
  togglePMCustomId(id: $id)
}
    `;
export type TogglePmCustomIdMutationFn = Apollo.MutationFunction<TogglePmCustomIdMutation, TogglePmCustomIdMutationVariables>;

/**
 * __useTogglePmCustomIdMutation__
 *
 * To run a mutation, you first call `useTogglePmCustomIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePmCustomIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePmCustomIdMutation, { data, loading, error }] = useTogglePmCustomIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePmCustomIdMutation(baseOptions?: Apollo.MutationHookOptions<TogglePmCustomIdMutation, TogglePmCustomIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePmCustomIdMutation, TogglePmCustomIdMutationVariables>(TogglePmCustomIdDocument, options);
      }
export type TogglePmCustomIdMutationHookResult = ReturnType<typeof useTogglePmCustomIdMutation>;
export type TogglePmCustomIdMutationResult = Apollo.MutationResult<TogglePmCustomIdMutation>;
export type TogglePmCustomIdMutationOptions = Apollo.BaseMutationOptions<TogglePmCustomIdMutation, TogglePmCustomIdMutationVariables>;
export const RemovePmCustomIdsDocument = gql`
    mutation removePMCustomIds($data: DeleteRecordsInput!) {
  removePMCustomIds(input: $data)
}
    `;
export type RemovePmCustomIdsMutationFn = Apollo.MutationFunction<RemovePmCustomIdsMutation, RemovePmCustomIdsMutationVariables>;

/**
 * __useRemovePmCustomIdsMutation__
 *
 * To run a mutation, you first call `useRemovePmCustomIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePmCustomIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePmCustomIdsMutation, { data, loading, error }] = useRemovePmCustomIdsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePmCustomIdsMutation(baseOptions?: Apollo.MutationHookOptions<RemovePmCustomIdsMutation, RemovePmCustomIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePmCustomIdsMutation, RemovePmCustomIdsMutationVariables>(RemovePmCustomIdsDocument, options);
      }
export type RemovePmCustomIdsMutationHookResult = ReturnType<typeof useRemovePmCustomIdsMutation>;
export type RemovePmCustomIdsMutationResult = Apollo.MutationResult<RemovePmCustomIdsMutation>;
export type RemovePmCustomIdsMutationOptions = Apollo.BaseMutationOptions<RemovePmCustomIdsMutation, RemovePmCustomIdsMutationVariables>;
export const GetPmCustomIdsDocument = gql`
    query getPMCustomIds($active: Boolean, $search: String) {
  getPMCustomIds(active: $active, search: $search) {
    ...PMCustomIdCoreFields
    index
    active
    createdAt
  }
}
    ${PmCustomIdCoreFieldsFragmentDoc}`;

/**
 * __useGetPmCustomIdsQuery__
 *
 * To run a query within a React component, call `useGetPmCustomIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmCustomIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmCustomIdsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPmCustomIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetPmCustomIdsQuery, GetPmCustomIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmCustomIdsQuery, GetPmCustomIdsQueryVariables>(GetPmCustomIdsDocument, options);
      }
export function useGetPmCustomIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmCustomIdsQuery, GetPmCustomIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmCustomIdsQuery, GetPmCustomIdsQueryVariables>(GetPmCustomIdsDocument, options);
        }
export type GetPmCustomIdsQueryHookResult = ReturnType<typeof useGetPmCustomIdsQuery>;
export type GetPmCustomIdsLazyQueryHookResult = ReturnType<typeof useGetPmCustomIdsLazyQuery>;
export type GetPmCustomIdsQueryResult = Apollo.QueryResult<GetPmCustomIdsQuery, GetPmCustomIdsQueryVariables>;
export const GetPmCustomIdsDropdownDocument = gql`
    query getPMCustomIdsDropdown($active: Boolean, $search: String) {
  getPMCustomIds(active: $active, search: $search) {
    ...PMCustomIdCoreFields
    index
    active
  }
}
    ${PmCustomIdCoreFieldsFragmentDoc}`;

/**
 * __useGetPmCustomIdsDropdownQuery__
 *
 * To run a query within a React component, call `useGetPmCustomIdsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmCustomIdsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmCustomIdsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPmCustomIdsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetPmCustomIdsDropdownQuery, GetPmCustomIdsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmCustomIdsDropdownQuery, GetPmCustomIdsDropdownQueryVariables>(GetPmCustomIdsDropdownDocument, options);
      }
export function useGetPmCustomIdsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmCustomIdsDropdownQuery, GetPmCustomIdsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmCustomIdsDropdownQuery, GetPmCustomIdsDropdownQueryVariables>(GetPmCustomIdsDropdownDocument, options);
        }
export type GetPmCustomIdsDropdownQueryHookResult = ReturnType<typeof useGetPmCustomIdsDropdownQuery>;
export type GetPmCustomIdsDropdownLazyQueryHookResult = ReturnType<typeof useGetPmCustomIdsDropdownLazyQuery>;
export type GetPmCustomIdsDropdownQueryResult = Apollo.QueryResult<GetPmCustomIdsDropdownQuery, GetPmCustomIdsDropdownQueryVariables>;
export const GetPmCustomIdDocument = gql`
    query getPMCustomId($id: String!) {
  getPMCustomId(id: $id) {
    ...PMCustomIdCoreFields
  }
}
    ${PmCustomIdCoreFieldsFragmentDoc}`;

/**
 * __useGetPmCustomIdQuery__
 *
 * To run a query within a React component, call `useGetPmCustomIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmCustomIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmCustomIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPmCustomIdQuery(baseOptions: Apollo.QueryHookOptions<GetPmCustomIdQuery, GetPmCustomIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmCustomIdQuery, GetPmCustomIdQueryVariables>(GetPmCustomIdDocument, options);
      }
export function useGetPmCustomIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmCustomIdQuery, GetPmCustomIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmCustomIdQuery, GetPmCustomIdQueryVariables>(GetPmCustomIdDocument, options);
        }
export type GetPmCustomIdQueryHookResult = ReturnType<typeof useGetPmCustomIdQuery>;
export type GetPmCustomIdLazyQueryHookResult = ReturnType<typeof useGetPmCustomIdLazyQuery>;
export type GetPmCustomIdQueryResult = Apollo.QueryResult<GetPmCustomIdQuery, GetPmCustomIdQueryVariables>;
export const CreateEquipmentCategoryDocument = gql`
    mutation createEquipmentCategory($data: EquipmentCategoryInput!) {
  createEquipmentCategory(input: $data) {
    id
  }
}
    `;
export type CreateEquipmentCategoryMutationFn = Apollo.MutationFunction<CreateEquipmentCategoryMutation, CreateEquipmentCategoryMutationVariables>;

/**
 * __useCreateEquipmentCategoryMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentCategoryMutation, { data, loading, error }] = useCreateEquipmentCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEquipmentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentCategoryMutation, CreateEquipmentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentCategoryMutation, CreateEquipmentCategoryMutationVariables>(CreateEquipmentCategoryDocument, options);
      }
export type CreateEquipmentCategoryMutationHookResult = ReturnType<typeof useCreateEquipmentCategoryMutation>;
export type CreateEquipmentCategoryMutationResult = Apollo.MutationResult<CreateEquipmentCategoryMutation>;
export type CreateEquipmentCategoryMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentCategoryMutation, CreateEquipmentCategoryMutationVariables>;
export const UpdateEquipmentCategoryDocument = gql`
    mutation updateEquipmentCategory($id: String!, $data: EquipmentCategoryInput!) {
  updateEquipmentCategory(id: $id, input: $data) {
    ...EquipmentCategoryCoreFields
  }
}
    ${EquipmentCategoryCoreFieldsFragmentDoc}`;
export type UpdateEquipmentCategoryMutationFn = Apollo.MutationFunction<UpdateEquipmentCategoryMutation, UpdateEquipmentCategoryMutationVariables>;

/**
 * __useUpdateEquipmentCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentCategoryMutation, { data, loading, error }] = useUpdateEquipmentCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEquipmentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentCategoryMutation, UpdateEquipmentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentCategoryMutation, UpdateEquipmentCategoryMutationVariables>(UpdateEquipmentCategoryDocument, options);
      }
export type UpdateEquipmentCategoryMutationHookResult = ReturnType<typeof useUpdateEquipmentCategoryMutation>;
export type UpdateEquipmentCategoryMutationResult = Apollo.MutationResult<UpdateEquipmentCategoryMutation>;
export type UpdateEquipmentCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentCategoryMutation, UpdateEquipmentCategoryMutationVariables>;
export const RemoveEquipmentCategoriesDocument = gql`
    mutation removeEquipmentCategories($data: DeleteRecordsInput!) {
  removeEquipmentCategories(input: $data)
}
    `;
export type RemoveEquipmentCategoriesMutationFn = Apollo.MutationFunction<RemoveEquipmentCategoriesMutation, RemoveEquipmentCategoriesMutationVariables>;

/**
 * __useRemoveEquipmentCategoriesMutation__
 *
 * To run a mutation, you first call `useRemoveEquipmentCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEquipmentCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEquipmentCategoriesMutation, { data, loading, error }] = useRemoveEquipmentCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveEquipmentCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEquipmentCategoriesMutation, RemoveEquipmentCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEquipmentCategoriesMutation, RemoveEquipmentCategoriesMutationVariables>(RemoveEquipmentCategoriesDocument, options);
      }
export type RemoveEquipmentCategoriesMutationHookResult = ReturnType<typeof useRemoveEquipmentCategoriesMutation>;
export type RemoveEquipmentCategoriesMutationResult = Apollo.MutationResult<RemoveEquipmentCategoriesMutation>;
export type RemoveEquipmentCategoriesMutationOptions = Apollo.BaseMutationOptions<RemoveEquipmentCategoriesMutation, RemoveEquipmentCategoriesMutationVariables>;
export const GetEquipmentCategoriesTableDocument = gql`
    query getEquipmentCategoriesTable($take: Int! = 10, $after: String, $before: String, $search: String) {
  getEquipmentCategories(
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getEquipmentCategoriesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCategoryCoreFields
      index
      equipmentCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentCategoriesTableQuery__
 *
 * To run a query within a React component, call `useGetEquipmentCategoriesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentCategoriesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentCategoriesTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEquipmentCategoriesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentCategoriesTableQuery, GetEquipmentCategoriesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentCategoriesTableQuery, GetEquipmentCategoriesTableQueryVariables>(GetEquipmentCategoriesTableDocument, options);
      }
export function useGetEquipmentCategoriesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentCategoriesTableQuery, GetEquipmentCategoriesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentCategoriesTableQuery, GetEquipmentCategoriesTableQueryVariables>(GetEquipmentCategoriesTableDocument, options);
        }
export type GetEquipmentCategoriesTableQueryHookResult = ReturnType<typeof useGetEquipmentCategoriesTableQuery>;
export type GetEquipmentCategoriesTableLazyQueryHookResult = ReturnType<typeof useGetEquipmentCategoriesTableLazyQuery>;
export type GetEquipmentCategoriesTableQueryResult = Apollo.QueryResult<GetEquipmentCategoriesTableQuery, GetEquipmentCategoriesTableQueryVariables>;
export const GetEquipmentCategoriesDropdownDocument = gql`
    query getEquipmentCategoriesDropdown($take: Int! = 10, $after: String, $before: String, $search: String) {
  getEquipmentCategories(
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getEquipmentCategoriesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCategoryCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentCategoriesDropdownQuery__
 *
 * To run a query within a React component, call `useGetEquipmentCategoriesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentCategoriesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentCategoriesDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEquipmentCategoriesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentCategoriesDropdownQuery, GetEquipmentCategoriesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentCategoriesDropdownQuery, GetEquipmentCategoriesDropdownQueryVariables>(GetEquipmentCategoriesDropdownDocument, options);
      }
export function useGetEquipmentCategoriesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentCategoriesDropdownQuery, GetEquipmentCategoriesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentCategoriesDropdownQuery, GetEquipmentCategoriesDropdownQueryVariables>(GetEquipmentCategoriesDropdownDocument, options);
        }
export type GetEquipmentCategoriesDropdownQueryHookResult = ReturnType<typeof useGetEquipmentCategoriesDropdownQuery>;
export type GetEquipmentCategoriesDropdownLazyQueryHookResult = ReturnType<typeof useGetEquipmentCategoriesDropdownLazyQuery>;
export type GetEquipmentCategoriesDropdownQueryResult = Apollo.QueryResult<GetEquipmentCategoriesDropdownQuery, GetEquipmentCategoriesDropdownQueryVariables>;
export const GetEquipmentCategoryDocument = gql`
    query getEquipmentCategory($id: String!) {
  getEquipmentCategory(id: $id) {
    ...EquipmentCategoryCoreFields
  }
}
    ${EquipmentCategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentCategoryQuery__
 *
 * To run a query within a React component, call `useGetEquipmentCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentCategoryQuery, GetEquipmentCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentCategoryQuery, GetEquipmentCategoryQueryVariables>(GetEquipmentCategoryDocument, options);
      }
export function useGetEquipmentCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentCategoryQuery, GetEquipmentCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentCategoryQuery, GetEquipmentCategoryQueryVariables>(GetEquipmentCategoryDocument, options);
        }
export type GetEquipmentCategoryQueryHookResult = ReturnType<typeof useGetEquipmentCategoryQuery>;
export type GetEquipmentCategoryLazyQueryHookResult = ReturnType<typeof useGetEquipmentCategoryLazyQuery>;
export type GetEquipmentCategoryQueryResult = Apollo.QueryResult<GetEquipmentCategoryQuery, GetEquipmentCategoryQueryVariables>;
export const ExportEquipmentCategoriesDocument = gql`
    query exportEquipmentCategories($search: String) {
  exportEquipmentCategories(search: $search)
}
    `;

/**
 * __useExportEquipmentCategoriesQuery__
 *
 * To run a query within a React component, call `useExportEquipmentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEquipmentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEquipmentCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportEquipmentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ExportEquipmentCategoriesQuery, ExportEquipmentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEquipmentCategoriesQuery, ExportEquipmentCategoriesQueryVariables>(ExportEquipmentCategoriesDocument, options);
      }
export function useExportEquipmentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEquipmentCategoriesQuery, ExportEquipmentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEquipmentCategoriesQuery, ExportEquipmentCategoriesQueryVariables>(ExportEquipmentCategoriesDocument, options);
        }
export type ExportEquipmentCategoriesQueryHookResult = ReturnType<typeof useExportEquipmentCategoriesQuery>;
export type ExportEquipmentCategoriesLazyQueryHookResult = ReturnType<typeof useExportEquipmentCategoriesLazyQuery>;
export type ExportEquipmentCategoriesQueryResult = Apollo.QueryResult<ExportEquipmentCategoriesQuery, ExportEquipmentCategoriesQueryVariables>;
export const CreateEquipmentDocument = gql`
    mutation createEquipment($data: CreateEquipmentInput!) {
  createEquipment(input: $data) {
    id
  }
}
    `;
export type CreateEquipmentMutationFn = Apollo.MutationFunction<CreateEquipmentMutation, CreateEquipmentMutationVariables>;

/**
 * __useCreateEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentMutation, { data, loading, error }] = useCreateEquipmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentMutation, CreateEquipmentMutationVariables>(CreateEquipmentDocument, options);
      }
export type CreateEquipmentMutationHookResult = ReturnType<typeof useCreateEquipmentMutation>;
export type CreateEquipmentMutationResult = Apollo.MutationResult<CreateEquipmentMutation>;
export type CreateEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>;
export const UpdateEquipmentDocument = gql`
    mutation updateEquipment($id: String!, $data: UpdateEquipmentInput!) {
  updateEquipment(id: $id, input: $data) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;
export type UpdateEquipmentMutationFn = Apollo.MutationFunction<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;

/**
 * __useUpdateEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentMutation, { data, loading, error }] = useUpdateEquipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>(UpdateEquipmentDocument, options);
      }
export type UpdateEquipmentMutationHookResult = ReturnType<typeof useUpdateEquipmentMutation>;
export type UpdateEquipmentMutationResult = Apollo.MutationResult<UpdateEquipmentMutation>;
export type UpdateEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;
export const ToggleEquipmentDocument = gql`
    mutation toggleEquipment($id: String!) {
  toggleEquipment(id: $id)
}
    `;
export type ToggleEquipmentMutationFn = Apollo.MutationFunction<ToggleEquipmentMutation, ToggleEquipmentMutationVariables>;

/**
 * __useToggleEquipmentMutation__
 *
 * To run a mutation, you first call `useToggleEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEquipmentMutation, { data, loading, error }] = useToggleEquipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ToggleEquipmentMutation, ToggleEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleEquipmentMutation, ToggleEquipmentMutationVariables>(ToggleEquipmentDocument, options);
      }
export type ToggleEquipmentMutationHookResult = ReturnType<typeof useToggleEquipmentMutation>;
export type ToggleEquipmentMutationResult = Apollo.MutationResult<ToggleEquipmentMutation>;
export type ToggleEquipmentMutationOptions = Apollo.BaseMutationOptions<ToggleEquipmentMutation, ToggleEquipmentMutationVariables>;
export const RemoveEquipmentsDocument = gql`
    mutation removeEquipments($data: DeleteRecordsInput!) {
  removeEquipments(input: $data)
}
    `;
export type RemoveEquipmentsMutationFn = Apollo.MutationFunction<RemoveEquipmentsMutation, RemoveEquipmentsMutationVariables>;

/**
 * __useRemoveEquipmentsMutation__
 *
 * To run a mutation, you first call `useRemoveEquipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEquipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEquipmentsMutation, { data, loading, error }] = useRemoveEquipmentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveEquipmentsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEquipmentsMutation, RemoveEquipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEquipmentsMutation, RemoveEquipmentsMutationVariables>(RemoveEquipmentsDocument, options);
      }
export type RemoveEquipmentsMutationHookResult = ReturnType<typeof useRemoveEquipmentsMutation>;
export type RemoveEquipmentsMutationResult = Apollo.MutationResult<RemoveEquipmentsMutation>;
export type RemoveEquipmentsMutationOptions = Apollo.BaseMutationOptions<RemoveEquipmentsMutation, RemoveEquipmentsMutationVariables>;
export const DeleteEquipmentAttachmentDocument = gql`
    mutation deleteEquipmentAttachment($attachmentId: String!, $id: String!) {
  deleteEquipmentAttachment(attachmentId: $attachmentId, id: $id)
}
    `;
export type DeleteEquipmentAttachmentMutationFn = Apollo.MutationFunction<DeleteEquipmentAttachmentMutation, DeleteEquipmentAttachmentMutationVariables>;

/**
 * __useDeleteEquipmentAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentAttachmentMutation, { data, loading, error }] = useDeleteEquipmentAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentAttachmentMutation, DeleteEquipmentAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentAttachmentMutation, DeleteEquipmentAttachmentMutationVariables>(DeleteEquipmentAttachmentDocument, options);
      }
export type DeleteEquipmentAttachmentMutationHookResult = ReturnType<typeof useDeleteEquipmentAttachmentMutation>;
export type DeleteEquipmentAttachmentMutationResult = Apollo.MutationResult<DeleteEquipmentAttachmentMutation>;
export type DeleteEquipmentAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentAttachmentMutation, DeleteEquipmentAttachmentMutationVariables>;
export const GetEquipmentListTableDocument = gql`
    query getEquipmentListTable($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $floorIds: [String!], $suiteIds: [String!], $categoryIds: [String!], $active: Boolean, $nonBuildingRecords: EquipmentNonBuildingEnum! = INCLUDE) {
  getEquipmentList(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    floorIds: $floorIds
    suiteIds: $suiteIds
    categoryIds: $categoryIds
    active: $active
    nonBuildingRecords: $nonBuildingRecords
  ) @connection(key: "getEquipmentListTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCoreFields
      index
      active
      building {
        ...BuildingCoreFields
      }
      category {
        ...EquipmentCategoryCoreFields
      }
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
      specificLocation
      assetTag
      serialNumber
      manufacturer
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentListTableQuery__
 *
 * To run a query within a React component, call `useGetEquipmentListTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentListTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentListTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      floorIds: // value for 'floorIds'
 *      suiteIds: // value for 'suiteIds'
 *      categoryIds: // value for 'categoryIds'
 *      active: // value for 'active'
 *      nonBuildingRecords: // value for 'nonBuildingRecords'
 *   },
 * });
 */
export function useGetEquipmentListTableQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentListTableQuery, GetEquipmentListTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentListTableQuery, GetEquipmentListTableQueryVariables>(GetEquipmentListTableDocument, options);
      }
export function useGetEquipmentListTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentListTableQuery, GetEquipmentListTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentListTableQuery, GetEquipmentListTableQueryVariables>(GetEquipmentListTableDocument, options);
        }
export type GetEquipmentListTableQueryHookResult = ReturnType<typeof useGetEquipmentListTableQuery>;
export type GetEquipmentListTableLazyQueryHookResult = ReturnType<typeof useGetEquipmentListTableLazyQuery>;
export type GetEquipmentListTableQueryResult = Apollo.QueryResult<GetEquipmentListTableQuery, GetEquipmentListTableQueryVariables>;
export const GetEquipmentListDropdownDocument = gql`
    query getEquipmentListDropdown($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $floorIds: [String!], $suiteIds: [String!], $categoryIds: [String!], $active: Boolean, $nonBuildingRecords: EquipmentNonBuildingEnum! = INCLUDE, $includeCategory: Boolean!) {
  getEquipmentList(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    floorIds: $floorIds
    suiteIds: $suiteIds
    categoryIds: $categoryIds
    active: $active
    nonBuildingRecords: $nonBuildingRecords
  ) @connection(key: "getEquipmentListDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCoreFields
      active
      category @include(if: $includeCategory) {
        ...EquipmentCategoryCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentListDropdownQuery__
 *
 * To run a query within a React component, call `useGetEquipmentListDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentListDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentListDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      floorIds: // value for 'floorIds'
 *      suiteIds: // value for 'suiteIds'
 *      categoryIds: // value for 'categoryIds'
 *      active: // value for 'active'
 *      nonBuildingRecords: // value for 'nonBuildingRecords'
 *      includeCategory: // value for 'includeCategory'
 *   },
 * });
 */
export function useGetEquipmentListDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentListDropdownQuery, GetEquipmentListDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentListDropdownQuery, GetEquipmentListDropdownQueryVariables>(GetEquipmentListDropdownDocument, options);
      }
export function useGetEquipmentListDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentListDropdownQuery, GetEquipmentListDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentListDropdownQuery, GetEquipmentListDropdownQueryVariables>(GetEquipmentListDropdownDocument, options);
        }
export type GetEquipmentListDropdownQueryHookResult = ReturnType<typeof useGetEquipmentListDropdownQuery>;
export type GetEquipmentListDropdownLazyQueryHookResult = ReturnType<typeof useGetEquipmentListDropdownLazyQuery>;
export type GetEquipmentListDropdownQueryResult = Apollo.QueryResult<GetEquipmentListDropdownQuery, GetEquipmentListDropdownQueryVariables>;
export const GetEquipmentListDropdownGroupedDocument = gql`
    query getEquipmentListDropdownGrouped($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $floorIds: [String!], $suiteIds: [String!], $categoryIds: [String!], $active: Boolean, $nonBuildingRecords: EquipmentNonBuildingEnum! = INCLUDE) {
  getEquipmentListGrouped(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    floorIds: $floorIds
    suiteIds: $suiteIds
    categoryIds: $categoryIds
    active: $active
    nonBuildingRecords: $nonBuildingRecords
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      title
      equipmentList {
        ...EquipmentCoreFields
        active
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentListDropdownGroupedQuery__
 *
 * To run a query within a React component, call `useGetEquipmentListDropdownGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentListDropdownGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentListDropdownGroupedQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      floorIds: // value for 'floorIds'
 *      suiteIds: // value for 'suiteIds'
 *      categoryIds: // value for 'categoryIds'
 *      active: // value for 'active'
 *      nonBuildingRecords: // value for 'nonBuildingRecords'
 *   },
 * });
 */
export function useGetEquipmentListDropdownGroupedQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentListDropdownGroupedQuery, GetEquipmentListDropdownGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentListDropdownGroupedQuery, GetEquipmentListDropdownGroupedQueryVariables>(GetEquipmentListDropdownGroupedDocument, options);
      }
export function useGetEquipmentListDropdownGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentListDropdownGroupedQuery, GetEquipmentListDropdownGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentListDropdownGroupedQuery, GetEquipmentListDropdownGroupedQueryVariables>(GetEquipmentListDropdownGroupedDocument, options);
        }
export type GetEquipmentListDropdownGroupedQueryHookResult = ReturnType<typeof useGetEquipmentListDropdownGroupedQuery>;
export type GetEquipmentListDropdownGroupedLazyQueryHookResult = ReturnType<typeof useGetEquipmentListDropdownGroupedLazyQuery>;
export type GetEquipmentListDropdownGroupedQueryResult = Apollo.QueryResult<GetEquipmentListDropdownGroupedQuery, GetEquipmentListDropdownGroupedQueryVariables>;
export const GetSingleEquipmentDocument = gql`
    query getSingleEquipment($id: String!) {
  getSingleEquipment(id: $id) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;

/**
 * __useGetSingleEquipmentQuery__
 *
 * To run a query within a React component, call `useGetSingleEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleEquipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetSingleEquipmentQuery, GetSingleEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleEquipmentQuery, GetSingleEquipmentQueryVariables>(GetSingleEquipmentDocument, options);
      }
export function useGetSingleEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleEquipmentQuery, GetSingleEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleEquipmentQuery, GetSingleEquipmentQueryVariables>(GetSingleEquipmentDocument, options);
        }
export type GetSingleEquipmentQueryHookResult = ReturnType<typeof useGetSingleEquipmentQuery>;
export type GetSingleEquipmentLazyQueryHookResult = ReturnType<typeof useGetSingleEquipmentLazyQuery>;
export type GetSingleEquipmentQueryResult = Apollo.QueryResult<GetSingleEquipmentQuery, GetSingleEquipmentQueryVariables>;
export const GetEquipmentTasksDocument = gql`
    query getEquipmentTasks($equipmentId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getEquipmentTasks(
    equipmentId: $equipmentId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...TaskCoreFields
      index
      status
      createdAt
      completedAt
      assignedTo {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${TaskCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentTasksQuery__
 *
 * To run a query within a React component, call `useGetEquipmentTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentTasksQuery({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEquipmentTasksQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentTasksQuery, GetEquipmentTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentTasksQuery, GetEquipmentTasksQueryVariables>(GetEquipmentTasksDocument, options);
      }
export function useGetEquipmentTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentTasksQuery, GetEquipmentTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentTasksQuery, GetEquipmentTasksQueryVariables>(GetEquipmentTasksDocument, options);
        }
export type GetEquipmentTasksQueryHookResult = ReturnType<typeof useGetEquipmentTasksQuery>;
export type GetEquipmentTasksLazyQueryHookResult = ReturnType<typeof useGetEquipmentTasksLazyQuery>;
export type GetEquipmentTasksQueryResult = Apollo.QueryResult<GetEquipmentTasksQuery, GetEquipmentTasksQueryVariables>;
export const GetEquipmentWorkOrdersDocument = gql`
    query getEquipmentWorkOrders($equipmentId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getEquipmentWorkOrders(
    equipmentId: $equipmentId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      status {
        ...StatusCoreFields
        color
      }
      assignedTo {
        ...UserCoreFields
      }
      createdAt
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetEquipmentWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetEquipmentWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentWorkOrdersQuery({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEquipmentWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentWorkOrdersQuery, GetEquipmentWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentWorkOrdersQuery, GetEquipmentWorkOrdersQueryVariables>(GetEquipmentWorkOrdersDocument, options);
      }
export function useGetEquipmentWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentWorkOrdersQuery, GetEquipmentWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentWorkOrdersQuery, GetEquipmentWorkOrdersQueryVariables>(GetEquipmentWorkOrdersDocument, options);
        }
export type GetEquipmentWorkOrdersQueryHookResult = ReturnType<typeof useGetEquipmentWorkOrdersQuery>;
export type GetEquipmentWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetEquipmentWorkOrdersLazyQuery>;
export type GetEquipmentWorkOrdersQueryResult = Apollo.QueryResult<GetEquipmentWorkOrdersQuery, GetEquipmentWorkOrdersQueryVariables>;
export const GetEquipmentQrCodeDocument = gql`
    query getEquipmentQRCode($id: String!) {
  getEquipmentQRCode(id: $id)
}
    `;

/**
 * __useGetEquipmentQrCodeQuery__
 *
 * To run a query within a React component, call `useGetEquipmentQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentQrCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentQrCodeQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentQrCodeQuery, GetEquipmentQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentQrCodeQuery, GetEquipmentQrCodeQueryVariables>(GetEquipmentQrCodeDocument, options);
      }
export function useGetEquipmentQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentQrCodeQuery, GetEquipmentQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentQrCodeQuery, GetEquipmentQrCodeQueryVariables>(GetEquipmentQrCodeDocument, options);
        }
export type GetEquipmentQrCodeQueryHookResult = ReturnType<typeof useGetEquipmentQrCodeQuery>;
export type GetEquipmentQrCodeLazyQueryHookResult = ReturnType<typeof useGetEquipmentQrCodeLazyQuery>;
export type GetEquipmentQrCodeQueryResult = Apollo.QueryResult<GetEquipmentQrCodeQuery, GetEquipmentQrCodeQueryVariables>;
export const PrintEquipmentQrCodeDocument = gql`
    query printEquipmentQRCode($id: String!) {
  printEquipmentQRCode(id: $id)
}
    `;

/**
 * __usePrintEquipmentQrCodeQuery__
 *
 * To run a query within a React component, call `usePrintEquipmentQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintEquipmentQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintEquipmentQrCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrintEquipmentQrCodeQuery(baseOptions: Apollo.QueryHookOptions<PrintEquipmentQrCodeQuery, PrintEquipmentQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintEquipmentQrCodeQuery, PrintEquipmentQrCodeQueryVariables>(PrintEquipmentQrCodeDocument, options);
      }
export function usePrintEquipmentQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintEquipmentQrCodeQuery, PrintEquipmentQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintEquipmentQrCodeQuery, PrintEquipmentQrCodeQueryVariables>(PrintEquipmentQrCodeDocument, options);
        }
export type PrintEquipmentQrCodeQueryHookResult = ReturnType<typeof usePrintEquipmentQrCodeQuery>;
export type PrintEquipmentQrCodeLazyQueryHookResult = ReturnType<typeof usePrintEquipmentQrCodeLazyQuery>;
export type PrintEquipmentQrCodeQueryResult = Apollo.QueryResult<PrintEquipmentQrCodeQuery, PrintEquipmentQrCodeQueryVariables>;
export const ExportEquipmentsDocument = gql`
    query exportEquipments($search: String, $buildingIds: [String!], $floorIds: [String!], $suiteIds: [String!], $categoryIds: [String!], $active: Boolean, $nonBuildingRecords: EquipmentNonBuildingEnum! = INCLUDE) {
  exportEquipments(
    search: $search
    buildingIds: $buildingIds
    floorIds: $floorIds
    suiteIds: $suiteIds
    categoryIds: $categoryIds
    active: $active
    nonBuildingRecords: $nonBuildingRecords
  )
}
    `;

/**
 * __useExportEquipmentsQuery__
 *
 * To run a query within a React component, call `useExportEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEquipmentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      floorIds: // value for 'floorIds'
 *      suiteIds: // value for 'suiteIds'
 *      categoryIds: // value for 'categoryIds'
 *      active: // value for 'active'
 *      nonBuildingRecords: // value for 'nonBuildingRecords'
 *   },
 * });
 */
export function useExportEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<ExportEquipmentsQuery, ExportEquipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEquipmentsQuery, ExportEquipmentsQueryVariables>(ExportEquipmentsDocument, options);
      }
export function useExportEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEquipmentsQuery, ExportEquipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEquipmentsQuery, ExportEquipmentsQueryVariables>(ExportEquipmentsDocument, options);
        }
export type ExportEquipmentsQueryHookResult = ReturnType<typeof useExportEquipmentsQuery>;
export type ExportEquipmentsLazyQueryHookResult = ReturnType<typeof useExportEquipmentsLazyQuery>;
export type ExportEquipmentsQueryResult = Apollo.QueryResult<ExportEquipmentsQuery, ExportEquipmentsQueryVariables>;
export const CreateProcedureDocument = gql`
    mutation createProcedure($data: ProcedureInput!) {
  createProcedure(input: $data) {
    id
  }
}
    `;
export type CreateProcedureMutationFn = Apollo.MutationFunction<CreateProcedureMutation, CreateProcedureMutationVariables>;

/**
 * __useCreateProcedureMutation__
 *
 * To run a mutation, you first call `useCreateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureMutation, { data, loading, error }] = useCreateProcedureMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureMutation, CreateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureMutation, CreateProcedureMutationVariables>(CreateProcedureDocument, options);
      }
export type CreateProcedureMutationHookResult = ReturnType<typeof useCreateProcedureMutation>;
export type CreateProcedureMutationResult = Apollo.MutationResult<CreateProcedureMutation>;
export type CreateProcedureMutationOptions = Apollo.BaseMutationOptions<CreateProcedureMutation, CreateProcedureMutationVariables>;
export const UpdateProcedureDocument = gql`
    mutation updateProcedure($id: String!, $data: ProcedureInput!) {
  updateProcedure(id: $id, input: $data) {
    ...ProcedureFields
  }
}
    ${ProcedureFieldsFragmentDoc}`;
export type UpdateProcedureMutationFn = Apollo.MutationFunction<UpdateProcedureMutation, UpdateProcedureMutationVariables>;

/**
 * __useUpdateProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureMutation, { data, loading, error }] = useUpdateProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureMutation, UpdateProcedureMutationVariables>(UpdateProcedureDocument, options);
      }
export type UpdateProcedureMutationHookResult = ReturnType<typeof useUpdateProcedureMutation>;
export type UpdateProcedureMutationResult = Apollo.MutationResult<UpdateProcedureMutation>;
export type UpdateProcedureMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>;
export const ToggleProcedureDocument = gql`
    mutation toggleProcedure($id: String!) {
  toggleProcedure(id: $id)
}
    `;
export type ToggleProcedureMutationFn = Apollo.MutationFunction<ToggleProcedureMutation, ToggleProcedureMutationVariables>;

/**
 * __useToggleProcedureMutation__
 *
 * To run a mutation, you first call `useToggleProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProcedureMutation, { data, loading, error }] = useToggleProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleProcedureMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProcedureMutation, ToggleProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProcedureMutation, ToggleProcedureMutationVariables>(ToggleProcedureDocument, options);
      }
export type ToggleProcedureMutationHookResult = ReturnType<typeof useToggleProcedureMutation>;
export type ToggleProcedureMutationResult = Apollo.MutationResult<ToggleProcedureMutation>;
export type ToggleProcedureMutationOptions = Apollo.BaseMutationOptions<ToggleProcedureMutation, ToggleProcedureMutationVariables>;
export const RemoveProceduresDocument = gql`
    mutation removeProcedures($data: DeleteRecordsInput!) {
  removeProcedures(input: $data)
}
    `;
export type RemoveProceduresMutationFn = Apollo.MutationFunction<RemoveProceduresMutation, RemoveProceduresMutationVariables>;

/**
 * __useRemoveProceduresMutation__
 *
 * To run a mutation, you first call `useRemoveProceduresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProceduresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProceduresMutation, { data, loading, error }] = useRemoveProceduresMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveProceduresMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProceduresMutation, RemoveProceduresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProceduresMutation, RemoveProceduresMutationVariables>(RemoveProceduresDocument, options);
      }
export type RemoveProceduresMutationHookResult = ReturnType<typeof useRemoveProceduresMutation>;
export type RemoveProceduresMutationResult = Apollo.MutationResult<RemoveProceduresMutation>;
export type RemoveProceduresMutationOptions = Apollo.BaseMutationOptions<RemoveProceduresMutation, RemoveProceduresMutationVariables>;
export const GetProceduresTableDocument = gql`
    query getProceduresTable($take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getProcedures(
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getProceduresTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...ProcedureCoreFields
      index
      active
      estimatedLabor
      schedulesCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ProcedureCoreFieldsFragmentDoc}`;

/**
 * __useGetProceduresTableQuery__
 *
 * To run a query within a React component, call `useGetProceduresTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProceduresTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProceduresTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProceduresTableQuery(baseOptions?: Apollo.QueryHookOptions<GetProceduresTableQuery, GetProceduresTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProceduresTableQuery, GetProceduresTableQueryVariables>(GetProceduresTableDocument, options);
      }
export function useGetProceduresTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProceduresTableQuery, GetProceduresTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProceduresTableQuery, GetProceduresTableQueryVariables>(GetProceduresTableDocument, options);
        }
export type GetProceduresTableQueryHookResult = ReturnType<typeof useGetProceduresTableQuery>;
export type GetProceduresTableLazyQueryHookResult = ReturnType<typeof useGetProceduresTableLazyQuery>;
export type GetProceduresTableQueryResult = Apollo.QueryResult<GetProceduresTableQuery, GetProceduresTableQueryVariables>;
export const GetProceduresDropdownDocument = gql`
    query getProceduresDropdown($take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getProcedures(
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getProceduresDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...ProcedureCoreFields
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ProcedureCoreFieldsFragmentDoc}`;

/**
 * __useGetProceduresDropdownQuery__
 *
 * To run a query within a React component, call `useGetProceduresDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProceduresDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProceduresDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProceduresDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetProceduresDropdownQuery, GetProceduresDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProceduresDropdownQuery, GetProceduresDropdownQueryVariables>(GetProceduresDropdownDocument, options);
      }
export function useGetProceduresDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProceduresDropdownQuery, GetProceduresDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProceduresDropdownQuery, GetProceduresDropdownQueryVariables>(GetProceduresDropdownDocument, options);
        }
export type GetProceduresDropdownQueryHookResult = ReturnType<typeof useGetProceduresDropdownQuery>;
export type GetProceduresDropdownLazyQueryHookResult = ReturnType<typeof useGetProceduresDropdownLazyQuery>;
export type GetProceduresDropdownQueryResult = Apollo.QueryResult<GetProceduresDropdownQuery, GetProceduresDropdownQueryVariables>;
export const GetProcedureDocument = gql`
    query getProcedure($id: String!) {
  getProcedure(id: $id) {
    ...ProcedureFields
  }
}
    ${ProcedureFieldsFragmentDoc}`;

/**
 * __useGetProcedureQuery__
 *
 * To run a query within a React component, call `useGetProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcedureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProcedureQuery(baseOptions: Apollo.QueryHookOptions<GetProcedureQuery, GetProcedureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcedureQuery, GetProcedureQueryVariables>(GetProcedureDocument, options);
      }
export function useGetProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcedureQuery, GetProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcedureQuery, GetProcedureQueryVariables>(GetProcedureDocument, options);
        }
export type GetProcedureQueryHookResult = ReturnType<typeof useGetProcedureQuery>;
export type GetProcedureLazyQueryHookResult = ReturnType<typeof useGetProcedureLazyQuery>;
export type GetProcedureQueryResult = Apollo.QueryResult<GetProcedureQuery, GetProcedureQueryVariables>;
export const ExportProceduresDocument = gql`
    query exportProcedures($search: String, $active: Boolean) {
  exportProcedures(search: $search, active: $active)
}
    `;

/**
 * __useExportProceduresQuery__
 *
 * To run a query within a React component, call `useExportProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportProceduresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useExportProceduresQuery(baseOptions?: Apollo.QueryHookOptions<ExportProceduresQuery, ExportProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportProceduresQuery, ExportProceduresQueryVariables>(ExportProceduresDocument, options);
      }
export function useExportProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportProceduresQuery, ExportProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportProceduresQuery, ExportProceduresQueryVariables>(ExportProceduresDocument, options);
        }
export type ExportProceduresQueryHookResult = ReturnType<typeof useExportProceduresQuery>;
export type ExportProceduresLazyQueryHookResult = ReturnType<typeof useExportProceduresLazyQuery>;
export type ExportProceduresQueryResult = Apollo.QueryResult<ExportProceduresQuery, ExportProceduresQueryVariables>;
export const CreateScheduleDocument = gql`
    mutation createSchedule($data: SchedulesInput!) {
  createSchedule(input: $data) {
    id
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const UpdateScheduleTitleDocument = gql`
    mutation updateScheduleTitle($scheduleId: String!, $title: String!) {
  updateScheduleTitle(scheduleId: $scheduleId, title: $title) {
    ...ScheduleCoreFields
  }
}
    ${ScheduleCoreFieldsFragmentDoc}`;
export type UpdateScheduleTitleMutationFn = Apollo.MutationFunction<UpdateScheduleTitleMutation, UpdateScheduleTitleMutationVariables>;

/**
 * __useUpdateScheduleTitleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleTitleMutation, { data, loading, error }] = useUpdateScheduleTitleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateScheduleTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleTitleMutation, UpdateScheduleTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleTitleMutation, UpdateScheduleTitleMutationVariables>(UpdateScheduleTitleDocument, options);
      }
export type UpdateScheduleTitleMutationHookResult = ReturnType<typeof useUpdateScheduleTitleMutation>;
export type UpdateScheduleTitleMutationResult = Apollo.MutationResult<UpdateScheduleTitleMutation>;
export type UpdateScheduleTitleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleTitleMutation, UpdateScheduleTitleMutationVariables>;
export const UpdateScheduleNotesDocument = gql`
    mutation updateScheduleNotes($scheduleId: String!, $notes: String) {
  updateScheduleNotes(scheduleId: $scheduleId, notes: $notes) {
    id
    notes
  }
}
    `;
export type UpdateScheduleNotesMutationFn = Apollo.MutationFunction<UpdateScheduleNotesMutation, UpdateScheduleNotesMutationVariables>;

/**
 * __useUpdateScheduleNotesMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleNotesMutation, { data, loading, error }] = useUpdateScheduleNotesMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateScheduleNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleNotesMutation, UpdateScheduleNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleNotesMutation, UpdateScheduleNotesMutationVariables>(UpdateScheduleNotesDocument, options);
      }
export type UpdateScheduleNotesMutationHookResult = ReturnType<typeof useUpdateScheduleNotesMutation>;
export type UpdateScheduleNotesMutationResult = Apollo.MutationResult<UpdateScheduleNotesMutation>;
export type UpdateScheduleNotesMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleNotesMutation, UpdateScheduleNotesMutationVariables>;
export const UpdateScheduleNextGenerationDateDocument = gql`
    mutation updateScheduleNextGenerationDate($id: String!, $nextGenerationDate: DateTime!) {
  updateScheduleNextGenerationDate(
    id: $id
    nextGenerationDate: $nextGenerationDate
  ) {
    id
    nextGenerationDate
  }
}
    `;
export type UpdateScheduleNextGenerationDateMutationFn = Apollo.MutationFunction<UpdateScheduleNextGenerationDateMutation, UpdateScheduleNextGenerationDateMutationVariables>;

/**
 * __useUpdateScheduleNextGenerationDateMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleNextGenerationDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleNextGenerationDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleNextGenerationDateMutation, { data, loading, error }] = useUpdateScheduleNextGenerationDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nextGenerationDate: // value for 'nextGenerationDate'
 *   },
 * });
 */
export function useUpdateScheduleNextGenerationDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleNextGenerationDateMutation, UpdateScheduleNextGenerationDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleNextGenerationDateMutation, UpdateScheduleNextGenerationDateMutationVariables>(UpdateScheduleNextGenerationDateDocument, options);
      }
export type UpdateScheduleNextGenerationDateMutationHookResult = ReturnType<typeof useUpdateScheduleNextGenerationDateMutation>;
export type UpdateScheduleNextGenerationDateMutationResult = Apollo.MutationResult<UpdateScheduleNextGenerationDateMutation>;
export type UpdateScheduleNextGenerationDateMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleNextGenerationDateMutation, UpdateScheduleNextGenerationDateMutationVariables>;
export const UpdateScheduleRRuleDocument = gql`
    mutation updateScheduleRRule($scheduleId: String!, $input: SchedulesUpdateRRuleInput!) {
  updateScheduleRRule(scheduleId: $scheduleId, input: $input) {
    id
    rruleText
    rruleObject {
      ...RRuleFields
    }
    recordStatus
    nextGenerationDate
  }
}
    ${RRuleFieldsFragmentDoc}`;
export type UpdateScheduleRRuleMutationFn = Apollo.MutationFunction<UpdateScheduleRRuleMutation, UpdateScheduleRRuleMutationVariables>;

/**
 * __useUpdateScheduleRRuleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleRRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleRRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleRRuleMutation, { data, loading, error }] = useUpdateScheduleRRuleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleRRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleRRuleMutation, UpdateScheduleRRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleRRuleMutation, UpdateScheduleRRuleMutationVariables>(UpdateScheduleRRuleDocument, options);
      }
export type UpdateScheduleRRuleMutationHookResult = ReturnType<typeof useUpdateScheduleRRuleMutation>;
export type UpdateScheduleRRuleMutationResult = Apollo.MutationResult<UpdateScheduleRRuleMutation>;
export type UpdateScheduleRRuleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleRRuleMutation, UpdateScheduleRRuleMutationVariables>;
export const UpdateScheduleAssignedToIdDocument = gql`
    mutation updateScheduleAssignedToId($scheduleId: String!, $assignedToId: String) {
  updateScheduleAssignedToId(scheduleId: $scheduleId, assignedToId: $assignedToId) {
    id
    assignedTo {
      ...UserCoreFields
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type UpdateScheduleAssignedToIdMutationFn = Apollo.MutationFunction<UpdateScheduleAssignedToIdMutation, UpdateScheduleAssignedToIdMutationVariables>;

/**
 * __useUpdateScheduleAssignedToIdMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleAssignedToIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleAssignedToIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleAssignedToIdMutation, { data, loading, error }] = useUpdateScheduleAssignedToIdMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useUpdateScheduleAssignedToIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleAssignedToIdMutation, UpdateScheduleAssignedToIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleAssignedToIdMutation, UpdateScheduleAssignedToIdMutationVariables>(UpdateScheduleAssignedToIdDocument, options);
      }
export type UpdateScheduleAssignedToIdMutationHookResult = ReturnType<typeof useUpdateScheduleAssignedToIdMutation>;
export type UpdateScheduleAssignedToIdMutationResult = Apollo.MutationResult<UpdateScheduleAssignedToIdMutation>;
export type UpdateScheduleAssignedToIdMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleAssignedToIdMutation, UpdateScheduleAssignedToIdMutationVariables>;
export const UpdateScheduleDueAfterDaysDocument = gql`
    mutation updateScheduleDueAfterDays($scheduleId: String!, $dueAfterDays: Int) {
  updateScheduleDueAfterDays(scheduleId: $scheduleId, dueAfterDays: $dueAfterDays) {
    id
    dueAfterDays
  }
}
    `;
export type UpdateScheduleDueAfterDaysMutationFn = Apollo.MutationFunction<UpdateScheduleDueAfterDaysMutation, UpdateScheduleDueAfterDaysMutationVariables>;

/**
 * __useUpdateScheduleDueAfterDaysMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleDueAfterDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleDueAfterDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleDueAfterDaysMutation, { data, loading, error }] = useUpdateScheduleDueAfterDaysMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      dueAfterDays: // value for 'dueAfterDays'
 *   },
 * });
 */
export function useUpdateScheduleDueAfterDaysMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleDueAfterDaysMutation, UpdateScheduleDueAfterDaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleDueAfterDaysMutation, UpdateScheduleDueAfterDaysMutationVariables>(UpdateScheduleDueAfterDaysDocument, options);
      }
export type UpdateScheduleDueAfterDaysMutationHookResult = ReturnType<typeof useUpdateScheduleDueAfterDaysMutation>;
export type UpdateScheduleDueAfterDaysMutationResult = Apollo.MutationResult<UpdateScheduleDueAfterDaysMutation>;
export type UpdateScheduleDueAfterDaysMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleDueAfterDaysMutation, UpdateScheduleDueAfterDaysMutationVariables>;
export const UpdateScheduleTaskTypeDocument = gql`
    mutation updateScheduleTaskType($scheduleId: String!, $taskTypeId: String) {
  updateScheduleTaskType(scheduleId: $scheduleId, taskTypeId: $taskTypeId) {
    id
    taskType {
      ...TaskTypeCoreFields
    }
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;
export type UpdateScheduleTaskTypeMutationFn = Apollo.MutationFunction<UpdateScheduleTaskTypeMutation, UpdateScheduleTaskTypeMutationVariables>;

/**
 * __useUpdateScheduleTaskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleTaskTypeMutation, { data, loading, error }] = useUpdateScheduleTaskTypeMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      taskTypeId: // value for 'taskTypeId'
 *   },
 * });
 */
export function useUpdateScheduleTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleTaskTypeMutation, UpdateScheduleTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleTaskTypeMutation, UpdateScheduleTaskTypeMutationVariables>(UpdateScheduleTaskTypeDocument, options);
      }
export type UpdateScheduleTaskTypeMutationHookResult = ReturnType<typeof useUpdateScheduleTaskTypeMutation>;
export type UpdateScheduleTaskTypeMutationResult = Apollo.MutationResult<UpdateScheduleTaskTypeMutation>;
export type UpdateScheduleTaskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleTaskTypeMutation, UpdateScheduleTaskTypeMutationVariables>;
export const AddScheduleAttachmentsDocument = gql`
    mutation addScheduleAttachments($scheduleId: String!, $attachments: [FileObjectInput!]!) {
  addScheduleAttachments(scheduleId: $scheduleId, attachments: $attachments) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type AddScheduleAttachmentsMutationFn = Apollo.MutationFunction<AddScheduleAttachmentsMutation, AddScheduleAttachmentsMutationVariables>;

/**
 * __useAddScheduleAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddScheduleAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduleAttachmentsMutation, { data, loading, error }] = useAddScheduleAttachmentsMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddScheduleAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduleAttachmentsMutation, AddScheduleAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduleAttachmentsMutation, AddScheduleAttachmentsMutationVariables>(AddScheduleAttachmentsDocument, options);
      }
export type AddScheduleAttachmentsMutationHookResult = ReturnType<typeof useAddScheduleAttachmentsMutation>;
export type AddScheduleAttachmentsMutationResult = Apollo.MutationResult<AddScheduleAttachmentsMutation>;
export type AddScheduleAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddScheduleAttachmentsMutation, AddScheduleAttachmentsMutationVariables>;
export const RemoveScheduleAttachmentDocument = gql`
    mutation removeScheduleAttachment($scheduleId: String!, $attachmentId: String!) {
  removeScheduleAttachment(scheduleId: $scheduleId, attachmentId: $attachmentId) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type RemoveScheduleAttachmentMutationFn = Apollo.MutationFunction<RemoveScheduleAttachmentMutation, RemoveScheduleAttachmentMutationVariables>;

/**
 * __useRemoveScheduleAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleAttachmentMutation, { data, loading, error }] = useRemoveScheduleAttachmentMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveScheduleAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScheduleAttachmentMutation, RemoveScheduleAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScheduleAttachmentMutation, RemoveScheduleAttachmentMutationVariables>(RemoveScheduleAttachmentDocument, options);
      }
export type RemoveScheduleAttachmentMutationHookResult = ReturnType<typeof useRemoveScheduleAttachmentMutation>;
export type RemoveScheduleAttachmentMutationResult = Apollo.MutationResult<RemoveScheduleAttachmentMutation>;
export type RemoveScheduleAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveScheduleAttachmentMutation, RemoveScheduleAttachmentMutationVariables>;
export const ToggleScheduleSplitEquipmentOnTaskDocument = gql`
    mutation toggleScheduleSplitEquipmentOnTask($scheduleId: String!) {
  toggleScheduleSplitEquipmentOnTask(scheduleId: $scheduleId) {
    id
    splitEquipmentOnTask
  }
}
    `;
export type ToggleScheduleSplitEquipmentOnTaskMutationFn = Apollo.MutationFunction<ToggleScheduleSplitEquipmentOnTaskMutation, ToggleScheduleSplitEquipmentOnTaskMutationVariables>;

/**
 * __useToggleScheduleSplitEquipmentOnTaskMutation__
 *
 * To run a mutation, you first call `useToggleScheduleSplitEquipmentOnTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleScheduleSplitEquipmentOnTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleScheduleSplitEquipmentOnTaskMutation, { data, loading, error }] = useToggleScheduleSplitEquipmentOnTaskMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useToggleScheduleSplitEquipmentOnTaskMutation(baseOptions?: Apollo.MutationHookOptions<ToggleScheduleSplitEquipmentOnTaskMutation, ToggleScheduleSplitEquipmentOnTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleScheduleSplitEquipmentOnTaskMutation, ToggleScheduleSplitEquipmentOnTaskMutationVariables>(ToggleScheduleSplitEquipmentOnTaskDocument, options);
      }
export type ToggleScheduleSplitEquipmentOnTaskMutationHookResult = ReturnType<typeof useToggleScheduleSplitEquipmentOnTaskMutation>;
export type ToggleScheduleSplitEquipmentOnTaskMutationResult = Apollo.MutationResult<ToggleScheduleSplitEquipmentOnTaskMutation>;
export type ToggleScheduleSplitEquipmentOnTaskMutationOptions = Apollo.BaseMutationOptions<ToggleScheduleSplitEquipmentOnTaskMutation, ToggleScheduleSplitEquipmentOnTaskMutationVariables>;
export const AddScheduleProcedureDocument = gql`
    mutation addScheduleProcedure($scheduleId: String!, $procedureId: String!) {
  addScheduleProcedure(scheduleId: $scheduleId, procedureId: $procedureId) {
    id
    procedureCount
    procedures {
      ...ScheduleProcedureFields
    }
  }
}
    ${ScheduleProcedureFieldsFragmentDoc}`;
export type AddScheduleProcedureMutationFn = Apollo.MutationFunction<AddScheduleProcedureMutation, AddScheduleProcedureMutationVariables>;

/**
 * __useAddScheduleProcedureMutation__
 *
 * To run a mutation, you first call `useAddScheduleProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduleProcedureMutation, { data, loading, error }] = useAddScheduleProcedureMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useAddScheduleProcedureMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduleProcedureMutation, AddScheduleProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduleProcedureMutation, AddScheduleProcedureMutationVariables>(AddScheduleProcedureDocument, options);
      }
export type AddScheduleProcedureMutationHookResult = ReturnType<typeof useAddScheduleProcedureMutation>;
export type AddScheduleProcedureMutationResult = Apollo.MutationResult<AddScheduleProcedureMutation>;
export type AddScheduleProcedureMutationOptions = Apollo.BaseMutationOptions<AddScheduleProcedureMutation, AddScheduleProcedureMutationVariables>;
export const RemoveScheduleProcedureDocument = gql`
    mutation removeScheduleProcedure($scheduleId: String!, $procedureId: String!) {
  removeScheduleProcedure(scheduleId: $scheduleId, procedureId: $procedureId) {
    id
    procedureCount
    procedures {
      ...ScheduleProcedureFields
    }
  }
}
    ${ScheduleProcedureFieldsFragmentDoc}`;
export type RemoveScheduleProcedureMutationFn = Apollo.MutationFunction<RemoveScheduleProcedureMutation, RemoveScheduleProcedureMutationVariables>;

/**
 * __useRemoveScheduleProcedureMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleProcedureMutation, { data, loading, error }] = useRemoveScheduleProcedureMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useRemoveScheduleProcedureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScheduleProcedureMutation, RemoveScheduleProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScheduleProcedureMutation, RemoveScheduleProcedureMutationVariables>(RemoveScheduleProcedureDocument, options);
      }
export type RemoveScheduleProcedureMutationHookResult = ReturnType<typeof useRemoveScheduleProcedureMutation>;
export type RemoveScheduleProcedureMutationResult = Apollo.MutationResult<RemoveScheduleProcedureMutation>;
export type RemoveScheduleProcedureMutationOptions = Apollo.BaseMutationOptions<RemoveScheduleProcedureMutation, RemoveScheduleProcedureMutationVariables>;
export const AddScheduleEquipmentDocument = gql`
    mutation addScheduleEquipment($scheduleId: String!, $equipmentId: String!) {
  addScheduleEquipment(scheduleId: $scheduleId, equipmentId: $equipmentId) {
    id
    equipmentCount
    equipment {
      ...ScheduleEquipmentFields
    }
  }
}
    ${ScheduleEquipmentFieldsFragmentDoc}`;
export type AddScheduleEquipmentMutationFn = Apollo.MutationFunction<AddScheduleEquipmentMutation, AddScheduleEquipmentMutationVariables>;

/**
 * __useAddScheduleEquipmentMutation__
 *
 * To run a mutation, you first call `useAddScheduleEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduleEquipmentMutation, { data, loading, error }] = useAddScheduleEquipmentMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useAddScheduleEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduleEquipmentMutation, AddScheduleEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduleEquipmentMutation, AddScheduleEquipmentMutationVariables>(AddScheduleEquipmentDocument, options);
      }
export type AddScheduleEquipmentMutationHookResult = ReturnType<typeof useAddScheduleEquipmentMutation>;
export type AddScheduleEquipmentMutationResult = Apollo.MutationResult<AddScheduleEquipmentMutation>;
export type AddScheduleEquipmentMutationOptions = Apollo.BaseMutationOptions<AddScheduleEquipmentMutation, AddScheduleEquipmentMutationVariables>;
export const RemoveScheduleEquipmentDocument = gql`
    mutation removeScheduleEquipment($scheduleId: String!, $equipmentId: String!) {
  removeScheduleEquipment(scheduleId: $scheduleId, equipmentId: $equipmentId) {
    id
    equipmentCount
    equipment {
      ...ScheduleEquipmentFields
    }
  }
}
    ${ScheduleEquipmentFieldsFragmentDoc}`;
export type RemoveScheduleEquipmentMutationFn = Apollo.MutationFunction<RemoveScheduleEquipmentMutation, RemoveScheduleEquipmentMutationVariables>;

/**
 * __useRemoveScheduleEquipmentMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleEquipmentMutation, { data, loading, error }] = useRemoveScheduleEquipmentMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useRemoveScheduleEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScheduleEquipmentMutation, RemoveScheduleEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScheduleEquipmentMutation, RemoveScheduleEquipmentMutationVariables>(RemoveScheduleEquipmentDocument, options);
      }
export type RemoveScheduleEquipmentMutationHookResult = ReturnType<typeof useRemoveScheduleEquipmentMutation>;
export type RemoveScheduleEquipmentMutationResult = Apollo.MutationResult<RemoveScheduleEquipmentMutation>;
export type RemoveScheduleEquipmentMutationOptions = Apollo.BaseMutationOptions<RemoveScheduleEquipmentMutation, RemoveScheduleEquipmentMutationVariables>;
export const GenerateTaskDocument = gql`
    mutation generateTask($scheduleId: String!) {
  generateTask(scheduleId: $scheduleId)
}
    `;
export type GenerateTaskMutationFn = Apollo.MutationFunction<GenerateTaskMutation, GenerateTaskMutationVariables>;

/**
 * __useGenerateTaskMutation__
 *
 * To run a mutation, you first call `useGenerateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaskMutation, { data, loading, error }] = useGenerateTaskMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGenerateTaskMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaskMutation, GenerateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaskMutation, GenerateTaskMutationVariables>(GenerateTaskDocument, options);
      }
export type GenerateTaskMutationHookResult = ReturnType<typeof useGenerateTaskMutation>;
export type GenerateTaskMutationResult = Apollo.MutationResult<GenerateTaskMutation>;
export type GenerateTaskMutationOptions = Apollo.BaseMutationOptions<GenerateTaskMutation, GenerateTaskMutationVariables>;
export const SkipScheduleDateDocument = gql`
    mutation skipScheduleDate($scheduleId: String!, $date: String!) {
  skipScheduleDate(scheduleId: $scheduleId, date: $date) {
    id
    nextGenerationDate
    excludeDates
  }
}
    `;
export type SkipScheduleDateMutationFn = Apollo.MutationFunction<SkipScheduleDateMutation, SkipScheduleDateMutationVariables>;

/**
 * __useSkipScheduleDateMutation__
 *
 * To run a mutation, you first call `useSkipScheduleDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipScheduleDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipScheduleDateMutation, { data, loading, error }] = useSkipScheduleDateMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSkipScheduleDateMutation(baseOptions?: Apollo.MutationHookOptions<SkipScheduleDateMutation, SkipScheduleDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipScheduleDateMutation, SkipScheduleDateMutationVariables>(SkipScheduleDateDocument, options);
      }
export type SkipScheduleDateMutationHookResult = ReturnType<typeof useSkipScheduleDateMutation>;
export type SkipScheduleDateMutationResult = Apollo.MutationResult<SkipScheduleDateMutation>;
export type SkipScheduleDateMutationOptions = Apollo.BaseMutationOptions<SkipScheduleDateMutation, SkipScheduleDateMutationVariables>;
export const BulkPauseSchedulesDocument = gql`
    mutation bulkPauseSchedules($ids: [String!]!, $pause: Boolean!) {
  bulkPauseSchedules(ids: $ids, pause: $pause) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
    }
  }
}
    `;
export type BulkPauseSchedulesMutationFn = Apollo.MutationFunction<BulkPauseSchedulesMutation, BulkPauseSchedulesMutationVariables>;

/**
 * __useBulkPauseSchedulesMutation__
 *
 * To run a mutation, you first call `useBulkPauseSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPauseSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPauseSchedulesMutation, { data, loading, error }] = useBulkPauseSchedulesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      pause: // value for 'pause'
 *   },
 * });
 */
export function useBulkPauseSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkPauseSchedulesMutation, BulkPauseSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPauseSchedulesMutation, BulkPauseSchedulesMutationVariables>(BulkPauseSchedulesDocument, options);
      }
export type BulkPauseSchedulesMutationHookResult = ReturnType<typeof useBulkPauseSchedulesMutation>;
export type BulkPauseSchedulesMutationResult = Apollo.MutationResult<BulkPauseSchedulesMutation>;
export type BulkPauseSchedulesMutationOptions = Apollo.BaseMutationOptions<BulkPauseSchedulesMutation, BulkPauseSchedulesMutationVariables>;
export const BulkSkipNextSchedulesDocument = gql`
    mutation bulkSkipNextSchedules($ids: [String!]!) {
  bulkSkipNextSchedules(ids: $ids) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
      nextGenerationDate
      excludeDates
    }
  }
}
    `;
export type BulkSkipNextSchedulesMutationFn = Apollo.MutationFunction<BulkSkipNextSchedulesMutation, BulkSkipNextSchedulesMutationVariables>;

/**
 * __useBulkSkipNextSchedulesMutation__
 *
 * To run a mutation, you first call `useBulkSkipNextSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSkipNextSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSkipNextSchedulesMutation, { data, loading, error }] = useBulkSkipNextSchedulesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkSkipNextSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkSkipNextSchedulesMutation, BulkSkipNextSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSkipNextSchedulesMutation, BulkSkipNextSchedulesMutationVariables>(BulkSkipNextSchedulesDocument, options);
      }
export type BulkSkipNextSchedulesMutationHookResult = ReturnType<typeof useBulkSkipNextSchedulesMutation>;
export type BulkSkipNextSchedulesMutationResult = Apollo.MutationResult<BulkSkipNextSchedulesMutation>;
export type BulkSkipNextSchedulesMutationOptions = Apollo.BaseMutationOptions<BulkSkipNextSchedulesMutation, BulkSkipNextSchedulesMutationVariables>;
export const RemoveSchedulesDocument = gql`
    mutation removeSchedules($data: DeleteRecordsInput!) {
  removeSchedules(input: $data)
}
    `;
export type RemoveSchedulesMutationFn = Apollo.MutationFunction<RemoveSchedulesMutation, RemoveSchedulesMutationVariables>;

/**
 * __useRemoveSchedulesMutation__
 *
 * To run a mutation, you first call `useRemoveSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSchedulesMutation, { data, loading, error }] = useRemoveSchedulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSchedulesMutation, RemoveSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSchedulesMutation, RemoveSchedulesMutationVariables>(RemoveSchedulesDocument, options);
      }
export type RemoveSchedulesMutationHookResult = ReturnType<typeof useRemoveSchedulesMutation>;
export type RemoveSchedulesMutationResult = Apollo.MutationResult<RemoveSchedulesMutation>;
export type RemoveSchedulesMutationOptions = Apollo.BaseMutationOptions<RemoveSchedulesMutation, RemoveSchedulesMutationVariables>;
export const GetSchedulesDocument = gql`
    query getSchedules($take: Int! = 10, $after: String, $before: String, $search: String, $taskTypeIds: [String!], $recordStatuses: [RRuleStatuses!], $buildingIds: [String!], $from: DateTime, $to: DateTime) {
  getSchedules(
    take: $take
    after: $after
    before: $before
    search: $search
    taskTypeIds: $taskTypeIds
    recordStatuses: $recordStatuses
    buildingIds: $buildingIds
    from: $from
    to: $to
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...ScheduleCoreFields
      index
      recordStatus
      nextGenerationDate
      prevGenerationDate
      excludeDates
      equipmentCount
      procedureCount
      createdAt
      startDate
      timezone
      rruleText
      taskType {
        ...TaskTypeCoreFields
      }
      building {
        ...BuildingCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ScheduleCoreFieldsFragmentDoc}
${TaskTypeCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetSchedulesQuery__
 *
 * To run a query within a React component, call `useGetSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      taskTypeIds: // value for 'taskTypeIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      buildingIds: // value for 'buildingIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchedulesQuery, GetSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(GetSchedulesDocument, options);
      }
export function useGetSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulesQuery, GetSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(GetSchedulesDocument, options);
        }
export type GetSchedulesQueryHookResult = ReturnType<typeof useGetSchedulesQuery>;
export type GetSchedulesLazyQueryHookResult = ReturnType<typeof useGetSchedulesLazyQuery>;
export type GetSchedulesQueryResult = Apollo.QueryResult<GetSchedulesQuery, GetSchedulesQueryVariables>;
export const GetSchedulesCalendarDocument = gql`
    query getSchedulesCalendar($search: String, $from: DateTime!, $to: DateTime!, $taskTypeIds: [String!], $recordStatuses: [RRuleStatuses!], $buildingIds: [String!]) {
  getSchedulesCalendar(
    search: $search
    from: $from
    to: $to
    taskTypeIds: $taskTypeIds
    recordStatuses: $recordStatuses
    buildingIds: $buildingIds
  ) {
    dates
    record {
      ...ScheduleCoreFields
      index
      recordStatus
    }
  }
}
    ${ScheduleCoreFieldsFragmentDoc}`;

/**
 * __useGetSchedulesCalendarQuery__
 *
 * To run a query within a React component, call `useGetSchedulesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulesCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      taskTypeIds: // value for 'taskTypeIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      buildingIds: // value for 'buildingIds'
 *   },
 * });
 */
export function useGetSchedulesCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulesCalendarQuery, GetSchedulesCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulesCalendarQuery, GetSchedulesCalendarQueryVariables>(GetSchedulesCalendarDocument, options);
      }
export function useGetSchedulesCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulesCalendarQuery, GetSchedulesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulesCalendarQuery, GetSchedulesCalendarQueryVariables>(GetSchedulesCalendarDocument, options);
        }
export type GetSchedulesCalendarQueryHookResult = ReturnType<typeof useGetSchedulesCalendarQuery>;
export type GetSchedulesCalendarLazyQueryHookResult = ReturnType<typeof useGetSchedulesCalendarLazyQuery>;
export type GetSchedulesCalendarQueryResult = Apollo.QueryResult<GetSchedulesCalendarQuery, GetSchedulesCalendarQueryVariables>;
export const GetScheduleDocument = gql`
    query getSchedule($scheduleId: String!) {
  getSchedule(scheduleId: $scheduleId) {
    ...ScheduleFields
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useGetScheduleQuery__
 *
 * To run a query within a React component, call `useGetScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGetScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, options);
      }
export function useGetScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, options);
        }
export type GetScheduleQueryHookResult = ReturnType<typeof useGetScheduleQuery>;
export type GetScheduleLazyQueryHookResult = ReturnType<typeof useGetScheduleLazyQuery>;
export type GetScheduleQueryResult = Apollo.QueryResult<GetScheduleQuery, GetScheduleQueryVariables>;
export const GetScheduleRelatedRecordsDocument = gql`
    query getScheduleRelatedRecords($id: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getScheduleRelatedRecords(
    id: $id
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      status
      title
      assignedTo {
        ...UserCoreFields
      }
      createdAt
      charges
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetScheduleRelatedRecordsQuery__
 *
 * To run a query within a React component, call `useGetScheduleRelatedRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleRelatedRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleRelatedRecordsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetScheduleRelatedRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleRelatedRecordsQuery, GetScheduleRelatedRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleRelatedRecordsQuery, GetScheduleRelatedRecordsQueryVariables>(GetScheduleRelatedRecordsDocument, options);
      }
export function useGetScheduleRelatedRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleRelatedRecordsQuery, GetScheduleRelatedRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleRelatedRecordsQuery, GetScheduleRelatedRecordsQueryVariables>(GetScheduleRelatedRecordsDocument, options);
        }
export type GetScheduleRelatedRecordsQueryHookResult = ReturnType<typeof useGetScheduleRelatedRecordsQuery>;
export type GetScheduleRelatedRecordsLazyQueryHookResult = ReturnType<typeof useGetScheduleRelatedRecordsLazyQuery>;
export type GetScheduleRelatedRecordsQueryResult = Apollo.QueryResult<GetScheduleRelatedRecordsQuery, GetScheduleRelatedRecordsQueryVariables>;
export const ExportSchedulesDocument = gql`
    query exportSchedules($search: String, $taskTypeIds: [String!], $recordStatuses: [RRuleStatuses!], $buildingIds: [String!], $from: DateTime, $to: DateTime) {
  exportSchedules(
    search: $search
    taskTypeIds: $taskTypeIds
    recordStatuses: $recordStatuses
    buildingIds: $buildingIds
    from: $from
    to: $to
  )
}
    `;

/**
 * __useExportSchedulesQuery__
 *
 * To run a query within a React component, call `useExportSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSchedulesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      taskTypeIds: // value for 'taskTypeIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      buildingIds: // value for 'buildingIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExportSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<ExportSchedulesQuery, ExportSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSchedulesQuery, ExportSchedulesQueryVariables>(ExportSchedulesDocument, options);
      }
export function useExportSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSchedulesQuery, ExportSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSchedulesQuery, ExportSchedulesQueryVariables>(ExportSchedulesDocument, options);
        }
export type ExportSchedulesQueryHookResult = ReturnType<typeof useExportSchedulesQuery>;
export type ExportSchedulesLazyQueryHookResult = ReturnType<typeof useExportSchedulesLazyQuery>;
export type ExportSchedulesQueryResult = Apollo.QueryResult<ExportSchedulesQuery, ExportSchedulesQueryVariables>;
export const CreateTaskTypeDocument = gql`
    mutation createTaskType($title: String!) {
  createTaskType(title: $title) {
    id
  }
}
    `;
export type CreateTaskTypeMutationFn = Apollo.MutationFunction<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>;

/**
 * __useCreateTaskTypeMutation__
 *
 * To run a mutation, you first call `useCreateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskTypeMutation, { data, loading, error }] = useCreateTaskTypeMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>(CreateTaskTypeDocument, options);
      }
export type CreateTaskTypeMutationHookResult = ReturnType<typeof useCreateTaskTypeMutation>;
export type CreateTaskTypeMutationResult = Apollo.MutationResult<CreateTaskTypeMutation>;
export type CreateTaskTypeMutationOptions = Apollo.BaseMutationOptions<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>;
export const UpdateTaskTypeDocument = gql`
    mutation updateTaskType($id: String!, $title: String!) {
  updateTaskType(id: $id, title: $title) {
    ...TaskTypeCoreFields
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;
export type UpdateTaskTypeMutationFn = Apollo.MutationFunction<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;

/**
 * __useUpdateTaskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTypeMutation, { data, loading, error }] = useUpdateTaskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>(UpdateTaskTypeDocument, options);
      }
export type UpdateTaskTypeMutationHookResult = ReturnType<typeof useUpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationResult = Apollo.MutationResult<UpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;
export const ToggleTaskTypeDocument = gql`
    mutation toggleTaskType($id: String!) {
  toggleTaskType(id: $id)
}
    `;
export type ToggleTaskTypeMutationFn = Apollo.MutationFunction<ToggleTaskTypeMutation, ToggleTaskTypeMutationVariables>;

/**
 * __useToggleTaskTypeMutation__
 *
 * To run a mutation, you first call `useToggleTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaskTypeMutation, { data, loading, error }] = useToggleTaskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTaskTypeMutation, ToggleTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTaskTypeMutation, ToggleTaskTypeMutationVariables>(ToggleTaskTypeDocument, options);
      }
export type ToggleTaskTypeMutationHookResult = ReturnType<typeof useToggleTaskTypeMutation>;
export type ToggleTaskTypeMutationResult = Apollo.MutationResult<ToggleTaskTypeMutation>;
export type ToggleTaskTypeMutationOptions = Apollo.BaseMutationOptions<ToggleTaskTypeMutation, ToggleTaskTypeMutationVariables>;
export const RemoveTaskTypesDocument = gql`
    mutation removeTaskTypes($data: DeleteRecordsInput!) {
  removeTaskTypes(input: $data)
}
    `;
export type RemoveTaskTypesMutationFn = Apollo.MutationFunction<RemoveTaskTypesMutation, RemoveTaskTypesMutationVariables>;

/**
 * __useRemoveTaskTypesMutation__
 *
 * To run a mutation, you first call `useRemoveTaskTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskTypesMutation, { data, loading, error }] = useRemoveTaskTypesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveTaskTypesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskTypesMutation, RemoveTaskTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskTypesMutation, RemoveTaskTypesMutationVariables>(RemoveTaskTypesDocument, options);
      }
export type RemoveTaskTypesMutationHookResult = ReturnType<typeof useRemoveTaskTypesMutation>;
export type RemoveTaskTypesMutationResult = Apollo.MutationResult<RemoveTaskTypesMutation>;
export type RemoveTaskTypesMutationOptions = Apollo.BaseMutationOptions<RemoveTaskTypesMutation, RemoveTaskTypesMutationVariables>;
export const GetTaskTypesDocument = gql`
    query getTaskTypes($active: Boolean, $search: String) {
  getTaskTypes(active: $active, search: $search) {
    ...TaskTypeCoreFields
    index
    active
    scheduleCount
    taskCount
    createdAt
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypesQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypesQuery, GetTaskTypesQueryVariables>(GetTaskTypesDocument, options);
      }
export function useGetTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypesQuery, GetTaskTypesQueryVariables>(GetTaskTypesDocument, options);
        }
export type GetTaskTypesQueryHookResult = ReturnType<typeof useGetTaskTypesQuery>;
export type GetTaskTypesLazyQueryHookResult = ReturnType<typeof useGetTaskTypesLazyQuery>;
export type GetTaskTypesQueryResult = Apollo.QueryResult<GetTaskTypesQuery, GetTaskTypesQueryVariables>;
export const GetTaskTypesDropdownDocument = gql`
    query getTaskTypesDropdown($active: Boolean, $search: String) {
  getTaskTypes(active: $active, search: $search) {
    ...TaskTypeCoreFields
    index
    active
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaskTypesDropdownQuery__
 *
 * To run a query within a React component, call `useGetTaskTypesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTaskTypesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskTypesDropdownQuery, GetTaskTypesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypesDropdownQuery, GetTaskTypesDropdownQueryVariables>(GetTaskTypesDropdownDocument, options);
      }
export function useGetTaskTypesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypesDropdownQuery, GetTaskTypesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypesDropdownQuery, GetTaskTypesDropdownQueryVariables>(GetTaskTypesDropdownDocument, options);
        }
export type GetTaskTypesDropdownQueryHookResult = ReturnType<typeof useGetTaskTypesDropdownQuery>;
export type GetTaskTypesDropdownLazyQueryHookResult = ReturnType<typeof useGetTaskTypesDropdownLazyQuery>;
export type GetTaskTypesDropdownQueryResult = Apollo.QueryResult<GetTaskTypesDropdownQuery, GetTaskTypesDropdownQueryVariables>;
export const GetTaskTypeDocument = gql`
    query getTaskType($id: String!) {
  getTaskType(id: $id) {
    ...TaskTypeCoreFields
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaskTypeQuery__
 *
 * To run a query within a React component, call `useGetTaskTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskTypeQuery(baseOptions: Apollo.QueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypeQuery, GetTaskTypeQueryVariables>(GetTaskTypeDocument, options);
      }
export function useGetTaskTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypeQuery, GetTaskTypeQueryVariables>(GetTaskTypeDocument, options);
        }
export type GetTaskTypeQueryHookResult = ReturnType<typeof useGetTaskTypeQuery>;
export type GetTaskTypeLazyQueryHookResult = ReturnType<typeof useGetTaskTypeLazyQuery>;
export type GetTaskTypeQueryResult = Apollo.QueryResult<GetTaskTypeQuery, GetTaskTypeQueryVariables>;
export const ToggleTaskWatcherDocument = gql`
    mutation toggleTaskWatcher($taskId: String!, $userId: String!) {
  toggleTaskWatcher(taskId: $taskId, userId: $userId) {
    id
    firstName
    lastName
  }
}
    `;
export type ToggleTaskWatcherMutationFn = Apollo.MutationFunction<ToggleTaskWatcherMutation, ToggleTaskWatcherMutationVariables>;

/**
 * __useToggleTaskWatcherMutation__
 *
 * To run a mutation, you first call `useToggleTaskWatcherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaskWatcherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaskWatcherMutation, { data, loading, error }] = useToggleTaskWatcherMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleTaskWatcherMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTaskWatcherMutation, ToggleTaskWatcherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTaskWatcherMutation, ToggleTaskWatcherMutationVariables>(ToggleTaskWatcherDocument, options);
      }
export type ToggleTaskWatcherMutationHookResult = ReturnType<typeof useToggleTaskWatcherMutation>;
export type ToggleTaskWatcherMutationResult = Apollo.MutationResult<ToggleTaskWatcherMutation>;
export type ToggleTaskWatcherMutationOptions = Apollo.BaseMutationOptions<ToggleTaskWatcherMutation, ToggleTaskWatcherMutationVariables>;
export const UpdateTaskNotesDocument = gql`
    mutation updateTaskNotes($taskId: String!, $notes: String) {
  updateTaskNotes(taskId: $taskId, notes: $notes) {
    id
    notes
  }
}
    `;
export type UpdateTaskNotesMutationFn = Apollo.MutationFunction<UpdateTaskNotesMutation, UpdateTaskNotesMutationVariables>;

/**
 * __useUpdateTaskNotesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskNotesMutation, { data, loading, error }] = useUpdateTaskNotesMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateTaskNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskNotesMutation, UpdateTaskNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskNotesMutation, UpdateTaskNotesMutationVariables>(UpdateTaskNotesDocument, options);
      }
export type UpdateTaskNotesMutationHookResult = ReturnType<typeof useUpdateTaskNotesMutation>;
export type UpdateTaskNotesMutationResult = Apollo.MutationResult<UpdateTaskNotesMutation>;
export type UpdateTaskNotesMutationOptions = Apollo.BaseMutationOptions<UpdateTaskNotesMutation, UpdateTaskNotesMutationVariables>;
export const UpdateTaskAssignedToDocument = gql`
    mutation updateTaskAssignedTo($taskId: String!, $assignedToId: String) {
  updateTaskAssignedTo(taskId: $taskId, assignedToId: $assignedToId) {
    id
    assignedTo {
      ...UserCoreFields
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type UpdateTaskAssignedToMutationFn = Apollo.MutationFunction<UpdateTaskAssignedToMutation, UpdateTaskAssignedToMutationVariables>;

/**
 * __useUpdateTaskAssignedToMutation__
 *
 * To run a mutation, you first call `useUpdateTaskAssignedToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAssignedToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskAssignedToMutation, { data, loading, error }] = useUpdateTaskAssignedToMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useUpdateTaskAssignedToMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskAssignedToMutation, UpdateTaskAssignedToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskAssignedToMutation, UpdateTaskAssignedToMutationVariables>(UpdateTaskAssignedToDocument, options);
      }
export type UpdateTaskAssignedToMutationHookResult = ReturnType<typeof useUpdateTaskAssignedToMutation>;
export type UpdateTaskAssignedToMutationResult = Apollo.MutationResult<UpdateTaskAssignedToMutation>;
export type UpdateTaskAssignedToMutationOptions = Apollo.BaseMutationOptions<UpdateTaskAssignedToMutation, UpdateTaskAssignedToMutationVariables>;
export const UpdateTaskDueDateDocument = gql`
    mutation updateTaskDueDate($taskId: String!, $dueDate: String) {
  updateTaskDueDate(taskId: $taskId, dueDate: $dueDate) {
    id
    dueDate
    status
  }
}
    `;
export type UpdateTaskDueDateMutationFn = Apollo.MutationFunction<UpdateTaskDueDateMutation, UpdateTaskDueDateMutationVariables>;

/**
 * __useUpdateTaskDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDueDateMutation, { data, loading, error }] = useUpdateTaskDueDateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpdateTaskDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDueDateMutation, UpdateTaskDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDueDateMutation, UpdateTaskDueDateMutationVariables>(UpdateTaskDueDateDocument, options);
      }
export type UpdateTaskDueDateMutationHookResult = ReturnType<typeof useUpdateTaskDueDateMutation>;
export type UpdateTaskDueDateMutationResult = Apollo.MutationResult<UpdateTaskDueDateMutation>;
export type UpdateTaskDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDueDateMutation, UpdateTaskDueDateMutationVariables>;
export const UpdateTaskTaskTypeDocument = gql`
    mutation updateTaskTaskType($taskId: String!, $taskTypeId: String) {
  updateTaskTaskType(taskId: $taskId, taskTypeId: $taskTypeId) {
    id
    taskType {
      ...TaskTypeCoreFields
    }
  }
}
    ${TaskTypeCoreFieldsFragmentDoc}`;
export type UpdateTaskTaskTypeMutationFn = Apollo.MutationFunction<UpdateTaskTaskTypeMutation, UpdateTaskTaskTypeMutationVariables>;

/**
 * __useUpdateTaskTaskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTaskTypeMutation, { data, loading, error }] = useUpdateTaskTaskTypeMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      taskTypeId: // value for 'taskTypeId'
 *   },
 * });
 */
export function useUpdateTaskTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTaskTypeMutation, UpdateTaskTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTaskTypeMutation, UpdateTaskTaskTypeMutationVariables>(UpdateTaskTaskTypeDocument, options);
      }
export type UpdateTaskTaskTypeMutationHookResult = ReturnType<typeof useUpdateTaskTaskTypeMutation>;
export type UpdateTaskTaskTypeMutationResult = Apollo.MutationResult<UpdateTaskTaskTypeMutation>;
export type UpdateTaskTaskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTaskTypeMutation, UpdateTaskTaskTypeMutationVariables>;
export const UpdateTaskProcedureNotesDocument = gql`
    mutation updateTaskProcedureNotes($taskProcedureId: String!, $notes: String) {
  updateTaskProcedureNotes(taskProcedureId: $taskProcedureId, notes: $notes) {
    id
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type UpdateTaskProcedureNotesMutationFn = Apollo.MutationFunction<UpdateTaskProcedureNotesMutation, UpdateTaskProcedureNotesMutationVariables>;

/**
 * __useUpdateTaskProcedureNotesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskProcedureNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskProcedureNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskProcedureNotesMutation, { data, loading, error }] = useUpdateTaskProcedureNotesMutation({
 *   variables: {
 *      taskProcedureId: // value for 'taskProcedureId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateTaskProcedureNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskProcedureNotesMutation, UpdateTaskProcedureNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskProcedureNotesMutation, UpdateTaskProcedureNotesMutationVariables>(UpdateTaskProcedureNotesDocument, options);
      }
export type UpdateTaskProcedureNotesMutationHookResult = ReturnType<typeof useUpdateTaskProcedureNotesMutation>;
export type UpdateTaskProcedureNotesMutationResult = Apollo.MutationResult<UpdateTaskProcedureNotesMutation>;
export type UpdateTaskProcedureNotesMutationOptions = Apollo.BaseMutationOptions<UpdateTaskProcedureNotesMutation, UpdateTaskProcedureNotesMutationVariables>;
export const AddTaskAttachmentsDocument = gql`
    mutation addTaskAttachments($taskId: String!, $attachments: [FileObjectInput!]!) {
  addTaskAttachments(taskId: $taskId, attachments: $attachments) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type AddTaskAttachmentsMutationFn = Apollo.MutationFunction<AddTaskAttachmentsMutation, AddTaskAttachmentsMutationVariables>;

/**
 * __useAddTaskAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddTaskAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskAttachmentsMutation, { data, loading, error }] = useAddTaskAttachmentsMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddTaskAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskAttachmentsMutation, AddTaskAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskAttachmentsMutation, AddTaskAttachmentsMutationVariables>(AddTaskAttachmentsDocument, options);
      }
export type AddTaskAttachmentsMutationHookResult = ReturnType<typeof useAddTaskAttachmentsMutation>;
export type AddTaskAttachmentsMutationResult = Apollo.MutationResult<AddTaskAttachmentsMutation>;
export type AddTaskAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddTaskAttachmentsMutation, AddTaskAttachmentsMutationVariables>;
export const RemoveTaskAttachmentDocument = gql`
    mutation removeTaskAttachment($taskId: String!, $attachmentId: String!) {
  removeTaskAttachment(taskId: $taskId, attachmentId: $attachmentId) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type RemoveTaskAttachmentMutationFn = Apollo.MutationFunction<RemoveTaskAttachmentMutation, RemoveTaskAttachmentMutationVariables>;

/**
 * __useRemoveTaskAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveTaskAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskAttachmentMutation, { data, loading, error }] = useRemoveTaskAttachmentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveTaskAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskAttachmentMutation, RemoveTaskAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskAttachmentMutation, RemoveTaskAttachmentMutationVariables>(RemoveTaskAttachmentDocument, options);
      }
export type RemoveTaskAttachmentMutationHookResult = ReturnType<typeof useRemoveTaskAttachmentMutation>;
export type RemoveTaskAttachmentMutationResult = Apollo.MutationResult<RemoveTaskAttachmentMutation>;
export type RemoveTaskAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveTaskAttachmentMutation, RemoveTaskAttachmentMutationVariables>;
export const AddTaskEquipmentDocument = gql`
    mutation addTaskEquipment($taskId: String!, $equipmentId: String!) {
  addTaskEquipment(taskId: $taskId, equipmentId: $equipmentId) {
    id
    equipment {
      ...TaskEquipmentFields
    }
  }
}
    ${TaskEquipmentFieldsFragmentDoc}`;
export type AddTaskEquipmentMutationFn = Apollo.MutationFunction<AddTaskEquipmentMutation, AddTaskEquipmentMutationVariables>;

/**
 * __useAddTaskEquipmentMutation__
 *
 * To run a mutation, you first call `useAddTaskEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskEquipmentMutation, { data, loading, error }] = useAddTaskEquipmentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useAddTaskEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskEquipmentMutation, AddTaskEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskEquipmentMutation, AddTaskEquipmentMutationVariables>(AddTaskEquipmentDocument, options);
      }
export type AddTaskEquipmentMutationHookResult = ReturnType<typeof useAddTaskEquipmentMutation>;
export type AddTaskEquipmentMutationResult = Apollo.MutationResult<AddTaskEquipmentMutation>;
export type AddTaskEquipmentMutationOptions = Apollo.BaseMutationOptions<AddTaskEquipmentMutation, AddTaskEquipmentMutationVariables>;
export const RemoveTaskEquipmentDocument = gql`
    mutation removeTaskEquipment($taskId: String!, $equipmentId: String!) {
  removeTaskEquipment(taskId: $taskId, equipmentId: $equipmentId) {
    id
    equipment {
      ...TaskEquipmentFields
    }
  }
}
    ${TaskEquipmentFieldsFragmentDoc}`;
export type RemoveTaskEquipmentMutationFn = Apollo.MutationFunction<RemoveTaskEquipmentMutation, RemoveTaskEquipmentMutationVariables>;

/**
 * __useRemoveTaskEquipmentMutation__
 *
 * To run a mutation, you first call `useRemoveTaskEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskEquipmentMutation, { data, loading, error }] = useRemoveTaskEquipmentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useRemoveTaskEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskEquipmentMutation, RemoveTaskEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskEquipmentMutation, RemoveTaskEquipmentMutationVariables>(RemoveTaskEquipmentDocument, options);
      }
export type RemoveTaskEquipmentMutationHookResult = ReturnType<typeof useRemoveTaskEquipmentMutation>;
export type RemoveTaskEquipmentMutationResult = Apollo.MutationResult<RemoveTaskEquipmentMutation>;
export type RemoveTaskEquipmentMutationOptions = Apollo.BaseMutationOptions<RemoveTaskEquipmentMutation, RemoveTaskEquipmentMutationVariables>;
export const AddTaskProcedureDocument = gql`
    mutation addTaskProcedure($taskId: String!, $procedureId: String!) {
  addTaskProcedure(taskId: $taskId, procedureId: $procedureId) {
    id
    status
    systemCompleted
    completedAt
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type AddTaskProcedureMutationFn = Apollo.MutationFunction<AddTaskProcedureMutation, AddTaskProcedureMutationVariables>;

/**
 * __useAddTaskProcedureMutation__
 *
 * To run a mutation, you first call `useAddTaskProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskProcedureMutation, { data, loading, error }] = useAddTaskProcedureMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useAddTaskProcedureMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskProcedureMutation, AddTaskProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskProcedureMutation, AddTaskProcedureMutationVariables>(AddTaskProcedureDocument, options);
      }
export type AddTaskProcedureMutationHookResult = ReturnType<typeof useAddTaskProcedureMutation>;
export type AddTaskProcedureMutationResult = Apollo.MutationResult<AddTaskProcedureMutation>;
export type AddTaskProcedureMutationOptions = Apollo.BaseMutationOptions<AddTaskProcedureMutation, AddTaskProcedureMutationVariables>;
export const RemoveTaskProcedureDocument = gql`
    mutation removeTaskProcedure($taskId: String!, $procedureId: String!) {
  removeTaskProcedure(taskId: $taskId, procedureId: $procedureId) {
    id
    status
    systemCompleted
    completedAt
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type RemoveTaskProcedureMutationFn = Apollo.MutationFunction<RemoveTaskProcedureMutation, RemoveTaskProcedureMutationVariables>;

/**
 * __useRemoveTaskProcedureMutation__
 *
 * To run a mutation, you first call `useRemoveTaskProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskProcedureMutation, { data, loading, error }] = useRemoveTaskProcedureMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useRemoveTaskProcedureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskProcedureMutation, RemoveTaskProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskProcedureMutation, RemoveTaskProcedureMutationVariables>(RemoveTaskProcedureDocument, options);
      }
export type RemoveTaskProcedureMutationHookResult = ReturnType<typeof useRemoveTaskProcedureMutation>;
export type RemoveTaskProcedureMutationResult = Apollo.MutationResult<RemoveTaskProcedureMutation>;
export type RemoveTaskProcedureMutationOptions = Apollo.BaseMutationOptions<RemoveTaskProcedureMutation, RemoveTaskProcedureMutationVariables>;
export const ToggleTaskDocument = gql`
    mutation toggleTask($taskId: String!) {
  toggleTask(taskId: $taskId) {
    id
    status
    userCompleted
    completedAt
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type ToggleTaskMutationFn = Apollo.MutationFunction<ToggleTaskMutation, ToggleTaskMutationVariables>;

/**
 * __useToggleTaskMutation__
 *
 * To run a mutation, you first call `useToggleTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaskMutation, { data, loading, error }] = useToggleTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useToggleTaskMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTaskMutation, ToggleTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTaskMutation, ToggleTaskMutationVariables>(ToggleTaskDocument, options);
      }
export type ToggleTaskMutationHookResult = ReturnType<typeof useToggleTaskMutation>;
export type ToggleTaskMutationResult = Apollo.MutationResult<ToggleTaskMutation>;
export type ToggleTaskMutationOptions = Apollo.BaseMutationOptions<ToggleTaskMutation, ToggleTaskMutationVariables>;
export const SetTaskStepValueDocument = gql`
    mutation setTaskStepValue($taskStepId: String!, $value: CustomFieldScalar) {
  setTaskStepValue(taskStepId: $taskStepId, value: $value) {
    id
    status
    systemCompleted
    completedAt
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type SetTaskStepValueMutationFn = Apollo.MutationFunction<SetTaskStepValueMutation, SetTaskStepValueMutationVariables>;

/**
 * __useSetTaskStepValueMutation__
 *
 * To run a mutation, you first call `useSetTaskStepValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskStepValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskStepValueMutation, { data, loading, error }] = useSetTaskStepValueMutation({
 *   variables: {
 *      taskStepId: // value for 'taskStepId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetTaskStepValueMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskStepValueMutation, SetTaskStepValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskStepValueMutation, SetTaskStepValueMutationVariables>(SetTaskStepValueDocument, options);
      }
export type SetTaskStepValueMutationHookResult = ReturnType<typeof useSetTaskStepValueMutation>;
export type SetTaskStepValueMutationResult = Apollo.MutationResult<SetTaskStepValueMutation>;
export type SetTaskStepValueMutationOptions = Apollo.BaseMutationOptions<SetTaskStepValueMutation, SetTaskStepValueMutationVariables>;
export const SetTaskStepCustomIdDocument = gql`
    mutation setTaskStepCustomId($taskStepId: String!, $customId: String, $predefinedCustomFieldId: String) {
  setTaskStepCustomId(
    taskStepId: $taskStepId
    customId: $customId
    predefinedCustomFieldId: $predefinedCustomFieldId
  ) {
    id
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type SetTaskStepCustomIdMutationFn = Apollo.MutationFunction<SetTaskStepCustomIdMutation, SetTaskStepCustomIdMutationVariables>;

/**
 * __useSetTaskStepCustomIdMutation__
 *
 * To run a mutation, you first call `useSetTaskStepCustomIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskStepCustomIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskStepCustomIdMutation, { data, loading, error }] = useSetTaskStepCustomIdMutation({
 *   variables: {
 *      taskStepId: // value for 'taskStepId'
 *      customId: // value for 'customId'
 *      predefinedCustomFieldId: // value for 'predefinedCustomFieldId'
 *   },
 * });
 */
export function useSetTaskStepCustomIdMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskStepCustomIdMutation, SetTaskStepCustomIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskStepCustomIdMutation, SetTaskStepCustomIdMutationVariables>(SetTaskStepCustomIdDocument, options);
      }
export type SetTaskStepCustomIdMutationHookResult = ReturnType<typeof useSetTaskStepCustomIdMutation>;
export type SetTaskStepCustomIdMutationResult = Apollo.MutationResult<SetTaskStepCustomIdMutation>;
export type SetTaskStepCustomIdMutationOptions = Apollo.BaseMutationOptions<SetTaskStepCustomIdMutation, SetTaskStepCustomIdMutationVariables>;
export const RemoveTaskStepAttachmentDocument = gql`
    mutation removeTaskStepAttachment($taskStepId: String!, $attachmentId: String!) {
  removeTaskStepAttachment(taskStepId: $taskStepId, attachmentId: $attachmentId) {
    id
    status
    systemCompleted
    completedAt
    procedures {
      ...TaskProcedureFields
    }
  }
}
    ${TaskProcedureFieldsFragmentDoc}`;
export type RemoveTaskStepAttachmentMutationFn = Apollo.MutationFunction<RemoveTaskStepAttachmentMutation, RemoveTaskStepAttachmentMutationVariables>;

/**
 * __useRemoveTaskStepAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveTaskStepAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskStepAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskStepAttachmentMutation, { data, loading, error }] = useRemoveTaskStepAttachmentMutation({
 *   variables: {
 *      taskStepId: // value for 'taskStepId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveTaskStepAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskStepAttachmentMutation, RemoveTaskStepAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskStepAttachmentMutation, RemoveTaskStepAttachmentMutationVariables>(RemoveTaskStepAttachmentDocument, options);
      }
export type RemoveTaskStepAttachmentMutationHookResult = ReturnType<typeof useRemoveTaskStepAttachmentMutation>;
export type RemoveTaskStepAttachmentMutationResult = Apollo.MutationResult<RemoveTaskStepAttachmentMutation>;
export type RemoveTaskStepAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveTaskStepAttachmentMutation, RemoveTaskStepAttachmentMutationVariables>;
export const RemoveTasksDocument = gql`
    mutation removeTasks($data: DeleteRecordsInput!) {
  removeTasks(input: $data)
}
    `;
export type RemoveTasksMutationFn = Apollo.MutationFunction<RemoveTasksMutation, RemoveTasksMutationVariables>;

/**
 * __useRemoveTasksMutation__
 *
 * To run a mutation, you first call `useRemoveTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTasksMutation, { data, loading, error }] = useRemoveTasksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveTasksMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTasksMutation, RemoveTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTasksMutation, RemoveTasksMutationVariables>(RemoveTasksDocument, options);
      }
export type RemoveTasksMutationHookResult = ReturnType<typeof useRemoveTasksMutation>;
export type RemoveTasksMutationResult = Apollo.MutationResult<RemoveTasksMutation>;
export type RemoveTasksMutationOptions = Apollo.BaseMutationOptions<RemoveTasksMutation, RemoveTasksMutationVariables>;
export const GetTasksDocument = gql`
    query getTasks($take: Int! = 10, $after: String, $before: String, $search: String, $taskTypeIds: [String!], $buildingIds: [String!], $createdFrom: DateTime, $createdTo: DateTime, $completedFrom: DateTime, $completedTo: DateTime, $dueDateFrom: DateTime, $dueDateTo: DateTime, $createdByIds: [String!], $assignedToIds: [String!], $equipmentIds: [String!], $status: TaskStatusEnum) {
  getTasks(
    take: $take
    after: $after
    before: $before
    search: $search
    taskTypeIds: $taskTypeIds
    buildingIds: $buildingIds
    createdFrom: $createdFrom
    createdTo: $createdTo
    completedFrom: $completedFrom
    completedTo: $completedTo
    dueDateFrom: $dueDateFrom
    dueDateTo: $dueDateTo
    createdByIds: $createdByIds
    assignedToIds: $assignedToIds
    equipmentIds: $equipmentIds
    status: $status
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...TaskCoreFields
      index
      status
      notes
      charges
      createdAt
      completedAt
      dueDate
      equipment {
        ...EquipmentCoreFields
      }
      taskType {
        ...TaskTypeCoreFields
      }
      building {
        ...BuildingCoreFields
      }
      assignedTo {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${TaskCoreFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${TaskTypeCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      taskTypeIds: // value for 'taskTypeIds'
 *      buildingIds: // value for 'buildingIds'
 *      createdFrom: // value for 'createdFrom'
 *      createdTo: // value for 'createdTo'
 *      completedFrom: // value for 'completedFrom'
 *      completedTo: // value for 'completedTo'
 *      dueDateFrom: // value for 'dueDateFrom'
 *      dueDateTo: // value for 'dueDateTo'
 *      createdByIds: // value for 'createdByIds'
 *      assignedToIds: // value for 'assignedToIds'
 *      equipmentIds: // value for 'equipmentIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetTaskDocument = gql`
    query getTask($id: String!) {
  getTask(id: $id) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetTaskChargesDocument = gql`
    query getTaskCharges($taskId: String!, $search: String) {
  getTaskCharges(taskId: $taskId, search: $search) {
    id
    type
    date
    billable
    invoiceId
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetTaskChargesQuery__
 *
 * To run a query within a React component, call `useGetTaskChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskChargesQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTaskChargesQuery(baseOptions: Apollo.QueryHookOptions<GetTaskChargesQuery, GetTaskChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskChargesQuery, GetTaskChargesQueryVariables>(GetTaskChargesDocument, options);
      }
export function useGetTaskChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskChargesQuery, GetTaskChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskChargesQuery, GetTaskChargesQueryVariables>(GetTaskChargesDocument, options);
        }
export type GetTaskChargesQueryHookResult = ReturnType<typeof useGetTaskChargesQuery>;
export type GetTaskChargesLazyQueryHookResult = ReturnType<typeof useGetTaskChargesLazyQuery>;
export type GetTaskChargesQueryResult = Apollo.QueryResult<GetTaskChargesQuery, GetTaskChargesQueryVariables>;
export const CreatePrinterDocument = gql`
    mutation createPrinter($data: PrinterInput!) {
  createPrinter(input: $data) {
    id
  }
}
    `;
export type CreatePrinterMutationFn = Apollo.MutationFunction<CreatePrinterMutation, CreatePrinterMutationVariables>;

/**
 * __useCreatePrinterMutation__
 *
 * To run a mutation, you first call `useCreatePrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrinterMutation, { data, loading, error }] = useCreatePrinterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrinterMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrinterMutation, CreatePrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrinterMutation, CreatePrinterMutationVariables>(CreatePrinterDocument, options);
      }
export type CreatePrinterMutationHookResult = ReturnType<typeof useCreatePrinterMutation>;
export type CreatePrinterMutationResult = Apollo.MutationResult<CreatePrinterMutation>;
export type CreatePrinterMutationOptions = Apollo.BaseMutationOptions<CreatePrinterMutation, CreatePrinterMutationVariables>;
export const UpdatePrinterDocument = gql`
    mutation updatePrinter($id: String!, $data: PrinterInput!) {
  updatePrinter(printerId: $id, input: $data) {
    ...PrinterFields
  }
}
    ${PrinterFieldsFragmentDoc}`;
export type UpdatePrinterMutationFn = Apollo.MutationFunction<UpdatePrinterMutation, UpdatePrinterMutationVariables>;

/**
 * __useUpdatePrinterMutation__
 *
 * To run a mutation, you first call `useUpdatePrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrinterMutation, { data, loading, error }] = useUpdatePrinterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrinterMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrinterMutation, UpdatePrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrinterMutation, UpdatePrinterMutationVariables>(UpdatePrinterDocument, options);
      }
export type UpdatePrinterMutationHookResult = ReturnType<typeof useUpdatePrinterMutation>;
export type UpdatePrinterMutationResult = Apollo.MutationResult<UpdatePrinterMutation>;
export type UpdatePrinterMutationOptions = Apollo.BaseMutationOptions<UpdatePrinterMutation, UpdatePrinterMutationVariables>;
export const DeletePrintersDocument = gql`
    mutation deletePrinters($data: DeleteRecordsInput!) {
  deletePrinters(input: $data)
}
    `;
export type DeletePrintersMutationFn = Apollo.MutationFunction<DeletePrintersMutation, DeletePrintersMutationVariables>;

/**
 * __useDeletePrintersMutation__
 *
 * To run a mutation, you first call `useDeletePrintersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrintersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrintersMutation, { data, loading, error }] = useDeletePrintersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePrintersMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrintersMutation, DeletePrintersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrintersMutation, DeletePrintersMutationVariables>(DeletePrintersDocument, options);
      }
export type DeletePrintersMutationHookResult = ReturnType<typeof useDeletePrintersMutation>;
export type DeletePrintersMutationResult = Apollo.MutationResult<DeletePrintersMutation>;
export type DeletePrintersMutationOptions = Apollo.BaseMutationOptions<DeletePrintersMutation, DeletePrintersMutationVariables>;
export const SyncPrintersDocument = gql`
    mutation syncPrinters {
  syncPrinters
}
    `;
export type SyncPrintersMutationFn = Apollo.MutationFunction<SyncPrintersMutation, SyncPrintersMutationVariables>;

/**
 * __useSyncPrintersMutation__
 *
 * To run a mutation, you first call `useSyncPrintersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPrintersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPrintersMutation, { data, loading, error }] = useSyncPrintersMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPrintersMutation(baseOptions?: Apollo.MutationHookOptions<SyncPrintersMutation, SyncPrintersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPrintersMutation, SyncPrintersMutationVariables>(SyncPrintersDocument, options);
      }
export type SyncPrintersMutationHookResult = ReturnType<typeof useSyncPrintersMutation>;
export type SyncPrintersMutationResult = Apollo.MutationResult<SyncPrintersMutation>;
export type SyncPrintersMutationOptions = Apollo.BaseMutationOptions<SyncPrintersMutation, SyncPrintersMutationVariables>;
export const GetPrintersTableDocument = gql`
    query getPrintersTable {
  getPrinters {
    ...PrinterFields
    synced
  }
}
    ${PrinterFieldsFragmentDoc}`;

/**
 * __useGetPrintersTableQuery__
 *
 * To run a query within a React component, call `useGetPrintersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintersTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrintersTableQuery(baseOptions?: Apollo.QueryHookOptions<GetPrintersTableQuery, GetPrintersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintersTableQuery, GetPrintersTableQueryVariables>(GetPrintersTableDocument, options);
      }
export function useGetPrintersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintersTableQuery, GetPrintersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintersTableQuery, GetPrintersTableQueryVariables>(GetPrintersTableDocument, options);
        }
export type GetPrintersTableQueryHookResult = ReturnType<typeof useGetPrintersTableQuery>;
export type GetPrintersTableLazyQueryHookResult = ReturnType<typeof useGetPrintersTableLazyQuery>;
export type GetPrintersTableQueryResult = Apollo.QueryResult<GetPrintersTableQuery, GetPrintersTableQueryVariables>;
export const GetPrintersDropdownDocument = gql`
    query getPrintersDropdown {
  getPrinters {
    ...PrinterCoreFields
  }
}
    ${PrinterCoreFieldsFragmentDoc}`;

/**
 * __useGetPrintersDropdownQuery__
 *
 * To run a query within a React component, call `useGetPrintersDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintersDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintersDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrintersDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetPrintersDropdownQuery, GetPrintersDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintersDropdownQuery, GetPrintersDropdownQueryVariables>(GetPrintersDropdownDocument, options);
      }
export function useGetPrintersDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintersDropdownQuery, GetPrintersDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintersDropdownQuery, GetPrintersDropdownQueryVariables>(GetPrintersDropdownDocument, options);
        }
export type GetPrintersDropdownQueryHookResult = ReturnType<typeof useGetPrintersDropdownQuery>;
export type GetPrintersDropdownLazyQueryHookResult = ReturnType<typeof useGetPrintersDropdownLazyQuery>;
export type GetPrintersDropdownQueryResult = Apollo.QueryResult<GetPrintersDropdownQuery, GetPrintersDropdownQueryVariables>;
export const GetPrinterDocument = gql`
    query getPrinter($id: String!) {
  getPrinter(printerId: $id) {
    ...PrinterFields
  }
}
    ${PrinterFieldsFragmentDoc}`;

/**
 * __useGetPrinterQuery__
 *
 * To run a query within a React component, call `useGetPrinterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrinterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrinterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrinterQuery(baseOptions: Apollo.QueryHookOptions<GetPrinterQuery, GetPrinterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrinterQuery, GetPrinterQueryVariables>(GetPrinterDocument, options);
      }
export function useGetPrinterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrinterQuery, GetPrinterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrinterQuery, GetPrinterQueryVariables>(GetPrinterDocument, options);
        }
export type GetPrinterQueryHookResult = ReturnType<typeof useGetPrinterQuery>;
export type GetPrinterLazyQueryHookResult = ReturnType<typeof useGetPrinterLazyQuery>;
export type GetPrinterQueryResult = Apollo.QueryResult<GetPrinterQuery, GetPrinterQueryVariables>;
export const ExportPrintersDocument = gql`
    query exportPrinters {
  exportPrinters
}
    `;

/**
 * __useExportPrintersQuery__
 *
 * To run a query within a React component, call `useExportPrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPrintersQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportPrintersQuery(baseOptions?: Apollo.QueryHookOptions<ExportPrintersQuery, ExportPrintersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPrintersQuery, ExportPrintersQueryVariables>(ExportPrintersDocument, options);
      }
export function useExportPrintersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPrintersQuery, ExportPrintersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPrintersQuery, ExportPrintersQueryVariables>(ExportPrintersDocument, options);
        }
export type ExportPrintersQueryHookResult = ReturnType<typeof useExportPrintersQuery>;
export type ExportPrintersLazyQueryHookResult = ReturnType<typeof useExportPrintersLazyQuery>;
export type ExportPrintersQueryResult = Apollo.QueryResult<ExportPrintersQuery, ExportPrintersQueryVariables>;
export const CreatePriorityDocument = gql`
    mutation createPriority($data: PriorityInput!) {
  createPriority(input: $data) {
    id
  }
}
    `;
export type CreatePriorityMutationFn = Apollo.MutationFunction<CreatePriorityMutation, CreatePriorityMutationVariables>;

/**
 * __useCreatePriorityMutation__
 *
 * To run a mutation, you first call `useCreatePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriorityMutation, { data, loading, error }] = useCreatePriorityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePriorityMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriorityMutation, CreatePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriorityMutation, CreatePriorityMutationVariables>(CreatePriorityDocument, options);
      }
export type CreatePriorityMutationHookResult = ReturnType<typeof useCreatePriorityMutation>;
export type CreatePriorityMutationResult = Apollo.MutationResult<CreatePriorityMutation>;
export type CreatePriorityMutationOptions = Apollo.BaseMutationOptions<CreatePriorityMutation, CreatePriorityMutationVariables>;
export const UpdatePriorityDocument = gql`
    mutation updatePriority($id: String!, $data: PriorityUpdateInput!) {
  updatePriority(id: $id, input: $data) {
    ...PriorityFields
  }
}
    ${PriorityFieldsFragmentDoc}`;
export type UpdatePriorityMutationFn = Apollo.MutationFunction<UpdatePriorityMutation, UpdatePriorityMutationVariables>;

/**
 * __useUpdatePriorityMutation__
 *
 * To run a mutation, you first call `useUpdatePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriorityMutation, { data, loading, error }] = useUpdatePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriorityMutation, UpdatePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriorityMutation, UpdatePriorityMutationVariables>(UpdatePriorityDocument, options);
      }
export type UpdatePriorityMutationHookResult = ReturnType<typeof useUpdatePriorityMutation>;
export type UpdatePriorityMutationResult = Apollo.MutationResult<UpdatePriorityMutation>;
export type UpdatePriorityMutationOptions = Apollo.BaseMutationOptions<UpdatePriorityMutation, UpdatePriorityMutationVariables>;
export const ReorderPrioritiesDocument = gql`
    mutation reorderPriorities($id: String!, $secondId: String!) {
  reorderPriorities(id: $id, secondId: $secondId)
}
    `;
export type ReorderPrioritiesMutationFn = Apollo.MutationFunction<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>;

/**
 * __useReorderPrioritiesMutation__
 *
 * To run a mutation, you first call `useReorderPrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPrioritiesMutation, { data, loading, error }] = useReorderPrioritiesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderPrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>(ReorderPrioritiesDocument, options);
      }
export type ReorderPrioritiesMutationHookResult = ReturnType<typeof useReorderPrioritiesMutation>;
export type ReorderPrioritiesMutationResult = Apollo.MutationResult<ReorderPrioritiesMutation>;
export type ReorderPrioritiesMutationOptions = Apollo.BaseMutationOptions<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>;
export const TogglePriorityDocument = gql`
    mutation togglePriority($id: String!) {
  togglePriority(id: $id)
}
    `;
export type TogglePriorityMutationFn = Apollo.MutationFunction<TogglePriorityMutation, TogglePriorityMutationVariables>;

/**
 * __useTogglePriorityMutation__
 *
 * To run a mutation, you first call `useTogglePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePriorityMutation, { data, loading, error }] = useTogglePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePriorityMutation(baseOptions?: Apollo.MutationHookOptions<TogglePriorityMutation, TogglePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePriorityMutation, TogglePriorityMutationVariables>(TogglePriorityDocument, options);
      }
export type TogglePriorityMutationHookResult = ReturnType<typeof useTogglePriorityMutation>;
export type TogglePriorityMutationResult = Apollo.MutationResult<TogglePriorityMutation>;
export type TogglePriorityMutationOptions = Apollo.BaseMutationOptions<TogglePriorityMutation, TogglePriorityMutationVariables>;
export const RemovePrioritiesDocument = gql`
    mutation removePriorities($data: DeleteRecordsInput!) {
  removePriorities(input: $data)
}
    `;
export type RemovePrioritiesMutationFn = Apollo.MutationFunction<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>;

/**
 * __useRemovePrioritiesMutation__
 *
 * To run a mutation, you first call `useRemovePrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePrioritiesMutation, { data, loading, error }] = useRemovePrioritiesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>(RemovePrioritiesDocument, options);
      }
export type RemovePrioritiesMutationHookResult = ReturnType<typeof useRemovePrioritiesMutation>;
export type RemovePrioritiesMutationResult = Apollo.MutationResult<RemovePrioritiesMutation>;
export type RemovePrioritiesMutationOptions = Apollo.BaseMutationOptions<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>;
export const GetPrioritiesTableDocument = gql`
    query getPrioritiesTable($recordType: PriorityRecordType!, $active: Boolean, $search: String) {
  getPriorities(recordType: $recordType, active: $active, search: $search) {
    ...PriorityCoreFields
    color
    index
    active
    propertyId
  }
}
    ${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetPrioritiesTableQuery__
 *
 * To run a query within a React component, call `useGetPrioritiesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrioritiesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrioritiesTableQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPrioritiesTableQuery(baseOptions: Apollo.QueryHookOptions<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>(GetPrioritiesTableDocument, options);
      }
export function useGetPrioritiesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>(GetPrioritiesTableDocument, options);
        }
export type GetPrioritiesTableQueryHookResult = ReturnType<typeof useGetPrioritiesTableQuery>;
export type GetPrioritiesTableLazyQueryHookResult = ReturnType<typeof useGetPrioritiesTableLazyQuery>;
export type GetPrioritiesTableQueryResult = Apollo.QueryResult<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>;
export const GetPrioritiesDropdownDocument = gql`
    query getPrioritiesDropdown($recordType: PriorityRecordType!, $active: Boolean, $search: String) {
  getPriorities(recordType: $recordType, active: $active, search: $search) {
    ...PriorityCoreFields
    color
    active
  }
}
    ${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetPrioritiesDropdownQuery__
 *
 * To run a query within a React component, call `useGetPrioritiesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrioritiesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrioritiesDropdownQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPrioritiesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>(GetPrioritiesDropdownDocument, options);
      }
export function useGetPrioritiesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>(GetPrioritiesDropdownDocument, options);
        }
export type GetPrioritiesDropdownQueryHookResult = ReturnType<typeof useGetPrioritiesDropdownQuery>;
export type GetPrioritiesDropdownLazyQueryHookResult = ReturnType<typeof useGetPrioritiesDropdownLazyQuery>;
export type GetPrioritiesDropdownQueryResult = Apollo.QueryResult<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>;
export const GetFilterablePrioritiesDocument = gql`
    query getFilterablePriorities($location: FilterablePriorityLocationType!, $search: String) {
  getFilterablePriorities(location: $location, search: $search) {
    id
    title
    color
    active
    isDeleted
  }
}
    `;

/**
 * __useGetFilterablePrioritiesQuery__
 *
 * To run a query within a React component, call `useGetFilterablePrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterablePrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterablePrioritiesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterablePrioritiesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>(GetFilterablePrioritiesDocument, options);
      }
export function useGetFilterablePrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>(GetFilterablePrioritiesDocument, options);
        }
export type GetFilterablePrioritiesQueryHookResult = ReturnType<typeof useGetFilterablePrioritiesQuery>;
export type GetFilterablePrioritiesLazyQueryHookResult = ReturnType<typeof useGetFilterablePrioritiesLazyQuery>;
export type GetFilterablePrioritiesQueryResult = Apollo.QueryResult<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>;
export const GetPublicPrioritiesDocument = gql`
    query getPublicPriorities($propertyId: String!, $recordType: PriorityRecordType!, $search: String!) {
  getPublicPriorities(
    propertyId: $propertyId
    recordType: $recordType
    search: $search
  ) {
    ...PriorityCoreFields
    color
  }
}
    ${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicPrioritiesQuery__
 *
 * To run a query within a React component, call `useGetPublicPrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPrioritiesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      recordType: // value for 'recordType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicPrioritiesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicPrioritiesQuery, GetPublicPrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicPrioritiesQuery, GetPublicPrioritiesQueryVariables>(GetPublicPrioritiesDocument, options);
      }
export function useGetPublicPrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicPrioritiesQuery, GetPublicPrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicPrioritiesQuery, GetPublicPrioritiesQueryVariables>(GetPublicPrioritiesDocument, options);
        }
export type GetPublicPrioritiesQueryHookResult = ReturnType<typeof useGetPublicPrioritiesQuery>;
export type GetPublicPrioritiesLazyQueryHookResult = ReturnType<typeof useGetPublicPrioritiesLazyQuery>;
export type GetPublicPrioritiesQueryResult = Apollo.QueryResult<GetPublicPrioritiesQuery, GetPublicPrioritiesQueryVariables>;
export const GetPriorityDocument = gql`
    query getPriority($id: String!) {
  getPriority(id: $id) {
    ...PriorityFields
  }
}
    ${PriorityFieldsFragmentDoc}`;

/**
 * __useGetPriorityQuery__
 *
 * To run a query within a React component, call `useGetPriorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriorityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPriorityQuery(baseOptions: Apollo.QueryHookOptions<GetPriorityQuery, GetPriorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriorityQuery, GetPriorityQueryVariables>(GetPriorityDocument, options);
      }
export function useGetPriorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriorityQuery, GetPriorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriorityQuery, GetPriorityQueryVariables>(GetPriorityDocument, options);
        }
export type GetPriorityQueryHookResult = ReturnType<typeof useGetPriorityQuery>;
export type GetPriorityLazyQueryHookResult = ReturnType<typeof useGetPriorityLazyQuery>;
export type GetPriorityQueryResult = Apollo.QueryResult<GetPriorityQuery, GetPriorityQueryVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($data: ProductInput!) {
  createProduct(input: $data) {
    id
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($id: String!, $data: ProductInput!) {
  updateProduct(id: $id, input: $data) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const ToggleProductDocument = gql`
    mutation toggleProduct($id: String!) {
  toggleProduct(id: $id)
}
    `;
export type ToggleProductMutationFn = Apollo.MutationFunction<ToggleProductMutation, ToggleProductMutationVariables>;

/**
 * __useToggleProductMutation__
 *
 * To run a mutation, you first call `useToggleProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProductMutation, { data, loading, error }] = useToggleProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleProductMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProductMutation, ToggleProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProductMutation, ToggleProductMutationVariables>(ToggleProductDocument, options);
      }
export type ToggleProductMutationHookResult = ReturnType<typeof useToggleProductMutation>;
export type ToggleProductMutationResult = Apollo.MutationResult<ToggleProductMutation>;
export type ToggleProductMutationOptions = Apollo.BaseMutationOptions<ToggleProductMutation, ToggleProductMutationVariables>;
export const RemoveProductsDocument = gql`
    mutation removeProducts($data: DeleteRecordsInput!) {
  removeProducts(input: $data)
}
    `;
export type RemoveProductsMutationFn = Apollo.MutationFunction<RemoveProductsMutation, RemoveProductsMutationVariables>;

/**
 * __useRemoveProductsMutation__
 *
 * To run a mutation, you first call `useRemoveProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductsMutation, { data, loading, error }] = useRemoveProductsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveProductsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductsMutation, RemoveProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductsMutation, RemoveProductsMutationVariables>(RemoveProductsDocument, options);
      }
export type RemoveProductsMutationHookResult = ReturnType<typeof useRemoveProductsMutation>;
export type RemoveProductsMutationResult = Apollo.MutationResult<RemoveProductsMutation>;
export type RemoveProductsMutationOptions = Apollo.BaseMutationOptions<RemoveProductsMutation, RemoveProductsMutationVariables>;
export const GetProductsPublicDocument = gql`
    query getProductsPublic($search: String, $active: Boolean) {
  getProducts(search: $search, active: $active) {
    ...ProductCoreFields
  }
}
    ${ProductCoreFieldsFragmentDoc}`;

/**
 * __useGetProductsPublicQuery__
 *
 * To run a query within a React component, call `useGetProductsPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsPublicQuery({
 *   variables: {
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProductsPublicQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsPublicQuery, GetProductsPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsPublicQuery, GetProductsPublicQueryVariables>(GetProductsPublicDocument, options);
      }
export function useGetProductsPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsPublicQuery, GetProductsPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsPublicQuery, GetProductsPublicQueryVariables>(GetProductsPublicDocument, options);
        }
export type GetProductsPublicQueryHookResult = ReturnType<typeof useGetProductsPublicQuery>;
export type GetProductsPublicLazyQueryHookResult = ReturnType<typeof useGetProductsPublicLazyQuery>;
export type GetProductsPublicQueryResult = Apollo.QueryResult<GetProductsPublicQuery, GetProductsPublicQueryVariables>;
export const GetProductsAdminDocument = gql`
    query getProductsAdmin($search: String, $active: Boolean) {
  getProducts(search: $search, active: $active, admin: true) {
    ...ProductCoreFields
    active
    createdAt
    createdBy {
      ...UserCoreFields
    }
  }
}
    ${ProductCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetProductsAdminQuery__
 *
 * To run a query within a React component, call `useGetProductsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsAdminQuery({
 *   variables: {
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProductsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsAdminQuery, GetProductsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsAdminQuery, GetProductsAdminQueryVariables>(GetProductsAdminDocument, options);
      }
export function useGetProductsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsAdminQuery, GetProductsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsAdminQuery, GetProductsAdminQueryVariables>(GetProductsAdminDocument, options);
        }
export type GetProductsAdminQueryHookResult = ReturnType<typeof useGetProductsAdminQuery>;
export type GetProductsAdminLazyQueryHookResult = ReturnType<typeof useGetProductsAdminLazyQuery>;
export type GetProductsAdminQueryResult = Apollo.QueryResult<GetProductsAdminQuery, GetProductsAdminQueryVariables>;
export const GetProductsGeneaTableDocument = gql`
    query getProductsGeneaTable($search: String, $active: Boolean) {
  getProducts(search: $search, active: $active, admin: true) {
    ...ProductCoreFields
    geneaAccessGroup {
      ...GeneaAccessGroupFields
    }
  }
}
    ${ProductCoreFieldsFragmentDoc}
${GeneaAccessGroupFieldsFragmentDoc}`;

/**
 * __useGetProductsGeneaTableQuery__
 *
 * To run a query within a React component, call `useGetProductsGeneaTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsGeneaTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsGeneaTableQuery({
 *   variables: {
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProductsGeneaTableQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsGeneaTableQuery, GetProductsGeneaTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsGeneaTableQuery, GetProductsGeneaTableQueryVariables>(GetProductsGeneaTableDocument, options);
      }
export function useGetProductsGeneaTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsGeneaTableQuery, GetProductsGeneaTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsGeneaTableQuery, GetProductsGeneaTableQueryVariables>(GetProductsGeneaTableDocument, options);
        }
export type GetProductsGeneaTableQueryHookResult = ReturnType<typeof useGetProductsGeneaTableQuery>;
export type GetProductsGeneaTableLazyQueryHookResult = ReturnType<typeof useGetProductsGeneaTableLazyQuery>;
export type GetProductsGeneaTableQueryResult = Apollo.QueryResult<GetProductsGeneaTableQuery, GetProductsGeneaTableQueryVariables>;
export const GetProductsDropdownDocument = gql`
    query getProductsDropdown($admin: Boolean! = false, $search: String, $active: Boolean) {
  getProducts(admin: $admin, search: $search, active: $active) {
    ...ProductCoreFields
    active
  }
}
    ${ProductCoreFieldsFragmentDoc}`;

/**
 * __useGetProductsDropdownQuery__
 *
 * To run a query within a React component, call `useGetProductsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsDropdownQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetProductsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsDropdownQuery, GetProductsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsDropdownQuery, GetProductsDropdownQueryVariables>(GetProductsDropdownDocument, options);
      }
export function useGetProductsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsDropdownQuery, GetProductsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsDropdownQuery, GetProductsDropdownQueryVariables>(GetProductsDropdownDocument, options);
        }
export type GetProductsDropdownQueryHookResult = ReturnType<typeof useGetProductsDropdownQuery>;
export type GetProductsDropdownLazyQueryHookResult = ReturnType<typeof useGetProductsDropdownLazyQuery>;
export type GetProductsDropdownQueryResult = Apollo.QueryResult<GetProductsDropdownQuery, GetProductsDropdownQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: String!) {
  getProduct(id: $id) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const UpdatePropertyDocument = gql`
    mutation updateProperty($data: PropertyUpdateInput!) {
  updateProperty(input: $data) {
    ...PropertyCoreFields
  }
}
    ${PropertyCoreFieldsFragmentDoc}`;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(UpdatePropertyDocument, options);
      }
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const GetMyPropertyDataDocument = gql`
    query getMyPropertyData($propertyId: String!) {
  getMyPropertyData(propertyId: $propertyId) {
    ...UserCoreFields
    homepageId
    role {
      ...RoleCoreFields
      permissions {
        ...AllRolePermissions
      }
    }
    printer {
      ...PrinterCoreFields
    }
    property {
      ...PropertyCoreFields
      stripeApiKey
    }
  }
}
    ${UserCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}
${AllRolePermissionsFragmentDoc}
${PrinterCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetMyPropertyDataQuery__
 *
 * To run a query within a React component, call `useGetMyPropertyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPropertyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPropertyDataQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetMyPropertyDataQuery(baseOptions: Apollo.QueryHookOptions<GetMyPropertyDataQuery, GetMyPropertyDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPropertyDataQuery, GetMyPropertyDataQueryVariables>(GetMyPropertyDataDocument, options);
      }
export function useGetMyPropertyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPropertyDataQuery, GetMyPropertyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPropertyDataQuery, GetMyPropertyDataQueryVariables>(GetMyPropertyDataDocument, options);
        }
export type GetMyPropertyDataQueryHookResult = ReturnType<typeof useGetMyPropertyDataQuery>;
export type GetMyPropertyDataLazyQueryHookResult = ReturnType<typeof useGetMyPropertyDataLazyQuery>;
export type GetMyPropertyDataQueryResult = Apollo.QueryResult<GetMyPropertyDataQuery, GetMyPropertyDataQueryVariables>;
export const GetPropertyDocument = gql`
    query getProperty {
  getProperty {
    ...PropertyCoreFields
  }
}
    ${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetPropertyQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPropertyQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
      }
export function useGetPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export type GetPropertyQueryHookResult = ReturnType<typeof useGetPropertyQuery>;
export type GetPropertyLazyQueryHookResult = ReturnType<typeof useGetPropertyLazyQuery>;
export type GetPropertyQueryResult = Apollo.QueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export const CreatePropertyAddonDocument = gql`
    mutation createPropertyAddon($data: PropertyAddonsInput!) {
  createPropertyAddon(input: $data) {
    id
  }
}
    `;
export type CreatePropertyAddonMutationFn = Apollo.MutationFunction<CreatePropertyAddonMutation, CreatePropertyAddonMutationVariables>;

/**
 * __useCreatePropertyAddonMutation__
 *
 * To run a mutation, you first call `useCreatePropertyAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyAddonMutation, { data, loading, error }] = useCreatePropertyAddonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePropertyAddonMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyAddonMutation, CreatePropertyAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyAddonMutation, CreatePropertyAddonMutationVariables>(CreatePropertyAddonDocument, options);
      }
export type CreatePropertyAddonMutationHookResult = ReturnType<typeof useCreatePropertyAddonMutation>;
export type CreatePropertyAddonMutationResult = Apollo.MutationResult<CreatePropertyAddonMutation>;
export type CreatePropertyAddonMutationOptions = Apollo.BaseMutationOptions<CreatePropertyAddonMutation, CreatePropertyAddonMutationVariables>;
export const UpdatePropertyAddonDocument = gql`
    mutation updatePropertyAddon($id: String!, $data: PropertyAddonsInput!) {
  updatePropertyAddon(id: $id, input: $data) {
    ...PropertyAddonFields
  }
}
    ${PropertyAddonFieldsFragmentDoc}`;
export type UpdatePropertyAddonMutationFn = Apollo.MutationFunction<UpdatePropertyAddonMutation, UpdatePropertyAddonMutationVariables>;

/**
 * __useUpdatePropertyAddonMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyAddonMutation, { data, loading, error }] = useUpdatePropertyAddonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePropertyAddonMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyAddonMutation, UpdatePropertyAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyAddonMutation, UpdatePropertyAddonMutationVariables>(UpdatePropertyAddonDocument, options);
      }
export type UpdatePropertyAddonMutationHookResult = ReturnType<typeof useUpdatePropertyAddonMutation>;
export type UpdatePropertyAddonMutationResult = Apollo.MutationResult<UpdatePropertyAddonMutation>;
export type UpdatePropertyAddonMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyAddonMutation, UpdatePropertyAddonMutationVariables>;
export const RemovePropertyAddonsDocument = gql`
    mutation removePropertyAddons($data: DeleteRecordsInput!) {
  removePropertyAddons(input: $data)
}
    `;
export type RemovePropertyAddonsMutationFn = Apollo.MutationFunction<RemovePropertyAddonsMutation, RemovePropertyAddonsMutationVariables>;

/**
 * __useRemovePropertyAddonsMutation__
 *
 * To run a mutation, you first call `useRemovePropertyAddonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertyAddonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertyAddonsMutation, { data, loading, error }] = useRemovePropertyAddonsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePropertyAddonsMutation(baseOptions?: Apollo.MutationHookOptions<RemovePropertyAddonsMutation, RemovePropertyAddonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePropertyAddonsMutation, RemovePropertyAddonsMutationVariables>(RemovePropertyAddonsDocument, options);
      }
export type RemovePropertyAddonsMutationHookResult = ReturnType<typeof useRemovePropertyAddonsMutation>;
export type RemovePropertyAddonsMutationResult = Apollo.MutationResult<RemovePropertyAddonsMutation>;
export type RemovePropertyAddonsMutationOptions = Apollo.BaseMutationOptions<RemovePropertyAddonsMutation, RemovePropertyAddonsMutationVariables>;
export const GetPropertyAddonsDocument = gql`
    query getPropertyAddons($search: String) {
  getPropertyAddons(search: $search) {
    ...PropertyAddonFields
  }
}
    ${PropertyAddonFieldsFragmentDoc}`;

/**
 * __useGetPropertyAddonsQuery__
 *
 * To run a query within a React component, call `useGetPropertyAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyAddonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyAddonsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPropertyAddonsQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyAddonsQuery, GetPropertyAddonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyAddonsQuery, GetPropertyAddonsQueryVariables>(GetPropertyAddonsDocument, options);
      }
export function useGetPropertyAddonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyAddonsQuery, GetPropertyAddonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyAddonsQuery, GetPropertyAddonsQueryVariables>(GetPropertyAddonsDocument, options);
        }
export type GetPropertyAddonsQueryHookResult = ReturnType<typeof useGetPropertyAddonsQuery>;
export type GetPropertyAddonsLazyQueryHookResult = ReturnType<typeof useGetPropertyAddonsLazyQuery>;
export type GetPropertyAddonsQueryResult = Apollo.QueryResult<GetPropertyAddonsQuery, GetPropertyAddonsQueryVariables>;
export const GetPropertyAddonDocument = gql`
    query getPropertyAddon($id: String!) {
  getPropertyAddon(id: $id) {
    ...PropertyAddonFields
  }
}
    ${PropertyAddonFieldsFragmentDoc}`;

/**
 * __useGetPropertyAddonQuery__
 *
 * To run a query within a React component, call `useGetPropertyAddonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyAddonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyAddonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyAddonQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyAddonQuery, GetPropertyAddonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyAddonQuery, GetPropertyAddonQueryVariables>(GetPropertyAddonDocument, options);
      }
export function useGetPropertyAddonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyAddonQuery, GetPropertyAddonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyAddonQuery, GetPropertyAddonQueryVariables>(GetPropertyAddonDocument, options);
        }
export type GetPropertyAddonQueryHookResult = ReturnType<typeof useGetPropertyAddonQuery>;
export type GetPropertyAddonLazyQueryHookResult = ReturnType<typeof useGetPropertyAddonLazyQuery>;
export type GetPropertyAddonQueryResult = Apollo.QueryResult<GetPropertyAddonQuery, GetPropertyAddonQueryVariables>;
export const CreateReportDocument = gql`
    mutation createReport($data: ReportInput!) {
  createReport(input: $data) {
    id
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreatePmReportDocument = gql`
    mutation createPMReport($data: ReportPMInput!) {
  createPMReport(input: $data) {
    id
  }
}
    `;
export type CreatePmReportMutationFn = Apollo.MutationFunction<CreatePmReportMutation, CreatePmReportMutationVariables>;

/**
 * __useCreatePmReportMutation__
 *
 * To run a mutation, you first call `useCreatePmReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePmReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPmReportMutation, { data, loading, error }] = useCreatePmReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePmReportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePmReportMutation, CreatePmReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePmReportMutation, CreatePmReportMutationVariables>(CreatePmReportDocument, options);
      }
export type CreatePmReportMutationHookResult = ReturnType<typeof useCreatePmReportMutation>;
export type CreatePmReportMutationResult = Apollo.MutationResult<CreatePmReportMutation>;
export type CreatePmReportMutationOptions = Apollo.BaseMutationOptions<CreatePmReportMutation, CreatePmReportMutationVariables>;
export const RemoveReportsDocument = gql`
    mutation removeReports($data: DeleteRecordsInput!) {
  removeReports(input: $data)
}
    `;
export type RemoveReportsMutationFn = Apollo.MutationFunction<RemoveReportsMutation, RemoveReportsMutationVariables>;

/**
 * __useRemoveReportsMutation__
 *
 * To run a mutation, you first call `useRemoveReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReportsMutation, { data, loading, error }] = useRemoveReportsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveReportsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReportsMutation, RemoveReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReportsMutation, RemoveReportsMutationVariables>(RemoveReportsDocument, options);
      }
export type RemoveReportsMutationHookResult = ReturnType<typeof useRemoveReportsMutation>;
export type RemoveReportsMutationResult = Apollo.MutationResult<RemoveReportsMutation>;
export type RemoveReportsMutationOptions = Apollo.BaseMutationOptions<RemoveReportsMutation, RemoveReportsMutationVariables>;
export const GetReportsDocument = gql`
    query getReports($take: Int! = 10, $after: String, $before: String, $search: String, $type: ReportType, $status: ReportStatus) {
  getReports(
    take: $take
    after: $after
    before: $before
    search: $search
    type: $type
    status: $status
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      companies
      createdAt
      file {
        ...FileFields
      }
      from
      to
      isPrivate
      status
      type
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const UpdateReportSettingsDocument = gql`
    mutation updateReportSettings($data: ReportSettingInput!) {
  updateReportSettings(input: $data) {
    ...ReportingSettingsFields
  }
}
    ${ReportingSettingsFieldsFragmentDoc}`;
export type UpdateReportSettingsMutationFn = Apollo.MutationFunction<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>;

/**
 * __useUpdateReportSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateReportSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportSettingsMutation, { data, loading, error }] = useUpdateReportSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>(UpdateReportSettingsDocument, options);
      }
export type UpdateReportSettingsMutationHookResult = ReturnType<typeof useUpdateReportSettingsMutation>;
export type UpdateReportSettingsMutationResult = Apollo.MutationResult<UpdateReportSettingsMutation>;
export type UpdateReportSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>;
export const GetReportSettingsDocument = gql`
    query getReportSettings {
  getReportSettings {
    ...ReportingSettingsFields
  }
}
    ${ReportingSettingsFieldsFragmentDoc}`;

/**
 * __useGetReportSettingsQuery__
 *
 * To run a query within a React component, call `useGetReportSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportSettingsQuery, GetReportSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportSettingsQuery, GetReportSettingsQueryVariables>(GetReportSettingsDocument, options);
      }
export function useGetReportSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportSettingsQuery, GetReportSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportSettingsQuery, GetReportSettingsQueryVariables>(GetReportSettingsDocument, options);
        }
export type GetReportSettingsQueryHookResult = ReturnType<typeof useGetReportSettingsQuery>;
export type GetReportSettingsLazyQueryHookResult = ReturnType<typeof useGetReportSettingsLazyQuery>;
export type GetReportSettingsQueryResult = Apollo.QueryResult<GetReportSettingsQuery, GetReportSettingsQueryVariables>;
export const AddRepositoryFolderDocument = gql`
    mutation addRepositoryFolder($destinationId: String, $name: String!, $isPrivate: Boolean!) {
  addRepositoryFolder(
    destinationId: $destinationId
    name: $name
    isPrivate: $isPrivate
  )
}
    `;
export type AddRepositoryFolderMutationFn = Apollo.MutationFunction<AddRepositoryFolderMutation, AddRepositoryFolderMutationVariables>;

/**
 * __useAddRepositoryFolderMutation__
 *
 * To run a mutation, you first call `useAddRepositoryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRepositoryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRepositoryFolderMutation, { data, loading, error }] = useAddRepositoryFolderMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      name: // value for 'name'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useAddRepositoryFolderMutation(baseOptions?: Apollo.MutationHookOptions<AddRepositoryFolderMutation, AddRepositoryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRepositoryFolderMutation, AddRepositoryFolderMutationVariables>(AddRepositoryFolderDocument, options);
      }
export type AddRepositoryFolderMutationHookResult = ReturnType<typeof useAddRepositoryFolderMutation>;
export type AddRepositoryFolderMutationResult = Apollo.MutationResult<AddRepositoryFolderMutation>;
export type AddRepositoryFolderMutationOptions = Apollo.BaseMutationOptions<AddRepositoryFolderMutation, AddRepositoryFolderMutationVariables>;
export const UpdateRepositoryFolderDocument = gql`
    mutation updateRepositoryFolder($folderId: String!, $name: String!, $isPrivate: Boolean!) {
  updateRepositoryFolder(folderId: $folderId, name: $name, isPrivate: $isPrivate)
}
    `;
export type UpdateRepositoryFolderMutationFn = Apollo.MutationFunction<UpdateRepositoryFolderMutation, UpdateRepositoryFolderMutationVariables>;

/**
 * __useUpdateRepositoryFolderMutation__
 *
 * To run a mutation, you first call `useUpdateRepositoryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRepositoryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRepositoryFolderMutation, { data, loading, error }] = useUpdateRepositoryFolderMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      name: // value for 'name'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useUpdateRepositoryFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRepositoryFolderMutation, UpdateRepositoryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRepositoryFolderMutation, UpdateRepositoryFolderMutationVariables>(UpdateRepositoryFolderDocument, options);
      }
export type UpdateRepositoryFolderMutationHookResult = ReturnType<typeof useUpdateRepositoryFolderMutation>;
export type UpdateRepositoryFolderMutationResult = Apollo.MutationResult<UpdateRepositoryFolderMutation>;
export type UpdateRepositoryFolderMutationOptions = Apollo.BaseMutationOptions<UpdateRepositoryFolderMutation, UpdateRepositoryFolderMutationVariables>;
export const AddRepositoryFilesDocument = gql`
    mutation addRepositoryFiles($destinationId: String, $files: [FileObjectInput!]!) {
  addRepositoryFiles(destinationId: $destinationId, files: $files)
}
    `;
export type AddRepositoryFilesMutationFn = Apollo.MutationFunction<AddRepositoryFilesMutation, AddRepositoryFilesMutationVariables>;

/**
 * __useAddRepositoryFilesMutation__
 *
 * To run a mutation, you first call `useAddRepositoryFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRepositoryFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRepositoryFilesMutation, { data, loading, error }] = useAddRepositoryFilesMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddRepositoryFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddRepositoryFilesMutation, AddRepositoryFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRepositoryFilesMutation, AddRepositoryFilesMutationVariables>(AddRepositoryFilesDocument, options);
      }
export type AddRepositoryFilesMutationHookResult = ReturnType<typeof useAddRepositoryFilesMutation>;
export type AddRepositoryFilesMutationResult = Apollo.MutationResult<AddRepositoryFilesMutation>;
export type AddRepositoryFilesMutationOptions = Apollo.BaseMutationOptions<AddRepositoryFilesMutation, AddRepositoryFilesMutationVariables>;
export const MoveRepositoryFilesDocument = gql`
    mutation moveRepositoryFiles($sourceId: String, $destinationId: String, $fileIds: [String!]!) {
  moveRepositoryFiles(
    sourceId: $sourceId
    destinationId: $destinationId
    fileIds: $fileIds
  )
}
    `;
export type MoveRepositoryFilesMutationFn = Apollo.MutationFunction<MoveRepositoryFilesMutation, MoveRepositoryFilesMutationVariables>;

/**
 * __useMoveRepositoryFilesMutation__
 *
 * To run a mutation, you first call `useMoveRepositoryFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRepositoryFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRepositoryFilesMutation, { data, loading, error }] = useMoveRepositoryFilesMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      destinationId: // value for 'destinationId'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useMoveRepositoryFilesMutation(baseOptions?: Apollo.MutationHookOptions<MoveRepositoryFilesMutation, MoveRepositoryFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveRepositoryFilesMutation, MoveRepositoryFilesMutationVariables>(MoveRepositoryFilesDocument, options);
      }
export type MoveRepositoryFilesMutationHookResult = ReturnType<typeof useMoveRepositoryFilesMutation>;
export type MoveRepositoryFilesMutationResult = Apollo.MutationResult<MoveRepositoryFilesMutation>;
export type MoveRepositoryFilesMutationOptions = Apollo.BaseMutationOptions<MoveRepositoryFilesMutation, MoveRepositoryFilesMutationVariables>;
export const DownloadRepositoryFilesDocument = gql`
    mutation downloadRepositoryFiles($fileIds: [String!]!) {
  downloadRepositoryFiles(fileIds: $fileIds)
}
    `;
export type DownloadRepositoryFilesMutationFn = Apollo.MutationFunction<DownloadRepositoryFilesMutation, DownloadRepositoryFilesMutationVariables>;

/**
 * __useDownloadRepositoryFilesMutation__
 *
 * To run a mutation, you first call `useDownloadRepositoryFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadRepositoryFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadRepositoryFilesMutation, { data, loading, error }] = useDownloadRepositoryFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDownloadRepositoryFilesMutation(baseOptions?: Apollo.MutationHookOptions<DownloadRepositoryFilesMutation, DownloadRepositoryFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadRepositoryFilesMutation, DownloadRepositoryFilesMutationVariables>(DownloadRepositoryFilesDocument, options);
      }
export type DownloadRepositoryFilesMutationHookResult = ReturnType<typeof useDownloadRepositoryFilesMutation>;
export type DownloadRepositoryFilesMutationResult = Apollo.MutationResult<DownloadRepositoryFilesMutation>;
export type DownloadRepositoryFilesMutationOptions = Apollo.BaseMutationOptions<DownloadRepositoryFilesMutation, DownloadRepositoryFilesMutationVariables>;
export const DeleteRepositoryFilesDocument = gql`
    mutation deleteRepositoryFiles($ids: [String!]!) {
  deleteRepositoryFiles(ids: $ids)
}
    `;
export type DeleteRepositoryFilesMutationFn = Apollo.MutationFunction<DeleteRepositoryFilesMutation, DeleteRepositoryFilesMutationVariables>;

/**
 * __useDeleteRepositoryFilesMutation__
 *
 * To run a mutation, you first call `useDeleteRepositoryFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRepositoryFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRepositoryFilesMutation, { data, loading, error }] = useDeleteRepositoryFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRepositoryFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRepositoryFilesMutation, DeleteRepositoryFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRepositoryFilesMutation, DeleteRepositoryFilesMutationVariables>(DeleteRepositoryFilesDocument, options);
      }
export type DeleteRepositoryFilesMutationHookResult = ReturnType<typeof useDeleteRepositoryFilesMutation>;
export type DeleteRepositoryFilesMutationResult = Apollo.MutationResult<DeleteRepositoryFilesMutation>;
export type DeleteRepositoryFilesMutationOptions = Apollo.BaseMutationOptions<DeleteRepositoryFilesMutation, DeleteRepositoryFilesMutationVariables>;
export const GetRepositoryFilesDocument = gql`
    query getRepositoryFiles($folderId: String, $search: String) {
  getRepositoryFiles(folderId: $folderId, search: $search) {
    breadcrumbs {
      id
      name
    }
    files {
      ...RepositoryFileFields
    }
  }
}
    ${RepositoryFileFieldsFragmentDoc}`;

/**
 * __useGetRepositoryFilesQuery__
 *
 * To run a query within a React component, call `useGetRepositoryFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepositoryFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepositoryFilesQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRepositoryFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetRepositoryFilesQuery, GetRepositoryFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepositoryFilesQuery, GetRepositoryFilesQueryVariables>(GetRepositoryFilesDocument, options);
      }
export function useGetRepositoryFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRepositoryFilesQuery, GetRepositoryFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepositoryFilesQuery, GetRepositoryFilesQueryVariables>(GetRepositoryFilesDocument, options);
        }
export type GetRepositoryFilesQueryHookResult = ReturnType<typeof useGetRepositoryFilesQuery>;
export type GetRepositoryFilesLazyQueryHookResult = ReturnType<typeof useGetRepositoryFilesLazyQuery>;
export type GetRepositoryFilesQueryResult = Apollo.QueryResult<GetRepositoryFilesQuery, GetRepositoryFilesQueryVariables>;
export const GetRolesDropdownDocument = gql`
    query getRolesDropdown($take: Int! = 10, $after: String, $before: String, $search: String, $onlyAssignable: Boolean) {
  getRoles(
    take: $take
    after: $after
    before: $before
    search: $search
    onlyAssignable: $onlyAssignable
  ) @connection(key: "getRolesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...RoleCoreFields
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}`;

/**
 * __useGetRolesDropdownQuery__
 *
 * To run a query within a React component, call `useGetRolesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      onlyAssignable: // value for 'onlyAssignable'
 *   },
 * });
 */
export function useGetRolesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>(GetRolesDropdownDocument, options);
      }
export function useGetRolesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>(GetRolesDropdownDocument, options);
        }
export type GetRolesDropdownQueryHookResult = ReturnType<typeof useGetRolesDropdownQuery>;
export type GetRolesDropdownLazyQueryHookResult = ReturnType<typeof useGetRolesDropdownLazyQuery>;
export type GetRolesDropdownQueryResult = Apollo.QueryResult<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>;
export const CreateRoomReservationDocument = gql`
    mutation createRoomReservation($data: RoomReservationInput!) {
  createRoomReservation(input: $data) {
    id
  }
}
    `;
export type CreateRoomReservationMutationFn = Apollo.MutationFunction<CreateRoomReservationMutation, CreateRoomReservationMutationVariables>;

/**
 * __useCreateRoomReservationMutation__
 *
 * To run a mutation, you first call `useCreateRoomReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomReservationMutation, { data, loading, error }] = useCreateRoomReservationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomReservationMutation, CreateRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomReservationMutation, CreateRoomReservationMutationVariables>(CreateRoomReservationDocument, options);
      }
export type CreateRoomReservationMutationHookResult = ReturnType<typeof useCreateRoomReservationMutation>;
export type CreateRoomReservationMutationResult = Apollo.MutationResult<CreateRoomReservationMutation>;
export type CreateRoomReservationMutationOptions = Apollo.BaseMutationOptions<CreateRoomReservationMutation, CreateRoomReservationMutationVariables>;
export const UpdateRoomReservationDocument = gql`
    mutation updateRoomReservation($id: String!, $data: RoomReservationUpdateInput!) {
  updateRoomReservation(reservationId: $id, input: $data) {
    ...RoomReservationFields
  }
}
    ${RoomReservationFieldsFragmentDoc}`;
export type UpdateRoomReservationMutationFn = Apollo.MutationFunction<UpdateRoomReservationMutation, UpdateRoomReservationMutationVariables>;

/**
 * __useUpdateRoomReservationMutation__
 *
 * To run a mutation, you first call `useUpdateRoomReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomReservationMutation, { data, loading, error }] = useUpdateRoomReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomReservationMutation, UpdateRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomReservationMutation, UpdateRoomReservationMutationVariables>(UpdateRoomReservationDocument, options);
      }
export type UpdateRoomReservationMutationHookResult = ReturnType<typeof useUpdateRoomReservationMutation>;
export type UpdateRoomReservationMutationResult = Apollo.MutationResult<UpdateRoomReservationMutation>;
export type UpdateRoomReservationMutationOptions = Apollo.BaseMutationOptions<UpdateRoomReservationMutation, UpdateRoomReservationMutationVariables>;
export const ApproveRoomReservationDocument = gql`
    mutation approveRoomReservation($id: String!) {
  approveRoomReservation(reservationId: $id)
}
    `;
export type ApproveRoomReservationMutationFn = Apollo.MutationFunction<ApproveRoomReservationMutation, ApproveRoomReservationMutationVariables>;

/**
 * __useApproveRoomReservationMutation__
 *
 * To run a mutation, you first call `useApproveRoomReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRoomReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRoomReservationMutation, { data, loading, error }] = useApproveRoomReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRoomReservationMutation, ApproveRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRoomReservationMutation, ApproveRoomReservationMutationVariables>(ApproveRoomReservationDocument, options);
      }
export type ApproveRoomReservationMutationHookResult = ReturnType<typeof useApproveRoomReservationMutation>;
export type ApproveRoomReservationMutationResult = Apollo.MutationResult<ApproveRoomReservationMutation>;
export type ApproveRoomReservationMutationOptions = Apollo.BaseMutationOptions<ApproveRoomReservationMutation, ApproveRoomReservationMutationVariables>;
export const DenyRoomReservationDocument = gql`
    mutation denyRoomReservation($id: String!) {
  denyRoomReservation(reservationId: $id)
}
    `;
export type DenyRoomReservationMutationFn = Apollo.MutationFunction<DenyRoomReservationMutation, DenyRoomReservationMutationVariables>;

/**
 * __useDenyRoomReservationMutation__
 *
 * To run a mutation, you first call `useDenyRoomReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyRoomReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyRoomReservationMutation, { data, loading, error }] = useDenyRoomReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDenyRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<DenyRoomReservationMutation, DenyRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyRoomReservationMutation, DenyRoomReservationMutationVariables>(DenyRoomReservationDocument, options);
      }
export type DenyRoomReservationMutationHookResult = ReturnType<typeof useDenyRoomReservationMutation>;
export type DenyRoomReservationMutationResult = Apollo.MutationResult<DenyRoomReservationMutation>;
export type DenyRoomReservationMutationOptions = Apollo.BaseMutationOptions<DenyRoomReservationMutation, DenyRoomReservationMutationVariables>;
export const CancelRoomReservationDocument = gql`
    mutation cancelRoomReservation($id: String!) {
  cancelRoomReservation(reservationId: $id)
}
    `;
export type CancelRoomReservationMutationFn = Apollo.MutationFunction<CancelRoomReservationMutation, CancelRoomReservationMutationVariables>;

/**
 * __useCancelRoomReservationMutation__
 *
 * To run a mutation, you first call `useCancelRoomReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRoomReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRoomReservationMutation, { data, loading, error }] = useCancelRoomReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelRoomReservationMutation, CancelRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRoomReservationMutation, CancelRoomReservationMutationVariables>(CancelRoomReservationDocument, options);
      }
export type CancelRoomReservationMutationHookResult = ReturnType<typeof useCancelRoomReservationMutation>;
export type CancelRoomReservationMutationResult = Apollo.MutationResult<CancelRoomReservationMutation>;
export type CancelRoomReservationMutationOptions = Apollo.BaseMutationOptions<CancelRoomReservationMutation, CancelRoomReservationMutationVariables>;
export const DeleteRoomReservationAttachmentsDocument = gql`
    mutation deleteRoomReservationAttachments($attachmentId: String!, $id: String!) {
  deleteRoomReservationAttachment(attachmentId: $attachmentId, reservationId: $id)
}
    `;
export type DeleteRoomReservationAttachmentsMutationFn = Apollo.MutationFunction<DeleteRoomReservationAttachmentsMutation, DeleteRoomReservationAttachmentsMutationVariables>;

/**
 * __useDeleteRoomReservationAttachmentsMutation__
 *
 * To run a mutation, you first call `useDeleteRoomReservationAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomReservationAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomReservationAttachmentsMutation, { data, loading, error }] = useDeleteRoomReservationAttachmentsMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomReservationAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomReservationAttachmentsMutation, DeleteRoomReservationAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomReservationAttachmentsMutation, DeleteRoomReservationAttachmentsMutationVariables>(DeleteRoomReservationAttachmentsDocument, options);
      }
export type DeleteRoomReservationAttachmentsMutationHookResult = ReturnType<typeof useDeleteRoomReservationAttachmentsMutation>;
export type DeleteRoomReservationAttachmentsMutationResult = Apollo.MutationResult<DeleteRoomReservationAttachmentsMutation>;
export type DeleteRoomReservationAttachmentsMutationOptions = Apollo.BaseMutationOptions<DeleteRoomReservationAttachmentsMutation, DeleteRoomReservationAttachmentsMutationVariables>;
export const GenerateRoomReservationWoDocument = gql`
    mutation generateRoomReservationWO($data: RoomReservationGenerateWOInput!) {
  generateRoomReservationWO(input: $data) {
    id
    workOrder {
      id
      index
    }
  }
}
    `;
export type GenerateRoomReservationWoMutationFn = Apollo.MutationFunction<GenerateRoomReservationWoMutation, GenerateRoomReservationWoMutationVariables>;

/**
 * __useGenerateRoomReservationWoMutation__
 *
 * To run a mutation, you first call `useGenerateRoomReservationWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRoomReservationWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRoomReservationWoMutation, { data, loading, error }] = useGenerateRoomReservationWoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateRoomReservationWoMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRoomReservationWoMutation, GenerateRoomReservationWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRoomReservationWoMutation, GenerateRoomReservationWoMutationVariables>(GenerateRoomReservationWoDocument, options);
      }
export type GenerateRoomReservationWoMutationHookResult = ReturnType<typeof useGenerateRoomReservationWoMutation>;
export type GenerateRoomReservationWoMutationResult = Apollo.MutationResult<GenerateRoomReservationWoMutation>;
export type GenerateRoomReservationWoMutationOptions = Apollo.BaseMutationOptions<GenerateRoomReservationWoMutation, GenerateRoomReservationWoMutationVariables>;
export const SyncRoomReservationWoDocument = gql`
    mutation syncRoomReservationWO($id: String!, $index: Float!) {
  syncRoomReservationWO(reservationId: $id, index: $index) {
    id
    workOrder {
      id
      index
    }
  }
}
    `;
export type SyncRoomReservationWoMutationFn = Apollo.MutationFunction<SyncRoomReservationWoMutation, SyncRoomReservationWoMutationVariables>;

/**
 * __useSyncRoomReservationWoMutation__
 *
 * To run a mutation, you first call `useSyncRoomReservationWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRoomReservationWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRoomReservationWoMutation, { data, loading, error }] = useSyncRoomReservationWoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useSyncRoomReservationWoMutation(baseOptions?: Apollo.MutationHookOptions<SyncRoomReservationWoMutation, SyncRoomReservationWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncRoomReservationWoMutation, SyncRoomReservationWoMutationVariables>(SyncRoomReservationWoDocument, options);
      }
export type SyncRoomReservationWoMutationHookResult = ReturnType<typeof useSyncRoomReservationWoMutation>;
export type SyncRoomReservationWoMutationResult = Apollo.MutationResult<SyncRoomReservationWoMutation>;
export type SyncRoomReservationWoMutationOptions = Apollo.BaseMutationOptions<SyncRoomReservationWoMutation, SyncRoomReservationWoMutationVariables>;
export const UnsyncRoomReservationWoDocument = gql`
    mutation unsyncRoomReservationWO($id: String!) {
  unSyncRoomReservationWO(id: $id) {
    id
    workOrder {
      id
      index
    }
  }
}
    `;
export type UnsyncRoomReservationWoMutationFn = Apollo.MutationFunction<UnsyncRoomReservationWoMutation, UnsyncRoomReservationWoMutationVariables>;

/**
 * __useUnsyncRoomReservationWoMutation__
 *
 * To run a mutation, you first call `useUnsyncRoomReservationWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsyncRoomReservationWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsyncRoomReservationWoMutation, { data, loading, error }] = useUnsyncRoomReservationWoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsyncRoomReservationWoMutation(baseOptions?: Apollo.MutationHookOptions<UnsyncRoomReservationWoMutation, UnsyncRoomReservationWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsyncRoomReservationWoMutation, UnsyncRoomReservationWoMutationVariables>(UnsyncRoomReservationWoDocument, options);
      }
export type UnsyncRoomReservationWoMutationHookResult = ReturnType<typeof useUnsyncRoomReservationWoMutation>;
export type UnsyncRoomReservationWoMutationResult = Apollo.MutationResult<UnsyncRoomReservationWoMutation>;
export type UnsyncRoomReservationWoMutationOptions = Apollo.BaseMutationOptions<UnsyncRoomReservationWoMutation, UnsyncRoomReservationWoMutationVariables>;
export const UpdateRoomReservationCustomFieldDocument = gql`
    mutation updateRoomReservationCustomField($id: String!, $value: CustomFieldScalar) {
  updateRoomReservationCustomField(id: $id, value: $value) {
    id
    value
    customField {
      ...CustomFieldFields
    }
  }
}
    ${CustomFieldFieldsFragmentDoc}`;
export type UpdateRoomReservationCustomFieldMutationFn = Apollo.MutationFunction<UpdateRoomReservationCustomFieldMutation, UpdateRoomReservationCustomFieldMutationVariables>;

/**
 * __useUpdateRoomReservationCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateRoomReservationCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomReservationCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomReservationCustomFieldMutation, { data, loading, error }] = useUpdateRoomReservationCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateRoomReservationCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomReservationCustomFieldMutation, UpdateRoomReservationCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomReservationCustomFieldMutation, UpdateRoomReservationCustomFieldMutationVariables>(UpdateRoomReservationCustomFieldDocument, options);
      }
export type UpdateRoomReservationCustomFieldMutationHookResult = ReturnType<typeof useUpdateRoomReservationCustomFieldMutation>;
export type UpdateRoomReservationCustomFieldMutationResult = Apollo.MutationResult<UpdateRoomReservationCustomFieldMutation>;
export type UpdateRoomReservationCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateRoomReservationCustomFieldMutation, UpdateRoomReservationCustomFieldMutationVariables>;
export const GetRoomReservationsDocument = gql`
    query getRoomReservations($take: Int! = 10, $after: String, $before: String, $search: String, $from: DateTime, $to: DateTime, $status: RoomReservationStatusEnum) {
  getRoomReservations(
    take: $take
    after: $after
    before: $before
    search: $search
    status: $status
    from: $from
    to: $to
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      from
      to
      date
      status
      total
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      room {
        ...RoomCoreFields
        cancellationPeriod
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${RoomCoreFieldsFragmentDoc}`;

/**
 * __useGetRoomReservationsQuery__
 *
 * To run a query within a React component, call `useGetRoomReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomReservationsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRoomReservationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRoomReservationsQuery, GetRoomReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomReservationsQuery, GetRoomReservationsQueryVariables>(GetRoomReservationsDocument, options);
      }
export function useGetRoomReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomReservationsQuery, GetRoomReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomReservationsQuery, GetRoomReservationsQueryVariables>(GetRoomReservationsDocument, options);
        }
export type GetRoomReservationsQueryHookResult = ReturnType<typeof useGetRoomReservationsQuery>;
export type GetRoomReservationsLazyQueryHookResult = ReturnType<typeof useGetRoomReservationsLazyQuery>;
export type GetRoomReservationsQueryResult = Apollo.QueryResult<GetRoomReservationsQuery, GetRoomReservationsQueryVariables>;
export const GetRoomReservationsCalendarDocument = gql`
    query getRoomReservationsCalendar($search: String, $from: DateTime!, $to: DateTime!, $status: RoomReservationStatusEnum) {
  getRoomReservationsCalendar(
    search: $search
    status: $status
    from: $from
    to: $to
  ) {
    id
    from
    to
    date
    status
    requestedFor {
      ...UserCoreFields
    }
    room {
      ...RoomCoreFields
      color
    }
  }
}
    ${UserCoreFieldsFragmentDoc}
${RoomCoreFieldsFragmentDoc}`;

/**
 * __useGetRoomReservationsCalendarQuery__
 *
 * To run a query within a React component, call `useGetRoomReservationsCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomReservationsCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomReservationsCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRoomReservationsCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetRoomReservationsCalendarQuery, GetRoomReservationsCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomReservationsCalendarQuery, GetRoomReservationsCalendarQueryVariables>(GetRoomReservationsCalendarDocument, options);
      }
export function useGetRoomReservationsCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomReservationsCalendarQuery, GetRoomReservationsCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomReservationsCalendarQuery, GetRoomReservationsCalendarQueryVariables>(GetRoomReservationsCalendarDocument, options);
        }
export type GetRoomReservationsCalendarQueryHookResult = ReturnType<typeof useGetRoomReservationsCalendarQuery>;
export type GetRoomReservationsCalendarLazyQueryHookResult = ReturnType<typeof useGetRoomReservationsCalendarLazyQuery>;
export type GetRoomReservationsCalendarQueryResult = Apollo.QueryResult<GetRoomReservationsCalendarQuery, GetRoomReservationsCalendarQueryVariables>;
export const GetPublicRoomReservationsCalendarDocument = gql`
    query getPublicRoomReservationsCalendar($search: String, $from: DateTime!, $to: DateTime!) {
  getPublicRoomReservationsCalendar(search: $search, from: $from, to: $to) {
    id
    from
    to
    date
    room {
      ...RoomCoreFields
      color
      size
    }
  }
}
    ${RoomCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicRoomReservationsCalendarQuery__
 *
 * To run a query within a React component, call `useGetPublicRoomReservationsCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicRoomReservationsCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicRoomReservationsCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetPublicRoomReservationsCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetPublicRoomReservationsCalendarQuery, GetPublicRoomReservationsCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicRoomReservationsCalendarQuery, GetPublicRoomReservationsCalendarQueryVariables>(GetPublicRoomReservationsCalendarDocument, options);
      }
export function useGetPublicRoomReservationsCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicRoomReservationsCalendarQuery, GetPublicRoomReservationsCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicRoomReservationsCalendarQuery, GetPublicRoomReservationsCalendarQueryVariables>(GetPublicRoomReservationsCalendarDocument, options);
        }
export type GetPublicRoomReservationsCalendarQueryHookResult = ReturnType<typeof useGetPublicRoomReservationsCalendarQuery>;
export type GetPublicRoomReservationsCalendarLazyQueryHookResult = ReturnType<typeof useGetPublicRoomReservationsCalendarLazyQuery>;
export type GetPublicRoomReservationsCalendarQueryResult = Apollo.QueryResult<GetPublicRoomReservationsCalendarQuery, GetPublicRoomReservationsCalendarQueryVariables>;
export const GetRoomReservationDocument = gql`
    query getRoomReservation($id: String!) {
  getRoomReservation(reservationId: $id) {
    ...RoomReservationFields
  }
}
    ${RoomReservationFieldsFragmentDoc}`;

/**
 * __useGetRoomReservationQuery__
 *
 * To run a query within a React component, call `useGetRoomReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomReservationQuery(baseOptions: Apollo.QueryHookOptions<GetRoomReservationQuery, GetRoomReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomReservationQuery, GetRoomReservationQueryVariables>(GetRoomReservationDocument, options);
      }
export function useGetRoomReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomReservationQuery, GetRoomReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomReservationQuery, GetRoomReservationQueryVariables>(GetRoomReservationDocument, options);
        }
export type GetRoomReservationQueryHookResult = ReturnType<typeof useGetRoomReservationQuery>;
export type GetRoomReservationLazyQueryHookResult = ReturnType<typeof useGetRoomReservationLazyQuery>;
export type GetRoomReservationQueryResult = Apollo.QueryResult<GetRoomReservationQuery, GetRoomReservationQueryVariables>;
export const GetRoomReservationChargesDocument = gql`
    query getRoomReservationCharges($reservationId: String!, $search: String) {
  getRoomReservationCharges(reservationId: $reservationId, search: $search) {
    id
    type
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetRoomReservationChargesQuery__
 *
 * To run a query within a React component, call `useGetRoomReservationChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomReservationChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomReservationChargesQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRoomReservationChargesQuery(baseOptions: Apollo.QueryHookOptions<GetRoomReservationChargesQuery, GetRoomReservationChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomReservationChargesQuery, GetRoomReservationChargesQueryVariables>(GetRoomReservationChargesDocument, options);
      }
export function useGetRoomReservationChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomReservationChargesQuery, GetRoomReservationChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomReservationChargesQuery, GetRoomReservationChargesQueryVariables>(GetRoomReservationChargesDocument, options);
        }
export type GetRoomReservationChargesQueryHookResult = ReturnType<typeof useGetRoomReservationChargesQuery>;
export type GetRoomReservationChargesLazyQueryHookResult = ReturnType<typeof useGetRoomReservationChargesLazyQuery>;
export type GetRoomReservationChargesQueryResult = Apollo.QueryResult<GetRoomReservationChargesQuery, GetRoomReservationChargesQueryVariables>;
export const CreateRoomDocument = gql`
    mutation createRoom($data: RoomInput!) {
  createRoom(input: $data) {
    id
  }
}
    `;
export type CreateRoomMutationFn = Apollo.MutationFunction<CreateRoomMutation, CreateRoomMutationVariables>;

/**
 * __useCreateRoomMutation__
 *
 * To run a mutation, you first call `useCreateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomMutation, { data, loading, error }] = useCreateRoomMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRoomMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomMutation, CreateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomMutation, CreateRoomMutationVariables>(CreateRoomDocument, options);
      }
export type CreateRoomMutationHookResult = ReturnType<typeof useCreateRoomMutation>;
export type CreateRoomMutationResult = Apollo.MutationResult<CreateRoomMutation>;
export type CreateRoomMutationOptions = Apollo.BaseMutationOptions<CreateRoomMutation, CreateRoomMutationVariables>;
export const UpdateRoomDocument = gql`
    mutation updateRoom($id: String!, $data: RoomInput!) {
  updateRoom(roomId: $id, input: $data) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const ToggleRoomDocument = gql`
    mutation toggleRoom($id: String!) {
  toggleRoom(roomId: $id)
}
    `;
export type ToggleRoomMutationFn = Apollo.MutationFunction<ToggleRoomMutation, ToggleRoomMutationVariables>;

/**
 * __useToggleRoomMutation__
 *
 * To run a mutation, you first call `useToggleRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleRoomMutation, { data, loading, error }] = useToggleRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleRoomMutation(baseOptions?: Apollo.MutationHookOptions<ToggleRoomMutation, ToggleRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleRoomMutation, ToggleRoomMutationVariables>(ToggleRoomDocument, options);
      }
export type ToggleRoomMutationHookResult = ReturnType<typeof useToggleRoomMutation>;
export type ToggleRoomMutationResult = Apollo.MutationResult<ToggleRoomMutation>;
export type ToggleRoomMutationOptions = Apollo.BaseMutationOptions<ToggleRoomMutation, ToggleRoomMutationVariables>;
export const RemoveRoomsDocument = gql`
    mutation removeRooms($data: DeleteRecordsInput!) {
  removeRooms(input: $data)
}
    `;
export type RemoveRoomsMutationFn = Apollo.MutationFunction<RemoveRoomsMutation, RemoveRoomsMutationVariables>;

/**
 * __useRemoveRoomsMutation__
 *
 * To run a mutation, you first call `useRemoveRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoomsMutation, { data, loading, error }] = useRemoveRoomsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveRoomsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoomsMutation, RemoveRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoomsMutation, RemoveRoomsMutationVariables>(RemoveRoomsDocument, options);
      }
export type RemoveRoomsMutationHookResult = ReturnType<typeof useRemoveRoomsMutation>;
export type RemoveRoomsMutationResult = Apollo.MutationResult<RemoveRoomsMutation>;
export type RemoveRoomsMutationOptions = Apollo.BaseMutationOptions<RemoveRoomsMutation, RemoveRoomsMutationVariables>;
export const ReorderRoomsDocument = gql`
    mutation reorderRooms($id: String!, $secondId: String!) {
  reorderRooms(id: $id, secondId: $secondId)
}
    `;
export type ReorderRoomsMutationFn = Apollo.MutationFunction<ReorderRoomsMutation, ReorderRoomsMutationVariables>;

/**
 * __useReorderRoomsMutation__
 *
 * To run a mutation, you first call `useReorderRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderRoomsMutation, { data, loading, error }] = useReorderRoomsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderRoomsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderRoomsMutation, ReorderRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderRoomsMutation, ReorderRoomsMutationVariables>(ReorderRoomsDocument, options);
      }
export type ReorderRoomsMutationHookResult = ReturnType<typeof useReorderRoomsMutation>;
export type ReorderRoomsMutationResult = Apollo.MutationResult<ReorderRoomsMutation>;
export type ReorderRoomsMutationOptions = Apollo.BaseMutationOptions<ReorderRoomsMutation, ReorderRoomsMutationVariables>;
export const GetAllRoomsSelectorDocument = gql`
    query getAllRoomsSelector($active: Boolean, $date: String!) {
  getRooms(active: $active, date: $date) {
    ...RoomCoreFields
    active
    subtitle
    size
    image {
      ...FileFields
    }
    color
    amenities {
      icon
      name
    }
    minBookingTime
    maxBookingTime
    from
    to
    limitAdvanceDays
    reservations {
      date
      from
      to
    }
  }
}
    ${RoomCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetAllRoomsSelectorQuery__
 *
 * To run a query within a React component, call `useGetAllRoomsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRoomsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRoomsSelectorQuery({
 *   variables: {
 *      active: // value for 'active'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetAllRoomsSelectorQuery(baseOptions: Apollo.QueryHookOptions<GetAllRoomsSelectorQuery, GetAllRoomsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRoomsSelectorQuery, GetAllRoomsSelectorQueryVariables>(GetAllRoomsSelectorDocument, options);
      }
export function useGetAllRoomsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRoomsSelectorQuery, GetAllRoomsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRoomsSelectorQuery, GetAllRoomsSelectorQueryVariables>(GetAllRoomsSelectorDocument, options);
        }
export type GetAllRoomsSelectorQueryHookResult = ReturnType<typeof useGetAllRoomsSelectorQuery>;
export type GetAllRoomsSelectorLazyQueryHookResult = ReturnType<typeof useGetAllRoomsSelectorLazyQuery>;
export type GetAllRoomsSelectorQueryResult = Apollo.QueryResult<GetAllRoomsSelectorQuery, GetAllRoomsSelectorQueryVariables>;
export const GetAllRoomsAdminDocument = gql`
    query getAllRoomsAdmin($active: Boolean, $search: String) {
  getRooms(active: $active, search: $search) {
    ...RoomCoreFields
    index
    active
    subtitle
    from
    to
  }
}
    ${RoomCoreFieldsFragmentDoc}`;

/**
 * __useGetAllRoomsAdminQuery__
 *
 * To run a query within a React component, call `useGetAllRoomsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRoomsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRoomsAdminQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllRoomsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRoomsAdminQuery, GetAllRoomsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRoomsAdminQuery, GetAllRoomsAdminQueryVariables>(GetAllRoomsAdminDocument, options);
      }
export function useGetAllRoomsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRoomsAdminQuery, GetAllRoomsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRoomsAdminQuery, GetAllRoomsAdminQueryVariables>(GetAllRoomsAdminDocument, options);
        }
export type GetAllRoomsAdminQueryHookResult = ReturnType<typeof useGetAllRoomsAdminQuery>;
export type GetAllRoomsAdminLazyQueryHookResult = ReturnType<typeof useGetAllRoomsAdminLazyQuery>;
export type GetAllRoomsAdminQueryResult = Apollo.QueryResult<GetAllRoomsAdminQuery, GetAllRoomsAdminQueryVariables>;
export const GetAllRoomsDropdownDocument = gql`
    query getAllRoomsDropdown($active: Boolean) {
  getRooms(active: $active) {
    ...RoomCoreFields
    active
  }
}
    ${RoomCoreFieldsFragmentDoc}`;

/**
 * __useGetAllRoomsDropdownQuery__
 *
 * To run a query within a React component, call `useGetAllRoomsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRoomsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRoomsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetAllRoomsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRoomsDropdownQuery, GetAllRoomsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRoomsDropdownQuery, GetAllRoomsDropdownQueryVariables>(GetAllRoomsDropdownDocument, options);
      }
export function useGetAllRoomsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRoomsDropdownQuery, GetAllRoomsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRoomsDropdownQuery, GetAllRoomsDropdownQueryVariables>(GetAllRoomsDropdownDocument, options);
        }
export type GetAllRoomsDropdownQueryHookResult = ReturnType<typeof useGetAllRoomsDropdownQuery>;
export type GetAllRoomsDropdownLazyQueryHookResult = ReturnType<typeof useGetAllRoomsDropdownLazyQuery>;
export type GetAllRoomsDropdownQueryResult = Apollo.QueryResult<GetAllRoomsDropdownQuery, GetAllRoomsDropdownQueryVariables>;
export const GetRoomSelectorDocument = gql`
    query getRoomSelector($id: String!) {
  getRoom(roomId: $id) {
    ...RoomCoreFields
    subtitle
    size
    image {
      ...FileFields
    }
    addons {
      ...MaterialCoreFields
      price
      description
    }
    rateModel
    rate
    maxRate
    interval
    halfDayRate
    fullDayRate
    halfDayMinutes
    liabilityPolicy
    cancellationPolicy
    notes
    requiresApproval
  }
}
    ${RoomCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetRoomSelectorQuery__
 *
 * To run a query within a React component, call `useGetRoomSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomSelectorQuery(baseOptions: Apollo.QueryHookOptions<GetRoomSelectorQuery, GetRoomSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomSelectorQuery, GetRoomSelectorQueryVariables>(GetRoomSelectorDocument, options);
      }
export function useGetRoomSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomSelectorQuery, GetRoomSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomSelectorQuery, GetRoomSelectorQueryVariables>(GetRoomSelectorDocument, options);
        }
export type GetRoomSelectorQueryHookResult = ReturnType<typeof useGetRoomSelectorQuery>;
export type GetRoomSelectorLazyQueryHookResult = ReturnType<typeof useGetRoomSelectorLazyQuery>;
export type GetRoomSelectorQueryResult = Apollo.QueryResult<GetRoomSelectorQuery, GetRoomSelectorQueryVariables>;
export const GetRoomAdminDocument = gql`
    query getRoomAdmin($id: String!) {
  getRoom(roomId: $id) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useGetRoomAdminQuery__
 *
 * To run a query within a React component, call `useGetRoomAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomAdminQuery(baseOptions: Apollo.QueryHookOptions<GetRoomAdminQuery, GetRoomAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomAdminQuery, GetRoomAdminQueryVariables>(GetRoomAdminDocument, options);
      }
export function useGetRoomAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomAdminQuery, GetRoomAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomAdminQuery, GetRoomAdminQueryVariables>(GetRoomAdminDocument, options);
        }
export type GetRoomAdminQueryHookResult = ReturnType<typeof useGetRoomAdminQuery>;
export type GetRoomAdminLazyQueryHookResult = ReturnType<typeof useGetRoomAdminLazyQuery>;
export type GetRoomAdminQueryResult = Apollo.QueryResult<GetRoomAdminQuery, GetRoomAdminQueryVariables>;
export const ExportRoomsDocument = gql`
    query exportRooms($active: Boolean, $search: String) {
  exportRooms(active: $active, search: $search)
}
    `;

/**
 * __useExportRoomsQuery__
 *
 * To run a query within a React component, call `useExportRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportRoomsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportRoomsQuery(baseOptions?: Apollo.QueryHookOptions<ExportRoomsQuery, ExportRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportRoomsQuery, ExportRoomsQueryVariables>(ExportRoomsDocument, options);
      }
export function useExportRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportRoomsQuery, ExportRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportRoomsQuery, ExportRoomsQueryVariables>(ExportRoomsDocument, options);
        }
export type ExportRoomsQueryHookResult = ReturnType<typeof useExportRoomsQuery>;
export type ExportRoomsLazyQueryHookResult = ReturnType<typeof useExportRoomsLazyQuery>;
export type ExportRoomsQueryResult = Apollo.QueryResult<ExportRoomsQuery, ExportRoomsQueryVariables>;
export const UpdateRoomSettingsDocument = gql`
    mutation updateRoomSettings($data: RoomSettingsInput!) {
  updateRoomSettings(input: $data) {
    ...RoomSettingsFields
  }
}
    ${RoomSettingsFieldsFragmentDoc}`;
export type UpdateRoomSettingsMutationFn = Apollo.MutationFunction<UpdateRoomSettingsMutation, UpdateRoomSettingsMutationVariables>;

/**
 * __useUpdateRoomSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateRoomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomSettingsMutation, { data, loading, error }] = useUpdateRoomSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomSettingsMutation, UpdateRoomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomSettingsMutation, UpdateRoomSettingsMutationVariables>(UpdateRoomSettingsDocument, options);
      }
export type UpdateRoomSettingsMutationHookResult = ReturnType<typeof useUpdateRoomSettingsMutation>;
export type UpdateRoomSettingsMutationResult = Apollo.MutationResult<UpdateRoomSettingsMutation>;
export type UpdateRoomSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateRoomSettingsMutation, UpdateRoomSettingsMutationVariables>;
export const GetRoomSettingsDocument = gql`
    query getRoomSettings {
  getRoomSettings {
    ...RoomSettingsFields
  }
}
    ${RoomSettingsFieldsFragmentDoc}`;

/**
 * __useGetRoomSettingsQuery__
 *
 * To run a query within a React component, call `useGetRoomSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoomSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetRoomSettingsQuery, GetRoomSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomSettingsQuery, GetRoomSettingsQueryVariables>(GetRoomSettingsDocument, options);
      }
export function useGetRoomSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomSettingsQuery, GetRoomSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomSettingsQuery, GetRoomSettingsQueryVariables>(GetRoomSettingsDocument, options);
        }
export type GetRoomSettingsQueryHookResult = ReturnType<typeof useGetRoomSettingsQuery>;
export type GetRoomSettingsLazyQueryHookResult = ReturnType<typeof useGetRoomSettingsLazyQuery>;
export type GetRoomSettingsQueryResult = Apollo.QueryResult<GetRoomSettingsQuery, GetRoomSettingsQueryVariables>;
export const CreateShippingProviderDocument = gql`
    mutation createShippingProvider($data: ShippingProviderInput!) {
  createShippingProvider(input: $data) {
    id
  }
}
    `;
export type CreateShippingProviderMutationFn = Apollo.MutationFunction<CreateShippingProviderMutation, CreateShippingProviderMutationVariables>;

/**
 * __useCreateShippingProviderMutation__
 *
 * To run a mutation, you first call `useCreateShippingProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShippingProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShippingProviderMutation, { data, loading, error }] = useCreateShippingProviderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateShippingProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateShippingProviderMutation, CreateShippingProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShippingProviderMutation, CreateShippingProviderMutationVariables>(CreateShippingProviderDocument, options);
      }
export type CreateShippingProviderMutationHookResult = ReturnType<typeof useCreateShippingProviderMutation>;
export type CreateShippingProviderMutationResult = Apollo.MutationResult<CreateShippingProviderMutation>;
export type CreateShippingProviderMutationOptions = Apollo.BaseMutationOptions<CreateShippingProviderMutation, CreateShippingProviderMutationVariables>;
export const UpdateShippingProviderDocument = gql`
    mutation updateShippingProvider($id: String!, $data: ShippingProviderInput!) {
  updateShippingProvider(id: $id, input: $data) {
    ...ShippingProviderFields
  }
}
    ${ShippingProviderFieldsFragmentDoc}`;
export type UpdateShippingProviderMutationFn = Apollo.MutationFunction<UpdateShippingProviderMutation, UpdateShippingProviderMutationVariables>;

/**
 * __useUpdateShippingProviderMutation__
 *
 * To run a mutation, you first call `useUpdateShippingProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingProviderMutation, { data, loading, error }] = useUpdateShippingProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateShippingProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingProviderMutation, UpdateShippingProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingProviderMutation, UpdateShippingProviderMutationVariables>(UpdateShippingProviderDocument, options);
      }
export type UpdateShippingProviderMutationHookResult = ReturnType<typeof useUpdateShippingProviderMutation>;
export type UpdateShippingProviderMutationResult = Apollo.MutationResult<UpdateShippingProviderMutation>;
export type UpdateShippingProviderMutationOptions = Apollo.BaseMutationOptions<UpdateShippingProviderMutation, UpdateShippingProviderMutationVariables>;
export const RemoveShippingProvidersDocument = gql`
    mutation removeShippingProviders($data: DeleteRecordsInput!) {
  removeShippingProviders(input: $data)
}
    `;
export type RemoveShippingProvidersMutationFn = Apollo.MutationFunction<RemoveShippingProvidersMutation, RemoveShippingProvidersMutationVariables>;

/**
 * __useRemoveShippingProvidersMutation__
 *
 * To run a mutation, you first call `useRemoveShippingProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShippingProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShippingProvidersMutation, { data, loading, error }] = useRemoveShippingProvidersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveShippingProvidersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShippingProvidersMutation, RemoveShippingProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShippingProvidersMutation, RemoveShippingProvidersMutationVariables>(RemoveShippingProvidersDocument, options);
      }
export type RemoveShippingProvidersMutationHookResult = ReturnType<typeof useRemoveShippingProvidersMutation>;
export type RemoveShippingProvidersMutationResult = Apollo.MutationResult<RemoveShippingProvidersMutation>;
export type RemoveShippingProvidersMutationOptions = Apollo.BaseMutationOptions<RemoveShippingProvidersMutation, RemoveShippingProvidersMutationVariables>;
export const GetShippingProvidersDocument = gql`
    query getShippingProviders($search: String) {
  getShippingProviders(search: $search) {
    ...ShippingProviderFields
  }
}
    ${ShippingProviderFieldsFragmentDoc}`;

/**
 * __useGetShippingProvidersQuery__
 *
 * To run a query within a React component, call `useGetShippingProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingProvidersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetShippingProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetShippingProvidersQuery, GetShippingProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingProvidersQuery, GetShippingProvidersQueryVariables>(GetShippingProvidersDocument, options);
      }
export function useGetShippingProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingProvidersQuery, GetShippingProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingProvidersQuery, GetShippingProvidersQueryVariables>(GetShippingProvidersDocument, options);
        }
export type GetShippingProvidersQueryHookResult = ReturnType<typeof useGetShippingProvidersQuery>;
export type GetShippingProvidersLazyQueryHookResult = ReturnType<typeof useGetShippingProvidersLazyQuery>;
export type GetShippingProvidersQueryResult = Apollo.QueryResult<GetShippingProvidersQuery, GetShippingProvidersQueryVariables>;
export const GetShippingProviderDocument = gql`
    query getShippingProvider($id: String!) {
  getShippingProvider(id: $id) {
    ...ShippingProviderFields
  }
}
    ${ShippingProviderFieldsFragmentDoc}`;

/**
 * __useGetShippingProviderQuery__
 *
 * To run a query within a React component, call `useGetShippingProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShippingProviderQuery(baseOptions: Apollo.QueryHookOptions<GetShippingProviderQuery, GetShippingProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingProviderQuery, GetShippingProviderQueryVariables>(GetShippingProviderDocument, options);
      }
export function useGetShippingProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingProviderQuery, GetShippingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingProviderQuery, GetShippingProviderQueryVariables>(GetShippingProviderDocument, options);
        }
export type GetShippingProviderQueryHookResult = ReturnType<typeof useGetShippingProviderQuery>;
export type GetShippingProviderLazyQueryHookResult = ReturnType<typeof useGetShippingProviderLazyQuery>;
export type GetShippingProviderQueryResult = Apollo.QueryResult<GetShippingProviderQuery, GetShippingProviderQueryVariables>;
export const GetStackingPlanDocument = gql`
    query getStackingPlan($date: String!, $buildingId: String!) {
  getStackingPlan(date: $date, buildingId: $buildingId) {
    years
    floors {
      ...StackingPlanFloorFields
    }
  }
}
    ${StackingPlanFloorFieldsFragmentDoc}`;

/**
 * __useGetStackingPlanQuery__
 *
 * To run a query within a React component, call `useGetStackingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStackingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStackingPlanQuery({
 *   variables: {
 *      date: // value for 'date'
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useGetStackingPlanQuery(baseOptions: Apollo.QueryHookOptions<GetStackingPlanQuery, GetStackingPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStackingPlanQuery, GetStackingPlanQueryVariables>(GetStackingPlanDocument, options);
      }
export function useGetStackingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStackingPlanQuery, GetStackingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStackingPlanQuery, GetStackingPlanQueryVariables>(GetStackingPlanDocument, options);
        }
export type GetStackingPlanQueryHookResult = ReturnType<typeof useGetStackingPlanQuery>;
export type GetStackingPlanLazyQueryHookResult = ReturnType<typeof useGetStackingPlanLazyQuery>;
export type GetStackingPlanQueryResult = Apollo.QueryResult<GetStackingPlanQuery, GetStackingPlanQueryVariables>;
export const CreateStatusDocument = gql`
    mutation createStatus($data: StatusInput!) {
  createStatus(input: $data) {
    id
  }
}
    `;
export type CreateStatusMutationFn = Apollo.MutationFunction<CreateStatusMutation, CreateStatusMutationVariables>;

/**
 * __useCreateStatusMutation__
 *
 * To run a mutation, you first call `useCreateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatusMutation, { data, loading, error }] = useCreateStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateStatusMutation, CreateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStatusMutation, CreateStatusMutationVariables>(CreateStatusDocument, options);
      }
export type CreateStatusMutationHookResult = ReturnType<typeof useCreateStatusMutation>;
export type CreateStatusMutationResult = Apollo.MutationResult<CreateStatusMutation>;
export type CreateStatusMutationOptions = Apollo.BaseMutationOptions<CreateStatusMutation, CreateStatusMutationVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($id: String!, $data: StatusUpdateInput!) {
  updateStatus(id: $id, input: $data) {
    ...StatusFields
  }
}
    ${StatusFieldsFragmentDoc}`;
export type UpdateStatusMutationFn = Apollo.MutationFunction<UpdateStatusMutation, UpdateStatusMutationVariables>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMutation, UpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, options);
      }
export type UpdateStatusMutationHookResult = ReturnType<typeof useUpdateStatusMutation>;
export type UpdateStatusMutationResult = Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const ReorderStatusesDocument = gql`
    mutation reorderStatuses($id: String!, $secondId: String!) {
  reorderStatuses(id: $id, secondId: $secondId)
}
    `;
export type ReorderStatusesMutationFn = Apollo.MutationFunction<ReorderStatusesMutation, ReorderStatusesMutationVariables>;

/**
 * __useReorderStatusesMutation__
 *
 * To run a mutation, you first call `useReorderStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderStatusesMutation, { data, loading, error }] = useReorderStatusesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderStatusesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderStatusesMutation, ReorderStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderStatusesMutation, ReorderStatusesMutationVariables>(ReorderStatusesDocument, options);
      }
export type ReorderStatusesMutationHookResult = ReturnType<typeof useReorderStatusesMutation>;
export type ReorderStatusesMutationResult = Apollo.MutationResult<ReorderStatusesMutation>;
export type ReorderStatusesMutationOptions = Apollo.BaseMutationOptions<ReorderStatusesMutation, ReorderStatusesMutationVariables>;
export const ToggleStatusDocument = gql`
    mutation toggleStatus($id: String!) {
  toggleStatus(id: $id)
}
    `;
export type ToggleStatusMutationFn = Apollo.MutationFunction<ToggleStatusMutation, ToggleStatusMutationVariables>;

/**
 * __useToggleStatusMutation__
 *
 * To run a mutation, you first call `useToggleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleStatusMutation, { data, loading, error }] = useToggleStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleStatusMutation, ToggleStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleStatusMutation, ToggleStatusMutationVariables>(ToggleStatusDocument, options);
      }
export type ToggleStatusMutationHookResult = ReturnType<typeof useToggleStatusMutation>;
export type ToggleStatusMutationResult = Apollo.MutationResult<ToggleStatusMutation>;
export type ToggleStatusMutationOptions = Apollo.BaseMutationOptions<ToggleStatusMutation, ToggleStatusMutationVariables>;
export const RemoveStatusesDocument = gql`
    mutation removeStatuses($data: DeleteRecordsInput!) {
  removeStatuses(input: $data)
}
    `;
export type RemoveStatusesMutationFn = Apollo.MutationFunction<RemoveStatusesMutation, RemoveStatusesMutationVariables>;

/**
 * __useRemoveStatusesMutation__
 *
 * To run a mutation, you first call `useRemoveStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStatusesMutation, { data, loading, error }] = useRemoveStatusesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveStatusesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStatusesMutation, RemoveStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStatusesMutation, RemoveStatusesMutationVariables>(RemoveStatusesDocument, options);
      }
export type RemoveStatusesMutationHookResult = ReturnType<typeof useRemoveStatusesMutation>;
export type RemoveStatusesMutationResult = Apollo.MutationResult<RemoveStatusesMutation>;
export type RemoveStatusesMutationOptions = Apollo.BaseMutationOptions<RemoveStatusesMutation, RemoveStatusesMutationVariables>;
export const GetStatusesTableDocument = gql`
    query getStatusesTable($recordType: StatusRecordType!, $active: Boolean, $search: String) {
  getStatuses(recordType: $recordType, active: $active, search: $search) {
    ...StatusCoreFields
    color
    index
    active
    propertyId
  }
}
    ${StatusCoreFieldsFragmentDoc}`;

/**
 * __useGetStatusesTableQuery__
 *
 * To run a query within a React component, call `useGetStatusesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusesTableQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetStatusesTableQuery(baseOptions: Apollo.QueryHookOptions<GetStatusesTableQuery, GetStatusesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusesTableQuery, GetStatusesTableQueryVariables>(GetStatusesTableDocument, options);
      }
export function useGetStatusesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusesTableQuery, GetStatusesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusesTableQuery, GetStatusesTableQueryVariables>(GetStatusesTableDocument, options);
        }
export type GetStatusesTableQueryHookResult = ReturnType<typeof useGetStatusesTableQuery>;
export type GetStatusesTableLazyQueryHookResult = ReturnType<typeof useGetStatusesTableLazyQuery>;
export type GetStatusesTableQueryResult = Apollo.QueryResult<GetStatusesTableQuery, GetStatusesTableQueryVariables>;
export const GetStatusesDropdownDocument = gql`
    query getStatusesDropdown($recordType: StatusRecordType!, $active: Boolean, $search: String) {
  getStatuses(recordType: $recordType, active: $active, search: $search) {
    ...StatusCoreFields
    color
    active
  }
}
    ${StatusCoreFieldsFragmentDoc}`;

/**
 * __useGetStatusesDropdownQuery__
 *
 * To run a query within a React component, call `useGetStatusesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusesDropdownQuery({
 *   variables: {
 *      recordType: // value for 'recordType'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetStatusesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>(GetStatusesDropdownDocument, options);
      }
export function useGetStatusesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>(GetStatusesDropdownDocument, options);
        }
export type GetStatusesDropdownQueryHookResult = ReturnType<typeof useGetStatusesDropdownQuery>;
export type GetStatusesDropdownLazyQueryHookResult = ReturnType<typeof useGetStatusesDropdownLazyQuery>;
export type GetStatusesDropdownQueryResult = Apollo.QueryResult<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>;
export const GetPublicStatusesDocument = gql`
    query getPublicStatuses($propertyId: String!, $recordType: StatusRecordType!, $search: String!) {
  getPublicStatuses(
    propertyId: $propertyId
    recordType: $recordType
    search: $search
  ) {
    ...StatusCoreFields
    color
  }
}
    ${StatusCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicStatusesQuery__
 *
 * To run a query within a React component, call `useGetPublicStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicStatusesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      recordType: // value for 'recordType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicStatusesQuery, GetPublicStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicStatusesQuery, GetPublicStatusesQueryVariables>(GetPublicStatusesDocument, options);
      }
export function useGetPublicStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicStatusesQuery, GetPublicStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicStatusesQuery, GetPublicStatusesQueryVariables>(GetPublicStatusesDocument, options);
        }
export type GetPublicStatusesQueryHookResult = ReturnType<typeof useGetPublicStatusesQuery>;
export type GetPublicStatusesLazyQueryHookResult = ReturnType<typeof useGetPublicStatusesLazyQuery>;
export type GetPublicStatusesQueryResult = Apollo.QueryResult<GetPublicStatusesQuery, GetPublicStatusesQueryVariables>;
export const GetFilterableStatusesDocument = gql`
    query getFilterableStatuses($location: FilterableStatusLocationType!, $search: String) {
  getFilterableStatuses(location: $location, search: $search) {
    id
    title
    color
    active
    isDeleted
  }
}
    `;

/**
 * __useGetFilterableStatusesQuery__
 *
 * To run a query within a React component, call `useGetFilterableStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterableStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterableStatusesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterableStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>(GetFilterableStatusesDocument, options);
      }
export function useGetFilterableStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>(GetFilterableStatusesDocument, options);
        }
export type GetFilterableStatusesQueryHookResult = ReturnType<typeof useGetFilterableStatusesQuery>;
export type GetFilterableStatusesLazyQueryHookResult = ReturnType<typeof useGetFilterableStatusesLazyQuery>;
export type GetFilterableStatusesQueryResult = Apollo.QueryResult<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>;
export const GetStatusDocument = gql`
    query getStatus($id: String!) {
  getStatus(id: $id) {
    ...StatusFields
  }
}
    ${StatusFieldsFragmentDoc}`;

/**
 * __useGetStatusQuery__
 *
 * To run a query within a React component, call `useGetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStatusQuery(baseOptions: Apollo.QueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
      }
export function useGetStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
        }
export type GetStatusQueryHookResult = ReturnType<typeof useGetStatusQuery>;
export type GetStatusLazyQueryHookResult = ReturnType<typeof useGetStatusLazyQuery>;
export type GetStatusQueryResult = Apollo.QueryResult<GetStatusQuery, GetStatusQueryVariables>;
export const GetStripeInvoicesDocument = gql`
    query getStripeInvoices($take: Int! = 10, $after: String, $before: String, $search: String) {
  getStripeInvoices(take: $take, after: $after, before: $before, search: $search) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      amountDue
      amountPaid
      createdAt
      invoiceNumber
      status
      subscriptionId
      paymentId
      type
      productData {
        title
      }
      company {
        ...CompanyCoreFields
      }
      user {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetStripeInvoicesQuery__
 *
 * To run a query within a React component, call `useGetStripeInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeInvoicesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetStripeInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeInvoicesQuery, GetStripeInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeInvoicesQuery, GetStripeInvoicesQueryVariables>(GetStripeInvoicesDocument, options);
      }
export function useGetStripeInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeInvoicesQuery, GetStripeInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeInvoicesQuery, GetStripeInvoicesQueryVariables>(GetStripeInvoicesDocument, options);
        }
export type GetStripeInvoicesQueryHookResult = ReturnType<typeof useGetStripeInvoicesQuery>;
export type GetStripeInvoicesLazyQueryHookResult = ReturnType<typeof useGetStripeInvoicesLazyQuery>;
export type GetStripeInvoicesQueryResult = Apollo.QueryResult<GetStripeInvoicesQuery, GetStripeInvoicesQueryVariables>;
export const GetStripeInvoiceDocument = gql`
    query getStripeInvoice($invoiceId: String!) {
  getStripeInvoice(invoiceId: $invoiceId) {
    ...StripeInvoiceFields
  }
}
    ${StripeInvoiceFieldsFragmentDoc}`;

/**
 * __useGetStripeInvoiceQuery__
 *
 * To run a query within a React component, call `useGetStripeInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetStripeInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetStripeInvoiceQuery, GetStripeInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeInvoiceQuery, GetStripeInvoiceQueryVariables>(GetStripeInvoiceDocument, options);
      }
export function useGetStripeInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeInvoiceQuery, GetStripeInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeInvoiceQuery, GetStripeInvoiceQueryVariables>(GetStripeInvoiceDocument, options);
        }
export type GetStripeInvoiceQueryHookResult = ReturnType<typeof useGetStripeInvoiceQuery>;
export type GetStripeInvoiceLazyQueryHookResult = ReturnType<typeof useGetStripeInvoiceLazyQuery>;
export type GetStripeInvoiceQueryResult = Apollo.QueryResult<GetStripeInvoiceQuery, GetStripeInvoiceQueryVariables>;
export const HandleStripeOauthDocument = gql`
    mutation handleStripeOauth($propertyId: String!, $code: String!) {
  handleStripeOauth(propertyId: $propertyId, code: $code)
}
    `;
export type HandleStripeOauthMutationFn = Apollo.MutationFunction<HandleStripeOauthMutation, HandleStripeOauthMutationVariables>;

/**
 * __useHandleStripeOauthMutation__
 *
 * To run a mutation, you first call `useHandleStripeOauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleStripeOauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleStripeOauthMutation, { data, loading, error }] = useHandleStripeOauthMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useHandleStripeOauthMutation(baseOptions?: Apollo.MutationHookOptions<HandleStripeOauthMutation, HandleStripeOauthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleStripeOauthMutation, HandleStripeOauthMutationVariables>(HandleStripeOauthDocument, options);
      }
export type HandleStripeOauthMutationHookResult = ReturnType<typeof useHandleStripeOauthMutation>;
export type HandleStripeOauthMutationResult = Apollo.MutationResult<HandleStripeOauthMutation>;
export type HandleStripeOauthMutationOptions = Apollo.BaseMutationOptions<HandleStripeOauthMutation, HandleStripeOauthMutationVariables>;
export const UpdateStripeSettingsDocument = gql`
    mutation updateStripeSettings($data: StripeSettingsInput!) {
  updateStripeSettings(input: $data) {
    ...StripeSettingsFields
  }
}
    ${StripeSettingsFieldsFragmentDoc}`;
export type UpdateStripeSettingsMutationFn = Apollo.MutationFunction<UpdateStripeSettingsMutation, UpdateStripeSettingsMutationVariables>;

/**
 * __useUpdateStripeSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateStripeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStripeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStripeSettingsMutation, { data, loading, error }] = useUpdateStripeSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStripeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStripeSettingsMutation, UpdateStripeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStripeSettingsMutation, UpdateStripeSettingsMutationVariables>(UpdateStripeSettingsDocument, options);
      }
export type UpdateStripeSettingsMutationHookResult = ReturnType<typeof useUpdateStripeSettingsMutation>;
export type UpdateStripeSettingsMutationResult = Apollo.MutationResult<UpdateStripeSettingsMutation>;
export type UpdateStripeSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateStripeSettingsMutation, UpdateStripeSettingsMutationVariables>;
export const GetStripeSettingsDocument = gql`
    query getStripeSettings {
  getStripeSettings {
    ...StripeSettingsFields
  }
}
    ${StripeSettingsFieldsFragmentDoc}`;

/**
 * __useGetStripeSettingsQuery__
 *
 * To run a query within a React component, call `useGetStripeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeSettingsQuery, GetStripeSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeSettingsQuery, GetStripeSettingsQueryVariables>(GetStripeSettingsDocument, options);
      }
export function useGetStripeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeSettingsQuery, GetStripeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeSettingsQuery, GetStripeSettingsQueryVariables>(GetStripeSettingsDocument, options);
        }
export type GetStripeSettingsQueryHookResult = ReturnType<typeof useGetStripeSettingsQuery>;
export type GetStripeSettingsLazyQueryHookResult = ReturnType<typeof useGetStripeSettingsLazyQuery>;
export type GetStripeSettingsQueryResult = Apollo.QueryResult<GetStripeSettingsQuery, GetStripeSettingsQueryVariables>;
export const GetSubscriptionChargesDocument = gql`
    query getSubscriptionCharges($id: String!) {
  getSubscriptionCharges(id: $id) {
    id
    invoiceLink
    charges {
      id
      amount
      amountRefunded
      refunded
      description
      createdAt
    }
  }
}
    `;

/**
 * __useGetSubscriptionChargesQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionChargesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionChargesQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionChargesQuery, GetSubscriptionChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionChargesQuery, GetSubscriptionChargesQueryVariables>(GetSubscriptionChargesDocument, options);
      }
export function useGetSubscriptionChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionChargesQuery, GetSubscriptionChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionChargesQuery, GetSubscriptionChargesQueryVariables>(GetSubscriptionChargesDocument, options);
        }
export type GetSubscriptionChargesQueryHookResult = ReturnType<typeof useGetSubscriptionChargesQuery>;
export type GetSubscriptionChargesLazyQueryHookResult = ReturnType<typeof useGetSubscriptionChargesLazyQuery>;
export type GetSubscriptionChargesQueryResult = Apollo.QueryResult<GetSubscriptionChargesQuery, GetSubscriptionChargesQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($data: SubscriptionInput!) {
  createSubscription(input: $data) {
    id
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($id: String!, $data: SubscriptionUpdateInput!) {
  updateSubscription(id: $id, input: $data) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($data: SubscriptionCancelInput!) {
  cancelSubscription(input: $data) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const RefundChargeDocument = gql`
    mutation refundCharge($data: RefundChargeInput!) {
  refundCharge(input: $data)
}
    `;
export type RefundChargeMutationFn = Apollo.MutationFunction<RefundChargeMutation, RefundChargeMutationVariables>;

/**
 * __useRefundChargeMutation__
 *
 * To run a mutation, you first call `useRefundChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundChargeMutation, { data, loading, error }] = useRefundChargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRefundChargeMutation(baseOptions?: Apollo.MutationHookOptions<RefundChargeMutation, RefundChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundChargeMutation, RefundChargeMutationVariables>(RefundChargeDocument, options);
      }
export type RefundChargeMutationHookResult = ReturnType<typeof useRefundChargeMutation>;
export type RefundChargeMutationResult = Apollo.MutationResult<RefundChargeMutation>;
export type RefundChargeMutationOptions = Apollo.BaseMutationOptions<RefundChargeMutation, RefundChargeMutationVariables>;
export const CheckSubscriptionTrialDocument = gql`
    mutation checkSubscriptionTrial($data: SubscriptionTrialInput!) {
  checkSubscriptionTrial(input: $data)
}
    `;
export type CheckSubscriptionTrialMutationFn = Apollo.MutationFunction<CheckSubscriptionTrialMutation, CheckSubscriptionTrialMutationVariables>;

/**
 * __useCheckSubscriptionTrialMutation__
 *
 * To run a mutation, you first call `useCheckSubscriptionTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSubscriptionTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSubscriptionTrialMutation, { data, loading, error }] = useCheckSubscriptionTrialMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckSubscriptionTrialMutation(baseOptions?: Apollo.MutationHookOptions<CheckSubscriptionTrialMutation, CheckSubscriptionTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckSubscriptionTrialMutation, CheckSubscriptionTrialMutationVariables>(CheckSubscriptionTrialDocument, options);
      }
export type CheckSubscriptionTrialMutationHookResult = ReturnType<typeof useCheckSubscriptionTrialMutation>;
export type CheckSubscriptionTrialMutationResult = Apollo.MutationResult<CheckSubscriptionTrialMutation>;
export type CheckSubscriptionTrialMutationOptions = Apollo.BaseMutationOptions<CheckSubscriptionTrialMutation, CheckSubscriptionTrialMutationVariables>;
export const GenerateSubscriptionWaiverTextDocument = gql`
    mutation generateSubscriptionWaiverText($data: SubscriptionWaiverTextInput!) {
  generateSubscriptionWaiverText(input: $data) {
    text
  }
}
    `;
export type GenerateSubscriptionWaiverTextMutationFn = Apollo.MutationFunction<GenerateSubscriptionWaiverTextMutation, GenerateSubscriptionWaiverTextMutationVariables>;

/**
 * __useGenerateSubscriptionWaiverTextMutation__
 *
 * To run a mutation, you first call `useGenerateSubscriptionWaiverTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSubscriptionWaiverTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSubscriptionWaiverTextMutation, { data, loading, error }] = useGenerateSubscriptionWaiverTextMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateSubscriptionWaiverTextMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSubscriptionWaiverTextMutation, GenerateSubscriptionWaiverTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSubscriptionWaiverTextMutation, GenerateSubscriptionWaiverTextMutationVariables>(GenerateSubscriptionWaiverTextDocument, options);
      }
export type GenerateSubscriptionWaiverTextMutationHookResult = ReturnType<typeof useGenerateSubscriptionWaiverTextMutation>;
export type GenerateSubscriptionWaiverTextMutationResult = Apollo.MutationResult<GenerateSubscriptionWaiverTextMutation>;
export type GenerateSubscriptionWaiverTextMutationOptions = Apollo.BaseMutationOptions<GenerateSubscriptionWaiverTextMutation, GenerateSubscriptionWaiverTextMutationVariables>;
export const ValidateCouponDocument = gql`
    mutation validateCoupon($data: CouponValidateInput!) {
  validateCoupon(input: $data) {
    discount
    price
    total
  }
}
    `;
export type ValidateCouponMutationFn = Apollo.MutationFunction<ValidateCouponMutation, ValidateCouponMutationVariables>;

/**
 * __useValidateCouponMutation__
 *
 * To run a mutation, you first call `useValidateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCouponMutation, { data, loading, error }] = useValidateCouponMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useValidateCouponMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCouponMutation, ValidateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCouponMutation, ValidateCouponMutationVariables>(ValidateCouponDocument, options);
      }
export type ValidateCouponMutationHookResult = ReturnType<typeof useValidateCouponMutation>;
export type ValidateCouponMutationResult = Apollo.MutationResult<ValidateCouponMutation>;
export type ValidateCouponMutationOptions = Apollo.BaseMutationOptions<ValidateCouponMutation, ValidateCouponMutationVariables>;
export const AddSubscriptionAttachmentsDocument = gql`
    mutation addSubscriptionAttachments($subscriptionId: String!, $attachments: [FileObjectInput!]!) {
  addSubscriptionAttachments(
    subscriptionId: $subscriptionId
    attachments: $attachments
  ) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type AddSubscriptionAttachmentsMutationFn = Apollo.MutationFunction<AddSubscriptionAttachmentsMutation, AddSubscriptionAttachmentsMutationVariables>;

/**
 * __useAddSubscriptionAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionAttachmentsMutation, { data, loading, error }] = useAddSubscriptionAttachmentsMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddSubscriptionAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddSubscriptionAttachmentsMutation, AddSubscriptionAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubscriptionAttachmentsMutation, AddSubscriptionAttachmentsMutationVariables>(AddSubscriptionAttachmentsDocument, options);
      }
export type AddSubscriptionAttachmentsMutationHookResult = ReturnType<typeof useAddSubscriptionAttachmentsMutation>;
export type AddSubscriptionAttachmentsMutationResult = Apollo.MutationResult<AddSubscriptionAttachmentsMutation>;
export type AddSubscriptionAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddSubscriptionAttachmentsMutation, AddSubscriptionAttachmentsMutationVariables>;
export const RemoveSubscriptionAttachmentDocument = gql`
    mutation removeSubscriptionAttachment($id: String!, $attachmentId: String!) {
  removeSubscriptionAttachment(id: $id, attachmentId: $attachmentId) {
    id
    attachments {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type RemoveSubscriptionAttachmentMutationFn = Apollo.MutationFunction<RemoveSubscriptionAttachmentMutation, RemoveSubscriptionAttachmentMutationVariables>;

/**
 * __useRemoveSubscriptionAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveSubscriptionAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubscriptionAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubscriptionAttachmentMutation, { data, loading, error }] = useRemoveSubscriptionAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveSubscriptionAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSubscriptionAttachmentMutation, RemoveSubscriptionAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSubscriptionAttachmentMutation, RemoveSubscriptionAttachmentMutationVariables>(RemoveSubscriptionAttachmentDocument, options);
      }
export type RemoveSubscriptionAttachmentMutationHookResult = ReturnType<typeof useRemoveSubscriptionAttachmentMutation>;
export type RemoveSubscriptionAttachmentMutationResult = Apollo.MutationResult<RemoveSubscriptionAttachmentMutation>;
export type RemoveSubscriptionAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveSubscriptionAttachmentMutation, RemoveSubscriptionAttachmentMutationVariables>;
export const GetSubscriptionsDocument = gql`
    query getSubscriptions($take: Int! = 10, $after: String, $before: String, $search: String, $productIds: [String!], $companyIds: [String!], $requestedForIds: [String!], $statuses: [SubscriptionStatusEnum!], $billingPeriod: [PriceBillingPeriod!]) {
  getSubscriptions(
    take: $take
    after: $after
    before: $before
    search: $search
    requestedForIds: $requestedForIds
    companyIds: $companyIds
    productIds: $productIds
    statuses: $statuses
    billingPeriod: $billingPeriod
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      index
      id
      canceledAt
      createdAt
      startDate
      nextChargeDate
      status
      type
      productData {
        id
        title
        active
      }
      priceData {
        id
        title
        paidPrice
        billingPeriod
        type
      }
      couponData {
        id
      }
      requestedFor {
        ...UserCoreFields
      }
      company {
        ...CompanyCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      productIds: // value for 'productIds'
 *      companyIds: // value for 'companyIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      statuses: // value for 'statuses'
 *      billingPeriod: // value for 'billingPeriod'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription($id: String!) {
  getSubscription(id: $id) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const CreateSuiteDocument = gql`
    mutation createSuite($data: SuiteInput!) {
  createSuite(input: $data) {
    id
  }
}
    `;
export type CreateSuiteMutationFn = Apollo.MutationFunction<CreateSuiteMutation, CreateSuiteMutationVariables>;

/**
 * __useCreateSuiteMutation__
 *
 * To run a mutation, you first call `useCreateSuiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuiteMutation, { data, loading, error }] = useCreateSuiteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSuiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSuiteMutation, CreateSuiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSuiteMutation, CreateSuiteMutationVariables>(CreateSuiteDocument, options);
      }
export type CreateSuiteMutationHookResult = ReturnType<typeof useCreateSuiteMutation>;
export type CreateSuiteMutationResult = Apollo.MutationResult<CreateSuiteMutation>;
export type CreateSuiteMutationOptions = Apollo.BaseMutationOptions<CreateSuiteMutation, CreateSuiteMutationVariables>;
export const UpdateSuiteDocument = gql`
    mutation updateSuite($id: String!, $data: SuiteInput!) {
  updateSuite(suiteId: $id, input: $data) {
    ...SuiteFields
  }
}
    ${SuiteFieldsFragmentDoc}`;
export type UpdateSuiteMutationFn = Apollo.MutationFunction<UpdateSuiteMutation, UpdateSuiteMutationVariables>;

/**
 * __useUpdateSuiteMutation__
 *
 * To run a mutation, you first call `useUpdateSuiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuiteMutation, { data, loading, error }] = useUpdateSuiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSuiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuiteMutation, UpdateSuiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuiteMutation, UpdateSuiteMutationVariables>(UpdateSuiteDocument, options);
      }
export type UpdateSuiteMutationHookResult = ReturnType<typeof useUpdateSuiteMutation>;
export type UpdateSuiteMutationResult = Apollo.MutationResult<UpdateSuiteMutation>;
export type UpdateSuiteMutationOptions = Apollo.BaseMutationOptions<UpdateSuiteMutation, UpdateSuiteMutationVariables>;
export const RemoveSuitesDocument = gql`
    mutation removeSuites($data: DeleteRecordsInput!) {
  removeSuites(input: $data)
}
    `;
export type RemoveSuitesMutationFn = Apollo.MutationFunction<RemoveSuitesMutation, RemoveSuitesMutationVariables>;

/**
 * __useRemoveSuitesMutation__
 *
 * To run a mutation, you first call `useRemoveSuitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSuitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSuitesMutation, { data, loading, error }] = useRemoveSuitesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveSuitesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSuitesMutation, RemoveSuitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSuitesMutation, RemoveSuitesMutationVariables>(RemoveSuitesDocument, options);
      }
export type RemoveSuitesMutationHookResult = ReturnType<typeof useRemoveSuitesMutation>;
export type RemoveSuitesMutationResult = Apollo.MutationResult<RemoveSuitesMutation>;
export type RemoveSuitesMutationOptions = Apollo.BaseMutationOptions<RemoveSuitesMutation, RemoveSuitesMutationVariables>;
export const ReorderSuitesDocument = gql`
    mutation reorderSuites($floorId: String!, $id: String!, $secondId: String!) {
  reorderSuites(floorId: $floorId, id: $id, secondId: $secondId)
}
    `;
export type ReorderSuitesMutationFn = Apollo.MutationFunction<ReorderSuitesMutation, ReorderSuitesMutationVariables>;

/**
 * __useReorderSuitesMutation__
 *
 * To run a mutation, you first call `useReorderSuitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderSuitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderSuitesMutation, { data, loading, error }] = useReorderSuitesMutation({
 *   variables: {
 *      floorId: // value for 'floorId'
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderSuitesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderSuitesMutation, ReorderSuitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderSuitesMutation, ReorderSuitesMutationVariables>(ReorderSuitesDocument, options);
      }
export type ReorderSuitesMutationHookResult = ReturnType<typeof useReorderSuitesMutation>;
export type ReorderSuitesMutationResult = Apollo.MutationResult<ReorderSuitesMutation>;
export type ReorderSuitesMutationOptions = Apollo.BaseMutationOptions<ReorderSuitesMutation, ReorderSuitesMutationVariables>;
export const GetSuitesTableDocument = gql`
    query getSuitesTable($buildingIds: [String!], $types: [SuiteType!], $floorId: String, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getSuites(
    buildingIds: $buildingIds
    types: $types
    floorId: $floorId
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getSuitesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...SuiteCoreFields
      index
      type
      size
      isPublic
      floor {
        ...FloorCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}`;

/**
 * __useGetSuitesTableQuery__
 *
 * To run a query within a React component, call `useGetSuitesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuitesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuitesTableQuery({
 *   variables: {
 *      buildingIds: // value for 'buildingIds'
 *      types: // value for 'types'
 *      floorId: // value for 'floorId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSuitesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetSuitesTableQuery, GetSuitesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuitesTableQuery, GetSuitesTableQueryVariables>(GetSuitesTableDocument, options);
      }
export function useGetSuitesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuitesTableQuery, GetSuitesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuitesTableQuery, GetSuitesTableQueryVariables>(GetSuitesTableDocument, options);
        }
export type GetSuitesTableQueryHookResult = ReturnType<typeof useGetSuitesTableQuery>;
export type GetSuitesTableLazyQueryHookResult = ReturnType<typeof useGetSuitesTableLazyQuery>;
export type GetSuitesTableQueryResult = Apollo.QueryResult<GetSuitesTableQuery, GetSuitesTableQueryVariables>;
export const GetSuitesDropdownDocument = gql`
    query getSuitesDropdown($buildingIds: [String!], $types: [SuiteType!], $floorId: String, $includeFloor: Boolean!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getSuites(
    buildingIds: $buildingIds
    types: $types
    floorId: $floorId
    take: $take
    after: $after
    before: $before
    search: $search
  ) @connection(key: "getSuitesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...SuiteCoreFields
      type
      floor @include(if: $includeFloor) {
        ...FloorCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}`;

/**
 * __useGetSuitesDropdownQuery__
 *
 * To run a query within a React component, call `useGetSuitesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuitesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuitesDropdownQuery({
 *   variables: {
 *      buildingIds: // value for 'buildingIds'
 *      types: // value for 'types'
 *      floorId: // value for 'floorId'
 *      includeFloor: // value for 'includeFloor'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSuitesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetSuitesDropdownQuery, GetSuitesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuitesDropdownQuery, GetSuitesDropdownQueryVariables>(GetSuitesDropdownDocument, options);
      }
export function useGetSuitesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuitesDropdownQuery, GetSuitesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuitesDropdownQuery, GetSuitesDropdownQueryVariables>(GetSuitesDropdownDocument, options);
        }
export type GetSuitesDropdownQueryHookResult = ReturnType<typeof useGetSuitesDropdownQuery>;
export type GetSuitesDropdownLazyQueryHookResult = ReturnType<typeof useGetSuitesDropdownLazyQuery>;
export type GetSuitesDropdownQueryResult = Apollo.QueryResult<GetSuitesDropdownQuery, GetSuitesDropdownQueryVariables>;
export const GetPublicSuitesDocument = gql`
    query getPublicSuites($propertyId: String!, $buildingIds: [String!], $types: [SuiteType!], $floorId: String, $take: Int! = 10, $after: String, $before: String, $search: String!) {
  getPublicSuites(
    propertyId: $propertyId
    buildingIds: $buildingIds
    types: $types
    floorId: $floorId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...SuiteCoreFields
      type
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicSuitesQuery__
 *
 * To run a query within a React component, call `useGetPublicSuitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicSuitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicSuitesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      buildingIds: // value for 'buildingIds'
 *      types: // value for 'types'
 *      floorId: // value for 'floorId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicSuitesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicSuitesQuery, GetPublicSuitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicSuitesQuery, GetPublicSuitesQueryVariables>(GetPublicSuitesDocument, options);
      }
export function useGetPublicSuitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicSuitesQuery, GetPublicSuitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicSuitesQuery, GetPublicSuitesQueryVariables>(GetPublicSuitesDocument, options);
        }
export type GetPublicSuitesQueryHookResult = ReturnType<typeof useGetPublicSuitesQuery>;
export type GetPublicSuitesLazyQueryHookResult = ReturnType<typeof useGetPublicSuitesLazyQuery>;
export type GetPublicSuitesQueryResult = Apollo.QueryResult<GetPublicSuitesQuery, GetPublicSuitesQueryVariables>;
export const GetSuiteDocument = gql`
    query getSuite($id: String!) {
  getSuite(suiteId: $id) {
    ...SuiteFields
  }
}
    ${SuiteFieldsFragmentDoc}`;

/**
 * __useGetSuiteQuery__
 *
 * To run a query within a React component, call `useGetSuiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSuiteQuery(baseOptions: Apollo.QueryHookOptions<GetSuiteQuery, GetSuiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuiteQuery, GetSuiteQueryVariables>(GetSuiteDocument, options);
      }
export function useGetSuiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuiteQuery, GetSuiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuiteQuery, GetSuiteQueryVariables>(GetSuiteDocument, options);
        }
export type GetSuiteQueryHookResult = ReturnType<typeof useGetSuiteQuery>;
export type GetSuiteLazyQueryHookResult = ReturnType<typeof useGetSuiteLazyQuery>;
export type GetSuiteQueryResult = Apollo.QueryResult<GetSuiteQuery, GetSuiteQueryVariables>;
export const ExportSuitesDocument = gql`
    query exportSuites($buildingIds: [String!], $types: [SuiteType!], $floorId: String, $search: String) {
  exportSuites(
    buildingIds: $buildingIds
    types: $types
    floorId: $floorId
    search: $search
  )
}
    `;

/**
 * __useExportSuitesQuery__
 *
 * To run a query within a React component, call `useExportSuitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSuitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSuitesQuery({
 *   variables: {
 *      buildingIds: // value for 'buildingIds'
 *      types: // value for 'types'
 *      floorId: // value for 'floorId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExportSuitesQuery(baseOptions?: Apollo.QueryHookOptions<ExportSuitesQuery, ExportSuitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSuitesQuery, ExportSuitesQueryVariables>(ExportSuitesDocument, options);
      }
export function useExportSuitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSuitesQuery, ExportSuitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSuitesQuery, ExportSuitesQueryVariables>(ExportSuitesDocument, options);
        }
export type ExportSuitesQueryHookResult = ReturnType<typeof useExportSuitesQuery>;
export type ExportSuitesLazyQueryHookResult = ReturnType<typeof useExportSuitesLazyQuery>;
export type ExportSuitesQueryResult = Apollo.QueryResult<ExportSuitesQuery, ExportSuitesQueryVariables>;
export const CreateTaxDocument = gql`
    mutation createTax($data: TaxInput!) {
  createTax(input: $data) {
    id
  }
}
    `;
export type CreateTaxMutationFn = Apollo.MutationFunction<CreateTaxMutation, CreateTaxMutationVariables>;

/**
 * __useCreateTaxMutation__
 *
 * To run a mutation, you first call `useCreateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxMutation, { data, loading, error }] = useCreateTaxMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxMutation, CreateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxMutation, CreateTaxMutationVariables>(CreateTaxDocument, options);
      }
export type CreateTaxMutationHookResult = ReturnType<typeof useCreateTaxMutation>;
export type CreateTaxMutationResult = Apollo.MutationResult<CreateTaxMutation>;
export type CreateTaxMutationOptions = Apollo.BaseMutationOptions<CreateTaxMutation, CreateTaxMutationVariables>;
export const UpdateTaxDocument = gql`
    mutation updateTax($id: String!, $data: TaxInput!) {
  updateTax(id: $id, input: $data) {
    ...TaxFields
  }
}
    ${TaxFieldsFragmentDoc}`;
export type UpdateTaxMutationFn = Apollo.MutationFunction<UpdateTaxMutation, UpdateTaxMutationVariables>;

/**
 * __useUpdateTaxMutation__
 *
 * To run a mutation, you first call `useUpdateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxMutation, { data, loading, error }] = useUpdateTaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxMutation, UpdateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxMutation, UpdateTaxMutationVariables>(UpdateTaxDocument, options);
      }
export type UpdateTaxMutationHookResult = ReturnType<typeof useUpdateTaxMutation>;
export type UpdateTaxMutationResult = Apollo.MutationResult<UpdateTaxMutation>;
export type UpdateTaxMutationOptions = Apollo.BaseMutationOptions<UpdateTaxMutation, UpdateTaxMutationVariables>;
export const ToggleTaxDocument = gql`
    mutation toggleTax($id: String!) {
  toggleTax(id: $id)
}
    `;
export type ToggleTaxMutationFn = Apollo.MutationFunction<ToggleTaxMutation, ToggleTaxMutationVariables>;

/**
 * __useToggleTaxMutation__
 *
 * To run a mutation, you first call `useToggleTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaxMutation, { data, loading, error }] = useToggleTaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleTaxMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTaxMutation, ToggleTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTaxMutation, ToggleTaxMutationVariables>(ToggleTaxDocument, options);
      }
export type ToggleTaxMutationHookResult = ReturnType<typeof useToggleTaxMutation>;
export type ToggleTaxMutationResult = Apollo.MutationResult<ToggleTaxMutation>;
export type ToggleTaxMutationOptions = Apollo.BaseMutationOptions<ToggleTaxMutation, ToggleTaxMutationVariables>;
export const RemoveTaxesDocument = gql`
    mutation removeTaxes($data: DeleteRecordsInput!) {
  removeTaxes(input: $data)
}
    `;
export type RemoveTaxesMutationFn = Apollo.MutationFunction<RemoveTaxesMutation, RemoveTaxesMutationVariables>;

/**
 * __useRemoveTaxesMutation__
 *
 * To run a mutation, you first call `useRemoveTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaxesMutation, { data, loading, error }] = useRemoveTaxesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveTaxesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaxesMutation, RemoveTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaxesMutation, RemoveTaxesMutationVariables>(RemoveTaxesDocument, options);
      }
export type RemoveTaxesMutationHookResult = ReturnType<typeof useRemoveTaxesMutation>;
export type RemoveTaxesMutationResult = Apollo.MutationResult<RemoveTaxesMutation>;
export type RemoveTaxesMutationOptions = Apollo.BaseMutationOptions<RemoveTaxesMutation, RemoveTaxesMutationVariables>;
export const GetTaxesTableDocument = gql`
    query getTaxesTable($active: Boolean, $search: String) {
  getTaxes(active: $active, search: $search) {
    ...TaxCoreFields
    index
    active
    amount
    propertyId
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaxesTableQuery__
 *
 * To run a query within a React component, call `useGetTaxesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxesTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTaxesTableQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxesTableQuery, GetTaxesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxesTableQuery, GetTaxesTableQueryVariables>(GetTaxesTableDocument, options);
      }
export function useGetTaxesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxesTableQuery, GetTaxesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxesTableQuery, GetTaxesTableQueryVariables>(GetTaxesTableDocument, options);
        }
export type GetTaxesTableQueryHookResult = ReturnType<typeof useGetTaxesTableQuery>;
export type GetTaxesTableLazyQueryHookResult = ReturnType<typeof useGetTaxesTableLazyQuery>;
export type GetTaxesTableQueryResult = Apollo.QueryResult<GetTaxesTableQuery, GetTaxesTableQueryVariables>;
export const GetTaxesDropdownDocument = gql`
    query getTaxesDropdown($active: Boolean, $search: String, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getTaxes(active: $active, search: $search) {
    ...TaxCoreFields
    active
    amount
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaxesDropdownQuery__
 *
 * To run a query within a React component, call `useGetTaxesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxesDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetTaxesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>(GetTaxesDropdownDocument, options);
      }
export function useGetTaxesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>(GetTaxesDropdownDocument, options);
        }
export type GetTaxesDropdownQueryHookResult = ReturnType<typeof useGetTaxesDropdownQuery>;
export type GetTaxesDropdownLazyQueryHookResult = ReturnType<typeof useGetTaxesDropdownLazyQuery>;
export type GetTaxesDropdownQueryResult = Apollo.QueryResult<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>;
export const GetTaxDocument = gql`
    query getTax($id: String!) {
  getTax(id: $id) {
    ...TaxFields
  }
}
    ${TaxFieldsFragmentDoc}`;

/**
 * __useGetTaxQuery__
 *
 * To run a query within a React component, call `useGetTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaxQuery(baseOptions: Apollo.QueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
      }
export function useGetTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
export type GetTaxQueryHookResult = ReturnType<typeof useGetTaxQuery>;
export type GetTaxLazyQueryHookResult = ReturnType<typeof useGetTaxLazyQuery>;
export type GetTaxQueryResult = Apollo.QueryResult<GetTaxQuery, GetTaxQueryVariables>;
export const UploadFilesDocument = gql`
    mutation uploadFiles($files: [Upload!]!, $save: Boolean) {
  uploadFiles(files: $files, save: $save) {
    name
    size
    url
  }
}
    `;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *      save: // value for 'save'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const CreateUserPaymentMethodDocument = gql`
    mutation createUserPaymentMethod($userId: String!, $paymentMethod: PaymentMethodTypeEnum!) {
  createUserPaymentMethod(userId: $userId, paymentMethod: $paymentMethod) {
    clientSecret
  }
}
    `;
export type CreateUserPaymentMethodMutationFn = Apollo.MutationFunction<CreateUserPaymentMethodMutation, CreateUserPaymentMethodMutationVariables>;

/**
 * __useCreateUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPaymentMethodMutation, { data, loading, error }] = useCreateUserPaymentMethodMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useCreateUserPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPaymentMethodMutation, CreateUserPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserPaymentMethodMutation, CreateUserPaymentMethodMutationVariables>(CreateUserPaymentMethodDocument, options);
      }
export type CreateUserPaymentMethodMutationHookResult = ReturnType<typeof useCreateUserPaymentMethodMutation>;
export type CreateUserPaymentMethodMutationResult = Apollo.MutationResult<CreateUserPaymentMethodMutation>;
export type CreateUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateUserPaymentMethodMutation, CreateUserPaymentMethodMutationVariables>;
export const SaveUserVerificationPaymentMethodDocument = gql`
    mutation saveUserVerificationPaymentMethod($data: UserVerificationPaymentMethodInput!) {
  saveUserVerificationPaymentMethod(input: $data)
}
    `;
export type SaveUserVerificationPaymentMethodMutationFn = Apollo.MutationFunction<SaveUserVerificationPaymentMethodMutation, SaveUserVerificationPaymentMethodMutationVariables>;

/**
 * __useSaveUserVerificationPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSaveUserVerificationPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserVerificationPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserVerificationPaymentMethodMutation, { data, loading, error }] = useSaveUserVerificationPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveUserVerificationPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserVerificationPaymentMethodMutation, SaveUserVerificationPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserVerificationPaymentMethodMutation, SaveUserVerificationPaymentMethodMutationVariables>(SaveUserVerificationPaymentMethodDocument, options);
      }
export type SaveUserVerificationPaymentMethodMutationHookResult = ReturnType<typeof useSaveUserVerificationPaymentMethodMutation>;
export type SaveUserVerificationPaymentMethodMutationResult = Apollo.MutationResult<SaveUserVerificationPaymentMethodMutation>;
export type SaveUserVerificationPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SaveUserVerificationPaymentMethodMutation, SaveUserVerificationPaymentMethodMutationVariables>;
export const SetUserDefaultPaymentMethodDocument = gql`
    mutation setUserDefaultPaymentMethod($data: UserPaymentMethodInput!) {
  setUserDefaultPaymentMethod(input: $data)
}
    `;
export type SetUserDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetUserDefaultPaymentMethodMutation, SetUserDefaultPaymentMethodMutationVariables>;

/**
 * __useSetUserDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetUserDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDefaultPaymentMethodMutation, { data, loading, error }] = useSetUserDefaultPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDefaultPaymentMethodMutation, SetUserDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserDefaultPaymentMethodMutation, SetUserDefaultPaymentMethodMutationVariables>(SetUserDefaultPaymentMethodDocument, options);
      }
export type SetUserDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetUserDefaultPaymentMethodMutation>;
export type SetUserDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetUserDefaultPaymentMethodMutation>;
export type SetUserDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetUserDefaultPaymentMethodMutation, SetUserDefaultPaymentMethodMutationVariables>;
export const RemoveUserPaymentMethodDocument = gql`
    mutation removeUserPaymentMethod($data: UserPaymentMethodInput!) {
  removeUserPaymentMethod(input: $data)
}
    `;
export type RemoveUserPaymentMethodMutationFn = Apollo.MutationFunction<RemoveUserPaymentMethodMutation, RemoveUserPaymentMethodMutationVariables>;

/**
 * __useRemoveUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserPaymentMethodMutation, { data, loading, error }] = useRemoveUserPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveUserPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserPaymentMethodMutation, RemoveUserPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserPaymentMethodMutation, RemoveUserPaymentMethodMutationVariables>(RemoveUserPaymentMethodDocument, options);
      }
export type RemoveUserPaymentMethodMutationHookResult = ReturnType<typeof useRemoveUserPaymentMethodMutation>;
export type RemoveUserPaymentMethodMutationResult = Apollo.MutationResult<RemoveUserPaymentMethodMutation>;
export type RemoveUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemoveUserPaymentMethodMutation, RemoveUserPaymentMethodMutationVariables>;
export const GetUserPaymentMethodsDocument = gql`
    query getUserPaymentMethods($userId: String!) {
  getUserPaymentMethods(userId: $userId) {
    ...UserPaymentMethodFields
  }
}
    ${UserPaymentMethodFieldsFragmentDoc}`;

/**
 * __useGetUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPaymentMethodsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPaymentMethodsQuery, GetUserPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPaymentMethodsQuery, GetUserPaymentMethodsQueryVariables>(GetUserPaymentMethodsDocument, options);
      }
export function useGetUserPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPaymentMethodsQuery, GetUserPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPaymentMethodsQuery, GetUserPaymentMethodsQueryVariables>(GetUserPaymentMethodsDocument, options);
        }
export type GetUserPaymentMethodsQueryHookResult = ReturnType<typeof useGetUserPaymentMethodsQuery>;
export type GetUserPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetUserPaymentMethodsLazyQuery>;
export type GetUserPaymentMethodsQueryResult = Apollo.QueryResult<GetUserPaymentMethodsQuery, GetUserPaymentMethodsQueryVariables>;
export const SaveUserWidgetDocument = gql`
    mutation saveUserWidget($data: UserDashboardWidgetInput!) {
  saveUserWidget(input: $data) {
    id
  }
}
    `;
export type SaveUserWidgetMutationFn = Apollo.MutationFunction<SaveUserWidgetMutation, SaveUserWidgetMutationVariables>;

/**
 * __useSaveUserWidgetMutation__
 *
 * To run a mutation, you first call `useSaveUserWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserWidgetMutation, { data, loading, error }] = useSaveUserWidgetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveUserWidgetMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserWidgetMutation, SaveUserWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserWidgetMutation, SaveUserWidgetMutationVariables>(SaveUserWidgetDocument, options);
      }
export type SaveUserWidgetMutationHookResult = ReturnType<typeof useSaveUserWidgetMutation>;
export type SaveUserWidgetMutationResult = Apollo.MutationResult<SaveUserWidgetMutation>;
export type SaveUserWidgetMutationOptions = Apollo.BaseMutationOptions<SaveUserWidgetMutation, SaveUserWidgetMutationVariables>;
export const UpdateUserWidgetsLayoutDocument = gql`
    mutation updateUserWidgetsLayout($data: [UpdateUserDashboardWidgetInput!]!) {
  updateUserWidgetsLayout(input: $data)
}
    `;
export type UpdateUserWidgetsLayoutMutationFn = Apollo.MutationFunction<UpdateUserWidgetsLayoutMutation, UpdateUserWidgetsLayoutMutationVariables>;

/**
 * __useUpdateUserWidgetsLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateUserWidgetsLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserWidgetsLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserWidgetsLayoutMutation, { data, loading, error }] = useUpdateUserWidgetsLayoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserWidgetsLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserWidgetsLayoutMutation, UpdateUserWidgetsLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserWidgetsLayoutMutation, UpdateUserWidgetsLayoutMutationVariables>(UpdateUserWidgetsLayoutDocument, options);
      }
export type UpdateUserWidgetsLayoutMutationHookResult = ReturnType<typeof useUpdateUserWidgetsLayoutMutation>;
export type UpdateUserWidgetsLayoutMutationResult = Apollo.MutationResult<UpdateUserWidgetsLayoutMutation>;
export type UpdateUserWidgetsLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateUserWidgetsLayoutMutation, UpdateUserWidgetsLayoutMutationVariables>;
export const RemoveUserWidgetDocument = gql`
    mutation removeUserWidget($id: String!) {
  removeUserWidget(id: $id)
}
    `;
export type RemoveUserWidgetMutationFn = Apollo.MutationFunction<RemoveUserWidgetMutation, RemoveUserWidgetMutationVariables>;

/**
 * __useRemoveUserWidgetMutation__
 *
 * To run a mutation, you first call `useRemoveUserWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserWidgetMutation, { data, loading, error }] = useRemoveUserWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserWidgetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserWidgetMutation, RemoveUserWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserWidgetMutation, RemoveUserWidgetMutationVariables>(RemoveUserWidgetDocument, options);
      }
export type RemoveUserWidgetMutationHookResult = ReturnType<typeof useRemoveUserWidgetMutation>;
export type RemoveUserWidgetMutationResult = Apollo.MutationResult<RemoveUserWidgetMutation>;
export type RemoveUserWidgetMutationOptions = Apollo.BaseMutationOptions<RemoveUserWidgetMutation, RemoveUserWidgetMutationVariables>;
export const GetUserAvailableWidgetsDocument = gql`
    query getUserAvailableWidgets {
  getUserAvailableWidgets {
    type
    title
    icon
  }
}
    `;

/**
 * __useGetUserAvailableWidgetsQuery__
 *
 * To run a query within a React component, call `useGetUserAvailableWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAvailableWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAvailableWidgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAvailableWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAvailableWidgetsQuery, GetUserAvailableWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAvailableWidgetsQuery, GetUserAvailableWidgetsQueryVariables>(GetUserAvailableWidgetsDocument, options);
      }
export function useGetUserAvailableWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAvailableWidgetsQuery, GetUserAvailableWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAvailableWidgetsQuery, GetUserAvailableWidgetsQueryVariables>(GetUserAvailableWidgetsDocument, options);
        }
export type GetUserAvailableWidgetsQueryHookResult = ReturnType<typeof useGetUserAvailableWidgetsQuery>;
export type GetUserAvailableWidgetsLazyQueryHookResult = ReturnType<typeof useGetUserAvailableWidgetsLazyQuery>;
export type GetUserAvailableWidgetsQueryResult = Apollo.QueryResult<GetUserAvailableWidgetsQuery, GetUserAvailableWidgetsQueryVariables>;
export const GetUserWidgetsDocument = gql`
    query getUserWidgets {
  getUserWidgets {
    ...UserWidgetFields
  }
}
    ${UserWidgetFieldsFragmentDoc}`;

/**
 * __useGetUserWidgetsQuery__
 *
 * To run a query within a React component, call `useGetUserWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWidgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWidgetsQuery, GetUserWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWidgetsQuery, GetUserWidgetsQueryVariables>(GetUserWidgetsDocument, options);
      }
export function useGetUserWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWidgetsQuery, GetUserWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWidgetsQuery, GetUserWidgetsQueryVariables>(GetUserWidgetsDocument, options);
        }
export type GetUserWidgetsQueryHookResult = ReturnType<typeof useGetUserWidgetsQuery>;
export type GetUserWidgetsLazyQueryHookResult = ReturnType<typeof useGetUserWidgetsLazyQuery>;
export type GetUserWidgetsQueryResult = Apollo.QueryResult<GetUserWidgetsQuery, GetUserWidgetsQueryVariables>;
export const GetUserWidgetContentDocument = gql`
    query getUserWidgetContent($id: String!) {
  getUserWidgetContent(id: $id) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      title
      status {
        title
        color
      }
      additionalData {
        key
        title
        html
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetUserWidgetContentQuery__
 *
 * To run a query within a React component, call `useGetUserWidgetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWidgetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWidgetContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserWidgetContentQuery(baseOptions: Apollo.QueryHookOptions<GetUserWidgetContentQuery, GetUserWidgetContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWidgetContentQuery, GetUserWidgetContentQueryVariables>(GetUserWidgetContentDocument, options);
      }
export function useGetUserWidgetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWidgetContentQuery, GetUserWidgetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWidgetContentQuery, GetUserWidgetContentQueryVariables>(GetUserWidgetContentDocument, options);
        }
export type GetUserWidgetContentQueryHookResult = ReturnType<typeof useGetUserWidgetContentQuery>;
export type GetUserWidgetContentLazyQueryHookResult = ReturnType<typeof useGetUserWidgetContentLazyQuery>;
export type GetUserWidgetContentQueryResult = Apollo.QueryResult<GetUserWidgetContentQuery, GetUserWidgetContentQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($data: UserPropertyCreateInput!) {
  createUser(input: $data) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const AddUserToPropertyDocument = gql`
    mutation addUserToProperty($data: UserPropertyAddInput!) {
  addUserToProperty(input: $data) {
    id
  }
}
    `;
export type AddUserToPropertyMutationFn = Apollo.MutationFunction<AddUserToPropertyMutation, AddUserToPropertyMutationVariables>;

/**
 * __useAddUserToPropertyMutation__
 *
 * To run a mutation, you first call `useAddUserToPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToPropertyMutation, { data, loading, error }] = useAddUserToPropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserToPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToPropertyMutation, AddUserToPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToPropertyMutation, AddUserToPropertyMutationVariables>(AddUserToPropertyDocument, options);
      }
export type AddUserToPropertyMutationHookResult = ReturnType<typeof useAddUserToPropertyMutation>;
export type AddUserToPropertyMutationResult = Apollo.MutationResult<AddUserToPropertyMutation>;
export type AddUserToPropertyMutationOptions = Apollo.BaseMutationOptions<AddUserToPropertyMutation, AddUserToPropertyMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: String!, $data: UserPropertyUpdateInput!) {
  updateUser(userId: $id, input: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserPhotoDocument = gql`
    mutation updateUserPhoto($id: String!, $photo: FileObjectInput) {
  updateUserPhoto(userId: $id, photo: $photo) {
    id
    photo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type UpdateUserPhotoMutationFn = Apollo.MutationFunction<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>;

/**
 * __useUpdateUserPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhotoMutation, { data, loading, error }] = useUpdateUserPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateUserPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>(UpdateUserPhotoDocument, options);
      }
export type UpdateUserPhotoMutationHookResult = ReturnType<typeof useUpdateUserPhotoMutation>;
export type UpdateUserPhotoMutationResult = Apollo.MutationResult<UpdateUserPhotoMutation>;
export type UpdateUserPhotoMutationOptions = Apollo.BaseMutationOptions<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>;
export const BulkStatusUserDocument = gql`
    mutation bulkStatusUser($ids: [String!]!, $status: UserStatuses) {
  bulkStatusUser(ids: $ids, status: $status) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status
    }
  }
}
    `;
export type BulkStatusUserMutationFn = Apollo.MutationFunction<BulkStatusUserMutation, BulkStatusUserMutationVariables>;

/**
 * __useBulkStatusUserMutation__
 *
 * To run a mutation, you first call `useBulkStatusUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusUserMutation, { data, loading, error }] = useBulkStatusUserMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkStatusUserMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusUserMutation, BulkStatusUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusUserMutation, BulkStatusUserMutationVariables>(BulkStatusUserDocument, options);
      }
export type BulkStatusUserMutationHookResult = ReturnType<typeof useBulkStatusUserMutation>;
export type BulkStatusUserMutationResult = Apollo.MutationResult<BulkStatusUserMutation>;
export type BulkStatusUserMutationOptions = Apollo.BaseMutationOptions<BulkStatusUserMutation, BulkStatusUserMutationVariables>;
export const UpdateUserPrinterDocument = gql`
    mutation updateUserPrinter($id: String!, $printerId: String) {
  updateUserPrinter(userId: $id, printerId: $printerId) {
    id
    printer {
      ...PrinterCoreFields
    }
  }
}
    ${PrinterCoreFieldsFragmentDoc}`;
export type UpdateUserPrinterMutationFn = Apollo.MutationFunction<UpdateUserPrinterMutation, UpdateUserPrinterMutationVariables>;

/**
 * __useUpdateUserPrinterMutation__
 *
 * To run a mutation, you first call `useUpdateUserPrinterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPrinterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPrinterMutation, { data, loading, error }] = useUpdateUserPrinterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      printerId: // value for 'printerId'
 *   },
 * });
 */
export function useUpdateUserPrinterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPrinterMutation, UpdateUserPrinterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPrinterMutation, UpdateUserPrinterMutationVariables>(UpdateUserPrinterDocument, options);
      }
export type UpdateUserPrinterMutationHookResult = ReturnType<typeof useUpdateUserPrinterMutation>;
export type UpdateUserPrinterMutationResult = Apollo.MutationResult<UpdateUserPrinterMutation>;
export type UpdateUserPrinterMutationOptions = Apollo.BaseMutationOptions<UpdateUserPrinterMutation, UpdateUserPrinterMutationVariables>;
export const UpdateUserPreferenceDocument = gql`
    mutation updateUserPreference($data: UserPropertyPreferenceInput!) {
  updateUserPreference(input: $data) {
    homepageId
    printer {
      ...PrinterCoreFields
    }
  }
}
    ${PrinterCoreFieldsFragmentDoc}`;
export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
      }
export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;
export const ToggleLoginAuthDocument = gql`
    mutation toggleLoginAuth($data: ToggleLoginAuthInput!) {
  toggleLoginAuth(input: $data)
}
    `;
export type ToggleLoginAuthMutationFn = Apollo.MutationFunction<ToggleLoginAuthMutation, ToggleLoginAuthMutationVariables>;

/**
 * __useToggleLoginAuthMutation__
 *
 * To run a mutation, you first call `useToggleLoginAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLoginAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLoginAuthMutation, { data, loading, error }] = useToggleLoginAuthMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleLoginAuthMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLoginAuthMutation, ToggleLoginAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLoginAuthMutation, ToggleLoginAuthMutationVariables>(ToggleLoginAuthDocument, options);
      }
export type ToggleLoginAuthMutationHookResult = ReturnType<typeof useToggleLoginAuthMutation>;
export type ToggleLoginAuthMutationResult = Apollo.MutationResult<ToggleLoginAuthMutation>;
export type ToggleLoginAuthMutationOptions = Apollo.BaseMutationOptions<ToggleLoginAuthMutation, ToggleLoginAuthMutationVariables>;
export const VerifyPhoneDocument = gql`
    mutation verifyPhone($data: VerifyPhoneInput!) {
  verifyPhone(input: $data)
}
    `;
export type VerifyPhoneMutationFn = Apollo.MutationFunction<VerifyPhoneMutation, VerifyPhoneMutationVariables>;

/**
 * __useVerifyPhoneMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneMutation, { data, loading, error }] = useVerifyPhoneMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerifyPhoneMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneMutation, VerifyPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneMutation, VerifyPhoneMutationVariables>(VerifyPhoneDocument, options);
      }
export type VerifyPhoneMutationHookResult = ReturnType<typeof useVerifyPhoneMutation>;
export type VerifyPhoneMutationResult = Apollo.MutationResult<VerifyPhoneMutation>;
export type VerifyPhoneMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneMutation, VerifyPhoneMutationVariables>;
export const UpdateUserPhoneDocument = gql`
    mutation updateUserPhone($data: UpdateUserPhoneInput!) {
  updateUserPhone(input: $data)
}
    `;
export type UpdateUserPhoneMutationFn = Apollo.MutationFunction<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;

/**
 * __useUpdateUserPhoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhoneMutation, { data, loading, error }] = useUpdateUserPhoneMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserPhoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>(UpdateUserPhoneDocument, options);
      }
export type UpdateUserPhoneMutationHookResult = ReturnType<typeof useUpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationResult = Apollo.MutationResult<UpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;
export const RemoveUserPhoneDocument = gql`
    mutation removeUserPhone($userId: String!) {
  removeUserPhone(userId: $userId)
}
    `;
export type RemoveUserPhoneMutationFn = Apollo.MutationFunction<RemoveUserPhoneMutation, RemoveUserPhoneMutationVariables>;

/**
 * __useRemoveUserPhoneMutation__
 *
 * To run a mutation, you first call `useRemoveUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserPhoneMutation, { data, loading, error }] = useRemoveUserPhoneMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserPhoneMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserPhoneMutation, RemoveUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserPhoneMutation, RemoveUserPhoneMutationVariables>(RemoveUserPhoneDocument, options);
      }
export type RemoveUserPhoneMutationHookResult = ReturnType<typeof useRemoveUserPhoneMutation>;
export type RemoveUserPhoneMutationResult = Apollo.MutationResult<RemoveUserPhoneMutation>;
export type RemoveUserPhoneMutationOptions = Apollo.BaseMutationOptions<RemoveUserPhoneMutation, RemoveUserPhoneMutationVariables>;
export const ToggleMyNotificationDocument = gql`
    mutation toggleMyNotification($toggleType: EmailToggleEnum!, $type: EmailTemplateType!) {
  toggleMyNotification(toggleType: $toggleType, type: $type)
}
    `;
export type ToggleMyNotificationMutationFn = Apollo.MutationFunction<ToggleMyNotificationMutation, ToggleMyNotificationMutationVariables>;

/**
 * __useToggleMyNotificationMutation__
 *
 * To run a mutation, you first call `useToggleMyNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMyNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMyNotificationMutation, { data, loading, error }] = useToggleMyNotificationMutation({
 *   variables: {
 *      toggleType: // value for 'toggleType'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useToggleMyNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMyNotificationMutation, ToggleMyNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMyNotificationMutation, ToggleMyNotificationMutationVariables>(ToggleMyNotificationDocument, options);
      }
export type ToggleMyNotificationMutationHookResult = ReturnType<typeof useToggleMyNotificationMutation>;
export type ToggleMyNotificationMutationResult = Apollo.MutationResult<ToggleMyNotificationMutation>;
export type ToggleMyNotificationMutationOptions = Apollo.BaseMutationOptions<ToggleMyNotificationMutation, ToggleMyNotificationMutationVariables>;
export const ResendWelcomeEmailDocument = gql`
    mutation resendWelcomeEmail($userIds: [String!]!) {
  resendWelcomeEmail(userIds: $userIds)
}
    `;
export type ResendWelcomeEmailMutationFn = Apollo.MutationFunction<ResendWelcomeEmailMutation, ResendWelcomeEmailMutationVariables>;

/**
 * __useResendWelcomeEmailMutation__
 *
 * To run a mutation, you first call `useResendWelcomeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWelcomeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWelcomeEmailMutation, { data, loading, error }] = useResendWelcomeEmailMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useResendWelcomeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendWelcomeEmailMutation, ResendWelcomeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendWelcomeEmailMutation, ResendWelcomeEmailMutationVariables>(ResendWelcomeEmailDocument, options);
      }
export type ResendWelcomeEmailMutationHookResult = ReturnType<typeof useResendWelcomeEmailMutation>;
export type ResendWelcomeEmailMutationResult = Apollo.MutationResult<ResendWelcomeEmailMutation>;
export type ResendWelcomeEmailMutationOptions = Apollo.BaseMutationOptions<ResendWelcomeEmailMutation, ResendWelcomeEmailMutationVariables>;
export const MeDocument = gql`
    query me($portfolioId: String!) {
  me(portfolioId: $portfolioId) {
    ...LoggedInUserFields
  }
}
    ${LoggedInUserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useMeQuery(baseOptions: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetUsersTableDocument = gql`
    query getUsersTable($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $status: UserStatuses, $search: String, $roleIds: [String!], $buildingIds: [String!], $primaryBuildingId: String, $fullAccessBuildingUsers: UserFullAccessEnum = INCLUDE, $companyIds: [String!], $primaryCompanyId: String, $fullAccessCompanyUsers: UserFullAccessEnum = INCLUDE, $sortBy: SortUserFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC, $orderByIds: [String!]) {
  getUsers(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    status: $status
    roleIds: $roleIds
    buildingIds: $buildingIds
    primaryBuildingId: $primaryBuildingId
    fullAccessBuildingUsers: $fullAccessBuildingUsers
    companyIds: $companyIds
    primaryCompanyId: $primaryCompanyId
    fullAccessCompanyUsers: $fullAccessCompanyUsers
    sortBy: $sortBy
    sortByDir: $sortByDir
    orderByIds: $orderByIds
  ) @connection(key: "getUsersTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...UserCoreFields
      index
      buildings {
        ...BuildingCoreFields
      }
      role {
        ...RoleCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}`;

/**
 * __useGetUsersTableQuery__
 *
 * To run a query within a React component, call `useGetUsersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersTableQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      roleIds: // value for 'roleIds'
 *      buildingIds: // value for 'buildingIds'
 *      primaryBuildingId: // value for 'primaryBuildingId'
 *      fullAccessBuildingUsers: // value for 'fullAccessBuildingUsers'
 *      companyIds: // value for 'companyIds'
 *      primaryCompanyId: // value for 'primaryCompanyId'
 *      fullAccessCompanyUsers: // value for 'fullAccessCompanyUsers'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *      orderByIds: // value for 'orderByIds'
 *   },
 * });
 */
export function useGetUsersTableQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersTableQuery, GetUsersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersTableQuery, GetUsersTableQueryVariables>(GetUsersTableDocument, options);
      }
export function useGetUsersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersTableQuery, GetUsersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersTableQuery, GetUsersTableQueryVariables>(GetUsersTableDocument, options);
        }
export type GetUsersTableQueryHookResult = ReturnType<typeof useGetUsersTableQuery>;
export type GetUsersTableLazyQueryHookResult = ReturnType<typeof useGetUsersTableLazyQuery>;
export type GetUsersTableQueryResult = Apollo.QueryResult<GetUsersTableQuery, GetUsersTableQueryVariables>;
export const GetUsersDropdownDocument = gql`
    query getUsersDropdown($admin: Boolean = false, $take: Int! = 10, $after: String, $before: String, $status: UserStatuses, $search: String, $roleIds: [String!], $buildingIds: [String!], $primaryBuildingId: String, $fullAccessBuildingUsers: UserFullAccessEnum = INCLUDE, $companyIds: [String!], $primaryCompanyId: String, $fullAccessCompanyUsers: UserFullAccessEnum! = INCLUDE, $sortBy: SortUserFieldEnum! = FIRST_NAME, $sortByDir: SortDirectionEnum! = ASC, $orderByIds: [String!]) {
  getUsers(
    admin: $admin
    take: $take
    after: $after
    before: $before
    search: $search
    status: $status
    roleIds: $roleIds
    buildingIds: $buildingIds
    primaryBuildingId: $primaryBuildingId
    fullAccessBuildingUsers: $fullAccessBuildingUsers
    companyIds: $companyIds
    primaryCompanyId: $primaryCompanyId
    fullAccessCompanyUsers: $fullAccessCompanyUsers
    sortBy: $sortBy
    sortByDir: $sortByDir
    orderByIds: $orderByIds
  ) @connection(key: "getUsersDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...UserCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetUsersDropdownQuery__
 *
 * To run a query within a React component, call `useGetUsersDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDropdownQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      roleIds: // value for 'roleIds'
 *      buildingIds: // value for 'buildingIds'
 *      primaryBuildingId: // value for 'primaryBuildingId'
 *      fullAccessBuildingUsers: // value for 'fullAccessBuildingUsers'
 *      companyIds: // value for 'companyIds'
 *      primaryCompanyId: // value for 'primaryCompanyId'
 *      fullAccessCompanyUsers: // value for 'fullAccessCompanyUsers'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *      orderByIds: // value for 'orderByIds'
 *   },
 * });
 */
export function useGetUsersDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>(GetUsersDropdownDocument, options);
      }
export function useGetUsersDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>(GetUsersDropdownDocument, options);
        }
export type GetUsersDropdownQueryHookResult = ReturnType<typeof useGetUsersDropdownQuery>;
export type GetUsersDropdownLazyQueryHookResult = ReturnType<typeof useGetUsersDropdownLazyQuery>;
export type GetUsersDropdownQueryResult = Apollo.QueryResult<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: String!) {
  getUser(userId: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ValidateUserEmailDocument = gql`
    query validateUserEmail($email: String!) {
  validateUserEmail(email: $email) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useValidateUserEmailQuery__
 *
 * To run a query within a React component, call `useValidateUserEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateUserEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateUserEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateUserEmailQuery(baseOptions: Apollo.QueryHookOptions<ValidateUserEmailQuery, ValidateUserEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateUserEmailQuery, ValidateUserEmailQueryVariables>(ValidateUserEmailDocument, options);
      }
export function useValidateUserEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateUserEmailQuery, ValidateUserEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateUserEmailQuery, ValidateUserEmailQueryVariables>(ValidateUserEmailDocument, options);
        }
export type ValidateUserEmailQueryHookResult = ReturnType<typeof useValidateUserEmailQuery>;
export type ValidateUserEmailLazyQueryHookResult = ReturnType<typeof useValidateUserEmailLazyQuery>;
export type ValidateUserEmailQueryResult = Apollo.QueryResult<ValidateUserEmailQuery, ValidateUserEmailQueryVariables>;
export const CheckUserPermissionsDocument = gql`
    query checkUserPermissions($data: UserCheckPermissionsInput!) {
  checkUserPermissions(input: $data)
}
    `;

/**
 * __useCheckUserPermissionsQuery__
 *
 * To run a query within a React component, call `useCheckUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserPermissionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>(CheckUserPermissionsDocument, options);
      }
export function useCheckUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>(CheckUserPermissionsDocument, options);
        }
export type CheckUserPermissionsQueryHookResult = ReturnType<typeof useCheckUserPermissionsQuery>;
export type CheckUserPermissionsLazyQueryHookResult = ReturnType<typeof useCheckUserPermissionsLazyQuery>;
export type CheckUserPermissionsQueryResult = Apollo.QueryResult<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>;
export const GetMyNotificationsSettingsDocument = gql`
    query getMyNotificationsSettings($search: String) {
  getMyNotificationsSettings(search: $search) {
    trigger
    type
    category
    appActive
    appUserActive
    emailActive
    emailUserActive
    smsActive
    smsUserActive
  }
}
    `;

/**
 * __useGetMyNotificationsSettingsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsSettingsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMyNotificationsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsSettingsQuery, GetMyNotificationsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsSettingsQuery, GetMyNotificationsSettingsQueryVariables>(GetMyNotificationsSettingsDocument, options);
      }
export function useGetMyNotificationsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsSettingsQuery, GetMyNotificationsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsSettingsQuery, GetMyNotificationsSettingsQueryVariables>(GetMyNotificationsSettingsDocument, options);
        }
export type GetMyNotificationsSettingsQueryHookResult = ReturnType<typeof useGetMyNotificationsSettingsQuery>;
export type GetMyNotificationsSettingsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsSettingsLazyQuery>;
export type GetMyNotificationsSettingsQueryResult = Apollo.QueryResult<GetMyNotificationsSettingsQuery, GetMyNotificationsSettingsQueryVariables>;
export const ExportUsersDocument = gql`
    query exportUsers($admin: Boolean = false, $status: UserStatuses, $search: String, $roleIds: [String!], $buildingIds: [String!], $primaryBuildingId: String, $fullAccessBuildingUsers: UserFullAccessEnum = INCLUDE, $companyIds: [String!], $primaryCompanyId: String, $fullAccessCompanyUsers: UserFullAccessEnum = INCLUDE, $sortBy: SortUserFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  exportUsers(
    admin: $admin
    search: $search
    status: $status
    roleIds: $roleIds
    buildingIds: $buildingIds
    primaryBuildingId: $primaryBuildingId
    fullAccessBuildingUsers: $fullAccessBuildingUsers
    companyIds: $companyIds
    primaryCompanyId: $primaryCompanyId
    fullAccessCompanyUsers: $fullAccessCompanyUsers
    sortBy: $sortBy
    sortByDir: $sortByDir
  )
}
    `;

/**
 * __useExportUsersQuery__
 *
 * To run a query within a React component, call `useExportUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportUsersQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      roleIds: // value for 'roleIds'
 *      buildingIds: // value for 'buildingIds'
 *      primaryBuildingId: // value for 'primaryBuildingId'
 *      fullAccessBuildingUsers: // value for 'fullAccessBuildingUsers'
 *      companyIds: // value for 'companyIds'
 *      primaryCompanyId: // value for 'primaryCompanyId'
 *      fullAccessCompanyUsers: // value for 'fullAccessCompanyUsers'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useExportUsersQuery(baseOptions?: Apollo.QueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportUsersQuery, ExportUsersQueryVariables>(ExportUsersDocument, options);
      }
export function useExportUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportUsersQuery, ExportUsersQueryVariables>(ExportUsersDocument, options);
        }
export type ExportUsersQueryHookResult = ReturnType<typeof useExportUsersQuery>;
export type ExportUsersLazyQueryHookResult = ReturnType<typeof useExportUsersLazyQuery>;
export type ExportUsersQueryResult = Apollo.QueryResult<ExportUsersQuery, ExportUsersQueryVariables>;
export const StoreVendorAccessDocument = gql`
    mutation storeVendorAccess($data: StoreVendorAccessInput!) {
  storeVendorAccess(input: $data)
}
    `;
export type StoreVendorAccessMutationFn = Apollo.MutationFunction<StoreVendorAccessMutation, StoreVendorAccessMutationVariables>;

/**
 * __useStoreVendorAccessMutation__
 *
 * To run a mutation, you first call `useStoreVendorAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreVendorAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeVendorAccessMutation, { data, loading, error }] = useStoreVendorAccessMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStoreVendorAccessMutation(baseOptions?: Apollo.MutationHookOptions<StoreVendorAccessMutation, StoreVendorAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreVendorAccessMutation, StoreVendorAccessMutationVariables>(StoreVendorAccessDocument, options);
      }
export type StoreVendorAccessMutationHookResult = ReturnType<typeof useStoreVendorAccessMutation>;
export type StoreVendorAccessMutationResult = Apollo.MutationResult<StoreVendorAccessMutation>;
export type StoreVendorAccessMutationOptions = Apollo.BaseMutationOptions<StoreVendorAccessMutation, StoreVendorAccessMutationVariables>;
export const UpdateVendorAccessVisitDocument = gql`
    mutation updateVendorAccessVisit($id: String!, $data: UpdateVendorAccessInput!) {
  updateVendorAccessVisit(id: $id, input: $data) {
    ...VendorAccessFields
  }
}
    ${VendorAccessFieldsFragmentDoc}`;
export type UpdateVendorAccessVisitMutationFn = Apollo.MutationFunction<UpdateVendorAccessVisitMutation, UpdateVendorAccessVisitMutationVariables>;

/**
 * __useUpdateVendorAccessVisitMutation__
 *
 * To run a mutation, you first call `useUpdateVendorAccessVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorAccessVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorAccessVisitMutation, { data, loading, error }] = useUpdateVendorAccessVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateVendorAccessVisitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorAccessVisitMutation, UpdateVendorAccessVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorAccessVisitMutation, UpdateVendorAccessVisitMutationVariables>(UpdateVendorAccessVisitDocument, options);
      }
export type UpdateVendorAccessVisitMutationHookResult = ReturnType<typeof useUpdateVendorAccessVisitMutation>;
export type UpdateVendorAccessVisitMutationResult = Apollo.MutationResult<UpdateVendorAccessVisitMutation>;
export type UpdateVendorAccessVisitMutationOptions = Apollo.BaseMutationOptions<UpdateVendorAccessVisitMutation, UpdateVendorAccessVisitMutationVariables>;
export const BulkStatusVendorAccessDocument = gql`
    mutation bulkStatusVendorAccess($ids: [String!]!, $status: VendorAccessStatusEnum!) {
  bulkStatusVendorAccess(ids: $ids, status: $status) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status
    }
  }
}
    `;
export type BulkStatusVendorAccessMutationFn = Apollo.MutationFunction<BulkStatusVendorAccessMutation, BulkStatusVendorAccessMutationVariables>;

/**
 * __useBulkStatusVendorAccessMutation__
 *
 * To run a mutation, you first call `useBulkStatusVendorAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusVendorAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusVendorAccessMutation, { data, loading, error }] = useBulkStatusVendorAccessMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkStatusVendorAccessMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusVendorAccessMutation, BulkStatusVendorAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusVendorAccessMutation, BulkStatusVendorAccessMutationVariables>(BulkStatusVendorAccessDocument, options);
      }
export type BulkStatusVendorAccessMutationHookResult = ReturnType<typeof useBulkStatusVendorAccessMutation>;
export type BulkStatusVendorAccessMutationResult = Apollo.MutationResult<BulkStatusVendorAccessMutation>;
export type BulkStatusVendorAccessMutationOptions = Apollo.BaseMutationOptions<BulkStatusVendorAccessMutation, BulkStatusVendorAccessMutationVariables>;
export const VendorAccessWebCheckInDocument = gql`
    mutation vendorAccessWebCheckIn($ids: [String!]!) {
  vendorAccessWebCheckIn(ids: $ids) {
    errorCount
    errorMessages
    successCount
    data {
      id
      visit {
        id
        checkInDates
      }
    }
  }
}
    `;
export type VendorAccessWebCheckInMutationFn = Apollo.MutationFunction<VendorAccessWebCheckInMutation, VendorAccessWebCheckInMutationVariables>;

/**
 * __useVendorAccessWebCheckInMutation__
 *
 * To run a mutation, you first call `useVendorAccessWebCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorAccessWebCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorAccessWebCheckInMutation, { data, loading, error }] = useVendorAccessWebCheckInMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVendorAccessWebCheckInMutation(baseOptions?: Apollo.MutationHookOptions<VendorAccessWebCheckInMutation, VendorAccessWebCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorAccessWebCheckInMutation, VendorAccessWebCheckInMutationVariables>(VendorAccessWebCheckInDocument, options);
      }
export type VendorAccessWebCheckInMutationHookResult = ReturnType<typeof useVendorAccessWebCheckInMutation>;
export type VendorAccessWebCheckInMutationResult = Apollo.MutationResult<VendorAccessWebCheckInMutation>;
export type VendorAccessWebCheckInMutationOptions = Apollo.BaseMutationOptions<VendorAccessWebCheckInMutation, VendorAccessWebCheckInMutationVariables>;
export const PrintVendorAccessBadgeDocument = gql`
    mutation printVendorAccessBadge($ids: [String!]!) {
  printVendorAccessBadge(ids: $ids) {
    notification
    errorCount
    errorMessages
    successCount
  }
}
    `;
export type PrintVendorAccessBadgeMutationFn = Apollo.MutationFunction<PrintVendorAccessBadgeMutation, PrintVendorAccessBadgeMutationVariables>;

/**
 * __usePrintVendorAccessBadgeMutation__
 *
 * To run a mutation, you first call `usePrintVendorAccessBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintVendorAccessBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printVendorAccessBadgeMutation, { data, loading, error }] = usePrintVendorAccessBadgeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePrintVendorAccessBadgeMutation(baseOptions?: Apollo.MutationHookOptions<PrintVendorAccessBadgeMutation, PrintVendorAccessBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintVendorAccessBadgeMutation, PrintVendorAccessBadgeMutationVariables>(PrintVendorAccessBadgeDocument, options);
      }
export type PrintVendorAccessBadgeMutationHookResult = ReturnType<typeof usePrintVendorAccessBadgeMutation>;
export type PrintVendorAccessBadgeMutationResult = Apollo.MutationResult<PrintVendorAccessBadgeMutation>;
export type PrintVendorAccessBadgeMutationOptions = Apollo.BaseMutationOptions<PrintVendorAccessBadgeMutation, PrintVendorAccessBadgeMutationVariables>;
export const NotifyVendorAccessDocument = gql`
    mutation notifyVendorAccess($id: String!, $userId: String!) {
  notifyVendorAccess(id: $id, userId: $userId) {
    id
    firstName
    lastName
  }
}
    `;
export type NotifyVendorAccessMutationFn = Apollo.MutationFunction<NotifyVendorAccessMutation, NotifyVendorAccessMutationVariables>;

/**
 * __useNotifyVendorAccessMutation__
 *
 * To run a mutation, you first call `useNotifyVendorAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyVendorAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyVendorAccessMutation, { data, loading, error }] = useNotifyVendorAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotifyVendorAccessMutation(baseOptions?: Apollo.MutationHookOptions<NotifyVendorAccessMutation, NotifyVendorAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyVendorAccessMutation, NotifyVendorAccessMutationVariables>(NotifyVendorAccessDocument, options);
      }
export type NotifyVendorAccessMutationHookResult = ReturnType<typeof useNotifyVendorAccessMutation>;
export type NotifyVendorAccessMutationResult = Apollo.MutationResult<NotifyVendorAccessMutation>;
export type NotifyVendorAccessMutationOptions = Apollo.BaseMutationOptions<NotifyVendorAccessMutation, NotifyVendorAccessMutationVariables>;
export const DeleteVendorAccessAttachmentDocument = gql`
    mutation deleteVendorAccessAttachment($attachmentId: String!, $id: String!) {
  deleteVendorAccessAttachment(attachmentId: $attachmentId, id: $id)
}
    `;
export type DeleteVendorAccessAttachmentMutationFn = Apollo.MutationFunction<DeleteVendorAccessAttachmentMutation, DeleteVendorAccessAttachmentMutationVariables>;

/**
 * __useDeleteVendorAccessAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteVendorAccessAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVendorAccessAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVendorAccessAttachmentMutation, { data, loading, error }] = useDeleteVendorAccessAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVendorAccessAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVendorAccessAttachmentMutation, DeleteVendorAccessAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVendorAccessAttachmentMutation, DeleteVendorAccessAttachmentMutationVariables>(DeleteVendorAccessAttachmentDocument, options);
      }
export type DeleteVendorAccessAttachmentMutationHookResult = ReturnType<typeof useDeleteVendorAccessAttachmentMutation>;
export type DeleteVendorAccessAttachmentMutationResult = Apollo.MutationResult<DeleteVendorAccessAttachmentMutation>;
export type DeleteVendorAccessAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteVendorAccessAttachmentMutation, DeleteVendorAccessAttachmentMutationVariables>;
export const GetVendorAccessListDocument = gql`
    query getVendorAccessList($take: Int! = 10, $after: String, $before: String, $search: String, $from: DateTime, $to: DateTime, $buildingIds: [String!], $companyIds: [String!], $hostIds: [String!], $statuses: [VendorAccessStatusEnum!]) {
  getVendorAccessList(
    take: $take
    after: $after
    before: $before
    search: $search
    from: $from
    to: $to
    buildingIds: $buildingIds
    companyIds: $companyIds
    hostIds: $hostIds
    statuses: $statuses
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      code
      status
      building {
        ...BuildingCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      company {
        ...CompanyCoreFields
      }
      coi {
        ...CoiCoreFields
      }
      visit {
        ...VendorAccessVisitCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${CoiCoreFieldsFragmentDoc}
${VendorAccessVisitCoreFieldsFragmentDoc}`;

/**
 * __useGetVendorAccessListQuery__
 *
 * To run a query within a React component, call `useGetVendorAccessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAccessListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAccessListQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      buildingIds: // value for 'buildingIds'
 *      companyIds: // value for 'companyIds'
 *      hostIds: // value for 'hostIds'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetVendorAccessListQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorAccessListQuery, GetVendorAccessListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAccessListQuery, GetVendorAccessListQueryVariables>(GetVendorAccessListDocument, options);
      }
export function useGetVendorAccessListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAccessListQuery, GetVendorAccessListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAccessListQuery, GetVendorAccessListQueryVariables>(GetVendorAccessListDocument, options);
        }
export type GetVendorAccessListQueryHookResult = ReturnType<typeof useGetVendorAccessListQuery>;
export type GetVendorAccessListLazyQueryHookResult = ReturnType<typeof useGetVendorAccessListLazyQuery>;
export type GetVendorAccessListQueryResult = Apollo.QueryResult<GetVendorAccessListQuery, GetVendorAccessListQueryVariables>;
export const GetVendorAccessDocument = gql`
    query getVendorAccess($id: String!) {
  getVendorAccess(id: $id) {
    ...VendorAccessFields
  }
}
    ${VendorAccessFieldsFragmentDoc}`;

/**
 * __useGetVendorAccessQuery__
 *
 * To run a query within a React component, call `useGetVendorAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVendorAccessQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAccessQuery, GetVendorAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAccessQuery, GetVendorAccessQueryVariables>(GetVendorAccessDocument, options);
      }
export function useGetVendorAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAccessQuery, GetVendorAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAccessQuery, GetVendorAccessQueryVariables>(GetVendorAccessDocument, options);
        }
export type GetVendorAccessQueryHookResult = ReturnType<typeof useGetVendorAccessQuery>;
export type GetVendorAccessLazyQueryHookResult = ReturnType<typeof useGetVendorAccessLazyQuery>;
export type GetVendorAccessQueryResult = Apollo.QueryResult<GetVendorAccessQuery, GetVendorAccessQueryVariables>;
export const GetVendorAccessPrintDocument = gql`
    query getVendorAccessPrint($id: String!) {
  getVendorAccess(id: $id) {
    id
    code
    status
    requestedFor {
      ...UserCoreFields
    }
    company {
      ...CompanyCoreFields
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
    }
    visit {
      ...VendorAccessVisitCoreFields
    }
  }
}
    ${UserCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${VendorAccessVisitCoreFieldsFragmentDoc}`;

/**
 * __useGetVendorAccessPrintQuery__
 *
 * To run a query within a React component, call `useGetVendorAccessPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAccessPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAccessPrintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVendorAccessPrintQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAccessPrintQuery, GetVendorAccessPrintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAccessPrintQuery, GetVendorAccessPrintQueryVariables>(GetVendorAccessPrintDocument, options);
      }
export function useGetVendorAccessPrintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAccessPrintQuery, GetVendorAccessPrintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAccessPrintQuery, GetVendorAccessPrintQueryVariables>(GetVendorAccessPrintDocument, options);
        }
export type GetVendorAccessPrintQueryHookResult = ReturnType<typeof useGetVendorAccessPrintQuery>;
export type GetVendorAccessPrintLazyQueryHookResult = ReturnType<typeof useGetVendorAccessPrintLazyQuery>;
export type GetVendorAccessPrintQueryResult = Apollo.QueryResult<GetVendorAccessPrintQuery, GetVendorAccessPrintQueryVariables>;
export const GetVendorAccessQrCodeDocument = gql`
    query getVendorAccessQrCode($id: String!) {
  getVendorAccessQrCode(id: $id)
}
    `;

/**
 * __useGetVendorAccessQrCodeQuery__
 *
 * To run a query within a React component, call `useGetVendorAccessQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAccessQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAccessQrCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVendorAccessQrCodeQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAccessQrCodeQuery, GetVendorAccessQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorAccessQrCodeQuery, GetVendorAccessQrCodeQueryVariables>(GetVendorAccessQrCodeDocument, options);
      }
export function useGetVendorAccessQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAccessQrCodeQuery, GetVendorAccessQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorAccessQrCodeQuery, GetVendorAccessQrCodeQueryVariables>(GetVendorAccessQrCodeDocument, options);
        }
export type GetVendorAccessQrCodeQueryHookResult = ReturnType<typeof useGetVendorAccessQrCodeQuery>;
export type GetVendorAccessQrCodeLazyQueryHookResult = ReturnType<typeof useGetVendorAccessQrCodeLazyQuery>;
export type GetVendorAccessQrCodeQueryResult = Apollo.QueryResult<GetVendorAccessQrCodeQuery, GetVendorAccessQrCodeQueryVariables>;
export const ExportVendorAccessListDocument = gql`
    query exportVendorAccessList($search: String, $from: DateTime, $to: DateTime, $buildingIds: [String!], $companyIds: [String!], $hostIds: [String!], $statuses: [VendorAccessStatusEnum!]) {
  exportVendorAccessList(
    search: $search
    to: $to
    from: $from
    buildingIds: $buildingIds
    companyIds: $companyIds
    hostIds: $hostIds
    statuses: $statuses
  )
}
    `;

/**
 * __useExportVendorAccessListQuery__
 *
 * To run a query within a React component, call `useExportVendorAccessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportVendorAccessListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportVendorAccessListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      buildingIds: // value for 'buildingIds'
 *      companyIds: // value for 'companyIds'
 *      hostIds: // value for 'hostIds'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useExportVendorAccessListQuery(baseOptions?: Apollo.QueryHookOptions<ExportVendorAccessListQuery, ExportVendorAccessListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportVendorAccessListQuery, ExportVendorAccessListQueryVariables>(ExportVendorAccessListDocument, options);
      }
export function useExportVendorAccessListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportVendorAccessListQuery, ExportVendorAccessListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportVendorAccessListQuery, ExportVendorAccessListQueryVariables>(ExportVendorAccessListDocument, options);
        }
export type ExportVendorAccessListQueryHookResult = ReturnType<typeof useExportVendorAccessListQuery>;
export type ExportVendorAccessListLazyQueryHookResult = ReturnType<typeof useExportVendorAccessListLazyQuery>;
export type ExportVendorAccessListQueryResult = Apollo.QueryResult<ExportVendorAccessListQuery, ExportVendorAccessListQueryVariables>;
export const CreateWaiverTemplateDocument = gql`
    mutation createWaiverTemplate($data: WaiverInput!) {
  createWaiverTemplate(input: $data) {
    id
  }
}
    `;
export type CreateWaiverTemplateMutationFn = Apollo.MutationFunction<CreateWaiverTemplateMutation, CreateWaiverTemplateMutationVariables>;

/**
 * __useCreateWaiverTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWaiverTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaiverTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaiverTemplateMutation, { data, loading, error }] = useCreateWaiverTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWaiverTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWaiverTemplateMutation, CreateWaiverTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWaiverTemplateMutation, CreateWaiverTemplateMutationVariables>(CreateWaiverTemplateDocument, options);
      }
export type CreateWaiverTemplateMutationHookResult = ReturnType<typeof useCreateWaiverTemplateMutation>;
export type CreateWaiverTemplateMutationResult = Apollo.MutationResult<CreateWaiverTemplateMutation>;
export type CreateWaiverTemplateMutationOptions = Apollo.BaseMutationOptions<CreateWaiverTemplateMutation, CreateWaiverTemplateMutationVariables>;
export const UpdateWaiverTemplateDocument = gql`
    mutation updateWaiverTemplate($id: String!, $data: WaiverUpdateInput!) {
  updateWaiverTemplate(id: $id, input: $data) {
    ...WaiverTemplateFields
  }
}
    ${WaiverTemplateFieldsFragmentDoc}`;
export type UpdateWaiverTemplateMutationFn = Apollo.MutationFunction<UpdateWaiverTemplateMutation, UpdateWaiverTemplateMutationVariables>;

/**
 * __useUpdateWaiverTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateWaiverTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWaiverTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWaiverTemplateMutation, { data, loading, error }] = useUpdateWaiverTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWaiverTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWaiverTemplateMutation, UpdateWaiverTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWaiverTemplateMutation, UpdateWaiverTemplateMutationVariables>(UpdateWaiverTemplateDocument, options);
      }
export type UpdateWaiverTemplateMutationHookResult = ReturnType<typeof useUpdateWaiverTemplateMutation>;
export type UpdateWaiverTemplateMutationResult = Apollo.MutationResult<UpdateWaiverTemplateMutation>;
export type UpdateWaiverTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateWaiverTemplateMutation, UpdateWaiverTemplateMutationVariables>;
export const RemoveWaiverTemplatesDocument = gql`
    mutation removeWaiverTemplates($data: DeleteRecordsInput!) {
  removeWaiverTemplates(input: $data)
}
    `;
export type RemoveWaiverTemplatesMutationFn = Apollo.MutationFunction<RemoveWaiverTemplatesMutation, RemoveWaiverTemplatesMutationVariables>;

/**
 * __useRemoveWaiverTemplatesMutation__
 *
 * To run a mutation, you first call `useRemoveWaiverTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWaiverTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWaiverTemplatesMutation, { data, loading, error }] = useRemoveWaiverTemplatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWaiverTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWaiverTemplatesMutation, RemoveWaiverTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWaiverTemplatesMutation, RemoveWaiverTemplatesMutationVariables>(RemoveWaiverTemplatesDocument, options);
      }
export type RemoveWaiverTemplatesMutationHookResult = ReturnType<typeof useRemoveWaiverTemplatesMutation>;
export type RemoveWaiverTemplatesMutationResult = Apollo.MutationResult<RemoveWaiverTemplatesMutation>;
export type RemoveWaiverTemplatesMutationOptions = Apollo.BaseMutationOptions<RemoveWaiverTemplatesMutation, RemoveWaiverTemplatesMutationVariables>;
export const GetWaiverTemplatesDocument = gql`
    query getWaiverTemplates($search: String, $type: WaiverTypesEnum, $active: Boolean) {
  getWaiverTemplates(search: $search, type: $type, active: $active) {
    ...WaiverTemplateFields
  }
}
    ${WaiverTemplateFieldsFragmentDoc}`;

/**
 * __useGetWaiverTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWaiverTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaiverTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaiverTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetWaiverTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWaiverTemplatesQuery, GetWaiverTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaiverTemplatesQuery, GetWaiverTemplatesQueryVariables>(GetWaiverTemplatesDocument, options);
      }
export function useGetWaiverTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaiverTemplatesQuery, GetWaiverTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaiverTemplatesQuery, GetWaiverTemplatesQueryVariables>(GetWaiverTemplatesDocument, options);
        }
export type GetWaiverTemplatesQueryHookResult = ReturnType<typeof useGetWaiverTemplatesQuery>;
export type GetWaiverTemplatesLazyQueryHookResult = ReturnType<typeof useGetWaiverTemplatesLazyQuery>;
export type GetWaiverTemplatesQueryResult = Apollo.QueryResult<GetWaiverTemplatesQuery, GetWaiverTemplatesQueryVariables>;
export const GetWaiverTemplateDocument = gql`
    query getWaiverTemplate($id: String!) {
  getWaiverTemplate(id: $id) {
    ...WaiverTemplateFields
  }
}
    ${WaiverTemplateFieldsFragmentDoc}`;

/**
 * __useGetWaiverTemplateQuery__
 *
 * To run a query within a React component, call `useGetWaiverTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaiverTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaiverTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWaiverTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetWaiverTemplateQuery, GetWaiverTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaiverTemplateQuery, GetWaiverTemplateQueryVariables>(GetWaiverTemplateDocument, options);
      }
export function useGetWaiverTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaiverTemplateQuery, GetWaiverTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaiverTemplateQuery, GetWaiverTemplateQueryVariables>(GetWaiverTemplateDocument, options);
        }
export type GetWaiverTemplateQueryHookResult = ReturnType<typeof useGetWaiverTemplateQuery>;
export type GetWaiverTemplateLazyQueryHookResult = ReturnType<typeof useGetWaiverTemplateLazyQuery>;
export type GetWaiverTemplateQueryResult = Apollo.QueryResult<GetWaiverTemplateQuery, GetWaiverTemplateQueryVariables>;
export const GetWaiverVariablesDocument = gql`
    query getWaiverVariables {
  getWaiverVariables
}
    `;

/**
 * __useGetWaiverVariablesQuery__
 *
 * To run a query within a React component, call `useGetWaiverVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaiverVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaiverVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaiverVariablesQuery(baseOptions?: Apollo.QueryHookOptions<GetWaiverVariablesQuery, GetWaiverVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaiverVariablesQuery, GetWaiverVariablesQueryVariables>(GetWaiverVariablesDocument, options);
      }
export function useGetWaiverVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaiverVariablesQuery, GetWaiverVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaiverVariablesQuery, GetWaiverVariablesQueryVariables>(GetWaiverVariablesDocument, options);
        }
export type GetWaiverVariablesQueryHookResult = ReturnType<typeof useGetWaiverVariablesQuery>;
export type GetWaiverVariablesLazyQueryHookResult = ReturnType<typeof useGetWaiverVariablesLazyQuery>;
export type GetWaiverVariablesQueryResult = Apollo.QueryResult<GetWaiverVariablesQuery, GetWaiverVariablesQueryVariables>;
export const CreateWatchlistDocument = gql`
    mutation createWatchlist($data: WatchlistInput!) {
  createWatchlist(input: $data) {
    id
  }
}
    `;
export type CreateWatchlistMutationFn = Apollo.MutationFunction<CreateWatchlistMutation, CreateWatchlistMutationVariables>;

/**
 * __useCreateWatchlistMutation__
 *
 * To run a mutation, you first call `useCreateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWatchlistMutation, { data, loading, error }] = useCreateWatchlistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<CreateWatchlistMutation, CreateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWatchlistMutation, CreateWatchlistMutationVariables>(CreateWatchlistDocument, options);
      }
export type CreateWatchlistMutationHookResult = ReturnType<typeof useCreateWatchlistMutation>;
export type CreateWatchlistMutationResult = Apollo.MutationResult<CreateWatchlistMutation>;
export type CreateWatchlistMutationOptions = Apollo.BaseMutationOptions<CreateWatchlistMutation, CreateWatchlistMutationVariables>;
export const UpdateWatchlistDocument = gql`
    mutation updateWatchlist($id: String!, $data: WatchlistUpdateInput!) {
  updateWatchlist(watchlistId: $id, input: $data) {
    ...WatchlistFields
  }
}
    ${WatchlistFieldsFragmentDoc}`;
export type UpdateWatchlistMutationFn = Apollo.MutationFunction<UpdateWatchlistMutation, UpdateWatchlistMutationVariables>;

/**
 * __useUpdateWatchlistMutation__
 *
 * To run a mutation, you first call `useUpdateWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWatchlistMutation, { data, loading, error }] = useUpdateWatchlistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWatchlistMutation, UpdateWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWatchlistMutation, UpdateWatchlistMutationVariables>(UpdateWatchlistDocument, options);
      }
export type UpdateWatchlistMutationHookResult = ReturnType<typeof useUpdateWatchlistMutation>;
export type UpdateWatchlistMutationResult = Apollo.MutationResult<UpdateWatchlistMutation>;
export type UpdateWatchlistMutationOptions = Apollo.BaseMutationOptions<UpdateWatchlistMutation, UpdateWatchlistMutationVariables>;
export const ToggleWatchlistDocument = gql`
    mutation toggleWatchlist($id: String!) {
  toggleWatchlist(watchlistId: $id)
}
    `;
export type ToggleWatchlistMutationFn = Apollo.MutationFunction<ToggleWatchlistMutation, ToggleWatchlistMutationVariables>;

/**
 * __useToggleWatchlistMutation__
 *
 * To run a mutation, you first call `useToggleWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWatchlistMutation, { data, loading, error }] = useToggleWatchlistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWatchlistMutation, ToggleWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWatchlistMutation, ToggleWatchlistMutationVariables>(ToggleWatchlistDocument, options);
      }
export type ToggleWatchlistMutationHookResult = ReturnType<typeof useToggleWatchlistMutation>;
export type ToggleWatchlistMutationResult = Apollo.MutationResult<ToggleWatchlistMutation>;
export type ToggleWatchlistMutationOptions = Apollo.BaseMutationOptions<ToggleWatchlistMutation, ToggleWatchlistMutationVariables>;
export const RemoveWatchlistDocument = gql`
    mutation removeWatchlist($data: DeleteRecordsInput!) {
  removeWatchlist(input: $data)
}
    `;
export type RemoveWatchlistMutationFn = Apollo.MutationFunction<RemoveWatchlistMutation, RemoveWatchlistMutationVariables>;

/**
 * __useRemoveWatchlistMutation__
 *
 * To run a mutation, you first call `useRemoveWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWatchlistMutation, { data, loading, error }] = useRemoveWatchlistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWatchlistMutation, RemoveWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWatchlistMutation, RemoveWatchlistMutationVariables>(RemoveWatchlistDocument, options);
      }
export type RemoveWatchlistMutationHookResult = ReturnType<typeof useRemoveWatchlistMutation>;
export type RemoveWatchlistMutationResult = Apollo.MutationResult<RemoveWatchlistMutation>;
export type RemoveWatchlistMutationOptions = Apollo.BaseMutationOptions<RemoveWatchlistMutation, RemoveWatchlistMutationVariables>;
export const DeleteWatchlistAttachmentDocument = gql`
    mutation deleteWatchlistAttachment($attachmentId: String!, $id: String!) {
  deleteWatchlistAttachment(attachmentId: $attachmentId, watchlistId: $id)
}
    `;
export type DeleteWatchlistAttachmentMutationFn = Apollo.MutationFunction<DeleteWatchlistAttachmentMutation, DeleteWatchlistAttachmentMutationVariables>;

/**
 * __useDeleteWatchlistAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteWatchlistAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWatchlistAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWatchlistAttachmentMutation, { data, loading, error }] = useDeleteWatchlistAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWatchlistAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWatchlistAttachmentMutation, DeleteWatchlistAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWatchlistAttachmentMutation, DeleteWatchlistAttachmentMutationVariables>(DeleteWatchlistAttachmentDocument, options);
      }
export type DeleteWatchlistAttachmentMutationHookResult = ReturnType<typeof useDeleteWatchlistAttachmentMutation>;
export type DeleteWatchlistAttachmentMutationResult = Apollo.MutationResult<DeleteWatchlistAttachmentMutation>;
export type DeleteWatchlistAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteWatchlistAttachmentMutation, DeleteWatchlistAttachmentMutationVariables>;
export const GetWatchlistDocument = gql`
    query getWatchlist($take: Int! = 10, $after: String, $before: String, $search: String, $companyIds: [String!], $requestedForIds: [String!]) {
  getWatchlist(
    take: $take
    after: $after
    before: $before
    search: $search
    companyIds: $companyIds
    requestedForIds: $requestedForIds
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...WatchlistCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${WatchlistCoreFieldsFragmentDoc}`;

/**
 * __useGetWatchlistQuery__
 *
 * To run a query within a React component, call `useGetWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyIds: // value for 'companyIds'
 *      requestedForIds: // value for 'requestedForIds'
 *   },
 * });
 */
export function useGetWatchlistQuery(baseOptions?: Apollo.QueryHookOptions<GetWatchlistQuery, GetWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWatchlistQuery, GetWatchlistQueryVariables>(GetWatchlistDocument, options);
      }
export function useGetWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWatchlistQuery, GetWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWatchlistQuery, GetWatchlistQueryVariables>(GetWatchlistDocument, options);
        }
export type GetWatchlistQueryHookResult = ReturnType<typeof useGetWatchlistQuery>;
export type GetWatchlistLazyQueryHookResult = ReturnType<typeof useGetWatchlistLazyQuery>;
export type GetWatchlistQueryResult = Apollo.QueryResult<GetWatchlistQuery, GetWatchlistQueryVariables>;
export const GetSingleWatchlistDocument = gql`
    query getSingleWatchlist($id: String!) {
  getSingleWatchlist(watchlistId: $id) {
    ...WatchlistFields
  }
}
    ${WatchlistFieldsFragmentDoc}`;

/**
 * __useGetSingleWatchlistQuery__
 *
 * To run a query within a React component, call `useGetSingleWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleWatchlistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleWatchlistQuery(baseOptions: Apollo.QueryHookOptions<GetSingleWatchlistQuery, GetSingleWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleWatchlistQuery, GetSingleWatchlistQueryVariables>(GetSingleWatchlistDocument, options);
      }
export function useGetSingleWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleWatchlistQuery, GetSingleWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleWatchlistQuery, GetSingleWatchlistQueryVariables>(GetSingleWatchlistDocument, options);
        }
export type GetSingleWatchlistQueryHookResult = ReturnType<typeof useGetSingleWatchlistQuery>;
export type GetSingleWatchlistLazyQueryHookResult = ReturnType<typeof useGetSingleWatchlistLazyQuery>;
export type GetSingleWatchlistQueryResult = Apollo.QueryResult<GetSingleWatchlistQuery, GetSingleWatchlistQueryVariables>;
export const CheckGuestWatchlistDocument = gql`
    query checkGuestWatchlist($id: String!) {
  checkGuestWatchlist(id: $id) {
    id
    firstName
    lastName
    userPhoto {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useCheckGuestWatchlistQuery__
 *
 * To run a query within a React component, call `useCheckGuestWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGuestWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGuestWatchlistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckGuestWatchlistQuery(baseOptions: Apollo.QueryHookOptions<CheckGuestWatchlistQuery, CheckGuestWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckGuestWatchlistQuery, CheckGuestWatchlistQueryVariables>(CheckGuestWatchlistDocument, options);
      }
export function useCheckGuestWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckGuestWatchlistQuery, CheckGuestWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckGuestWatchlistQuery, CheckGuestWatchlistQueryVariables>(CheckGuestWatchlistDocument, options);
        }
export type CheckGuestWatchlistQueryHookResult = ReturnType<typeof useCheckGuestWatchlistQuery>;
export type CheckGuestWatchlistLazyQueryHookResult = ReturnType<typeof useCheckGuestWatchlistLazyQuery>;
export type CheckGuestWatchlistQueryResult = Apollo.QueryResult<CheckGuestWatchlistQuery, CheckGuestWatchlistQueryVariables>;
export const ExportWatchlistDocument = gql`
    query exportWatchlist($search: String, $companyIds: [String!], $requestedForIds: [String!]) {
  exportWatchlist(
    search: $search
    companyIds: $companyIds
    requestedForIds: $requestedForIds
  )
}
    `;

/**
 * __useExportWatchlistQuery__
 *
 * To run a query within a React component, call `useExportWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWatchlistQuery({
 *   variables: {
 *      search: // value for 'search'
 *      companyIds: // value for 'companyIds'
 *      requestedForIds: // value for 'requestedForIds'
 *   },
 * });
 */
export function useExportWatchlistQuery(baseOptions?: Apollo.QueryHookOptions<ExportWatchlistQuery, ExportWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportWatchlistQuery, ExportWatchlistQueryVariables>(ExportWatchlistDocument, options);
      }
export function useExportWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportWatchlistQuery, ExportWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportWatchlistQuery, ExportWatchlistQueryVariables>(ExportWatchlistDocument, options);
        }
export type ExportWatchlistQueryHookResult = ReturnType<typeof useExportWatchlistQuery>;
export type ExportWatchlistLazyQueryHookResult = ReturnType<typeof useExportWatchlistLazyQuery>;
export type ExportWatchlistQueryResult = Apollo.QueryResult<ExportWatchlistQuery, ExportWatchlistQueryVariables>;
export const GetWorkOrderStatusWidgetDocument = gql`
    query getWorkOrderStatusWidget($companyId: String, $categoryIds: [String!], $buildingIds: [String!], $from: DateTime!, $to: DateTime) {
  getWOStatusWidget(
    companyId: $companyId
    buildingIds: $buildingIds
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    count
    percentage
    color
  }
}
    `;

/**
 * __useGetWorkOrderStatusWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderStatusWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderStatusWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderStatusWidgetQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      categoryIds: // value for 'categoryIds'
 *      buildingIds: // value for 'buildingIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderStatusWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>(GetWorkOrderStatusWidgetDocument, options);
      }
export function useGetWorkOrderStatusWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>(GetWorkOrderStatusWidgetDocument, options);
        }
export type GetWorkOrderStatusWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderStatusWidgetQuery>;
export type GetWorkOrderStatusWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderStatusWidgetLazyQuery>;
export type GetWorkOrderStatusWidgetQueryResult = Apollo.QueryResult<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>;
export const GetWorkOrderReviewsWidgetDocument = gql`
    query getWorkOrderReviewsWidget($from: DateTime!, $to: DateTime) {
  getWOReviewsWidget(from: $from, to: $to) {
    name
    count
  }
}
    `;

/**
 * __useGetWorkOrderReviewsWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderReviewsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderReviewsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderReviewsWidgetQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderReviewsWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>(GetWorkOrderReviewsWidgetDocument, options);
      }
export function useGetWorkOrderReviewsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>(GetWorkOrderReviewsWidgetDocument, options);
        }
export type GetWorkOrderReviewsWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderReviewsWidgetQuery>;
export type GetWorkOrderReviewsWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderReviewsWidgetLazyQuery>;
export type GetWorkOrderReviewsWidgetQueryResult = Apollo.QueryResult<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>;
export const GetWorkOrderRevenueWidgetDocument = gql`
    query getWorkOrderRevenueWidget($companyId: String, $categoryIds: [String!], $buildingIds: [String!], $from: DateTime!, $to: DateTime) {
  getWORevenueWidget(
    companyId: $companyId
    buildingIds: $buildingIds
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    laborRevenue
    markupRevenue
    materialRevenue
  }
}
    `;

/**
 * __useGetWorkOrderRevenueWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderRevenueWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderRevenueWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderRevenueWidgetQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      categoryIds: // value for 'categoryIds'
 *      buildingIds: // value for 'buildingIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderRevenueWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>(GetWorkOrderRevenueWidgetDocument, options);
      }
export function useGetWorkOrderRevenueWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>(GetWorkOrderRevenueWidgetDocument, options);
        }
export type GetWorkOrderRevenueWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderRevenueWidgetQuery>;
export type GetWorkOrderRevenueWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderRevenueWidgetLazyQuery>;
export type GetWorkOrderRevenueWidgetQueryResult = Apollo.QueryResult<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>;
export const GetWorkOrderCategoryWidgetDocument = gql`
    query getWorkOrderCategoryWidget($companyId: String, $categoryIds: [String!], $buildingIds: [String!], $from: DateTime!, $to: DateTime) {
  getWOCategoryWidget(
    companyId: $companyId
    buildingIds: $buildingIds
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    count
  }
}
    `;

/**
 * __useGetWorkOrderCategoryWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderCategoryWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderCategoryWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderCategoryWidgetQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      categoryIds: // value for 'categoryIds'
 *      buildingIds: // value for 'buildingIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderCategoryWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>(GetWorkOrderCategoryWidgetDocument, options);
      }
export function useGetWorkOrderCategoryWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>(GetWorkOrderCategoryWidgetDocument, options);
        }
export type GetWorkOrderCategoryWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderCategoryWidgetQuery>;
export type GetWorkOrderCategoryWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderCategoryWidgetLazyQuery>;
export type GetWorkOrderCategoryWidgetQueryResult = Apollo.QueryResult<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>;
export const GetCoiWidgetDocument = gql`
    query getCOIWidget($companyId: String) {
  getCOIWidget(companyId: $companyId) {
    name
    count
    percentage
  }
}
    `;

/**
 * __useGetCoiWidgetQuery__
 *
 * To run a query within a React component, call `useGetCoiWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiWidgetQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCoiWidgetQuery(baseOptions?: Apollo.QueryHookOptions<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>(GetCoiWidgetDocument, options);
      }
export function useGetCoiWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>(GetCoiWidgetDocument, options);
        }
export type GetCoiWidgetQueryHookResult = ReturnType<typeof useGetCoiWidgetQuery>;
export type GetCoiWidgetLazyQueryHookResult = ReturnType<typeof useGetCoiWidgetLazyQuery>;
export type GetCoiWidgetQueryResult = Apollo.QueryResult<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>;
export const GetTaskOpenWidgetDocument = gql`
    query getTaskOpenWidget {
  getTaskOpenWidget {
    count
  }
}
    `;

/**
 * __useGetTaskOpenWidgetQuery__
 *
 * To run a query within a React component, call `useGetTaskOpenWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOpenWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOpenWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskOpenWidgetQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>(GetTaskOpenWidgetDocument, options);
      }
export function useGetTaskOpenWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>(GetTaskOpenWidgetDocument, options);
        }
export type GetTaskOpenWidgetQueryHookResult = ReturnType<typeof useGetTaskOpenWidgetQuery>;
export type GetTaskOpenWidgetLazyQueryHookResult = ReturnType<typeof useGetTaskOpenWidgetLazyQuery>;
export type GetTaskOpenWidgetQueryResult = Apollo.QueryResult<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>;
export const GetTaskOverdueWidgetDocument = gql`
    query getTaskOverdueWidget {
  getTaskOverdueWidget {
    count
  }
}
    `;

/**
 * __useGetTaskOverdueWidgetQuery__
 *
 * To run a query within a React component, call `useGetTaskOverdueWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOverdueWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOverdueWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskOverdueWidgetQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>(GetTaskOverdueWidgetDocument, options);
      }
export function useGetTaskOverdueWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>(GetTaskOverdueWidgetDocument, options);
        }
export type GetTaskOverdueWidgetQueryHookResult = ReturnType<typeof useGetTaskOverdueWidgetQuery>;
export type GetTaskOverdueWidgetLazyQueryHookResult = ReturnType<typeof useGetTaskOverdueWidgetLazyQuery>;
export type GetTaskOverdueWidgetQueryResult = Apollo.QueryResult<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>;
export const GetGeneaAttendanceWidgetDocument = gql`
    query getGeneaAttendanceWidget {
  getGeneaAttendanceWidget
}
    `;

/**
 * __useGetGeneaAttendanceWidgetQuery__
 *
 * To run a query within a React component, call `useGetGeneaAttendanceWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneaAttendanceWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneaAttendanceWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneaAttendanceWidgetQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneaAttendanceWidgetQuery, GetGeneaAttendanceWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneaAttendanceWidgetQuery, GetGeneaAttendanceWidgetQueryVariables>(GetGeneaAttendanceWidgetDocument, options);
      }
export function useGetGeneaAttendanceWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneaAttendanceWidgetQuery, GetGeneaAttendanceWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneaAttendanceWidgetQuery, GetGeneaAttendanceWidgetQueryVariables>(GetGeneaAttendanceWidgetDocument, options);
        }
export type GetGeneaAttendanceWidgetQueryHookResult = ReturnType<typeof useGetGeneaAttendanceWidgetQuery>;
export type GetGeneaAttendanceWidgetLazyQueryHookResult = ReturnType<typeof useGetGeneaAttendanceWidgetLazyQuery>;
export type GetGeneaAttendanceWidgetQueryResult = Apollo.QueryResult<GetGeneaAttendanceWidgetQuery, GetGeneaAttendanceWidgetQueryVariables>;
export const GetAmanoOccupancyWidgetDocument = gql`
    query getAmanoOccupancyWidget($facilityId: String!) {
  getAmanoOccupancyWidget(facilityId: $facilityId) {
    contract {
      occupied
    }
    transient {
      occupied
    }
    overall {
      occupied
      available
    }
  }
}
    `;

/**
 * __useGetAmanoOccupancyWidgetQuery__
 *
 * To run a query within a React component, call `useGetAmanoOccupancyWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmanoOccupancyWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmanoOccupancyWidgetQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useGetAmanoOccupancyWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetAmanoOccupancyWidgetQuery, GetAmanoOccupancyWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmanoOccupancyWidgetQuery, GetAmanoOccupancyWidgetQueryVariables>(GetAmanoOccupancyWidgetDocument, options);
      }
export function useGetAmanoOccupancyWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmanoOccupancyWidgetQuery, GetAmanoOccupancyWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmanoOccupancyWidgetQuery, GetAmanoOccupancyWidgetQueryVariables>(GetAmanoOccupancyWidgetDocument, options);
        }
export type GetAmanoOccupancyWidgetQueryHookResult = ReturnType<typeof useGetAmanoOccupancyWidgetQuery>;
export type GetAmanoOccupancyWidgetLazyQueryHookResult = ReturnType<typeof useGetAmanoOccupancyWidgetLazyQuery>;
export type GetAmanoOccupancyWidgetQueryResult = Apollo.QueryResult<GetAmanoOccupancyWidgetQuery, GetAmanoOccupancyWidgetQueryVariables>;
export const CreateWorkOrderTemplateDocument = gql`
    mutation createWorkOrderTemplate($data: WorkOrderTemplateInput!) {
  createWorkOrderTemplate(input: $data) {
    id
  }
}
    `;
export type CreateWorkOrderTemplateMutationFn = Apollo.MutationFunction<CreateWorkOrderTemplateMutation, CreateWorkOrderTemplateMutationVariables>;

/**
 * __useCreateWorkOrderTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderTemplateMutation, { data, loading, error }] = useCreateWorkOrderTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkOrderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderTemplateMutation, CreateWorkOrderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderTemplateMutation, CreateWorkOrderTemplateMutationVariables>(CreateWorkOrderTemplateDocument, options);
      }
export type CreateWorkOrderTemplateMutationHookResult = ReturnType<typeof useCreateWorkOrderTemplateMutation>;
export type CreateWorkOrderTemplateMutationResult = Apollo.MutationResult<CreateWorkOrderTemplateMutation>;
export type CreateWorkOrderTemplateMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderTemplateMutation, CreateWorkOrderTemplateMutationVariables>;
export const UpdateWorkOrderTemplateDocument = gql`
    mutation updateWorkOrderTemplate($templateId: String!, $data: WorkOrderTemplateUpdateInput!) {
  updateWorkOrderTemplate(templateId: $templateId, input: $data) {
    ...WorkOrderTemplateFields
  }
}
    ${WorkOrderTemplateFieldsFragmentDoc}`;
export type UpdateWorkOrderTemplateMutationFn = Apollo.MutationFunction<UpdateWorkOrderTemplateMutation, UpdateWorkOrderTemplateMutationVariables>;

/**
 * __useUpdateWorkOrderTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderTemplateMutation, { data, loading, error }] = useUpdateWorkOrderTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkOrderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderTemplateMutation, UpdateWorkOrderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderTemplateMutation, UpdateWorkOrderTemplateMutationVariables>(UpdateWorkOrderTemplateDocument, options);
      }
export type UpdateWorkOrderTemplateMutationHookResult = ReturnType<typeof useUpdateWorkOrderTemplateMutation>;
export type UpdateWorkOrderTemplateMutationResult = Apollo.MutationResult<UpdateWorkOrderTemplateMutation>;
export type UpdateWorkOrderTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderTemplateMutation, UpdateWorkOrderTemplateMutationVariables>;
export const UpdateWoTemplateNextGenerationDateDocument = gql`
    mutation updateWOTemplateNextGenerationDate($id: String!, $nextGenerationDate: DateTime!) {
  updateWOTemplateNextGenerationDate(
    id: $id
    nextGenerationDate: $nextGenerationDate
  ) {
    id
    nextGenerationDate
  }
}
    `;
export type UpdateWoTemplateNextGenerationDateMutationFn = Apollo.MutationFunction<UpdateWoTemplateNextGenerationDateMutation, UpdateWoTemplateNextGenerationDateMutationVariables>;

/**
 * __useUpdateWoTemplateNextGenerationDateMutation__
 *
 * To run a mutation, you first call `useUpdateWoTemplateNextGenerationDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWoTemplateNextGenerationDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWoTemplateNextGenerationDateMutation, { data, loading, error }] = useUpdateWoTemplateNextGenerationDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nextGenerationDate: // value for 'nextGenerationDate'
 *   },
 * });
 */
export function useUpdateWoTemplateNextGenerationDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWoTemplateNextGenerationDateMutation, UpdateWoTemplateNextGenerationDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWoTemplateNextGenerationDateMutation, UpdateWoTemplateNextGenerationDateMutationVariables>(UpdateWoTemplateNextGenerationDateDocument, options);
      }
export type UpdateWoTemplateNextGenerationDateMutationHookResult = ReturnType<typeof useUpdateWoTemplateNextGenerationDateMutation>;
export type UpdateWoTemplateNextGenerationDateMutationResult = Apollo.MutationResult<UpdateWoTemplateNextGenerationDateMutation>;
export type UpdateWoTemplateNextGenerationDateMutationOptions = Apollo.BaseMutationOptions<UpdateWoTemplateNextGenerationDateMutation, UpdateWoTemplateNextGenerationDateMutationVariables>;
export const RemoveWorkOrderTemplatesDocument = gql`
    mutation removeWorkOrderTemplates($data: DeleteRecordsInput!) {
  removeWorkOrderTemplates(input: $data)
}
    `;
export type RemoveWorkOrderTemplatesMutationFn = Apollo.MutationFunction<RemoveWorkOrderTemplatesMutation, RemoveWorkOrderTemplatesMutationVariables>;

/**
 * __useRemoveWorkOrderTemplatesMutation__
 *
 * To run a mutation, you first call `useRemoveWorkOrderTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkOrderTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkOrderTemplatesMutation, { data, loading, error }] = useRemoveWorkOrderTemplatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWorkOrderTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkOrderTemplatesMutation, RemoveWorkOrderTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkOrderTemplatesMutation, RemoveWorkOrderTemplatesMutationVariables>(RemoveWorkOrderTemplatesDocument, options);
      }
export type RemoveWorkOrderTemplatesMutationHookResult = ReturnType<typeof useRemoveWorkOrderTemplatesMutation>;
export type RemoveWorkOrderTemplatesMutationResult = Apollo.MutationResult<RemoveWorkOrderTemplatesMutation>;
export type RemoveWorkOrderTemplatesMutationOptions = Apollo.BaseMutationOptions<RemoveWorkOrderTemplatesMutation, RemoveWorkOrderTemplatesMutationVariables>;
export const SkipWoTemplateDateDocument = gql`
    mutation skipWOTemplateDate($templateId: String!, $date: String!) {
  skipWOTemplateDate(templateId: $templateId, date: $date) {
    id
    nextGenerationDate
    excludeDates
  }
}
    `;
export type SkipWoTemplateDateMutationFn = Apollo.MutationFunction<SkipWoTemplateDateMutation, SkipWoTemplateDateMutationVariables>;

/**
 * __useSkipWoTemplateDateMutation__
 *
 * To run a mutation, you first call `useSkipWoTemplateDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipWoTemplateDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipWoTemplateDateMutation, { data, loading, error }] = useSkipWoTemplateDateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSkipWoTemplateDateMutation(baseOptions?: Apollo.MutationHookOptions<SkipWoTemplateDateMutation, SkipWoTemplateDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipWoTemplateDateMutation, SkipWoTemplateDateMutationVariables>(SkipWoTemplateDateDocument, options);
      }
export type SkipWoTemplateDateMutationHookResult = ReturnType<typeof useSkipWoTemplateDateMutation>;
export type SkipWoTemplateDateMutationResult = Apollo.MutationResult<SkipWoTemplateDateMutation>;
export type SkipWoTemplateDateMutationOptions = Apollo.BaseMutationOptions<SkipWoTemplateDateMutation, SkipWoTemplateDateMutationVariables>;
export const GenerateWorkOrderDocument = gql`
    mutation generateWorkOrder($templateId: String!) {
  generateWorkOrder(templateId: $templateId)
}
    `;
export type GenerateWorkOrderMutationFn = Apollo.MutationFunction<GenerateWorkOrderMutation, GenerateWorkOrderMutationVariables>;

/**
 * __useGenerateWorkOrderMutation__
 *
 * To run a mutation, you first call `useGenerateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWorkOrderMutation, { data, loading, error }] = useGenerateWorkOrderMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGenerateWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<GenerateWorkOrderMutation, GenerateWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateWorkOrderMutation, GenerateWorkOrderMutationVariables>(GenerateWorkOrderDocument, options);
      }
export type GenerateWorkOrderMutationHookResult = ReturnType<typeof useGenerateWorkOrderMutation>;
export type GenerateWorkOrderMutationResult = Apollo.MutationResult<GenerateWorkOrderMutation>;
export type GenerateWorkOrderMutationOptions = Apollo.BaseMutationOptions<GenerateWorkOrderMutation, GenerateWorkOrderMutationVariables>;
export const BulkPauseWoTemplateDocument = gql`
    mutation bulkPauseWOTemplate($ids: [String!]!, $pause: Boolean!) {
  bulkPauseWOTemplate(ids: $ids, pause: $pause) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
    }
  }
}
    `;
export type BulkPauseWoTemplateMutationFn = Apollo.MutationFunction<BulkPauseWoTemplateMutation, BulkPauseWoTemplateMutationVariables>;

/**
 * __useBulkPauseWoTemplateMutation__
 *
 * To run a mutation, you first call `useBulkPauseWoTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPauseWoTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPauseWoTemplateMutation, { data, loading, error }] = useBulkPauseWoTemplateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      pause: // value for 'pause'
 *   },
 * });
 */
export function useBulkPauseWoTemplateMutation(baseOptions?: Apollo.MutationHookOptions<BulkPauseWoTemplateMutation, BulkPauseWoTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPauseWoTemplateMutation, BulkPauseWoTemplateMutationVariables>(BulkPauseWoTemplateDocument, options);
      }
export type BulkPauseWoTemplateMutationHookResult = ReturnType<typeof useBulkPauseWoTemplateMutation>;
export type BulkPauseWoTemplateMutationResult = Apollo.MutationResult<BulkPauseWoTemplateMutation>;
export type BulkPauseWoTemplateMutationOptions = Apollo.BaseMutationOptions<BulkPauseWoTemplateMutation, BulkPauseWoTemplateMutationVariables>;
export const BulkSkipNextWoTemplateDocument = gql`
    mutation bulkSkipNextWOTemplate($ids: [String!]!) {
  bulkSkipNextWOTemplate(ids: $ids) {
    errorCount
    errorMessages
    successCount
    data {
      id
      recordStatus
      nextGenerationDate
      excludeDates
    }
  }
}
    `;
export type BulkSkipNextWoTemplateMutationFn = Apollo.MutationFunction<BulkSkipNextWoTemplateMutation, BulkSkipNextWoTemplateMutationVariables>;

/**
 * __useBulkSkipNextWoTemplateMutation__
 *
 * To run a mutation, you first call `useBulkSkipNextWoTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSkipNextWoTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSkipNextWoTemplateMutation, { data, loading, error }] = useBulkSkipNextWoTemplateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkSkipNextWoTemplateMutation(baseOptions?: Apollo.MutationHookOptions<BulkSkipNextWoTemplateMutation, BulkSkipNextWoTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSkipNextWoTemplateMutation, BulkSkipNextWoTemplateMutationVariables>(BulkSkipNextWoTemplateDocument, options);
      }
export type BulkSkipNextWoTemplateMutationHookResult = ReturnType<typeof useBulkSkipNextWoTemplateMutation>;
export type BulkSkipNextWoTemplateMutationResult = Apollo.MutationResult<BulkSkipNextWoTemplateMutation>;
export type BulkSkipNextWoTemplateMutationOptions = Apollo.BaseMutationOptions<BulkSkipNextWoTemplateMutation, BulkSkipNextWoTemplateMutationVariables>;
export const DeleteWoTemplateAttachmentDocument = gql`
    mutation deleteWOTemplateAttachment($attachmentId: String!, $templateId: String!) {
  deleteWOTemplateAttachment(attachmentId: $attachmentId, templateId: $templateId)
}
    `;
export type DeleteWoTemplateAttachmentMutationFn = Apollo.MutationFunction<DeleteWoTemplateAttachmentMutation, DeleteWoTemplateAttachmentMutationVariables>;

/**
 * __useDeleteWoTemplateAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteWoTemplateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWoTemplateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWoTemplateAttachmentMutation, { data, loading, error }] = useDeleteWoTemplateAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteWoTemplateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWoTemplateAttachmentMutation, DeleteWoTemplateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWoTemplateAttachmentMutation, DeleteWoTemplateAttachmentMutationVariables>(DeleteWoTemplateAttachmentDocument, options);
      }
export type DeleteWoTemplateAttachmentMutationHookResult = ReturnType<typeof useDeleteWoTemplateAttachmentMutation>;
export type DeleteWoTemplateAttachmentMutationResult = Apollo.MutationResult<DeleteWoTemplateAttachmentMutation>;
export type DeleteWoTemplateAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteWoTemplateAttachmentMutation, DeleteWoTemplateAttachmentMutationVariables>;
export const GetWorkOrderTemplatesDocument = gql`
    query getWorkOrderTemplates($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $recordStatuses: [RRuleStatuses!], $from: DateTime, $to: DateTime, $categoryIds: [String!], $companyIds: [String!]) {
  getWorkOrderTemplates(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    recordStatuses: $recordStatuses
    from: $from
    to: $to
    categoryIds: $categoryIds
    companyIds: $companyIds
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      description
      recordStatus
      rruleText
      building {
        ...BuildingCoreFields
      }
      category {
        ...CategoryCoreFields
      }
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      assignedTo {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      createdAt
      startDate
      nextGenerationDate
      prevGenerationDate
      excludeDates
      timezone
      charges
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderTemplatesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetWorkOrderTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkOrderTemplatesQuery, GetWorkOrderTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderTemplatesQuery, GetWorkOrderTemplatesQueryVariables>(GetWorkOrderTemplatesDocument, options);
      }
export function useGetWorkOrderTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderTemplatesQuery, GetWorkOrderTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderTemplatesQuery, GetWorkOrderTemplatesQueryVariables>(GetWorkOrderTemplatesDocument, options);
        }
export type GetWorkOrderTemplatesQueryHookResult = ReturnType<typeof useGetWorkOrderTemplatesQuery>;
export type GetWorkOrderTemplatesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderTemplatesLazyQuery>;
export type GetWorkOrderTemplatesQueryResult = Apollo.QueryResult<GetWorkOrderTemplatesQuery, GetWorkOrderTemplatesQueryVariables>;
export const GetWorkOrderTemplatesCalendarDocument = gql`
    query getWorkOrderTemplatesCalendar($search: String, $buildingIds: [String!], $recordStatuses: [RRuleStatuses!], $from: DateTime!, $to: DateTime!, $categoryIds: [String!], $companyIds: [String!]) {
  getWorkOrderTemplatesCalendar(
    search: $search
    buildingIds: $buildingIds
    recordStatuses: $recordStatuses
    from: $from
    to: $to
    categoryIds: $categoryIds
    companyIds: $companyIds
  ) {
    dates
    record {
      id
      index
      recordStatus
      category {
        ...CategoryCoreFields
      }
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      assignedTo {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${CategoryCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderTemplatesCalendarQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderTemplatesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderTemplatesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderTemplatesCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetWorkOrderTemplatesCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderTemplatesCalendarQuery, GetWorkOrderTemplatesCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderTemplatesCalendarQuery, GetWorkOrderTemplatesCalendarQueryVariables>(GetWorkOrderTemplatesCalendarDocument, options);
      }
export function useGetWorkOrderTemplatesCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderTemplatesCalendarQuery, GetWorkOrderTemplatesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderTemplatesCalendarQuery, GetWorkOrderTemplatesCalendarQueryVariables>(GetWorkOrderTemplatesCalendarDocument, options);
        }
export type GetWorkOrderTemplatesCalendarQueryHookResult = ReturnType<typeof useGetWorkOrderTemplatesCalendarQuery>;
export type GetWorkOrderTemplatesCalendarLazyQueryHookResult = ReturnType<typeof useGetWorkOrderTemplatesCalendarLazyQuery>;
export type GetWorkOrderTemplatesCalendarQueryResult = Apollo.QueryResult<GetWorkOrderTemplatesCalendarQuery, GetWorkOrderTemplatesCalendarQueryVariables>;
export const GetWorkOrderTemplateDocument = gql`
    query getWorkOrderTemplate($id: String!) {
  getWorkOrderTemplate(templateId: $id) {
    ...WorkOrderTemplateFields
  }
}
    ${WorkOrderTemplateFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderTemplateQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkOrderTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderTemplateQuery, GetWorkOrderTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderTemplateQuery, GetWorkOrderTemplateQueryVariables>(GetWorkOrderTemplateDocument, options);
      }
export function useGetWorkOrderTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderTemplateQuery, GetWorkOrderTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderTemplateQuery, GetWorkOrderTemplateQueryVariables>(GetWorkOrderTemplateDocument, options);
        }
export type GetWorkOrderTemplateQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateQuery>;
export type GetWorkOrderTemplateLazyQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateLazyQuery>;
export type GetWorkOrderTemplateQueryResult = Apollo.QueryResult<GetWorkOrderTemplateQuery, GetWorkOrderTemplateQueryVariables>;
export const GetWorkOrderTemplateChargesDocument = gql`
    query getWorkOrderTemplateCharges($workOrderTemplateId: String!, $search: String) {
  getWorkOrderTemplateCharges(
    workOrderTemplateId: $workOrderTemplateId
    search: $search
  ) {
    id
    type
    billable
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderTemplateChargesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderTemplateChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderTemplateChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderTemplateChargesQuery({
 *   variables: {
 *      workOrderTemplateId: // value for 'workOrderTemplateId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderTemplateChargesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderTemplateChargesQuery, GetWorkOrderTemplateChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderTemplateChargesQuery, GetWorkOrderTemplateChargesQueryVariables>(GetWorkOrderTemplateChargesDocument, options);
      }
export function useGetWorkOrderTemplateChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderTemplateChargesQuery, GetWorkOrderTemplateChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderTemplateChargesQuery, GetWorkOrderTemplateChargesQueryVariables>(GetWorkOrderTemplateChargesDocument, options);
        }
export type GetWorkOrderTemplateChargesQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateChargesQuery>;
export type GetWorkOrderTemplateChargesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateChargesLazyQuery>;
export type GetWorkOrderTemplateChargesQueryResult = Apollo.QueryResult<GetWorkOrderTemplateChargesQuery, GetWorkOrderTemplateChargesQueryVariables>;
export const GetWorkOrderTemplateRelatedRecordsDocument = gql`
    query getWorkOrderTemplateRelatedRecords($workOrderTemplateId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getWorkOrderTemplateRelatedRecords(
    workOrderTemplateId: $workOrderTemplateId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      status {
        ...StatusCoreFields
        color
      }
      assignedTo {
        ...UserCoreFields
      }
      createdAt
      charges
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderTemplateRelatedRecordsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderTemplateRelatedRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderTemplateRelatedRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderTemplateRelatedRecordsQuery({
 *   variables: {
 *      workOrderTemplateId: // value for 'workOrderTemplateId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderTemplateRelatedRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderTemplateRelatedRecordsQuery, GetWorkOrderTemplateRelatedRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderTemplateRelatedRecordsQuery, GetWorkOrderTemplateRelatedRecordsQueryVariables>(GetWorkOrderTemplateRelatedRecordsDocument, options);
      }
export function useGetWorkOrderTemplateRelatedRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderTemplateRelatedRecordsQuery, GetWorkOrderTemplateRelatedRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderTemplateRelatedRecordsQuery, GetWorkOrderTemplateRelatedRecordsQueryVariables>(GetWorkOrderTemplateRelatedRecordsDocument, options);
        }
export type GetWorkOrderTemplateRelatedRecordsQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateRelatedRecordsQuery>;
export type GetWorkOrderTemplateRelatedRecordsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderTemplateRelatedRecordsLazyQuery>;
export type GetWorkOrderTemplateRelatedRecordsQueryResult = Apollo.QueryResult<GetWorkOrderTemplateRelatedRecordsQuery, GetWorkOrderTemplateRelatedRecordsQueryVariables>;
export const ExportWorkOrderTemplatesDocument = gql`
    query exportWorkOrderTemplates($search: String, $to: DateTime, $from: DateTime, $buildingIds: [String!], $recordStatuses: [RRuleStatuses!], $categoryIds: [String!], $companyIds: [String!]) {
  exportWorkOrderTemplates(
    search: $search
    to: $to
    from: $from
    buildingIds: $buildingIds
    recordStatuses: $recordStatuses
    categoryIds: $categoryIds
    companyIds: $companyIds
  )
}
    `;

/**
 * __useExportWorkOrderTemplatesQuery__
 *
 * To run a query within a React component, call `useExportWorkOrderTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWorkOrderTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWorkOrderTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      buildingIds: // value for 'buildingIds'
 *      recordStatuses: // value for 'recordStatuses'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useExportWorkOrderTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ExportWorkOrderTemplatesQuery, ExportWorkOrderTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportWorkOrderTemplatesQuery, ExportWorkOrderTemplatesQueryVariables>(ExportWorkOrderTemplatesDocument, options);
      }
export function useExportWorkOrderTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportWorkOrderTemplatesQuery, ExportWorkOrderTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportWorkOrderTemplatesQuery, ExportWorkOrderTemplatesQueryVariables>(ExportWorkOrderTemplatesDocument, options);
        }
export type ExportWorkOrderTemplatesQueryHookResult = ReturnType<typeof useExportWorkOrderTemplatesQuery>;
export type ExportWorkOrderTemplatesLazyQueryHookResult = ReturnType<typeof useExportWorkOrderTemplatesLazyQuery>;
export type ExportWorkOrderTemplatesQueryResult = Apollo.QueryResult<ExportWorkOrderTemplatesQuery, ExportWorkOrderTemplatesQueryVariables>;
export const CreateWorkOrderEmailDocument = gql`
    mutation createWorkOrderEmail($data: WorkOrderEmailInput!) {
  createWorkOrderEmail(input: $data) {
    id
    email
  }
}
    `;
export type CreateWorkOrderEmailMutationFn = Apollo.MutationFunction<CreateWorkOrderEmailMutation, CreateWorkOrderEmailMutationVariables>;

/**
 * __useCreateWorkOrderEmailMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderEmailMutation, { data, loading, error }] = useCreateWorkOrderEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkOrderEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderEmailMutation, CreateWorkOrderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderEmailMutation, CreateWorkOrderEmailMutationVariables>(CreateWorkOrderEmailDocument, options);
      }
export type CreateWorkOrderEmailMutationHookResult = ReturnType<typeof useCreateWorkOrderEmailMutation>;
export type CreateWorkOrderEmailMutationResult = Apollo.MutationResult<CreateWorkOrderEmailMutation>;
export type CreateWorkOrderEmailMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderEmailMutation, CreateWorkOrderEmailMutationVariables>;
export const UpdateWorkOrderEmailDocument = gql`
    mutation updateWorkOrderEmail($id: String!, $data: WorkOrderEmailInput!) {
  updateWorkOrderEmail(id: $id, input: $data) {
    ...WorkOrderEmailFields
  }
}
    ${WorkOrderEmailFieldsFragmentDoc}`;
export type UpdateWorkOrderEmailMutationFn = Apollo.MutationFunction<UpdateWorkOrderEmailMutation, UpdateWorkOrderEmailMutationVariables>;

/**
 * __useUpdateWorkOrderEmailMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderEmailMutation, { data, loading, error }] = useUpdateWorkOrderEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkOrderEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderEmailMutation, UpdateWorkOrderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderEmailMutation, UpdateWorkOrderEmailMutationVariables>(UpdateWorkOrderEmailDocument, options);
      }
export type UpdateWorkOrderEmailMutationHookResult = ReturnType<typeof useUpdateWorkOrderEmailMutation>;
export type UpdateWorkOrderEmailMutationResult = Apollo.MutationResult<UpdateWorkOrderEmailMutation>;
export type UpdateWorkOrderEmailMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderEmailMutation, UpdateWorkOrderEmailMutationVariables>;
export const ToggleWorkOrderEmailDocument = gql`
    mutation toggleWorkOrderEmail($id: String!) {
  toggleWorkOrderEmail(id: $id)
}
    `;
export type ToggleWorkOrderEmailMutationFn = Apollo.MutationFunction<ToggleWorkOrderEmailMutation, ToggleWorkOrderEmailMutationVariables>;

/**
 * __useToggleWorkOrderEmailMutation__
 *
 * To run a mutation, you first call `useToggleWorkOrderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkOrderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkOrderEmailMutation, { data, loading, error }] = useToggleWorkOrderEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleWorkOrderEmailMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkOrderEmailMutation, ToggleWorkOrderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkOrderEmailMutation, ToggleWorkOrderEmailMutationVariables>(ToggleWorkOrderEmailDocument, options);
      }
export type ToggleWorkOrderEmailMutationHookResult = ReturnType<typeof useToggleWorkOrderEmailMutation>;
export type ToggleWorkOrderEmailMutationResult = Apollo.MutationResult<ToggleWorkOrderEmailMutation>;
export type ToggleWorkOrderEmailMutationOptions = Apollo.BaseMutationOptions<ToggleWorkOrderEmailMutation, ToggleWorkOrderEmailMutationVariables>;
export const RemoveWorkOrderEmailsDocument = gql`
    mutation removeWorkOrderEmails($data: DeleteRecordsInput!) {
  removeWorkOrderEmails(input: $data)
}
    `;
export type RemoveWorkOrderEmailsMutationFn = Apollo.MutationFunction<RemoveWorkOrderEmailsMutation, RemoveWorkOrderEmailsMutationVariables>;

/**
 * __useRemoveWorkOrderEmailsMutation__
 *
 * To run a mutation, you first call `useRemoveWorkOrderEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkOrderEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkOrderEmailsMutation, { data, loading, error }] = useRemoveWorkOrderEmailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWorkOrderEmailsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkOrderEmailsMutation, RemoveWorkOrderEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkOrderEmailsMutation, RemoveWorkOrderEmailsMutationVariables>(RemoveWorkOrderEmailsDocument, options);
      }
export type RemoveWorkOrderEmailsMutationHookResult = ReturnType<typeof useRemoveWorkOrderEmailsMutation>;
export type RemoveWorkOrderEmailsMutationResult = Apollo.MutationResult<RemoveWorkOrderEmailsMutation>;
export type RemoveWorkOrderEmailsMutationOptions = Apollo.BaseMutationOptions<RemoveWorkOrderEmailsMutation, RemoveWorkOrderEmailsMutationVariables>;
export const GetWorkOrderEmailsDocument = gql`
    query getWorkOrderEmails($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $active: Boolean) {
  getWorkOrderEmails(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...WorkOrderEmailCoreFields
      email
      index
      active
      createdBy {
        ...UserCoreFields
      }
      building {
        ...BuildingCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${WorkOrderEmailCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderEmailsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderEmailsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetWorkOrderEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkOrderEmailsQuery, GetWorkOrderEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderEmailsQuery, GetWorkOrderEmailsQueryVariables>(GetWorkOrderEmailsDocument, options);
      }
export function useGetWorkOrderEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderEmailsQuery, GetWorkOrderEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderEmailsQuery, GetWorkOrderEmailsQueryVariables>(GetWorkOrderEmailsDocument, options);
        }
export type GetWorkOrderEmailsQueryHookResult = ReturnType<typeof useGetWorkOrderEmailsQuery>;
export type GetWorkOrderEmailsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderEmailsLazyQuery>;
export type GetWorkOrderEmailsQueryResult = Apollo.QueryResult<GetWorkOrderEmailsQuery, GetWorkOrderEmailsQueryVariables>;
export const GetWorkOrderEmailDocument = gql`
    query getWorkOrderEmail($id: String!) {
  getWorkOrderEmail(id: $id) {
    ...WorkOrderEmailFields
  }
}
    ${WorkOrderEmailFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderEmailQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkOrderEmailQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderEmailQuery, GetWorkOrderEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderEmailQuery, GetWorkOrderEmailQueryVariables>(GetWorkOrderEmailDocument, options);
      }
export function useGetWorkOrderEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderEmailQuery, GetWorkOrderEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderEmailQuery, GetWorkOrderEmailQueryVariables>(GetWorkOrderEmailDocument, options);
        }
export type GetWorkOrderEmailQueryHookResult = ReturnType<typeof useGetWorkOrderEmailQuery>;
export type GetWorkOrderEmailLazyQueryHookResult = ReturnType<typeof useGetWorkOrderEmailLazyQuery>;
export type GetWorkOrderEmailQueryResult = Apollo.QueryResult<GetWorkOrderEmailQuery, GetWorkOrderEmailQueryVariables>;
export const CreateGuestWorkOrderFormDocument = gql`
    mutation createGuestWorkOrderForm($data: GuestWOFormInput!) {
  createGuestWorkOrderForm(input: $data) {
    id
  }
}
    `;
export type CreateGuestWorkOrderFormMutationFn = Apollo.MutationFunction<CreateGuestWorkOrderFormMutation, CreateGuestWorkOrderFormMutationVariables>;

/**
 * __useCreateGuestWorkOrderFormMutation__
 *
 * To run a mutation, you first call `useCreateGuestWorkOrderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestWorkOrderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestWorkOrderFormMutation, { data, loading, error }] = useCreateGuestWorkOrderFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGuestWorkOrderFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuestWorkOrderFormMutation, CreateGuestWorkOrderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuestWorkOrderFormMutation, CreateGuestWorkOrderFormMutationVariables>(CreateGuestWorkOrderFormDocument, options);
      }
export type CreateGuestWorkOrderFormMutationHookResult = ReturnType<typeof useCreateGuestWorkOrderFormMutation>;
export type CreateGuestWorkOrderFormMutationResult = Apollo.MutationResult<CreateGuestWorkOrderFormMutation>;
export type CreateGuestWorkOrderFormMutationOptions = Apollo.BaseMutationOptions<CreateGuestWorkOrderFormMutation, CreateGuestWorkOrderFormMutationVariables>;
export const UpdateGuestWorkOrderFormDocument = gql`
    mutation updateGuestWorkOrderForm($formId: String!, $data: GuestWOFormUpdateInput!) {
  updateGuestWorkOrderForm(formId: $formId, input: $data) {
    ...WorkOrderGuestFormFields
  }
}
    ${WorkOrderGuestFormFieldsFragmentDoc}`;
export type UpdateGuestWorkOrderFormMutationFn = Apollo.MutationFunction<UpdateGuestWorkOrderFormMutation, UpdateGuestWorkOrderFormMutationVariables>;

/**
 * __useUpdateGuestWorkOrderFormMutation__
 *
 * To run a mutation, you first call `useUpdateGuestWorkOrderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestWorkOrderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestWorkOrderFormMutation, { data, loading, error }] = useUpdateGuestWorkOrderFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGuestWorkOrderFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuestWorkOrderFormMutation, UpdateGuestWorkOrderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuestWorkOrderFormMutation, UpdateGuestWorkOrderFormMutationVariables>(UpdateGuestWorkOrderFormDocument, options);
      }
export type UpdateGuestWorkOrderFormMutationHookResult = ReturnType<typeof useUpdateGuestWorkOrderFormMutation>;
export type UpdateGuestWorkOrderFormMutationResult = Apollo.MutationResult<UpdateGuestWorkOrderFormMutation>;
export type UpdateGuestWorkOrderFormMutationOptions = Apollo.BaseMutationOptions<UpdateGuestWorkOrderFormMutation, UpdateGuestWorkOrderFormMutationVariables>;
export const ToggleGuestWorkOrderFormDocument = gql`
    mutation toggleGuestWorkOrderForm($formId: String!) {
  toggleGuestWorkOrderForm(formId: $formId)
}
    `;
export type ToggleGuestWorkOrderFormMutationFn = Apollo.MutationFunction<ToggleGuestWorkOrderFormMutation, ToggleGuestWorkOrderFormMutationVariables>;

/**
 * __useToggleGuestWorkOrderFormMutation__
 *
 * To run a mutation, you first call `useToggleGuestWorkOrderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGuestWorkOrderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGuestWorkOrderFormMutation, { data, loading, error }] = useToggleGuestWorkOrderFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useToggleGuestWorkOrderFormMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGuestWorkOrderFormMutation, ToggleGuestWorkOrderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGuestWorkOrderFormMutation, ToggleGuestWorkOrderFormMutationVariables>(ToggleGuestWorkOrderFormDocument, options);
      }
export type ToggleGuestWorkOrderFormMutationHookResult = ReturnType<typeof useToggleGuestWorkOrderFormMutation>;
export type ToggleGuestWorkOrderFormMutationResult = Apollo.MutationResult<ToggleGuestWorkOrderFormMutation>;
export type ToggleGuestWorkOrderFormMutationOptions = Apollo.BaseMutationOptions<ToggleGuestWorkOrderFormMutation, ToggleGuestWorkOrderFormMutationVariables>;
export const RemoveGuestWorkOrderFormDocument = gql`
    mutation removeGuestWorkOrderForm($data: DeleteRecordsInput!) {
  removeGuestWorkOrderForm(input: $data)
}
    `;
export type RemoveGuestWorkOrderFormMutationFn = Apollo.MutationFunction<RemoveGuestWorkOrderFormMutation, RemoveGuestWorkOrderFormMutationVariables>;

/**
 * __useRemoveGuestWorkOrderFormMutation__
 *
 * To run a mutation, you first call `useRemoveGuestWorkOrderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGuestWorkOrderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGuestWorkOrderFormMutation, { data, loading, error }] = useRemoveGuestWorkOrderFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGuestWorkOrderFormMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGuestWorkOrderFormMutation, RemoveGuestWorkOrderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGuestWorkOrderFormMutation, RemoveGuestWorkOrderFormMutationVariables>(RemoveGuestWorkOrderFormDocument, options);
      }
export type RemoveGuestWorkOrderFormMutationHookResult = ReturnType<typeof useRemoveGuestWorkOrderFormMutation>;
export type RemoveGuestWorkOrderFormMutationResult = Apollo.MutationResult<RemoveGuestWorkOrderFormMutation>;
export type RemoveGuestWorkOrderFormMutationOptions = Apollo.BaseMutationOptions<RemoveGuestWorkOrderFormMutation, RemoveGuestWorkOrderFormMutationVariables>;
export const CreatePublicWorkOrderDocument = gql`
    mutation createPublicWorkOrder($data: WorkOrderPublicInput!) {
  createPublicWorkOrder(input: $data)
}
    `;
export type CreatePublicWorkOrderMutationFn = Apollo.MutationFunction<CreatePublicWorkOrderMutation, CreatePublicWorkOrderMutationVariables>;

/**
 * __useCreatePublicWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreatePublicWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicWorkOrderMutation, { data, loading, error }] = useCreatePublicWorkOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePublicWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicWorkOrderMutation, CreatePublicWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicWorkOrderMutation, CreatePublicWorkOrderMutationVariables>(CreatePublicWorkOrderDocument, options);
      }
export type CreatePublicWorkOrderMutationHookResult = ReturnType<typeof useCreatePublicWorkOrderMutation>;
export type CreatePublicWorkOrderMutationResult = Apollo.MutationResult<CreatePublicWorkOrderMutation>;
export type CreatePublicWorkOrderMutationOptions = Apollo.BaseMutationOptions<CreatePublicWorkOrderMutation, CreatePublicWorkOrderMutationVariables>;
export const GetGuestWorkOrderFormsDocument = gql`
    query getGuestWorkOrderForms($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $active: Boolean) {
  getGuestWorkOrderForms(
    take: $take
    after: $after
    before: $before
    search: $search
    buildingIds: $buildingIds
    active: $active
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...WorkOrderGuestFormCoreFields
      index
      subTitle
      active
      createdBy {
        ...UserCoreFields
      }
      building {
        ...BuildingCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${WorkOrderGuestFormCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetGuestWorkOrderFormsQuery__
 *
 * To run a query within a React component, call `useGetGuestWorkOrderFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestWorkOrderFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestWorkOrderFormsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetGuestWorkOrderFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetGuestWorkOrderFormsQuery, GetGuestWorkOrderFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestWorkOrderFormsQuery, GetGuestWorkOrderFormsQueryVariables>(GetGuestWorkOrderFormsDocument, options);
      }
export function useGetGuestWorkOrderFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestWorkOrderFormsQuery, GetGuestWorkOrderFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestWorkOrderFormsQuery, GetGuestWorkOrderFormsQueryVariables>(GetGuestWorkOrderFormsDocument, options);
        }
export type GetGuestWorkOrderFormsQueryHookResult = ReturnType<typeof useGetGuestWorkOrderFormsQuery>;
export type GetGuestWorkOrderFormsLazyQueryHookResult = ReturnType<typeof useGetGuestWorkOrderFormsLazyQuery>;
export type GetGuestWorkOrderFormsQueryResult = Apollo.QueryResult<GetGuestWorkOrderFormsQuery, GetGuestWorkOrderFormsQueryVariables>;
export const GetGuestWorkOrderFormDocument = gql`
    query getGuestWorkOrderForm($formId: String!) {
  getGuestWorkOrderForm(formId: $formId) {
    ...WorkOrderGuestFormFields
  }
}
    ${WorkOrderGuestFormFieldsFragmentDoc}`;

/**
 * __useGetGuestWorkOrderFormQuery__
 *
 * To run a query within a React component, call `useGetGuestWorkOrderFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestWorkOrderFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestWorkOrderFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetGuestWorkOrderFormQuery(baseOptions: Apollo.QueryHookOptions<GetGuestWorkOrderFormQuery, GetGuestWorkOrderFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestWorkOrderFormQuery, GetGuestWorkOrderFormQueryVariables>(GetGuestWorkOrderFormDocument, options);
      }
export function useGetGuestWorkOrderFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestWorkOrderFormQuery, GetGuestWorkOrderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestWorkOrderFormQuery, GetGuestWorkOrderFormQueryVariables>(GetGuestWorkOrderFormDocument, options);
        }
export type GetGuestWorkOrderFormQueryHookResult = ReturnType<typeof useGetGuestWorkOrderFormQuery>;
export type GetGuestWorkOrderFormLazyQueryHookResult = ReturnType<typeof useGetGuestWorkOrderFormLazyQuery>;
export type GetGuestWorkOrderFormQueryResult = Apollo.QueryResult<GetGuestWorkOrderFormQuery, GetGuestWorkOrderFormQueryVariables>;
export const GetPublicGuestWorkOrderFormDocument = gql`
    query getPublicGuestWorkOrderForm($formId: String!) {
  getGuestWorkOrderForm(formId: $formId) {
    ...WorkOrderGuestFormCoreFields
    subTitle
    propertyId
    building {
      ...BuildingCoreFields
    }
    category {
      ...CategoryCoreFields
    }
    hasStatus
    statusRequired
    status {
      ...StatusCoreFields
      color
    }
    hasPriority
    priorityRequired
    priority {
      ...PriorityCoreFields
      color
    }
    hasAssignee
    assigneeRequired
    assignee {
      ...UserCoreFields
    }
    hasFloor
    floorRequired
    floor {
      ...FloorCoreFields
    }
    hasSuite
    suiteRequired
    suite {
      ...SuiteCoreFields
    }
    hasAttachments
    attachmentsRequired
    attachmentTypes
  }
}
    ${WorkOrderGuestFormCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetPublicGuestWorkOrderFormQuery__
 *
 * To run a query within a React component, call `useGetPublicGuestWorkOrderFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicGuestWorkOrderFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicGuestWorkOrderFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetPublicGuestWorkOrderFormQuery(baseOptions: Apollo.QueryHookOptions<GetPublicGuestWorkOrderFormQuery, GetPublicGuestWorkOrderFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicGuestWorkOrderFormQuery, GetPublicGuestWorkOrderFormQueryVariables>(GetPublicGuestWorkOrderFormDocument, options);
      }
export function useGetPublicGuestWorkOrderFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicGuestWorkOrderFormQuery, GetPublicGuestWorkOrderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicGuestWorkOrderFormQuery, GetPublicGuestWorkOrderFormQueryVariables>(GetPublicGuestWorkOrderFormDocument, options);
        }
export type GetPublicGuestWorkOrderFormQueryHookResult = ReturnType<typeof useGetPublicGuestWorkOrderFormQuery>;
export type GetPublicGuestWorkOrderFormLazyQueryHookResult = ReturnType<typeof useGetPublicGuestWorkOrderFormLazyQuery>;
export type GetPublicGuestWorkOrderFormQueryResult = Apollo.QueryResult<GetPublicGuestWorkOrderFormQuery, GetPublicGuestWorkOrderFormQueryVariables>;
export const GetWorkOrderStatusSettingsDocument = gql`
    query getWorkOrderStatusSettings {
  getWorkOrderStatusSetting {
    ...WorkOrdersStatusSettingsFields
  }
}
    ${WorkOrdersStatusSettingsFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderStatusSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderStatusSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderStatusSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderStatusSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkOrderStatusSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>(GetWorkOrderStatusSettingsDocument, options);
      }
export function useGetWorkOrderStatusSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>(GetWorkOrderStatusSettingsDocument, options);
        }
export type GetWorkOrderStatusSettingsQueryHookResult = ReturnType<typeof useGetWorkOrderStatusSettingsQuery>;
export type GetWorkOrderStatusSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderStatusSettingsLazyQuery>;
export type GetWorkOrderStatusSettingsQueryResult = Apollo.QueryResult<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>;
export const CreateWorkOrderDocument = gql`
    mutation createWorkOrder($data: WorkOrderInput!) {
  createWorkOrder(input: $data) {
    id
  }
}
    `;
export type CreateWorkOrderMutationFn = Apollo.MutationFunction<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>;

/**
 * __useCreateWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderMutation, { data, loading, error }] = useCreateWorkOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>(CreateWorkOrderDocument, options);
      }
export type CreateWorkOrderMutationHookResult = ReturnType<typeof useCreateWorkOrderMutation>;
export type CreateWorkOrderMutationResult = Apollo.MutationResult<CreateWorkOrderMutation>;
export type CreateWorkOrderMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>;
export const UpdateWorkOrderDocument = gql`
    mutation updateWorkOrder($id: String!, $data: WorkOrderUpdateInput!) {
  updateWorkOrder(workOrderId: $id, input: $data) {
    ...WorkOrderFields
  }
}
    ${WorkOrderFieldsFragmentDoc}`;
export type UpdateWorkOrderMutationFn = Apollo.MutationFunction<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>;

/**
 * __useUpdateWorkOrderMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderMutation, { data, loading, error }] = useUpdateWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>(UpdateWorkOrderDocument, options);
      }
export type UpdateWorkOrderMutationHookResult = ReturnType<typeof useUpdateWorkOrderMutation>;
export type UpdateWorkOrderMutationResult = Apollo.MutationResult<UpdateWorkOrderMutation>;
export type UpdateWorkOrderMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>;
export const BulkStatusWoDocument = gql`
    mutation bulkStatusWO($ids: [String!]!, $statusId: String) {
  bulkStatusWO(ids: $ids, statusId: $statusId) {
    errorCount
    errorMessages
    successCount
    data {
      id
      status {
        ...StatusCoreFields
        color
      }
      closedAt
    }
  }
}
    ${StatusCoreFieldsFragmentDoc}`;
export type BulkStatusWoMutationFn = Apollo.MutationFunction<BulkStatusWoMutation, BulkStatusWoMutationVariables>;

/**
 * __useBulkStatusWoMutation__
 *
 * To run a mutation, you first call `useBulkStatusWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStatusWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStatusWoMutation, { data, loading, error }] = useBulkStatusWoMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useBulkStatusWoMutation(baseOptions?: Apollo.MutationHookOptions<BulkStatusWoMutation, BulkStatusWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStatusWoMutation, BulkStatusWoMutationVariables>(BulkStatusWoDocument, options);
      }
export type BulkStatusWoMutationHookResult = ReturnType<typeof useBulkStatusWoMutation>;
export type BulkStatusWoMutationResult = Apollo.MutationResult<BulkStatusWoMutation>;
export type BulkStatusWoMutationOptions = Apollo.BaseMutationOptions<BulkStatusWoMutation, BulkStatusWoMutationVariables>;
export const BulkAssigneeWoDocument = gql`
    mutation bulkAssigneeWO($ids: [String!]!, $assignedToId: String) {
  bulkAssigneeWO(ids: $ids, assignedToId: $assignedToId) {
    errorCount
    errorMessages
    successCount
    data {
      id
      assignedTo {
        ...UserCoreFields
      }
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type BulkAssigneeWoMutationFn = Apollo.MutationFunction<BulkAssigneeWoMutation, BulkAssigneeWoMutationVariables>;

/**
 * __useBulkAssigneeWoMutation__
 *
 * To run a mutation, you first call `useBulkAssigneeWoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssigneeWoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssigneeWoMutation, { data, loading, error }] = useBulkAssigneeWoMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useBulkAssigneeWoMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssigneeWoMutation, BulkAssigneeWoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssigneeWoMutation, BulkAssigneeWoMutationVariables>(BulkAssigneeWoDocument, options);
      }
export type BulkAssigneeWoMutationHookResult = ReturnType<typeof useBulkAssigneeWoMutation>;
export type BulkAssigneeWoMutationResult = Apollo.MutationResult<BulkAssigneeWoMutation>;
export type BulkAssigneeWoMutationOptions = Apollo.BaseMutationOptions<BulkAssigneeWoMutation, BulkAssigneeWoMutationVariables>;
export const ArchiveWorkOrdersDocument = gql`
    mutation archiveWorkOrders($ids: [String!]!) {
  archiveWorkOrders(ids: $ids)
}
    `;
export type ArchiveWorkOrdersMutationFn = Apollo.MutationFunction<ArchiveWorkOrdersMutation, ArchiveWorkOrdersMutationVariables>;

/**
 * __useArchiveWorkOrdersMutation__
 *
 * To run a mutation, you first call `useArchiveWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkOrdersMutation, { data, loading, error }] = useArchiveWorkOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWorkOrdersMutation, ArchiveWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorkOrdersMutation, ArchiveWorkOrdersMutationVariables>(ArchiveWorkOrdersDocument, options);
      }
export type ArchiveWorkOrdersMutationHookResult = ReturnType<typeof useArchiveWorkOrdersMutation>;
export type ArchiveWorkOrdersMutationResult = Apollo.MutationResult<ArchiveWorkOrdersMutation>;
export type ArchiveWorkOrdersMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkOrdersMutation, ArchiveWorkOrdersMutationVariables>;
export const UnArchiveWorkOrdersDocument = gql`
    mutation unArchiveWorkOrders($ids: [String!]!) {
  unArchiveWorkOrders(ids: $ids)
}
    `;
export type UnArchiveWorkOrdersMutationFn = Apollo.MutationFunction<UnArchiveWorkOrdersMutation, UnArchiveWorkOrdersMutationVariables>;

/**
 * __useUnArchiveWorkOrdersMutation__
 *
 * To run a mutation, you first call `useUnArchiveWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveWorkOrdersMutation, { data, loading, error }] = useUnArchiveWorkOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnArchiveWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveWorkOrdersMutation, UnArchiveWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveWorkOrdersMutation, UnArchiveWorkOrdersMutationVariables>(UnArchiveWorkOrdersDocument, options);
      }
export type UnArchiveWorkOrdersMutationHookResult = ReturnType<typeof useUnArchiveWorkOrdersMutation>;
export type UnArchiveWorkOrdersMutationResult = Apollo.MutationResult<UnArchiveWorkOrdersMutation>;
export type UnArchiveWorkOrdersMutationOptions = Apollo.BaseMutationOptions<UnArchiveWorkOrdersMutation, UnArchiveWorkOrdersMutationVariables>;
export const RemoveWorkOrdersDocument = gql`
    mutation removeWorkOrders($data: DeleteRecordsInput!) {
  removeWorkOrders(input: $data)
}
    `;
export type RemoveWorkOrdersMutationFn = Apollo.MutationFunction<RemoveWorkOrdersMutation, RemoveWorkOrdersMutationVariables>;

/**
 * __useRemoveWorkOrdersMutation__
 *
 * To run a mutation, you first call `useRemoveWorkOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkOrdersMutation, { data, loading, error }] = useRemoveWorkOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWorkOrdersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkOrdersMutation, RemoveWorkOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkOrdersMutation, RemoveWorkOrdersMutationVariables>(RemoveWorkOrdersDocument, options);
      }
export type RemoveWorkOrdersMutationHookResult = ReturnType<typeof useRemoveWorkOrdersMutation>;
export type RemoveWorkOrdersMutationResult = Apollo.MutationResult<RemoveWorkOrdersMutation>;
export type RemoveWorkOrdersMutationOptions = Apollo.BaseMutationOptions<RemoveWorkOrdersMutation, RemoveWorkOrdersMutationVariables>;
export const DeleteWoAttachmentDocument = gql`
    mutation deleteWOAttachment($attachmentId: String!, $id: String!) {
  deleteWOAttachment(attachmentId: $attachmentId, id: $id)
}
    `;
export type DeleteWoAttachmentMutationFn = Apollo.MutationFunction<DeleteWoAttachmentMutation, DeleteWoAttachmentMutationVariables>;

/**
 * __useDeleteWoAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteWoAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWoAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWoAttachmentMutation, { data, loading, error }] = useDeleteWoAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWoAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWoAttachmentMutation, DeleteWoAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWoAttachmentMutation, DeleteWoAttachmentMutationVariables>(DeleteWoAttachmentDocument, options);
      }
export type DeleteWoAttachmentMutationHookResult = ReturnType<typeof useDeleteWoAttachmentMutation>;
export type DeleteWoAttachmentMutationResult = Apollo.MutationResult<DeleteWoAttachmentMutation>;
export type DeleteWoAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteWoAttachmentMutation, DeleteWoAttachmentMutationVariables>;
export const CreateWoReviewDocument = gql`
    mutation createWOReview($data: WorkOrderReviewInput!) {
  createWOReview(input: $data)
}
    `;
export type CreateWoReviewMutationFn = Apollo.MutationFunction<CreateWoReviewMutation, CreateWoReviewMutationVariables>;

/**
 * __useCreateWoReviewMutation__
 *
 * To run a mutation, you first call `useCreateWoReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWoReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWoReviewMutation, { data, loading, error }] = useCreateWoReviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWoReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateWoReviewMutation, CreateWoReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWoReviewMutation, CreateWoReviewMutationVariables>(CreateWoReviewDocument, options);
      }
export type CreateWoReviewMutationHookResult = ReturnType<typeof useCreateWoReviewMutation>;
export type CreateWoReviewMutationResult = Apollo.MutationResult<CreateWoReviewMutation>;
export type CreateWoReviewMutationOptions = Apollo.BaseMutationOptions<CreateWoReviewMutation, CreateWoReviewMutationVariables>;
export const WorkOrderSubscribeDocument = gql`
    mutation workOrderSubscribe($id: String!, $userId: String!) {
  workOrderSubscribe(workOrderId: $id, userId: $userId) {
    id
    firstName
    lastName
  }
}
    `;
export type WorkOrderSubscribeMutationFn = Apollo.MutationFunction<WorkOrderSubscribeMutation, WorkOrderSubscribeMutationVariables>;

/**
 * __useWorkOrderSubscribeMutation__
 *
 * To run a mutation, you first call `useWorkOrderSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workOrderSubscribeMutation, { data, loading, error }] = useWorkOrderSubscribeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkOrderSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<WorkOrderSubscribeMutation, WorkOrderSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkOrderSubscribeMutation, WorkOrderSubscribeMutationVariables>(WorkOrderSubscribeDocument, options);
      }
export type WorkOrderSubscribeMutationHookResult = ReturnType<typeof useWorkOrderSubscribeMutation>;
export type WorkOrderSubscribeMutationResult = Apollo.MutationResult<WorkOrderSubscribeMutation>;
export type WorkOrderSubscribeMutationOptions = Apollo.BaseMutationOptions<WorkOrderSubscribeMutation, WorkOrderSubscribeMutationVariables>;
export const AcknowledgeWorkOrderDocument = gql`
    mutation acknowledgeWorkOrder($id: String!) {
  acknowledgeWorkOrder(workOrderId: $id) {
    ...WorkOrderFields
  }
}
    ${WorkOrderFieldsFragmentDoc}`;
export type AcknowledgeWorkOrderMutationFn = Apollo.MutationFunction<AcknowledgeWorkOrderMutation, AcknowledgeWorkOrderMutationVariables>;

/**
 * __useAcknowledgeWorkOrderMutation__
 *
 * To run a mutation, you first call `useAcknowledgeWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeWorkOrderMutation, { data, loading, error }] = useAcknowledgeWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcknowledgeWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeWorkOrderMutation, AcknowledgeWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeWorkOrderMutation, AcknowledgeWorkOrderMutationVariables>(AcknowledgeWorkOrderDocument, options);
      }
export type AcknowledgeWorkOrderMutationHookResult = ReturnType<typeof useAcknowledgeWorkOrderMutation>;
export type AcknowledgeWorkOrderMutationResult = Apollo.MutationResult<AcknowledgeWorkOrderMutation>;
export type AcknowledgeWorkOrderMutationOptions = Apollo.BaseMutationOptions<AcknowledgeWorkOrderMutation, AcknowledgeWorkOrderMutationVariables>;
export const ShareWorkOrderDocument = gql`
    mutation shareWorkOrder($data: WorkOrderShareInput!) {
  shareWorkOrder(input: $data)
}
    `;
export type ShareWorkOrderMutationFn = Apollo.MutationFunction<ShareWorkOrderMutation, ShareWorkOrderMutationVariables>;

/**
 * __useShareWorkOrderMutation__
 *
 * To run a mutation, you first call `useShareWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareWorkOrderMutation, { data, loading, error }] = useShareWorkOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useShareWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShareWorkOrderMutation, ShareWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareWorkOrderMutation, ShareWorkOrderMutationVariables>(ShareWorkOrderDocument, options);
      }
export type ShareWorkOrderMutationHookResult = ReturnType<typeof useShareWorkOrderMutation>;
export type ShareWorkOrderMutationResult = Apollo.MutationResult<ShareWorkOrderMutation>;
export type ShareWorkOrderMutationOptions = Apollo.BaseMutationOptions<ShareWorkOrderMutation, ShareWorkOrderMutationVariables>;
export const AddWorkOrderEquipmentDocument = gql`
    mutation addWorkOrderEquipment($data: WorkOrderEquipmentAddInput!) {
  addWorkOrderEquipment(input: $data)
}
    `;
export type AddWorkOrderEquipmentMutationFn = Apollo.MutationFunction<AddWorkOrderEquipmentMutation, AddWorkOrderEquipmentMutationVariables>;

/**
 * __useAddWorkOrderEquipmentMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderEquipmentMutation, { data, loading, error }] = useAddWorkOrderEquipmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderEquipmentMutation, AddWorkOrderEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderEquipmentMutation, AddWorkOrderEquipmentMutationVariables>(AddWorkOrderEquipmentDocument, options);
      }
export type AddWorkOrderEquipmentMutationHookResult = ReturnType<typeof useAddWorkOrderEquipmentMutation>;
export type AddWorkOrderEquipmentMutationResult = Apollo.MutationResult<AddWorkOrderEquipmentMutation>;
export type AddWorkOrderEquipmentMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderEquipmentMutation, AddWorkOrderEquipmentMutationVariables>;
export const RemoveWorkOrderEquipmentDocument = gql`
    mutation removeWorkOrderEquipment($data: WorkOrderEquipmentRemoveInput!) {
  removeWorkOrderEquipment(input: $data)
}
    `;
export type RemoveWorkOrderEquipmentMutationFn = Apollo.MutationFunction<RemoveWorkOrderEquipmentMutation, RemoveWorkOrderEquipmentMutationVariables>;

/**
 * __useRemoveWorkOrderEquipmentMutation__
 *
 * To run a mutation, you first call `useRemoveWorkOrderEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkOrderEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkOrderEquipmentMutation, { data, loading, error }] = useRemoveWorkOrderEquipmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveWorkOrderEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkOrderEquipmentMutation, RemoveWorkOrderEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkOrderEquipmentMutation, RemoveWorkOrderEquipmentMutationVariables>(RemoveWorkOrderEquipmentDocument, options);
      }
export type RemoveWorkOrderEquipmentMutationHookResult = ReturnType<typeof useRemoveWorkOrderEquipmentMutation>;
export type RemoveWorkOrderEquipmentMutationResult = Apollo.MutationResult<RemoveWorkOrderEquipmentMutation>;
export type RemoveWorkOrderEquipmentMutationOptions = Apollo.BaseMutationOptions<RemoveWorkOrderEquipmentMutation, RemoveWorkOrderEquipmentMutationVariables>;
export const UpdateWorkOrderCustomFieldDocument = gql`
    mutation updateWorkOrderCustomField($id: String!, $value: CustomFieldScalar) {
  updateWorkOrderCustomField(id: $id, value: $value) {
    id
    value
    customField {
      ...CustomFieldFields
    }
  }
}
    ${CustomFieldFieldsFragmentDoc}`;
export type UpdateWorkOrderCustomFieldMutationFn = Apollo.MutationFunction<UpdateWorkOrderCustomFieldMutation, UpdateWorkOrderCustomFieldMutationVariables>;

/**
 * __useUpdateWorkOrderCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderCustomFieldMutation, { data, loading, error }] = useUpdateWorkOrderCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateWorkOrderCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderCustomFieldMutation, UpdateWorkOrderCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderCustomFieldMutation, UpdateWorkOrderCustomFieldMutationVariables>(UpdateWorkOrderCustomFieldDocument, options);
      }
export type UpdateWorkOrderCustomFieldMutationHookResult = ReturnType<typeof useUpdateWorkOrderCustomFieldMutation>;
export type UpdateWorkOrderCustomFieldMutationResult = Apollo.MutationResult<UpdateWorkOrderCustomFieldMutation>;
export type UpdateWorkOrderCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderCustomFieldMutation, UpdateWorkOrderCustomFieldMutationVariables>;
export const GetWorkOrdersDocument = gql`
    query getWorkOrders($take: Int! = 10, $after: String, $before: String, $search: String, $buildingIds: [String!], $statusIds: [String!], $from: DateTime, $to: DateTime, $assigneeIds: [String!], $categoryIds: [String!], $companyIds: [String!], $priorityIds: [String!], $requestedForIds: [String!], $closedAtFrom: DateTime, $closedAtTo: DateTime, $archived: ArchiveStatusEnum! = NOT_ARCHIVED) {
  getWorkOrders(
    take: $take
    after: $after
    before: $before
    search: $search
    to: $to
    from: $from
    buildingIds: $buildingIds
    statusIds: $statusIds
    assigneeIds: $assigneeIds
    categoryIds: $categoryIds
    companyIds: $companyIds
    priorityIds: $priorityIds
    requestedForIds: $requestedForIds
    closedAtFrom: $closedAtFrom
    closedAtTo: $closedAtTo
    archived: $archived
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      isArchived
      building {
        ...BuildingCoreFields
      }
      category {
        ...CategoryCoreFields
      }
      status {
        ...StatusCoreFields
        color
      }
      priority {
        ...PriorityCoreFields
        color
      }
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      assignedTo {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      createdByGuest {
        firstName
        lastName
        email
      }
      suite {
        ...SuiteCoreFields
      }
      description
      createdAt
      closedAt
      startDate
      dueDate
      timezone
      charges
      workOrderTemplate {
        id
        index
      }
      review {
        id
        comment
        score
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      statusIds: // value for 'statusIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      assigneeIds: // value for 'assigneeIds'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *      priorityIds: // value for 'priorityIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      closedAtFrom: // value for 'closedAtFrom'
 *      closedAtTo: // value for 'closedAtTo'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
      }
export function useGetWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
        }
export type GetWorkOrdersQueryHookResult = ReturnType<typeof useGetWorkOrdersQuery>;
export type GetWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersLazyQuery>;
export type GetWorkOrdersQueryResult = Apollo.QueryResult<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>;
export const GetWorkOrderDocument = gql`
    query getWorkOrder($id: String!) {
  getWorkOrder(workOrderId: $id) {
    ...WorkOrderFields
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
      }
export function useGetWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
        }
export type GetWorkOrderQueryHookResult = ReturnType<typeof useGetWorkOrderQuery>;
export type GetWorkOrderLazyQueryHookResult = ReturnType<typeof useGetWorkOrderLazyQuery>;
export type GetWorkOrderQueryResult = Apollo.QueryResult<GetWorkOrderQuery, GetWorkOrderQueryVariables>;
export const GetWorkOrderChargesDocument = gql`
    query getWorkOrderCharges($workOrderId: String!, $search: String) {
  getWorkOrderCharges(workOrderId: $workOrderId, search: $search) {
    id
    type
    date
    billable
    invoiceId
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderChargesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderChargesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderChargesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>(GetWorkOrderChargesDocument, options);
      }
export function useGetWorkOrderChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>(GetWorkOrderChargesDocument, options);
        }
export type GetWorkOrderChargesQueryHookResult = ReturnType<typeof useGetWorkOrderChargesQuery>;
export type GetWorkOrderChargesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderChargesLazyQuery>;
export type GetWorkOrderChargesQueryResult = Apollo.QueryResult<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>;
export const GetWorkOrderEquipmentDocument = gql`
    query getWorkOrderEquipment($workOrderId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getWorkOrderEquipment(
    workOrderId: $workOrderId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCoreFields
      index
      active
      category {
        ...EquipmentCategoryCoreFields
      }
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderEquipmentQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderEquipmentQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>(GetWorkOrderEquipmentDocument, options);
      }
export function useGetWorkOrderEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>(GetWorkOrderEquipmentDocument, options);
        }
export type GetWorkOrderEquipmentQueryHookResult = ReturnType<typeof useGetWorkOrderEquipmentQuery>;
export type GetWorkOrderEquipmentLazyQueryHookResult = ReturnType<typeof useGetWorkOrderEquipmentLazyQuery>;
export type GetWorkOrderEquipmentQueryResult = Apollo.QueryResult<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>;
export const ExportWorkOrdersDocument = gql`
    query exportWorkOrders($search: String, $buildingIds: [String!], $statusIds: [String!], $workOrderTemplateId: String, $to: DateTime, $from: DateTime, $assigneeIds: [String!], $categoryIds: [String!], $companyIds: [String!], $priorityIds: [String!], $requestedForIds: [String!], $closedAtFrom: DateTime, $closedAtTo: DateTime, $archived: ArchiveStatusEnum! = NOT_ARCHIVED) {
  exportWorkOrders(
    search: $search
    to: $to
    from: $from
    buildingIds: $buildingIds
    statusIds: $statusIds
    workOrderTemplateId: $workOrderTemplateId
    assigneeIds: $assigneeIds
    categoryIds: $categoryIds
    companyIds: $companyIds
    priorityIds: $priorityIds
    requestedForIds: $requestedForIds
    closedAtFrom: $closedAtFrom
    closedAtTo: $closedAtTo
    archived: $archived
  )
}
    `;

/**
 * __useExportWorkOrdersQuery__
 *
 * To run a query within a React component, call `useExportWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWorkOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      buildingIds: // value for 'buildingIds'
 *      statusIds: // value for 'statusIds'
 *      workOrderTemplateId: // value for 'workOrderTemplateId'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      assigneeIds: // value for 'assigneeIds'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *      priorityIds: // value for 'priorityIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      closedAtFrom: // value for 'closedAtFrom'
 *      closedAtTo: // value for 'closedAtTo'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useExportWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<ExportWorkOrdersQuery, ExportWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportWorkOrdersQuery, ExportWorkOrdersQueryVariables>(ExportWorkOrdersDocument, options);
      }
export function useExportWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportWorkOrdersQuery, ExportWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportWorkOrdersQuery, ExportWorkOrdersQueryVariables>(ExportWorkOrdersDocument, options);
        }
export type ExportWorkOrdersQueryHookResult = ReturnType<typeof useExportWorkOrdersQuery>;
export type ExportWorkOrdersLazyQueryHookResult = ReturnType<typeof useExportWorkOrdersLazyQuery>;
export type ExportWorkOrdersQueryResult = Apollo.QueryResult<ExportWorkOrdersQuery, ExportWorkOrdersQueryVariables>;